export const databricksEtlTool = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "16"}
    height={height || "16"}
    viewBox="0 0 16 16"
    fill="none"
  >
    <rect
      x="0.899902"
      width="14.4"
      height="16"
      fill="url(#pattern0_2211_68967)"
    />
    <defs>
      <pattern
        id="pattern0_2211_68967"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_2211_68967"
          transform="matrix(0.00353357 0 0 0.0031746 -0.558304 0)"
        />
      </pattern>
      <image
        id="image0_2211_68967"
        width="600"
        height="315"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const connectionEdgeLine = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "7"}
    viewBox="0 0 20 7"
    fill="none"
  >
    <path
      d="M20 3.5L15 0.613249V6.38675L20 3.5ZM0 4H15.5V3H0V4Z"
      fill="#949494"
    />
  </svg>
);

export const functionalLineageSvg = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M1.02887 16.3261C1.04668 15.4489 1.48063 14.6314 2.19904 14.1214C2.91747 13.6114 3.83626 13.4685 4.67701 13.7361C5.51798 14.0038 6.18236 14.6504 6.4688 15.4805C7.20801 15.4417 7.90397 15.1223 8.41297 14.5885C8.92196 14.0546 9.2052 13.3468 9.20411 12.6113L9.20411 11.5541C9.20327 10.4643 9.60309 9.4117 10.3285 8.59428L6.46879 8.59428C6.20465 9.44961 5.54219 10.1261 4.6889 10.412C3.83561 10.6977 2.89609 10.5576 2.16491 10.0355C1.43351 9.51346 1 8.67348 1 7.77873C1 6.88397 1.43353 6.04401 2.16491 5.52194C2.89609 4.99988 3.83561 4.8598 4.6889 5.14546C5.54219 5.43135 6.20466 6.10784 6.46879 6.96317L17.5312 6.96317C17.7953 6.10784 18.4578 5.43136 19.3111 5.14546C20.1644 4.85978 21.1039 4.99988 21.8351 5.52194C22.5665 6.044 23 6.88397 23 7.77873C23 8.67348 22.5665 9.51344 21.8351 10.0355C21.1039 10.5576 20.1644 10.6977 19.3111 10.412C18.4578 10.1261 17.7953 9.44961 17.5312 8.59428L15.1302 8.59428C15.0242 8.63726 14.9104 8.65791 14.7959 8.65454L13.7626 8.65454C12.9969 8.65454 12.2625 8.95686 11.7211 9.49493C11.1797 10.033 10.8755 10.763 10.8755 11.524L10.8755 12.5812L10.8755 12.5809C10.8764 13.7517 10.4212 14.8775 9.60527 15.7221C8.78954 16.5667 7.67635 17.0646 6.49918 17.1114C6.23737 17.9652 5.5787 18.6419 4.72883 18.9305C3.87918 19.2194 2.9415 19.0847 2.20848 18.5688C1.47561 18.0528 1.03678 17.2186 1.02875 16.3261L1.02887 16.3261ZM2.70044 7.77878C2.70044 8.07521 2.81895 8.35943 3.02967 8.56901C3.2406 8.77843 3.52658 8.89619 3.82483 8.89619C4.12309 8.89619 4.4091 8.77843 4.62 8.56901C4.83093 8.35939 4.94922 8.07519 4.94922 7.77878C4.94922 7.48237 4.83093 7.19813 4.62 6.98855C4.40907 6.77893 4.12309 6.66137 3.82483 6.66137C3.52658 6.66137 3.24056 6.77893 3.02967 6.98855C2.81895 7.19817 2.70044 7.48238 2.70044 7.77878ZM21.2999 7.77878C21.2999 7.48236 21.1814 7.19813 20.9707 6.98855C20.7597 6.77893 20.4737 6.66137 20.1755 6.66137C19.8772 6.66137 19.5912 6.77893 19.3803 6.98855C19.1694 7.19817 19.0511 7.48237 19.0511 7.77878C19.0511 8.07519 19.1694 8.35943 19.3803 8.56901C19.5913 8.77843 19.8772 8.89619 20.1755 8.89619C20.4737 8.89619 20.7598 8.77843 20.9707 8.56901C21.1814 8.35939 21.2999 8.07519 21.2999 7.77878ZM4.97979 16.3261C4.97979 16.0297 4.86128 15.7455 4.65035 15.5359C4.43942 15.3263 4.15344 15.2087 3.8554 15.2087C3.55713 15.2087 3.27113 15.3263 3.06024 15.5359C2.84935 15.7455 2.7308 16.0297 2.7308 16.3261C2.7308 16.6226 2.84931 16.9068 3.06024 17.1164C3.27117 17.3258 3.55715 17.4436 3.8554 17.4436C4.15347 17.4436 4.43946 17.3258 4.65035 17.1164C4.86128 16.9068 4.97979 16.6226 4.97979 16.3261Z"
      fill="#949494"
    />
  </svg>
);

export const technicalLineageSvg = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22.468 9.32204C22.0432 9.02234 21.5539 8.82678 21.0396 8.75115C20.5252 8.67552 20.0003 8.72196 19.5072 8.8867C19.0141 9.05144 18.5667 9.32987 18.2012 9.69948C17.8356 10.0691 17.5621 10.5195 17.4027 11.0144H11.456L11.7851 10.8499L12.4315 10.5208C12.579 10.4351 12.6883 10.2964 12.737 10.133C12.7955 9.97361 12.7955 9.7987 12.737 9.63935C12.4294 8.91562 12.0089 8.24524 11.4913 7.6532C11.3845 7.52486 11.2336 7.44103 11.0682 7.41815C10.9067 7.3846 10.7386 7.41403 10.5981 7.50042L9.72843 7.99402C9.24815 7.58359 8.69909 7.26131 8.1066 7.04207V6.09013C8.10827 5.92614 8.04972 5.76724 7.94206 5.64354C7.83069 5.51047 7.67733 5.41928 7.50722 5.38498C6.7636 5.26751 6.00614 5.26751 5.26252 5.38498C5.097 5.42256 4.94837 5.51338 4.83943 5.64354C4.73693 5.77024 4.6791 5.92721 4.6749 6.09013V7.10083C4.10546 7.31221 3.57373 7.61378 3.10007 7.99402L2.20689 7.50042C2.05514 7.42164 1.88238 7.39285 1.71329 7.41815C1.63163 7.42942 1.55309 7.45709 1.4824 7.4995C1.41171 7.54192 1.35033 7.5982 1.30196 7.66495C0.776683 8.24039 0.35162 8.89983 0.0444497 9.61585C-0.0148166 9.77909 -0.0148166 9.95796 0.0444497 10.1212C0.101633 10.2806 0.214267 10.4141 0.361765 10.4973L1.34897 11.0026C1.2314 11.6318 1.2314 12.2773 1.34897 12.9065L0.361765 13.4236C0.212115 13.5042 0.0986838 13.6386 0.0444497 13.7997C-0.0139788 13.9591 -0.0139788 14.134 0.0444497 14.2933C0.349301 15.0176 0.774466 15.6852 1.30196 16.2677C1.40669 16.397 1.55135 16.488 1.71329 16.5263C1.8853 16.5555 2.06196 16.5176 2.20689 16.4205L3.10007 15.9504C3.57796 16.3642 4.12766 16.6868 4.72191 16.9023V17.9248C4.7285 18.0908 4.78593 18.2508 4.88644 18.3831C4.99565 18.5166 5.15068 18.6046 5.32128 18.6299C6.06393 18.7592 6.82333 18.7592 7.56599 18.6299C7.7306 18.5972 7.87953 18.5103 7.98907 18.3831C8.09486 18.2537 8.15295 18.0919 8.15361 17.9248V16.9023C8.75282 16.6975 9.30446 16.3737 9.77544 15.9504L10.6451 16.4675C10.7875 16.5487 10.9537 16.5778 11.1152 16.5498C11.2807 16.5204 11.4283 16.4276 11.5265 16.2912C12.0421 15.7065 12.4553 15.039 12.7488 14.3168C12.8072 14.1575 12.8072 13.9826 12.7488 13.8232C12.6946 13.6621 12.5811 13.5277 12.4315 13.4471L11.7498 13.1416L11.456 12.977H17.4027C17.5689 13.4717 17.8507 13.9196 18.2248 14.2834C18.5989 14.6473 19.0544 14.9166 19.5534 15.069C20.0435 15.2284 20.5643 15.2696 21.0733 15.1893C21.5824 15.109 22.0652 14.9094 22.4823 14.6068C22.8995 14.3043 23.2392 13.9073 23.4736 13.4484C23.7081 12.9895 23.8306 12.4817 23.8313 11.9663C23.8305 11.449 23.7065 10.9392 23.4694 10.4793C23.2323 10.0195 22.889 9.62275 22.468 9.32204ZM4.83943 13.5176C4.47003 13.0857 4.26962 12.5346 4.27531 11.9663C4.26547 11.3839 4.48009 10.82 4.87469 10.3915C5.14671 10.1225 5.48873 9.93521 5.86189 9.8509C6.04461 9.79478 6.23486 9.76704 6.426 9.76863C6.89199 9.7753 7.34257 9.93652 7.70702 10.227L7.95382 10.4385C8.34357 10.8521 8.56197 11.3981 8.56494 11.9663C8.57342 12.5542 8.35447 13.1226 7.95382 13.5529L7.80103 13.7292C7.41157 14.0305 6.93004 14.1883 6.43776 14.1758C6.22565 14.1759 6.01505 14.1401 5.81488 14.07C5.46344 13.9679 5.14388 13.7778 4.88644 13.5176H4.83943ZM21.3986 12.9065C21.2762 13.0298 21.1307 13.1277 20.9703 13.1945C20.8099 13.2613 20.638 13.2956 20.4642 13.2956C20.2905 13.2956 20.1186 13.2613 19.9582 13.1945C19.7978 13.1277 19.6523 13.0298 19.5299 12.9065C19.407 12.7852 19.3094 12.6406 19.2427 12.4812C19.1761 12.3219 19.1418 12.1508 19.1418 11.9781C19.1418 11.8053 19.1761 11.6343 19.2427 11.4749C19.3094 11.3156 19.407 11.171 19.5299 11.0496C19.6523 10.9263 19.7978 10.8285 19.9582 10.7617C20.1186 10.6949 20.2905 10.6605 20.4642 10.6605C20.638 10.6605 20.8099 10.6949 20.9703 10.7617C21.1307 10.8285 21.2762 10.9263 21.3986 11.0496C21.5215 11.171 21.6191 11.3156 21.6858 11.4749C21.7524 11.6343 21.7867 11.8053 21.7867 11.9781C21.7867 12.1508 21.7524 12.3219 21.6858 12.4812C21.6191 12.6406 21.5215 12.7852 21.3986 12.9065Z"
      fill="#949494"
    />
  </svg>
);

export const layerIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "32"}
    height={height || "32"}
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M16 28.0719L4 18.7385L6.2 17.0719L16 24.6719L25.8 17.0719L28 18.7385L16 28.0719ZM16 21.3385L4 12.0052L16 2.67188L28 12.0052L16 21.3385ZM16 17.9385L23.6667 12.0052L16 6.07188L8.33333 12.0052L16 17.9385Z"
      fill="#428BCA"
    />
  </svg>
);

export const notificationBellIcon = (
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 90 112.5"
    enableBackground="new 0 0 90 90"
    xmlSpace="preserve"
    width="30px"
    height="33px"
  >
    <g>
      <path
        d="M69.1,55.2c-2.2-2.7-5.2-6.4-5.2-10.3V32.7c0-10.6-7.9-19.2-18-19.2C35.8,13.5,28,22.1,28,32.7v12.3   c0,3.8-3.3,7.4-5.3,10.1c-1.9,2.5-3.3,4.5-2.3,6.4c0.9,1.7,3.1,2,4.9,2h10.8c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10h11   c1.1,0,3.8,0,4.7-1.9C72.7,59.6,71.2,57.7,69.1,55.2z M46,69.6c-3.4,0-6.1-2.7-6.1-6.1H52C52,66.8,49.3,69.6,46,69.6z M67,59.5   H25.2c-0.3,0-0.5,0-0.7,0c0.4-0.6,1-1.4,1.4-2c2.3-3.1,6.1-7.4,6.1-12.5V32.7c0-8.4,6-15.2,13.9-15.2c7.9,0,14,6.8,14,15.2v12.3   c0,5.3,3.5,9.7,6.1,12.8c0.4,0.5,1,1.2,1.4,1.7C67.3,59.5,67.1,59.5,67,59.5z"
        fill="#fff"
        strokeWidth="5px"
      />
    </g>
  </svg>
);

export const questionMarkSvg = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="question-circle"
    className="svg-inline--fa fa-question-circle faW-16"
    role="img"
    viewBox="0 0 512 512"
  >
    <path
      fill="currentColor"
      d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
    />
  </svg>
);

export const bellIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="bell"
    className="svg-inline--fa fa-bell faW-14"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    width="20px"
    height="17px"
  >
    <path
      fill="#fff"
      d="M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
    />
  </svg>
);

export const searchIcon = (width?: string): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="search"
    className="svg-inline--fa fa-search faW-16"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width || "13px"}
  >
    <path
      fill="#95D0F0"
      d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
    />
  </svg>
);

export const sortDownIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="sort-down"
    className="svg-inline--fa fa-sort-down faW-10"
    role="img"
    viewBox="0 0 320 512"
    width="10px"
    height="12px"
  >
    <path
      fill="#777"
      d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
    />
  </svg>
);

export const sortUpIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="sort-up"
    className="svg-inline--fa fa-sort-up faW-10"
    role="img"
    viewBox="0 0 320 512"
    width="10px"
    height="12px"
  >
    <path
      fill="#777"
      d="M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
    />
  </svg>
);

export const homeIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="home"
    className="svg-inline--fa fa-home faW-18"
    role="img"
    viewBox="0 0 576 512"
    width={width || "18.5px"}
    height={height || "15px"}
  >
    <path
      fill="#b1bac1"
      d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
    />
  </svg>
);

export const rightAngleIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="angleRight"
    className="svg-inline--fa fa-angleRight faW-8"
    role="img"
    viewBox="0 0 256 512"
    width="8px"
  >
    <path
      fill="#b2b6bf"
      d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
    />
  </svg>
);

export const settingsIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="cog"
    className="svg-inline--fa fa-cog faW-16"
    role="img"
    viewBox="0 0 512 512"
    width="20px"
  >
    <path
      fill="#fff"
      d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    />
  </svg>
);

export const scheduleIcon = (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 16 16"
    height="20px"
    width="18px"
  >
    <path
      fillRule="evenodd"
      d="M14 0H2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M6.5 7a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm-9 3a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm-9 3a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2z"
      clipRule="evenodd"
    />
  </svg>
);

export const arrowLeft = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="arrow-left"
    className="svg-inline--fa fa-arrow-left faW-14"
    role="img"
    width="18px"
    height="14px"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    />
  </svg>
);

export const arrowRight = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="arrowRight"
    className="svg-inline--fa fa-arrowRight faW-14"
    role="img"
    viewBox="0 0 448 512"
    width="18px"
    height="14px"
  >
    <path
      fill="currentColor"
      d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
    />
  </svg>
);

export const crossIcon = (
  width?: string,
  height?: string,
  fill?: string
): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="times"
    className="svg-inline--fa fa-times faW-11"
    role="img"
    viewBox="0 0 352 512"
    width={width || "21px"}
    height={height || "27px"}
  >
    <path
      fill={fill || "#a8a8a8"}
      d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    />
  </svg>
);

export const sliderIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="sliders-h"
    className="svg-inline--fa fa-sliders-h faW-16"
    role="img"
    viewBox="0 0 512 512"
  >
    <path
      fill="currentColor"
      d="M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
    />
  </svg>
);

export const arrowBackIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="arrow-left"
    className="svg-inline--fa fa-arrow-left faW-14"
    role="img"
    viewBox="0 0 448 512"
    height={height || "14px"}
    width={width || "18px"}
  >
    <path
      fill="currentColor"
      d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    />
  </svg>
);

export const cloneIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="clone"
    className="svg-inline--fa fa-clone faW-16"
    role="img"
    viewBox="0 0 512 512"
  >
    <path
      fill="currentColor"
      d="M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"
    />
  </svg>
);

export const profilingIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="crosshairs"
    className="svg-inline--fa fa-crosshairs faW-16"
    role="img"
    viewBox="0 0 512 512"
  >
    <path
      fill="currentColor"
      d="M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
    />
  </svg>
);

export const arrowUpIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="arrow-up"
    className="svg-inline--fa fa-arrow-up faW-14"
    role="img"
    viewBox="0 0 448 512"
    width="22px"
    height="22px"
  >
    <path
      fill="#fff"
      d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
    />
  </svg>
);

export const arrowDownIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="angle-down"
    className="svg-inline--fa fa-angle-down faW-10"
    role="img"
    viewBox="0 0 320 512"
  >
    <path
      fill="currentColor"
      d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
    />
  </svg>
);

export const sortArrowIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="sort-amount-down-alt"
    className="svg-inline--fa fa-sort-amount-down-alt faW-16"
    role="img"
    viewBox="0 0 512 512"
  >
    <path
      fill="currentColor"
      d="M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
    />
  </svg>
);

export const UndoIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="undo"
    className="svg-inline--fa fa-undo faW-16"
    role="img"
    viewBox="0 0 512 512"
  >
    <path
      fill="currentColor"
      d="M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
    />
  </svg>
);

export const settingIconDynamicColor = (): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="cog"
    className="svg-inline--fa fa-cog faW-16"
    role="img"
    viewBox="0 0 512 512"
  >
    <path
      fill="#d6d5d5"
      d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    />
  </svg>
);

export const editPencilIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "18.657"}
    height={height || "18.66"}
    viewBox="0 0 27.51 27.514"
  >
    <defs>
      <style>{`.edit-icon-greater-cls-1{fill:#428bca}`}</style>
    </defs>
    <g
      id="Group_1179"
      data-name="Group 1179"
      transform="translate(-645.236 -368.94)"
    >
      <path
        id="Path_2270"
        data-name="Path 2270"
        className="edit-icon-greater-cls-1"
        d="M896.284-55.188v-7.369a.393.393 0 0 1 .13-.3q7.428-7.422 14.852-14.848c.037-.037.076-.073.1-.1l7.544 7.553c-.007.007-.044.049-.083.088q-7.435 7.437-14.874 14.871a.364.364 0 0 1-.227.107q-3.654.008-7.307 0c-.04.007-.076.002-.135-.002zm8.226-3.945-4.271-4.267c-.516.516-1.045 1.043-1.569 1.574a.266.266 0 0 0-.056.17v1.7a1.317 1.317 0 0 0 .016.137h2.313v2.293c.022.01.031.018.041.018h1.826a.2.2 0 0 0 .123-.053c.527-.521 1.054-1.049 1.577-1.571zm-2.41-4.944a.476.476 0 0 0 .368-.184l9.713-9.716a.981.981 0 0 0 .115-.13.453.453 0 0 0-.027-.545.457.457 0 0 0-.546-.016 1.117 1.117 0 0 0-.129.117l-9.694 9.692a.893.893 0 0 0-.142.169.389.389 0 0 0 .342.613z"
        transform="translate(-251.045 451.633)"
      />
      <path
        id="Path_2271"
        data-name="Path 2271"
        className="edit-icon-greater-cls-1"
        d="m1416.406-220.436-7.547-7.546c.031-.034.063-.073.1-.108l2.963-2.945a2.282 2.282 0 0 1 3.195.034c1.011 1 2.013 2 3.018 3 .405.4.8.812 1.217 1.209a2.372 2.372 0 0 1 .005 3.42c-.965.921-1.891 1.882-2.835 2.826l-.116.11z"
        transform="translate(-747.334 600.611)"
      />
    </g>
  </svg>
);

export const editIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="pencil-alt"
    className="svg-inline--fa fa-pencil-alt faW-16"
    role="img"
    viewBox="0 0 512 512"
    width="13px"
    height="17px"
  >
    <path
      fill="#478FCA"
      d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
    />
  </svg>
);
export const deleteIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="trash-alt"
    className="svg-inline--fa fa-trash-alt faW-14"
    role="img"
    viewBox="0 0 448 512"
    width="13px"
    height="17px"
  >
    <path
      fill="#478FCA"
      d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
    />
  </svg>
);

export const siteMapIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="sitemap"
    className="svg-inline--fa fa-sitemap faW-20"
    role="img"
    viewBox="0 0 640 512"
    width="14px"
    height="14px"
  >
    <path
      fill="#478fca"
      d="M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    />
  </svg>
);

export const downloadIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="download"
    className="svg-inline--fa fa-download faW-16"
    role="img"
    viewBox="0 0 512 512"
    width="13px"
    height="14px"
  >
    <path
      fill="#478fca"
      d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
    />
  </svg>
);

export const sortIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="sort"
    className="svg-inline--fa fa-sort faW-10"
    role="img"
    viewBox="0 0 320 512"
    width="8px"
    height="14px"
  >
    <path
      fill="#ccc"
      d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
    />
  </svg>
);

export const gripIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="grip-vertical"
    className="svg-inline--fa fa-grip-vertical faW-10"
    role="img"
    viewBox="0 0 320 512"
    width="6px"
    height="10px"
  >
    <path
      fill="#777"
      d="M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    />
  </svg>
);

export const warningIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="exclamation-triangle"
    className="svg-inline--fa fa-exclamation-triangle faW-18"
    role="img"
    viewBox="0 0 576 512"
    width="30px"
    height="30px"
  >
    <path
      fill="currentColor"
      d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    />
  </svg>
);

export const StackOverFlow = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fab"
    data-icon="stack-overflow"
    className="svg-inline--fa fa-stack-overflow faW-12"
    role="img"
    viewBox="0 0 384 512"
  >
    <path
      fill="currentColor"
      d="M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"
    />
  </svg>
);

export const infoIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="info"
    className="svg-inline--fa fa-info faW-6"
    role="img"
    viewBox="0 0 192 512"
    width="5px"
    height="17px"
  >
    <path
      fill="#478fca"
      d="M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
    />
  </svg>
);

export const angleDown = (width?: string, height?: string): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="angle-down"
    className="svg-inline--fa fa-angle-down faW-10"
    role="img"
    viewBox="0 0 320 512"
    width={width || "13px"}
    height={height || "14px"}
  >
    <path
      fill="#858585"
      d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
    />
  </svg>
);

export const angleUp = (width?: string, height?: string): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="angle-up"
    className="svg-inline--fa fa-angle-up faW-10"
    role="img"
    viewBox="0 0 320 512"
    width={width || "13px"}
    height={height || "14px"}
  >
    <path
      fill="#858585"
      d="M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
    />
  </svg>
);

export const clockIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="clock"
    className="svg-inline--fa fa-clock faW-16"
    role="img"
    viewBox="0 0 512 512"
    width={width || "13px"}
    height={height || "16px"}
  >
    <path
      fill="#393939"
      d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
    />
  </svg>
);

export const SavedInfo = (
  <svg width="34" height="34">
    <g data-name="Group 1164">
      <g
        data-name="Ellipse 276"
        style={{
          fill: "#deeadc",
          stroke: "#5f9856",
          strokeWidth: ".5px",
          opacity: 0.34,
        }}
      >
        <circle cx="17" cy="17" r="17" style={{ stroke: "none" }} />
        <circle cx="17" cy="17" r="16.75" style={{ fill: "none" }} />
      </g>
      <path
        data-name="Exclusion 1"
        d="M12.657 18.121H1.488A1.471 1.471 0 0 1 0 16.671V1.449A1.471 1.471 0 0 1 1.488 0h6.1v3.624a2.069 2.069 0 0 0 2.091 2.039h4.466v11.008a1.471 1.471 0 0 1-1.488 1.45zm-8.43-8.23a.4.4 0 0 0-.282.109l-.956.925a.387.387 0 0 0 0 .557l2.783 2.733a.41.41 0 0 0 .29.118.4.4 0 0 0 .283-.115l4.817-4.65a.385.385 0 0 0 0-.557l-.95-.933a.417.417 0 0 0-.291-.117.4.4 0 0 0-.282.114L6.067 11.53l-1.55-1.522a.413.413 0 0 0-.29-.117zm9.686-5.405H9.679a.874.874 0 0 1-.886-.861V.34A.341.341 0 0 1 9.138 0a1.5 1.5 0 0 1 .962.34l3.55 2.88a1.321 1.321 0 0 1 .5 1.038.227.227 0 0 1-.237.227z"
        transform="translate(10.335 7.669)"
        style={{ fill: "#5f9856" }}
      />
    </g>
  </svg>
);

export const userIcon = (
  <svg width="10.4" height="11.8" viewBox="0 0 13 14">
    <defs>
      <style>{`.cls-usericon-111{fill:#d2d2d2;fillRule:evenodd}`}</style>
    </defs>
    <g
      id="Group_6"
      data-name="Group 6"
      transform="translate(-1734.928 -245.832)"
    >
      <path
        id="Path_126"
        data-name="Path 126"
        className="cls-usericon-111"
        d="M1741.412 342.807h-4.012a2.237 2.237 0 0 1-2.472-2.488 8.268 8.268 0 0 1 .607-3.374 2.613 2.613 0 0 1 2.2-1.767 1.556 1.556 0 0 1 .753.163c.6.276 1.149.661 1.763.88a3.971 3.971 0 0 0 3.419-.446c.106-.061.2-.136.31-.2.352-.2.644-.512 1.129-.423a2.394 2.394 0 0 1 1.637.883 5.92 5.92 0 0 1 .76 1.412 8.243 8.243 0 0 1 .4 3.262 2.124 2.124 0 0 1-2.116 2.077c-1.459.035-2.92.008-4.38.008z"
        transform="translate(0 -82.14)"
      />
      <path
        id="Path_127"
        data-name="Path 127"
        className="cls-usericon-111"
        d="M1782.084 250.383a3.542 3.542 0 1 1-3.524-3.551 3.512 3.512 0 0 1 3.524 3.551z"
        transform="translate(-37.121 -1)"
      />
    </g>
  </svg>
);

export const chevronRight = (
  <svg width="4.56" height="8.048" viewBox="0 0 6 11">
    <defs>
      <style>{`.chevronRight-icon{ fill: none;
        stroke: #b8bbc3;
        stroke-linecap: round;
        stroke-linejoin: round;
        strokeWidth: 1.5px; }`}</style>
    </defs>
    <path
      data-name="Icon feather-chevronRight"
      d="m13.5 16.894 3.947-3.947L13.5 9"
      transform="translate(-12.439 -7.939)"
      className="chevronRight-icon"
    />
  </svg>
);

export const collapsedIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || 20} height={height || 20} fill="none">
    <path fill="#949494" d="m14.167 10.77-6.25 6.015V4.757l6.25 6.014z" />
  </svg>
);

export const expandedIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || 20} height={height || 20} fill="none">
    <path fill="#949494" d="m9.729 14.666-6.014-6.25h12.028l-6.014 6.25z" />
  </svg>
);

export const chevronLeft = (
  <svg width="4.56" height="8.048" viewBox="0 0 6 11" transform="scale(-1, 1)">
    <defs>
      <style>{`.chevronRight-icon{ fill: none;
        stroke: #b8bbc3;
        stroke-linecap: round;
        stroke-linejoin: round;
        strokeWidth: 1.5px; }`}</style>
    </defs>
    <path
      data-name="Icon feather-chevronRight"
      d="m13.5 16.894 3.947-3.947L13.5 9"
      transform="translate(-12.439 -7.939)"
      className="chevronRight-icon"
    />
  </svg>
);

export const databaseIcon = (
  <svg width="11.523" height="13.169" viewBox="0 0 11 13">
    <defs>
      <style>{`.databaseicon-class__12345{ fill: #328db5 }`}</style>
    </defs>
    <path
      data-name="Icon awesome-database"
      d="M11.523 1.881v1.176c0 1.036-2.581 1.881-5.761 1.881S0 4.093 0 3.057V1.881C0 .845 2.581 0 5.761 0s5.762.845 5.762 1.881zm0 2.646v2.645c0 1.036-2.581 1.881-5.761 1.881S0 8.209 0 7.172V4.527c1.238.852 3.5 1.249 5.761 1.249s4.524-.397 5.762-1.249zm0 4.115v2.646c0 1.036-2.581 1.881-5.761 1.881S0 12.324 0 11.288V8.642c1.238.852 3.5 1.249 5.761 1.249s4.524-.396 5.762-1.249z"
      className="databaseicon-class__12345"
    />
  </svg>
);

export const whiteDatabaseIcon = (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#kfsmuvi4qa)">
      <path
        d="M17.12 2.429v1.513c0 1.337-3.808 2.43-8.5 2.43S.12 5.283.12 3.946V2.433C.12 1.091 3.927 0 8.619 0s8.5 1.09 8.5 2.429zm0 3.415v3.414c0 1.337-3.808 2.43-8.5 2.43s-8.5-1.095-8.5-2.43V5.844c1.825 1.1 5.168 1.615 8.499 1.615 3.33 0 6.673-.515 8.5-1.615zm0 5.312v3.415c0 1.337-3.808 2.429-8.5 2.429s-8.5-1.092-8.5-2.429v-3.416c1.825 1.1 5.168 1.613 8.499 1.613 3.33 0 6.67-.512 8.5-1.613v.001z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="kfsmuvi4qa">
        <path fill="#fff" transform="translate(.12)" d="M0 0h17v17H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const greyDatabaseIcon = (
  <svg width="11.523" height="13.169" viewBox="0 0 14 14">
    <defs>
      <style>{`.greydatabaseicon-class__12345{ fill: #bdbec4 }`}</style>
    </defs>
    <path
      data-name="Icon awesome-database"
      d="M11.523 1.881v1.176c0 1.036-2.581 1.881-5.761 1.881S0 4.093 0 3.057V1.881C0 .845 2.581 0 5.761 0s5.762.845 5.762 1.881zm0 2.646v2.645c0 1.036-2.581 1.881-5.761 1.881S0 8.209 0 7.172V4.527c1.238.852 3.5 1.249 5.761 1.249s4.524-.397 5.762-1.249zm0 4.115v2.646c0 1.036-2.581 1.881-5.761 1.881S0 12.324 0 11.288V8.642c1.238.852 3.5 1.249 5.761 1.249s4.524-.396 5.762-1.249z"
      className="greydatabaseicon-class__12345"
    />
  </svg>
);

export const dataSourceIcon = (
  width?: string,
  height?: string,
  fill?: string
): JSX.Element => (
  <svg
    width={width || "14.7"}
    height={height || "16.8"}
    viewBox="0 0 18.4 21.029"
  >
    <defs>
      <style>{`.datasource_icon_1{fill:${fill || "#b1bac1"}}`}</style>
    </defs>
    <path
      className="datasource_icon_1"
      data-name="Icon awesome-database"
      d="M18.4 3v1.882c0 1.655-4.121 3-9.2 3S0 6.536 0 4.882V3c0-1.651 4.121-3 9.2-3s9.2 1.349 9.2 3zm0 4.224v4.224c0 1.655-4.121 3-9.2 3s-9.2-1.349-9.2-3V7.229C1.977 8.59 5.594 9.223 9.2 9.223s7.223-.633 9.2-1.994zm0 6.571v4.224c0 1.655-4.121 3-9.2 3s-9.2-1.349-9.2-3V13.8c1.977 1.361 5.594 1.995 9.2 1.995s7.223-.634 9.2-1.995z"
    />
  </svg>
);

export const databaseTableIcon = (
  width?: string,
  height?: string,
  fill?: string
): JSX.Element => (
  <svg
    width={width || "15.564"}
    height={height || "13.169"}
    viewBox="0 0 70 59"
  >
    <defs>
      <style>{`.databasetableicon-class1245{ fill: ${
        fill || "#428bca"
      } }`}</style>
    </defs>
    <path
      data-name="Path 2543"
      d="M-1855.107 688.735q-14.078 0-28.154.007a6.773 6.773 0 0 1-5.906-3.08 6.631 6.631 0 0 1-1.095-3.919v-30.6c0-4.956.008-9.911 0-14.866a6.752 6.752 0 0 1 3.815-6.354 6.826 6.826 0 0 1 3.323-.681q10.24.008 20.476 0 17.973 0 35.944.007a6.746 6.746 0 0 1 6.481 4.876 6.884 6.884 0 0 1 .262 1.822q.021 21.484.01 42.968a35.364 35.364 0 0 1-.082 3.969 6.641 6.641 0 0 1-6.591 5.842q-14.24.018-28.483 0zm-21.69-21.617v.006h6.53c1.145 0 1.64-.48 1.64-1.607v-7.673c0-1.062-.454-1.539-1.518-1.542q-6.557-.017-13.115-.007c-1.124 0-1.588.484-1.589 1.6v7.674c0 1.063.5 1.551 1.574 1.552l6.475-.003zm.041-16.229v-.007c2.195 0 4.39.006 6.584 0 1.072 0 1.54-.473 1.541-1.521q.007-3.863 0-7.727a1.372 1.372 0 0 0-1.563-1.577q-6.53-.009-13.061 0c-1.11 0-1.6.5-1.6 1.594v7.51c0 1.291.436 1.73 1.729 1.732q3.187 0 6.37-.004zm43.276 16.229v.006h6.421c1.223 0 1.686-.454 1.686-1.665q0-3.782-.005-7.564c0-1.151-.424-1.591-1.566-1.593q-6.53-.013-13.059-.008c-1.107 0-1.585.492-1.586 1.6q0 3.809.006 7.618c0 1.139.471 1.6 1.628 1.606q3.236.003 6.475 0zm.014-16.23v-.006c2.195 0 4.391.008 6.585 0 1.047 0 1.5-.463 1.5-1.5q.01-3.863 0-7.727c0-1.136-.482-1.6-1.64-1.6h-13.007a1.374 1.374 0 0 0-1.565 1.571c0 2.576-.007 5.151 0 7.727a1.348 1.348 0 0 0 1.538 1.536c2.199.005 4.395-.001 6.588-.001zm-21.678-.006v.007h6.419c1.3 0 1.73-.43 1.73-1.727q0-3.7-.007-7.4c0-1.248-.456-1.711-1.7-1.711h-12.787c-1.28 0-1.719.444-1.72 1.741q0 3.727.007 7.455c0 1.218.415 1.632 1.634 1.633q3.214.007 6.424.002zm.05 5.409v.008c-2.195 0-4.388-.006-6.585 0-1.075 0-1.517.453-1.52 1.524q-.008 3.836-.006 7.672c0 1.15.474 1.625 1.612 1.625q6.5 0 13-.006c1.115 0 1.581-.467 1.584-1.593q.015-3.809.008-7.617c0-1.158-.46-1.611-1.623-1.614-2.153-.003-4.313.001-6.47.001zm-21.686 27.036v.007h6.585c1.1 0 1.568-.474 1.569-1.554v-7.675c0-1.1-.489-1.6-1.587-1.6h-13.062c-1.079 0-1.569.49-1.571 1.562q-.007 3.837 0 7.674c0 1.124.468 1.583 1.59 1.584q3.238.004 6.476.002zm43.278 0v.008c2.213 0 4.426.007 6.638 0a1.318 1.318 0 0 0 1.491-1.517q.005-3.891 0-7.781a1.34 1.34 0 0 0-1.491-1.528q-6.611-.011-13.222.006a1.327 1.327 0 0 0-1.494 1.521q-.01 3.836 0 7.672c0 1.2.447 1.621 1.66 1.621zm-21.618.01v-.009h6.427c1.268 0 1.684-.395 1.688-1.648q.017-3.758 0-7.516c0-1.228-.447-1.655-1.693-1.656q-6.4-.006-12.8-.005c-1.264 0-1.711.449-1.71 1.694v7.515c0 1.167.441 1.62 1.607 1.623 2.161.003 4.322 0 6.481 0z"
      transform="translate(1890.265 -629.24)"
      className="databasetableicon-class1245"
    />
  </svg>
);

export const barChartReportIcon = (
  <svg width="9.877" height="13.169">
    <defs>
      <style>{`.cls-barchartReport-icon{fill:#328db5}`}</style>
    </defs>
    <g id="profitReport" transform="translate(-64)">
      <g id="Group_685" data-name="Group 685" transform="translate(70.584)">
        <g id="Group_684" data-name="Group 684">
          <path
            id="Path_2151"
            data-name="Path 2151"
            className="cls-barchartReport-icon"
            d="M320 0v3.292h3.292z"
            transform="translate(-320)"
          />
        </g>
      </g>
      <g id="Group_687" data-name="Group 687" transform="translate(64)">
        <g id="Group_686" data-name="Group 686">
          <path
            id="Path_2152"
            data-name="Path 2152"
            className="cls-barchartReport-icon"
            d="M70.584 4.115a.824.824 0 0 1-.823-.823V0h-4.938A.824.824 0 0 0 64 .823v11.523a.824.824 0 0 0 .823.823h8.231a.823.823 0 0 0 .823-.823V4.115zm-3.292 7.408h-1.646V9.054h1.646zm2.469 0h-1.646V7.408h1.646zm2.469 0h-1.646V5.761h1.646z"
            transform="translate(-64)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const barChartIcon = (
  <svg width="14" height="13">
    <defs>
      <style>{`.cls-bar-chart-icon{fill:#328db5}`}</style>
    </defs>
    <g
      id="Group_1279"
      data-name="Group 1279"
      transform="translate(-922 -377.455)"
    >
      <path
        id="Rectangle_1121"
        data-name="Rectangle 1121"
        className="cls-bar-chart-icon"
        transform="translate(922 383.455)"
        d="M0 0h4v7H0z"
      />
      <path
        id="Rectangle_1122"
        data-name="Rectangle 1122"
        className="cls-bar-chart-icon"
        transform="translate(927 377.455)"
        d="M0 0h4v13H0z"
      />
      <path
        id="Rectangle_1123"
        data-name="Rectangle 1123"
        className="cls-bar-chart-icon"
        transform="translate(932 380.455)"
        d="M0 0h4v10H0z"
      />
    </g>
  </svg>
);

export const starIconInCircle = (
  <svg width="48" height="48">
    <g data-name="Group 1305">
      <g data-name="Group 750">
        <g data-name="Group 742">
          <g
            data-name="Ellipse 263"
            style={{ stroke: "#428bca", fill: "#fff" }}
          >
            <circle cx="24" cy="24" r="24" style={{ stroke: "none" }} />
            <circle cx="24" cy="24" r="23.5" style={{ fill: "none" }} />
          </g>
        </g>
      </g>
      <path
        data-name="Icon feather-star"
        d="m12.6 3 2.968 6.012 6.637.97-4.8 4.677 1.133 6.608-5.938-3.121-5.931 3.122L7.8 14.66 3 9.982l6.637-.97z"
        transform="translate(11.5 11.5)"
        style={{
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2px",
          fill: "none",
          stroke: "#428bca",
        }}
      />
    </g>
  </svg>
);

export const settingsInCircleIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48">
    <defs>
      <style>{`.cls-2{fill:#428bca}`}</style>
    </defs>
    <g id="Group_749" data-name="Group 749" transform="translate(48.183 .181)">
      <g id="Group_743" data-name="Group 743" transform="translate(-48)">
        <g
          id="Ellipse_263"
          data-name="Ellipse 263"
          transform="translate(-.183 -.181)"
          style={{ fill: "#fff", stroke: "#428bca" }}
        >
          <circle cx="24" cy="24" r="24" style={{ stroke: "none" }} />
          <circle cx="24" cy="24" r="23.5" style={{ fill: "none" }} />
        </g>
        <g
          id="Group_744"
          data-name="Group 744"
          transform="translate(14.713 14.713)"
        >
          <path
            id="Union_9"
            data-name="Union 9"
            className="cls-2"
            d="M12 18a1 1 0 0 1-1-1v-1.842H8V2.842h3V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4.631a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V3.789H9V14.21h2v-1.841a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V17a1 1 0 0 1-1 1zM1 12.316a1 1 0 0 1-1-1V6.684a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4.631a1 1 0 0 1-1 1z"
            transform="translate(.104 .105)"
          />
          <path
            id="Rectangle_1043"
            data-name="Rectangle 1043"
            className="cls-2"
            transform="translate(5.181 9.127)"
            d="M0 0h4.091v1.007H0z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const successTickInCircleIcon = (
  <svg width="30" height="30">
    <g data-name="Group 841">
      <g data-name="Ellipse 264" style={{ fill: "#fff", stroke: "#73aa6a" }}>
        <circle cx="15" cy="15" r="15" style={{ stroke: "none" }} />
        <circle cx="15" cy="15" r="14.5" style={{ fill: "none" }} />
      </g>
      <g data-name="tick (1)">
        <g data-name="Group 840">
          <path
            data-name="Path 2269"
            d="M11.712 68.172a.594.594 0 0 0-.841 0l-7.12 7.12-2.737-2.737a.594.594 0 0 0-.841.84l3.157 3.157a.594.594 0 0 0 .841 0l7.541-7.541a.594.594 0 0 0 0-.839z"
            transform="translate(9.737 -57.362)"
            style={{ fill: "#74ab6b", stroke: "#74ab6b" }}
          />
        </g>
      </g>
    </g>
  </svg>
);

export const warningIconInCircle = (
  <svg width="29.695" height="29.695">
    <defs>
      <style>{`.cls-222{fill:#dd5a43}`}</style>
    </defs>
    <g id="Group_843" data-name="Group 843" transform="translate(-.001)">
      <g
        id="Ellipse_264"
        data-name="Ellipse 264"
        transform="translate(.001)"
        style={{ fill: "#fff", stroke: "#dd5a43" }}
      >
        <circle cx="14.848" cy="14.848" r="14.848" style={{ stroke: "none" }} />
        <circle cx="14.848" cy="14.848" r="14.348" style={{ fill: "none" }} />
      </g>
      <g
        id="Group_844"
        data-name="Group 844"
        transform="translate(14.038 8.098)"
      >
        <rect
          id="Rectangle_1101"
          data-name="Rectangle 1101"
          className="cls-222"
          width="1.611"
          height="10.363"
          rx=".806"
          transform="translate(.21)"
        />
        <circle
          id="Ellipse_265"
          data-name="Ellipse 265"
          className="cls-222"
          cx="1.091"
          cy="1.091"
          transform="translate(0 11.388)"
          r="1.091"
        />
      </g>
    </g>
  </svg>
);

export const directionIconInCircle = (
  <svg width="48" height="48">
    <defs>
      <style>
        {`.cls-3{stroke:#428bca}.cls-2{fill:#428bca}.cls-3{fill:none;strokeWidth:.8px}`}
      </style>
    </defs>
    <g id="Group_1187" data-name="Group 1187" transform="translate(-.072 .181)">
      <g id="Group_745" data-name="Group 745">
        <g
          id="Ellipse_263"
          data-name="Ellipse 263"
          transform="translate(.072 -.181)"
          style={{ stroke: "#428bca", fill: "#fff" }}
        >
          <circle cx="24" cy="24" r="24" style={{ stroke: "none" }} />
          <circle cx="24" cy="24" r="23.5" style={{ fill: "none" }} />
        </g>
        <rect
          id="Rectangle_1044"
          data-name="Rectangle 1044"
          className="cls-2"
          width="7"
          height="5"
          rx="1"
          transform="translate(21.072 21.819)"
        />
        <g
          id="Group_746"
          data-name="Group 746"
          transform="translate(12.874 12.875)"
        >
          <rect
            id="Rectangle_1045"
            data-name="Rectangle 1045"
            className="cls-2"
            width="5"
            height="6"
            rx="1"
            transform="translate(9.198 -.057)"
          />
          <rect
            id="Rectangle_1046"
            data-name="Rectangle 1046"
            className="cls-2"
            width="5"
            height="6"
            rx="1"
            transform="translate(9.198 16.943)"
          />
          <rect
            id="Rectangle_1047"
            data-name="Rectangle 1047"
            className="cls-2"
            width="6"
            height="5"
            rx="1"
            transform="translate(18.198 8.943)"
          />
          <rect
            id="Rectangle_1048"
            data-name="Rectangle 1048"
            className="cls-2"
            width="6"
            height="5"
            rx="1"
            transform="translate(-.802 8.943)"
          />
          <path
            id="Line_159"
            data-name="Line 159"
            className="cls-3"
            transform="translate(11.744 3.066)"
            d="M0 0v8.037"
          />
          <path
            id="Line_160"
            data-name="Line 160"
            className="cls-3"
            transform="translate(11.744 13.296)"
            d="M0 0v8.037"
          />
          <path
            id="Line_161"
            data-name="Line 161"
            className="cls-3"
            transform="translate(12.793 11.444)"
            d="M7.307 0H0"
          />
          <path
            id="Line_162"
            data-name="Line 162"
            className="cls-3"
            transform="translate(2.198 11.444)"
            d="M7.307 0H0"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const filledTickIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "21"} height={height || "21"} viewBox="0 0 21 21">
    <g data-name="Group 1113">
      <g data-name="Ellipse 264" style={{ fill: "#73aa6a", stroke: "#73aa6a" }}>
        <circle cx="10.5" cy="10.5" r="10.5" style={{ stroke: "none" }} />
        <circle cx="10.5" cy="10.5" r="10" style={{ fill: "none" }} />
      </g>
      <g data-name="tick (1)">
        <g data-name="Group 840">
          <path
            data-name="Path 2269"
            d="M7.529 68.127a.347.347 0 0 0-.54 0l-4.578 5.294-1.759-2.035a.347.347 0 0 0-.54 0 .492.492 0 0 0 0 .625l2.03 2.347a.347.347 0 0 0 .54 0l4.847-5.607a.492.492 0 0 0 0-.624z"
            transform="translate(6.519 -60.749)"
            style={{ fill: "#fff", stroke: "#fff" }}
          />
        </g>
      </g>
    </g>
  </svg>
);

export const antiClockIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "14"} height={height || "14"} viewBox="0 0 18 18">
    <path
      data-name="Icon awesome-history"
      d="M18 9.265a8.719 8.719 0 0 1-14.191 6.8.843.843 0 0 1-.065-1.252l.4-.4a.845.845 0 0 1 1.121-.07 6.469 6.469 0 1 0-.413-9.784l1.781 1.793a.562.562 0 0 1-.4.96H1.125a.562.562 0 0 1-.562-.562V1.639a.563.563 0 0 1 .96-.4l1.735 1.738A8.719 8.719 0 0 1 18 9.265zm-6.36 2.77.345-.444a.844.844 0 0 0-.148-1.184l-1.431-1.113V5.625a.844.844 0 0 0-.844-.844H9a.844.844 0 0 0-.844.844v4.769l2.3 1.789a.844.844 0 0 0 1.184-.148z"
      transform="translate(-.563 -.563)"
      style={{ fill: "#428bca" }}
    />
  </svg>
);

export const filledFilterIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "25"} height={height || "25"} viewBox="0 0 25 25">
    <defs>
      <style>{`.filled-filter-icon{fill:#d6d5d5}`}</style>
    </defs>
    <path
      data-name="Icon awesome-filter"
      d="M23.827 0H1.173a1.173 1.173 0 0 0-.828 2l9.03 9.032v10.062a1.172 1.172 0 0 0 .5.96l3.906 2.733a1.173 1.173 0 0 0 1.844-.96V11.032L24.656 2a1.173 1.173 0 0 0-.829-2z"
      className="filled-filter-icon"
    />
  </svg>
);

export const rowIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "26"} height={height || "10.781"} viewBox="0 0 26 11">
    <g data-name="Group 836">
      <path
        data-name="Path 2242"
        d="M0 149.854v10.781h26v-10.781zm8.033 8.878H1.9v-6.976h6.13zm8.032 0h-6.13v-6.976h6.13v6.976zm8.033 0h-6.13v-6.976H24.1v6.976z"
        transform="translate(0 -149.854)"
        style={{ fill: "#d6d5d5" }}
      />
    </g>
  </svg>
);

export const secondaryClockIcon = (
  <svg width="12.345" height="12.351">
    <defs>
      <style>{`.cls-1{fill:#bdbec4;fillRule:evenodd}`}</style>
    </defs>
    <g
      id="Group_135"
      data-name="Group 135"
      transform="translate(-176.132 -262.092)"
    >
      <path
        id="Path_238"
        data-name="Path 238"
        className="cls-1"
        d="M176.135 268.251a6.171 6.171 0 1 1 6.464 6.185 6.192 6.192 0 0 1-6.464-6.185zm6.174-4.972a4.989 4.989 0 1 0 4.985 5.053 4.963 4.963 0 0 0-4.985-5.053z"
      />
      <path
        id="Path_239"
        data-name="Path 239"
        className="cls-1"
        d="M272.61 306.674v-1.843c0-.417.072-.486.5-.487h.51c.3.006.389.1.39.424 0 1.04.008 2.079 0 3.119a.482.482 0 0 0 .24.461c.453.308.89.638 1.332.962.255.187.274.31.094.566-.119.17-.243.337-.363.506a.323.323 0 0 1-.511.081c-.665-.482-1.335-.957-1.987-1.456a.59.59 0 0 1-.191-.4c-.024-.647-.014-1.29-.014-1.933z"
        transform="translate(-91.004 -39.856)"
      />
    </g>
  </svg>
);

export const integerIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "12.5"} height={height || "12.5"} viewBox="0 0 17 17">
    <defs>
      <style>{`.integer-icon-svg{fill:#515151}`}</style>
    </defs>
    <path
      data-name="Icon awesome-hashtag"
      d="m16.721 7.946.271-1.518a.455.455 0 0 0-.448-.535h-2.838l.555-3.107a.455.455 0 0 0-.448-.535H12.27a.455.455 0 0 0-.448.375l-.583 3.267H7.5l.555-3.107A.455.455 0 0 0 7.6 2.25H6.061a.455.455 0 0 0-.448.375l-.584 3.268h-3a.455.455 0 0 0-.448.375l-.273 1.518a.455.455 0 0 0 .448.535H4.6l-.867 4.857h-3a.455.455 0 0 0-.448.375l-.278 1.519a.455.455 0 0 0 .448.535h2.839l-.555 3.107a.455.455 0 0 0 .448.535h1.542a.455.455 0 0 0 .448-.375l.584-3.267H9.5l-.555 3.107a.455.455 0 0 0 .448.535h1.542a.455.455 0 0 0 .448-.375l.583-3.267h3a.455.455 0 0 0 .448-.375l.271-1.518a.455.455 0 0 0-.448-.535H12.4l.867-4.857h3a.455.455 0 0 0 .448-.375zm-6.783 5.232H6.195l.867-4.857H10.8z"
      transform="translate(0 -2.25)"
      className="integer-icon-svg"
    />
  </svg>
);

export const moreDetailsIcon = (
  <svg width="36" height="36" viewBox="0 0 36 36">
    <defs>
      <style>
        {`.cls-2{fill:none;stroke:#428bca;stroke-linecap:round;stroke-linejoin:round;strokeWidth:2px}`}
      </style>
    </defs>
    <g id="Group_1193" data-name="Group 1193" transform="translate(-10.327)">
      <g id="Group_742" data-name="Group 742" transform="translate(10.327)">
        <g
          id="Ellipse_263"
          data-name="Ellipse 263"
          style={{ stroke: "#428bca", fill: "none" }}
        >
          <circle cx="18" cy="18" r="18" style={{ stroke: "none" }} />
          <circle cx="18" cy="18" r="17.5" style={{ fill: "none" }} />
        </g>
      </g>
      <g
        id="Icon_feather-arrow-upRight"
        data-name="Icon feather-arrow-upRight"
        transform="translate(13.093 2.766)"
      >
        <path
          id="Path_2392"
          data-name="Path 2392"
          className="cls-2"
          d="m10.5 19.969 9.469-9.469"
        />
        <path
          id="Path_2393"
          data-name="Path 2393"
          className="cls-2"
          d="M10.5 10.5h9.469v9.469"
        />
      </g>
    </g>
  </svg>
);

export const profileDetailsIcon = (
  <svg width="21.071" height="21.416">
    <path
      d="M20.048 9h-2.124a7.687 7.687 0 0 0-5.5-5.51V1.022A1.022 1.022 0 0 0 11.412 0h-1.72a1.022 1.022 0 0 0-1.029 1.022v2.443A7.681 7.681 0 0 0 3.087 9H1.022A1.022 1.022 0 0 0 0 10.031v1.719a1.022 1.022 0 0 0 1.022 1.022H3.08a7.7 7.7 0 0 0 5.583 5.57v2.045a1.029 1.029 0 0 0 1.029 1.029h1.719a1.029 1.029 0 0 0 1.022-1.029v-2.071a7.674 7.674 0 0 0 5.49-5.543h2.124a1.022 1.022 0 0 0 1.022-1.022v-1.72A1.022 1.022 0 0 0 20.048 9zm-7.614 7.966v-1.54a1.022 1.022 0 0 0-1.022-1.022h-1.72a1.022 1.022 0 0 0-1.029 1.022v1.54a6.38 6.38 0 0 1-4.215-4.2h1.527A1.022 1.022 0 0 0 7 11.75v-1.719A1.022 1.022 0 0 0 5.975 9H4.461a6.353 6.353 0 0 1 4.2-4.162v1.137A1.022 1.022 0 0 0 9.692 7h1.719a1.022 1.022 0 0 0 1.022-1.022V4.866A6.366 6.366 0 0 1 16.557 9h-1.468a1.022 1.022 0 0 0-1.022 1.029v1.721a1.022 1.022 0 0 0 1.022 1.022H16.6a6.346 6.346 0 0 1-4.162 4.169z"
      style={{ fill: "#d6d5d5" }}
    />
  </svg>
);

export const decimalIcon = (
  <svg width="19" height="11.77" viewBox="0 0 24 15">
    <defs>
      <style>{`.cls-decimal-icon{fill:#515151;stroke:#fff;strokeWidth:.5px}`}</style>
      <style>{`.cls-decimal-icon{fill:#515151;stroke:#fff;strokeWidth:.5px}`}</style>
    </defs>
    <g
      id="Group_1206"
      data-name="Group 1206"
      transform="translate(-912.974 -1319.335)"
    >
      <g id="week" transform="translate(980.043 1234)">
        <g
          id="Group_1027"
          data-name="Group 1027"
          transform="translate(-52.964 85.639)"
        >
          <g id="Group_1026" data-name="Group 1026">
            <path
              id="Path_2356"
              data-name="Path 2356"
              className="cls-decimal-icon"
              d="M140.743 143.345c-2.652 0-4.707 1.23-4.707 4.534v5.092c0 3.3 2.056 4.534 4.707 4.534s4.727-1.23 4.727-4.534v-5.092c0-3.304-2.075-4.534-4.727-4.534zm1.729 9.626c0 1.326-.653 1.921-1.729 1.921s-1.71-.6-1.71-1.921v-5.092c0-1.326.634-1.921 1.71-1.921s1.729.6 1.729 1.921z"
              transform="translate(-136.036 -143.345)"
            />
          </g>
        </g>
        <g
          id="Group_1029"
          data-name="Group 1029"
          transform="translate(-47.819 85.6)"
        >
          <g id="Group_1028" data-name="Group 1028" transform="translate(-19)">
            <path
              id="Path_2357"
              data-name="Path 2357"
              className="cls-decimal-icon"
              d="m297.677 142.866-2.536 1.537a1.147 1.147 0 0 0-.557 1.018c0 .6.384 1.191.941 1.191a.874.874 0 0 0 .48-.154l.557-.346v9.78c0 .615.749.922 1.5.922s1.5-.307 1.5-.922v-12.22c-.002-.784-1.312-1.163-1.885-.806z"
              transform="translate(-294.584 -142.731)"
            />
          </g>
        </g>
      </g>
      <circle
        id="Ellipse_268"
        data-name="Ellipse 268"
        cx="2"
        cy="2"
        r="2"
        transform="translate(921 1327)"
        fill="#515151"
      />
    </g>
  </svg>
);

export const stringIcon = (
  <svg id="alphabet" width="20" height="9" viewBox="0 0 25 10.714">
    <defs>
      <style>{`.string-icon-cls-1{fill:#515151}`}</style>
    </defs>
    <path
      id="Path_2238"
      data-name="Path 2238"
      className="string-icon-cls-1"
      d="M15.25 10.714a.893.893 0 0 1-.893-.893v-6.25a1.786 1.786 0 0 0-3.571 0v6.25a.893.893 0 1 1-1.786 0v-6.25a3.571 3.571 0 0 1 7.143 0v6.25a.893.893 0 0 1-.893.893z"
      transform="translate(-9)"
    />
    <path
      id="Path_2239"
      data-name="Path 2239"
      className="string-icon-cls-1"
      d="M15.25 4.786H9.893a.893.893 0 1 1 0-1.786h5.357a.893.893 0 1 1 0 1.786z"
      transform="translate(-9 2.357)"
    />
    <path
      id="Path_2240"
      data-name="Path 2240"
      className="string-icon-cls-1"
      d="M18.018 10.714h-3.125A.893.893 0 0 1 14 9.821V.893A.893.893 0 0 1 14.893 0h3.125A3.124 3.124 0 0 1 20.2 5.357a3.124 3.124 0 0 1-2.186 5.357zm-2.232-1.785h2.232a1.339 1.339 0 0 0 0-2.679h-2.232zm0-4.464h2.232a1.339 1.339 0 0 0 0-2.679h-2.232z"
      transform="translate(-5.071)"
    />
    <path
      id="Path_2241"
      data-name="Path 2241"
      className="string-icon-cls-1"
      d="M25.25 10.714h-3.571A2.682 2.682 0 0 1 19 8.036V2.679A2.682 2.682 0 0 1 21.679 0h3.571a.893.893 0 1 1 0 1.786h-3.571a.893.893 0 0 0-.893.893v5.357a.893.893 0 0 0 .893.893h3.571a.893.893 0 1 1 0 1.786z"
      transform="translate(-1.143)"
    />
  </svg>
);

export const percentageIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "13.308"} height={height || "18"} viewBox="0 0 13 18">
    <defs>
      <style>{`.cls-1{fill:#515151}`}</style>
    </defs>
    <g
      id="Group_1023"
      data-name="Group 1023"
      transform="translate(-912.692 -1423)"
    >
      <rect
        id="Rectangle_1145"
        data-name="Rectangle 1145"
        className="cls-1"
        width="2.73"
        height="18"
        rx="1"
        transform="rotate(38 -1605.63 2052.219)"
      />
      <circle
        id="Ellipse_266"
        data-name="Ellipse 266"
        className="cls-1"
        cx="3"
        cy="3"
        r="3"
        transform="translate(920 1435)"
      />
      <circle
        id="Ellipse_267"
        data-name="Ellipse 267"
        className="cls-1"
        cx="3"
        cy="3"
        r="3"
        transform="translate(913 1423)"
      />
    </g>
  </svg>
);

export const groupExpandIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "48"} height={height || "48"}>
    <g data-name="Group 1264">
      <g data-name="Group 743">
        <g
          data-name="Ellipse 263"
          transform="translate(0 .001)"
          style={{ fill: "#fff", stroke: "#428bca" }}
        >
          <circle cx="24" cy="24" r="24" style={{ stroke: "none" }} />
          <circle cx="24" cy="24" r="23.5" style={{ fill: "none" }} />
        </g>
        <path
          data-name="Icon awesome-expand-arrows-alt"
          d="M18.856 15.382V20.1a1.008 1.008 0 0 1-1.01 1.01h-4.714a1.012 1.012 0 0 1-.716-1.726l1.524-1.524-4.512-4.515-4.513 4.516L6.44 19.38a1.012 1.012 0 0 1-.716 1.726H1.01A1.008 1.008 0 0 1 0 20.1v-4.718a1.011 1.011 0 0 1 1.726-.716l1.523 1.524 4.515-4.512-4.516-4.516L1.726 8.69A1.011 1.011 0 0 1 0 7.974V3.26a1.008 1.008 0 0 1 1.01-1.01h4.714a1.012 1.012 0 0 1 .716 1.726L4.916 5.5l4.512 4.512L13.941 5.5l-1.525-1.524a1.012 1.012 0 0 1 .716-1.726h4.714a1.008 1.008 0 0 1 1.01 1.01v4.714a1.011 1.011 0 0 1-1.726.716l-1.523-1.524-4.515 4.512 4.515 4.516 1.523-1.524a1.009 1.009 0 0 1 1.726.712z"
          transform="translate(14.573 12.323)"
          style={{ fill: "#428bca" }}
        />
      </g>
    </g>
  </svg>
);

export const horizentalBarChartIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "21.064"} height={height || "20.849"}>
    <path
      data-name="Icon metro-chart-bars"
      d="M9.571 26.992h20.848v1.856H9.571zm2.64-8.424h3.856v8.5h-3.856zm5.784-6.216h3.856v14.712h-3.856zm5.784-4.568h3.856v19.28h-3.856z"
      transform="rotate(90 19.21 9.639)"
      style={{ fill: "#328db5" }}
    />
  </svg>
);

export const groupCollapsedIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "48"} height={height || "48"}>
    <defs>
      <style>{`.cls-2020{fill:#428bca}`}</style>
    </defs>
    <g id="Group_1264" data-name="Group 1264" transform="translate(.183 .182)">
      <g id="Group_743" data-name="Group 743">
        <g
          id="Ellipse_263"
          data-name="Ellipse 263"
          transform="translate(-.183 -.181)"
          style={{ fill: "#fff", stroke: "#428bca" }}
        >
          <circle cx="24" cy="24" r="24" style={{ stroke: "none" }} />
          <circle cx="24" cy="24" r="23.5" style={{ fill: "none" }} />
        </g>
        <g
          id="Group_1272"
          data-name="Group 1272"
          transform="translate(13.261 13.262)"
        >
          <g id="two-arrows">
            <g id="_x36_">
              <g id="Group_1272-2" data-name="Group 1272">
                <path
                  id="Path_2432"
                  data-name="Path 2432"
                  className="cls-2020"
                  d="M8.992 12.115a.676.676 0 0 0-.5-.23L2.8 11.877a.679.679 0 0 0-.681.681c0 .377.44.8.629.989l1.439 1.439L0 19.133l1.979 1.979L6.106 16.9l1.439 1.439c.311.311.627.643 1 .643a.679.679 0 0 0 .681-.681l-.008-5.689a.676.676 0 0 0-.226-.497zm8.02-6.061 4.1-4.074L19.133 0l-4.072 4.09L13.6 2.617c-.317-.319-.638-.658-1.021-.658a.694.694 0 0 0-.693.7l.008 5.823a.807.807 0 0 0 .744.749l5.786.008a.694.694 0 0 0 .693-.7c0-.385-.447-.819-.639-1.012z"
                />
              </g>
            </g>
          </g>
          <g id="two-arrows-2" data-name="two-arrows">
            <g id="_x36_2" data-name="_x36_">
              <g id="Group_1272-3" data-name="Group 1272">
                <path
                  id="Path_2432-2"
                  data-name="Path 2432"
                  className="cls-2020"
                  d="M12.121 12.115a.676.676 0 0 1 .5-.23l5.689-.008a.679.679 0 0 1 .681.681c0 .377-.44.8-.629.989l-1.439 1.439 4.188 4.147-1.979 1.979-4.125-4.212-1.439 1.439c-.311.311-.627.643-1 .643a.679.679 0 0 1-.681-.681l.008-5.689a.676.676 0 0 1 .226-.497zM4.1 6.053 0 1.979 1.979 0l4.073 4.09 1.464-1.473c.317-.319.638-.658 1.021-.658a.694.694 0 0 1 .693.7l-.009 5.82a.807.807 0 0 1-.744.749l-5.786.008A.694.694 0 0 1 2 8.539c0-.385.447-.819.639-1.012z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const singleCollapseIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "42"} height={height || "42"}>
    <defs>
      <style>{`.cls-1256{ fill: #fafafa; stroke: #328db5; strokeWidth: 0.5px }`}</style>
    </defs>
    <g data-name="Group 1274">
      <g data-name="Group 1261">
        <g data-name="Ellipse 263" className="cls-1256">
          <circle cx="21" cy="21" r="21" style={{ stroke: "none" }} />
          <circle cx="21" cy="21" r="20.75" style={{ fill: "none" }} />
        </g>
      </g>
      <g data-name="Group 1272">
        <path
          data-name="Path 2432"
          d="M8.992 12.115a.676.676 0 0 0-.5-.23L2.8 11.877a.679.679 0 0 0-.681.681c0 .377.44.8.629.989l1.439 1.439L0 19.133l1.979 1.979L6.106 16.9l1.439 1.439c.311.311.627.643 1 .643a.679.679 0 0 0 .681-.681l-.008-5.689a.676.676 0 0 0-.226-.497zm8.02-6.061 4.1-4.074L19.133 0l-4.072 4.09L13.6 2.617c-.317-.319-.638-.658-1.021-.658a.694.694 0 0 0-.693.7l.008 5.823a.807.807 0 0 0 .744.749l5.786.008a.694.694 0 0 0 .693-.7c0-.385-.447-.819-.639-1.012z"
          style={{ fill: "#428bca" }}
          transform="translate(10.444 10.444)"
        />
      </g>
    </g>
  </svg>
);

export const uploadIcon = (width?: string, height?: string): JSX.Element => (
  <svg id="upload" width={width || "49.966"} height={height || "49.966"}>
    <defs>
      <style>{` .cls-1{fill:#428bca}`}</style>
    </defs>
    <path
      id="Path_2416"
      data-name="Path 2416"
      className="cls-1"
      d="M386.851 12.18h10.893L385.388 0v10.716a1.465 1.465 0 0 0 1.463 1.464z"
      transform="translate(-347.778)"
    />
    <path
      id="Path_2417"
      data-name="Path 2417"
      className="cls-1"
      d="M88.675 10.716V0h-27.38a1.464 1.464 0 0 0-1.464 1.464v9.857h16.351a8.048 8.048 0 0 1 8.039 8.039v16.99a8.048 8.048 0 0 1-8.039 8.039H59.831V48.5a1.464 1.464 0 0 0 1.464 1.464h41.2a1.464 1.464 0 0 0 1.464-1.464V15.108H93.065a4.4 4.4 0 0 1-4.39-4.392z"
      transform="translate(-53.992)"
    />
    <path
      id="Path_2418"
      data-name="Path 2418"
      d="M27.4 167.205v-16.99a5.209 5.209 0 0 0-5.209-5.209H5.209A5.209 5.209 0 0 0 0 150.216v16.99a5.209 5.209 0 0 0 5.209 5.209H22.19a5.209 5.209 0 0 0 5.21-5.21zm-8.153-10a1.464 1.464 0 0 1-2.07 0l-2.013-2.013v10.628a1.464 1.464 0 0 1-2.928 0v-10.631l-2.013 2.011a1.464 1.464 0 0 1-2.07-2.07l4.512-4.512a1.472 1.472 0 0 1 2.07 0l4.512 4.512a1.464 1.464 0 0 1 0 2.07z"
      transform="translate(0 -130.856)"
      style={{ fill: "#a7a7a7" }}
    />
  </svg>
);

export const buildingIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "64.858"} height={height || "55.073"}>
    <defs>
      <style>{`.cls-125362{fill:#428bca}.cls-212545{fill:#a7a7a7}`}</style>
    </defs>
    <g id="building" transform="translate(4.892)">
      <path
        id="Path_2410"
        data-name="Path 2410"
        className="cls-125362"
        d="M233.5 437h4.84v8.067h-4.84z"
        transform="translate(-208.384 -389.994)"
      />
      <path
        id="Path_2411"
        data-name="Path 2411"
        className="cls-125362"
        d="M166.089 152h-20.976a1.614 1.614 0 0 0-1.613 1.613v37.11h6.454v-9.681a1.614 1.614 0 0 1 1.613-1.613h8.067a1.614 1.614 0 0 1 1.613 1.613v9.681h6.453v-37.11a1.614 1.614 0 0 0-1.611-1.613zm-6.454 24.2h-8.067a1.613 1.613 0 0 1 0-3.227h8.067a1.613 1.613 0 1 1 0 3.227zm0-6.454h-8.067a1.613 1.613 0 0 1 0-3.227h8.067a1.613 1.613 0 1 1 0 3.227zm0-6.454h-8.067a1.613 1.613 0 0 1 0-3.227h8.067a1.613 1.613 0 1 1 0 3.227z"
        transform="translate(-128.064 -135.65)"
      />
      <path
        id="Path_2412"
        data-name="Path 2412"
        className="cls-212545"
        d="M413.341 347H398.5v24.86h5.914v-7.91a2.26 2.26 0 1 1 4.52 0v7.91h4.407a2.26 2.26 0 0 0 2.26-2.26v-20.34a2.26 2.26 0 0 0-2.26-2.26z"
        transform="translate(-355.635 -316.787)"
      />
      <path
        id="Path_2413"
        data-name="Path 2413"
        className="cls-212545"
        d="M0 349.26v20.34a2.26 2.26 0 0 0 2.26 2.26h4.407v-7.91a2.26 2.26 0 1 1 4.52 0v7.91H17.1V347H2.26A2.26 2.26 0 0 0 0 349.26z"
        transform="translate(-4.892 -316.787)"
      />
      <path
        id="Path_2414"
        data-name="Path 2414"
        className="cls-125362"
        d="M203.021 78.613A1.614 1.614 0 0 0 201.408 77h-11.295a1.614 1.614 0 0 0-1.613 1.613v3.227h14.521z"
        transform="translate(-168.224 -68.718)"
      />
      <path
        id="Path_2415"
        data-name="Path 2415"
        className="cls-125362"
        d="M244.227 1.613a1.613 1.613 0 0 0-3.227 0v3.443h3.227z"
        transform="translate(-215.077)"
      />
    </g>
  </svg>
);

export const secondaryUploadIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg id="upload" width={width || "49.966"} height={height || "49.966"}>
    <defs>
      <style>{`.cls-1{fill:#72b4f3}`}</style>
    </defs>
    <path
      id="Path_2416"
      data-name="Path 2416"
      className="cls-1"
      d="M386.851 12.18h10.893L385.388 0v10.716a1.465 1.465 0 0 0 1.463 1.464z"
      transform="translate(-347.778)"
    />
    <path
      id="Path_2417"
      data-name="Path 2417"
      className="cls-1"
      d="M88.675 10.716V0h-27.38a1.464 1.464 0 0 0-1.464 1.464v9.857h16.351a8.048 8.048 0 0 1 8.039 8.039v16.99a8.048 8.048 0 0 1-8.039 8.039H59.831V48.5a1.464 1.464 0 0 0 1.464 1.464h41.2a1.464 1.464 0 0 0 1.464-1.464V15.108H93.065a4.4 4.4 0 0 1-4.39-4.392z"
      transform="translate(-53.992)"
    />
    <path
      id="Path_2418"
      data-name="Path 2418"
      d="M27.4 167.205v-16.99a5.209 5.209 0 0 0-5.209-5.209H5.209A5.209 5.209 0 0 0 0 150.216v16.99a5.209 5.209 0 0 0 5.209 5.209H22.19a5.209 5.209 0 0 0 5.21-5.21zm-8.153-10a1.464 1.464 0 0 1-2.07 0l-2.013-2.013v10.628a1.464 1.464 0 0 1-2.928 0v-10.631l-2.013 2.011a1.464 1.464 0 0 1-2.07-2.07l4.512-4.512a1.472 1.472 0 0 1 2.07 0l4.512 4.512a1.464 1.464 0 0 1 0 2.07z"
      transform="translate(0 -130.856)"
      style={{ fill: "#fff" }}
    />
  </svg>
);

export const cloudyUploadIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 270.11 197.83"
    width={width || "132px"}
    height={height || "97px"}
  >
    <defs>
      <style>{`.cls-1{fill:#bed7eb;}`}</style>
    </defs>
    <title>upload</title>
    <path
      className="cls-1"
      d="M269.41,134.62c-2.72-15.9-12.73-29.41-26.27-37.89l-9.07-4.12c-1-.44-4.74-.52-5-1.77a2.94,2.94,0,0,1,.55-1.93,34.11,34.11,0,0,0,3.63-10c2.87-14.6-3.2-29.8-15.92-37.65-11.59-7.16-28.25-9.16-39.23.27-3.29,2.83-3.75,1.87-5.39-1.7A65.42,65.42,0,0,0,156.28,18C132.67-2.64,95.52-6.28,69,11,46.45,25.65,35.78,50.05,36.14,76.31a1.83,1.83,0,0,1-1,1.94C13,89.92-1.1,112.46.07,137.67A59.27,59.27,0,0,0,2.21,151c6.21,22.18,24.87,39,47.62,45.06,8.34,2.21,17.06,1.7,25.6,1.68q59.55-.14,119.11-.12c18.08,0,36.12,1.68,51.81-9.07C263.21,177,272.86,154.8,269.41,134.62ZM178,106.81c-2.51,1.28-5.76.68-8.43.67q-11.61,0-23.22-.19c-3.47-.05-2.51,2.68-2.54,5.39q0,20.59.12,41.2c0,2.54-.08,5.7-2.5,7a4.09,4.09,0,0,1-.71.3,10.82,10.82,0,0,1-3.45.37c-8.56,0-17.12,0-25.67-.13a2.52,2.52,0,0,1-2.28-1.3,2.23,2.23,0,0,1-1-1.54c-.73-4.06-.31-8.16-.33-12.24q-.09-18.12,0-36.22c0-2.05-.74-2.48-2.62-2.46-9.08.08-18.16,0-27.25,0a4.82,4.82,0,0,1-2.55-.24c-8.23-4.12,1.53-11.26,5.44-15.21q12.23-12.35,24.57-24.57,6.82-6.73,13.67-13.44c1.95-1.91,4.34-5.23,7.45-4.81,1.81.24,3.58,1.83,5.15,3.49h0c1,1.09,2,2.21,2.75,3,1.46,1.46,3,2.9,4.54,4.34l12.59,12.69c.11.13.22.25.32.38s.19.24.29.35l9.46,9.48.64.57,11,11.11h0l3,3,.1.11a1.85,1.85,0,0,1,.14.14l1.56,1.56a5.41,5.41,0,0,1,1.59,3.81A3.32,3.32,0,0,1,178,106.81Z"
    />
  </svg>
);

export const rightAngle = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "39"}
    viewBox={`0 0 ${width || "20"} ${height || "39"}`}
  >
    <path
      data-name="Polygon 3"
      d="M18.784.734a1 1 0 0 1 1.432 0L37.344 18.3a1 1 0 0 1-.716 1.7H2.372a1 1 0 0 1-.716-1.7z"
      transform="rotate(90 10 10)"
      style={{ fill: "#eeada1" }}
    />
  </svg>
);

export const rectangleFileIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "49"} height={height || "49"}>
    <path
      data-name="Rectangle 1199"
      style={{ fill: "#32a3ce" }}
      d="M0 0h49v49H0z"
    />
  </svg>
);

export const blankFileIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "21.618"}
    height={height || "28.824"}
    viewBox="0 0 21.618 28.824"
  >
    <path
      data-name="Icon awesome-file"
      d="M12.611 7.656V0H1.351A1.348 1.348 0 0 0 0 1.351v26.122a1.348 1.348 0 0 0 1.351 1.351h18.916a1.348 1.348 0 0 0 1.351-1.351V9.008h-7.656a1.355 1.355 0 0 1-1.351-1.352zm9.008-.794v.343h-7.207V0h.343a1.35 1.35 0 0 1 .957.394l5.512 5.517a1.347 1.347 0 0 1 .394.952z"
      style={{ fill: "#fff" }}
    />
  </svg>
);

export const dvSumLogo = (): JSX.Element => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 147 77.77"
    width="53px"
    height="26px"
  >
    <defs>
      <style>{`.cls-1{fill:#3bc2cb;}.cls-2{fill:#fe6304;}.cls-3{fill:#28bec8;}`}</style>
    </defs>
    <title>Dvsum</title>
    <path className="cls-1" d="M32.48,36.13c-.83.14-.94-.42-1-1Z" />
    <path
      className="cls-2"
      d="M.73,70.22a24.68,24.68,0,0,1-.18-3.87V11c0-.57,0-1.14,0-1.71A8.46,8.46,0,0,1,1.63,5.13,8.37,8.37,0,0,1,3.16,3,9.19,9.19,0,0,1,5.94,1.19,7.59,7.59,0,0,1,9.16.49h13.7C30.7.49,38.72,0,46.5,1c8.67,1.6,17,5.68,22.62,12.59l.16.2A134,134,0,0,1,79.66,28.5c-.28.31,0,.58.1.85a8.49,8.49,0,0,1-2.42,8.47,8.29,8.29,0,0,1-8.89,1.92,20.75,20.75,0,0,1-2.68-1.31l-.2-.2c-.14-.18-.3-.36-.44-.56-1.66-2.42-3.29-4.85-5-7.25a44.89,44.89,0,0,0-5.8-7.35A19.44,19.44,0,0,0,41.87,18c-7.75-.4-15.53-.08-23.3-.15-.82,0-.62.53-.62,1q0,20.24,0,40.47c0,.82.26,1,1,1,7.08,0,14.15-.06,21.23,0a12.69,12.69,0,0,0,8.28-3,20.85,20.85,0,0,0,4.8-5.93,8.66,8.66,0,0,1,15.13,8.44A34.09,34.09,0,0,1,53,74.71a21.68,21.68,0,0,1-9.15,2.55c-12,.06-24,0-36,0A4.45,4.45,0,0,1,6.22,77a8.89,8.89,0,0,1-3.63-2.56,8.92,8.92,0,0,1-1.86-4.2Z"
    />
    <path
      className="cls-2"
      d="M29.6,39.72c0-3.41,0-6.82,0-10.22,0-.35-.15-.82.48-.8,2.84.11,5.7-.34,8.5.3a10.85,10.85,0,0,1,8.33,11.81,10.76,10.76,0,0,1-10.16,10c-2.14.11-4.29,0-6.43.07-.72,0-.73-.35-.73-.88Q29.61,44.89,29.6,39.72Z"
    />
    <path
      className="cls-3"
      d="M145,4.12A8.94,8.94,0,0,0,140.29.7,8.64,8.64,0,0,0,132.82,2a15,15,0,0,0-3,3.47q-14,19.24-27.89,38.51L96,52.17c-.63.88-.59.84-1.15-.08q-2.26-3.77-4.61-7.47c-2.65-4.2-5.33-8.39-8-12.58l-2.53-3.68c-.28.31,0,.58.1.85a8.49,8.49,0,0,1-2.42,8.47,8.29,8.29,0,0,1-8.89,1.92,20.29,20.29,0,0,1-2.69-1.32c0,.42.29.68.49,1,4.1,6.24,8,12.59,12,18.94q4.58,7.42,9,14.91c2.49,4.18,7.51,5,11.44,3.25,1.73-.78,2.8-2.28,3.9-3.77,5.69-7.69,11.08-15.6,16.82-23.26,2.71-3.6,5.29-7.29,7.94-10.93q6-8.35,12.08-16.7,2.52-3.49,5-7a13.54,13.54,0,0,0,1.65-2.76,7.28,7.28,0,0,0,.4-1.38A8.39,8.39,0,0,0,145,4.12Z"
    />
  </svg>
);

export const newsPaperIcon = (height?: string, width?: string): JSX.Element => (
  <svg id="newspaper" width={width || "19.893"} height={height || "22.046"}>
    <defs>
      <style>{`.cls-10326596{fill:#4c4c4c}`}</style>
    </defs>
    <path
      id="Path_2631"
      data-name="Path 2631"
      className="cls-10326596"
      d="M44.248 3.488h-2.8V.646A.646.646 0 0 0 40.8 0H25.646A.646.646 0 0 0 25 .646v17.267a.646.646 0 0 0 .646.646h2.8V21.4a.646.646 0 0 0 .646.646h15.156a.646.646 0 0 0 .646-.646V4.134a.646.646 0 0 0-.646-.646zm-17.956-2.2h13.865v15.979H26.292zM43.6 20.755H29.737v-2.2H40.8a.646.646 0 0 0 .646-.646V4.78H43.6z"
      transform="translate(-25)"
    />
    <path
      id="Path_2632"
      data-name="Path 2632"
      className="cls-10326596"
      d="M99.291 65h-9.645a.646.646 0 0 0 0 1.292h9.645a.646.646 0 0 0 0-1.292z"
      transform="translate(-86.244 -62.201)"
    />
    <path
      id="Path_2633"
      data-name="Path 2633"
      className="cls-10326596"
      d="M237.091 273h-3.445a.646.646 0 0 0 0 1.292h3.445a.646.646 0 0 0 0-1.292z"
      transform="translate(-224.044 -261.245)"
    />
    <path
      id="Path_2634"
      data-name="Path 2634"
      className="cls-10326596"
      d="M99.291 337h-9.645a.646.646 0 1 0 0 1.292h9.645a.646.646 0 1 0 0-1.292z"
      transform="translate(-86.244 -322.489)"
    />
    <path
      id="Path_2635"
      data-name="Path 2635"
      className="cls-10326596"
      d="M89.646 136.492h3.445a.646.646 0 0 0 .646-.646v-6.2a.646.646 0 0 0-.646-.646h-3.445a.646.646 0 0 0-.646.646v6.2a.646.646 0 0 0 .646.646zm.646-6.2h2.153v4.908h-2.153z"
      transform="translate(-86.244 -123.445)"
    />
    <path
      id="Path_2636"
      data-name="Path 2636"
      className="cls-10326596"
      d="M237.091 137h-3.445a.646.646 0 0 0 0 1.292h3.445a.646.646 0 0 0 0-1.292z"
      transform="translate(-224.044 -131.101)"
    />
    <path
      id="Path_2637"
      data-name="Path 2637"
      className="cls-10326596"
      d="M237.091 201h-3.445a.646.646 0 0 0 0 1.292h3.445a.646.646 0 0 0 0-1.292z"
      transform="translate(-224.044 -192.345)"
    />
  </svg>
);

export const historyIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    id="history_1_"
    data-name="history (1)"
    width={width || "22.046"}
    height={height || "22.046"}
  >
    <defs>
      <style>{`.cls-1035689{fill:#4c4c4c}`}</style>
      <style>{`.cls-inner-g{stroke: #4c4c4c; strokeWidth: 1.3px; fill: none }`}</style>
    </defs>
    <g id="Group_1665" data-name="Group 1665">
      <g id="Group_1664" data-name="Group 1664">
        <path
          id="Path_2628"
          data-name="Path 2628"
          className="cls-1035689"
          d="M11.023 0a.646.646 0 0 0 0 1.292 9.849 9.849 0 1 1-6.76 2.8V5.21a.646.646 0 1 0 1.291 0V2.627a.645.645 0 0 0-.645-.646H2.3a.644.644 0 1 0 0 1.287h.948A10.979 10.979 0 1 0 11.023 0z"
        />
      </g>
    </g>
    <g
      id="Group_1669"
      data-name="Group 1669"
      transform="translate(10.377 7.794)"
    >
      <g id="Group_1668" data-name="Group 1668">
        <path
          id="Path_2630"
          data-name="Path 2630"
          className="cls-1035689"
          d="m243.394 185.065-1.1-1.1v-2.316a.646.646 0 0 0-1.292 0v2.584a.646.646 0 0 0 .189.457l1.292 1.292a.646.646 0 0 0 .913-.913z"
          transform="translate(-241 -181)"
        />
      </g>
    </g>
    <g
      id="Ellipse_283"
      data-name="Ellipse 283"
      transform="translate(4.819 4.307)"
      className="cls-inner-g"
    >
      <circle cx="6.461" cy="6.461" r="6.461" style={{ stroke: "none" }} />
      <circle cx="6.461" cy="6.461" r="5.811" style={{ fill: "none" }} />
    </g>
  </svg>
);

export const tagIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "22.924"}
    height={height || "22.924"}
    viewBox="0 0 22 22"
  >
    <defs>
      <style>{`.cls-tag{fill:none;stroke:#4c4c4c;strokeWidth:1.5px}`}</style>
    </defs>
    <path
      data-name="Icon awesome-tag"
      d="M0 10.468V1.993A1.993 1.993 0 0 1 1.993 0h8.475a1.993 1.993 0 0 1 1.409.584l8.8 8.8a1.993 1.993 0 0 1 0 2.818L12.2 20.674a1.993 1.993 0 0 1-2.818 0l-8.8-8.8A1.993 1.993 0 0 1 0 10.468zm4.65-7.81A1.993 1.993 0 1 0 6.643 4.65 1.993 1.993 0 0 0 4.65 2.657z"
      transform="translate(.75 .75)"
      className="cls-tag"
    />
  </svg>
);

export const uploadIcon1 = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "17.71"} height={height || "22.275"}>
    <defs>
      <style>{`.cls-121605sdwe{fill:#4c4c4c;stroke:#4c4c4c;strokeWidth:.3px}`}</style>
    </defs>
    <g id="surface1" transform="translate(.15 .15)">
      <path
        id="Path_2625"
        data-name="Path 2625"
        className="cls-121605sdwe"
        d="M12.342.17A.532.532 0 0 0 11.96 0H3.388A2.9 2.9 0 0 0 .5 2.882v16.211a2.9 2.9 0 0 0 2.888 2.882h11.635a2.9 2.9 0 0 0 2.888-2.882V6.221a.571.571 0 0 0-.154-.372zm.154 1.7 3.626 3.81h-2.357A1.264 1.264 0 0 1 12.5 4.416zm2.527 19.04H3.388a1.839 1.839 0 0 1-1.826-1.821V2.882a1.839 1.839 0 0 1 1.826-1.82h8.047v3.354a2.322 2.322 0 0 0 2.33 2.325h3.084v12.352a1.835 1.835 0 0 1-1.826 1.821zm0 0"
        transform="translate(-.5)"
      />
      <path
        id="Path_2626"
        data-name="Path 2626"
        className="cls-121605sdwe"
        d="M98.44 401.934H89.7a.531.531 0 0 0 0 1.062h8.742a.531.531 0 1 0-.005-1.062zm0 0"
        transform="translate(-85.366 -384.683)"
      />
      <path
        id="Path_2627"
        data-name="Path 2627"
        className="cls-121605sdwe"
        d="m119.309 174.528 2.187-2.352v5.8a.531.531 0 0 0 1.062 0v-5.8l2.187 2.352a.53.53 0 0 0 .775-.722l-3.111-3.339a.527.527 0 0 0-.775 0l-3.111 3.339a.529.529 0 0 0 .026.748.542.542 0 0 0 .76-.026zm0 0"
        transform="translate(-113.322 -162.988)"
      />
    </g>
  </svg>
);

export const bookIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "27.046"} height={height || "24.491"}>
    <defs>
      <style>
        {`.cls-1book{fill:none;stroke:#4c4c4c;stroke-linecap:round;stroke-linejoin:round;strokeWidth:1.5px}`}
      </style>
    </defs>
    <g
      id="Icon_feather-book-open"
      data-name="Icon feather-book-open"
      transform="translate(.75 .75)"
    >
      <path
        id="Path_2623"
        data-name="Path 2623"
        className="cls-1book"
        d="M3 4.5h7.664a5.109 5.109 0 0 1 5.109 5.109v17.882a3.832 3.832 0 0 0-3.832-3.832H3z"
        transform="translate(-3 -4.5)"
      />
      <path
        id="Path_2624"
        data-name="Path 2624"
        className="cls-1book"
        d="M30.773 4.5h-7.664A5.109 5.109 0 0 0 18 9.609v17.882a3.832 3.832 0 0 1 3.832-3.832h8.941z"
        transform="translate(-5.227 -4.5)"
      />
    </g>
  </svg>
);

export const linkEmbedIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "22.131"}
    height={height || "22.111"}
    viewBox="0 0 22 22"
  >
    <defs>
      <style>
        {`.cls-1linkembedicon{fill:none;stroke:#4c4c4c;stroke-linecap:round;stroke-linejoin:round;strokeWidth:1.5px}`}
      </style>
    </defs>
    <g
      id="Icon_feather-link"
      data-name="Icon feather-link"
      transform="translate(.75 .75)"
    >
      <path
        id="Path_2638"
        data-name="Path 2638"
        className="cls-1linkembedicon"
        d="M15 14.344a5.155 5.155 0 0 0 7.774.557l3.093-3.093a5.155 5.155 0 1 0-7.29-7.29L16.8 6.281"
        transform="translate(-6.747 -3.007)"
      />
      <path
        id="Path_2639"
        data-name="Path 2639"
        className="cls-1linkembedicon"
        d="M15.37 15.56A5.155 5.155 0 0 0 7.6 15l-3.1 3.1a5.155 5.155 0 1 0 7.29 7.29l1.763-1.764"
        transform="translate(-2.993 -6.285)"
      />
    </g>
  </svg>
);

export const squareEditIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "24.491"} height={height || "24.491"}>
    <defs>
      <style>
        {`.cls-1editicon{fill:none;stroke:#4c4c4c;stroke-linecap:round;stroke-linejoin:round;strokeWidth:1.5px}`}
      </style>
    </defs>
    <g
      id="Icon_feather-edit"
      data-name="Icon feather-edit"
      transform="translate(.75 .75)"
    >
      <path
        id="Path_2621"
        data-name="Path 2621"
        className="cls-1editicon"
        d="M13.284 6h-8A2.285 2.285 0 0 0 3 8.285v16a2.285 2.285 0 0 0 2.285 2.285h16a2.285 2.285 0 0 0 2.285-2.285v-8"
        transform="translate(-3 -3.576)"
      />
      <path
        id="Path_2622"
        data-name="Path 2622"
        className="cls-1editicon"
        d="M24 3.528a2.424 2.424 0 0 1 3.428 3.428L16.571 17.811 12 18.954l1.143-4.571z"
        transform="translate(-5.144 -2.818)"
      />
    </g>
  </svg>
);

export const addInfoIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "37"} height={height || "37"}>
    <g data-name="Group 1698">
      <path
        data-name="Icon material-send"
        d="m3.01 22.172 20.608-8.836L3.01 4.5 3 11.373l14.727 1.964L3 15.3z"
        transform="translate(7.381 5.164)"
        style={{ fill: "#428bca" }}
      />
      <g data-name="Group 1671">
        <g data-name="Group 742">
          <g
            data-name="Ellipse 263"
            style={{ stroke: "#428bca", fill: "none" }}
          >
            <circle cx="18.5" cy="18.5" r="18.5" style={{ stroke: "none" }} />
            <circle cx="18.5" cy="18.5" r="18" style={{ fill: "none" }} />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const uploadIcon2 = (): JSX.Element => (
  <svg width="40.987" height="51.655">
    <defs>
      <style>{`.cls-2{fill:#4c4c4c;stroke:#4c4c4c;strokeWidth:.3px}`}</style>
    </defs>
    <g id="surface1" transform="translate(.15 .15)" style={{ opacity: ".2" }}>
      <path
        id="Path_2625"
        data-name="Path 2625"
        className="cls-2"
        d="M28.175.4a1.242 1.242 0 0 0-.893-.4H7.248A6.777 6.777 0 0 0 .5 6.736v37.883a6.777 6.777 0 0 0 6.748 6.736h27.191a6.777 6.777 0 0 0 6.748-6.736V14.538a1.335 1.335 0 0 0-.36-.868zm.36 3.982 8.473 8.894H31.5a2.954 2.954 0 0 1-2.965-2.952zm5.9 44.5H7.248a4.3 4.3 0 0 1-4.267-4.255V6.736a4.3 4.3 0 0 1 4.267-4.255h18.806v7.84a5.427 5.427 0 0 0 5.446 5.433h7.207v28.865a4.288 4.288 0 0 1-4.268 4.255zm0 0"
        transform="translate(-.5)"
      />
      <path
        id="Path_2626"
        data-name="Path 2626"
        className="cls-2"
        d="M110.83 401.934H90.412a1.24 1.24 0 0 0 0 2.481h20.431a1.241 1.241 0 1 0-.013-2.481zm0 0"
        transform="translate(-80.278 -361.619)"
      />
      <path
        id="Path_2627"
        data-name="Path 2627"
        className="cls-2"
        d="m120.55 180.184 5.111-5.5v13.546a1.241 1.241 0 0 0 2.481 0v-13.542l5.111 5.5a1.238 1.238 0 0 0 1.811-1.687l-7.269-7.8a1.231 1.231 0 0 0-1.811 0l-7.269 7.8a1.236 1.236 0 0 0 .062 1.749 1.266 1.266 0 0 0 1.773-.066zm0 0"
        transform="translate(-106.558 -153.216)"
      />
    </g>
  </svg>
);

export const lightCrossIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "10.53"} height={height || "10.527"} viewBox="0 0 11 11">
    <defs>
      <style>{`.light-cross-icon{fill:#777}`}</style>
    </defs>
    <path
      data-name="Icon ionic-ios-close"
      d="m17.8 16.552 3.761-3.761a.881.881 0 1 0-1.246-1.246l-3.761 3.761-3.761-3.761a.881.881 0 1 0-1.246 1.246l3.761 3.761-3.761 3.761a.881.881 0 0 0 1.246 1.246l3.758-3.759 3.761 3.761a.881.881 0 0 0 1.246-1.246z"
      transform="translate(-11.285 -11.289)"
      className=".light-cross-icon"
    />
  </svg>
);

export const closeIconInCircle = (): JSX.Element => (
  <svg width="14" height="14">
    <defs>
      <style>{`.circle-cls{fill:#eaeaea}`}</style>
      <style>{`.path-cls{fill:#777}`}</style>
    </defs>
    <g data-name="Group 1649" transform="translate(-488.254 -1207.254)">
      <circle
        data-name="Ellipse 282"
        cx="7"
        cy="7"
        r="7"
        transform="translate(488.254 1207.254)"
        className="circle-cls"
      />
      <path
        data-name="Icon ionic-ios-close"
        d="m14.65 14.008 1.943-1.943a.455.455 0 1 0-.644-.644l-1.943 1.943-1.943-1.943a.455.455 0 1 0-.644.644l1.943 1.943-1.943 1.943a.455.455 0 0 0 .644.644l1.943-1.943L15.95 16.6a.455.455 0 0 0 .644-.644z"
        transform="translate(481.248 1200.245)"
        className="path-cls"
      />
    </g>
  </svg>
);

export const glossaryHeaderLogo = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    id="Group_1161"
    data-name="Group 1161"
    width={width || "42.648"}
    height={height || "22.5"}
  >
    <defs>
      <style>{`.cls-1{fill:#fff}`}</style>
    </defs>
    <path
      id="Path_2502"
      data-name="Path 2502"
      className="cls-1"
      d="M118.978 207.507a2.429 2.429 0 0 0-.832-1.3 2.554 2.554 0 0 0-3.207.022 8.022 8.022 0 0 0-1.077 1.345c-.2.264-.4.527-.592.8-.3.416-.6.836-.895 1.256q-.63.83-1.221 1.689c-.175.234-.352.468-.525.709-.234.325-.468.653-.7.98-.214.291-.429.581-.641.873-.373.515-.742 1.033-1.113 1.549a.367.367 0 0 0-.042.043q-.639.888-1.284 1.773c-.367.509-.731 1.02-1.1 1.529l-1.516 2.082a.156.156 0 0 1-.2 0 1.469 1.469 0 0 1-.312-.447 14.75 14.75 0 0 0-1-1.641c-.012-.023-.021-.047-.034-.068-.413-.661-.829-1.32-1.239-1.983a10.079 10.079 0 0 0-.847-1.231c-.078-.136-.163-.27-.242-.406a7.253 7.253 0 0 0-.8-1.225c-.347-.57-.692-1.14-1.083-1.682-.09-.135-.178-.272-.272-.4-.424-.592-.843-1.182-1.31-1.747a9.955 9.955 0 0 0-1.06-1.237 6.583 6.583 0 0 0-.889-.784.562.562 0 0 0-.156-.14 10.836 10.836 0 0 0-6.126-2.159c-.857-.051-1.725-.041-2.588-.047a192.712 192.712 0 0 0-3.877.006c-1.091.016-2.187.007-3.281.008a2.487 2.487 0 0 0-2.375 1.822 5.552 5.552 0 0 0-.111 1.521v11.623a.2.2 0 0 0 0 .03v4.931a1.091 1.091 0 0 0 .025.164 1.5 1.5 0 0 0 .063.452 2.424 2.424 0 0 0 2.228 1.907c.636.037 1.275.025 1.913.026h7.389a8.583 8.583 0 0 0 1.069-.053 8.922 8.922 0 0 0 5.356-2.728 9.24 9.24 0 0 0 1.06-1.295 7.106 7.106 0 0 0 .624-.957 2.612 2.612 0 0 0 .234-2.235 2.26 2.26 0 0 0-1.066-1.285 1.9 1.9 0 0 0-.691-.3 2.406 2.406 0 0 0-2.165.456 2.375 2.375 0 0 0-.643.727 6.626 6.626 0 0 1-1.182 1.533 3.57 3.57 0 0 1-2.462 1.075c-2.116.012-4.232.007-6.349.007-.234 0-.312-.078-.334-.306-.007-.078-.011-.162-.016-.244a.32.32 0 0 0 .017-.179v-2.076a.038.038 0 0 0 0-.013v-6.407c0-.525-.013-1.051-.02-1.578 0-.065 0-.131.006-.2a11.676 11.676 0 0 1 .027-1.214.392.392 0 0 1 .379-.179c.362 0 .724.008 1.087.008h3.857c.055 0 .111-.005.167-.008l.505.008a10.184 10.184 0 0 1 1.6.111 5.906 5.906 0 0 1 3.325 1.715c.132.167.267.33.4.5.35.468.7.935 1.045 1.4l1.259 1.837.214.317c.15.234.3.473.452.709q.51.79 1.022 1.578c.072.116.141.234.214.349l1.068 1.681c.217.357.433.714.653 1.069a226.09 226.09 0 0 1 2.939 4.856 2.544 2.544 0 0 0 3 1.161 2.87 2.87 0 0 0 1.453-1.145q1.74-2.4 3.469-4.8c.3-.409.588-.821.882-1.231l.587-.8c.319-.44.634-.882.95-1.325.8-1.076 1.577-2.168 2.356-3.257l1.78-2.454c.133-.179.268-.358.4-.539.275-.384.571-.751.829-1.148.023-.033.048-.065.068-.1a10.8 10.8 0 0 1 1.1-1.55 2.319 2.319 0 0 0 .404-2.134z"
      transform="translate(-76.43 -205.646)"
    />
    <path
      id="Path_2503"
      data-name="Path 2503"
      className="cls-1"
      d="M185.115 317.9c.018.178.156.183.281.184h1.4a3.484 3.484 0 0 0 1.715-.408 3.19 3.19 0 0 0 1.408-1.6 3.132 3.132 0 0 0 .186-1.918c-.027-.114-.047-.234-.082-.341a3.15 3.15 0 0 0-3.047-2.242c-.526-.007-1.051.023-1.578-.014-.219-.016-.312.093-.312.335v2.835q0 1.448.009 2.9a.626.626 0 0 0 .02.269z"
      transform="translate(-176.62 -303.306)"
    />
  </svg>
);

export const questionCircle = (): JSX.Element => (
  <svg width="27.13" height="27.13">
    <path
      data-name="Icon awesome-question-circle"
      d="M27.693 14.127A13.565 13.565 0 1 1 14.127.563a13.564 13.564 0 0 1 13.566 13.564zm-13.2-9.08a7.085 7.085 0 0 0-6.376 3.488.657.657 0 0 0 .149.889l1.9 1.439a.656.656 0 0 0 .912-.116c.977-1.239 1.647-1.958 3.134-1.958 1.117 0 2.5.719 2.5 1.8 0 .819-.676 1.24-1.78 1.858-1.287.721-2.989 1.619-2.989 3.865v.219a.656.656 0 0 0 .656.656h3.063a.656.656 0 0 0 .656-.656v-.073c0-1.557 4.55-1.622 4.55-5.834-.003-3.17-3.293-5.576-6.376-5.576zm-.364 13.565a2.516 2.516 0 1 0 2.516 2.516 2.519 2.519 0 0 0-2.518-2.515z"
      transform="translate(-.563 -.563)"
      style={{ fill: "#d5e1ec" }}
    />
  </svg>
);

export const notificationBell = (): JSX.Element => (
  <svg width="22.493" height="28.132">
    <defs>
      <style>{`.notification-icon-cls{fill:#d5e1ec}`}</style>
    </defs>
    <g
      id="Icon_ionic-ios-notifications"
      data-name="Icon ionic-ios-notifications"
      transform="translate(-6.761 -3.93)"
    >
      <path
        id="Path_2504"
        data-name="Path 2504"
        className="notification-icon-cls"
        d="M17.993 32.063c2.187 0 3.382-1.547 3.382-3.727H14.6c0 2.18 1.2 3.727 3.393 3.727z"
      />
      <path
        id="Path_2505"
        data-name="Path 2505"
        className="notification-icon-cls"
        d="M28.969 24.764c-1.083-1.427-3.213-2.264-3.213-8.655 0-6.56-2.9-9.2-5.6-9.83-.253-.063-.436-.148-.436-.415v-.2a1.716 1.716 0 1 0-3.431 0v.2c0 .26-.183.352-.436.415-2.707.64-5.6 3.27-5.6 9.83 0 6.391-2.13 7.221-3.213 8.655A1.4 1.4 0 0 0 8.163 27h19.695a1.4 1.4 0 0 0 1.111-2.236z"
      />
    </g>
  </svg>
);

export const userCircleIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "27.125"} height={height || "27.125"}>
    <path
      data-name="Icon awesome-user-circle"
      d="M13.563.563a13.563 13.563 0 1 0 13.562 13.562A13.56 13.56 0 0 0 13.563.563zm0 5.25a4.813 4.813 0 1 1-4.813 4.812 4.813 4.813 0 0 1 4.813-4.812zm0 18.813A10.48 10.48 0 0 1 5.551 20.9a6.1 6.1 0 0 1 5.387-3.27 1.338 1.338 0 0 1 .388.06 7.241 7.241 0 0 0 2.237.377 7.213 7.213 0 0 0 2.237-.377 1.338 1.338 0 0 1 .388-.06 6.1 6.1 0 0 1 5.387 3.27 10.48 10.48 0 0 1-8.012 3.725z"
      transform="translate(0 -.563)"
      style={{ fill: "#fff", opacity: ".8" }}
    />
  </svg>
);

export const chevronDown = (): JSX.Element => (
  <svg width="10.016" height="5.758">
    <defs>
      <style>{`.cls-chevron-down{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;strokeWidth:1.5px}`}</style>
    </defs>
    <path
      data-name="Icon feather-chevronRight"
      d="m13.5 16.894 3.947-3.947L13.5 9"
      transform="rotate(90 15.197 2.758)"
      className="cls-chevron-down"
    />
  </svg>
);

export const termsIcon = (): JSX.Element => (
  <svg width="20.521" height="16.673">
    <defs>
      <style>{`.terms-cls1{fill: #fff}`}</style>
    </defs>
    <path
      data-name="Icon awesome-list"
      d="M3.206 16.2H.641a.641.641 0 0 0-.641.642v2.565a.641.641 0 0 0 .641.641h2.565a.641.641 0 0 0 .641-.641v-2.565a.641.641 0 0 0-.641-.642zm0-12.825H.641A.641.641 0 0 0 0 4.016v2.565a.641.641 0 0 0 .641.641h2.565a.641.641 0 0 0 .641-.641V4.016a.641.641 0 0 0-.641-.641zm0 6.413H.641a.641.641 0 0 0-.641.641v2.565a.641.641 0 0 0 .641.641h2.565a.641.641 0 0 0 .641-.641v-2.565a.641.641 0 0 0-.641-.641zm16.673 7.054H7.054a.641.641 0 0 0-.641.641v1.283a.641.641 0 0 0 .641.641h12.825a.641.641 0 0 0 .641-.641v-1.283a.641.641 0 0 0-.641-.641zm0-12.825H7.054a.641.641 0 0 0-.641.641V5.94a.641.641 0 0 0 .641.641h12.825a.641.641 0 0 0 .641-.641V4.658a.641.641 0 0 0-.641-.642zm0 6.413H7.054a.641.641 0 0 0-.641.641v1.283a.641.641 0 0 0 .641.641h12.825a.641.641 0 0 0 .641-.641V11.07a.641.641 0 0 0-.641-.641z"
      transform="translate(0 -3.375)"
      className="terms-cls1"
    />
  </svg>
);

export const glossaryIcon = (): JSX.Element => (
  <svg width="19.318" height="18.275">
    <defs>
      <style>{`.glossary-cls-1{fill:#b1bac1}`}</style>
    </defs>
    <g
      id="Group_1550"
      data-name="Group 1550"
      transform="translate(-1014.5 -178.208)"
    >
      <path
        id="Icon_awesome-download"
        data-name="Icon awesome-download"
        className="glossary-cls-1"
        d="M19.318 12.48v4.226a.9.9 0 0 1-.906.906H.906A.9.9 0 0 1 0 16.706V12.48a.9.9 0 0 1 .906-.906h5.535l1.849 1.849a1.933 1.933 0 0 0 2.739 0l1.849-1.849h5.535a.9.9 0 0 1 .905.906z"
        transform="translate(1014.5 178.872)"
      />
      <path
        id="Icon_awesome-download-2"
        data-name="Icon awesome-download"
        className="glossary-cls-1"
        d="M8.2 9.238h3.018a.9.9 0 0 0 .906-.906V4.241h3.309a.753.753 0 0 0 .532-1.287L9.777-2.788c-.283-.283-.3-.283-.581 0L3.45 2.955a.753.753 0 0 0 .532 1.287H7.3v4.091a.9.9 0 0 0 .9.905z"
        transform="translate(1014.451 181.208)"
      />
    </g>
  </svg>
);

export const categoriesIcon = (): JSX.Element => (
  <svg width="18.279" height="18.276">
    <defs>
      <style>{`.categories-cls-1{fill:#b1bac1}`}</style>
    </defs>
    <g
      id="Icon_ionic-ios-apps"
      data-name="Icon ionic-ios-apps"
      transform="translate(-4.493 -4.496)"
    >
      <path
        id="Path_2567"
        data-name="Path 2567"
        className="categories-cls-1"
        d="m22.146 8-7.11-3.241a3.85 3.85 0 0 0-2.8 0L5.128 8c-.838.381-.838 1 0 1.385l7.043 3.215a4.046 4.046 0 0 0 2.932 0l7.043-3.212c.838-.382.838-1.006 0-1.388z"
        transform="translate(-.002)"
      />
      <g
        id="Group_1551"
        data-name="Group 1551"
        transform="translate(4.493 12.198)"
      >
        <path
          id="Path_2568"
          data-name="Path 2568"
          className="categories-cls-1"
          d="M12.171 25.315 7.422 23.15a.772.772 0 0 0-.633 0l-1.661.757c-.838.381-.838 1 0 1.385l7.043 3.208a4.046 4.046 0 0 0 2.932 0l7.043-3.212c.838-.381.838-1 0-1.385l-1.661-.757a.772.772 0 0 0-.633 0L15.1 25.315a4.046 4.046 0 0 1-2.929 0z"
          transform="translate(-4.495 -18.204)"
        />
        <path
          id="Path_2569"
          data-name="Path 2569"
          className="categories-cls-1"
          d="m22.144 16.628-1.509-.685a.761.761 0 0 0-.628 0l-5.14 2.327a4.2 4.2 0 0 1-2.47 0l-5.14-2.327a.761.761 0 0 0-.628 0l-1.509.685c-.838.381-.838 1 0 1.385l7.043 3.212a4.046 4.046 0 0 0 2.932 0l7.043-3.212c.844-.381.844-1.004.006-1.385z"
          transform="translate(-4.493 -15.875)"
        />
      </g>
    </g>
  </svg>
);

export const iconChevronDownLarge = (
  <svg width="16.195" height="8.191">
    <defs>
      <style>{`.icon-chevron-down-cls{fill:none;stroke:#428bca;stroke-linecap:round;stroke-linejoin:round;strokeWidth:2px}`}</style>
    </defs>
    <path
      data-name="Icon feather-chevron-down"
      d="m9 13.5 6.687 5.78 6.687-5.78"
      transform="translate(-7.59 -12.09)"
      className="icon-chevron-down-cls"
    />
  </svg>
);

export const iconRefresh = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "17.99"}
    height={height || "17.992"}
    viewBox="0 0 17.99 17.992"
  >
    <g data-name="Group 2224">
      <path
        data-name="Path 2671"
        d="M-1409.666 68.67c.176-.189.343-.375.518-.553.311-.315.626-.625.94-.936a.742.742 0 0 1 .85-.2.766.766 0 0 1 .465.744v5.063a1.316 1.316 0 0 1-.046.371.748.748 0 0 1-.726.51h-5.194a.735.735 0 0 1-.714-.458.683.683 0 0 1 .153-.813q.741-.754 1.49-1.5a.807.807 0 0 1 .137-.09l-.009-.069c-.306-.224-.6-.466-.92-.67a5.678 5.678 0 0 0-3.74-.862 5.766 5.766 0 0 0-4.475 2.754 10.36 10.36 0 0 0-.641 1.36c-.135.3-.191.348-.516.348h-2.13a.4.4 0 0 1-.42-.553 9.141 9.141 0 0 1 2.553-4.476 8.467 8.467 0 0 1 3.895-2.186 9.04 9.04 0 0 1 5.986.521 8.786 8.786 0 0 1 2.361 1.543l.183.152z"
        transform="translate(1424.881 -66.169)"
        style={{ fill: "#428bca" }}
      />
      <path
        data-name="Path 2672"
        d="M-1426.321 388.959a5.7 5.7 0 0 0 2.429 1.374 5.866 5.866 0 0 0 6.153-1.82 6.294 6.294 0 0 0 1.131-1.979l.089-.211a.378.378 0 0 1 .384-.25h2.164a.375.375 0 0 1 .391.514 9.1 9.1 0 0 1-2.476 4.447 8.5 8.5 0 0 1-4.556 2.383 9.017 9.017 0 0 1-3.755-.1 8.9 8.9 0 0 1-3.97-2.126l-.134-.118c-.24.246-.474.489-.711.729q-.392.4-.789.787a.693.693 0 0 1-.813.161.712.712 0 0 1-.455-.7v-2.294c0-.945.02-1.891 0-2.835a.816.816 0 0 1 .863-.864c1.644.017 3.289.006 4.933 0a.922.922 0 0 1 .7.2.724.724 0 0 1 .02 1.077q-.75.756-1.505 1.508a1.136 1.136 0 0 1-.093.117z"
        transform="translate(1431.247 -375.58)"
        style={{ fill: "#428bca" }}
      />
    </g>
  </svg>
);

export const iconForward = (): JSX.Element => (
  <svg width="48" height="48" viewBox="0 0 48 48">
    <g data-name="Group 1167">
      <g data-name="Group 1163">
        <g data-name="Group 742">
          <g
            data-name="Ellipse 263"
            style={{ stroke: "#428bca", fill: "#fff" }}
          >
            <circle cx="24" cy="24" r="24" style={{ stroke: "none" }} />
            <circle cx="24" cy="24" r="23.5" style={{ fill: "none" }} />
          </g>
        </g>
      </g>
      <path
        data-name="Path 2511"
        d="m20.787 33.633-6-6a.75.75 0 0 0-1.278.528v3H10.88q-8.36 0-10.259 4.725A10.676 10.676 0 0 0 0 39.789a14.079 14.079 0 0 0 1.489 5.288l.123.281q.088.199.158.352a1.332 1.332 0 0 0 .153.258.4.4 0 0 0 .328.2.342.342 0 0 0 .276-.117.437.437 0 0 0 .1-.293 2.387 2.387 0 0 0-.029-.311 2.425 2.425 0 0 1-.029-.275q-.059-.8-.059-1.442a9.979 9.979 0 0 1 .205-2.122 6.372 6.372 0 0 1 .569-1.624 4.079 4.079 0 0 1 .937-1.184 5.5 5.5 0 0 1 1.237-.815 6.706 6.706 0 0 1 1.559-.5 14.866 14.866 0 0 1 1.806-.252q.909-.07 2.058-.07h2.626v3a.746.746 0 0 0 1.278.528l6-6a.737.737 0 0 0 0-1.055z"
        transform="translate(13 -12.408)"
        style={{ strokeWidth: "2px", fill: "none", stroke: "#428bca" }}
      />
    </g>
  </svg>
);

export const iconShare = (): JSX.Element => (
  <svg width="48" height="48">
    <defs>
      <style>
        {`.icon-share-cls-2{stroke:#428bca;fill:none;stroke-linecap:round;stroke-linejoin:round;strokeWidth:2px}`}
      </style>
    </defs>
    <g id="Group_1165" data-name="Group 1165" transform="translate(-1847 -69)">
      <g
        id="Group_1163"
        data-name="Group 1163"
        transform="translate(427.851 -281.148)"
      >
        <g
          id="Group_742"
          data-name="Group 742"
          transform="translate(1419.147 350.147)"
        >
          <g
            id="Ellipse_263"
            data-name="Ellipse 263"
            transform="translate(.002 .001)"
            style={{ stroke: "#428bca", fill: "#fff" }}
          >
            <circle cx="24" cy="24" r="24" style={{ stroke: "none" }} />
            <circle cx="24" cy="24" r="23.5" style={{ fill: "none" }} />
          </g>
        </g>
      </g>
      <g
        id="Icon_feather-share-2"
        data-name="Icon feather-share-2"
        transform="translate(1856.5 80)"
      >
        <path
          id="Path_2506"
          data-name="Path 2506"
          className="icon-share-cls-2"
          d="M28.677 6.088A3.088 3.088 0 1 1 25.588 3a3.088 3.088 0 0 1 3.089 3.088z"
          transform="translate(-5.647)"
        />
        <path
          id="Path_2507"
          data-name="Path 2507"
          className="icon-share-cls-2"
          d="M10.677 16.588A3.088 3.088 0 1 1 7.588 13.5a3.088 3.088 0 0 1 3.089 3.088z"
          transform="translate(0 -3.294)"
        />
        <path
          id="Path_2508"
          data-name="Path 2508"
          className="icon-share-cls-2"
          d="M28.677 27.088A3.088 3.088 0 1 1 25.588 24a3.088 3.088 0 0 1 3.089 3.088z"
          transform="translate(-5.647 -6.588)"
        />
        <path
          id="Path_2509"
          data-name="Path 2509"
          className="icon-share-cls-2"
          d="m12.885 20.265 7.031 4.1"
          transform="translate(-2.63 -5.416)"
        />
        <path
          id="Path_2510"
          data-name="Path 2510"
          className="icon-share-cls-2"
          d="m19.906 9.765-7.021 4.1"
          transform="translate(-2.63 -2.122)"
        />
      </g>
    </g>
  </svg>
);

export const iconDownload = (
  width?: string,
  height?: string,
  color?: string
): JSX.Element => (
  <svg
    width={width || "19.194"}
    height={height || "21.948"}
    viewBox="0 0 19.194 21.948"
  >
    <path
      id="Icon_awesome-download"
      data-name="Icon awesome-download"
      d="M7.254-3H9.94a.8.8,0,0,1,.806.806V3.448h2.945a.67.67,0,0,1,.474,1.145L9.057,9.7a.651.651,0,0,1-.917,0L3.026,4.593A.67.67,0,0,1,3.5,3.448H6.448V-2.194A.8.8,0,0,1,7.254-3Zm9.94,15.381v3.761a.8.8,0,0,1-.806.806H.806A.8.8,0,0,1,0,16.142V12.381a.8.8,0,0,1,.806-.806H5.732L7.378,13.22a1.721,1.721,0,0,0,2.438,0l1.645-1.645h4.926A.8.8,0,0,1,17.194,12.381Z"
      transform="translate(1 4)"
      fill="none"
      stroke={color || "#428bca"}
      strokeWidth="2"
    />
  </svg>
);

export const searchIconWithVerticalBar = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "35.867"} height={height || "24.622"}>
    <defs>
      <style>{`.cls-11230wsw065wwe{fill:#488bc3}`}</style>
    </defs>
    <g id="Group_1012" data-name="Group 1012" transform="translate(0 -53.696)">
      <path
        id="Path_2349"
        data-name="Path 2349"
        className="cls-11230wsw065wwe"
        d="m148.345 87.376-5.481-4.482a10.091 10.091 0 0 0-8.264-15.881c-.2 0-.395.006-.591.018v2.925c.2-.016.392-.026.591-.026a7.175 7.175 0 1 1-5.073 12.248 7.209 7.209 0 0 1-1.137-1.478 2.586 2.586 0 0 1-3.451-.813l-.031.044a10.095 10.095 0 0 0 15.481 5.436l5.482 4.482a1.75 1.75 0 1 0 2.474-2.475z"
        transform="translate(-112.991 -12.046)"
      />
      <path
        id="Path_2350"
        data-name="Path 2350"
        className="cls-11230wsw065wwe"
        d="M91.684 135.172a1.152 1.152 0 0 0-1.152 1.152v3.791a1.152 1.152 0 1 0 2.3 0v-3.791a1.151 1.151 0 0 0-1.148-1.152z"
        transform="translate(-81.895 -73.703)"
      />
      <path
        id="Path_2351"
        data-name="Path 2351"
        className="cls-11230wsw065wwe"
        d="M1.152 135.172A1.152 1.152 0 0 0 0 136.324v3.791a1.152 1.152 0 1 0 2.3 0v-3.791a1.151 1.151 0 0 0-1.148-1.152z"
        transform="translate(0 -73.703)"
      />
      <path
        id="Path_2352"
        data-name="Path 2352"
        className="cls-11230wsw065wwe"
        d="M46.416 85.381a1.152 1.152 0 0 0-1.152 1.152v8.541a1.152 1.152 0 1 0 2.3 0v-8.541a1.151 1.151 0 0 0-1.148-1.152z"
        transform="translate(-40.946 -28.662)"
      />
      <path
        id="Path_2353"
        data-name="Path 2353"
        className="cls-11230wsw065wwe"
        d="M182.213 67.563a1.152 1.152 0 0 0 1.152-1.152V54.848a1.152 1.152 0 0 0-2.3 0v11.564a1.152 1.152 0 0 0 1.148 1.151z"
        transform="translate(-163.787)"
      />
      <path
        id="Path_2354"
        data-name="Path 2354"
        className="cls-11230wsw065wwe"
        d="M136.947 96.226a1.152 1.152 0 0 0 1.152-1.152v-8.541a1.152 1.152 0 1 0-2.3 0v8.541a1.152 1.152 0 0 0 1.148 1.152z"
        transform="translate(-122.84 -28.662)"
      />
    </g>
  </svg>
);

export const searchIconWithLineage = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "35.664"}
    height={height || "26.147"}
    style={{ overflow: "unset" }}
  >
    <defs>
      <style>{`.cls-3sd2326sd{fill:#488bc3}`}</style>
    </defs>
    <g
      id="Group_1015"
      data-name="Group 1015"
      transform="translate(-265.001 -440.922)"
    >
      <path
        id="search"
        d="m23.033 21.123-5.519-5.741a9.36 9.36 0 1 0-7.167 3.344 9.263 9.263 0 0 0 5.364-1.694l5.561 5.784a1.221 1.221 0 1 0 1.76-1.693zM10.347 2.443a6.921 6.921 0 1 1-6.92 6.92 6.928 6.928 0 0 1 6.92-6.92z"
        transform="rotate(-5.13 5231.934 -2917.072)"
        style={{ stroke: "#488bc3", fill: "#488bc3" }}
      />
      <circle
        id="Ellipse_265"
        data-name="Ellipse 265"
        cx="7"
        cy="7"
        r="7"
        transform="translate(273 444)"
        style={{ fill: "#fff" }}
      />
      <g
        id="Group_1014"
        data-name="Group 1014"
        transform="rotate(180 141.053 230.053)"
      >
        <path
          id="Union_9"
          data-name="Union 9"
          className="cls-3sd2326sd"
          d="M12 18a1 1 0 0 1-1-1v-1.842H8V2.842h3V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4.631a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V3.789H9V14.21h2v-1.841a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V17a1 1 0 0 1-1 1zM1 12.316a1 1 0 0 1-1-1V6.684a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4.631a1 1 0 0 1-1 1z"
          transform="translate(.104 .105)"
        />
        <path
          id="Rectangle_1043"
          data-name="Rectangle 1043"
          className="cls-3sd2326sd"
          transform="translate(5.181 8.601)"
          d="M0 0h3.699v1.007H0z"
        />
      </g>
    </g>
  </svg>
);

export const backIcon = (): JSX.Element => (
  <svg width="18.755" height="20.86">
    <path
      data-name="Path 1279"
      d="M-758.258 366.919a1.367 1.367 0 0 1 1.308.53 2.444 2.444 0 0 0 .209.2l.529.529q.476.515.991.991a5.22 5.22 0 0 0 .53.529q.5.537 1.035 1.035a4.239 4.239 0 0 0 .485.485q.5.538 1.035 1.035a4.247 4.247 0 0 0 .485.485q.5.538 1.035 1.035l.529.53q.477.514.991.991a5.137 5.137 0 0 0 .529.529l.322.338a2.291 2.291 0 0 1 .636.818l.05.362-.057.4a2.58 2.58 0 0 1-.5.633 3.459 3.459 0 0 0-.454.477l-.526.528-.992.993-.528.528-1.036 1.036-.484.484-1.037 1.036-.484.483-1.037 1.037-.527.527-.993.993-.527.526a2.908 2.908 0 0 0-.263.239 1.312 1.312 0 0 1-1.248.488 1.688 1.688 0 0 1-.654-.434 8.665 8.665 0 0 0-.859-.822l-.008.01.009-.009a.3.3 0 0 0-.04-.076 1.178 1.178 0 0 1-.238-1.434l.272-.344c.435-.371.839-.776 1.245-1.177a1.258 1.258 0 0 0 .272-.261c.46-.4.9-.829 1.331-1.26a.837.837 0 0 0 .232-.222 27.62 27.62 0 0 0 1.4-1.336l.074-.065 1.132-1.055h-10.7c-.148 0-.3-.01-.444-.01a1.118 1.118 0 0 1-1.077-1.05c-.006-.289-.009-.578-.013-.866l.011-.8a1.1 1.1 0 0 1 .948-1.088c.192-.033.385-.013.576-.035h10.7l-1.136-1.062-.071-.061a29.004 29.004 0 0 0-1.448-1.379.55.55 0 0 0-.183-.177 24.082 24.082 0 0 0-1.332-1.264 1.264 1.264 0 0 0-.271-.259c-.4-.42-.83-.808-1.257-1.2l-.262-.322a1.2 1.2 0 0 1 .32-1.526c.247-.226.48-.466.71-.71a1.975 1.975 0 0 1 .755-.536z"
      transform="rotate(180 -373.78 193.881)"
      style={{ fill: "#428bca" }}
    />
  </svg>
);

export const plusIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "48"} height={height || "48"} viewBox="0 0 48 48">
    <defs>
      <style>{`.plus-icon-in-circle-cls-2{fill:#428bca}`}</style>
    </defs>
    <g id="Group_1169" data-name="Group 1169" transform="translate(-1847 -69)">
      <g
        id="Group_1163"
        data-name="Group 1163"
        transform="translate(427.851 -281.148)"
      >
        <g
          id="Group_742"
          data-name="Group 742"
          transform="translate(1419.147 350.147)"
        >
          <g
            id="Ellipse_263"
            data-name="Ellipse 263"
            transform="translate(.002 .001)"
            style={{ stroke: "#428bca", fill: "none" }}
          >
            <circle cx="24" cy="24" r="24" style={{ stroke: "none" }} />
            <circle cx="24" cy="24" r="23.5" style={{ fill: "none" }} />
          </g>
        </g>
      </g>
      <g id="Group_1170" data-name="Group 1170" transform="translate(1)">
        <path
          id="Rectangle_1212"
          data-name="Rectangle 1212"
          className="plus-icon-in-circle-cls-2"
          transform="translate(1860 92)"
          d="M0 0h21v3H0z"
        />
        <path
          id="Rectangle_1213"
          data-name="Rectangle 1213"
          className="plus-icon-in-circle-cls-2"
          transform="rotate(-90 986.5 -882.5)"
          d="M0 0h21v3H0z"
        />
      </g>
    </g>
  </svg>
);

export const crossIconSolid = (
  width?: string,
  height?: string,
  fill?: string
): JSX.Element => (
  <svg
    width={width || "17.641"}
    height={height || "17.67"}
    viewBox="0 0 17.641 17.67"
  >
    <defs>
      <style>{`.solidcrossicon-cls12321{fill: ${fill || "#c2c2c2"}}`}</style>
    </defs>
    <path
      data-name="Path 2544"
      d="m-931.5 542.48-4.082 4.059a1.513 1.513 0 0 1-2.534.011q-.776-.776-1.549-1.554a1.482 1.482 0 0 1-.018-2.451q1.817-1.831 3.641-3.655c.151-.151.294-.31.525-.555-.355-.327-.7-.621-1.015-.938a360.165 360.165 0 0 1-3.264-3.277 1.416 1.416 0 0 1 0-2.2 98.92 98.92 0 0 1 1.8-1.807 1.455 1.455 0 0 1 2.283 0q2.062 2.046 4.111 4.106a.925.925 0 0 0 .117.068c.135-.124.292-.26.439-.406q1.843-1.847 3.684-3.7a1.486 1.486 0 0 1 2.411-.014q.8.794 1.591 1.6a1.493 1.493 0 0 1 .017 2.494l-3.97 4a1.07 1.07 0 0 0-.094.157c.129.14.268.3.416.446q1.839 1.85 3.681 3.7a1.468 1.468 0 0 1 0 2.408c-.57.576-1.14 1.152-1.717 1.721a1.438 1.438 0 0 1-2.237.007c-1.263-1.253-2.514-2.517-3.771-3.776-.14-.144-.284-.275-.465-.444z"
      transform="translate(940.321 -529.561)"
      className="solidcrossicon-cls12321"
    />
  </svg>
);

export const filledSuccessTickInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "28"} height={height || "28"} viewBox="0 0 28 28">
    <g data-name="Group 1403">
      <g data-name="Group 1163">
        <g data-name="Group 742">
          <circle
            data-name="Ellipse 263"
            cx="14"
            cy="14"
            r="14"
            style={{ fill: "#72aa69" }}
          />
        </g>
      </g>
      <path
        data-name="Icon feather-check"
        d="m16.908 9-7.5 7.5L6 13.091"
        transform="translate(2.225 1.042)"
        style={{
          fill: "none",
          stroke: "#fff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "3px",
        }}
      />
    </g>
  </svg>
);

export const deleteIcon1 = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "17.613"}
    height={height || "19.223"}
    viewBox="0 0 17.613 19.223"
  >
    <defs>
      <style>{`.delete-icon1-cls-1{fill:#d15b47}`}</style>
    </defs>
    <g id="Group_1176" data-name="Group 1176">
      <g id="Group_1173" data-name="Group 1173">
        <path
          id="Path_2518"
          data-name="Path 2518"
          className="delete-icon1-cls-1"
          d="M-1179.567-100.144h-1.153a.827.827 0 0 1-.142-.007.373.373 0 0 1-.3-.375v-.821a.377.377 0 0 1 .381-.4h3.774a.137.137 0 0 0 .151-.1c.269-.65.531-1.3.817-1.944a1.807 1.807 0 0 1 1.731-1.153q1.948-.025 3.9 0a1.809 1.809 0 0 1 1.732 1.151c.283.635.542 1.281.808 1.924a.164.164 0 0 0 .18.124h3.645a.969.969 0 0 1 .174.01.361.361 0 0 1 .316.363q.01.421 0 .843a.369.369 0 0 1-.4.384H-1165.153v11.799a2.946 2.946 0 0 1-.445 1.654 1.95 1.95 0 0 1-1.042.874 1.876 1.876 0 0 1-.547.085q-5.171.007-10.342 0a1.825 1.825 0 0 1-1.545-.867 2.67 2.67 0 0 1-.486-1.573v-11.82zm1.6.006v11.932a1.44 1.44 0 0 0 .237.729.305.305 0 0 0 .281.146q5.068-.006 10.136 0a.363.363 0 0 0 .35-.2 1.56 1.56 0 0 0 .2-.806v-11.8zm2.805-1.61h5.59a.274.274 0 0 0-.011-.046c-.187-.458-.374-.917-.564-1.374a.281.281 0 0 0-.278-.176h-3.861a.3.3 0 0 0-.29.193c-.076.177-.149.356-.223.534z"
          transform="translate(1181.168 104.952)"
        />
        <path
          id="Path_2519"
          data-name="Path 2519"
          className="delete-icon1-cls-1"
          d="M-960.242 228.482v3.513c0 .342-.135.478-.477.478h-.689a.393.393 0 0 1-.435-.434v-7.136a.392.392 0 0 1 .441-.438h.722a.388.388 0 0 1 .438.438v3.579z"
          transform="translate(966.644 -217.253)"
        />
        <path
          id="Path_2520"
          data-name="Path 2520"
          className="delete-icon1-cls-1"
          d="M-669.119 228.456v-3.535c0-.321.138-.459.46-.46h.722a.385.385 0 0 1 .417.416v7.169a.389.389 0 0 1-.423.423h-.744a.389.389 0 0 1-.432-.434v-3.579z"
          transform="translate(680.329 -217.249)"
        />
        <path
          id="Path_2521"
          data-name="Path 2521"
          className="delete-icon1-cls-1"
          d="M-815.457 228.481v-3.524c0-.351.132-.482.483-.482h.679a.393.393 0 0 1 .441.438V232.005a.683.683 0 0 1-.046.265.362.362 0 0 1-.355.212h-.8a.389.389 0 0 1-.4-.444v-2.714z"
          transform="translate(823.463 -217.262)"
        />
      </g>
    </g>
  </svg>
);

export const selectAllIcon = (): JSX.Element => (
  <svg width="17.53" height="17.253">
    <path
      data-name="Path 2568"
      d="M4.224 2.91h8.164V1.033A.1.1 0 0 0 12.383 1a.086.086 0 0 0-.017-.026.067.067 0 0 0-.026-.017.079.079 0 0 0-.031-.005H1.033A.1.1 0 0 0 1 .959a.081.081 0 0 0-.025.018A.106.106 0 0 0 .958 1a.072.072 0 0 0-.005.03v11.277a.068.068 0 0 0 .007.03.1.1 0 0 0 .016.024.084.084 0 0 0 .024.022.087.087 0 0 0 .027.005h2.164V3.943a1.031 1.031 0 0 1 .3-.731l.009-.005a1.031 1.031 0 0 1 .725-.3zm2.77 7.308a.627.627 0 1 1 .841-.93L9.058 10.4l2.8-2.944a.628.628 0 0 1 .911.865L9.4 11.865l-.034-.026a.64.64 0 0 1-.249.062.622.622 0 0 1-.443-.161l-1.679-1.522zm6.345-7.308H15.5a1.016 1.016 0 0 1 .394.079 1.039 1.039 0 0 1 .336.225l.005.005a1.025 1.025 0 0 1 .3.725v11.275a1.034 1.034 0 0 1-.639.955 1.021 1.021 0 0 1-.394.079H4.224a1.034 1.034 0 0 1-.955-.639 1.02 1.02 0 0 1-.078-.394v-1.879H1.033a1.016 1.016 0 0 1-.394-.079A1.033 1.033 0 0 1 0 12.307V1.033A1.034 1.034 0 0 1 .639.078 1.045 1.045 0 0 1 1.033 0h11.273a1.036 1.036 0 0 1 1.035 1.033V2.91zm2.159.951H4.224a.1.1 0 0 0-.03.005.065.065 0 0 0-.027.019.067.067 0 0 0-.017.026.072.072 0 0 0-.005.03v11.275a.1.1 0 0 0 .005.03.089.089 0 0 0 .019.027.065.065 0 0 0 .024.015.072.072 0 0 0 .03.005H15.5a.1.1 0 0 0 .03-.005.062.062 0 0 0 .024-.017.108.108 0 0 0 .017-.026.089.089 0 0 0 0-.028V3.941a.1.1 0 0 0-.005-.03.078.078 0 0 0-.071-.047z"
      transform="translate(.5 .5)"
      style={{ fill: "#4894ca", stroke: "#4894ca" }}
    />
  </svg>
);

export const dummyIcon = (): JSX.Element => (
  <svg id="Group_1179" data-name="Group 1179" width="15.277" height="17.729">
    <defs>
      <style>{`.cls-1dsd035ssder45{fill:#4894ca}`}</style>
    </defs>
    <path
      id="Rectangle_1216"
      data-name="Rectangle 1216"
      className="cls-1dsd035ssder45"
      d="M0 0h15.277v2.599H0z"
    />
    <path
      id="Rectangle_1217"
      data-name="Rectangle 1217"
      className="cls-1dsd035ssder45"
      transform="translate(0 15.13)"
      d="M0 0h15.277v2.599H0z"
    />
    <path
      id="Rectangle_1218"
      data-name="Rectangle 1218"
      className="cls-1dsd035ssder45"
      transform="translate(5.145 5.043)"
      d="M0 0h10.132v2.599H0z"
    />
    <circle
      id="Ellipse_264"
      data-name="Ellipse 264"
      className="cls-1dsd035ssder45"
      cx="1.671"
      cy="1.671"
      transform="translate(0 4.671)"
      r="1.671"
    />
    <path
      id="Rectangle_1219"
      data-name="Rectangle 1219"
      className="cls-1dsd035ssder45"
      transform="translate(5.145 10.087)"
      d="M0 0h10.132v2.599H0z"
    />
    <circle
      id="Ellipse_265"
      data-name="Ellipse 265"
      className="cls-1dsd035ssder45"
      cx="1.671"
      cy="1.671"
      transform="translate(0 9.693)"
      r="1.671"
    />
  </svg>
);

export const studyIcon = (): JSX.Element => (
  <svg width="18.458" height="10.068" viewBox="0 0 18 10">
    <defs>
      <style>{`.studyicon-cls-1{fill:#929292}`}</style>
    </defs>
    <g id="study" transform="translate(-6.5 -11)">
      <path
        id="Path_2549"
        data-name="Path 2549"
        className="studyicon-cls-1"
        d="M7.339 21.068a.839.839 0 0 1-.839-.839v-8.39a.839.839 0 1 1 1.678 0v8.39a.839.839 0 0 1-.839.839z"
      />
      <path
        id="Path_2550"
        data-name="Path 2550"
        className="studyicon-cls-1"
        d="M14.373 21.068H9.339a.839.839 0 0 1-.839-.839v-2.517a2.52 2.52 0 0 1 2.517-2.517h1.678a.841.841 0 0 0 .839-.839v-.839a.841.841 0 0 0-.839-.839H9.339a.839.839 0 0 1 0-1.678h3.356a2.52 2.52 0 0 1 2.517 2.517v.839a2.52 2.52 0 0 1-2.517 2.517h-1.678a.841.841 0 0 0-.839.839v1.678h4.195a.839.839 0 0 1 0 1.678z"
        transform="translate(1.356)"
      />
      <path
        id="Path_2551"
        data-name="Path 2551"
        className="studyicon-cls-1"
        d="M17.695 19.373h-3.356a.839.839 0 0 1 0-1.678h3.356a.841.841 0 0 0 .839-.839v-.839a.841.841 0 0 0-.839-.839h-3.356a.839.839 0 0 1 0-1.678h3.356a2.52 2.52 0 0 1 2.517 2.517v.839a2.52 2.52 0 0 1-2.517 2.517z"
        transform="translate(4.746 1.695)"
      />
      <path
        id="Path_2552"
        data-name="Path 2552"
        className="studyicon-cls-1"
        d="M17.695 16.873h-3.356a.839.839 0 0 1 0-1.678h3.356a.841.841 0 0 0 .839-.839v-.839a.841.841 0 0 0-.839-.839h-3.356a.839.839 0 0 1 0-1.678h3.356a2.52 2.52 0 0 1 2.517 2.517v.839a2.52 2.52 0 0 1-2.517 2.517z"
        transform="translate(4.746)"
      />
    </g>
  </svg>
);

export const searchIcon1 = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "19.2"}
    height={height || "19.887"}
    viewBox="0 0 19.2 19.887"
  >
    <path
      d="m19.892 18.114-4.733-4.923a8.026 8.026 0 1 0-6.146 2.868 7.943 7.943 0 0 0 4.6-1.453l4.769 4.96a1.047 1.047 0 1 0 1.51-1.452zM9.013 2.095a5.935 5.935 0 1 1-5.934 5.934 5.941 5.941 0 0 1 5.934-5.934z"
      transform="translate(-.984)"
      style={{ fill: "#428bca" }}
    />
  </svg>
);

export const filterIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "16.631"}
    height={height || "17.014"}
    viewBox="0 0 16.631 17.014"
  >
    <path
      d="M16.006 0H1.194a.7.7 0 0 0-.62.378.706.706 0 0 0 .055.734l5.426 7.644.006.008a1.551 1.551 0 0 1 .3.92v6.232a.693.693 0 0 0 .693.7.714.714 0 0 0 .273-.055l3.054-1.161a.66.66 0 0 0 .455-.652V9.684a1.551 1.551 0 0 1 .3-.92l.006-.008 5.426-7.645a.7.7 0 0 0 .055-.734.7.7 0 0 0-.617-.377zM10.46 8.265a2.4 2.4 0 0 0-.468 1.42v4.958L7.208 15.7V9.684a2.4 2.4 0 0 0-.468-1.42L1.472.843h14.256zm0 0"
      transform="translate(-.285 .2)"
      style={{ fill: "#428bca", stroke: "#428bca", strokeWidth: ".4px" }}
    />
  </svg>
);

export const clock1 = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "22"} height={height || "22"} viewBox="0 0 22 22">
    <defs>
      <style>
        {`.clock1-cls-1{fill:none;stroke:#3b3b3b;stroke-linecap:round;stroke-linejoin:round;strokeWidth:2px}`}
      </style>
    </defs>
    <g id="clock_new" data-name="clock new" transform="translate(-1 -1)">
      <circle
        id="Ellipse_1"
        data-name="Ellipse 1"
        className="clock1-cls-1"
        cx="10"
        cy="10"
        r="10"
        transform="translate(2 2)"
      />
      <path
        id="Path_2343"
        data-name="Path 2343"
        className="clock1-cls-1"
        d="M12 6v6l3 3"
      />
    </g>
  </svg>
);

export const searchIconInBox = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "28.809"}
    height={height || "23.068"}
    viewBox="0 0 28.809 23.068"
  >
    <g data-name="Group 1026">
      <path
        data-name="Path 2344"
        d="M839.468 176.065c-3.775 0-7.55-.005-11.325 0a2.9 2.9 0 0 1-2.472-1.138 2.58 2.58 0 0 1-.569-1.573q-.008-2.015-.007-4.03c0-4.451.006-8.9 0-13.353a2.861 2.861 0 0 1 1.088-2.361 2.634 2.634 0 0 1 1.695-.61c2.353 0 4.706-.007 7.058.006a.769.769 0 0 1 .47.228q1.2 1.177 2.373 2.383a.831.831 0 0 0 .652.262c4.135-.006 8.27 0 12.4-.008a2.941 2.941 0 0 1 2.492 1.157 2.731 2.731 0 0 1 .558 1.418c.022.226.013.456.013.684q0 6.94.006 13.88a3.015 3.015 0 0 1-.567 1.894 2.906 2.906 0 0 1-2.488 1.16q-5.688-.008-11.377.001z"
        transform="translate(-825.092 -153.001)"
        style={{ fill: "#b3b6b9", fillRule: "evenodd" }}
      />
      <path
        d="M12.457 10.991 9.585 8a4.87 4.87 0 1 0-3.729 1.74 4.82 4.82 0 0 0 2.791-.882l2.894 3.01a.635.635 0 1 0 .916-.881zm-6.6-9.72a3.6 3.6 0 1 1-3.6 3.6 3.605 3.605 0 0 1 3.599-3.6z"
        transform="translate(8.016 7.481)"
        style={{ fill: "#fff" }}
      />
    </g>
  </svg>
);

export const recommendIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "12.597"}
    height={height || "18.901"}
    viewBox="0 0 12.597 18.901"
  >
    <path
      data-name="Path 2660"
      d="M105.795 31.341v.63a1.577 1.577 0 0 1-1.575 1.575h-.346a1.575 1.575 0 0 1-3.086 0h-.347a1.577 1.577 0 0 1-1.575-1.575v-.63a.946.946 0 0 1 .945-.945h5.039a.946.946 0 0 1 .945.945zm.895-13.69a6.3 6.3 0 1 0-8.709 9.113q.09.086.184.169a2.094 2.094 0 0 1 .7 1.573.946.946 0 0 0 .945.945h5.039a.946.946 0 0 0 .945-.945 2.1 2.1 0 0 1 .7-1.576 6.311 6.311 0 0 0 .548-8.908q-.171-.193-.357-.372z"
      transform="translate(-96.033 -15.905)"
      style={{ fill: "#3b3b3b" }}
    />
  </svg>
);

export const termIcon = (
  width?: string,
  height?: string,
  fill?: string
): JSX.Element => (
  <svg
    width={width || "18.652"}
    height={height || "17.78"}
    viewBox="0 0 35.042 33.406"
  >
    <defs>
      <style>{`.termicon-cls-1{fill: ${fill || "#3b3b3b"} }`}</style>
    </defs>
    <g
      id="Group_2148"
      data-name="Group 2148"
      transform="translate(-4545 -53.819)"
    >
      <path
        id="Path_2358"
        data-name="Path 2358"
        d="M-919.19,686.191h-30.537a2.253,2.253,0,0,0-2.253,2.253v8.414h35v-2.137a2.266,2.266,0,0,0,.039-.386v-5.891A2.253,2.253,0,0,0-919.19,686.191Zm-25.472,7.047h-3.62v-1.713h3.62Zm14.055,0h-12.476v-1.713h12.476Z"
        transform="translate(5496.979 -632.371)"
        className="termicon-cls-1"
      />
      <path
        id="Path_2359"
        data-name="Path 2359"
        d="M-951.979,717.6v16.943a2.253,2.253,0,0,0,2.253,2.253h30.537a2.253,2.253,0,0,0,2.253-2.253V717.6Zm14.9,15.634h-11.205v-3.591h11.205Zm0-5.343h-11.205V725.75h11.205Zm0-4.582h-11.205v-2.137h11.205Zm15.75,6.705a3.22,3.22,0,0,1-3.22,3.22h-4.765a3.22,3.22,0,0,1-3.22-3.22v-5.622a3.22,3.22,0,0,1,3.22-3.22h4.765a3.22,3.22,0,0,1,3.22,3.22Z"
        transform="translate(5496.979 -649.567)"
        className="termicon-cls-1"
      />
    </g>
  </svg>
);

export const columnIcon = (
  width?: string,
  height?: string,
  fill?: string
): JSX.Element => (
  <svg
    width={width || "15.568"}
    height={height || "13.169"}
    viewBox="0 0 30.609 25.892"
  >
    <defs>
      <style>{`.column-icon-cls123321{fill:${fill || "#3b3b3b"} }`}</style>
    </defs>
    <g
      id="Group_2142"
      data-name="Group 2142"
      transform="translate(-427.896 -849.925)"
    >
      <path
        id="Path_1314"
        data-name="Path 1314"
        d="M-843.772,214.655a3.6,3.6,0,0,0-.09-.828,2.915,2.915,0,0,0-2.93-2.231q-6.13-.006-12.26,0t-12.26,0a2.925,2.925,0,0,0-3.065,3.081q0,4.65,0,19.726a2.942,2.942,0,0,0,3.07,3.083q12.228,0,24.456,0a2.944,2.944,0,0,0,3.082-3.072Q-843.765,220.962-843.772,214.655Zm-21.184,19.778c0,.506-.2.687-.713.688-.944,0-1.887,0-2.831,0s-1.887,0-2.831,0c-.494,0-.682-.19-.683-.679,0-1.115,0-2.938,0-4.053,0-.481.2-.678.69-.679q2.83,0,5.661,0c.5,0,.7.2.705.7C-864.95,231.517-864.95,233.329-864.956,234.434Zm-7.057-11.846c0-.514.185-.709.692-.71q2.831-.006,5.661,0c.506,0,.7.2.705.7,0,1.094,0,2.959,0,4.053,0,.539-.2.725-.748.727-.943,0-1.887,0-2.83,0-.911,0-1.823,0-2.734,0-.573,0-.747-.178-.747-.753C-872.014,225.526-872.015,223.67-872.013,222.588Zm7.057-3.74c0,.48-.212.68-.695.681q-2.831,0-5.661,0c-.505,0-.7-.2-.7-.7,0-1.1,0-3.11,0-4.214,0-.506.187-.688.7-.689.944,0,1.887,0,2.831,0s1.887,0,2.831,0c.494,0,.688.187.691.677C-864.95,215.716-864.95,217.732-864.956,218.847Zm18.824,15.577c0,.511-.185.7-.7.7-.943,0-1.887,0-2.83,0s-1.887,0-2.831,0c-.509,0-.7-.189-.7-.7,0-1.094,0-2.9,0-3.989,0-.523.2-.721.72-.721q2.815,0,5.629,0c.521,0,.71.194.71.725C-846.13,231.528-846.129,233.33-846.131,234.424Zm-7.059-11.8c0-.55.189-.745.729-.746q2.8,0,5.6,0c.551,0,.733.186.734.734,0,1.083,0,2.938,0,4.021,0,.546-.183.728-.738.729-.933,0-1.865,0-2.8,0s-1.844,0-2.766,0c-.57,0-.756-.186-.757-.75C-853.193,225.539-853.193,223.695-853.191,222.622Zm7.059-3.785c0,.486-.2.689-.68.69q-2.847,0-5.693,0c-.477,0-.682-.207-.684-.692-.005-1.115-.006-3.131,0-4.246,0-.472.2-.664.67-.666.954,0,1.909,0,2.863,0s1.887,0,2.831,0c.51,0,.694.187.695.7C-846.129,215.728-846.129,217.734-846.132,218.838Z"
        transform="translate(1302.273 638.332)"
        className="column-icon-cls123321"
      />
    </g>
  </svg>
);

export const unionIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "14"} height={height || "14"} viewBox="0 0 14 14">
    <path
      data-name="Union 1"
      d="M-3919 14V8h-6V6h6V0h2v6h6v2h-6v6z"
      transform="translate(3925)"
      style={{ fill: "#2c2c2c" }}
    />
  </svg>
);

export const listIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "18.83"}
    height={height || "13.957"}
    viewBox="0 0 18.83 13.957"
  >
    <defs>
      <style>{`.listicon-cls-1{fill:#2c2c2c}`}</style>
    </defs>
    <g
      id="Group_1051"
      data-name="Group 1051"
      transform="translate(1253.851 -1147.298)"
    >
      <path
        id="Rectangle_1162"
        data-name="Rectangle 1162"
        className="listicon-cls-1"
        transform="translate(-1249.5 1147.298)"
        d="M0 0h14.479v2.251H0z"
      />
      <path
        id="Rectangle_1163"
        data-name="Rectangle 1163"
        className="listicon-cls-1"
        transform="translate(-1249.5 1153.151)"
        d="M0 0h14.479v2.251H0z"
      />
      <path
        id="Rectangle_1164"
        data-name="Rectangle 1164"
        className="listicon-cls-1"
        transform="translate(-1249.5 1159.004)"
        d="M0 0h14.479v2.251H0z"
      />
      <path
        id="Rectangle_1165"
        data-name="Rectangle 1165"
        className="listicon-cls-1"
        transform="translate(-1253.851 1159.004)"
        d="M0 0h2.251v2.251H0z"
      />
      <path
        id="Rectangle_1166"
        data-name="Rectangle 1166"
        className="listicon-cls-1"
        transform="translate(-1253.851 1153.151)"
        d="M0 0h2.251v2.251H0z"
      />
      <path
        id="Rectangle_1167"
        data-name="Rectangle 1167"
        className="listicon-cls-1"
        transform="translate(-1253.851 1147.298)"
        d="M0 0h2.251v2.251H0z"
      />
    </g>
  </svg>
);

export const warningIconInFilledCircle = (
  width?: string,
  height?: string,
  fill?: string
): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "20"}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.9987 19.1663C15.0613 19.1663 19.1654 15.0623 19.1654 9.99967C19.1654 4.93706 15.0613 0.833008 9.9987 0.833008C4.93609 0.833008 0.832031 4.93706 0.832031 9.99967C0.832031 15.0623 4.93609 19.1663 9.9987 19.1663Z"
      fill={fill || "#428BCA"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.9987 4.5C10.505 4.5 10.9154 4.91041 10.9154 5.41667V11.8333C10.9154 12.3396 10.505 12.75 9.9987 12.75C9.49244 12.75 9.08203 12.3396 9.08203 11.8333V5.41667C9.08203 4.91041 9.49244 4.5 9.9987 4.5ZM9.9987 13.6667C10.505 13.6667 10.9154 14.0771 10.9154 14.5833C10.9154 15.0896 10.505 15.5 9.9987 15.5C9.49244 15.5 9.08203 15.0896 9.08203 14.5833C9.08203 14.0771 9.49244 13.6667 9.9987 13.6667Z"
      fill="white"
    />
  </svg>
);

export const tagIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "48"} height={height || "48"} viewBox="0 0 48 48">
    <g data-name="Group 1050">
      <g data-name="Group 1047">
        <g data-name="Group 743">
          <g
            data-name="Ellipse 263"
            style={{ fill: "#fff", stroke: "#428bca" }}
          >
            <circle cx="24" cy="24" r="24" style={{ stroke: "none" }} />
            <circle cx="24" cy="24" r="23.5" style={{ fill: "none" }} />
          </g>
        </g>
      </g>
      <path
        d="M40.914 0H28a1.973 1.973 0 0 0-1.976 1.89V21a1.464 1.464 0 0 0 .249.849.966.966 0 0 0 .8.415 1.44 1.44 0 0 0 .915-.386l5.779-4.906a1.145 1.145 0 0 1 1.4 0l5.759 4.905a1.39 1.39 0 0 0 .894.387c.507 0 1-.391 1-1.265V1.89A1.91 1.91 0 0 0 40.914 0z"
        transform="translate(-10.421 13.466)"
        style={{ stroke: "#478fca", strokeWidth: "2px", fill: "none" }}
      />
    </g>
  </svg>
);

export const shareIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    data-name="MDI / share-variant"
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
  >
    <path
      data-name="Path / share-variant"
      d="M18 16.08a2.912 2.912 0 0 0-1.96.77L8.91 12.7A3.274 3.274 0 0 0 9 12a3.274 3.274 0 0 0-.09-.7l7.05-4.11A2.993 2.993 0 1 0 15 5a3.274 3.274 0 0 0 .09.7L8.04 9.81a3 3 0 1 0 0 4.38l7.12 4.15a2.84 2.84 0 0 0-.08.66A2.92 2.92 0 1 0 18 16.08z"
      style={{ fill: "#428bca" }}
    />
  </svg>
);

export const plusIcon = (
  width?: string,
  height?: string,
  color?: string
): JSX.Element => (
  <svg width={width || "14"} height={height || "14"} viewBox="0 0 14 14">
    <defs>
      <style>{`.plusicon-cls1545{fill: ${color || "#428bca"}}`}</style>
    </defs>
    <path
      data-name="Union 1"
      d="M-3919 14V8h-6V6h6V0h2v6h6v2h-6v6z"
      transform="translate(3925)"
      className="plusicon-cls1545"
    />
  </svg>
);

export const minusIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "14"} height={height || "2"} viewBox="0 0 14 14">
    <rect
      id="Rectangle_1215"
      data-name="Rectangle 1215"
      width={width || "14"}
      height={height || "2"}
      fill="#2c2c2c"
    />
  </svg>
);

export const searchBlankSlate = (): JSX.Element => (
  <svg width="202" height="202" viewBox="0 0 202 202">
    <defs>
      <clipPath id="a">
        <circle
          data-name="Ellipse 290"
          cx="101"
          cy="101"
          r="101"
          style={{ fill: "#f7f7f7" }}
        />
      </clipPath>
    </defs>
    <g data-name="Group 1320" transform="translate(-1095 -313)">
      <circle
        data-name="Ellipse 289"
        cx="101"
        cy="101"
        r="101"
        transform="translate(1095 313)"
        style={{ fill: "#6face7", opacity: ".35" }}
      />
      <path
        data-name="Path 2638"
        d="M-1838.908 716.148q-20.565 0-41.127.012a9.894 9.894 0 0 1-8.628-4.5 9.691 9.691 0 0 1-1.6-5.725v-44.7c0-7.239.014-14.478 0-21.716a9.857 9.857 0 0 1 5.575-9.28 9.955 9.955 0 0 1 4.852-.994q14.956.01 29.914 0 26.253 0 52.5.01a9.855 9.855 0 0 1 9.467 7.122 9.992 9.992 0 0 1 .384 2.661q.036 31.383.014 62.766a51.356 51.356 0 0 1-.12 5.8 9.7 9.7 0 0 1-9.628 8.532q-20.8.027-41.6.007zm-31.685-31.577v.008h9.542c1.67 0 2.394-.7 2.394-2.346v-11.21c0-1.551-.666-2.248-2.218-2.252q-9.578-.025-19.161-.01c-1.641 0-2.318.706-2.318 2.332v11.21c0 1.553.731 2.266 2.3 2.267q4.729.003 9.461 0zm.059-23.706v-.01c3.208 0 6.413.008 9.619 0 1.566-.007 2.248-.691 2.254-2.221q.007-5.644 0-11.289a2 2 0 0 0-2.282-2.3q-9.542-.015-19.081 0c-1.62 0-2.333.73-2.334 2.328q0 5.485-.005 10.97c0 1.886.638 2.528 2.529 2.53q4.65-.003 9.3-.009zm63.217 23.706v.008h9.381c1.786 0 2.462-.664 2.462-2.432q0-5.524-.006-11.048c0-1.683-.62-2.324-2.289-2.328q-9.537-.019-19.074-.011c-1.618 0-2.315.719-2.316 2.337q0 5.563.005 11.129c0 1.663.692 2.343 2.381 2.345q4.728.004 9.456-.001zm.021-23.707v-.009c3.207 0 6.412.011 9.619-.005 1.527-.007 2.192-.676 2.2-2.183q.014-5.643 0-11.287c0-1.661-.7-2.337-2.4-2.343-1.749-.007-3.5 0-5.246 0h-13.752a2 2 0 0 0-2.285 2.294c0 3.763-.01 7.526 0 11.287a1.97 1.97 0 0 0 2.247 2.244c3.207.011 6.413.001 9.613.001zm-31.666-.009v.01h9.377c1.9 0 2.527-.628 2.527-2.523q0-5.4-.01-10.81c0-1.823-.668-2.5-2.48-2.5h-18.677c-1.87 0-2.509.649-2.515 2.543q0 5.445.011 10.889c0 1.78.606 2.384 2.387 2.386q4.691.009 9.38.004zm.071 7.9v.011c-3.2 0-6.41-.008-9.618 0-1.569.006-2.215.661-2.22 2.226q-.008 5.6-.005 11.207c0 1.68.69 2.374 2.354 2.374q9.5 0 19-.008c1.625 0 2.308-.683 2.315-2.327q.018-5.564.01-11.127c-.005-1.692-.671-2.353-2.371-2.358-3.16-.003-6.313.002-9.465.002zm-31.676 39.492v.012h9.62c1.6 0 2.289-.693 2.289-2.27v-11.21c0-1.609-.714-2.34-2.318-2.341q-9.542-.006-19.082.007c-1.576 0-2.289.714-2.3 2.281q-.011 5.6 0 11.21c0 1.642.686 2.313 2.325 2.314q4.733.001 9.466-.003zm63.218 0v.012c3.232 0 6.466.01 9.7 0a1.925 1.925 0 0 0 2.179-2.216q.01-5.684 0-11.366a1.956 1.956 0 0 0-2.177-2.233q-9.655-.016-19.314.008a1.94 1.94 0 0 0-2.185 2.223q-.011 5.6 0 11.206c0 1.748.651 2.368 2.424 2.37zm-31.576.013v-.013h9.388c1.851 0 2.458-.578 2.467-2.409q.019-5.489 0-10.978c-.008-1.794-.659-2.418-2.477-2.419q-9.346-.008-18.7-.008c-1.844 0-2.5.657-2.5 2.476q.008 5.489 0 10.978c0 1.7.643 2.366 2.346 2.369 3.166.008 6.321.003 9.475.003z"
        transform="translate(3032.664 -260.689)"
        style={{ fill: "#fff" }}
      />
      <g
        data-name="Mask Group 61"
        transform="translate(1095 313)"
        style={{ clipPath: "url(#a)" }}
      >
        <g
          data-name="Group 1317"
          transform="matrix(.998 .07 -.07 .998 95.175 78.611)"
        >
          <path
            d="M69.268 60.956h-4.433l-1.662-1.662a34.685 34.685 0 0 0 8.866-23.274 36.019 36.019 0 1 0-36.02 36.019 34.685 34.685 0 0 0 23.274-8.866l1.662 1.662v4.433l27.708 27.707 8.312-8.312-27.707-27.707zm-33.249 0a24.937 24.937 0 1 1 24.937-24.937 24.833 24.833 0 0 1-24.937 24.937z"
            style={{ fill: "#428bca", fillRule: "evenodd" }}
          />
          <circle
            data-name="Ellipse 288"
            cx="24.876"
            cy="24.876"
            r="24.876"
            transform="translate(10.837 10.838)"
            style={{ opacity: ".6", fill: "#fff" }}
          />
        </g>
      </g>
    </g>
  </svg>
);

export const settingsCogsIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24.012"}
    height={height || "19.146"}
    viewBox="0 0 24.012 19.146"
  >
    <path
      id="cogs-solid"
      d="M19.206,7.275l-.308.537a.464.464,0,0,1-.567.2,4.146,4.146,0,0,1-1.2-.7.466.466,0,0,1-.105-.589l.308-.537a3.239,3.239,0,0,1-.6-1.028h-.619a.463.463,0,0,1-.458-.386,4.227,4.227,0,0,1,0-1.392.467.467,0,0,1,.458-.39h.619a3.239,3.239,0,0,1,.6-1.028l-.308-.537A.462.462,0,0,1,17.127.84a4.2,4.2,0,0,1,1.2-.7.464.464,0,0,1,.567.2l.308.537a3.334,3.334,0,0,1,1.189,0L20.7.345a.464.464,0,0,1,.567-.2,4.146,4.146,0,0,1,1.2.7.466.466,0,0,1,.105.589l-.308.537a3.239,3.239,0,0,1,.6,1.028h.619a.463.463,0,0,1,.458.386,4.227,4.227,0,0,1,0,1.392.467.467,0,0,1-.458.39h-.619a3.239,3.239,0,0,1-.6,1.028l.308.537a.462.462,0,0,1-.105.589,4.2,4.2,0,0,1-1.2.7.464.464,0,0,1-.567-.2L20.4,7.275A3.334,3.334,0,0,1,19.206,7.275Zm-.394-2.206a1.4,1.4,0,0,0,1.981-1.981A1.4,1.4,0,0,0,18.812,5.069Zm-4.326,5.775,1.264.63a.9.9,0,0,1,.394,1.092,8.858,8.858,0,0,1-1.6,2.469.9.9,0,0,1-1.137.2l-1.092-.63a6.446,6.446,0,0,1-2.06,1.189v1.261a.9.9,0,0,1-.739.886,8.438,8.438,0,0,1-2.848,0,.9.9,0,0,1-.75-.886V15.792A6.516,6.516,0,0,1,3.859,14.6l-1.092.627a.9.9,0,0,1-1.137-.2A8.845,8.845,0,0,1,.047,12.565a.905.905,0,0,1,.394-1.092l1.249-.63a6.5,6.5,0,0,1,0-2.379L.441,7.83A.9.9,0,0,1,.047,6.742,8.81,8.81,0,0,1,1.631,4.273a.9.9,0,0,1,1.137-.2l1.092.63a6.446,6.446,0,0,1,2.06-1.189V2.251a.894.894,0,0,1,.735-.882,8.557,8.557,0,0,1,2.852,0,.9.9,0,0,1,.75.886V3.511A6.516,6.516,0,0,1,12.317,4.7l1.092-.63a.9.9,0,0,1,1.137.2,8.8,8.8,0,0,1,1.58,2.469A.9.9,0,0,1,15.75,7.83l-1.264.63A6.521,6.521,0,0,1,14.486,10.843Zm-4.413.792A2.806,2.806,0,0,0,6.107,7.669,2.806,2.806,0,0,0,10.073,11.635Zm9.133,6.855-.308.537a.464.464,0,0,1-.567.2,4.146,4.146,0,0,1-1.2-.7.466.466,0,0,1-.105-.589l.308-.537a3.239,3.239,0,0,1-.6-1.028h-.619a.463.463,0,0,1-.458-.386,4.227,4.227,0,0,1,0-1.392.467.467,0,0,1,.458-.39h.619a3.239,3.239,0,0,1,.6-1.028l-.308-.537a.462.462,0,0,1,.105-.589,4.2,4.2,0,0,1,1.2-.7.464.464,0,0,1,.567.2l.308.537a3.334,3.334,0,0,1,1.189,0l.308-.537a.464.464,0,0,1,.567-.2,4.146,4.146,0,0,1,1.2.7.466.466,0,0,1,.105.589l-.308.537a3.239,3.239,0,0,1,.6,1.028h.619a.463.463,0,0,1,.458.386,4.227,4.227,0,0,1,0,1.392.467.467,0,0,1-.458.39h-.619a3.239,3.239,0,0,1-.6,1.028l.308.537a.462.462,0,0,1-.105.589,4.2,4.2,0,0,1-1.2.7.464.464,0,0,1-.567-.2L20.4,18.49A3.334,3.334,0,0,1,19.206,18.49Zm-.394-2.21A1.4,1.4,0,0,0,20.793,14.3a1.4,1.4,0,0,0-1.981,1.981Z"
      transform="translate(0.009 -0.112)"
      fill="#b1bac1"
    />
  </svg>
);

export const plusIconInFilledCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "16"} height={height || "16"} viewBox="0 0 16 16">
    <g data-name="Group 1133" transform="translate(-634 -117)">
      <circle
        data-name="Ellipse 1"
        cx="8"
        cy="8"
        r="8"
        transform="translate(634 117)"
        style={{ fill: "#478fca" }}
      />
      <path
        data-name="Union 1"
        d="M2.8 8V5.2H0V2.8h2.8V0h2.4v2.8H8v2.4H5.2V8z"
        transform="translate(638 121)"
        style={{ fill: "#fff" }}
      />
    </g>
  </svg>
);

export const plusIconInFilledBlueCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "16"} height={height || "16"} viewBox="0 0 16 16">
    <g data-name="Group 1133" transform="translate(-634 -117)">
      <circle
        data-name="Ellipse 1"
        cx="8"
        cy="8"
        r="8"
        transform="translate(634 117)"
      />
      <path
        data-name="Union 1"
        d="M2.8 8V5.2H0V2.8h2.8V0h2.4v2.8H8v2.4H5.2V8z"
        transform="translate(638 121)"
      />
    </g>
  </svg>
);

export const chevronDown1 = (width?: string, height?: string): JSX.Element => (
  <svg
    id="Group_648"
    data-name="Group 648"
    width={width || "14.584"}
    height={height || "8.698"}
    viewBox="0 0 14.584 8.698"
  >
    <defs>
      <style>{`.cls-1{fill:#b7b7b7}`}</style>
    </defs>
    <path
      id="Path_magnify-minus-outline"
      data-name="Path / magnify-minus-outline"
      className="cls-1"
      d="M0 0h10.25v2.05H0z"
      transform="rotate(45 .725 1.75)"
    />
    <path
      id="Path_magnify-minus-outline-2"
      data-name="Path / magnify-minus-outline"
      className="cls-1"
      d="M0 2.05h10.25V0H0z"
      transform="rotate(135 6.992 3.745)"
    />
  </svg>
);

export const searchIconLight = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "14"}
    height={height || "14"}
    viewBox="0 0 16.648 17.244"
  >
    <path
      d="m17.38 15.707-4.1-4.269a6.96 6.96 0 1 0-5.329 2.487 6.888 6.888 0 0 0 3.989-1.26l4.135 4.3a.908.908 0 1 0 1.309-1.259zM7.946 1.816A5.146 5.146 0 1 1 2.8 6.962a5.152 5.152 0 0 1 5.146-5.146z"
      transform="translate(-.984)"
      style={{ fill: "#428bca" }}
    />
  </svg>
);

export const userGroupsTableSVG = (
  <svg width="100%" height="100%" viewBox="0 0 1668 308.5">
    <defs>
      <style>
        {`.cls-1{fill:none;stroke:#707070;opacity:.1}.cls-2{fill:#f0f0f0}.cls-3{font-size:14px;font-family:OpenSansSemiBold,Open Sans;fontWeight:600}`}
      </style>
    </defs>
    <g
      id="Group_2437"
      data-name="Group 2437"
      transform="translate(-259.125 -253)"
    >
      <path
        id="Line_414"
        data-name="Line 414"
        className="cls-1"
        transform="translate(259.125 575)"
        d="M0 0h1612"
      />
      <rect
        id="Rectangle_1422"
        data-name="Rectangle 1422"
        className="cls-2"
        width="40"
        height="15"
        rx="7.5"
        transform="translate(1812 540)"
      />
      <path
        id="Line_414-2"
        data-name="Line 414"
        className="cls-1"
        transform="translate(259.125 520)"
        d="M0 0h1612"
      />
      <rect
        id="Rectangle_1416"
        data-name="Rectangle 1416"
        className="cls-2"
        width="40"
        height="15"
        rx="7.5"
        transform="translate(1812 485)"
      />
      <path
        id="Line_414-3"
        data-name="Line 414"
        className="cls-1"
        transform="translate(259.125 465)"
        d="M0 0h1612"
      />
      <rect
        id="Rectangle_1410"
        data-name="Rectangle 1410"
        className="cls-2"
        width="40.293"
        height="15"
        rx="7.5"
        transform="translate(1812 430)"
      />
      <path
        id="Line_414-4"
        data-name="Line 414"
        className="cls-1"
        transform="translate(259.125 409)"
        d="M0 0h1612"
      />
      <rect
        id="Rectangle_1404"
        data-name="Rectangle 1404"
        className="cls-2"
        width="40"
        height="15"
        rx="7.5"
        transform="translate(1812 374)"
      />
      <path
        id="Line_397"
        data-name="Line 397"
        className="cls-1"
        transform="translate(259.125 354)"
        d="M0 0h1612"
      />
      <rect
        id="Rectangle_1279"
        data-name="Rectangle 1279"
        className="cls-2"
        width="40"
        height="15"
        rx="7.5"
        transform="translate(1812 320)"
      />
      <g id="Group_2442" data-name="Group 2442">
        <rect
          id="Rectangle_1419"
          data-name="Rectangle 1419"
          className="cls-2"
          width="145"
          height="15"
          rx="7.5"
          transform="translate(268 540)"
        />
        <rect
          id="Rectangle_1413"
          data-name="Rectangle 1413"
          className="cls-2"
          width="145"
          height="15"
          rx="7.5"
          transform="translate(268 485)"
        />
        <rect
          id="Rectangle_1407"
          data-name="Rectangle 1407"
          className="cls-2"
          width="145"
          height="15"
          rx="7.5"
          transform="translate(268 430)"
        />
        <rect
          id="Rectangle_1399"
          data-name="Rectangle 1399"
          className="cls-2"
          width="145"
          height="15"
          rx="7.5"
          transform="translate(268 374)"
        />
        <rect
          id="Rectangle_1270"
          data-name="Rectangle 1270"
          className="cls-2"
          width="145"
          height="15"
          rx="7.5"
          transform="translate(268 320)"
        />
        <g id="Group_2102" data-name="Group 2102" transform="translate(-59)">
          <text id="Role" className="cls-3" transform="translate(326 286)">
            <tspan x="0" y="0">
              Group Name
            </tspan>
          </text>
        </g>
      </g>
      <g id="Group_2439" data-name="Group 2439" transform="translate(36)">
        <rect
          id="Rectangle_1421"
          data-name="Rectangle 1421"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1560 540)"
        />
        <rect
          id="Rectangle_1415"
          data-name="Rectangle 1415"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1560 485)"
        />
        <rect
          id="Rectangle_1409"
          data-name="Rectangle 1409"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1560 430)"
        />
        <rect
          id="Rectangle_1403"
          data-name="Rectangle 1403"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1560 374)"
        />
        <rect
          id="Rectangle_1398"
          data-name="Rectangle 1398"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1560 320)"
        />
        <g id="Group_2099" data-name="Group 2099" transform="translate(333)">
          <text
            id="Created_By"
            data-name="Created By"
            className="cls-3"
            transform="translate(1227 286)"
          >
            <tspan x="0" y="0">
              Modified On
            </tspan>
          </text>
        </g>
      </g>
      <g id="Group_2441" data-name="Group 2441" transform="translate(-10)">
        <rect
          id="Rectangle_1418"
          data-name="Rectangle 1418"
          className="cls-2"
          width="168"
          height="15"
          rx="7.5"
          transform="translate(503 540)"
        />
        <rect
          id="Rectangle_1412"
          data-name="Rectangle 1412"
          className="cls-2"
          width="168"
          height="15"
          rx="7.5"
          transform="translate(503 485)"
        />
        <rect
          id="Rectangle_1406"
          data-name="Rectangle 1406"
          className="cls-2"
          width="168"
          height="15"
          rx="7.5"
          transform="translate(503 430)"
        />
        <rect
          id="Rectangle_1400"
          data-name="Rectangle 1400"
          className="cls-2"
          width="168"
          height="15"
          rx="7.5"
          transform="translate(503 374)"
        />
        <rect
          id="Rectangle_1395"
          data-name="Rectangle 1395"
          className="cls-2"
          width="168"
          height="15"
          rx="7.5"
          transform="translate(503 320)"
        />
        <g id="Group_2099-2" data-name="Group 2099" transform="translate(-724)">
          <text
            id="Created_By-2"
            data-name="Created By"
            className="cls-3"
            transform="translate(1227 286)"
          >
            <tspan x="0" y="0">
              Roles
            </tspan>
          </text>
        </g>
      </g>
      <g id="Group_2440" data-name="Group 2440" transform="translate(-33)">
        <rect
          id="Rectangle_1417"
          data-name="Rectangle 1417"
          className="cls-2"
          width="347"
          height="15"
          rx="7.5"
          transform="translate(771 540)"
        />
        <rect
          id="Rectangle_1411"
          data-name="Rectangle 1411"
          className="cls-2"
          width="347"
          height="15"
          rx="7.5"
          transform="translate(771 485)"
        />
        <rect
          id="Rectangle_1405"
          data-name="Rectangle 1405"
          className="cls-2"
          width="347"
          height="15"
          rx="7.5"
          transform="translate(771 430)"
        />
        <rect
          id="Rectangle_1401"
          data-name="Rectangle 1401"
          className="cls-2"
          width="347"
          height="15"
          rx="7.5"
          transform="translate(771 374)"
        />
        <rect
          id="Rectangle_1396"
          data-name="Rectangle 1396"
          className="cls-2"
          width="347"
          height="15"
          rx="7.5"
          transform="translate(771 320)"
        />
        <g id="Group_2099-3" data-name="Group 2099" transform="translate(-456)">
          <text
            id="Created_By-3"
            data-name="Created By"
            className="cls-3"
            transform="translate(1227 286)"
          >
            <tspan x="0" y="0">
              Users
            </tspan>
          </text>
        </g>
      </g>
      <g id="Group_2438" data-name="Group 2438" transform="translate(98)">
        <rect
          id="Rectangle_1420"
          data-name="Rectangle 1420"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1281 540)"
        />
        <rect
          id="Rectangle_1414"
          data-name="Rectangle 1414"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1281 485)"
        />
        <rect
          id="Rectangle_1408"
          data-name="Rectangle 1408"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1281 430)"
        />
        <rect
          id="Rectangle_1402"
          data-name="Rectangle 1402"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1281 374)"
        />
        <rect
          id="Rectangle_1397"
          data-name="Rectangle 1397"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1281 320)"
        />
        <g id="Group_2100" data-name="Group 2100" transform="translate(-173)">
          <text
            id="Modified_By"
            data-name="Modified By"
            className="cls-3"
            transform="translate(1454 286)"
          >
            <tspan x="0" y="0">
              Modified By
            </tspan>
          </text>
        </g>
      </g>
      <g id="Group_2443" data-name="Group 2443" transform="translate(-118)">
        <rect
          id="Rectangle_1420-2"
          data-name="Rectangle 1420"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1281 540)"
        />
        <rect
          id="Rectangle_1414-2"
          data-name="Rectangle 1414"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1281 485)"
        />
        <rect
          id="Rectangle_1408-2"
          data-name="Rectangle 1408"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1281 430)"
        />
        <rect
          id="Rectangle_1402-2"
          data-name="Rectangle 1402"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1281 374)"
        />
        <rect
          id="Rectangle_1397-2"
          data-name="Rectangle 1397"
          className="cls-2"
          width="139"
          height="15"
          rx="7.5"
          transform="translate(1281 320)"
        />
        <g id="Group_2100-2" data-name="Group 2100" transform="translate(-173)">
          <text
            id="Modified_By-2"
            data-name="Modified By"
            className="cls-3"
            transform="translate(1454 286)"
          >
            <tspan x="0" y="0">
              Created By
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
);

export const userGroupSVG = (
  <svg width="85.014" height="59.503" viewBox="0 0 85.014 59.503">
    <path
      d="M81.1 73.177a15.584 15.584 0 0 0 0-5.659l3.427-1.979a.962.962 0 0 0 .438-1.129 19.937 19.937 0 0 0-4.411-7.626.969.969 0 0 0-1.2-.186l-3.427 1.979a15.6 15.6 0 0 0-4.9-2.83v-3.959a.967.967 0 0 0-.757-.943 20.044 20.044 0 0 0-8.795 0 .967.967 0 0 0-.757.943v3.959a15.6 15.6 0 0 0-4.9 2.83L52.4 56.6a.972.972 0 0 0-1.2.186 19.937 19.937 0 0 0-4.411 7.626.978.978 0 0 0 .438 1.129l3.427 1.979a15.584 15.584 0 0 0 0 5.659l-3.427 1.979a.962.962 0 0 0-.438 1.129 20.036 20.036 0 0 0 4.411 7.624.969.969 0 0 0 1.2.186l3.427-1.979a15.6 15.6 0 0 0 4.9 2.83v3.959a.967.967 0 0 0 .757.943 20.044 20.044 0 0 0 8.795 0 .967.967 0 0 0 .757-.943v-3.96a15.6 15.6 0 0 0 4.9-2.83l3.428 1.983a.972.972 0 0 0 1.2-.186 19.937 19.937 0 0 0 4.411-7.626.979.979 0 0 0-.438-1.129zM65.893 76.79a6.443 6.443 0 1 1 6.443-6.443 6.449 6.449 0 0 1-6.443 6.443zm-53.139-19.2a8.5 8.5 0 1 0-8.5-8.5 8.51 8.51 0 0 0 8.499 8.504zm29.758 4.251c.252 0 .492-.066.744-.08a24.49 24.49 0 0 1 4.822-7.861 5.236 5.236 0 0 1 3.839-1.674 5.106 5.106 0 0 1 2.6.7l1.05.611c.106-.066.213-.12.319-.186a14.7 14.7 0 0 0 1.488-6.377 14.872 14.872 0 1 0-14.862 14.871zm13.975 25.843c-.306-.159-.611-.345-.9-.518a6.563 6.563 0 0 1-3.653 1.3 5.28 5.28 0 0 1-3.839-1.674 24.224 24.224 0 0 1-5.341-9.246c-1.421-4.583 3.308-6.6 3.427-6.682q-.02-.518 0-1.036l-1.05-.611a5.411 5.411 0 0 1-1.3-1.076c-.438.027-.864.08-1.3.08a20.972 20.972 0 0 1-9.1-2.126h-1.1A15.311 15.311 0 0 0 17 81.4v3.826a6.378 6.378 0 0 0 6.381 6.374h33.93a5.115 5.115 0 0 1-.824-2.7v-1.216zM23 64.316a8.477 8.477 0 0 0-6-2.471H8.5a8.51 8.51 0 0 0-8.5 8.5V74.6a4.247 4.247 0 0 0 4.251 4.251h8.755A19.481 19.481 0 0 1 23 64.316z"
      transform="translate(0 -32.1)"
      style={{ fill: "#428bca" }}
    />
  </svg>
);

export const doubleArrowLeft = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "10.407"}
    height={height || "11.264"}
    viewBox="0 0 10.407 11.264"
  >
    <defs>
      <style>{`.cls-1{fill:#b0b0b0}`}</style>
    </defs>
    <g
      id="Group_1861"
      data-name="Group 1861"
      transform="translate(-885.188 -441.011)"
    >
      <g
        id="Group_1859"
        data-name="Group 1859"
        transform="rotate(90 225.448 666.458)"
      >
        <path
          id="Path_magnify-minus-outline"
          data-name="Path / magnify-minus-outline"
          className="cls-1"
          d="M0 0h7.917v1.583H0z"
          transform="rotate(45 .56 1.352)"
        />
        <path
          id="Path_magnify-minus-outline-2"
          data-name="Path / magnify-minus-outline"
          className="cls-1"
          d="M0 1.583h7.917V0H0z"
          transform="rotate(135 5.4 2.893)"
        />
      </g>
      <g
        id="Group_1860"
        data-name="Group 1860"
        transform="rotate(90 227.292 668.303)"
      >
        <path
          id="Path_magnify-minus-outline-3"
          data-name="Path / magnify-minus-outline"
          className="cls-1"
          d="M0 0h7.917v1.583H0z"
          transform="rotate(45 .56 1.352)"
        />
        <path
          id="Path_magnify-minus-outline-4"
          data-name="Path / magnify-minus-outline"
          className="cls-1"
          d="M0 1.583h7.917V0H0z"
          transform="rotate(135 5.4 2.893)"
        />
      </g>
    </g>
  </svg>
);

export const singleArrowLeft = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "6.718"}
    height={height || "11.264"}
    viewBox="0 0 6.718 11.264"
  >
    <defs>
      <style>{`.cls-1{fill:#b0b0b0}`}</style>
    </defs>
    <g
      id="Group_1862"
      data-name="Group 1862"
      transform="translate(-888.877 -441.011)"
    >
      <g
        id="Group_1860"
        data-name="Group 1860"
        transform="rotate(90 227.292 668.303)"
      >
        <path
          id="Path_magnify-minus-outline"
          data-name="Path / magnify-minus-outline"
          className="cls-1"
          d="M0 0h7.917v1.583H0z"
          transform="rotate(45 .56 1.352)"
        />
        <path
          id="Path_magnify-minus-outline-2"
          data-name="Path / magnify-minus-outline"
          className="cls-1"
          d="M0 1.583h7.917V0H0z"
          transform="rotate(135 5.4 2.893)"
        />
      </g>
    </g>
  </svg>
);

export const singleArrowRight = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "6.718"}
    height={height || "11.264"}
    viewBox="0 0 6.718 11.264"
  >
    <defs>
      <style>{`.cls-1{fill:gray}`}</style>
    </defs>
    <g
      id="Group_1860"
      data-name="Group 1860"
      transform="rotate(90 3.359 3.359)"
    >
      <path
        id="Path_magnify-minus-outline"
        data-name="Path / magnify-minus-outline"
        className="cls-1"
        d="M0 1.583h7.917V0H0z"
        transform="rotate(-45 6.757 2.799)"
      />
      <path
        id="Path_magnify-minus-outline-2"
        data-name="Path / magnify-minus-outline"
        className="cls-1"
        d="M0 0h7.917v1.583H0z"
        transform="rotate(-135 6.464 1.258)"
      />
    </g>
  </svg>
);

export const doubleArrowRight = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "10.406"}
    height={height || "11.264"}
    viewBox="0 0 10.406 11.264"
  >
    <defs>
      <style>{`.cls-1{fill:gray}`}</style>
    </defs>
    <g id="Group_1864" data-name="Group 1864" transform="translate(-.001)">
      <g
        id="Group_1859"
        data-name="Group 1859"
        transform="rotate(90 5.204 5.204)"
      >
        <path
          id="Path_magnify-minus-outline"
          data-name="Path / magnify-minus-outline"
          className="cls-1"
          d="M0 1.583h7.917V0H0z"
          transform="rotate(-45 6.757 2.799)"
        />
        <path
          id="Path_magnify-minus-outline-2"
          data-name="Path / magnify-minus-outline"
          className="cls-1"
          d="M0 0h7.917v1.583H0z"
          transform="rotate(-135 6.464 1.258)"
        />
      </g>
      <g
        id="Group_1860"
        data-name="Group 1860"
        transform="rotate(90 3.36 3.36)"
      >
        <path
          id="Path_magnify-minus-outline-3"
          data-name="Path / magnify-minus-outline"
          className="cls-1"
          d="M0 1.583h7.917V0H0z"
          transform="rotate(-45 6.757 2.799)"
        />
        <path
          id="Path_magnify-minus-outline-4"
          data-name="Path / magnify-minus-outline"
          className="cls-1"
          d="M0 0h7.917v1.583H0z"
          transform="rotate(-135 6.464 1.258)"
        />
      </g>
    </g>
  </svg>
);

export const endorseIcon = (): JSX.Element => (
  <svg width="22.54" height="22.24" viewBox="0 0 28.54 25.318">
    <defs>
      <style>{`.endorse-icon-cls{ fill: #fff; stroke: #4c4c4c; strokeWidth: 2px;}`}</style>
    </defs>
    <g
      id="Group_2101"
      data-name="Group 2101"
      transform="translate(-180.962 -203.692)"
    >
      <path
        id="Path_2788"
        data-name="Path 2788"
        d="M258.34,213.014H260.1c1.439,0,2.877.007,4.316,0a2.312,2.312,0,0,1,2.332,1.207,2.644,2.644,0,0,1-.211,2.873.808.808,0,0,0-.123.786,2.656,2.656,0,0,1-.37,2.275.938.938,0,0,0-.157.885,2.819,2.819,0,0,1-.412,2.32,1.16,1.16,0,0,0-.13.741,3.036,3.036,0,0,1-2.863,3.829c-2.3.09-4.6.069-6.9.075-1.624,0-3.248-.027-4.872-.049a2.335,2.335,0,0,1-.6-.079c-1.173-.334-1.259-.452-1.259-1.644,0-3.554,0-7.108-.008-10.662a1.311,1.311,0,0,1,.329-.834c.841-1.162,1.676-2.335,2.423-3.559,1.279-2.1,1.251-2.115,1.2-4.56,0-.186-.009-.372-.015-.558a2.038,2.038,0,0,1,2.148-2.361,2.454,2.454,0,0,1,2.828,1.7c.333,1.008.72,2,1,3.024a8.9,8.9,0,0,1-.23,3.413C258.482,212.2,258.412,212.56,258.34,213.014Z"
        transform="translate(-57.73)"
        className="endorse-icon-cls"
      />
      <path
        id="Path_2789"
        data-name="Path 2789"
        d="M190.046,292.287c-.287.029-.567.08-.847.081q-3.25.01-6.5,0c-1.212,0-1.736-.526-1.736-1.724q0-5.282,0-10.563c0-1.17.529-1.692,1.708-1.694l6.8-.007h.57Z"
        transform="translate(0 -63.522)"
        className="endorse-icon-cls"
      />
    </g>
  </svg>
);

export const eyeIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "23.64"}
    height={height || "16.448"}
    viewBox="0 0 29.564 20.679"
  >
    <defs>
      <style>{`.eyeicon-svg{stroke: #4c4c4c; strokeWidth: 2px; fill: none}
      .eyeicon-svg-1{fill: transparent; stroke: #4c4c4c; strokeWidth: 2px}`}</style>
    </defs>
    <g data-name="Group 1058">
      <g data-name="7351082_eye_view_see_look_icon">
        <path
          data-name="Path 2365"
          d="M17.895 7C10.75 7 5.937 13.219 4.408 15.508a1.486 1.486 0 0 0 0 1.664c1.529 2.288 6.342 8.508 13.487 8.508s11.958-6.219 13.487-8.508a1.486 1.486 0 0 0 0-1.664C29.852 13.219 25.04 7 17.895 7z"
          transform="translate(-3.113 -6)"
          className="eyeicon-svg"
        />
        <path
          data-name="Path 2366"
          d="M18.673 14.336A4.672 4.672 0 1 1 14 9.667a4.67 4.67 0 0 1 4.673 4.669z"
          transform="translate(.779 -3.997)"
          className="eyeicon-svg-1"
        />
      </g>
    </g>
  </svg>
);

export const actionsIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "4"} height={height || "16.7"} viewBox="0 0 5 21">
    <defs>
      <style>{`.actions-icon-cls-1{fill:#4c4c4c}`}</style>
    </defs>
    <g id="Group_1344" data-name="Group 1344" transform="translate(-1703 -142)">
      <circle
        id="Ellipse_265"
        data-name="Ellipse 265"
        className="actions-icon-cls-1"
        cx="2.5"
        cy="2.5"
        r="2.5"
        transform="translate(1703 142)"
      />
      <circle
        id="Ellipse_266"
        data-name="Ellipse 266"
        className="actions-icon-cls-1"
        cx="2.5"
        cy="2.5"
        r="2.5"
        transform="translate(1703 150)"
      />
      <circle
        id="Ellipse_267"
        data-name="Ellipse 267"
        className="actions-icon-cls-1"
        cx="2.5"
        cy="2.5"
        r="2.5"
        transform="translate(1703 158)"
      />
    </g>
  </svg>
);

export const crossIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    data-name="Group 1687"
    width={width || "30"}
    height={height || "30"}
    viewBox="0 0 37 37"
  >
    <g data-name="Group 1114">
      <g data-name="Group 742">
        <g data-name="Ellipse 263" style={{ stroke: "#d15b47", fill: "none" }}>
          <circle cx="18.5" cy="18.5" r="18.5" style={{ stroke: "none" }} />
          <circle cx="18.5" cy="18.5" r="18" style={{ fill: "none" }} />
        </g>
      </g>
    </g>
    <path
      data-name="Icon ionic-ios-close"
      d="m19.694 18.085 4.856-4.856a1.138 1.138 0 0 0-1.609-1.609l-4.856 4.856-4.856-4.856a1.138 1.138 0 1 0-1.609 1.609l4.856 4.856-4.856 4.856a1.138 1.138 0 0 0 1.609 1.609l4.856-4.856 4.856 4.856a1.138 1.138 0 0 0 1.609-1.609z"
      transform="translate(.18 .178)"
      style={{ fill: "#d15b47" }}
    />
  </svg>
);

export const tickIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "30"} height={height || "30"} viewBox="0 0 37 37">
    <g id="Group_1686" data-name="Group 1686" transform="translate(0.093)">
      <g id="Group_1114" data-name="Group 1114" transform="translate(0 0)">
        <g id="Group_742" data-name="Group 742" transform="translate(0 0)">
          <g
            id="Ellipse_263"
            data-name="Ellipse 263"
            transform="translate(-0.093)"
            fill="none"
            stroke="#428bca"
            strokeWidth="1"
          >
            <circle cx="18.5" cy="18.5" r="18.5" stroke="none" />
            <circle cx="18.5" cy="18.5" r="18" fill="none" />
          </g>
        </g>
        <path
          id="Icon_feather-check"
          data-name="Icon feather-check"
          d="M24.263,9,11.707,21.556,6,15.849"
          transform="translate(3.132 2.985)"
          fill="none"
          stroke="#428bca"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
      </g>
    </g>
  </svg>
);

export const auditTrailIcon = (): JSX.Element => (
  <svg width="18" height="21" viewBox="0 0 22.497 26.924">
    <defs>
      <style>{`.cls-1{fill:#428bca}`}</style>
    </defs>
    <g
      id="Group_1840"
      data-name="Group 1840"
      transform="translate(712.682 -65.948)"
    >
      <path
        id="Path_2715"
        data-name="Path 2715"
        className="cls-1"
        d="M-710.736 347.4a1.517 1.517 0 0 1-.449.121 1.382 1.382 0 0 1-1.168-.462 1.382 1.382 0 0 1-.29-1.222 2.738 2.738 0 0 1 .842-1.2l1.983-1.949 1.011-.993a2.076 2.076 0 0 0 .433-.45c.122-.232.012-.37-.094-.58a5.5 5.5 0 0 1-.513-1.7 5.867 5.867 0 0 1 .575-3.474 5.882 5.882 0 0 1 4.32-3.073 5.816 5.816 0 0 1 6.425 4.419 5.745 5.745 0 0 1 .072 2.293 5.86 5.86 0 0 1-3.1 4.159 5.86 5.86 0 0 1-5.185-.012.592.592 0 0 0-.358-.1.563.563 0 0 0-.28.187l-3.128 3.177a3.756 3.756 0 0 1-1.096.859zm11.469-10.311a4.278 4.278 0 0 0-5.432-2.83 4.039 4.039 0 0 0-2.487 2.677 4.165 4.165 0 0 0 1.967 4.788 4.1 4.1 0 0 0 1.726.512 4.207 4.207 0 0 0 4.289-4.861q-.026-.146-.063-.286z"
        transform="translate(0 -254.912)"
      />
      <path
        id="Path_2716"
        data-name="Path 2716"
        className="cls-1"
        d="M-594.213 74.84c-.593-2.465-1.022-5.66.824-7.737a5.6 5.6 0 0 1 .643-.618 2.461 2.461 0 0 1 3.217.136 5.4 5.4 0 0 1 1.619 3.679 8.206 8.206 0 0 1-.1 2.408 12.307 12.307 0 0 1-.605 1.836 7.12 7.12 0 0 0-.4 2.017c-.015.282-.3.229-.52.187a6.034 6.034 0 0 0-3.082.259c-.3.1-.569.318-.859.441-.007 0-.544-1.881-.581-2.022q-.083-.288-.156-.586z"
        transform="translate(-112.869)"
      />
      <path
        id="Path_2717"
        data-name="Path 2717"
        className="cls-1"
        d="M-345.064 576.715a1.517 1.517 0 0 1-.655-.569 2.071 2.071 0 0 1-.219-1.09 11.251 11.251 0 0 1 .42-2.689c.08-.311.221-.457.554-.452a29.24 29.24 0 0 1 2.955.265 1.248 1.248 0 0 1 .937.426.96.96 0 0 1 .1.7 10.54 10.54 0 0 1-.5 1.767 3.032 3.032 0 0 1-1.218 1.662 2.535 2.535 0 0 1-1.863.17 2.677 2.677 0 0 1-.511-.19z"
        transform="translate(-350.914 -484.129)"
      />
      <path
        id="Path_2718"
        data-name="Path 2718"
        className="cls-1"
        d="M-348.682 286.292a3.341 3.341 0 0 0-.033-.354c-.177-1.108-.628-2.177-.9-3.273a7.489 7.489 0 0 1 .026-3.576c.38-1.651 1.643-3.256 3.471-3.2a3.255 3.255 0 0 1 1.73 1.106 4.6 4.6 0 0 1 .727 1.008 4.4 4.4 0 0 1 .26.591 8.65 8.65 0 0 1 .384 3.525 22.523 22.523 0 0 1-.674 3.743 7.42 7.42 0 0 1-.447 1.65c-.22.409-.821.228-1.194.16-.682-.125-1.362-.239-2.044-.387-.138-.03-1.226-.177-1.248-.3a5.17 5.17 0 0 1-.058-.693z"
        transform="translate(-347.198 -200.877)"
      />
      <path
        id="Path_2719"
        data-name="Path 2719"
        className="cls-1"
        d="M-545.185 388.627a3.89 3.89 0 0 1 .481.292c.071.1.2.153.233.28a6.649 6.649 0 0 1 .049 1.41 1.686 1.686 0 0 1-1.274 1.4 2.335 2.335 0 0 1-2.77-1 10.082 10.082 0 0 1-.659-1.635.262.262 0 0 1 .1-.313 3.33 3.33 0 0 1 3.84-.434z"
        transform="translate(-156.481 -308.357)"
      />
    </g>
  </svg>
);

export const tickIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "13.835"}
    height={height || "10.602"}
    viewBox="0 0 13.835 10.602"
  >
    <defs>
      <style>{`.tick-icon-cls-1{fill:#478fca}`}</style>
    </defs>

    <path
      data-name="Path 2674"
      d="m-1055.892-245.271 3.6-3.618c.681-.684 1.359-1.371 2.046-2.049.564-.557.977-.553 1.546 0 .321.314.644.628.951.956a.882.882 0 0 1 0 1.4q-3.734 3.751-7.482 7.488a.89.89 0 0 1-1.4-.007q-2.148-2.124-4.271-4.273a.858.858 0 0 1 0-1.36c.327-.354.669-.7 1.019-1.028a.906.906 0 0 1 1.473.032c.794.783 1.579 1.575 2.369 2.362a1.194 1.194 0 0 0 .149.097z"
      transform="translate(1061.239 251.354)"
      className="tick-icon-cls-1"
    />
  </svg>
);

export const tickIconGreen = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "14.906"}
    height={height || "11.687"}
    viewBox="0 0 14.906 11.687"
  >
    <path
      data-name="Path 2657"
      d="M-1513.046 634.654c1.579-1.552 3.126-3.071 4.671-4.592.391-.385.769-.781 1.161-1.164a.867.867 0 0 1 1.325.006q.562.55 1.11 1.114a.852.852 0 0 1-.007 1.324q-3.767 3.79-7.542 7.572a.862.862 0 0 1-1.348-.005q-2.149-2.148-4.29-4.3a.867.867 0 0 1-.008-1.377c.332-.342.671-.677 1.009-1.013a.891.891 0 0 1 1.476-.008q1.111 1.113 2.217 2.232c.082.079.172.157.226.211z"
      transform="translate(1518.836 -628.049)"
      style={{ fill: "#59a84b", stroke: "#fff" }}
    />
  </svg>
);

export const roundIcon = (): JSX.Element => (
  <svg width="14" height="14" viewBox="0 0 14 14">
    <g
      data-name="Ellipse 303"
      style={{ fill: "#fff", stroke: "#428bca", strokeWidth: "2px" }}
    >
      <circle cx="7" cy="7" r="7" style={{ stroke: "none" }} />
      <circle cx="7" cy="7" r="6" style={{ fill: "none" }} />
    </g>
  </svg>
);

export const filledInfoIconCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "14.399"}
    height={height || "14.399"}
    viewBox="0 0 14.399 14.399"
  >
    <g data-name="211674_help_circled_icon" style={{ opacity: ".6" }}>
      <path
        data-name="Path 2661"
        d="M39.2 32a7.2 7.2 0 1 0 7.2 7.2 7.2 7.2 0 0 0-7.2-7.2zm.649 10.5a.958.958 0 0 1-1.916-.058.958.958 0 0 1 1.916.058zm1.565-4.092a4.648 4.648 0 0 1-.816.73l-.421.289a1.115 1.115 0 0 0-.4.556 3.179 3.179 0 0 0-.067.6.131.131 0 0 1-.145.125h-1.259c-.132 0-.148-.077-.145-.116a2.633 2.633 0 0 1 .318-1.327 4.22 4.22 0 0 1 1.141-.977 1.329 1.329 0 0 0 .305-.312 1.115 1.115 0 0 0 .257-.64 1.137 1.137 0 0 0-.235-.733.928.928 0 0 0-.829-.366.907.907 0 0 0-.816.476 1.57 1.57 0 0 0-.141.877H36.6a2.425 2.425 0 0 1 .89-2.2 2.671 2.671 0 0 1 1.536-.4 3.1 3.1 0 0 1 1.99.572 1.991 1.991 0 0 1 .791 1.691 1.932 1.932 0 0 1-.393 1.156z"
        style={{ fill: "#5c5c5c" }}
        transform="translate(-32 -32)"
      />
    </g>
  </svg>
);

export const userRolesTableSVG = (
  <svg width="100%" height="100%" viewBox="0 0 1803 442" fill="none">
    <rect width="250.143" height="50" fill="white" />
    <path
      d="M17.0054 19.8643C18.0513 19.8643 18.9146 19.9915 19.5952 20.2461C20.2814 20.5007 20.7905 20.888 21.1226 21.4082C21.4601 21.9284 21.6289 22.5897 21.6289 23.3921C21.6289 23.9897 21.5182 24.4989 21.2969 24.9194C21.0755 25.34 20.785 25.6886 20.4253 25.9653C20.0656 26.242 19.681 26.4634 19.2715 26.6294L22.7163 32H20.4668L17.5366 27.1357H15.5859V32H13.5938V19.8643H17.0054ZM16.8726 21.5244H15.5859V25.4922H16.9639C17.888 25.4922 18.5576 25.3206 18.9727 24.9775C19.3932 24.6344 19.6035 24.1281 19.6035 23.4585C19.6035 22.7557 19.3794 22.2576 18.9312 21.9644C18.4884 21.6711 17.8022 21.5244 16.8726 21.5244ZM32.3867 27.3848C32.3867 28.1484 32.2871 28.8263 32.0879 29.4185C31.8887 30.0106 31.5981 30.5114 31.2163 30.9209C30.8345 31.3249 30.3752 31.6348 29.8384 31.8506C29.3016 32.0609 28.6956 32.166 28.0205 32.166C27.3896 32.166 26.8114 32.0609 26.2856 31.8506C25.7599 31.6348 25.3034 31.3249 24.916 30.9209C24.5342 30.5114 24.2381 30.0106 24.0278 29.4185C23.8175 28.8263 23.7124 28.1484 23.7124 27.3848C23.7124 26.3721 23.8867 25.5143 24.2354 24.8115C24.5895 24.1032 25.0931 23.5636 25.7461 23.1929C26.3991 22.8221 27.1766 22.6367 28.0786 22.6367C28.9253 22.6367 29.6724 22.8221 30.3198 23.1929C30.9673 23.5636 31.4736 24.1032 31.8389 24.8115C32.2041 25.5199 32.3867 26.3776 32.3867 27.3848ZM25.7212 27.3848C25.7212 28.0544 25.8014 28.6271 25.9619 29.103C26.1279 29.5789 26.3825 29.9442 26.7256 30.1987C27.0687 30.4478 27.5114 30.5723 28.0537 30.5723C28.596 30.5723 29.0387 30.4478 29.3818 30.1987C29.7249 29.9442 29.9767 29.5789 30.1372 29.103C30.2977 28.6271 30.3779 28.0544 30.3779 27.3848C30.3779 26.7152 30.2977 26.1479 30.1372 25.6831C29.9767 25.2127 29.7249 24.8558 29.3818 24.6123C29.0387 24.3633 28.5933 24.2388 28.0454 24.2388C27.2375 24.2388 26.6481 24.5099 26.2773 25.0522C25.9066 25.5946 25.7212 26.3721 25.7212 27.3848ZM36.5869 32H34.6279V19.084H36.5869V32ZM43.0366 22.6367C43.8556 22.6367 44.5584 22.8055 45.145 23.1431C45.7316 23.4806 46.1826 23.9593 46.498 24.5791C46.8135 25.1989 46.9712 25.9404 46.9712 26.8037V27.8496H40.8369C40.859 28.7406 41.097 29.4268 41.5508 29.9082C42.0101 30.3896 42.652 30.6304 43.4766 30.6304C44.0632 30.6304 44.5889 30.575 45.0537 30.4644C45.5241 30.3481 46.0083 30.1794 46.5063 29.958V31.5435C46.047 31.7593 45.5794 31.917 45.1035 32.0166C44.6276 32.1162 44.0576 32.166 43.3936 32.166C42.4915 32.166 41.6974 31.9917 41.0112 31.6431C40.3306 31.2889 39.7965 30.7632 39.4092 30.0659C39.0273 29.3687 38.8364 28.5026 38.8364 27.4678C38.8364 26.4385 39.0107 25.5641 39.3594 24.8447C39.708 24.1253 40.1978 23.5775 40.8286 23.2012C41.4595 22.8249 42.1955 22.6367 43.0366 22.6367ZM43.0366 24.106C42.4224 24.106 41.9243 24.3052 41.5425 24.7036C41.1662 25.1021 40.9448 25.6859 40.8784 26.4551H45.062C45.0565 25.9958 44.979 25.589 44.8296 25.2349C44.6857 24.8807 44.4644 24.604 44.1655 24.4048C43.8722 24.2056 43.4959 24.106 43.0366 24.106Z"
      fill="black"
    />
    <rect
      width="250.143"
      height="50"
      transform="translate(250.143)"
      fill="white"
    />
    <path
      d="M271.257 32L270.07 28.6299H265.43L264.243 32H262.143L266.658 19.8145H268.866L273.374 32H271.257ZM269.555 26.9199L268.402 23.5996C268.357 23.4557 268.294 23.2537 268.211 22.9937C268.128 22.728 268.045 22.4596 267.962 22.1885C267.879 21.9118 267.809 21.6794 267.754 21.4912C267.699 21.7181 267.63 21.9727 267.547 22.2549C267.469 22.5316 267.392 22.7917 267.314 23.0352C267.242 23.2786 267.187 23.4668 267.148 23.5996L265.986 26.9199H269.555ZM280.952 29.377C280.952 29.9801 280.806 30.4893 280.512 30.9043C280.219 31.3193 279.79 31.6348 279.226 31.8506C278.667 32.0609 277.981 32.166 277.167 32.166C276.525 32.166 275.972 32.119 275.507 32.0249C275.048 31.9364 274.613 31.798 274.204 31.6099V29.9248C274.641 30.1296 275.131 30.3066 275.673 30.4561C276.221 30.6055 276.738 30.6802 277.225 30.6802C277.867 30.6802 278.329 30.5806 278.612 30.3813C278.894 30.1766 279.035 29.9054 279.035 29.5679C279.035 29.3687 278.977 29.1916 278.861 29.0366C278.75 28.8761 278.54 28.7129 278.23 28.5469C277.925 28.3753 277.477 28.1706 276.885 27.9326C276.304 27.7002 275.814 27.4678 275.416 27.2354C275.017 27.0029 274.716 26.7235 274.511 26.397C274.306 26.0649 274.204 25.6416 274.204 25.127C274.204 24.3135 274.525 23.6965 275.167 23.2759C275.814 22.8498 276.669 22.6367 277.732 22.6367C278.296 22.6367 278.827 22.6948 279.325 22.811C279.829 22.9217 280.322 23.085 280.803 23.3008L280.189 24.77C279.774 24.5874 279.356 24.438 278.935 24.3218C278.52 24.2 278.097 24.1392 277.665 24.1392C277.162 24.1392 276.777 24.2166 276.511 24.3716C276.251 24.5265 276.121 24.7479 276.121 25.0356C276.121 25.2515 276.185 25.4341 276.312 25.5835C276.44 25.7329 276.658 25.8823 276.968 26.0317C277.283 26.1812 277.721 26.3665 278.28 26.5879C278.827 26.7982 279.301 27.0195 279.699 27.252C280.103 27.4788 280.413 27.7583 280.629 28.0903C280.844 28.4224 280.952 28.8512 280.952 29.377ZM289.237 29.377C289.237 29.9801 289.09 30.4893 288.797 30.9043C288.503 31.3193 288.074 31.6348 287.51 31.8506C286.951 32.0609 286.265 32.166 285.451 32.166C284.809 32.166 284.256 32.119 283.791 32.0249C283.332 31.9364 282.898 31.798 282.488 31.6099V29.9248C282.925 30.1296 283.415 30.3066 283.957 30.4561C284.505 30.6055 285.023 30.6802 285.51 30.6802C286.151 30.6802 286.614 30.5806 286.896 30.3813C287.178 30.1766 287.319 29.9054 287.319 29.5679C287.319 29.3687 287.261 29.1916 287.145 29.0366C287.034 28.8761 286.824 28.7129 286.514 28.5469C286.21 28.3753 285.761 28.1706 285.169 27.9326C284.588 27.7002 284.098 27.4678 283.7 27.2354C283.302 27.0029 283 26.7235 282.795 26.397C282.59 26.0649 282.488 25.6416 282.488 25.127C282.488 24.3135 282.809 23.6965 283.451 23.2759C284.098 22.8498 284.953 22.6367 286.016 22.6367C286.58 22.6367 287.112 22.6948 287.61 22.811C288.113 22.9217 288.606 23.085 289.087 23.3008L288.473 24.77C288.058 24.5874 287.64 24.438 287.219 24.3218C286.804 24.2 286.381 24.1392 285.949 24.1392C285.446 24.1392 285.061 24.2166 284.796 24.3716C284.536 24.5265 284.406 24.7479 284.406 25.0356C284.406 25.2515 284.469 25.4341 284.596 25.5835C284.724 25.7329 284.942 25.8823 285.252 26.0317C285.568 26.1812 286.005 26.3665 286.564 26.5879C287.112 26.7982 287.585 27.0195 287.983 27.252C288.387 27.4788 288.697 27.7583 288.913 28.0903C289.129 28.4224 289.237 28.8512 289.237 29.377ZM293.296 22.811V32H291.345V22.811H293.296ZM292.333 19.2915C292.632 19.2915 292.889 19.3717 293.105 19.5322C293.326 19.6927 293.437 19.9694 293.437 20.3623C293.437 20.7497 293.326 21.0264 293.105 21.1924C292.889 21.3529 292.632 21.4331 292.333 21.4331C292.023 21.4331 291.76 21.3529 291.544 21.1924C291.334 21.0264 291.229 20.7497 291.229 20.3623C291.229 19.9694 291.334 19.6927 291.544 19.5322C291.76 19.3717 292.023 19.2915 292.333 19.2915ZM298.716 36.084C297.471 36.084 296.516 35.8599 295.852 35.4116C295.188 34.9634 294.856 34.3353 294.856 33.5273C294.856 32.9629 295.033 32.4842 295.387 32.0913C295.742 31.7039 296.248 31.4355 296.906 31.2861C296.657 31.1755 296.442 31.0039 296.259 30.7715C296.082 30.5335 295.993 30.2707 295.993 29.9829C295.993 29.6398 296.09 29.3465 296.284 29.103C296.478 28.8595 296.768 28.6243 297.156 28.3975C296.674 28.1927 296.287 27.8607 295.993 27.4014C295.706 26.9365 295.562 26.3914 295.562 25.7661C295.562 25.1021 295.703 24.5376 295.985 24.0728C296.267 23.6024 296.68 23.2454 297.222 23.002C297.764 22.7529 298.42 22.6284 299.189 22.6284C299.355 22.6284 299.535 22.6395 299.729 22.6616C299.928 22.6782 300.111 22.7004 300.277 22.728C300.448 22.7502 300.578 22.7751 300.667 22.8027H303.846V23.8901L302.285 24.1807C302.435 24.391 302.554 24.6317 302.642 24.9028C302.731 25.1685 302.775 25.459 302.775 25.7744C302.775 26.7262 302.446 27.4761 301.787 28.0239C301.134 28.5662 300.232 28.8374 299.081 28.8374C298.805 28.8263 298.536 28.8042 298.276 28.771C298.077 28.8927 297.925 29.0283 297.82 29.1777C297.714 29.3216 297.662 29.4849 297.662 29.6675C297.662 29.8169 297.714 29.9386 297.82 30.0327C297.925 30.1213 298.08 30.1877 298.284 30.2319C298.495 30.2762 298.749 30.2983 299.048 30.2983H300.634C301.641 30.2983 302.41 30.5114 302.941 30.9375C303.472 31.3636 303.738 31.9889 303.738 32.8135C303.738 33.8594 303.306 34.6646 302.443 35.229C301.58 35.799 300.337 36.084 298.716 36.084ZM298.791 34.7144C299.471 34.7144 300.044 34.6479 300.509 34.5151C300.974 34.3823 301.325 34.1914 301.563 33.9424C301.801 33.6989 301.92 33.4084 301.92 33.0708C301.92 32.772 301.845 32.5423 301.696 32.3818C301.547 32.2214 301.323 32.1107 301.024 32.0498C300.725 31.9889 300.354 31.9585 299.911 31.9585H298.467C298.107 31.9585 297.789 32.0138 297.512 32.1245C297.236 32.2407 297.02 32.4067 296.865 32.6226C296.716 32.8384 296.641 33.0985 296.641 33.4028C296.641 33.8234 296.826 34.1471 297.197 34.374C297.573 34.6009 298.105 34.7144 298.791 34.7144ZM299.173 27.5591C299.743 27.5591 300.166 27.4041 300.443 27.0942C300.719 26.7788 300.858 26.3361 300.858 25.7661C300.858 25.1463 300.714 24.6815 300.426 24.3716C300.144 24.0617 299.723 23.9067 299.164 23.9067C298.616 23.9067 298.199 24.0645 297.911 24.3799C297.629 24.6953 297.488 25.1629 297.488 25.7827C297.488 26.3416 297.629 26.7788 297.911 27.0942C298.199 27.4041 298.619 27.5591 299.173 27.5591ZM310.312 22.6367C311.347 22.6367 312.152 22.9051 312.728 23.4419C313.309 23.9731 313.599 24.8281 313.599 26.0068V32H311.649V26.3721C311.649 25.6582 311.502 25.1242 311.209 24.77C310.915 24.4103 310.462 24.2305 309.847 24.2305C308.956 24.2305 308.337 24.5044 307.988 25.0522C307.645 25.6001 307.473 26.3942 307.473 27.4346V32H305.523V22.811H307.042L307.316 24.0562H307.424C307.623 23.7352 307.869 23.4723 308.162 23.2676C308.461 23.0573 308.793 22.8996 309.158 22.7944C309.529 22.6893 309.914 22.6367 310.312 22.6367ZM319.991 22.6367C320.81 22.6367 321.513 22.8055 322.099 23.1431C322.686 23.4806 323.137 23.9593 323.452 24.5791C323.768 25.1989 323.926 25.9404 323.926 26.8037V27.8496H317.791C317.813 28.7406 318.051 29.4268 318.505 29.9082C318.964 30.3896 319.606 30.6304 320.431 30.6304C321.017 30.6304 321.543 30.575 322.008 30.4644C322.478 30.3481 322.963 30.1794 323.461 29.958V31.5435C323.001 31.7593 322.534 31.917 322.058 32.0166C321.582 32.1162 321.012 32.166 320.348 32.166C319.446 32.166 318.652 31.9917 317.966 31.6431C317.285 31.2889 316.751 30.7632 316.364 30.0659C315.982 29.3687 315.791 28.5026 315.791 27.4678C315.791 26.4385 315.965 25.5641 316.314 24.8447C316.662 24.1253 317.152 23.5775 317.783 23.2012C318.414 22.8249 319.15 22.6367 319.991 22.6367ZM319.991 24.106C319.377 24.106 318.879 24.3052 318.497 24.7036C318.121 25.1021 317.899 25.6859 317.833 26.4551H322.016C322.011 25.9958 321.933 25.589 321.784 25.2349C321.64 24.8807 321.419 24.604 321.12 24.4048C320.827 24.2056 320.45 24.106 319.991 24.106ZM329.213 32.166C328.117 32.166 327.238 31.7676 326.573 30.9707C325.915 30.1683 325.586 28.9868 325.586 27.4263C325.586 25.8491 325.92 24.6566 326.59 23.8486C327.265 23.0407 328.153 22.6367 329.255 22.6367C329.719 22.6367 330.126 22.7004 330.475 22.8276C330.823 22.9494 331.122 23.1154 331.371 23.3257C331.626 23.536 331.842 23.7712 332.019 24.0312H332.11C332.082 23.8597 332.049 23.6134 332.01 23.2925C331.977 22.966 331.961 22.6644 331.961 22.3877V19.084H333.92V32H332.392L332.044 30.7466H331.961C331.795 31.0122 331.584 31.2529 331.33 31.4688C331.081 31.679 330.782 31.8478 330.433 31.9751C330.09 32.1024 329.684 32.166 329.213 32.166ZM329.761 30.5806C330.597 30.5806 331.186 30.3398 331.529 29.8584C331.872 29.377 332.049 28.6548 332.06 27.6919V27.4346C332.06 26.4053 331.894 25.6167 331.562 25.0688C331.23 24.5155 330.624 24.2388 329.744 24.2388C329.042 24.2388 328.505 24.5238 328.134 25.0938C327.769 25.6582 327.586 26.4468 327.586 27.4595C327.586 28.4722 327.769 29.2469 328.134 29.7837C328.505 30.3149 329.047 30.5806 329.761 30.5806ZM350.862 19.8643V27.7168C350.862 28.5635 350.682 29.3216 350.322 29.9912C349.968 30.6608 349.431 31.1921 348.712 31.585C347.992 31.9723 347.087 32.166 345.997 32.166C344.442 32.166 343.258 31.7593 342.445 30.9458C341.637 30.1268 341.233 29.0394 341.233 27.6836V19.8643H343.225V27.5093C343.225 28.522 343.463 29.269 343.939 29.7505C344.415 30.2319 345.126 30.4727 346.072 30.4727C346.725 30.4727 347.256 30.3592 347.666 30.1323C348.081 29.8999 348.385 29.5623 348.579 29.1196C348.778 28.6714 348.878 28.1318 348.878 27.501V19.8643H350.862ZM359.943 29.377C359.943 29.9801 359.796 30.4893 359.503 30.9043C359.209 31.3193 358.781 31.6348 358.216 31.8506C357.657 32.0609 356.971 32.166 356.157 32.166C355.516 32.166 354.962 32.119 354.497 32.0249C354.038 31.9364 353.604 31.798 353.194 31.6099V29.9248C353.631 30.1296 354.121 30.3066 354.663 30.4561C355.211 30.6055 355.729 30.6802 356.216 30.6802C356.858 30.6802 357.32 30.5806 357.602 30.3813C357.884 30.1766 358.025 29.9054 358.025 29.5679C358.025 29.3687 357.967 29.1916 357.851 29.0366C357.74 28.8761 357.53 28.7129 357.22 28.5469C356.916 28.3753 356.467 28.1706 355.875 27.9326C355.294 27.7002 354.804 27.4678 354.406 27.2354C354.008 27.0029 353.706 26.7235 353.501 26.397C353.296 26.0649 353.194 25.6416 353.194 25.127C353.194 24.3135 353.515 23.6965 354.157 23.2759C354.804 22.8498 355.659 22.6367 356.722 22.6367C357.286 22.6367 357.818 22.6948 358.316 22.811C358.819 22.9217 359.312 23.085 359.793 23.3008L359.179 24.77C358.764 24.5874 358.346 24.438 357.926 24.3218C357.51 24.2 357.087 24.1392 356.656 24.1392C356.152 24.1392 355.767 24.2166 355.502 24.3716C355.242 24.5265 355.112 24.7479 355.112 25.0356C355.112 25.2515 355.175 25.4341 355.302 25.5835C355.43 25.7329 355.648 25.8823 355.958 26.0317C356.274 26.1812 356.711 26.3665 357.27 26.5879C357.818 26.7982 358.291 27.0195 358.689 27.252C359.093 27.4788 359.403 27.7583 359.619 28.0903C359.835 28.4224 359.943 28.8512 359.943 29.377ZM365.712 22.6367C366.531 22.6367 367.233 22.8055 367.82 23.1431C368.407 23.4806 368.858 23.9593 369.173 24.5791C369.489 25.1989 369.646 25.9404 369.646 26.8037V27.8496H363.512C363.534 28.7406 363.772 29.4268 364.226 29.9082C364.685 30.3896 365.327 30.6304 366.152 30.6304C366.738 30.6304 367.264 30.575 367.729 30.4644C368.199 30.3481 368.683 30.1794 369.181 29.958V31.5435C368.722 31.7593 368.254 31.917 367.779 32.0166C367.303 32.1162 366.733 32.166 366.069 32.166C365.167 32.166 364.372 31.9917 363.686 31.6431C363.006 31.2889 362.472 30.7632 362.084 30.0659C361.702 29.3687 361.511 28.5026 361.511 27.4678C361.511 26.4385 361.686 25.5641 362.034 24.8447C362.383 24.1253 362.873 23.5775 363.504 23.2012C364.135 22.8249 364.871 22.6367 365.712 22.6367ZM365.712 24.106C365.097 24.106 364.599 24.3052 364.218 24.7036C363.841 25.1021 363.62 25.6859 363.553 26.4551H367.737C367.732 25.9958 367.654 25.589 367.505 25.2349C367.361 24.8807 367.139 24.604 366.841 24.4048C366.547 24.2056 366.171 24.106 365.712 24.106ZM376.503 22.6367C376.658 22.6367 376.826 22.645 377.009 22.6616C377.192 22.6782 377.349 22.7004 377.482 22.728L377.3 24.5542C377.183 24.521 377.039 24.4961 376.868 24.4795C376.702 24.4629 376.552 24.4546 376.42 24.4546C376.071 24.4546 375.739 24.5127 375.424 24.6289C375.108 24.7396 374.829 24.9111 374.585 25.1436C374.342 25.3704 374.151 25.6554 374.012 25.9985C373.874 26.3416 373.805 26.7401 373.805 27.1938V32H371.846V22.811H373.373L373.639 24.4297H373.73C373.913 24.1032 374.14 23.8044 374.411 23.5332C374.682 23.262 374.992 23.0462 375.341 22.8857C375.695 22.7197 376.082 22.6367 376.503 22.6367ZM388.697 25.4092H393.229V31.502C392.592 31.7122 391.934 31.8755 391.253 31.9917C390.573 32.1079 389.809 32.166 388.962 32.166C387.728 32.166 386.682 31.9225 385.824 31.4355C384.972 30.943 384.325 30.2319 383.882 29.3022C383.439 28.367 383.218 27.2409 383.218 25.9238C383.218 24.6566 383.464 23.5581 383.957 22.6284C384.449 21.6932 385.166 20.971 386.107 20.4619C387.047 19.9473 388.187 19.6899 389.527 19.6899C390.185 19.6899 390.822 19.7563 391.436 19.8892C392.056 20.0164 392.623 20.1935 393.137 20.4204L392.44 22.064C392.031 21.8703 391.571 21.707 391.062 21.5742C390.553 21.4414 390.025 21.375 389.477 21.375C388.608 21.375 387.858 21.5632 387.227 21.9395C386.602 22.3158 386.121 22.847 385.783 23.5332C385.445 24.2139 385.277 25.019 385.277 25.9487C385.277 26.8507 385.412 27.6421 385.683 28.3228C385.955 29.0034 386.378 29.5347 386.953 29.9165C387.534 30.2928 388.284 30.481 389.203 30.481C389.662 30.481 390.052 30.4561 390.373 30.4062C390.694 30.3564 390.99 30.3011 391.261 30.2402V27.1108H388.697V25.4092ZM400.592 22.6367C400.747 22.6367 400.915 22.645 401.098 22.6616C401.281 22.6782 401.438 22.7004 401.571 22.728L401.388 24.5542C401.272 24.521 401.128 24.4961 400.957 24.4795C400.791 24.4629 400.641 24.4546 400.509 24.4546C400.16 24.4546 399.828 24.5127 399.512 24.6289C399.197 24.7396 398.918 24.9111 398.674 25.1436C398.431 25.3704 398.24 25.6554 398.101 25.9985C397.963 26.3416 397.894 26.7401 397.894 27.1938V32H395.935V22.811H397.462L397.728 24.4297H397.819C398.002 24.1032 398.229 23.8044 398.5 23.5332C398.771 23.262 399.081 23.0462 399.429 22.8857C399.784 22.7197 400.171 22.6367 400.592 22.6367ZM411.407 27.3848C411.407 28.1484 411.308 28.8263 411.109 29.4185C410.909 30.0106 410.619 30.5114 410.237 30.9209C409.855 31.3249 409.396 31.6348 408.859 31.8506C408.322 32.0609 407.716 32.166 407.041 32.166C406.41 32.166 405.832 32.0609 405.306 31.8506C404.781 31.6348 404.324 31.3249 403.937 30.9209C403.555 30.5114 403.259 30.0106 403.049 29.4185C402.838 28.8263 402.733 28.1484 402.733 27.3848C402.733 26.3721 402.907 25.5143 403.256 24.8115C403.61 24.1032 404.114 23.5636 404.767 23.1929C405.42 22.8221 406.197 22.6367 407.099 22.6367C407.946 22.6367 408.693 22.8221 409.341 23.1929C409.988 23.5636 410.494 24.1032 410.86 24.8115C411.225 25.5199 411.407 26.3776 411.407 27.3848ZM404.742 27.3848C404.742 28.0544 404.822 28.6271 404.983 29.103C405.149 29.5789 405.403 29.9442 405.746 30.1987C406.089 30.4478 406.532 30.5723 407.074 30.5723C407.617 30.5723 408.059 30.4478 408.403 30.1987C408.746 29.9442 408.997 29.5789 409.158 29.103C409.318 28.6271 409.399 28.0544 409.399 27.3848C409.399 26.7152 409.318 26.1479 409.158 25.6831C408.997 25.2127 408.746 24.8558 408.403 24.6123C408.059 24.3633 407.614 24.2388 407.066 24.2388C406.258 24.2388 405.669 24.5099 405.298 25.0522C404.927 25.5946 404.742 26.3721 404.742 27.3848ZM421.659 22.811V32H420.123L419.858 30.7632H419.75C419.556 31.0786 419.31 31.3415 419.011 31.5518C418.712 31.7565 418.38 31.9087 418.015 32.0083C417.65 32.1134 417.265 32.166 416.861 32.166C416.169 32.166 415.577 32.0498 415.085 31.8174C414.598 31.5794 414.224 31.2142 413.964 30.7217C413.704 30.2292 413.574 29.5928 413.574 28.8125V22.811H415.533V28.4473C415.533 29.1611 415.677 29.6951 415.965 30.0493C416.258 30.4035 416.712 30.5806 417.326 30.5806C417.918 30.5806 418.388 30.4588 418.737 30.2153C419.086 29.9718 419.332 29.6121 419.476 29.1362C419.625 28.6603 419.7 28.0765 419.7 27.3848V22.811H421.659ZM429.171 22.6367C430.261 22.6367 431.136 23.0352 431.794 23.832C432.458 24.6289 432.79 25.8132 432.79 27.3848C432.79 28.4251 432.635 29.3022 432.325 30.0161C432.021 30.7244 431.592 31.2612 431.039 31.6265C430.491 31.9862 429.852 32.166 429.121 32.166C428.656 32.166 428.253 32.1051 427.909 31.9834C427.566 31.8617 427.273 31.7039 427.03 31.5103C426.786 31.311 426.581 31.0952 426.415 30.8628H426.299C426.327 31.0841 426.352 31.3304 426.374 31.6016C426.401 31.8672 426.415 32.1107 426.415 32.332V36.0757H424.456V22.811H426.05L426.324 24.0811H426.415C426.587 23.821 426.794 23.5802 427.038 23.3589C427.287 23.1375 427.586 22.9632 427.934 22.8359C428.288 22.7031 428.701 22.6367 429.171 22.6367ZM428.648 24.2305C428.111 24.2305 427.68 24.3384 427.353 24.5542C427.032 24.7645 426.797 25.0827 426.648 25.5088C426.504 25.9349 426.426 26.4689 426.415 27.1108V27.3848C426.415 28.0654 426.484 28.6437 426.623 29.1196C426.767 29.59 427.002 29.9497 427.328 30.1987C427.66 30.4422 428.109 30.564 428.673 30.564C429.149 30.564 429.542 30.4339 429.852 30.1738C430.167 29.9137 430.402 29.543 430.557 29.0615C430.712 28.5801 430.79 28.0129 430.79 27.3599C430.79 26.3693 430.613 25.6001 430.259 25.0522C429.91 24.5044 429.373 24.2305 428.648 24.2305ZM441.224 29.377C441.224 29.9801 441.077 30.4893 440.784 30.9043C440.491 31.3193 440.062 31.6348 439.497 31.8506C438.938 32.0609 438.252 32.166 437.439 32.166C436.797 32.166 436.243 32.119 435.779 32.0249C435.319 31.9364 434.885 31.798 434.475 31.6099V29.9248C434.913 30.1296 435.402 30.3066 435.945 30.4561C436.492 30.6055 437.01 30.6802 437.497 30.6802C438.139 30.6802 438.601 30.5806 438.883 30.3813C439.165 30.1766 439.306 29.9054 439.306 29.5679C439.306 29.3687 439.248 29.1916 439.132 29.0366C439.021 28.8761 438.811 28.7129 438.501 28.5469C438.197 28.3753 437.749 28.1706 437.156 27.9326C436.575 27.7002 436.086 27.4678 435.687 27.2354C435.289 27.0029 434.987 26.7235 434.782 26.397C434.578 26.0649 434.475 25.6416 434.475 25.127C434.475 24.3135 434.796 23.6965 435.438 23.2759C436.086 22.8498 436.941 22.6367 438.003 22.6367C438.568 22.6367 439.099 22.6948 439.597 22.811C440.101 22.9217 440.593 23.085 441.074 23.3008L440.46 24.77C440.045 24.5874 439.627 24.438 439.207 24.3218C438.792 24.2 438.368 24.1392 437.937 24.1392C437.433 24.1392 437.049 24.2166 436.783 24.3716C436.523 24.5265 436.393 24.7479 436.393 25.0356C436.393 25.2515 436.456 25.4341 436.584 25.5835C436.711 25.7329 436.93 25.8823 437.24 26.0317C437.555 26.1812 437.992 26.3665 438.551 26.5879C439.099 26.7982 439.572 27.0195 439.97 27.252C440.374 27.4788 440.684 27.7583 440.9 28.0903C441.116 28.4224 441.224 28.8512 441.224 29.377Z"
      fill="black"
    />
    <rect
      width="250.143"
      height="50"
      transform="translate(500.286)"
      fill="white"
    />
    <path
      d="M521.4 32L520.213 28.6299H515.573L514.386 32H512.286L516.801 19.8145H519.009L523.517 32H521.4ZM519.698 26.9199L518.544 23.5996C518.5 23.4557 518.437 23.2537 518.354 22.9937C518.271 22.728 518.188 22.4596 518.104 22.1885C518.021 21.9118 517.952 21.6794 517.897 21.4912C517.842 21.7181 517.772 21.9727 517.689 22.2549C517.612 22.5316 517.535 22.7917 517.457 23.0352C517.385 23.2786 517.33 23.4668 517.291 23.5996L516.129 26.9199H519.698ZM528.007 32.166C526.912 32.166 526.032 31.7676 525.368 30.9707C524.709 30.1683 524.38 28.9868 524.38 27.4263C524.38 25.8491 524.715 24.6566 525.384 23.8486C526.059 23.0407 526.948 22.6367 528.049 22.6367C528.514 22.6367 528.92 22.7004 529.269 22.8276C529.618 22.9494 529.917 23.1154 530.166 23.3257C530.42 23.536 530.636 23.7712 530.813 24.0312H530.904C530.877 23.8597 530.843 23.6134 530.805 23.2925C530.771 22.966 530.755 22.6644 530.755 22.3877V19.084H532.714V32H531.187L530.838 30.7466H530.755C530.589 31.0122 530.379 31.2529 530.124 31.4688C529.875 31.679 529.576 31.8478 529.228 31.9751C528.884 32.1024 528.478 32.166 528.007 32.166ZM528.555 30.5806C529.391 30.5806 529.98 30.3398 530.323 29.8584C530.666 29.377 530.843 28.6548 530.854 27.6919V27.4346C530.854 26.4053 530.688 25.6167 530.356 25.0688C530.024 24.5155 529.418 24.2388 528.539 24.2388C527.836 24.2388 527.299 24.5238 526.928 25.0938C526.563 25.6582 526.38 26.4468 526.38 27.4595C526.38 28.4722 526.563 29.2469 526.928 29.7837C527.299 30.3149 527.841 30.5806 528.555 30.5806ZM545.896 22.6367C546.925 22.6367 547.7 22.9023 548.22 23.4336C548.745 23.9648 549.008 24.8171 549.008 25.9902V32H547.058V26.3389C547.058 25.6416 546.922 25.1159 546.651 24.7617C546.38 24.4076 545.967 24.2305 545.414 24.2305C544.639 24.2305 544.08 24.4795 543.737 24.9775C543.4 25.4701 543.231 26.1867 543.231 27.1274V32H541.28V26.3389C541.28 25.874 541.219 25.4867 541.098 25.1768C540.981 24.8613 540.802 24.6261 540.558 24.4712C540.315 24.3107 540.007 24.2305 539.637 24.2305C539.1 24.2305 538.671 24.3522 538.35 24.5957C538.035 24.8392 537.808 25.1989 537.669 25.6748C537.531 26.1452 537.462 26.7235 537.462 27.4097V32H535.511V22.811H537.03L537.304 24.0479H537.412C537.6 23.7269 537.833 23.464 538.109 23.2593C538.392 23.049 538.704 22.894 539.047 22.7944C539.39 22.6893 539.747 22.6367 540.118 22.6367C540.804 22.6367 541.383 22.7585 541.853 23.002C542.323 23.2399 542.675 23.6051 542.907 24.0977H543.057C543.344 23.5996 543.746 23.2316 544.26 22.9937C544.775 22.7557 545.32 22.6367 545.896 22.6367ZM553.682 22.811V32H551.731V22.811H553.682ZM552.719 19.2915C553.018 19.2915 553.275 19.3717 553.491 19.5322C553.712 19.6927 553.823 19.9694 553.823 20.3623C553.823 20.7497 553.712 21.0264 553.491 21.1924C553.275 21.3529 553.018 21.4331 552.719 21.4331C552.409 21.4331 552.146 21.3529 551.93 21.1924C551.72 21.0264 551.615 20.7497 551.615 20.3623C551.615 19.9694 551.72 19.6927 551.93 19.5322C552.146 19.3717 552.409 19.2915 552.719 19.2915ZM561.269 22.6367C562.303 22.6367 563.109 22.9051 563.684 23.4419C564.265 23.9731 564.556 24.8281 564.556 26.0068V32H562.605V26.3721C562.605 25.6582 562.458 25.1242 562.165 24.77C561.872 24.4103 561.418 24.2305 560.804 24.2305C559.913 24.2305 559.293 24.5044 558.944 25.0522C558.601 25.6001 558.43 26.3942 558.43 27.4346V32H556.479V22.811H557.998L558.272 24.0562H558.38C558.579 23.7352 558.825 23.4723 559.119 23.2676C559.417 23.0573 559.75 22.8996 560.115 22.7944C560.486 22.6893 560.87 22.6367 561.269 22.6367Z"
      fill="black"
    />
    <rect
      width="250.143"
      height="50"
      transform="translate(750.429)"
      fill="white"
    />
    <path
      d="M769.194 21.3833C768.613 21.3833 768.093 21.4884 767.633 21.6987C767.18 21.909 766.795 22.2134 766.479 22.6118C766.164 23.0047 765.923 23.4834 765.757 24.0479C765.591 24.6068 765.508 25.2376 765.508 25.9404C765.508 26.8812 765.641 27.6919 765.907 28.3726C766.172 29.0477 766.576 29.5679 767.119 29.9331C767.661 30.2928 768.347 30.4727 769.177 30.4727C769.692 30.4727 770.193 30.4229 770.68 30.3232C771.167 30.2236 771.67 30.0881 772.19 29.9165V31.6099C771.698 31.8035 771.2 31.9447 770.696 32.0332C770.193 32.1217 769.612 32.166 768.953 32.166C767.714 32.166 766.684 31.9087 765.865 31.394C765.052 30.8794 764.443 30.1545 764.039 29.2192C763.641 28.284 763.441 27.1883 763.441 25.9321C763.441 25.0135 763.569 24.1724 763.823 23.4087C764.078 22.645 764.449 21.9865 764.936 21.4331C765.423 20.8742 766.023 20.4453 766.737 20.1465C767.456 19.8421 768.278 19.6899 769.202 19.6899C769.811 19.6899 770.409 19.7591 770.995 19.8975C771.587 20.0303 772.135 20.2212 772.639 20.4702L771.941 22.1138C771.521 21.9146 771.081 21.743 770.622 21.5991C770.162 21.4552 769.686 21.3833 769.194 21.3833ZM778.2 22.6367C779.362 22.6367 780.239 22.894 780.832 23.4087C781.429 23.9233 781.728 24.7257 781.728 25.8159V32H780.342L779.968 30.6968H779.902C779.642 31.0288 779.373 31.3027 779.097 31.5186C778.82 31.7344 778.499 31.8949 778.134 32C777.774 32.1107 777.334 32.166 776.814 32.166C776.266 32.166 775.776 32.0664 775.345 31.8672C774.913 31.6624 774.573 31.3525 774.324 30.9375C774.075 30.5225 773.95 29.9967 773.95 29.3604C773.95 28.4141 774.302 27.703 775.004 27.2271C775.713 26.7511 776.781 26.4883 778.208 26.4385L779.802 26.3804V25.8989C779.802 25.2625 779.653 24.8088 779.354 24.5376C779.061 24.2664 778.646 24.1309 778.109 24.1309C777.65 24.1309 777.204 24.1973 776.772 24.3301C776.341 24.4629 775.92 24.6261 775.511 24.8198L774.88 23.4419C775.328 23.2039 775.837 23.0103 776.407 22.8608C776.983 22.7114 777.58 22.6367 778.2 22.6367ZM779.794 27.6089L778.607 27.6504C777.633 27.6836 776.95 27.8496 776.557 28.1484C776.164 28.4473 775.967 28.8568 775.967 29.377C775.967 29.8307 776.103 30.1628 776.374 30.373C776.645 30.5778 777.002 30.6802 777.445 30.6802C778.12 30.6802 778.679 30.4893 779.122 30.1074C779.57 29.7201 779.794 29.1528 779.794 28.4058V27.6089ZM787.879 30.5889C788.133 30.5889 788.385 30.5667 788.634 30.5225C788.883 30.4727 789.11 30.4146 789.315 30.3481V31.8257C789.099 31.9198 788.82 32 788.477 32.0664C788.133 32.1328 787.777 32.166 787.406 32.166C786.886 32.166 786.418 32.0802 786.003 31.9087C785.588 31.7316 785.259 31.43 785.015 31.0039C784.772 30.5778 784.65 29.9884 784.65 29.2358V24.2969H783.396V23.4253L784.741 22.7363L785.38 20.769H786.609V22.811H789.24V24.2969H786.609V29.2109C786.609 29.6758 786.725 30.0216 786.958 30.2485C787.19 30.4754 787.497 30.5889 787.879 30.5889ZM794.785 22.6367C795.947 22.6367 796.824 22.894 797.417 23.4087C798.014 23.9233 798.313 24.7257 798.313 25.8159V32H796.927L796.553 30.6968H796.487C796.227 31.0288 795.958 31.3027 795.682 31.5186C795.405 31.7344 795.084 31.8949 794.719 32C794.359 32.1107 793.919 32.166 793.399 32.166C792.851 32.166 792.361 32.0664 791.93 31.8672C791.498 31.6624 791.158 31.3525 790.909 30.9375C790.66 30.5225 790.535 29.9967 790.535 29.3604C790.535 28.4141 790.887 27.703 791.589 27.2271C792.298 26.7511 793.366 26.4883 794.793 26.4385L796.387 26.3804V25.8989C796.387 25.2625 796.238 24.8088 795.939 24.5376C795.646 24.2664 795.231 24.1309 794.694 24.1309C794.235 24.1309 793.789 24.1973 793.357 24.3301C792.926 24.4629 792.505 24.6261 792.096 24.8198L791.465 23.4419C791.913 23.2039 792.422 23.0103 792.992 22.8608C793.568 22.7114 794.165 22.6367 794.785 22.6367ZM796.379 27.6089L795.192 27.6504C794.218 27.6836 793.535 27.8496 793.142 28.1484C792.749 28.4473 792.552 28.8568 792.552 29.377C792.552 29.8307 792.688 30.1628 792.959 30.373C793.23 30.5778 793.587 30.6802 794.03 30.6802C794.705 30.6802 795.264 30.4893 795.707 30.1074C796.155 29.7201 796.379 29.1528 796.379 28.4058V27.6089ZM803.003 32H801.044V19.084H803.003V32ZM813.927 27.3848C813.927 28.1484 813.827 28.8263 813.628 29.4185C813.429 30.0106 813.138 30.5114 812.756 30.9209C812.375 31.3249 811.915 31.6348 811.378 31.8506C810.842 32.0609 810.236 32.166 809.561 32.166C808.93 32.166 808.351 32.0609 807.826 31.8506C807.3 31.6348 806.843 31.3249 806.456 30.9209C806.074 30.5114 805.778 30.0106 805.568 29.4185C805.358 28.8263 805.252 28.1484 805.252 27.3848C805.252 26.3721 805.427 25.5143 805.775 24.8115C806.13 24.1032 806.633 23.5636 807.286 23.1929C807.939 22.8221 808.717 22.6367 809.619 22.6367C810.465 22.6367 811.212 22.8221 811.86 23.1929C812.507 23.5636 813.014 24.1032 813.379 24.8115C813.744 25.5199 813.927 26.3776 813.927 27.3848ZM807.261 27.3848C807.261 28.0544 807.341 28.6271 807.502 29.103C807.668 29.5789 807.923 29.9442 808.266 30.1987C808.609 30.4478 809.051 30.5723 809.594 30.5723C810.136 30.5723 810.579 30.4478 810.922 30.1987C811.265 29.9442 811.517 29.5789 811.677 29.103C811.838 28.6271 811.918 28.0544 811.918 27.3848C811.918 26.7152 811.838 26.1479 811.677 25.6831C811.517 25.2127 811.265 24.8558 810.922 24.6123C810.579 24.3633 810.133 24.2388 809.585 24.2388C808.778 24.2388 808.188 24.5099 807.817 25.0522C807.447 25.5946 807.261 26.3721 807.261 27.3848ZM818.791 36.084C817.546 36.084 816.591 35.8599 815.927 35.4116C815.263 34.9634 814.931 34.3353 814.931 33.5273C814.931 32.9629 815.108 32.4842 815.462 32.0913C815.817 31.7039 816.323 31.4355 816.981 31.2861C816.732 31.1755 816.517 31.0039 816.334 30.7715C816.157 30.5335 816.068 30.2707 816.068 29.9829C816.068 29.6398 816.165 29.3465 816.359 29.103C816.553 28.8595 816.843 28.6243 817.23 28.3975C816.749 28.1927 816.362 27.8607 816.068 27.4014C815.781 26.9365 815.637 26.3914 815.637 25.7661C815.637 25.1021 815.778 24.5376 816.06 24.0728C816.342 23.6024 816.755 23.2454 817.297 23.002C817.839 22.7529 818.495 22.6284 819.264 22.6284C819.43 22.6284 819.61 22.6395 819.804 22.6616C820.003 22.6782 820.186 22.7004 820.352 22.728C820.523 22.7502 820.653 22.7751 820.742 22.8027H823.921V23.8901L822.36 24.1807C822.51 24.391 822.629 24.6317 822.717 24.9028C822.806 25.1685 822.85 25.459 822.85 25.7744C822.85 26.7262 822.521 27.4761 821.862 28.0239C821.209 28.5662 820.307 28.8374 819.156 28.8374C818.88 28.8263 818.611 28.8042 818.351 28.771C818.152 28.8927 818 29.0283 817.895 29.1777C817.789 29.3216 817.737 29.4849 817.737 29.6675C817.737 29.8169 817.789 29.9386 817.895 30.0327C818 30.1213 818.155 30.1877 818.359 30.2319C818.57 30.2762 818.824 30.2983 819.123 30.2983H820.708C821.716 30.2983 822.485 30.5114 823.016 30.9375C823.547 31.3636 823.813 31.9889 823.813 32.8135C823.813 33.8594 823.381 34.6646 822.518 35.229C821.655 35.799 820.412 36.084 818.791 36.084ZM818.866 34.7144C819.546 34.7144 820.119 34.6479 820.584 34.5151C821.049 34.3823 821.4 34.1914 821.638 33.9424C821.876 33.6989 821.995 33.4084 821.995 33.0708C821.995 32.772 821.92 32.5423 821.771 32.3818C821.622 32.2214 821.397 32.1107 821.099 32.0498C820.8 31.9889 820.429 31.9585 819.986 31.9585H818.542C818.182 31.9585 817.864 32.0138 817.587 32.1245C817.311 32.2407 817.095 32.4067 816.94 32.6226C816.791 32.8384 816.716 33.0985 816.716 33.4028C816.716 33.8234 816.901 34.1471 817.272 34.374C817.648 34.6009 818.18 34.7144 818.866 34.7144ZM819.248 27.5591C819.818 27.5591 820.241 27.4041 820.518 27.0942C820.794 26.7788 820.933 26.3361 820.933 25.7661C820.933 25.1463 820.789 24.6815 820.501 24.3716C820.219 24.0617 819.798 23.9067 819.239 23.9067C818.691 23.9067 818.274 24.0645 817.986 24.3799C817.704 24.6953 817.562 25.1629 817.562 25.7827C817.562 26.3416 817.704 26.7788 817.986 27.0942C818.274 27.4041 818.694 27.5591 819.248 27.5591Z"
      fill="black"
    />
    <rect
      width="250.143"
      height="50"
      transform="translate(1000.57)"
      fill="white"
    />
    <path
      d="M1019.06 25.4092H1023.59V31.502C1022.96 31.7122 1022.3 31.8755 1021.62 31.9917C1020.94 32.1079 1020.18 32.166 1019.33 32.166C1018.09 32.166 1017.05 31.9225 1016.19 31.4355C1015.34 30.943 1014.69 30.2319 1014.25 29.3022C1013.81 28.367 1013.58 27.2409 1013.58 25.9238C1013.58 24.6566 1013.83 23.5581 1014.32 22.6284C1014.82 21.6932 1015.53 20.971 1016.47 20.4619C1017.41 19.9473 1018.55 19.6899 1019.89 19.6899C1020.55 19.6899 1021.19 19.7563 1021.8 19.8892C1022.42 20.0164 1022.99 20.1935 1023.5 20.4204L1022.81 22.064C1022.4 21.8703 1021.94 21.707 1021.43 21.5742C1020.92 21.4414 1020.39 21.375 1019.84 21.375C1018.97 21.375 1018.22 21.5632 1017.59 21.9395C1016.97 22.3158 1016.49 22.847 1016.15 23.5332C1015.81 24.2139 1015.64 25.019 1015.64 25.9487C1015.64 26.8507 1015.78 27.6421 1016.05 28.3228C1016.32 29.0034 1016.74 29.5347 1017.32 29.9165C1017.9 30.2928 1018.65 30.481 1019.57 30.481C1020.03 30.481 1020.42 30.4561 1020.74 30.4062C1021.06 30.3564 1021.36 30.3011 1021.63 30.2402V27.1108H1019.06V25.4092ZM1028.26 32H1026.3V19.084H1028.26V32ZM1039.18 27.3848C1039.18 28.1484 1039.08 28.8263 1038.89 29.4185C1038.69 30.0106 1038.4 30.5114 1038.01 30.9209C1037.63 31.3249 1037.17 31.6348 1036.64 31.8506C1036.1 32.0609 1035.49 32.166 1034.82 32.166C1034.19 32.166 1033.61 32.0609 1033.08 31.8506C1032.56 31.6348 1032.1 31.3249 1031.71 30.9209C1031.33 30.5114 1031.04 30.0106 1030.82 29.4185C1030.61 28.8263 1030.51 28.1484 1030.51 27.3848C1030.51 26.3721 1030.68 25.5143 1031.03 24.8115C1031.39 24.1032 1031.89 23.5636 1032.54 23.1929C1033.2 22.8221 1033.97 22.6367 1034.88 22.6367C1035.72 22.6367 1036.47 22.8221 1037.12 23.1929C1037.76 23.5636 1038.27 24.1032 1038.64 24.8115C1039 25.5199 1039.18 26.3776 1039.18 27.3848ZM1032.52 27.3848C1032.52 28.0544 1032.6 28.6271 1032.76 29.103C1032.93 29.5789 1033.18 29.9442 1033.52 30.1987C1033.87 30.4478 1034.31 30.5723 1034.85 30.5723C1035.39 30.5723 1035.84 30.4478 1036.18 30.1987C1036.52 29.9442 1036.77 29.5789 1036.93 29.103C1037.09 28.6271 1037.18 28.0544 1037.18 27.3848C1037.18 26.7152 1037.09 26.1479 1036.93 25.6831C1036.77 25.2127 1036.52 24.8558 1036.18 24.6123C1035.84 24.3633 1035.39 24.2388 1034.84 24.2388C1034.03 24.2388 1033.45 24.5099 1033.07 25.0522C1032.7 25.5946 1032.52 26.3721 1032.52 27.3848ZM1047.6 29.377C1047.6 29.9801 1047.45 30.4893 1047.16 30.9043C1046.87 31.3193 1046.44 31.6348 1045.87 31.8506C1045.32 32.0609 1044.63 32.166 1043.82 32.166C1043.17 32.166 1042.62 32.119 1042.16 32.0249C1041.7 31.9364 1041.26 31.798 1040.85 31.6099V29.9248C1041.29 30.1296 1041.78 30.3066 1042.32 30.4561C1042.87 30.6055 1043.39 30.6802 1043.87 30.6802C1044.52 30.6802 1044.98 30.5806 1045.26 30.3813C1045.54 30.1766 1045.68 29.9054 1045.68 29.5679C1045.68 29.3687 1045.63 29.1916 1045.51 29.0366C1045.4 28.8761 1045.19 28.7129 1044.88 28.5469C1044.57 28.3753 1044.13 28.1706 1043.53 27.9326C1042.95 27.7002 1042.46 27.4678 1042.06 27.2354C1041.67 27.0029 1041.36 26.7235 1041.16 26.397C1040.95 26.0649 1040.85 25.6416 1040.85 25.127C1040.85 24.3135 1041.17 23.6965 1041.82 23.2759C1042.46 22.8498 1043.32 22.6367 1044.38 22.6367C1044.94 22.6367 1045.48 22.6948 1045.97 22.811C1046.48 22.9217 1046.97 23.085 1047.45 23.3008L1046.84 24.77C1046.42 24.5874 1046 24.438 1045.58 24.3218C1045.17 24.2 1044.75 24.1392 1044.31 24.1392C1043.81 24.1392 1043.43 24.2166 1043.16 24.3716C1042.9 24.5265 1042.77 24.7479 1042.77 25.0356C1042.77 25.2515 1042.83 25.4341 1042.96 25.5835C1043.09 25.7329 1043.31 25.8823 1043.62 26.0317C1043.93 26.1812 1044.37 26.3665 1044.93 26.5879C1045.48 26.7982 1045.95 27.0195 1046.35 27.252C1046.75 27.4788 1047.06 27.7583 1047.28 28.0903C1047.49 28.4224 1047.6 28.8512 1047.6 29.377ZM1055.89 29.377C1055.89 29.9801 1055.74 30.4893 1055.45 30.9043C1055.15 31.3193 1054.72 31.6348 1054.16 31.8506C1053.6 32.0609 1052.91 32.166 1052.1 32.166C1051.46 32.166 1050.9 32.119 1050.44 32.0249C1049.98 31.9364 1049.55 31.798 1049.14 31.6099V29.9248C1049.57 30.1296 1050.06 30.3066 1050.61 30.4561C1051.15 30.6055 1051.67 30.6802 1052.16 30.6802C1052.8 30.6802 1053.26 30.5806 1053.54 30.3813C1053.83 30.1766 1053.97 29.9054 1053.97 29.5679C1053.97 29.3687 1053.91 29.1916 1053.79 29.0366C1053.68 28.8761 1053.47 28.7129 1053.16 28.5469C1052.86 28.3753 1052.41 28.1706 1051.82 27.9326C1051.24 27.7002 1050.75 27.4678 1050.35 27.2354C1049.95 27.0029 1049.65 26.7235 1049.44 26.397C1049.24 26.0649 1049.14 25.6416 1049.14 25.127C1049.14 24.3135 1049.46 23.6965 1050.1 23.2759C1050.75 22.8498 1051.6 22.6367 1052.66 22.6367C1053.23 22.6367 1053.76 22.6948 1054.26 22.811C1054.76 22.9217 1055.25 23.085 1055.74 23.3008L1055.12 24.77C1054.71 24.5874 1054.29 24.438 1053.87 24.3218C1053.45 24.2 1053.03 24.1392 1052.6 24.1392C1052.09 24.1392 1051.71 24.2166 1051.44 24.3716C1051.18 24.5265 1051.05 24.7479 1051.05 25.0356C1051.05 25.2515 1051.12 25.4341 1051.24 25.5835C1051.37 25.7329 1051.59 25.8823 1051.9 26.0317C1052.22 26.1812 1052.65 26.3665 1053.21 26.5879C1053.76 26.7982 1054.23 27.0195 1054.63 27.252C1055.04 27.4788 1055.35 27.7583 1055.56 28.0903C1055.78 28.4224 1055.89 28.8512 1055.89 29.377ZM1061.6 22.6367C1062.76 22.6367 1063.64 22.894 1064.23 23.4087C1064.82 23.9233 1065.12 24.7257 1065.12 25.8159V32H1063.74L1063.36 30.6968H1063.3C1063.04 31.0288 1062.77 31.3027 1062.49 31.5186C1062.22 31.7344 1061.89 31.8949 1061.53 32C1061.17 32.1107 1060.73 32.166 1060.21 32.166C1059.66 32.166 1059.17 32.0664 1058.74 31.8672C1058.31 31.6624 1057.97 31.3525 1057.72 30.9375C1057.47 30.5225 1057.35 29.9967 1057.35 29.3604C1057.35 28.4141 1057.7 27.703 1058.4 27.2271C1059.11 26.7511 1060.18 26.4883 1061.6 26.4385L1063.2 26.3804V25.8989C1063.2 25.2625 1063.05 24.8088 1062.75 24.5376C1062.46 24.2664 1062.04 24.1309 1061.5 24.1309C1061.05 24.1309 1060.6 24.1973 1060.17 24.3301C1059.74 24.4629 1059.32 24.6261 1058.91 24.8198L1058.28 23.4419C1058.72 23.2039 1059.23 23.0103 1059.8 22.8608C1060.38 22.7114 1060.98 22.6367 1061.6 22.6367ZM1063.19 27.6089L1062 27.6504C1061.03 27.6836 1060.35 27.8496 1059.95 28.1484C1059.56 28.4473 1059.36 28.8568 1059.36 29.377C1059.36 29.8307 1059.5 30.1628 1059.77 30.373C1060.04 30.5778 1060.4 30.6802 1060.84 30.6802C1061.52 30.6802 1062.07 30.4893 1062.52 30.1074C1062.97 29.7201 1063.19 29.1528 1063.19 28.4058V27.6089ZM1072.51 22.6367C1072.67 22.6367 1072.84 22.645 1073.02 22.6616C1073.2 22.6782 1073.36 22.7004 1073.49 22.728L1073.31 24.5542C1073.19 24.521 1073.05 24.4961 1072.88 24.4795C1072.71 24.4629 1072.56 24.4546 1072.43 24.4546C1072.08 24.4546 1071.75 24.5127 1071.43 24.6289C1071.12 24.7396 1070.84 24.9111 1070.59 25.1436C1070.35 25.3704 1070.16 25.6554 1070.02 25.9985C1069.88 26.3416 1069.81 26.7401 1069.81 27.1938V32H1067.85V22.811H1069.38L1069.65 24.4297H1069.74C1069.92 24.1032 1070.15 23.8044 1070.42 23.5332C1070.69 23.262 1071 23.0462 1071.35 22.8857C1071.7 22.7197 1072.09 22.6367 1072.51 22.6367ZM1073.81 22.811H1075.93L1077.82 28.0571C1077.9 28.2951 1077.97 28.5303 1078.04 28.7627C1078.11 28.9896 1078.17 29.2137 1078.22 29.4351C1078.28 29.6564 1078.32 29.8778 1078.36 30.0991H1078.41C1078.46 29.8114 1078.54 29.4904 1078.64 29.1362C1078.74 28.7765 1078.86 28.4168 1078.99 28.0571L1080.8 22.811H1082.9L1078.95 33.2617C1078.73 33.8594 1078.45 34.3685 1078.11 34.7891C1077.79 35.2152 1077.4 35.5361 1076.95 35.752C1076.5 35.9733 1075.99 36.084 1075.42 36.084C1075.14 36.084 1074.9 36.0674 1074.69 36.0342C1074.49 36.0065 1074.32 35.9761 1074.17 35.9429V34.3823C1074.29 34.41 1074.43 34.4349 1074.61 34.457C1074.79 34.4792 1074.97 34.4902 1075.16 34.4902C1075.51 34.4902 1075.81 34.4211 1076.06 34.2827C1076.32 34.1444 1076.53 33.9479 1076.71 33.6934C1076.89 33.4443 1077.04 33.1593 1077.15 32.8384L1077.48 31.9751L1073.81 22.811Z"
      fill="black"
    />
    <rect
      width="250.143"
      height="50"
      transform="translate(1250.71)"
      fill="white"
    />
    <path
      d="M1264.31 32V19.8643H1266.3V30.3066H1271.46V32H1264.31ZM1275.31 22.811V32H1273.36V22.811H1275.31ZM1274.34 19.2915C1274.64 19.2915 1274.9 19.3717 1275.12 19.5322C1275.34 19.6927 1275.45 19.9694 1275.45 20.3623C1275.45 20.7497 1275.34 21.0264 1275.12 21.1924C1274.9 21.3529 1274.64 21.4331 1274.34 21.4331C1274.03 21.4331 1273.77 21.3529 1273.56 21.1924C1273.34 21.0264 1273.24 20.7497 1273.24 20.3623C1273.24 19.9694 1273.34 19.6927 1273.56 19.5322C1273.77 19.3717 1274.03 19.2915 1274.34 19.2915ZM1282.89 22.6367C1283.93 22.6367 1284.73 22.9051 1285.31 23.4419C1285.89 23.9731 1286.18 24.8281 1286.18 26.0068V32H1284.23V26.3721C1284.23 25.6582 1284.08 25.1242 1283.79 24.77C1283.5 24.4103 1283.04 24.2305 1282.43 24.2305C1281.54 24.2305 1280.92 24.5044 1280.57 25.0522C1280.23 25.6001 1280.05 26.3942 1280.05 27.4346V32H1278.1V22.811H1279.62L1279.9 24.0562H1280C1280.2 23.7352 1280.45 23.4723 1280.74 23.2676C1281.04 23.0573 1281.37 22.8996 1281.74 22.7944C1282.11 22.6893 1282.5 22.6367 1282.89 22.6367ZM1292.57 22.6367C1293.39 22.6367 1294.09 22.8055 1294.68 23.1431C1295.27 23.4806 1295.72 23.9593 1296.03 24.5791C1296.35 25.1989 1296.51 25.9404 1296.51 26.8037V27.8496H1290.37C1290.39 28.7406 1290.63 29.4268 1291.09 29.9082C1291.55 30.3896 1292.19 30.6304 1293.01 30.6304C1293.6 30.6304 1294.12 30.575 1294.59 30.4644C1295.06 30.3481 1295.54 30.1794 1296.04 29.958V31.5435C1295.58 31.7593 1295.12 31.917 1294.64 32.0166C1294.16 32.1162 1293.59 32.166 1292.93 32.166C1292.03 32.166 1291.23 31.9917 1290.55 31.6431C1289.87 31.2889 1289.33 30.7632 1288.94 30.0659C1288.56 29.3687 1288.37 28.5026 1288.37 27.4678C1288.37 26.4385 1288.55 25.5641 1288.9 24.8447C1289.24 24.1253 1289.73 23.5775 1290.36 23.2012C1291 22.8249 1291.73 22.6367 1292.57 22.6367ZM1292.57 24.106C1291.96 24.106 1291.46 24.3052 1291.08 24.7036C1290.7 25.1021 1290.48 25.6859 1290.41 26.4551H1294.6C1294.59 25.9958 1294.51 25.589 1294.37 25.2349C1294.22 24.8807 1294 24.604 1293.7 24.4048C1293.41 24.2056 1293.03 24.106 1292.57 24.106ZM1302.31 22.6367C1303.47 22.6367 1304.35 22.894 1304.94 23.4087C1305.54 23.9233 1305.84 24.7257 1305.84 25.8159V32H1304.45L1304.08 30.6968H1304.01C1303.75 31.0288 1303.48 31.3027 1303.21 31.5186C1302.93 31.7344 1302.61 31.8949 1302.24 32C1301.88 32.1107 1301.44 32.166 1300.92 32.166C1300.38 32.166 1299.89 32.0664 1299.45 31.8672C1299.02 31.6624 1298.68 31.3525 1298.43 30.9375C1298.18 30.5225 1298.06 29.9967 1298.06 29.3604C1298.06 28.4141 1298.41 27.703 1299.11 27.2271C1299.82 26.7511 1300.89 26.4883 1302.32 26.4385L1303.91 26.3804V25.8989C1303.91 25.2625 1303.76 24.8088 1303.46 24.5376C1303.17 24.2664 1302.75 24.1309 1302.22 24.1309C1301.76 24.1309 1301.31 24.1973 1300.88 24.3301C1300.45 24.4629 1300.03 24.6261 1299.62 24.8198L1298.99 23.4419C1299.44 23.2039 1299.95 23.0103 1300.52 22.8608C1301.09 22.7114 1301.69 22.6367 1302.31 22.6367ZM1303.9 27.6089L1302.72 27.6504C1301.74 27.6836 1301.06 27.8496 1300.67 28.1484C1300.27 28.4473 1300.08 28.8568 1300.08 29.377C1300.08 29.8307 1300.21 30.1628 1300.48 30.373C1300.75 30.5778 1301.11 30.6802 1301.55 30.6802C1302.23 30.6802 1302.79 30.4893 1303.23 30.1074C1303.68 29.7201 1303.9 29.1528 1303.9 28.4058V27.6089ZM1311.19 36.084C1309.95 36.084 1308.99 35.8599 1308.33 35.4116C1307.66 34.9634 1307.33 34.3353 1307.33 33.5273C1307.33 32.9629 1307.51 32.4842 1307.86 32.0913C1308.22 31.7039 1308.72 31.4355 1309.38 31.2861C1309.13 31.1755 1308.92 31.0039 1308.73 30.7715C1308.56 30.5335 1308.47 30.2707 1308.47 29.9829C1308.47 29.6398 1308.57 29.3465 1308.76 29.103C1308.95 28.8595 1309.24 28.6243 1309.63 28.3975C1309.15 28.1927 1308.76 27.8607 1308.47 27.4014C1308.18 26.9365 1308.04 26.3914 1308.04 25.7661C1308.04 25.1021 1308.18 24.5376 1308.46 24.0728C1308.74 23.6024 1309.15 23.2454 1309.7 23.002C1310.24 22.7529 1310.89 22.6284 1311.66 22.6284C1311.83 22.6284 1312.01 22.6395 1312.2 22.6616C1312.4 22.6782 1312.59 22.7004 1312.75 22.728C1312.92 22.7502 1313.05 22.7751 1313.14 22.8027H1316.32V23.8901L1314.76 24.1807C1314.91 24.391 1315.03 24.6317 1315.12 24.9028C1315.21 25.1685 1315.25 25.459 1315.25 25.7744C1315.25 26.7262 1314.92 27.4761 1314.26 28.0239C1313.61 28.5662 1312.71 28.8374 1311.56 28.8374C1311.28 28.8263 1311.01 28.8042 1310.75 28.771C1310.55 28.8927 1310.4 29.0283 1310.29 29.1777C1310.19 29.3216 1310.14 29.4849 1310.14 29.6675C1310.14 29.8169 1310.19 29.9386 1310.29 30.0327C1310.4 30.1213 1310.55 30.1877 1310.76 30.2319C1310.97 30.2762 1311.22 30.2983 1311.52 30.2983H1313.11C1314.12 30.2983 1314.88 30.5114 1315.42 30.9375C1315.95 31.3636 1316.21 31.9889 1316.21 32.8135C1316.21 33.8594 1315.78 34.6646 1314.92 35.229C1314.05 35.799 1312.81 36.084 1311.19 36.084ZM1311.27 34.7144C1311.95 34.7144 1312.52 34.6479 1312.98 34.5151C1313.45 34.3823 1313.8 34.1914 1314.04 33.9424C1314.28 33.6989 1314.4 33.4084 1314.4 33.0708C1314.4 32.772 1314.32 32.5423 1314.17 32.3818C1314.02 32.2214 1313.8 32.1107 1313.5 32.0498C1313.2 31.9889 1312.83 31.9585 1312.39 31.9585H1310.94C1310.58 31.9585 1310.26 32.0138 1309.99 32.1245C1309.71 32.2407 1309.49 32.4067 1309.34 32.6226C1309.19 32.8384 1309.12 33.0985 1309.12 33.4028C1309.12 33.8234 1309.3 34.1471 1309.67 34.374C1310.05 34.6009 1310.58 34.7144 1311.27 34.7144ZM1311.65 27.5591C1312.22 27.5591 1312.64 27.4041 1312.92 27.0942C1313.19 26.7788 1313.33 26.3361 1313.33 25.7661C1313.33 25.1463 1313.19 24.6815 1312.9 24.3716C1312.62 24.0617 1312.2 23.9067 1311.64 23.9067C1311.09 23.9067 1310.67 24.0645 1310.39 24.3799C1310.1 24.6953 1309.96 25.1629 1309.96 25.7827C1309.96 26.3416 1310.1 26.7788 1310.39 27.0942C1310.67 27.4041 1311.09 27.5591 1311.65 27.5591ZM1321.66 22.6367C1322.48 22.6367 1323.18 22.8055 1323.77 23.1431C1324.35 23.4806 1324.8 23.9593 1325.12 24.5791C1325.44 25.1989 1325.59 25.9404 1325.59 26.8037V27.8496H1319.46C1319.48 28.7406 1319.72 29.4268 1320.17 29.9082C1320.63 30.3896 1321.27 30.6304 1322.1 30.6304C1322.68 30.6304 1323.21 30.575 1323.68 30.4644C1324.15 30.3481 1324.63 30.1794 1325.13 29.958V31.5435C1324.67 31.7593 1324.2 31.917 1323.73 32.0166C1323.25 32.1162 1322.68 32.166 1322.02 32.166C1321.11 32.166 1320.32 31.9917 1319.63 31.6431C1318.95 31.2889 1318.42 30.7632 1318.03 30.0659C1317.65 29.3687 1317.46 28.5026 1317.46 27.4678C1317.46 26.4385 1317.63 25.5641 1317.98 24.8447C1318.33 24.1253 1318.82 23.5775 1319.45 23.2012C1320.08 22.8249 1320.82 22.6367 1321.66 22.6367ZM1321.66 24.106C1321.04 24.106 1320.55 24.3052 1320.16 24.7036C1319.79 25.1021 1319.57 25.6859 1319.5 26.4551H1323.68C1323.68 25.9958 1323.6 25.589 1323.45 25.2349C1323.31 24.8807 1323.09 24.604 1322.79 24.4048C1322.49 24.2056 1322.12 24.106 1321.66 24.106Z"
      fill="black"
    />
    <rect
      width="250.143"
      height="50"
      transform="translate(1500.86)"
      fill="white"
    />
    <path
      d="M1519.69 32L1516.19 21.8647H1516.12C1516.14 22.0916 1516.16 22.4015 1516.18 22.7944C1516.2 23.1873 1516.22 23.6079 1516.24 24.0562C1516.25 24.5044 1516.26 24.9333 1516.26 25.3428V32H1514.45V19.8643H1517.25L1520.61 29.5513H1520.66L1524.14 19.8643H1526.93V32H1525.03V25.2432C1525.03 24.8724 1525.03 24.4712 1525.04 24.0396C1525.06 23.6079 1525.08 23.1984 1525.09 22.811C1525.11 22.4237 1525.13 22.1138 1525.14 21.8813H1525.08L1521.45 32H1519.69ZM1538.06 27.3848C1538.06 28.1484 1537.96 28.8263 1537.76 29.4185C1537.56 30.0106 1537.27 30.5114 1536.89 30.9209C1536.51 31.3249 1536.05 31.6348 1535.51 31.8506C1534.97 32.0609 1534.37 32.166 1533.69 32.166C1533.06 32.166 1532.48 32.0609 1531.96 31.8506C1531.43 31.6348 1530.98 31.3249 1530.59 30.9209C1530.21 30.5114 1529.91 30.0106 1529.7 29.4185C1529.49 28.8263 1529.38 28.1484 1529.38 27.3848C1529.38 26.3721 1529.56 25.5143 1529.91 24.8115C1530.26 24.1032 1530.76 23.5636 1531.42 23.1929C1532.07 22.8221 1532.85 22.6367 1533.75 22.6367C1534.6 22.6367 1535.34 22.8221 1535.99 23.1929C1536.64 23.5636 1537.15 24.1032 1537.51 24.8115C1537.88 25.5199 1538.06 26.3776 1538.06 27.3848ZM1531.39 27.3848C1531.39 28.0544 1531.47 28.6271 1531.63 29.103C1531.8 29.5789 1532.05 29.9442 1532.4 30.1987C1532.74 30.4478 1533.18 30.5723 1533.73 30.5723C1534.27 30.5723 1534.71 30.4478 1535.05 30.1987C1535.4 29.9442 1535.65 29.5789 1535.81 29.103C1535.97 28.6271 1536.05 28.0544 1536.05 27.3848C1536.05 26.7152 1535.97 26.1479 1535.81 25.6831C1535.65 25.2127 1535.4 24.8558 1535.05 24.6123C1534.71 24.3633 1534.26 24.2388 1533.72 24.2388C1532.91 24.2388 1532.32 24.5099 1531.95 25.0522C1531.58 25.5946 1531.39 26.3721 1531.39 27.3848ZM1543.39 32.166C1542.29 32.166 1541.41 31.7676 1540.75 30.9707C1540.09 30.1683 1539.76 28.9868 1539.76 27.4263C1539.76 25.8491 1540.09 24.6566 1540.76 23.8486C1541.44 23.0407 1542.33 22.6367 1543.43 22.6367C1543.89 22.6367 1544.3 22.7004 1544.65 22.8276C1545 22.9494 1545.3 23.1154 1545.55 23.3257C1545.8 23.536 1546.02 23.7712 1546.19 24.0312H1546.28C1546.26 23.8597 1546.22 23.6134 1546.18 23.2925C1546.15 22.966 1546.14 22.6644 1546.14 22.3877V19.084H1548.09V32H1546.57L1546.22 30.7466H1546.14C1545.97 31.0122 1545.76 31.2529 1545.5 31.4688C1545.26 31.679 1544.96 31.8478 1544.61 31.9751C1544.26 32.1024 1543.86 32.166 1543.39 32.166ZM1543.94 30.5806C1544.77 30.5806 1545.36 30.3398 1545.7 29.8584C1546.05 29.377 1546.22 28.6548 1546.23 27.6919V27.4346C1546.23 26.4053 1546.07 25.6167 1545.74 25.0688C1545.4 24.5155 1544.8 24.2388 1543.92 24.2388C1543.22 24.2388 1542.68 24.5238 1542.31 25.0938C1541.94 25.6582 1541.76 26.4468 1541.76 27.4595C1541.76 28.4722 1541.94 29.2469 1542.31 29.7837C1542.68 30.3149 1543.22 30.5806 1543.94 30.5806ZM1552.84 22.811V32H1550.89V22.811H1552.84ZM1551.88 19.2915C1552.18 19.2915 1552.44 19.3717 1552.65 19.5322C1552.87 19.6927 1552.98 19.9694 1552.98 20.3623C1552.98 20.7497 1552.87 21.0264 1552.65 21.1924C1552.44 21.3529 1552.18 21.4331 1551.88 21.4331C1551.57 21.4331 1551.31 21.3529 1551.09 21.1924C1550.88 21.0264 1550.78 20.7497 1550.78 20.3623C1550.78 19.9694 1550.88 19.6927 1551.09 19.5322C1551.31 19.3717 1551.57 19.2915 1551.88 19.2915ZM1560.23 24.2969H1558V32H1556.05V24.2969H1554.54V23.3589L1556.05 22.7861V22.147C1556.05 21.3667 1556.17 20.7469 1556.41 20.2876C1556.66 19.8283 1557.01 19.499 1557.47 19.2998C1557.94 19.0951 1558.49 18.9927 1559.13 18.9927C1559.55 18.9927 1559.94 19.0286 1560.29 19.1006C1560.64 19.167 1560.93 19.2445 1561.17 19.333L1560.66 20.8105C1560.47 20.7497 1560.26 20.6943 1560.03 20.6445C1559.8 20.5892 1559.55 20.5615 1559.28 20.5615C1558.84 20.5615 1558.51 20.6999 1558.3 20.9766C1558.1 21.2533 1558 21.6572 1558 22.1885V22.811H1560.23V24.2969ZM1563.74 22.811V32H1561.79V22.811H1563.74ZM1562.78 19.2915C1563.08 19.2915 1563.33 19.3717 1563.55 19.5322C1563.77 19.6927 1563.88 19.9694 1563.88 20.3623C1563.88 20.7497 1563.77 21.0264 1563.55 21.1924C1563.33 21.3529 1563.08 21.4331 1562.78 21.4331C1562.47 21.4331 1562.21 21.3529 1561.99 21.1924C1561.78 21.0264 1561.67 20.7497 1561.67 20.3623C1561.67 19.9694 1561.78 19.6927 1561.99 19.5322C1562.21 19.3717 1562.47 19.2915 1562.78 19.2915ZM1570.19 22.6367C1571.01 22.6367 1571.71 22.8055 1572.3 23.1431C1572.89 23.4806 1573.34 23.9593 1573.65 24.5791C1573.97 25.1989 1574.13 25.9404 1574.13 26.8037V27.8496H1567.99C1568.01 28.7406 1568.25 29.4268 1568.7 29.9082C1569.16 30.3896 1569.81 30.6304 1570.63 30.6304C1571.22 30.6304 1571.74 30.575 1572.21 30.4644C1572.68 30.3481 1573.16 30.1794 1573.66 29.958V31.5435C1573.2 31.7593 1572.73 31.917 1572.26 32.0166C1571.78 32.1162 1571.21 32.166 1570.55 32.166C1569.65 32.166 1568.85 31.9917 1568.17 31.6431C1567.48 31.2889 1566.95 30.7632 1566.56 30.0659C1566.18 29.3687 1565.99 28.5026 1565.99 27.4678C1565.99 26.4385 1566.16 25.5641 1566.51 24.8447C1566.86 24.1253 1567.35 23.5775 1567.98 23.2012C1568.61 22.8249 1569.35 22.6367 1570.19 22.6367ZM1570.19 24.106C1569.58 24.106 1569.08 24.3052 1568.7 24.7036C1568.32 25.1021 1568.1 25.6859 1568.03 26.4551H1572.22C1572.21 25.9958 1572.13 25.589 1571.98 25.2349C1571.84 24.8807 1571.62 24.604 1571.32 24.4048C1571.03 24.2056 1570.65 24.106 1570.19 24.106ZM1579.41 32.166C1578.32 32.166 1577.44 31.7676 1576.77 30.9707C1576.11 30.1683 1575.79 28.9868 1575.79 27.4263C1575.79 25.8491 1576.12 24.6566 1576.79 23.8486C1577.46 23.0407 1578.35 22.6367 1579.45 22.6367C1579.92 22.6367 1580.33 22.7004 1580.67 22.8276C1581.02 22.9494 1581.32 23.1154 1581.57 23.3257C1581.83 23.536 1582.04 23.7712 1582.22 24.0312H1582.31C1582.28 23.8597 1582.25 23.6134 1582.21 23.2925C1582.18 22.966 1582.16 22.6644 1582.16 22.3877V19.084H1584.12V32H1582.59L1582.24 30.7466H1582.16C1581.99 31.0122 1581.78 31.2529 1581.53 31.4688C1581.28 31.679 1580.98 31.8478 1580.63 31.9751C1580.29 32.1024 1579.88 32.166 1579.41 32.166ZM1579.96 30.5806C1580.8 30.5806 1581.39 30.3398 1581.73 29.8584C1582.07 29.377 1582.25 28.6548 1582.26 27.6919V27.4346C1582.26 26.4053 1582.09 25.6167 1581.76 25.0688C1581.43 24.5155 1580.82 24.2388 1579.94 24.2388C1579.24 24.2388 1578.7 24.5238 1578.33 25.0938C1577.97 25.6582 1577.79 26.4468 1577.79 27.4595C1577.79 28.4722 1577.97 29.2469 1578.33 29.7837C1578.7 30.3149 1579.25 30.5806 1579.96 30.5806ZM1602.31 25.9155C1602.31 26.8507 1602.19 27.703 1601.95 28.4722C1601.72 29.2358 1601.37 29.8944 1600.9 30.4478C1600.42 30.9956 1599.84 31.4189 1599.13 31.7178C1598.42 32.0166 1597.59 32.166 1596.64 32.166C1595.67 32.166 1594.83 32.0166 1594.11 31.7178C1593.41 31.4189 1592.82 30.9928 1592.35 30.4395C1591.88 29.8861 1591.53 29.2248 1591.3 28.4556C1591.07 27.6864 1590.95 26.8341 1590.95 25.8989C1590.95 24.6483 1591.16 23.5581 1591.57 22.6284C1591.98 21.6932 1592.61 20.9683 1593.45 20.4536C1594.3 19.9334 1595.36 19.6733 1596.65 19.6733C1597.92 19.6733 1598.96 19.9307 1599.8 20.4453C1600.64 20.96 1601.26 21.6849 1601.68 22.6201C1602.1 23.5498 1602.31 24.6483 1602.31 25.9155ZM1593.04 25.9155C1593.04 26.8507 1593.17 27.6615 1593.42 28.3477C1593.68 29.0283 1594.07 29.554 1594.59 29.9248C1595.13 30.29 1595.81 30.4727 1596.64 30.4727C1597.47 30.4727 1598.15 30.29 1598.68 29.9248C1599.2 29.554 1599.59 29.0283 1599.84 28.3477C1600.09 27.6615 1600.21 26.8507 1600.21 25.9155C1600.21 24.4933 1599.93 23.381 1599.36 22.5786C1598.8 21.7707 1597.89 21.3667 1596.65 21.3667C1595.82 21.3667 1595.14 21.5493 1594.6 21.9146C1594.07 22.2798 1593.68 22.8027 1593.42 23.4834C1593.17 24.1585 1593.04 24.9692 1593.04 25.9155ZM1609.5 22.6367C1610.54 22.6367 1611.34 22.9051 1611.92 23.4419C1612.5 23.9731 1612.79 24.8281 1612.79 26.0068V32H1610.84V26.3721C1610.84 25.6582 1610.69 25.1242 1610.4 24.77C1610.11 24.4103 1609.65 24.2305 1609.04 24.2305C1608.15 24.2305 1607.53 24.5044 1607.18 25.0522C1606.84 25.6001 1606.66 26.3942 1606.66 27.4346V32H1604.71V22.811H1606.23L1606.51 24.0562H1606.61C1606.81 23.7352 1607.06 23.4723 1607.35 23.2676C1607.65 23.0573 1607.98 22.8996 1608.35 22.7944C1608.72 22.6893 1609.1 22.6367 1609.5 22.6367Z"
      fill="black"
    />
    <rect width="52" height="49" transform="translate(1751 0.5)" fill="white" />
    <mask id="path-8-inside-1_8032_33256" fill="white">
      <path d="M0 50H250.143V99H0V50Z" />
    </mask>
    <path d="M0 50H250.143V99H0V50Z" fill="white" />
    <path
      d="M250.143 98H0V100H250.143V98Z"
      fill="#E6E6E6"
      mask="url(#path-8-inside-1_8032_33256)"
    />
    <rect x="12" y="66" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-11-inside-2_8032_33256" fill="white">
      <path d="M250.143 50H500.286V99H250.143V50Z" />
    </mask>
    <path d="M250.143 50H500.286V99H250.143V50Z" fill="white" />
    <path
      d="M500.286 98H250.143V100H500.286V98Z"
      fill="#E6E6E6"
      mask="url(#path-11-inside-2_8032_33256)"
    />
    <rect x="262.143" y="66" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-14-inside-3_8032_33256" fill="white">
      <path d="M500.286 50H750.429V99H500.286V50Z" />
    </mask>
    <path d="M500.286 50H750.429V99H500.286V50Z" fill="white" />
    <path
      d="M750.429 98H500.286V100H750.429V98Z"
      fill="#E6E6E6"
      mask="url(#path-14-inside-3_8032_33256)"
    />
    <rect x="512.286" y="66" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-17-inside-4_8032_33256" fill="white">
      <path d="M750.429 50H1000.57V99H750.429V50Z" />
    </mask>
    <path d="M750.429 50H1000.57V99H750.429V50Z" fill="white" />
    <path
      d="M1000.57 98H750.429V100H1000.57V98Z"
      fill="#E6E6E6"
      mask="url(#path-17-inside-4_8032_33256)"
    />
    <rect x="762.429" y="66" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-20-inside-5_8032_33256" fill="white">
      <path d="M1000.57 50H1250.71V99H1000.57V50Z" />
    </mask>
    <path d="M1000.57 50H1250.71V99H1000.57V50Z" fill="white" />
    <path
      d="M1250.71 98H1000.57V100H1250.71V98Z"
      fill="#E6E6E6"
      mask="url(#path-20-inside-5_8032_33256)"
    />
    <rect x="1012.57" y="66" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-23-inside-6_8032_33256" fill="white">
      <path d="M1250.71 50H1500.86V99H1250.71V50Z" />
    </mask>
    <path d="M1250.71 50H1500.86V99H1250.71V50Z" fill="white" />
    <path
      d="M1500.86 98H1250.71V100H1500.86V98Z"
      fill="#E6E6E6"
      mask="url(#path-23-inside-6_8032_33256)"
    />
    <rect x="1262.71" y="66" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-26-inside-7_8032_33256" fill="white">
      <path d="M1500.86 50H1751V99H1500.86V50Z" />
    </mask>
    <path d="M1500.86 50H1751V99H1500.86V50Z" fill="white" />
    <path
      d="M1751 98H1500.86V100H1751V98Z"
      fill="#E6E6E6"
      mask="url(#path-26-inside-7_8032_33256)"
    />
    <rect x="1512.86" y="66" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-29-inside-8_8032_33256" fill="white">
      <path d="M1751 50H1803V99H1751V50Z" />
    </mask>
    <path d="M1751 50H1803V99H1751V50Z" fill="white" />
    <path
      d="M1803 98H1751V100H1803V98Z"
      fill="#E8E8E8"
      mask="url(#path-29-inside-8_8032_33256)"
    />
    <mask id="path-31-inside-9_8032_33256" fill="white">
      <path d="M0 99H250.143V148H0V99Z" />
    </mask>
    <path d="M0 99H250.143V148H0V99Z" fill="white" />
    <path
      d="M250.143 147H0V149H250.143V147Z"
      fill="#E6E6E6"
      mask="url(#path-31-inside-9_8032_33256)"
    />
    <rect x="12" y="115" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-34-inside-10_8032_33256" fill="white">
      <path d="M250.143 99H500.286V148H250.143V99Z" />
    </mask>
    <path d="M250.143 99H500.286V148H250.143V99Z" fill="white" />
    <path
      d="M500.286 147H250.143V149H500.286V147Z"
      fill="#E6E6E6"
      mask="url(#path-34-inside-10_8032_33256)"
    />
    <rect x="262.143" y="115" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-37-inside-11_8032_33256" fill="white">
      <path d="M500.286 99H750.429V148H500.286V99Z" />
    </mask>
    <path d="M500.286 99H750.429V148H500.286V99Z" fill="white" />
    <path
      d="M750.429 147H500.286V149H750.429V147Z"
      fill="#E6E6E6"
      mask="url(#path-37-inside-11_8032_33256)"
    />
    <rect x="512.286" y="115" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-40-inside-12_8032_33256" fill="white">
      <path d="M750.429 99H1000.57V148H750.429V99Z" />
    </mask>
    <path d="M750.429 99H1000.57V148H750.429V99Z" fill="white" />
    <path
      d="M1000.57 147H750.429V149H1000.57V147Z"
      fill="#E6E6E6"
      mask="url(#path-40-inside-12_8032_33256)"
    />
    <rect x="762.429" y="115" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-43-inside-13_8032_33256" fill="white">
      <path d="M1000.57 99H1250.71V148H1000.57V99Z" />
    </mask>
    <path d="M1000.57 99H1250.71V148H1000.57V99Z" fill="white" />
    <path
      d="M1250.71 147H1000.57V149H1250.71V147Z"
      fill="#E6E6E6"
      mask="url(#path-43-inside-13_8032_33256)"
    />
    <rect x="1012.57" y="115" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-46-inside-14_8032_33256" fill="white">
      <path d="M1250.71 99H1500.86V148H1250.71V99Z" />
    </mask>
    <path d="M1250.71 99H1500.86V148H1250.71V99Z" fill="white" />
    <path
      d="M1500.86 147H1250.71V149H1500.86V147Z"
      fill="#E6E6E6"
      mask="url(#path-46-inside-14_8032_33256)"
    />
    <rect x="1262.71" y="115" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-49-inside-15_8032_33256" fill="white">
      <path d="M1500.86 99H1751V148H1500.86V99Z" />
    </mask>
    <path d="M1500.86 99H1751V148H1500.86V99Z" fill="white" />
    <path
      d="M1751 147H1500.86V149H1751V147Z"
      fill="#E6E6E6"
      mask="url(#path-49-inside-15_8032_33256)"
    />
    <rect x="1512.86" y="115" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-52-inside-16_8032_33256" fill="white">
      <path d="M1751 99H1803V148H1751V99Z" />
    </mask>
    <path d="M1751 99H1803V148H1751V99Z" fill="white" />
    <path
      d="M1803 147H1751V149H1803V147Z"
      fill="#E8E8E8"
      mask="url(#path-52-inside-16_8032_33256)"
    />
    <mask id="path-54-inside-17_8032_33256" fill="white">
      <path d="M0 148H250.143V197H0V148Z" />
    </mask>
    <path d="M0 148H250.143V197H0V148Z" fill="white" />
    <path
      d="M250.143 196H0V198H250.143V196Z"
      fill="#E6E6E6"
      mask="url(#path-54-inside-17_8032_33256)"
    />
    <rect x="12" y="164" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-57-inside-18_8032_33256" fill="white">
      <path d="M250.143 148H500.286V197H250.143V148Z" />
    </mask>
    <path d="M250.143 148H500.286V197H250.143V148Z" fill="white" />
    <path
      d="M500.286 196H250.143V198H500.286V196Z"
      fill="#E6E6E6"
      mask="url(#path-57-inside-18_8032_33256)"
    />
    <rect x="262.143" y="164" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-60-inside-19_8032_33256" fill="white">
      <path d="M500.286 148H750.429V197H500.286V148Z" />
    </mask>
    <path d="M500.286 148H750.429V197H500.286V148Z" fill="white" />
    <path
      d="M750.429 196H500.286V198H750.429V196Z"
      fill="#E6E6E6"
      mask="url(#path-60-inside-19_8032_33256)"
    />
    <rect x="512.286" y="164" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-63-inside-20_8032_33256" fill="white">
      <path d="M750.429 148H1000.57V197H750.429V148Z" />
    </mask>
    <path d="M750.429 148H1000.57V197H750.429V148Z" fill="white" />
    <path
      d="M1000.57 196H750.429V198H1000.57V196Z"
      fill="#E6E6E6"
      mask="url(#path-63-inside-20_8032_33256)"
    />
    <rect x="762.429" y="164" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-66-inside-21_8032_33256" fill="white">
      <path d="M1000.57 148H1250.71V197H1000.57V148Z" />
    </mask>
    <path d="M1000.57 148H1250.71V197H1000.57V148Z" fill="white" />
    <path
      d="M1250.71 196H1000.57V198H1250.71V196Z"
      fill="#E6E6E6"
      mask="url(#path-66-inside-21_8032_33256)"
    />
    <rect x="1012.57" y="164" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-69-inside-22_8032_33256" fill="white">
      <path d="M1250.71 148H1500.86V197H1250.71V148Z" />
    </mask>
    <path d="M1250.71 148H1500.86V197H1250.71V148Z" fill="white" />
    <path
      d="M1500.86 196H1250.71V198H1500.86V196Z"
      fill="#E6E6E6"
      mask="url(#path-69-inside-22_8032_33256)"
    />
    <rect x="1262.71" y="164" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-72-inside-23_8032_33256" fill="white">
      <path d="M1500.86 148H1751V197H1500.86V148Z" />
    </mask>
    <path d="M1500.86 148H1751V197H1500.86V148Z" fill="white" />
    <path
      d="M1751 196H1500.86V198H1751V196Z"
      fill="#E6E6E6"
      mask="url(#path-72-inside-23_8032_33256)"
    />
    <rect x="1512.86" y="164" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-75-inside-24_8032_33256" fill="white">
      <path d="M1751 148H1803V197H1751V148Z" />
    </mask>
    <path d="M1751 148H1803V197H1751V148Z" fill="white" />
    <path
      d="M1803 196H1751V198H1803V196Z"
      fill="#E8E8E8"
      mask="url(#path-75-inside-24_8032_33256)"
    />
    <mask id="path-77-inside-25_8032_33256" fill="white">
      <path d="M0 197H250.143V246H0V197Z" />
    </mask>
    <path d="M0 197H250.143V246H0V197Z" fill="white" />
    <path
      d="M250.143 245H0V247H250.143V245Z"
      fill="#E6E6E6"
      mask="url(#path-77-inside-25_8032_33256)"
    />
    <rect x="12" y="213" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-80-inside-26_8032_33256" fill="white">
      <path d="M250.143 197H500.286V246H250.143V197Z" />
    </mask>
    <path d="M250.143 197H500.286V246H250.143V197Z" fill="white" />
    <path
      d="M500.286 245H250.143V247H500.286V245Z"
      fill="#E6E6E6"
      mask="url(#path-80-inside-26_8032_33256)"
    />
    <rect x="262.143" y="213" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-83-inside-27_8032_33256" fill="white">
      <path d="M500.286 197H750.429V246H500.286V197Z" />
    </mask>
    <path d="M500.286 197H750.429V246H500.286V197Z" fill="white" />
    <path
      d="M750.429 245H500.286V247H750.429V245Z"
      fill="#E6E6E6"
      mask="url(#path-83-inside-27_8032_33256)"
    />
    <rect x="512.286" y="213" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-86-inside-28_8032_33256" fill="white">
      <path d="M750.429 197H1000.57V246H750.429V197Z" />
    </mask>
    <path d="M750.429 197H1000.57V246H750.429V197Z" fill="white" />
    <path
      d="M1000.57 245H750.429V247H1000.57V245Z"
      fill="#E6E6E6"
      mask="url(#path-86-inside-28_8032_33256)"
    />
    <rect x="762.429" y="213" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-89-inside-29_8032_33256" fill="white">
      <path d="M1000.57 197H1250.71V246H1000.57V197Z" />
    </mask>
    <path d="M1000.57 197H1250.71V246H1000.57V197Z" fill="white" />
    <path
      d="M1250.71 245H1000.57V247H1250.71V245Z"
      fill="#E6E6E6"
      mask="url(#path-89-inside-29_8032_33256)"
    />
    <rect x="1012.57" y="213" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-92-inside-30_8032_33256" fill="white">
      <path d="M1250.71 197H1500.86V246H1250.71V197Z" />
    </mask>
    <path d="M1250.71 197H1500.86V246H1250.71V197Z" fill="white" />
    <path
      d="M1500.86 245H1250.71V247H1500.86V245Z"
      fill="#E6E6E6"
      mask="url(#path-92-inside-30_8032_33256)"
    />
    <rect x="1262.71" y="213" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-95-inside-31_8032_33256" fill="white">
      <path d="M1500.86 197H1751V246H1500.86V197Z" />
    </mask>
    <path d="M1500.86 197H1751V246H1500.86V197Z" fill="white" />
    <path
      d="M1751 245H1500.86V247H1751V245Z"
      fill="#E6E6E6"
      mask="url(#path-95-inside-31_8032_33256)"
    />
    <rect x="1512.86" y="213" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-98-inside-32_8032_33256" fill="white">
      <path d="M1751 197H1803V246H1751V197Z" />
    </mask>
    <path d="M1751 197H1803V246H1751V197Z" fill="white" />
    <path
      d="M1803 245H1751V247H1803V245Z"
      fill="#E8E8E8"
      mask="url(#path-98-inside-32_8032_33256)"
    />
    <mask id="path-100-inside-33_8032_33256" fill="white">
      <path d="M0 246H250.143V295H0V246Z" />
    </mask>
    <path d="M0 246H250.143V295H0V246Z" fill="white" />
    <path
      d="M250.143 294H0V296H250.143V294Z"
      fill="#E6E6E6"
      mask="url(#path-100-inside-33_8032_33256)"
    />
    <rect x="12" y="262" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-103-inside-34_8032_33256" fill="white">
      <path d="M250.143 246H500.286V295H250.143V246Z" />
    </mask>
    <path d="M250.143 246H500.286V295H250.143V246Z" fill="white" />
    <path
      d="M500.286 294H250.143V296H500.286V294Z"
      fill="#E6E6E6"
      mask="url(#path-103-inside-34_8032_33256)"
    />
    <rect x="262.143" y="262" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-106-inside-35_8032_33256" fill="white">
      <path d="M500.286 246H750.429V295H500.286V246Z" />
    </mask>
    <path d="M500.286 246H750.429V295H500.286V246Z" fill="white" />
    <path
      d="M750.429 294H500.286V296H750.429V294Z"
      fill="#E6E6E6"
      mask="url(#path-106-inside-35_8032_33256)"
    />
    <rect x="512.286" y="262" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-109-inside-36_8032_33256" fill="white">
      <path d="M750.429 246H1000.57V295H750.429V246Z" />
    </mask>
    <path d="M750.429 246H1000.57V295H750.429V246Z" fill="white" />
    <path
      d="M1000.57 294H750.429V296H1000.57V294Z"
      fill="#E6E6E6"
      mask="url(#path-109-inside-36_8032_33256)"
    />
    <rect x="762.429" y="262" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-112-inside-37_8032_33256" fill="white">
      <path d="M1000.57 246H1250.71V295H1000.57V246Z" />
    </mask>
    <path d="M1000.57 246H1250.71V295H1000.57V246Z" fill="white" />
    <path
      d="M1250.71 294H1000.57V296H1250.71V294Z"
      fill="#E6E6E6"
      mask="url(#path-112-inside-37_8032_33256)"
    />
    <rect x="1012.57" y="262" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-115-inside-38_8032_33256" fill="white">
      <path d="M1250.71 246H1500.86V295H1250.71V246Z" />
    </mask>
    <path d="M1250.71 246H1500.86V295H1250.71V246Z" fill="white" />
    <path
      d="M1500.86 294H1250.71V296H1500.86V294Z"
      fill="#E6E6E6"
      mask="url(#path-115-inside-38_8032_33256)"
    />
    <rect x="1262.71" y="262" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-118-inside-39_8032_33256" fill="white">
      <path d="M1500.86 246H1751V295H1500.86V246Z" />
    </mask>
    <path d="M1500.86 246H1751V295H1500.86V246Z" fill="white" />
    <path
      d="M1751 294H1500.86V296H1751V294Z"
      fill="#E6E6E6"
      mask="url(#path-118-inside-39_8032_33256)"
    />
    <rect x="1512.86" y="262" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-121-inside-40_8032_33256" fill="white">
      <path d="M1751 246H1803V295H1751V246Z" />
    </mask>
    <path d="M1751 246H1803V295H1751V246Z" fill="white" />
    <path
      d="M1803 294H1751V296H1803V294Z"
      fill="#E8E8E8"
      mask="url(#path-121-inside-40_8032_33256)"
    />
    <mask id="path-123-inside-41_8032_33256" fill="white">
      <path d="M0 295H250.143V344H0V295Z" />
    </mask>
    <path d="M0 295H250.143V344H0V295Z" fill="white" />
    <path
      d="M250.143 343H0V345H250.143V343Z"
      fill="#E6E6E6"
      mask="url(#path-123-inside-41_8032_33256)"
    />
    <rect x="12" y="311" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-126-inside-42_8032_33256" fill="white">
      <path d="M250.143 295H500.286V344H250.143V295Z" />
    </mask>
    <path d="M250.143 295H500.286V344H250.143V295Z" fill="white" />
    <path
      d="M500.286 343H250.143V345H500.286V343Z"
      fill="#E6E6E6"
      mask="url(#path-126-inside-42_8032_33256)"
    />
    <rect x="262.143" y="311" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-129-inside-43_8032_33256" fill="white">
      <path d="M500.286 295H750.429V344H500.286V295Z" />
    </mask>
    <path d="M500.286 295H750.429V344H500.286V295Z" fill="white" />
    <path
      d="M750.429 343H500.286V345H750.429V343Z"
      fill="#E6E6E6"
      mask="url(#path-129-inside-43_8032_33256)"
    />
    <rect x="512.286" y="311" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-132-inside-44_8032_33256" fill="white">
      <path d="M750.429 295H1000.57V344H750.429V295Z" />
    </mask>
    <path d="M750.429 295H1000.57V344H750.429V295Z" fill="white" />
    <path
      d="M1000.57 343H750.429V345H1000.57V343Z"
      fill="#E6E6E6"
      mask="url(#path-132-inside-44_8032_33256)"
    />
    <rect x="762.429" y="311" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-135-inside-45_8032_33256" fill="white">
      <path d="M1000.57 295H1250.71V344H1000.57V295Z" />
    </mask>
    <path d="M1000.57 295H1250.71V344H1000.57V295Z" fill="white" />
    <path
      d="M1250.71 343H1000.57V345H1250.71V343Z"
      fill="#E6E6E6"
      mask="url(#path-135-inside-45_8032_33256)"
    />
    <rect x="1012.57" y="311" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-138-inside-46_8032_33256" fill="white">
      <path d="M1250.71 295H1500.86V344H1250.71V295Z" />
    </mask>
    <path d="M1250.71 295H1500.86V344H1250.71V295Z" fill="white" />
    <path
      d="M1500.86 343H1250.71V345H1500.86V343Z"
      fill="#E6E6E6"
      mask="url(#path-138-inside-46_8032_33256)"
    />
    <rect x="1262.71" y="311" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-141-inside-47_8032_33256" fill="white">
      <path d="M1500.86 295H1751V344H1500.86V295Z" />
    </mask>
    <path d="M1500.86 295H1751V344H1500.86V295Z" fill="white" />
    <path
      d="M1751 343H1500.86V345H1751V343Z"
      fill="#E6E6E6"
      mask="url(#path-141-inside-47_8032_33256)"
    />
    <rect x="1512.86" y="311" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-144-inside-48_8032_33256" fill="white">
      <path d="M1751 295H1803V344H1751V295Z" />
    </mask>
    <path d="M1751 295H1803V344H1751V295Z" fill="white" />
    <path
      d="M1803 343H1751V345H1803V343Z"
      fill="#E8E8E8"
      mask="url(#path-144-inside-48_8032_33256)"
    />
    <mask id="path-146-inside-49_8032_33256" fill="white">
      <path d="M0 344H250.143V393H0V344Z" />
    </mask>
    <path d="M0 344H250.143V393H0V344Z" fill="white" />
    <path
      d="M250.143 392H0V394H250.143V392Z"
      fill="#E6E6E6"
      mask="url(#path-146-inside-49_8032_33256)"
    />
    <rect x="12" y="360" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-149-inside-50_8032_33256" fill="white">
      <path d="M250.143 344H500.286V393H250.143V344Z" />
    </mask>
    <path d="M250.143 344H500.286V393H250.143V344Z" fill="white" />
    <path
      d="M500.286 392H250.143V394H500.286V392Z"
      fill="#E6E6E6"
      mask="url(#path-149-inside-50_8032_33256)"
    />
    <rect x="262.143" y="360" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-152-inside-51_8032_33256" fill="white">
      <path d="M500.286 344H750.429V393H500.286V344Z" />
    </mask>
    <path d="M500.286 344H750.429V393H500.286V344Z" fill="white" />
    <path
      d="M750.429 392H500.286V394H750.429V392Z"
      fill="#E6E6E6"
      mask="url(#path-152-inside-51_8032_33256)"
    />
    <rect x="512.286" y="360" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-155-inside-52_8032_33256" fill="white">
      <path d="M750.429 344H1000.57V393H750.429V344Z" />
    </mask>
    <path d="M750.429 344H1000.57V393H750.429V344Z" fill="white" />
    <path
      d="M1000.57 392H750.429V394H1000.57V392Z"
      fill="#E6E6E6"
      mask="url(#path-155-inside-52_8032_33256)"
    />
    <rect x="762.429" y="360" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-158-inside-53_8032_33256" fill="white">
      <path d="M1000.57 344H1250.71V393H1000.57V344Z" />
    </mask>
    <path d="M1000.57 344H1250.71V393H1000.57V344Z" fill="white" />
    <path
      d="M1250.71 392H1000.57V394H1250.71V392Z"
      fill="#E6E6E6"
      mask="url(#path-158-inside-53_8032_33256)"
    />
    <rect x="1012.57" y="360" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-161-inside-54_8032_33256" fill="white">
      <path d="M1250.71 344H1500.86V393H1250.71V344Z" />
    </mask>
    <path d="M1250.71 344H1500.86V393H1250.71V344Z" fill="white" />
    <path
      d="M1500.86 392H1250.71V394H1500.86V392Z"
      fill="#E6E6E6"
      mask="url(#path-161-inside-54_8032_33256)"
    />
    <rect x="1262.71" y="360" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-164-inside-55_8032_33256" fill="white">
      <path d="M1500.86 344H1751V393H1500.86V344Z" />
    </mask>
    <path d="M1500.86 344H1751V393H1500.86V344Z" fill="white" />
    <path
      d="M1751 392H1500.86V394H1751V392Z"
      fill="#E6E6E6"
      mask="url(#path-164-inside-55_8032_33256)"
    />
    <rect x="1512.86" y="360" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-167-inside-56_8032_33256" fill="white">
      <path d="M1751 344H1803V393H1751V344Z" />
    </mask>
    <path d="M1751 344H1803V393H1751V344Z" fill="white" />
    <path
      d="M1803 392H1751V394H1803V392Z"
      fill="#E8E8E8"
      mask="url(#path-167-inside-56_8032_33256)"
    />
    <mask id="path-169-inside-57_8032_33256" fill="white">
      <path d="M0 393H250.143V442H0V393Z" />
    </mask>
    <path d="M0 393H250.143V442H0V393Z" fill="white" />
    <path
      d="M250.143 441H0V443H250.143V441Z"
      fill="#E6E6E6"
      mask="url(#path-169-inside-57_8032_33256)"
    />
    <rect x="12" y="409" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-172-inside-58_8032_33256" fill="white">
      <path d="M250.143 393H500.286V442H250.143V393Z" />
    </mask>
    <path d="M250.143 393H500.286V442H250.143V393Z" fill="white" />
    <path
      d="M500.286 441H250.143V443H500.286V441Z"
      fill="#E6E6E6"
      mask="url(#path-172-inside-58_8032_33256)"
    />
    <rect x="262.143" y="409" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-175-inside-59_8032_33256" fill="white">
      <path d="M500.286 393H750.429V442H500.286V393Z" />
    </mask>
    <path d="M500.286 393H750.429V442H500.286V393Z" fill="white" />
    <path
      d="M750.429 441H500.286V443H750.429V441Z"
      fill="#E6E6E6"
      mask="url(#path-175-inside-59_8032_33256)"
    />
    <rect x="512.286" y="409" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-178-inside-60_8032_33256" fill="white">
      <path d="M750.429 393H1000.57V442H750.429V393Z" />
    </mask>
    <path d="M750.429 393H1000.57V442H750.429V393Z" fill="white" />
    <path
      d="M1000.57 441H750.429V443H1000.57V441Z"
      fill="#E6E6E6"
      mask="url(#path-178-inside-60_8032_33256)"
    />
    <rect x="762.429" y="409" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-181-inside-61_8032_33256" fill="white">
      <path d="M1000.57 393H1250.71V442H1000.57V393Z" />
    </mask>
    <path d="M1000.57 393H1250.71V442H1000.57V393Z" fill="white" />
    <path
      d="M1250.71 441H1000.57V443H1250.71V441Z"
      fill="#E6E6E6"
      mask="url(#path-181-inside-61_8032_33256)"
    />
    <rect x="1012.57" y="409" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-184-inside-62_8032_33256" fill="white">
      <path d="M1250.71 393H1500.86V442H1250.71V393Z" />
    </mask>
    <path d="M1250.71 393H1500.86V442H1250.71V393Z" fill="white" />
    <path
      d="M1500.86 441H1250.71V443H1500.86V441Z"
      fill="#E6E6E6"
      mask="url(#path-184-inside-62_8032_33256)"
    />
    <rect x="1262.71" y="409" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-187-inside-63_8032_33256" fill="white">
      <path d="M1500.86 393H1751V442H1500.86V393Z" />
    </mask>
    <path d="M1500.86 393H1751V442H1500.86V393Z" fill="white" />
    <path
      d="M1751 441H1500.86V443H1751V441Z"
      fill="#E6E6E6"
      mask="url(#path-187-inside-63_8032_33256)"
    />
    <rect x="1512.86" y="409" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-190-inside-64_8032_33256" fill="white">
      <path d="M1751 393H1803V442H1751V393Z" />
    </mask>
    <path d="M1751 393H1803V442H1751V393Z" fill="white" />
    <path
      d="M1803 441H1751V443H1803V441Z"
      fill="#E8E8E8"
      mask="url(#path-190-inside-64_8032_33256)"
    />
  </svg>
);

export const suggestionIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "15.21"}
    height={height || "20.8"}
    viewBox="0 0 19.121 26.528"
  >
    <defs>
      <style>{`.suggestion-icon-cls-1{fill:none;stroke:#4c4c4c;strokeWidth:1.8px}`}</style>
    </defs>
    <g
      id="Group_1907"
      data-name="Group 1907"
      transform="translate(-1716.099 -291.1)"
    >
      <path
        id="Line_357"
        data-name="Line 357"
        className="suggestion-icon-cls-1"
        transform="translate(1725.8 303.5)"
        d="M0 7V0"
      />
      <circle
        id="Ellipse_283"
        data-name="Ellipse 283"
        cx="2"
        cy="2"
        r="2"
        transform="translate(1723.8 301)"
        style={{ fill: "#4c4c4c" }}
      />
      <path
        id="Path_2723"
        data-name="Path 2723"
        className="suggestion-icon-cls-1"
        d="M109.454 35.828v.866a2.167 2.167 0 0 1-2.165 2.165h-.476a2.165 2.165 0 0 1-4.243 0h-.477a2.167 2.167 0 0 1-2.165-2.165v-.866a1.3 1.3 0 0 1 1.3-1.3h6.928a1.3 1.3 0 0 1 1.298 1.3zm1.23-17.522a8.665 8.665 0 1 0-11.973 12.528q.124.119.253.233a2.879 2.879 0 0 1 .963 2.163 1.3 1.3 0 0 0 1.3 1.3h6.928a1.3 1.3 0 0 0 1.3-1.3 2.887 2.887 0 0 1 .967-2.167 8.676 8.676 0 0 0 .754-12.246q-.235-.266-.491-.511z"
        transform="translate(1620.967 276.095)"
      />
    </g>
  </svg>
);

export const gridAscSortIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "8.667"}
    height={height || "12.059"}
    viewBox="0 0 8.667 12.059"
  >
    <defs>
      <style>{`.icn-cls-1{fill:#428bca} .icn-cls-2{fill:#b5b9c1}`}</style>
    </defs>
    <g data-name="Group 2324">
      <path
        className="icn-cls-1"
        d="m25.388 60.768-3.6-3.6a.724.724 0 0 0-1.027 0l-3.608 3.6a.728.728 0 0 0 .515 1.242h7.209a.728.728 0 0 0 .511-1.242z"
        transform="translate(-16.934 -56.95)"
      />
      <path
        className="icn-cls-2"
        data-name="sort-solid"
        d="M17.663 63.194h7.209a.728.728 0 0 1 .515 1.242l-3.6 3.6a.724.724 0 0 1-1.027 0l-3.608-3.6a.728.728 0 0 1 .511-1.242z"
        transform="translate(-16.934 -56.196)"
      />
    </g>
  </svg>
);

export const gridDescSortIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "8.667"}
    height={height || "12.059"}
    viewBox="0 0 8.667 12.059"
    transform="scale(1, -1)"
  >
    <defs>
      <style>{`.icn-cls-1{fill:#428bca} .icn-cls-2{fill:#b5b9c1}`}</style>
    </defs>
    <g data-name="Group 2324">
      <path
        className="icn-cls-1"
        d="m25.388 60.768-3.6-3.6a.724.724 0 0 0-1.027 0l-3.608 3.6a.728.728 0 0 0 .515 1.242h7.209a.728.728 0 0 0 .511-1.242z"
        transform="translate(-16.934 -56.95)"
      />
      <path
        className="icn-cls-2"
        data-name="sort-solid"
        d="M17.663 63.194h7.209a.728.728 0 0 1 .515 1.242l-3.6 3.6a.724.724 0 0 1-1.027 0l-3.608-3.6a.728.728 0 0 1 .511-1.242z"
        transform="translate(-16.934 -56.196)"
      />
    </g>
  </svg>
);
export const secondaryDeleteIcon = (): JSX.Element => (
  <svg width="27.51" height="24.071" viewBox="0 0 27.51 24.071">
    <defs>
      <style>{`.secondaryDeleteIcon{fill:#e5bab3}`}</style>
    </defs>
    <path
      data-name="Icon awesome-archive"
      d="M1.719 24.6a1.718 1.718 0 0 0 1.719 1.719h20.633A1.718 1.718 0 0 0 25.79 24.6V9.127H1.719zm8.6-11.391a.647.647 0 0 1 .645-.645h5.588a.647.647 0 0 1 .645.645v.43a.647.647 0 0 1-.645.645h-5.591a.647.647 0 0 1-.645-.645zM25.79 2.25H1.719A1.718 1.718 0 0 0 0 3.969v2.579a.862.862 0 0 0 .86.86h25.79a.862.862 0 0 0 .86-.86V3.969a1.718 1.718 0 0 0-1.72-1.719z"
      transform="translate(0 -2.25)"
      className="secondaryDeleteIcon"
    />
  </svg>
);

export const gridSortAscIconStr = `<svg width="8.667" height="12.059" viewBox="0 0 8.667 12.059">
<g data-name="Group 2324">
  <path
    fill="#428bca"
    className="icn-cls-1"
    d="m25.388 60.768-3.6-3.6a.724.724 0 0 0-1.027 0l-3.608 3.6a.728.728 0 0 0 .515 1.242h7.209a.728.728 0 0 0 .511-1.242z"
    transform="translate(-16.934 -56.95)"
  />
  <path
    fill="#b5b9c1"
    data-name="sort-solid"
    d="M17.663 63.194h7.209a.728.728 0 0 1 .515 1.242l-3.6 3.6a.724.724 0 0 1-1.027 0l-3.608-3.6a.728.728 0 0 1 .511-1.242z"
    transform="translate(-16.934 -56.196)"
  />
</g>
</svg>`;

export const gridSortDescIconStr = `<svg width="8.667" height="12.059" viewBox="0 0 8.667 12.059">
<g data-name="Group 2324">
  <path
    fill="#b5b9c1"
    className="icn-cls-1"
    d="m25.388 60.768-3.6-3.6a.724.724 0 0 0-1.027 0l-3.608 3.6a.728.728 0 0 0 .515 1.242h7.209a.728.728 0 0 0 .511-1.242z"
    transform="translate(-16.934 -56.95)"
  />
  <path
    fill="#428bca"
    data-name="sort-solid"
    d="M17.663 63.194h7.209a.728.728 0 0 1 .515 1.242l-3.6 3.6a.724.724 0 0 1-1.027 0l-3.608-3.6a.728.728 0 0 1 .511-1.242z"
    transform="translate(-16.934 -56.196)"
  />
</g>
</svg>`;

export const prevIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "14.7"}
    height={height || "16.291"}
    viewBox="0 0 14.7 16.291"
  >
    <defs>
      <style>
        {`.cls-1-prev-icon{fill:#393939;stroke:#393939;strokeWidth:.5px}`}
      </style>
    </defs>
    <path
      className="cls-1-prev-icon"
      data-name="Path 2800"
      d="M-758.217 366.915a1.034 1.034 0 0 0-.99.4 1.848 1.848 0 0 1-.158.148l-.4.4q-.36.39-.75.75a3.949 3.949 0 0 1-.4.4q-.377.407-.784.783a3.2 3.2 0 0 1-.367.367q-.376.407-.784.783a3.217 3.217 0 0 1-.367.367q-.376.407-.784.784l-.4.4c-.241.259-.49.51-.75.75a3.9 3.9 0 0 1-.4.4l-.244.256a1.735 1.735 0 0 0-.481.619l-.038.274.043.3a1.955 1.955 0 0 0 .381.479 2.615 2.615 0 0 1 .344.361l.4.4.751.752.4.4.785.785.366.366.785.784.366.365.785.785.4.4.752.751.4.4a2.206 2.206 0 0 1 .2.181.993.993 0 0 0 .945.369 1.276 1.276 0 0 0 .495-.328 6.563 6.563 0 0 1 .65-.623l.006.008-.007-.007a.225.225 0 0 1 .03-.057.892.892 0 0 0 .18-1.086l-.206-.26c-.33-.281-.635-.587-.943-.891a.952.952 0 0 1-.206-.2c-.348-.3-.68-.628-1.008-.954a.633.633 0 0 1-.175-.168 21.586 21.586 0 0 1-1.062-1.012l-.056-.049-.857-.8h8.1c.112 0 .224-.007.336-.007a.846.846 0 0 0 .815-.795c0-.219.007-.437.01-.656q0-.3-.008-.606a.831.831 0 0 0-.718-.824c-.146-.025-.291-.01-.436-.027h-8.1l.86-.8.054-.046a20.5 20.5 0 0 1 1.1-1.044.417.417 0 0 1 .139-.134c.327-.329.658-.653 1.008-.957a.959.959 0 0 1 .2-.2c.3-.318.628-.611.952-.907l.2-.244a.91.91 0 0 0-.242-1.155 10.073 10.073 0 0 1-.537-.537 1.5 1.5 0 0 0-.58-.393z"
      transform="translate(766.568 -366.651)"
    />
  </svg>
);

export const nextIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "14.699"}
    height={height || "16.291"}
    viewBox="0 0 14.699 16.291"
  >
    <defs>
      <style>
        {`.cls-1-next-icon{fill:#393939;stroke:#393939;strokeWidth:.5px}`}
      </style>
    </defs>
    <path
      className="cls-1-next-icon"
      data-name="Path 1279"
      d="M-760.216 366.915a1.034 1.034 0 0 1 .99.4 1.848 1.848 0 0 0 .158.148l.4.4q.36.39.75.75a3.946 3.946 0 0 0 .4.4q.377.407.784.783a3.2 3.2 0 0 0 .367.367q.376.407.784.784a3.217 3.217 0 0 0 .367.367q.376.407.783.784l.4.4c.241.259.49.51.75.75a3.9 3.9 0 0 0 .4.4l.244.256a1.735 1.735 0 0 1 .481.619l.038.274-.043.3a1.955 1.955 0 0 1-.381.479 2.615 2.615 0 0 0-.344.361l-.4.4-.751.752-.4.4-.784.785-.366.366-.785.784-.366.365-.785.785-.4.4-.752.751-.4.4a2.206 2.206 0 0 0-.2.181.993.993 0 0 1-.945.369 1.276 1.276 0 0 1-.495-.328 6.556 6.556 0 0 0-.65-.623l-.006.008.007-.007a.225.225 0 0 0-.03-.057.892.892 0 0 1-.18-1.086l.206-.26c.33-.281.635-.587.943-.891a.952.952 0 0 0 .206-.2c.348-.3.68-.628 1.008-.954a.633.633 0 0 0 .175-.168c.364-.327.721-.661 1.062-1.012l.056-.049.857-.8h-8.1c-.112 0-.224-.007-.336-.007a.846.846 0 0 1-.815-.795c0-.219-.007-.437-.01-.656q0-.3.008-.606a.831.831 0 0 1 .718-.824c.146-.025.291-.01.436-.027h8.1l-.86-.8-.054-.046a20.5 20.5 0 0 0-1.1-1.044.417.417 0 0 0-.139-.134 18.965 18.965 0 0 0-1.008-.957.959.959 0 0 0-.2-.2c-.3-.318-.628-.611-.952-.907l-.2-.244a.91.91 0 0 1 .242-1.155c.187-.171.364-.353.537-.537a1.5 1.5 0 0 1 .58-.394z"
      transform="translate(766.565 -366.651)"
    />
  </svg>
);

export const filterIconFlipped = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "15"} height={height || "15"} viewBox="0 0 18.8 18.8">
    <defs>
      <style>{`.cls-1-filter-icon { fill:#4c4c4c }`}</style>
    </defs>
    <path
      data-name="Icon awesome-filter"
      d="M.634-1h15.51A1.628 1.628 0 0 1 17.651.008a1.628 1.628 0 0 1-.353 1.78l-5.939 5.94v8.416a1.637 1.637 0 0 1-1.637 1.634 1.62 1.62 0 0 1-.933-.3L6.115 15.61a1.635 1.635 0 0 1-.7-1.338V7.728l-5.936-5.94A1.628 1.628 0 0 1-.874.009 1.628 1.628 0 0 1 .634-1zM16.074.662H.7L7.08 7.04v7.218l2.62 1.831V7.04z"
      transform="translate(.999 1)"
      className="cls-1-filter-icon"
    />
  </svg>
);

export const userGroupsIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "16"}
    height={height || "11.44"}
    viewBox="0 0 20.51 14.357"
  >
    <path
      id="users-solid"
      d="M3.077,38.153A2.051,2.051,0,1,0,1.026,36.1,2.053,2.053,0,0,0,3.077,38.153Zm14.357,0A2.051,2.051,0,1,0,15.383,36.1,2.053,2.053,0,0,0,17.434,38.153Zm1.026,1.026H16.408a2.045,2.045,0,0,0-1.445.6,4.688,4.688,0,0,1,2.407,3.506h2.115a1.024,1.024,0,0,0,1.026-1.026V41.23A2.053,2.053,0,0,0,18.459,39.179Zm-8.2,0a3.589,3.589,0,1,0-3.589-3.589A3.587,3.587,0,0,0,10.255,39.179ZM12.716,40.2H12.45a4.956,4.956,0,0,1-4.39,0H7.794A3.693,3.693,0,0,0,4.1,43.9v.923A1.539,1.539,0,0,0,5.64,46.357h9.23a1.539,1.539,0,0,0,1.538-1.538V43.9A3.693,3.693,0,0,0,12.716,40.2Zm-7.169-.429a2.045,2.045,0,0,0-1.445-.6H2.051A2.053,2.053,0,0,0,0,41.23v1.026a1.024,1.024,0,0,0,1.026,1.026H3.137a4.7,4.7,0,0,1,2.41-3.506Z"
      transform="translate(0 -32)"
      fill="#478fca"
    />
  </svg>
);

export const solidSuccessTickIcon = (
  <svg width="14.439" height="11.102" viewBox="0 0 14.439 11.102">
    <path
      data-name="Path 2311"
      d="M-402.819 692.911c1.647-1.618 3.26-3.2 4.872-4.789.407-.4.8-.815 1.211-1.214a.9.9 0 0 1 1.382 0q.586.573 1.158 1.162a.889.889 0 0 1-.005 1.381q-3.929 3.953-7.867 7.9a.9.9 0 0 1-1.406 0q-2.242-2.24-4.475-4.489a.9.9 0 0 1-.011-1.436q.559-.575 1.132-1.135a.894.894 0 0 1 1.406.016c.792.79 1.577 1.587 2.366 2.38.086.085.177.167.237.224z"
      transform="translate(408.31 -686.588)"
      style={{ fill: "#478848" }}
    />
  </svg>
);

export const dataDictionaryIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    version="1.1"
    width={width || "32"}
    height={height || "32"}
    viewBox="0 0 32 32"
  >
    <path
      fill="#b1bac1"
      d="M25.337 0.006c-6.222-0.007-12.447-0.007-18.671 0-0.377 0-0.75 0.052-1.111 0.156-1.702 0.474-2.856 2.056-2.787 3.821 0 8.006 0 16.013 0 24.021 0 0.326 0.030 0.648 0.092 0.965 0.379 1.767 1.942 3.030 3.748 3.030 0.918 0 1.837 0 2.755 0 0 0 15.938 0 15.938 0 1.1 0.028 2.157-0.425 2.897-1.239 0.229-0.274 0.442-0.557 0.641-0.853 0 0-0.051-0.058-0.051-0.058s-21.83 0-21.83 0c-0.062 0.004-0.124 0.004-0.187 0-0.793-0.047-1.394-0.733-1.346-1.524 0-0.56 0-1.109 0-1.673-0.011-0.412 0.156-0.81 0.455-1.091 0.319-0.281 0.738-0.425 1.164-0.395 5.615 0 11.227 0 16.842 0 0.322 0.002 0.648-0.019 0.967-0.062 2.149-0.326 3.862-1.97 4.269-4.104 0.097-0.723 0.137-1.45 0.118-2.179 0-4.951 0-9.904 0-14.855 0-0.052 0-0.105 0-0.157-0.026-2.129-1.773-3.83-3.904-3.802 0 0 0 0 0 0M23.405 15.584c-0.673 2.472-2.719 4.333-5.249 4.766-0.853 0.18-1.726 0.264-2.599 0.251 0 0-6.057 0-6.057 0s0-16.679 0-16.679c0.086-0.004 0.141-0.009 0.199-0.013 2.144 0.002 4.29-0.013 6.433 0.013 1.406-0.013 2.792 0.319 4.040 0.963 1.591 0.83 2.764 2.288 3.233 4.022 0.656 2.179 0.656 4.499 0 6.677 0 0 0 0 0 0M18.225 6.73c-0.761-0.287-1.565-0.44-2.378-0.457-1.136-0.024-2.273-0.024-3.409-0.024-0.058 0.004-0.116 0.011-0.174 0.024 0 0 0 11.984 0 11.984 1.13 0 2.228 0.023 3.326-0.013 0.564-0.019 1.124-0.084 1.677-0.197 1.702-0.23 3.092-1.471 3.514-3.133 0.508-1.803 0.493-3.711-0.049-5.502-0.343-1.25-1.28-2.253-2.507-2.682 0 0 0 0 0 0"
    />
  </svg>
);

export const exclamationCircledIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "19"} height={height || "19"} viewBox="0 0 19 19">
    <defs>
      <style>{`.exclamation-circled-cls-1{fill:#dd5a43;stroke:#dd5a43} .exclamation-circled-cls-2{fill:#fff}`}</style>
    </defs>
    <g id="Group_2568" data-name="Group 2568" transform="translate(-854 -1147)">
      <g id="Group_1348" data-name="Group 1348" transform="translate(854 1147)">
        <g
          id="Ellipse_264"
          data-name="Ellipse 264"
          className="exclamation-circled-cls-1"
        >
          <circle cx="9.5" cy="9.5" r="9.5" style={{ stroke: "none" }} />
          <circle cx="9.5" cy="9.5" r="9" style={{ fill: "none" }} />
        </g>
      </g>
      <g
        id="Group_844"
        data-name="Group 844"
        transform="translate(862.534 1150.955)"
      >
        <path
          id="Path_2643"
          data-name="Path 2643"
          className="exclamation-circled-cls-2"
          d="M.724 2a.724.724 0 0 1 .724.724v6.065a.724.724 0 0 1-1.448 0V2.724A.724.724 0 0 1 .724 2z"
          transform="translate(.188 -2)"
        />
        <circle
          id="Ellipse_265"
          data-name="Ellipse 265"
          className="exclamation-circled-cls-2"
          cx=".98"
          cy=".98"
          transform="translate(0 8.433)"
          r=".98"
        />
      </g>
    </g>
  </svg>
);

export const userIconFilledCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "32.8px"}
    height={height || "32.8px"}
    viewBox="0 0 41 41"
  >
    <defs>
      <style>{`.cls-2{fill:#428bca;fillRule:evenodd}`}</style>
    </defs>
    <g
      id="Group_1749"
      data-name="Group 1749"
      transform="translate(-1106.933 -750.933)"
    >
      <circle
        id="Ellipse_15"
        data-name="Ellipse 15"
        cx="20.5"
        cy="20.5"
        r="20.5"
        transform="translate(1106.933 750.933)"
        style={{ opacity: "0.1", fill: "#428bca" }}
      />
      <g
        id="Group_136"
        data-name="Group 136"
        transform="translate(1118.328 761.387)"
      >
        <path
          id="Path_126"
          data-name="Path 126"
          className="cls-2"
          d="M1743.537 345.319h-5.327a2.97 2.97 0 0 1-3.282-3.3 10.981 10.981 0 0 1 .805-4.48 3.47 3.47 0 0 1 2.924-2.346 2.065 2.065 0 0 1 1 .217c.792.367 1.526.877 2.341 1.169a5.272 5.272 0 0 0 4.539-.593c.141-.081.271-.181.411-.262.467-.269.855-.68 1.5-.562a3.178 3.178 0 0 1 2.173 1.173 7.85 7.85 0 0 1 1.009 1.875 10.941 10.941 0 0 1 .531 4.331 2.82 2.82 0 0 1-2.809 2.758c-1.937.046-3.876.011-5.814.011z"
          transform="translate(-1734.928 -326.503)"
        />
        <path
          id="Path_127"
          data-name="Path 127"
          className="cls-2"
          d="M1784.405 251.546a4.7 4.7 0 1 1-4.678-4.714 4.662 4.662 0 0 1 4.678 4.714z"
          transform="translate(-1771.083 -246.832)"
        />
      </g>
    </g>
  </svg>
);

export const scanIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "14.321"}
    height={height || "14.321"}
    viewBox="0 0 14.321 14.321"
  >
    <defs>
      <style>{`.cls-1{fill:#fff}`}</style>
    </defs>
    <g
      id="Group_1858"
      data-name="Group 1858"
      transform="translate(-84.011 -129.238)"
    >
      <path
        id="Path_2733"
        data-name="Path 2733"
        className="cls-1"
        d="M91.191 269.219h6.554c.441 0 .587.147.587.59v.693a.455.455 0 0 1-.514.506H84.621c-.473 0-.609-.138-.609-.613v-.671a.455.455 0 0 1 .513-.506h3.355z"
        transform="translate(-.001 -133.716)"
      />
      <path
        id="Path_2734"
        data-name="Path 2734"
        className="cls-1"
        d="M85.8 131.028v2.192a.449.449 0 0 1-.483.492q-.413.007-.827 0a.448.448 0 0 1-.478-.5v-3.487a.444.444 0 0 1 .481-.49h3.509a.447.447 0 0 1 .483.49q.006.4 0 .8a.453.453 0 0 1-.505.493c-.714.012-1.429.01-2.18.01z"
      />
      <path
        id="Path_2735"
        data-name="Path 2735"
        className="cls-1"
        d="M306.662 131.029h-2.115c-.413 0-.569-.156-.57-.564v-.738a.446.446 0 0 1 .485-.487h3.509a.441.441 0 0 1 .478.471v3.531a.441.441 0 0 1-.458.47c-.283.007-.566.006-.849 0a.448.448 0 0 1-.48-.5v-2.183z"
        transform="translate(-210.121 -.001)"
      />
      <path
        id="Path_2736"
        data-name="Path 2736"
        className="cls-1"
        d="M85.8 351.868h1.911c.7 0 .774.074.774.784v.514a.448.448 0 0 1-.484.49h-3.509a.445.445 0 0 1-.48-.491v-3.487a.446.446 0 0 1 .478-.495q.413-.007.827 0a.449.449 0 0 1 .483.492v1.922z"
        transform="translate(0 -210.099)"
      />
      <path
        id="Path_2737"
        data-name="Path 2737"
        className="cls-1"
        d="M306.636 351.888v-2.113c0-.416.152-.57.561-.572h.738a.447.447 0 0 1 .49.484v3.509a.445.445 0 0 1-.492.48h-3.487a.448.448 0 0 1-.494-.48q-.008-.413 0-.827a.448.448 0 0 1 .494-.481h1.922z"
        transform="translate(-210.095 -210.12)"
      />
    </g>
  </svg>
);

export const calendarIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "12.934"}
    height={height || "13.93"}
    viewBox="0 0 12.934 13.93"
  >
    <defs>
      <style>{`.calendar-icon-cls-1{fill:#858585;fillRule:evenodd}`}</style>
    </defs>
    <path
      data-name="Path 2872"
      d="M131.951 311.844v-.788a1.224 1.224 0 0 1 1.206-1.2h.479a1.223 1.223 0 0 1 1.287 1.3v.68h3v-.77a1.217 1.217 0 0 1 1.2-1.207 4.6 4.6 0 0 1 .822.035 1.2 1.2 0 0 1 .947 1.169v.787c.333 0 .644.023.951-.005a1.034 1.034 0 0 1 1.049 1.055c-.011 3.271 0 6.542 0 9.813a.994.994 0 0 1-1.068 1.073h-10.8a.993.993 0 0 1-1.069-1.073V312.9a.985.985 0 0 1 1.045-1.056zm-.982 2.98v7.944h10.9v-7.944zm2.959-2.62v-.976c0-.325-.043-.378-.37-.379h-.26c-.3 0-.355.055-.356.354v1.736c0 .658 0 .658.658.648.256 0 .328-.077.329-.342l-.001-1.045zm5.971.022v-1.085c0-.2-.09-.295-.289-.291h-.369c-.274 0-.33.057-.331.33v1.758c0 .675 0 .675.673.65.229-.008.31-.087.313-.319.004-.349.004-.696.004-1.043z"
      transform="translate(-129.955 -309.851)"
      className="calendar-icon-cls-1"
    />
  </svg>
);

export const schedulecalendarIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "44"}
    height={height || "43"}
    viewBox="0 0 44 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_5214_106954"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="44"
      height="43"
    >
      <path
        d="M0.834961 8.01086e-05H43.165V42.3301H0.834961V8.01086e-05Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_5214_106954)">
      <path
        d="M33.492 3.72021H5.38223C3.55584 3.72021 2.0752 5.20086 2.0752 7.02725V11.9878H36.799V7.02725C36.799 5.20086 35.3185 3.72021 33.492 3.72021Z"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.01953 6.20068V1.24014"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.8545 6.20068V1.24014"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.9092 6.20068V1.24014"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9648 6.20068V1.24014"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.083 17.5684H24.1499"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7246 17.5684H16.7915"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.4404 17.5684H31.5073"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.36621 23.1494H9.43311"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7246 23.1494H16.7915"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.083 23.1494H24.1499"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.36621 28.73H9.43311"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7246 28.73H16.7915"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.925 31.9955C41.925 37.0181 37.8533 41.0898 32.8307 41.0898C27.808 41.0898 23.7363 37.0181 23.7363 31.9955C23.7363 26.9729 27.808 22.9012 32.8307 22.9012C37.8533 22.9012 41.925 26.9729 41.925 31.9955Z"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.8311 27.8618V31.9956H36.9648"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.799 23.8108V11.9881H2.0752V31.8303C2.0752 33.2 3.1857 34.3105 4.55547 34.3105H24.034"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const testConnectionIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "18.113"}
    height={height || "18.45"}
    viewBox="0 0 18.113 18.45"
  >
    <defs>
      <style>{`.text-conn-icon-1{fill:#fff}`}</style>
    </defs>
    <path
      className="text-conn-icon-1"
      data-name="Path 2875"
      d="m-109.13 7.782.286-.162a2.828 2.828 0 0 1 2.874-.02c.263.139.174.155.382-.052.768-.766 1.532-1.536 2.3-2.3a.165.165 0 0 0 .036-.237 2.179 2.179 0 0 1-.161-1.966 2.206 2.206 0 0 1 2.272-1.345 2.189 2.189 0 0 1 1.88 1.864 2.087 2.087 0 0 1-.913 2.075 2.1 2.1 0 0 1-2.252.135.179.179 0 0 0-.228.036c-.231.218-.464.434-.69.658-.581.575-1.158 1.155-1.74 1.73a.128.128 0 0 0-.019.2 2.739 2.739 0 0 1 .159 3.035 2.738 2.738 0 0 1-1.878 1.38c-.118.027-.145.074-.144.186q.006 1.335 0 2.67a.185.185 0 0 0 .155.211 2.18 2.18 0 0 1 1.53 1.654 2.169 2.169 0 0 1-1.865 2.587 2.18 2.18 0 0 1-2.4-1.78 2.17 2.17 0 0 1 1.578-2.465c.146-.036.182-.093.18-.236q-.011-1.3 0-2.593c0-.139-.037-.2-.176-.227a2.882 2.882 0 0 1-1.767-1.176 2.691 2.691 0 0 1-.4-.914.224.224 0 0 0-.259-.192h-2.1c-.131 0-.264.012-.394 0s-.17.043-.2.152a2.277 2.277 0 0 1-.572.962 2.09 2.09 0 0 1-1.776.6 2.14 2.14 0 0 1-1.628-3.209 2.034 2.034 0 0 1 2.046-1.094 2.093 2.093 0 0 1 1.865 1.415c0 .008.005.016.008.024.117.323.117.323.455.326.775.005 1.551.009 2.326.019.1 0 .149-.02.17-.13a3.986 3.986 0 0 1 .431-1.109.138.138 0 0 0-.025-.2q-.823-.813-1.636-1.636a.179.179 0 0 0-.24-.041 1.684 1.684 0 0 1-1.359.044 1.62 1.62 0 0 1-1.043-1.585 1.7 1.7 0 0 1 1.108-1.535 1.186 1.186 0 0 1 .323-.058c.126-.01.256.011.381-.005a1.6 1.6 0 0 1 1.5 1.411 1.886 1.886 0 0 1-.155.977.124.124 0 0 0 .023.169q.857.85 1.71 1.706a.5.5 0 0 0 .042.041zm3.7 2.249a1.967 1.967 0 0 0-2-1.96 2 2 0 0 0-1.941 2.012 2 2 0 0 0 2.154 1.933 1.979 1.979 0 0 0 1.782-1.984z"
      transform="translate(117.354 -1.683)"
    />
  </svg>
);

export const collapsedIconInCircle = (): JSX.Element => (
  <svg width="25" height="25" viewBox="0 0 25 25">
    <g data-name="Group 1274">
      <g data-name="Group 1261">
        <g
          data-name="Ellipse 263"
          style={{ fill: "#fafafa", stroke: "#328db5", strokeWidth: ".5px" }}
        >
          <circle cx="12.5" cy="12.5" r="12.5" style={{ stroke: "none" }} />
          <circle cx="12.5" cy="12.5" r="12.25" style={{ fill: "none" }} />
        </g>
      </g>
      <g data-name="Group 1272">
        <path
          data-name="Path 2432"
          d="M5.339 7.193a.4.4 0 0 0-.3-.136H1.661a.4.4 0 0 0-.4.4c0 .224.261.475.373.587l.854.854L0 11.361l1.175 1.175 2.45-2.5.854.854c.185.185.373.382.6.382a.4.4 0 0 0 .4-.4V7.494a.4.4 0 0 0-.14-.301zm4.762-3.6 2.435-2.419L11.361 0 8.943 2.429l-.869-.874c-.188-.189-.379-.391-.606-.391a.412.412 0 0 0-.411.414v3.458a.479.479 0 0 0 .442.445h3.436a.412.412 0 0 0 .411-.414c0-.229-.266-.487-.38-.6z"
          style={{ fill: "#428bca" }}
          transform="translate(6.676 5.889)"
        />
      </g>
    </g>
  </svg>
);

export const editInfoIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "39"} height={height || "39"} viewBox="0 0 48 48">
    <defs>
      <style>{`.edit-infoicon-in-circle-cls-2{fill:#428bca}`}</style>
      <style>{`.edit-infoicon-in-circle-cls-2-g{fill: #fff; stroke: #428bca}`}</style>
      <style>{`.edit-infoicon-in-circle-cls1-circle1{stroke: none}`}</style>
      <style>{`.edit-infoicon-in-circle-cls1-circle2{fill: none}`}</style>
    </defs>
    <g
      id="Group_1947"
      data-name="Group 1947"
      transform="translate(-1575 -672.8)"
    >
      <g
        id="Group_1461"
        data-name="Group 1461"
        transform="translate(-272 603.8)"
      >
        <g
          id="Group_1163"
          data-name="Group 1163"
          transform="translate(427.851 -281.148)"
        >
          <g
            id="Group_742"
            data-name="Group 742"
            transform="translate(1419.147 350.147)"
          >
            <g
              id="Ellipse_263"
              data-name="Ellipse 263"
              transform="translate(.002 .001)"
              className="edit-infoicon-in-circle-cls-2-g"
            >
              <circle
                cx="24"
                cy="24"
                r="24"
                className="edit-infoicon-in-circle-cls1-circle1"
              />
              <circle
                cx="24"
                cy="24"
                r="23.5"
                className="edit-infoicon-in-circle-cls1-circle2"
              />
            </g>
          </g>
        </g>
      </g>
      <g
        id="Group_1945"
        data-name="Group 1945"
        transform="translate(248 -232.221)"
      >
        <g
          id="Group_846"
          data-name="Group 846"
          transform="translate(1342 918.954)"
        >
          <g id="Group_845" data-name="Group 845">
            <path
              id="Path_2270"
              data-name="Path 2270"
              className="edit-infoicon-in-circle-cls-2"
              d="M896.283-61.5v-5.312a.282.282 0 0 1 .094-.219q5.354-5.35 10.705-10.7l.072-.069 5.438 5.444c0 .005-.032.035-.06.064q-5.359 5.361-10.721 10.719a.263.263 0 0 1-.163.077q-2.633.006-5.267 0c-.029-.004-.056-.004-.098-.004zm5.929-2.843-3.079-3.074c-.372.372-.753.752-1.131 1.135a.191.191 0 0 0-.04.123v1.224a.978.978 0 0 0 .011.1h1.667v1.653c.016.007.022.013.029.013h1.316a.14.14 0 0 0 .089-.038l1.138-1.138zm-1.738-3.564a.343.343 0 0 0 .266-.133l7-7a.71.71 0 0 0 .083-.094.326.326 0 0 0-.02-.393.33.33 0 0 0-.394-.012.812.812 0 0 0-.093.085l-6.987 6.985a.641.641 0 0 0-.1.122.281.281 0 0 0 .245.438z"
              transform="translate(-896.281 81.327)"
            />
            <path
              id="Path_2271"
              data-name="Path 2271"
              className="edit-infoicon-in-circle-cls-2"
              d="m1414.3-223.573-5.44-5.439c.022-.024.045-.053.071-.078l2.136-2.123a1.645 1.645 0 0 1 2.3.024c.729.717 1.451 1.442 2.176 2.164.292.291.58.586.877.872a1.71 1.71 0 0 1 0 2.465c-.7.664-1.364 1.357-2.043 2.037-.023.026-.051.051-.077.078z"
              transform="translate(-1397.118 231.671)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const infoIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "39"} height={height || "39"} viewBox="0 0 48 48">
    <defs>
      <style>{`.infoIconInCircle-cls1{fill: #fff; stroke: #428bca}`}</style>
      <style>{`.infoIconInCircle-cls1-circle1{stroke: none}`}</style>
      <style>{`.infoIconInCircle-cls1-circle2{fill: none}`}</style>
      <style>{`.infoIconInCircle-cls1Path{fill: #428bca}`}</style>
    </defs>
    <g data-name="Group 1946">
      <g data-name="Group 1460">
        <g data-name="Group 1163">
          <g data-name="Group 742">
            <g data-name="Ellipse 263" className="infoIconInCircle-cls1">
              <circle
                cx="24"
                cy="24"
                r="24"
                className="infoIconInCircle-cls1-circle1"
              />
              <circle
                cx="24"
                cy="24"
                r="23.5"
                className="infoIconInCircle-cls1-circle2"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        data-name="Icon awesome-info"
        d="M.833 17.676h.833v-6.019H.833A.833.833 0 0 1 0 10.824V8.833A.833.833 0 0 1 .833 8H5.5a.833.833 0 0 1 .833.833v8.843h.833A.833.833 0 0 1 8 18.51v1.99a.833.833 0 0 1-.833.833H.833A.833.833 0 0 1 0 20.5v-1.99a.833.833 0 0 1 .833-.834zM4 0a3 3 0 1 0 3 3 3 3 0 0 0-3-3z"
        transform="translate(20 12.657)"
        className="infoIconInCircle-cls1Path"
      />
    </g>
  </svg>
);

export const romanInfoIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.1316 17.5H12.8684V10.8421H11.1316V17.5ZM12 8.86033C12.265 8.86033 12.4871 8.77071 12.6663 8.59147C12.8456 8.41222 12.9352 8.19011 12.9352 7.92513C12.9352 7.66016 12.8456 7.43805 12.6663 7.25879C12.4871 7.07954 12.265 6.98992 12 6.98992C11.735 6.98992 11.5129 7.07954 11.3337 7.25879C11.1544 7.43805 11.0648 7.66016 11.0648 7.92513C11.0648 8.19011 11.1544 8.41222 11.3337 8.59147C11.5129 8.77071 11.735 8.86033 12 8.86033ZM12.0019 23C10.4805 23 9.0505 22.7113 7.71181 22.1339C6.37311 21.5565 5.20863 20.7729 4.21838 19.7831C3.2281 18.7932 2.44414 17.6293 1.86648 16.2912C1.28883 14.9531 1 13.5233 1 12.0019C1 10.4805 1.2887 9.0505 1.86611 7.71181C2.44351 6.37311 3.22712 5.20863 4.21693 4.21838C5.20676 3.22811 6.37073 2.44414 7.70883 1.86649C9.04692 1.28883 10.4767 1 11.9981 1C13.5195 1 14.9495 1.2887 16.2882 1.86611C17.6269 2.44351 18.7914 3.22712 19.7816 4.21693C20.7719 5.20676 21.5559 6.37073 22.1335 7.70883C22.7112 9.04692 23 10.4767 23 11.9981C23 13.5195 22.7113 14.9495 22.1339 16.2882C21.5565 17.6269 20.7729 18.7914 19.7831 19.7816C18.7932 20.7719 17.6293 21.5559 16.2912 22.1335C14.9531 22.7112 13.5233 23 12.0019 23ZM12 21.2632C14.586 21.2632 16.7763 20.3658 18.5711 18.5711C20.3658 16.7763 21.2632 14.586 21.2632 12C21.2632 9.41403 20.3658 7.22367 18.5711 5.42893C16.7763 3.63419 14.586 2.73682 12 2.73682C9.41403 2.73682 7.22367 3.63419 5.42893 5.42893C3.63419 7.22367 2.73682 9.41403 2.73682 12C2.73682 14.586 3.63419 16.7763 5.42893 18.5711C7.22367 20.3658 9.41403 21.2632 12 21.2632Z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="0.25"
    />
  </svg>
);

export const filledRomanInfoIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "22"}
    height={height || "22"}
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M10.1316 16.5H11.8684V9.8421H10.1316V16.5ZM11 7.86033C11.265 7.86033 11.4871 7.77071 11.6663 7.59147C11.8456 7.41222 11.9352 7.19011 11.9352 6.92513C11.9352 6.66016 11.8456 6.43805 11.6663 6.25879C11.4871 6.07954 11.265 5.98992 11 5.98992C10.735 5.98992 10.5129 6.07954 10.3337 6.25879C10.1544 6.43805 10.0648 6.66016 10.0648 6.92513C10.0648 7.19011 10.1544 7.41222 10.3337 7.59147C10.5129 7.77071 10.735 7.86033 11 7.86033ZM11.0019 22C9.48054 22 8.0505 21.7113 6.71181 21.1339C5.37311 20.5565 4.20863 19.7729 3.21838 18.7831C2.2281 17.7932 1.44414 16.6293 0.866484 15.2912C0.288828 13.9531 0 12.5233 0 11.0019C0 9.48054 0.288703 8.0505 0.866108 6.71181C1.44351 5.37311 2.22712 4.20863 3.21693 3.21838C4.20676 2.22811 5.37073 1.44414 6.70883 0.866485C8.04692 0.288829 9.47666 0 10.9981 0C12.5195 0 13.9495 0.288704 15.2882 0.866109C16.6269 1.44351 17.7914 2.22712 18.7816 3.21693C19.7719 4.20676 20.5559 5.37073 21.1335 6.70883C21.7112 8.04692 22 9.47666 22 10.9981C22 12.5195 21.7113 13.9495 21.1339 15.2882C20.5565 16.6269 19.7729 17.7914 18.7831 18.7816C17.7932 19.7719 16.6293 20.5559 15.2912 21.1335C13.9531 21.7112 12.5233 22 11.0019 22Z"
      fill="#428BCA"
    />
  </svg>
);

export const booleanIcon = (
  <svg width="17" height="11" viewBox="0 0 22 13">
    <defs>
      <style>{`.booleanIcon-circle-cls1{fill: #515151}`}</style>
    </defs>
    <g id="Group_2244" data-name="Group 2244" transform="translate(-831 -1160)">
      <g
        id="Rectangle_1533"
        data-name="Rectangle 1533"
        transform="translate(831 1160)"
        fill="#fff"
        stroke="#515151"
        strokeWidth="2"
      >
        <rect width="22" height="13" rx="6.5" stroke="none" />
        <rect x="1" y="1" width="20" height="11" rx="5.5" fill="none" />
      </g>
      <circle
        id="Ellipse_285"
        data-name="Ellipse 285"
        cx="2.5"
        cy="2.5"
        r="2.5"
        transform="translate(835 1164)"
        className="booleanIcon-circle-cls1"
      />
    </g>
  </svg>
);
export const dateTimeIcon = (
  <svg width="15.2" height="17.12" viewBox="0 0 19.607 21.482">
    <g
      id="Group_2243"
      data-name="Group 2243"
      transform="translate(785.129 -28.126)"
    >
      <path
        id="Path_2783"
        data-name="Path 2783"
        d="M-546.6,315.228a5.761,5.761,0,0,0-.851-2.584,5.925,5.925,0,0,0-2.776-2.379,5.658,5.658,0,0,0-1.7-.426c-.192-.018-.385-.026-.574-.026a5.788,5.788,0,0,0-2.545.585,5.912,5.912,0,0,0-2.433,2.166,5.819,5.819,0,0,0-.858,2.29,5.828,5.828,0,0,0-.05,1.294,5.847,5.847,0,0,0,.853,2.649,5.933,5.933,0,0,0,2.2,2.107,5.641,5.641,0,0,0,1.921.658c.14.021.282.034.419.047l.2.019.024,0,.022,0,.011,0h.5l.089-.009.163-.015a5.766,5.766,0,0,0,2.572-.843,5.919,5.919,0,0,0,2.223-2.42,5.6,5.6,0,0,0,.559-1.8c.015-.113.025-.228.035-.339.005-.057.01-.114.016-.17,0-.011,0-.021.005-.031v0l0-.023,0-.01v-.494l-.009-.089C-546.587,315.337-546.593,315.282-546.6,315.228Zm-2.695,3.683a4.485,4.485,0,0,1-3.2,1.331h-.046a4.483,4.483,0,0,1-3.18-1.365A4.488,4.488,0,0,1-557,315.662a4.533,4.533,0,0,1,4.52-4.453h.05a4.531,4.531,0,0,1,4.462,4.518A4.485,4.485,0,0,1-549.292,318.911Z"
        transform="translate(-218.949 -272.031)"
        fill="#515151"
      />
      <path
        id="Path_2784"
        data-name="Path 2784"
        d="M-777.38,45.891H-783.7V35.008h14.979V37.97a6.408,6.408,0,0,1,1.381.891q0-1.545,0-3.091c0-1.182.006-2.364,0-3.547A1.361,1.361,0,0,0-768.7,30.9h-1.368c0-.366,0-.707,0-1.047a1.679,1.679,0,0,0-1.331-1.636,6.346,6.346,0,0,0-1.069-.043,1.7,1.7,0,0,0-1.691,1.689c0,.339,0,.679,0,1.024h-4.092c0-.377,0-.74,0-1.1a1.665,1.665,0,0,0-1.348-1.565,7.639,7.639,0,0,0-1.035-.045,1.688,1.688,0,0,0-1.708,1.707c0,.334,0,.667,0,1.018-.153,0-.288,0-.423,0-.425.012-.853,0-1.273.048a1.267,1.267,0,0,0-.99,1.026c-.037.4-.04.8-.042,1.207,0,1.063,0,2.126,0,3.189s0,2.148,0,3.223,0,2.126,0,3.188c0,1.04-.01,2.08,0,3.12a1.384,1.384,0,0,0,1.308,1.359h7.1c-.062-.09-.122-.181-.179-.275A6.294,6.294,0,0,1-777.38,45.891Zm4.579-14.482h0c0-.488,0-.977,0-1.465,0-.277.128-.4.407-.4.193,0,.386,0,.579,0a.342.342,0,0,1,.375.368q0,1.516,0,3.033a.321.321,0,0,1-.324.344c-.238.011-.477.01-.715,0a.327.327,0,0,1-.325-.361C-772.8,32.42-772.8,31.915-772.8,31.409Zm-8.182-1.53a.321.321,0,0,1,.332-.337c.238-.009.477-.009.716,0a.323.323,0,0,1,.316.351c0,.506,0,1.011,0,1.517h0c0,.489,0,.977,0,1.466,0,.29-.125.413-.415.413-.188,0-.375,0-.562,0a.342.342,0,0,1-.385-.375Q-780.986,31.4-780.983,29.879Z"
        fill="#515151"
        stroke="#515151"
        strokeWidth="0.1"
      />
      <path
        id="Path_2785"
        data-name="Path 2785"
        d="M-399.3,402.384c-.578-.348-1.156-.7-1.736-1.041a.165.165,0,0,1-.094-.167q0-1.413,0-2.827v-.074h-.863a.149.149,0,0,0,0,.023q0,1.706,0,3.413a.088.088,0,0,0,.039.061c.222.139.445.276.668.414l2,1.229.306.188.461-.75-.029-.02Z"
        transform="translate(-370.022 -357.476)"
        fill="#515151"
      />
    </g>
  </svg>
);
export const dateIcon = (
  <svg width="13.6" height="14" viewBox="0 0 16.884 18.161">
    <path
      id="Path_2782"
      data-name="Path 2782"
      d="M-782.494,30.756c0-.332,0-.648,0-.964a1.6,1.6,0,0,1,1.616-1.615,7.227,7.227,0,0,1,.979.042,1.575,1.575,0,0,1,1.276,1.48c0,.344,0,.687,0,1.044h3.871c0-.326,0-.647,0-.969a1.6,1.6,0,0,1,1.6-1.6,6.005,6.005,0,0,1,1.011.041,1.589,1.589,0,0,1,1.26,1.548c0,.322,0,.644,0,.99h1.295a1.287,1.287,0,0,1,1.283,1.25c.01,1.118,0,2.237,0,3.356q0,1.525,0,3.049c0,1.033,0,2.065,0,3.1q0,1.686,0,3.372a1.324,1.324,0,0,1-1.058,1.337,1.034,1.034,0,0,1-.224.019q-7.132,0-14.264,0a1.309,1.309,0,0,1-1.237-1.286c-.008-.984,0-1.968,0-2.952q0-1.508,0-3.017,0-1.525,0-3.049c0-1.006,0-2.011,0-3.017,0-.381,0-.763.039-1.142a1.2,1.2,0,0,1,.937-.971c.4-.048.8-.034,1.2-.046C-782.767,30.753-782.64,30.756-782.494,30.756Zm12.89,14.181V34.64h-14.172v10.3Zm-10.31-13.7h0c0-.479,0-.957,0-1.436a.305.305,0,0,0-.3-.332c-.226-.008-.452-.008-.677,0a.3.3,0,0,0-.314.319q0,1.436,0,2.871a.323.323,0,0,0,.365.354c.177,0,.355,0,.532,0,.274,0,.392-.117.392-.391C-779.913,32.161-779.914,31.7-779.914,31.236Zm6.453,0h0c0,.478,0,.957,0,1.435a.31.31,0,0,0,.307.342c.226.008.452.009.677,0a.3.3,0,0,0,.306-.326q0-1.435,0-2.87a.323.323,0,0,0-.355-.348c-.183,0-.365,0-.548,0-.264,0-.385.12-.385.383C-773.462,30.311-773.461,30.773-773.461,31.235Z"
      transform="translate(785.129 -28.126)"
      fill="#515151"
      stroke="#515151"
      strokeWidth="0.1"
    />
  </svg>
);

export const userShieldIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.664"
    height="18.131"
    viewBox="0 0 22.664 18.131"
  >
    <path
      d="m22.037 9.6-4.08-1.594a1.1 1.1 0 0 0-.786 0L13.092 9.6a.958.958 0 0 0-.627.882 8.051 8.051 0 0 0 4.706 7.575 1.1 1.1 0 0 0 .786 0 8.024 8.024 0 0 0 4.706-7.575.958.958 0 0 0-.626-.882zm-4.473 6.774v-6.7L20.947 11a6.335 6.335 0 0 1-3.382 5.376zM7.932 9.066A4.533 4.533 0 1 0 3.4 4.533a4.533 4.533 0 0 0 4.532 4.533zm3.4 1.417a2.012 2.012 0 0 1 .039-.255c-.089 0-.174-.028-.266-.028h-.591a6.165 6.165 0 0 1-5.163 0h-.592A4.761 4.761 0 0 0 0 14.958v1.473a1.7 1.7 0 0 0 1.7 1.7h12.465a1.743 1.743 0 0 0 .68-.142 9.515 9.515 0 0 1-3.513-7.507z"
      fill="#999"
    />
  </svg>
);

export const solidShieldIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.01"
    height="16.009"
    viewBox="0 0 15.01 16.009"
  >
    <path
      d="m30.088 2.642-6-2.5a1.506 1.506 0 0 0-1.154 0l-6 2.5A1.5 1.5 0 0 0 16 4.027c0 6.207 3.581 10.5 6.926 11.892a1.506 1.506 0 0 0 1.154 0c2.68-1.116 6.93-4.972 6.93-11.892a1.5 1.5 0 0 0-.922-1.385zm-6.58 11.338V2.066l5.5 2.292c-.108 4.735-2.57 8.165-5.5 9.622z"
      transform="translate(-16 -.025)"
      fill="#999"
    />
  </svg>
);

export const cloudGearIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23.141"
    height="16.407"
    viewBox="0 0 23.141 16.407"
  >
    <path
      data-name="Subtraction 5"
      d="M18.513 16.407H5.207a5.284 5.284 0 0 1-1.729-10.25v-.05c0-.081-.006-.165-.006-.248a5.773 5.773 0 0 1 10.8-2.923 3.419 3.419 0 0 1 1.928-.593 3.5 3.5 0 0 1 3.471 3.516 3.566 3.566 0 0 1-.231 1.267 4.693 4.693 0 0 1-.926 9.28zm-9.221-4.2a3.414 3.414 0 0 0 1.11.649v.91a.22.22 0 0 0 .171.216 4.527 4.527 0 0 0 1.994 0 .22.22 0 0 0 .171-.216v-.91a3.528 3.528 0 0 0 1.111-.65l.778.455a.22.22 0 0 0 .11.03.214.214 0 0 0 .16-.073 4.621 4.621 0 0 0 1-1.749.23.23 0 0 0-.1-.261l-.778-.455a3.558 3.558 0 0 0 0-1.3l.778-.455a.225.225 0 0 0 .1-.259 4.647 4.647 0 0 0-1-1.749.219.219 0 0 0-.162-.072.212.212 0 0 0-.108.03l-.778.454a3.44 3.44 0 0 0-1.111-.649v-.904a.22.22 0 0 0-.171-.216 4.543 4.543 0 0 0-1.994 0 .22.22 0 0 0-.171.216v.91a3.528 3.528 0 0 0-1.111.65l-.776-.455a.22.22 0 0 0-.11-.03.214.214 0 0 0-.16.073 4.621 4.621 0 0 0-1 1.749.224.224 0 0 0 .1.259l.778.455a3.6 3.6 0 0 0 0 1.3l-.778.455a.224.224 0 0 0-.1.259 4.647 4.647 0 0 0 1 1.749.219.219 0 0 0 .162.072.212.212 0 0 0 .108-.03l.778-.455zm2.276-1.222a1.48 1.48 0 1 1 1.461-1.48 1.472 1.472 0 0 1-1.461 1.482z"
      fill="#999"
    />
  </svg>
);

export const cloudKeyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23.138"
    height="16.407"
    viewBox="0 0 23.138 16.407"
  >
    <path
      data-name="Subtraction 6"
      d="M18.51 16.407H5.206A5.285 5.285 0 0 1 3.478 6.156v-.297a5.771 5.771 0 0 1 10.8-2.922 3.413 3.413 0 0 1 1.922-.593 3.5 3.5 0 0 1 3.471 3.515 3.579 3.579 0 0 1-.231 1.267 4.693 4.693 0 0 1-.926 9.28zm-8.708-9a2.724 2.724 0 0 0-2.62 2.038 2.765 2.765 0 0 0 .254 2.061 2.7 2.7 0 0 0 4.989-.638 2.924 2.924 0 0 0 .085-.508l.5-.254a.375.375 0 0 0 .192-.238l.148-.561.6.162a.367.367 0 0 0 .1.013.372.372 0 0 0 .35-.282l.16-.6.6.161a.367.367 0 0 0 .1.013.372.372 0 0 0 .357-.278l.447-1.69a.379.379 0 0 0-.036-.282.368.368 0 0 0-.227-.178l-1.163-.316a.37.37 0 0 0-.281.038l-3.065 1.789a2.7 2.7 0 0 0-1.492-.45zm-.9 4.029a.738.738 0 0 1-.645-.382.754.754 0 0 1-.07-.562.743.743 0 0 1 .713-.556.727.727 0 0 1 .192.026.736.736 0 0 1 .453.356.754.754 0 0 1 .07.562.743.743 0 0 1-.715.556z"
      fill="#999"
    />
  </svg>
);

export const copyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.609"
    height="16.696"
    viewBox="0 0 14.609 16.696"
  >
    <path
      d="M14.15 2.15 12.458.458A1.565 1.565 0 0 0 11.352 0H5.739a1.565 1.565 0 0 0-1.565 1.565V3.13H1.565A1.565 1.565 0 0 0 0 4.7v10.43a1.565 1.565 0 0 0 1.565 1.57h7.3a1.565 1.565 0 0 0 1.565-1.565v-1.57h2.609A1.565 1.565 0 0 0 14.609 12V3.257a1.565 1.565 0 0 0-.459-1.107zM8.674 15.13H1.761a.2.2 0 0 1-.2-.2V4.891a.2.2 0 0 1 .2-.2h2.413V12a1.565 1.565 0 0 0 1.565 1.565H8.87v1.37a.2.2 0 0 1-.196.195zM12.848 12H5.935a.2.2 0 0 1-.2-.2V1.761a.2.2 0 0 1 .2-.2h3.456v2.87a.783.783 0 0 0 .783.783h2.87V11.8a.2.2 0 0 1-.2.2zm.2-8.348h-2.092V1.565h.314a.2.2 0 0 1 .138.057L12.986 3.2a.2.2 0 0 1 .057.138z"
      fill="#428bca"
    />
  </svg>
);

export const copyTextIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "20"}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.333 18.958H6.666c-2.516 0-3.958-1.442-3.958-3.959V6.874c0-2.625 1.333-3.958 3.958-3.958a.63.63 0 0 1 .625.625 1.249 1.249 0 0 0 1.25 1.25h2.917c.692 0 1.25-.558 1.25-1.25a.63.63 0 0 1 .625-.625c2.625 0 3.958 1.333 3.958 3.958V15c0 2.517-1.441 3.959-3.958 3.959zM6.125 4.183c-1.317.108-2.167.7-2.167 2.691V15c0 1.85.858 2.709 2.708 2.709h6.667c1.85 0 2.708-.859 2.708-2.709V6.874c0-1.991-.85-2.575-2.166-2.691a2.505 2.505 0 0 1-2.417 1.858H8.541a2.477 2.477 0 0 1-1.766-.733 2.517 2.517 0 0 1-.65-1.125z"
      fill="#fff"
    />
    <path
      d="M11.458 6.041H8.54a2.477 2.477 0 0 1-1.767-.733 2.477 2.477 0 0 1-.733-1.767c0-1.375 1.125-2.5 2.5-2.5h2.917c.666 0 1.291.258 1.766.733.475.475.734 1.1.734 1.767 0 1.375-1.125 2.5-2.5 2.5zM8.54 2.291a1.248 1.248 0 0 0-.883 2.133c.233.234.55.367.883.367h2.917a1.248 1.248 0 0 0 .883-2.133 1.249 1.249 0 0 0-.883-.367H8.54z"
      fill="#fff"
    />
  </svg>
);

export const redirectCircledIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "33"} height={height || "33"} viewBox="0 0 33 33">
    <defs>
      <style>
        {`.redirect-icon-cls-2{stroke:#428bca;fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px}`}
      </style>
    </defs>
    <g id="Group_1733" data-name="Group 1733" transform="translate(0 -.3)">
      <g id="Group_742" data-name="Group 742" transform="translate(0 .5)">
        <g
          id="Ellipse_263"
          data-name="Ellipse 263"
          transform="translate(0 -.2)"
          style={{ stroke: "#428bca", fill: "#fff" }}
        >
          <circle cx="16.5" cy="16.5" r="16.5" style={{ stroke: "none" }} />
          <circle cx="16.5" cy="16.5" r="16" style={{ fill: "none" }} />
        </g>
      </g>
      <g
        id="Icon_feather-arrow-upRight"
        data-name="Icon feather-arrow-upRight"
        transform="translate(12 12.3)"
      >
        <path
          id="Path_2392"
          data-name="Path 2392"
          className="redirect-icon-cls-2"
          d="m10.5 19.208 8.708-8.708"
          transform="translate(-10.5 -10.5)"
        />
        <path
          id="Path_2393"
          data-name="Path 2393"
          className="redirect-icon-cls-2"
          d="M10.5 10.5h8.708v8.708"
          transform="translate(-10.5 -10.5)"
        />
      </g>
    </g>
  </svg>
);

export const termEndorseIcon = (
  <svg width="48" height="48" viewBox="0 0 60 60">
    <g data-name="Group 1164">
      <g
        data-name="Ellipse 276"
        style={{
          fill: "#deeadc",
          stroke: "#5f9856",
          strokeWidth: ".5px",
          opacity: ".34",
        }}
      >
        <circle cx="30" cy="30" r="30" style={{ stroke: "none" }} />
        <circle cx="30" cy="30" r="29.75" style={{ fill: "none" }} />
      </g>
      <path
        data-name="Exclusion 1"
        d="M22.305 31.935H2.623A2.593 2.593 0 0 1 0 29.379V2.553A2.592 2.592 0 0 1 2.623 0h10.744v6.387a3.646 3.646 0 0 0 3.69 3.593h7.871v19.4a2.593 2.593 0 0 1-2.623 2.555zM7.45 17.43a.711.711 0 0 0-.5.2l-1.685 1.63a.682.682 0 0 0-.008.982l4.9 4.816a.723.723 0 0 0 .511.208.705.705 0 0 0 .5-.2l8.489-8.2a.678.678 0 0 0 .008-.982L17.99 14.24a.735.735 0 0 0-.512-.206.7.7 0 0 0-.5.2l-6.286 6.086-2.731-2.682a.727.727 0 0 0-.511-.208zM24.518 7.9h-7.461A1.541 1.541 0 0 1 15.5 6.387V.6a.6.6 0 0 1 .6-.592A2.651 2.651 0 0 1 17.794.6l6.257 5.075a2.328 2.328 0 0 1 .877 1.825.4.4 0 0 1-.41.4z"
        transform="translate(18.295 13.514)"
        style={{ fill: "#5f9856" }}
      />
    </g>
  </svg>
);

export const categoryIcon = (): JSX.Element => (
  <svg width="11.84" height="10.4" viewBox="0 0 14.814 12.155">
    <defs>
      <style>{`.categoryicon-cls1{fill:#bcbdc3}`}</style>
    </defs>
    <g
      id="_353400_briefcase_old_style_icon"
      data-name="353400_briefcase_old_style_icon"
      transform="translate(-6.878 -11.387)"
    >
      <path
        id="Path_2649"
        data-name="Path 2649"
        className="categoryicon-cls1"
        d="M30.99 34.14v-.33a.726.726 0 1 0-1.453 0v.329a.726.726 0 1 0 1.453 0z"
        transform="translate(-15.978 -15.3)"
      />
      <path
        id="Path_2650"
        data-name="Path 2650"
        className="categoryicon-cls1"
        d="M16.221 37.547a1.278 1.278 0 0 1-2.449 0h-5a2.047 2.047 0 0 1-.882-.2v3.322a1.183 1.183 0 0 0 1.179 1.179h11.86a1.183 1.183 0 0 0 1.179-1.179v-3.323a2.048 2.048 0 0 1-.882.2h-5z"
        transform="translate(-.712 -18.305)"
      />
      <path
        id="Path_2651"
        data-name="Path 2651"
        className="categoryicon-cls1"
        d="M20.464 13.276h-2.831a2.246 2.246 0 0 0-2.214-1.889h-2.268a2.246 2.246 0 0 0-2.214 1.889h-2.83a1.208 1.208 0 0 0-1.229 1.179v2.722a1.179 1.179 0 0 0 1.179 1.179H13a1.28 1.28 0 0 1 .393-.865l.023-.019a1.3 1.3 0 0 1 .162-.129c.021-.014.044-.023.066-.036a1.26 1.26 0 0 1 .147-.077 1.284 1.284 0 0 1 .126-.039c.037-.011.071-.025.109-.033a1.271 1.271 0 0 1 .254-.026 1.291 1.291 0 0 1 .254.026c.038.008.073.022.109.033a1.211 1.211 0 0 1 .126.04 1.275 1.275 0 0 1 .146.077c.022.013.045.022.066.036a1.264 1.264 0 0 1 .162.129l.023.019a1.279 1.279 0 0 1 .393.865h4.947a1.179 1.179 0 0 0 1.179-1.179v-2.722a1.208 1.208 0 0 0-1.221-1.18zm-8.391 0a1.138 1.138 0 0 1 1.078-.785h2.268a1.138 1.138 0 0 1 1.078.785z"
      />
    </g>
  </svg>
);

export const managedByIcon = (): JSX.Element => (
  <svg width="16.24" height="11.68" viewBox="0 0 20.309 14.609">
    <defs>
      <style>{` .managed-by-icon-cls-1{fill:#d2d2d2}`}</style>
    </defs>
    <g
      id="Group_2653"
      data-name="Group 2653"
      transform="translate(92.761 -107.619)"
    >
      <path
        id="Path_2848"
        data-name="Path 2848"
        className="managed-by-icon-cls-1"
        d="M485.751 506.881h1.587a1.217 1.217 0 0 1 1.258 1.257v1.942a1.218 1.218 0 0 1-1.256 1.261q-1.587.006-3.174 0a1.213 1.213 0 0 1-1.255-1.259v-1.955a1.21 1.21 0 0 1 1.24-1.247c.534-.001 1.067.001 1.6.001z"
        transform="translate(-561.049 -389.12)"
      />
      <path
        id="Path_2849"
        data-name="Path 2849"
        className="managed-by-icon-cls-1"
        d="M197.907 506.887h1.587a1.214 1.214 0 0 1 1.253 1.248v1.968a1.208 1.208 0 0 1-1.22 1.243q-1.625.014-3.25 0a1.209 1.209 0 0 1-1.216-1.248v-1.955a1.216 1.216 0 0 1 1.259-1.256h1.587z"
        transform="translate(-280.509 -389.126)"
      />
      <path
        id="Path_2850"
        data-name="Path 2850"
        className="managed-by-icon-cls-1"
        d="M-89.915 506.878h1.6a1.207 1.207 0 0 1 1.243 1.23q.007 1 0 1.993a1.2 1.2 0 0 1-1.212 1.236q-1.631.017-3.263 0a1.193 1.193 0 0 1-1.2-1.2q-.018-1.028 0-2.056a1.2 1.2 0 0 1 1.236-1.2c.53-.005 1.063-.003 1.596-.003z"
        transform="translate(0 -389.117)"
      />
      <path
        id="Path_2851"
        data-name="Path 2851"
        className="managed-by-icon-cls-1"
        d="M197.924 107.62h1.562a1.217 1.217 0 0 1 1.281 1.284v1.9a1.215 1.215 0 0 1-1.268 1.27h-3.149a1.216 1.216 0 0 1-1.269-1.271v-1.917a1.217 1.217 0 0 1 1.27-1.271c.523.003 1.049.005 1.573.005z"
        transform="translate(-280.529)"
      />
      <path
        id="Path_2852"
        data-name="Path 2852"
        className="managed-by-icon-cls-1"
        d="M2.4 319.574a13.311 13.311 0 0 1 .083-1.644 1.98 1.98 0 0 1 1.99-1.6h5.254v-.8h.816v.8h5.253a2.022 2.022 0 0 1 2 1.55 2.257 2.257 0 0 1 .06.477c.009.368 0 .736 0 1.1 0 .033 0 .066-.006.107h-.807v-.146c-.005-.41.018-.823-.022-1.23a1.186 1.186 0 0 0-1.206-1.05h-5.267v2.427h-.81v-2.427H4.487a1.218 1.218 0 0 0-1.25 1.229c-.006.351 0 .7 0 1.054v.144z"
        transform="translate(-92.743 -202.632)"
      />
    </g>
  </svg>
);

export const doomianIcon = (): JSX.Element => (
  <svg width="12.8" height="12" viewBox="0 0 16 15">
    <defs>
      <style>{`.domain-icon-cls-2{fill:#fff}`}</style>
      <style>{`.domain-icon-cls-223{fill:#bdbec4;stroke:#bdbec4}`}</style>
    </defs>
    <g id="Group_2646" data-name="Group 2646" transform="translate(-96 -146)">
      <g
        id="Rectangle_1343"
        data-name="Rectangle 1343"
        transform="translate(96 146)"
        className="domain-icon-cls-223"
      >
        <rect width="16" height="15" rx="2" style={{ stroke: "none" }} />
        <rect
          x=".5"
          y=".5"
          width="15"
          height="14"
          rx="1.5"
          style={{ fill: "none" }}
        />
      </g>
      <g
        id="_353400_briefcase_old_style_icon"
        data-name="353400_briefcase_old_style_icon"
        transform="translate(92.122 137.613)"
      >
        <path
          id="Path_2649"
          data-name="Path 2649"
          className="domain-icon-cls-2"
          d="M30.535 33.809v-.226a.5.5 0 1 0-1 0v.226a.5.5 0 1 0 1 0z"
          transform="translate(-18.067 -17.3)"
        />
        <path
          id="Path_2650"
          data-name="Path 2650"
          className="domain-icon-cls-2"
          d="M13.615 37.484a.878.878 0 0 1-1.683 0H8.493a1.407 1.407 0 0 1-.606-.138v2.283a.813.813 0 0 0 .811.811h8.152a.813.813 0 0 0 .811-.811v-2.283a1.407 1.407 0 0 1-.606.138h-3.44z"
          transform="translate(-.805 -20.699)"
        />
        <path
          id="Path_2651"
          data-name="Path 2651"
          className="domain-icon-cls-2"
          d="M16.215 12.686H14.27a1.544 1.544 0 0 0-1.521-1.3h-1.56a1.544 1.544 0 0 0-1.521 1.3H7.722a.83.83 0 0 0-.844.811v1.871a.811.811 0 0 0 .811.811h3.4a.88.88 0 0 1 .27-.594l.016-.013a.891.891 0 0 1 .111-.089c.014-.01.03-.016.045-.025a.866.866 0 0 1 .1-.053.882.882 0 0 1 .087-.027c.025-.007.049-.017.075-.023a.874.874 0 0 1 .175-.018.887.887 0 0 1 .175.018c.026.005.05.015.075.023a.832.832 0 0 1 .087.027.876.876 0 0 1 .1.053c.015.009.031.015.046.025a.869.869 0 0 1 .111.089l.016.013a.879.879 0 0 1 .27.594h3.4a.811.811 0 0 0 .811-.811V13.5a.83.83 0 0 0-.844-.814zm-5.767 0a.782.782 0 0 1 .741-.54h1.559a.782.782 0 0 1 .741.54z"
        />
      </g>
    </g>
  </svg>
);

export const noAccessSvg = (
  <svg width="100%" height="100%" viewBox="0 0 1896 909">
    <defs>
      <style>{`.a{clipPath:url(#b);}.b{opacity:0.302;}.c{fill:#fafbfc;}`}</style>
      <clipPath id="b">
        <rect width="1896" height="909" />
      </clipPath>
    </defs>
    <g id="a" className="a">
      <rect className="c" width="1896" height="909" />
      <image
        width="1983"
        height="930"
        transform="translate(-43)"
        xlinkHref="data:image/png;base64,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
  CQAAAABA9xD+AgAAAEAvio6ZpPBl1ys8baFUOEjyZvnPskQuats0tkFpXr6ig4sVGVem0IxFCt14v8Lf/ntFLl1oho+IT9x3DfZ5ddmgAi0ZOVTDcwMK5OTIkwiA2wuB7TiPR75AQIMKCjTJiermUUM1udDWIgYAAAAAIDMIfwEAAACgl0XPv1Thry1V6CvfUyR/sKJ+89Ms0epvunaC+1NJsDmo3SZbfGaUP0fhIecoNG2hQv/hvyu0bLXCi3+gSNlVZry//eC0jxkR8GvesCG6c1SxLsj1KycvT57CQjm2JrDZjla7w+uRk5srT0GBinNzNDvHq+UTxmhyfp4CHn6WAwAAAAAyx7tgwYIV8X4AAJDlotHYZejk7tnK/Pnz3WkBABnk8Up5RYqOnCCNvUjR3HwpGDSlTk40FAtMbSbY30o8v436/IoWDFFkeKmi512qyJe+psjsxYpc/ReKXLpA0QnTFB02RsotMNtq75vbf4Jfy3EcBTyORgR8mpCTo+E+r5xIRLXhkIJmW5xAIFZ8PlNi48bkBDSrKF/XFw/SwuIhGp+Xo4ANhePzBACgs1555RV57O0EUoo9TyW67RUrtZss3TAAAND3OatWrWr+Y2QAAND/2IA2VWJYcteWSCTSqmtLOBxu7qaWhx56yJ0HAKAHmGOvU3NCzoEdcg7ukvP5Xjknq+Q01EjhkDmAR+IT9lHx84w8HskbUDSQKwUKFLW1mYuGKTpkpDRohKLFo6WhJYoWFkv+nNhzskRDOKKDjUHtaWhUpSlVwSbVmt3SZMY55l+uY3aBohqXl6MJuTk6Ny9XowL+2JMBAOiG++67T16vt1WxwW+imxoGJ4fCVmo3WbphAACg7yP8BQCgn0sEvMkSw5K7ibA3tUv4CwB9RFODnOoTck5+JpmuQkE3HO7T3POMKR6fFMiRcgvd4FcFg2PdnIFzP1v7SjWa1+tIsEmnQmG33yNHBV6Piv0+DTHFz0V0AEAGEf4CAIB0CH8BAOjnEgFvssSw5G4i7E3tEv4CAAAAQP9D+AsAANKxd2UCAAAAAAAAAAAAAPRzhL8AAAAAAAAAAAAAkAUIfwEAAAAAAAAAAAAgCxD+AgAAAAAAAAAAAEAWIPwFAAAAAAAAAAAAgCxA+AsAAAAAAAAAAAAAWYDwFwAAAAAAAAAAAACyAOEvAAAAAAAAAAAAAGQBwl8AAAAAAAAAAAAAyAKEvwAAAAAAAAAAAACQBQh/AQAAAAAAAAAAACALEP4CAAAAAAAAAAAAQBYg/AUAAAAAAAAAAACALED4CwAAAAAAAAAAAABZgPAXAAAAAAAAAAAAALIA4S8AAAAAAAAAAAAAZAHCXwAAAAAAAAAAAADIAoS/AAAAAAAAAAAAAJAFCH8BAAAAAAAAAAAAIAsQ/gIAAAAAAAAAAABAFiD8BQAAAAAAAAAAAIAsQPgLAAAAAAAAAAAAAFmA8BcAAAAAAAAAAAAAsgDhLwAAAAAAAAAAAABkAcJfAAAAAAAAAAAAAMgChL8AAAAAAAAAAAAAkAUIfwEAAAAAAAAAAAAgCxD+AgAAAAAAAAAAAEAWIPwFAAAAAAAAAAAAgCxA+AsAAAAAAAAAAAAAWYDwFwAAAAAAAAAAAACyAOEvAAAAAAAAAAAAAGQBwl8AAAAAAAAAAAAAyAKEvwAAAAAAAAAAAACQBQh/AQAAAAAAAAAAACALEP4CAAAAAAAAAAAAQBYg/AUAAAAAAAAAAACALED4CwAAAAAAAAAAAABZgPAXAAAAAAAAAAAAALIA4S8AAAAAAAAAAAAAZAHCXwAAAAAAAAAAAADIAoS/AAAAAAAAAAAAAJAFCH8BAAAAAAAAAAAAIAsQ/gIAAAAAAAAAAABAFiD8BQAAAAAAAAAAAIAsQPgLAAAAAAAAAAAAAFmA8BcAAAAAAAAAAAAAsgDhLwAAAAAAAAAAAABkAcJfAAAAAAAAAAAAAMgChL8AAAAAAAAAAAAAkAUIfwEAAAAAWS0SiSgajcYfAQAAAACQvQh/AQAAAABZj/AXAAAAADAQEP4CAAAAAAAAAAAAQBYg/AUAAAAAAAAAAACALED4CwAAAAAAAAAAAABZgPAXAAAAAAAAAAAAALIA4S8AAAAAAAAAAAAAZAHCXwAAAAAAAAAAAADIAoS/AAAAAAAAAAAAAJAFCH8BAAAAAAAAAAAAIAsQ/gIAAAAAAAAAAABAFiD8BQAAAAAAAAAAAIAsQPgLAAAAAAAAAAAAAFmA8BcAAAAAAAAAAAAAsgDhLwAAAAAAAAAAAABkAcJfAAAAAAAAAAAAAMgChL8AAAAAAAAAAAAAkAUIfwEAAAAAAAAAAAAgCxD+AgAAAAAAAAAAAEAWIPwFAAAAAAAAAAAAgCxA+AsAAAAAAAAAAAAAWYDwFwAAAAAAAAAAAACyAOEvAAAAAAAAAAAAAGQBwl8AAAAAAAAAAAAAyAKEvwAAAAAAAAAAAACQBQh/AQAAAAAAAAAAACALEP4CAAAAAAAAAAAAQBYg/AUAAAAAAAAAAACALED4CwAAAAAAAAAAAABZgPAXAAAAAAAAAAAAALIA4S8AAAAAAAAAAAAAZAHCXwAAAAAAAAAAAADIAoS/AAAAAAAAAAAAAJAFCH8BAAAAAAAAAAAAIAsQ/gIAAAAAAAAAAABAFiD8BQAAAAAAAAAAAIAsQPgLAAAAAAAAAAAAAFmA8BcAAAAAAAAAAAAAsgDhLwAA6P9qKrTxiRVadst1mjdvnik36rt/vUKrN1aoJhyfJuHIej1gp3liZ3xAbzuu9cvtOq7WF7UGLaTbH+EaVby8VpuOxB9b8ekeePl4fAAGpCNb9dQLmX/n7nzCfibmafX2+AAr8d5MV27+rpatWK3123k/om84/t5arbz/u7ox/h697pZluvfHa7U1+TgaF3u/P6D1acb1iu2r3XXsK8fztPsjzbEmNl0fOXei9evWl78n8B2m97CvAQAA+gTCXwAA0K8FP1mru25ZppVrtil44ULdetutplyr0vptWrtymZasWKfKYHxidMjxV/5eyx7epur4YyBmp1bfcq+e/Sz+sLeUzNIi93N9piyeWeiGbY98/zYte3qn+Ijji3Ncmx7+rpbcv1qbKgs18+bYe3TRtID2b1qte2/5rh57ryY+LTrmCzrWAAAAAECWIPwFAAD9WJXWr7K1gGbp7mee15Mr7tTt37ndlDu14qk1evK/zJLeekwrflURn94YsVAPbtigDXeUxQf0tmItXGmWv2Gpvqg1aOEL3x/AWZTO0a3u5/pMWXr/o1qz5kndeYVU8cw9+tEr1DDCFyP43rNa+XKlSpc8quefe1TL/3PSe/TnD2rRuEqtW/GoNp2KP8Eou8OeAx7UwhHxAb1t6lKz/A16cEFxfMAX6wvfH+gSXjcAAACg7yL8BQAA/deRrdryoenecKsWlsQGnRFQ6Q2361YzvPIXr2pnavPPAPq3vFItWv5DLcoLqvzRZ7WV6r/4AlS8t05BzdLib5aZs06K4lm6/dtzpPqNWv8Wf6AAAAAAAOgdhL8AAKD/O12dvtlX70SVzZYChcd0PFHrKnEf0dR7/tbs1Lof36UlN9h72N2o7654VluPVMXuz7t8vZov27v3SnxA66vsfXEf013x+wxfd8tdeuzlNPcYbiXNPX+7Nc8abVpp5neDmV+L6RLLWaZ1B+KD4iqeu80MX6lNtiXSFvsj9pwlD5eb/nI9ckvKerqCOv7es1px+43uOtp7r654ZquOn2W7j7/8gDv9Y1vSvFI1m7TSjLvtmaQa2vVVKn8m6T7OdjlPbFRFauup8XtXtrhXbFyr+0Mm9vO+Cq39wRJdZ553452rVX6WTKbmk41avSJxL0/73litjftab8fxD9fpseZ7fl6nJd9fqbXvpc48/ro8sVVVr5nX+mbTf8MSrXihUsHEtmw7rq1m279rxyXmY4al06Flxl/j1duqtOmnd7nTXnfLCq1LbEPintmJ19SUG2+/VyvXJL2u7rrdpbW2f81d7jQt7ucXNuu8ZmXzezfxelXWx8f3lLxZWvitEvN+Wa8tH8eHAb3umGpq470pCstmaboK9dnpqviQNPdKjat6a3XzsbX5+L8t9RiXOIaYI9uRrXq2xbHJnrfik7Unfqw58xnu5jw/eVa3tZhfnFmOPc7O+2l5y3N04pj/XOyY32J/nO1YYzSaY9Z6cyyLna/tce8xrf/kLE1rh3dqtZ3+r9epMj4oWey8uEIbk2pod+qYnvw9IaHVvU/bOf7Hp0iro8dXd9/Z7xItp7/x9hV6Nn4Oafkee0Cr3zrzvkyI3b96WXz/xtbR3mM99bzX1vu4Q+LbdO/S2Lk4tj7LWm9X4vxl3v8d/e4R3Jd0zr7Zfo7Osn+TxT8bHT4Pd3Q7LPPZWtv8PbMb03Xz8+bq1Hestr83dWtfAwAAoEcR/gIAgP5rxHTNvMh0X/6R7vqf67T1wHEFUy4ETv/PG/TSc8s1p73WLY9s1Iq/vEuPbQpq2reX6yc/vksL9aru/e5yrU13lVjHtOkf79Jd/7daV/3Vg/rJ392tRaWVWvfwMt21JuniWqd0dZ6FKrt0llT/hrbuiw+ygrtVscX2VGjLruQLhJXa8UaVNHO6ygrjg5oVavq3f6LlN080/RO1ePlPzL5YqNLYSNf+Xy7XbSveUGDhXWbcci29LKAtT9+r2368Se1dei++4lrNMd11b21tdWGwZssGbVSJFs60yzXqd2r1X9+mB35ZpdKv36kHf2zW6VsTVfXCSi278xFtan2tuhP2a+2P7tGrQ2/VD83633rVNE1p571R9fIDWrJ0pdZ9NlG32v2x/FaV7l+rlXfepbWfxCcy7HS33fmYeddM1+12ur+7U9fmbNHq+2/TXc9VtL4Y+tZjWv5opWb9zU/04N8s1NVlpc21Bst/eo/u/b+1muW+D5ZqVv0mrb7H7I+Upo07u8zyny7Xw4dm6a4fP6g7v361powzSzy1SY/85TKtfOG4Jt1kX1O7jWY+I3dr4xP36p7Ee2/cQjNuqfsa6pql7nS3Tou/gczr9ZR5ve59Yotyvtry9fruX6/WztQL2xlWeoF5/5ut3VqR9sMK9KiJly0yn90Krb77Xj27sUJVqe/3EvPZ2fC8nlzSXtP6Qe18Zpm++4O12jZyoe7+u5/oh385Rbv/0Rz/f2r/GCeNfc/qge/+SNvGLNZ/s5+5O2Yq8N5T5ry1skUT053S1XmeO11X5ZljzB93tjgPVFbEj/cbdpo9dEZw51ZzzA/oqovjx/xk7R1rXOV67M5lWn1oinvce/CeRRp/YJ0eWXqXnk06JrfiLdO19g9FPl5vvivEhyWEK1T+W3NiueZqzRwcG9TpY3pntHP8b6XTx1f7XeIePfCqYt8llt+uSac36al7Vuixf35A333iM0359g/N8KWamVuutT9Y3mK/VaxZptvuX62KvFmx7Tbni7tvnibZQPjOh7v+3kpm9vdad5sqVHDF7eZcbPfv3Vp8sbRljTnP/0Pr7xOVvzSvx8ptGv2t/2bWqe3vHsEPn9Ky/7RSa/eXxs7Z91yr4P9dpnt+0bnXrEPn4c5sh/me+cB379VTe0q0+G9j+/XOrxZpm5nuu/etU2Xiu2tHpuvu563T37HSf2/K1L4GAABAzyD8BQAA/ViJFj2wXHMGB1Xx0mO69/Yluu7GJVp2/0o99fJWVR7vyOWnoLb+0l7QnKW7//fjWr5krqZfNleLVzyuR2+QKtMGjRUqPzhLD69arsVzp2v6FQu1dOXDut02Mf3b8hYX3Tqu6/MsnjJTE1WlnbuTLkp+vE3rFVDAXiDcufvMhbgjO9wakrOunqXWmWdAJRdN17QJw0z/MJVebNbjslIlX3avOjpadybvp+UP655rzF7c+Lq2pV6tTTZ4pq420+mFLSnN89Zoy+ZNbkAy6wL72LweP7tHaw+UavHfP6rl3zHDL5uuuUuW6/HHlqrswHqtfLL9oLl9Vao87y49/P8sMvM1679kVovta+HURj3+cLmCM+/Wk/8Uf13mLtaKf3pQi8wrsvoXG2Pr8ek6rbS1pa+4W4+vvFOLml+/Z/SgeQ/t/NnKFkGx60BQ1/79T3SrmXbWgts19/z4cKPS7OO7//EnWrpglpnPIt39T4/rzotSmjbuwjIrm67Vwytv1dzLZmnhd+ZqotfsjS2va4f5HN3+yKO6+wb7mtptXKQ7Vz6qpeb1qPzFG7Ga04NLzbgpGm37R01xpysricUVFc8/rGc/Kdbih9foJ3ckvV7/+27NOrBW9/ysdeCfSYH8+Hp83vV3BdBVgcuW6uHbJipwaqueWrlMt91ga1ou04qfrtPGj6ta/UFSWp+u1+NPV6j45p9ozY+XauEV9riwVI+az9Doo238UcOWrdLfPN7iM/fw38aamH693YNxO7o6T+9ETZtnum/tOBNi6bh2bKkw5yDz+awv1+6kwLVi23opb5Gusn+8laqdY02M2R9XPNpiP/3k7283R7FKrTfLa8/EmQvNdBVa/17KPv2kXOvNuX7u1TNj54OuHNM7o53jf6rOH1/td4lr9WjzOetWPXj/IjN8p9a9VKIf/tOKM+ey/36n+e6QtN+CO/XGq+Z7xDXL9eiK2939O909X5jHyxe674P1W1r+EV
  JXBD98Q6+eluYsf1Qr4ud4u39vN49/uMB+n1iv1MWUb5PuTJwX2/zuUaX1//SsKksW6yeJ7XTPoU9q4eF1Mu/uDuvIebgz21H1znqV10/XnT+Kvy52v97x
  Ez36X8pUWGO+Fx3qxHTd+rx15TtWuu9NmdvXAAAA6BmEvwAAoH8rmasVa9bo0XsWa864Qqn+uCre26hnH75X311ynW68/1ltbe9aZc0WrX8+KN3wDV1bEh/mCqjsW7fFah
  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"
      />
      <rect className="b" width="1920" height="1218" />{" "}
    </g>
  </svg>
);

export const businessGlossaryIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "19.402"}
    height={height || "17.961"}
    viewBox="0 0 19.402 17.961"
  >
    <path
      data-name="Path 2877"
      d="M99.551 1232.479c-.056.3-.089.6-.172.885-.191.668-.409 1.329-.611 1.994q-1.366 4.5-2.729 9a1.136 1.136 0 0 1-1.272.939H84.616c-.229 0-.46.011-.688-.008a1.844 1.844 0 0 1-1.215-.425.773.773 0 0 1-.272-.8c.1-.324.406-.262.658-.262 3.355 0 6.71 0 10.065-.006a1.646 1.646 0 0 0 1.742-.937c.114-.273.241-.542.329-.823q.55-1.76 1.079-3.526c.762-2.527 1.526-5.053 2.275-7.584a1.585 1.585 0 0 0-1.6-2.087H93.7c-1.109 0-2.218.022-3.326-.007-1.091-.029-2.181.1-3.272.011a.746.746 0 0 0-.25.044c-.5.139-.7.558-.886.982-.083.194-.165.388-.257.577l-4.229 11.715a3.15 3.15 0 0 0-.232.642c-.033.307-.139.622-.151.934a3.218 3.218 0 0 0 3.023 3.051h10.7a2.51 2.51 0 0 0 2-1 3.485 3.485 0 0 0 .563-1.3q1.352-4.442 2.691-8.889a10.965 10.965 0 0 0 .417-1.686 1.3 1.3 0 0 0-.94-1.434zm-11.716.386c.064-.2.122-.4.193-.6a.58.58 0 0 1 .624-.438h6.844c.364 0 .465.135.352.484-.34 1.052-.253 1.021-1.346 1.011-.964-.008-1.928 0-2.892 0h-3.437c-.357 0-.446-.122-.338-.458zm-.958 2.96c.069-.208.13-.419.208-.624a.548.548 0 0 1 .547-.381h6.962c.295 0 .4.15.3.429-.366 1.1-.254 1.081-1.425 1.068-.945-.01-1.891 0-2.836 0h-3.404c-.396-.002-.477-.117-.352-.493z"
      transform="translate(-81.092 -1228.829)"
      fill="#b1bac1"
    />
  </svg>
);

export const solidBlueArrowUpIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "18.279"}
    height={height || "11.26"}
    viewBox="0 0 18.279 11.26"
  >
    <path
      data-name="Path 2752"
      d="m5717.149 320.05 8.08 8.078 8.079-8.078"
      transform="rotate(180 2867.184 165.125)"
      style={{ fill: "none", stroke: "#328db5", strokeWidth: "3px" }}
    />
  </svg>
);

export const solidBlueArrowDownIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "18.279"}
    height={height || "11.26"}
    viewBox="0 0 18.279 11.26"
  >
    <path
      data-name="Path 2752"
      d="m5717.149 320.05 8.08 8.078 8.079-8.078"
      transform="translate(-5716.088 -318.989)"
      style={{ fill: "none", stroke: "#328db5", strokeWidth: "3px" }}
    />
  </svg>
);

export const addIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "14.4"} height={height || "14.4"} viewBox="0 0 18 18">
    <defs>
      <style>
        {`.add-icon-secondary-cls-1{fill:#fff;stroke:#478fca}.add-icon-secondary-cls-2{stroke:none}.add-icon-secondary-cls-3{fill:none}`}
      </style>
    </defs>
    <g
      id="Group_2521"
      data-name="Group 2521"
      transform="translate(-633.213 -117.713)"
    >
      <g
        id="Ellipse_264"
        data-name="Ellipse 264"
        className="add-icon-secondary-cls-1"
        transform="translate(633.213 117.713)"
      >
        <circle className="add-icon-secondary-cls-2" cx="9" cy="9" r="9" />
        <circle className="add-icon-secondary-cls-3" cx="9" cy="9" r="8.5" />
      </g>
      <g
        id="Rectangle_1519"
        data-name="Rectangle 1519"
        className="add-icon-secondary-cls-1"
      >
        <path
          className="add-icon-secondary-cls-2"
          d="M0 0h8v2H0z"
          transform="translate(638.213 125.713)"
        />
        <path
          className="add-icon-secondary-cls-3"
          d="M.5.5h7v1h-7z"
          transform="translate(638.213 125.713)"
        />
      </g>
      <g
        id="Rectangle_1520"
        data-name="Rectangle 1520"
        className="add-icon-secondary-cls-1"
      >
        <path
          className="add-icon-secondary-cls-2"
          d="M0 0h8v2H0z"
          transform="rotate(-90 385.963 -255.25)"
        />
        <path
          className="add-icon-secondary-cls-3"
          d="M.5.5h7v1h-7z"
          transform="rotate(-90 385.963 -255.25)"
        />
      </g>
    </g>
  </svg>
);

export const refreshIconOutlined = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "19.953"}
    height={height || "20"}
    viewBox="0 0 19.953 20"
  >
    <defs>
      <style>{`.cls-1{fill:#989898}`}</style>
    </defs>
    <g
      id="Group_2645"
      data-name="Group 2645"
      transform="translate(2867.828 -463.204)"
    >
      <path
        id="Path_2802"
        data-name="Path 2802"
        className="cls-1"
        d="M-2850.249 571.41c-.35-.225-.666-.419-.972-.628-.494-.337-.492-.793.033-1.08q2.045-1.121 4.111-2.2c.55-.288.962-.024.945.595q-.063 2.307-.156 4.613c-.026.636-.415.836-.973.533-.356-.194-.729-.56-1.064-.527-.3.029-.556.5-.846.764a9.689 9.689 0 0 1-9.837 2.327 9.639 9.639 0 0 1-6.821-7.333c-.208-.831.183-1.463.9-1.529.615-.056 1.042.278 1.209 1a7.934 7.934 0 0 0 2.264 4 7.8 7.8 0 0 0 10.881-.152c.104-.108.194-.227.326-.383z"
        transform="translate(-1.745 -93.084)"
      />
      <path
        id="Path_2803"
        data-name="Path 2803"
        className="cls-1"
        d="M-2863.673 468.052c.346.22.638.395.917.587.5.344.505.8-.016 1.085q-2.066 1.136-4.158 2.226a.567.567 0 0 1-.9-.557q.052-2.359.151-4.717c.024-.567.429-.779.924-.512a7 7 0 0 1 .784.485c.28.2.461.139.689-.109a9.913 9.913 0 0 1 7.86-3.333 10.006 10.006 0 0 1 9.348 7.9 1.1 1.1 0 0 1-.465 1.254.954.954 0 0 1-1.234-.08 1.961 1.961 0 0 1-.461-.88 7.782 7.782 0 0 0-4.42-5.34 7.806 7.806 0 0 0-8.79 1.7c-.064.077-.121.158-.229.291z"
      />
    </g>
  </svg>
);

export const plusIconInCircleOutlined = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "20"} height={height || "20"} viewBox="0 0 20 20">
    <defs>
      <style>{`.cls-2{fill:#989898}.plus-circle-cls-1 {stroke:#989898;strokeWidth:1.6px;fill:none}`}</style>
    </defs>
    <g id="Group_2625" data-name="Group 2625" transform="translate(-47 -265)">
      <g
        id="Group_2622"
        data-name="Group 2622"
        transform="translate(-.813 -58.812)"
      >
        <g
          id="Ellipse_5"
          data-name="Ellipse 5"
          transform="translate(47.812 323.812)"
          className="plus-circle-cls-1"
        >
          <circle cx="10" cy="10" r="10" style={{ stroke: "none" }} />
          <circle cx="10" cy="10" r="9.2" style={{ fill: "none" }} />
        </g>
      </g>
      <g id="Group_2623" data-name="Group 2623">
        <path
          id="Rectangle_1497"
          data-name="Rectangle 1497"
          className="cls-2"
          transform="translate(53 274)"
          d="M0 0h8v2H0z"
        />
        <path
          id="Rectangle_1498"
          data-name="Rectangle 1498"
          className="cls-2"
          transform="rotate(-90 167.5 111.5)"
          d="M0 0h8v2H0z"
        />
      </g>
    </g>
  </svg>
);

export const exclamationIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "20"} height={height || "20"} viewBox="0 0 20 20">
    <defs>
      <style>
        {`.exclamation-circled-cls-1{fill:#d15b47}.exclamation-circled-cls-2{stroke:#d15b47;strokeWidth:1.6px;fill:none}`}
      </style>
    </defs>
    <g
      id="Group_2621"
      data-name="Group 2621"
      transform="translate(-47.812 -323.812)"
    >
      <g
        id="Group_2620"
        data-name="Group 2620"
        transform="translate(56.766 328.712)"
      >
        <path
          id="Path_2687"
          data-name="Path 2687"
          className="exclamation-circled-cls-1"
          d="M-2127.636 704.024a1.155 1.155 0 0 1-1.187 1.2 1.168 1.168 0 0 1-1.206-1.231 1.151 1.151 0 0 1 1.192-1.156 1.147 1.147 0 0 1 1.201 1.187z"
          transform="translate(2130.029 -694.94)"
        />
        <path
          id="Path_2688"
          data-name="Path 2688"
          className="exclamation-circled-cls-1"
          d="m-2127.726 607.191.077-1.192.06-.914c.042-.661.113-1.568-.7-1.8a1.211 1.211 0 0 0-1.618 1.247c.035.9.09 1.79.15 2.684l.093 1.341a4.987 4.987 0 0 0 .177 1.262c.013.038.025.077.041.114a.769.769 0 0 0 1.35.133 1.26 1.26 0 0 0 .171-.478c.08-.756.147-1.515.188-2.274a1.52 1.52 0 0 0 .011-.123z"
          transform="translate(2129.915 -603.231)"
        />
      </g>
      <g
        className="exclamation-circled-cls-2"
        id="Ellipse_5"
        data-name="Ellipse 5"
        transform="translate(47.812 323.812)"
      >
        <circle cx="10" cy="10" r="10" style={{ stroke: "none" }} />
        <circle cx="10" cy="10" r="9.2" style={{ fill: "none" }} />
      </g>
    </g>
  </svg>
);

export const playOrTourIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "21.6"} height={height || "21.6"} viewBox="0 0 27 27">
    <defs>
      <style>{`.cls-3{stroke:none}`}</style>
    </defs>
    <g id="Group_2116" data-name="Group 2116" transform="translate(-1316 -169)">
      <g
        id="Ellipse_265"
        data-name="Ellipse 265"
        transform="translate(1316 169)"
        style={{ stroke: "#4b90cc", strokeWidth: "2px", fill: "none" }}
      >
        <circle className="cls-3" cx="13.5" cy="13.5" r="13.5" />
        <circle cx="13.5" cy="13.5" r="12.5" style={{ fill: "none" }} />
      </g>
      <g id="Polygon_2" data-name="Polygon 2" style={{ fill: "#4b90cc" }}>
        <path
          className="cls-3"
          d="M8.3 8.5H1.7a.492.492 0 0 1-.431-.246.492.492 0 0 1-.007-.497l3.3-5.94A.49.49 0 0 1 5 1.558a.49.49 0 0 1 .437.257l3.3 5.941a.492.492 0 0 1-.006.497.492.492 0 0 1-.43.246z"
          transform="rotate(90 578.75 756.75)"
        />
        <path
          d="M5 2.06 1.7 8h6.6L5 2.06m0-1a.99.99 0 0 1 .874.513l3.3 5.941A1 1 0 0 1 8.3 9H1.7a1 1 0 0 1-.875-1.486l3.3-5.94A.99.99 0 0 1 5 1.058z"
          style={{ fill: "#4b90cc", stroke: "none" }}
          transform="rotate(90 578.75 756.75)"
        />
      </g>
    </g>
  </svg>
);

export const scanResultsIcon = (): JSX.Element => (
  <svg width="24.375" height="20.848" viewBox="0 0 30.375 25.848">
    <defs>
      <style>{`.scanresults-cls-1,.scanResults-cls-2{fill:#428bca}.scanresults-cls-1{fillRule:evenodd}`}</style>
    </defs>
    <g
      id="Group_434"
      data-name="Group 434"
      transform="translate(-825.494 -162.616)"
    >
      <g
        id="Group_433"
        data-name="Group 433"
        transform="translate(825.494 170.38)"
      >
        <path
          id="Path_699"
          data-name="Path 699"
          className="scanresults-cls-1"
          d="M1546.613 430.532c-1.63 0-3.261-.022-4.891.011-.6.012-.852-.131-.843-.8.034-2.687.025-5.374 0-8.061 0-.532.136-.747.708-.743q5.072.031 10.145 0c.483 0 .718.124.715.655q-.022 4.122 0 8.242c0 .581-.251.7-.769.7-1.683-.019-3.378-.005-5.065-.004zm.093-8.577c-1.3 0-2.6.022-3.9-.01-.6-.015-.863.148-.85.806a175.22 175.22 0 0 1 0 5.8c-.008.566.144.811.757.8q3.943-.037 7.887 0c.592 0 .79-.22.782-.8q-.037-2.9 0-5.8c.008-.584-.192-.814-.783-.8-1.294.023-2.593.005-3.893.004z"
          transform="translate(-1522.079 -412.459)"
        />
        <path
          id="Path_700"
          data-name="Path 700"
          className="scanresults-cls-1"
          d="M1443.129 374.207c1.632 0 3.265.021 4.9-.011.607-.012.849.143.84.8q-.052 3.944 0 7.889c.008.652-.221.814-.834.81-3.295-.023-6.59-.028-9.884 0-.7.007-.869-.244-.861-.9.03-2.569.04-5.139 0-7.708-.013-.754.27-.918.951-.9 1.622.045 3.259.019 4.888.02zm-.051 8.479c1.329 0 2.658-.022 3.986.01.563.014.726-.193.719-.735q-.037-2.989 0-5.98c.007-.555-.188-.728-.735-.724q-3.986.032-7.973 0c-.56 0-.731.2-.725.741q.033 2.989 0 5.98c-.007.566.207.727.742.716 1.327-.026 2.656-.008 3.985-.008z"
          transform="translate(-1437.281 -374.193)"
        />
        <path
          id="Path_705"
          data-name="Path 705"
          className="scanresults-cls-1"
          d="M1560.5 449.267h2.073c.37 0 .64.06.639.535 0 .421-.152.6-.576.6q-2.209-.014-4.417 0c-.423 0-.482-.237-.486-.58 0-.365.111-.561.513-.554.754.01 1.502-.001 2.254-.001z"
          transform="translate(-1535.874 -435.64)"
        />
        <path
          id="Path_706"
          data-name="Path 706"
          className="scanresults-cls-1"
          d="M1560.532 438.916c-.724 0-1.449-.014-2.174 0-.44.011-.571-.189-.571-.6 0-.44.254-.475.587-.474 1.419.005 2.838.009 4.257 0 .387 0 .627.068.62.539s-.257.543-.637.537c-.693-.009-1.387-.001-2.082-.002z"
          transform="translate(-1535.919 -426.293)"
        />
        <path
          id="Path_707"
          data-name="Path 707"
          className="scanresults-cls-1"
          d="M1456.541 391.668c.691 0 1.384.007 2.075 0 .377-.005.632.063.628.537s-.289.524-.65.523c-1.414 0-2.827-.008-4.24 0-.419 0-.59-.167-.579-.593s.276-.467.6-.465l2.166-.002z"
          transform="translate(-1450.781 -388.494)"
        />
        <path
          id="Path_708"
          data-name="Path 708"
          className="scanresults-cls-1"
          d="M1456.482 404.114c-.721 0-1.443-.009-2.165 0-.39.007-.524-.169-.521-.545s.12-.559.517-.557q2.21.012 4.419 0c.39 0 .522.178.524.551s-.129.557-.52.551c-.751-.008-1.503 0-2.254 0z"
          transform="translate(-1450.799 -397.785)"
        />
      </g>
      <path
        id="Union_1"
        data-name="Union 1"
        className="scanResults-cls-2"
        d="m10.484 16.181 3 2.023-3 2.021zM0 18.876v-1.347h10.484v1.347zm0-1.347v-5.391h1.5v5.392zm20.223-8.091V1.349h-2.7L16.219 0h5.5v9.439zM0 4.048V0h9.814l-.678 1.349H1.5v2.7z"
        transform="translate(830.222 166.882)"
      />
      <path
        id="Union_2"
        data-name="Union 2"
        className="scanResults-cls-2"
        d="M3 2.022 0 4.045V0z"
        transform="rotate(90 338.557 514.581)"
      />
      <path
        id="Rectangle_530"
        data-name="Rectangle 530"
        transform="rotate(-45 622.344 -928.094)"
        style={{ stroke: "#fff", strokeWidth: "1.2px", fill: "#fff" }}
        d="M0 0h6.741v6.741H0z"
      />
      <g id="Path_2815" data-name="Path 2815" style={{ fill: "#fff" }}>
        <path
          d="M6.241 6.241H.5V.5h5.741v5.741z"
          style={{ stroke: "none" }}
          transform="rotate(-45 622.344 -928.094)"
        />
        <path
          d="M1 1v4.741h4.741V1H1M0 0h6.741v6.741H0V0z"
          style={{ fill: "#428bca", stroke: "none" }}
          transform="rotate(-45 622.344 -928.094)"
        />
      </g>
    </g>
  </svg>
);

export const inSightsIcon = (): JSX.Element => (
  <svg width="23.56" height="26" viewBox="0 0 29.458 32.526">
    <defs>
      <style>
        {`.insightsicon-cls-1{fill:none;stroke:#328db5;strokeWidth:1.4px}.insights-icon-cls-2{fill:#328db5}`}
      </style>
    </defs>
    <g
      id="Group_2566"
      data-name="Group 2566"
      transform="translate(-96.234 -324.718)"
    >
      <g
        id="Group_2563"
        data-name="Group 2563"
        transform="translate(-1615 38.951)"
      >
        <path
          id="Line_357"
          data-name="Line 357"
          className="insightsicon-cls-1"
          transform="translate(1726.109 303.904)"
          d="M0 7.246V0"
        />
        <circle
          id="Ellipse_283"
          data-name="Ellipse 283"
          className="insights-icon-cls-2"
          cx="2.07"
          cy="2.07"
          r="2.07"
          transform="translate(1724.039 301.316)"
        />
        <path
          id="Path_2723"
          data-name="Path 2723"
          className="insightsicon-cls-1"
          d="M109.925 36.527v.9a2.244 2.244 0 0 1-2.241 2.241h-.493a2.241 2.241 0 0 1-4.392 0h-.493a2.244 2.244 0 0 1-2.241-2.241v-.9a1.346 1.346 0 0 1 1.345-1.345h7.171a1.346 1.346 0 0 1 1.344 1.345zM111.2 18.39a8.969 8.969 0 1 0-12.395 12.968q.129.123.262.241a2.98 2.98 0 0 1 1 2.239 1.346 1.346 0 0 0 1.345 1.345h7.171a1.346 1.346 0 0 0 1.345-1.345 2.988 2.988 0 0 1 1-2.243 8.98 8.98 0 0 0 .78-12.676q-.243-.275-.508-.529z"
          transform="translate(1620.967 276.095)"
        />
      </g>
      <g id="Group_2565" data-name="Group 2565">
        <g
          id="Group_2564"
          data-name="Group 2564"
          transform="translate(828.736 303.665)"
        >
          <path
            id="Path_2822"
            data-name="Path 2822"
            className="insights-icon-cls-2"
            d="M-658.645 96.228c-.862-.846-1.721-1.664-2.549-2.513a.938.938 0 0 1 .045-1.287.927.927 0 0 1 1.325-.077c.84.81 1.651 1.651 2.49 2.494z"
            transform="translate(-67.049 -67.031)"
          />
          <path
            id="Path_2823"
            data-name="Path 2823"
            className="insights-icon-cls-2"
            d="m-354.1 96.351-1.322-1.383a1.412 1.412 0 0 1 .127-.168l2.2-2.2a.981.981 0 0 1 1.392-.146.98.98 0 0 1 .019 1.514c-.754.766-1.518 1.521-2.278 2.28a1.3 1.3 0 0 1-.138.103z"
            transform="translate(-355.729 -67.143)"
          />
          <path
            id="Path_2824"
            data-name="Path 2824"
            className="insights-icon-cls-2"
            d="M-728.086 263.97v1.909c-.132.012-.223.027-.313.027h-3.057a.971.971 0 0 1-1.046-.955.962.962 0 0 1 .981-1c1.123-.017 2.246-.006 3.369-.006a.207.207 0 0 1 .066.025z"
            transform="translate(0 -229.138)"
          />
          <path
            id="Path_2825"
            data-name="Path 2825"
            className="insights-icon-cls-2"
            d="M-290.1 265.845v-1.93a.947.947 0 0 1 .169-.027c1.074 0 2.148-.009 3.222 0a.962.962 0 0 1 1.014.956.945.945 0 0 1-.991 1c-.923.009-1.847 0-2.77 0z"
            transform="translate(-417.349 -229.079)"
          />
          <path
            id="Path_2826"
            data-name="Path 2826"
            className="insights-icon-cls-2"
            d="M-487.727 25.337h-1.935a.586.586 0 0 1-.027-.127v-3.14a.945.945 0 0 1 .589-.92.872.872 0 0 1 1.043.176 1.052 1.052 0 0 1 .315.608c.031 1.129.015 2.259.015 3.403z"
            transform="translate(-229.061)"
          />
          <path
            id="Path_2827"
            data-name="Path 2827"
            className="insights-icon-cls-2"
            d="m-659.063 406.78 1.219 1.521c-.09.094-.17.184-.255.269-.493.493-.982.99-1.481 1.477a.987.987 0 0 1-1.438.041.991.991 0 0 1 .059-1.439c.577-.582 1.159-1.159 1.739-1.738.044-.044.097-.081.157-.131z"
            transform="translate(-67.17 -363.883)"
          />
          <path
            id="Path_2828"
            data-name="Path 2828"
            className="insights-icon-cls-2"
            d="M-341.681 405.322c.075.126.095.081.179.167.534.546 1.081 1.079 1.615 1.625a1 1 0 0 1 .035 1.461 1 1 0 0 1-1.42-.064q-.809-.792-1.6-1.6a.284.284 0 0 1-.032-.271c.359-.464.758-.74 1.223-1.318z"
            transform="translate(-367.518 -362.349)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const newKeywordIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "16"} height={height || "5"} viewBox="0 0 20.131 6.141">
    <defs>
      <style>{`.new-keyword-icon-cls-1{fill:#87b87f}`}</style>
    </defs>
    <g
      id="Group_2507"
      data-name="Group 2507"
      transform="translate(-107.769 -713.211)"
    >
      <g
        id="Group_2506"
        data-name="Group 2506"
        transform="translate(107.769 713.211)"
      >
        <path
          id="Path_2819"
          data-name="Path 2819"
          className="new-keyword-icon-cls-1"
          d="M1883.208 402.429c.165-1 .351-2 .483-3.009.049-.374.169-.521.556-.543 1.532-.087 1.559-.054 1.152 1.424a109.215 109.215 0 0 0-1 3.859c-.118.5-.285.74-.867.726-1.606-.039-1.594-.011-2-1.607a5.069 5.069 0 0 0-.543-1.8c-.246 1.032-.477 1.946-.678 2.867a.58.58 0 0 1-.661.537c-1.748.03-1.754.047-2.19-1.644-.332-1.287-.625-2.583-.971-3.865-.108-.4-.009-.476.371-.494 1.552-.074 1.545-.084 1.786 1.447.1.621.228 1.237.349 1.855a3.327 3.327 0 0 0 .146.388c.265-1.125.525-2.113.719-3.114.084-.434.256-.573.69-.579 1.628-.023 1.631-.037 2.015 1.533.165.674.318 1.351.476 2.027z"
          transform="translate(-1865.491 -398.791)"
        />
        <path
          id="Path_2820"
          data-name="Path 2820"
          className="new-keyword-icon-cls-1"
          d="M1839.737 401.881c-.289 0-.586-.006-.877 0-.152 0-.3 0-.456.011-.115.006-.292-.013-.382.075a.427.427 0 0 0-.052.409.663.663 0 0 0 .25.328.82.82 0 0 0 1.042 0 .862.862 0 0 1 .515-.219h1.52c.073 0 .147-.005.22 0 .055 0 .079.035.093.09a.569.569 0 0 1-.055.315 2.366 2.366 0 0 1-.989 1.149 3.119 3.119 0 0 1-3.2.172 3.2 3.2 0 0 1-.116-5.382 3.44 3.44 0 0 1 3.185-.015 1.334 1.334 0 0 1 .57.68c.24.6.315 1.283.509 1.9.128.409-.013.5-.38.487-.464-.01-.934 0-1.397 0zm-.9-.967h.5a.265.265 0 0 0 .273-.231c.031-.427-.391-.629-.835-.618-.417.01-.812.221-.777.611a.231.231 0 0 0 .127.2.523.523 0 0 0 .243.037z"
          transform="translate(-1830.115 -398.431)"
        />
        <path
          id="Path_2821"
          data-name="Path 2821"
          className="new-keyword-icon-cls-1"
          d="M1794.879 399.441a2.743 2.743 0 0 1 2.112-.73 1.947 1.947 0 0 1 1.2.5.788.788 0 0 1 .278 1.022 4 4 0 0 0 .323 3.618c.4.664.288.867-.47.878-1.388.021-1.387.021-1.388-1.331 0-.607.02-1.214-.007-1.819-.033-.749-.421-1.176-1.023-1.18-.572 0-.961.362-1.013 1.1-.059.859-.047 1.725-.023 2.587.013.468-.109.655-.619.653-1.382 0-1.382.019-1.382-1.351 0-1.353.016-2.707-.01-4.059-.008-.449.2-.6.621-.628a3.4 3.4 0 0 1 1.149.057.363.363 0 0 1 .243.192c.04.086.088.421.009.491z"
          transform="translate(-1792.854 -398.643)"
        />
      </g>
    </g>
  </svg>
);

export const alertIcon = (): JSX.Element => (
  <svg width="14.16" height="12.64" viewBox="0 0 17.717 15.861">
    <defs>
      <style>{`.alert-icon-cls-1{fill:#d15b47}`}</style>
    </defs>
    <g
      id="Group_1772"
      data-name="Group 1772"
      transform="translate(2237.385 -545.444)"
    >
      <path
        id="Path_2686"
        data-name="Path 2686"
        className="alert-icon-cls-1"
        d="M-2228.5 561.3h-6.547a4.54 4.54 0 0 1-.9-.06 1.707 1.707 0 0 1-1.2-2.59c.346-.688.75-1.347 1.136-2.014q2.871-4.978 5.749-9.953a4.726 4.726 0 0 1 .295-.454 1.7 1.7 0 0 1 2.853-.029 18 18 0 0 1 1.051 1.727q3.011 5.21 6.012 10.426a3.14 3.14 0 0 1 .294.656 1.673 1.673 0 0 1-1.51 2.251c-.8.062-1.614.038-2.421.041-1.603.006-3.207-.001-4.812-.001zm-.035-1.444c2.171 0 4.341.007 6.511-.008a4.674 4.674 0 0 0 .886-.176 4.949 4.949 0 0 0-.3-.823q-2.859-4.986-5.74-9.959c-.307-.532-.613-1.066-.928-1.594s-.522-.514-.843.008c-.076.123-.146.25-.219.375q-3.254 5.635-6.5 11.273a3.643 3.643 0 0 0-.235.729 3.525 3.525 0 0 0 .748.168c2.208.016 4.415.01 6.622.01z"
      />
      <path
        id="Path_2687"
        data-name="Path 2687"
        className="alert-icon-cls-1"
        d="M-2127.846 703.92a1.054 1.054 0 0 1-1.083 1.1 1.065 1.065 0 0 1-1.1-1.123 1.05 1.05 0 0 1 1.088-1.055 1.047 1.047 0 0 1 1.095 1.078z"
        transform="translate(-99.587 -146.005)"
      />
      <path
        id="Path_2688"
        data-name="Path 2688"
        className="alert-icon-cls-1"
        d="m-2127.917 606.845.07-1.088.054-.834c.039-.6.1-1.431-.635-1.639a1.105 1.105 0 0 0-1.477 1.138c.032.817.082 1.633.137 2.449.027.408.056.816.085 1.224a4.558 4.558 0 0 0 .161 1.151c.011.035.023.07.037.1a.7.7 0 0 0 1.232.122 1.147 1.147 0 0 0 .156-.436c.073-.69.134-1.383.171-2.075.004-.035.007-.074.009-.112z"
        transform="translate(-99.702 -53.605)"
      />
    </g>
  </svg>
);

// UNDO ITS TSYLING AS SOON AS I GET THE ICON FOR REF VIEW
export const chainIcon = (): JSX.Element => (
  <svg width="13" height="13" viewBox="0 0 15.453 15.453">
    <path
      d="M9.538 5.414a4.437 4.437 0 0 1 .011 6.267l-.011.011-1.963 1.962A4.439 4.439 0 0 1 1.3 7.376l1.081-1.083a.467.467 0 0 1 .8.31 5.381 5.381 0 0 0 .283 1.54.47.47 0 0 1-.11.485l-.382.382A2.1 2.1 0 1 0 5.923 12l1.963-1.96a2.1 2.1 0 0 0 0-2.974 2.187 2.187 0 0 0-.3-.25.468.468 0 0 1-.2-.368 1.163 1.163 0 0 1 .342-.87l.615-.615a.469.469 0 0 1 .6-.051 4.453 4.453 0 0 1 .6.5zM13.654 1.3a4.444 4.444 0 0 0-6.278 0L5.414 3.26l-.014.011a4.44 4.44 0 0 0 .61 6.769.469.469 0 0 0 .6-.051l.615-.615a1.163 1.163 0 0 0 .342-.87.468.468 0 0 0-.2-.368 2.188 2.188 0 0 1-.3-.25 2.1 2.1 0 0 1 0-2.974L9.028 2.95a2.1 2.1 0 1 1 2.955 2.993l-.382.382a.47.47 0 0 0-.11.485 5.381 5.381 0 0 1 .283 1.54.467.467 0 0 0 .8.31l1.084-1.084a4.444 4.444 0 0 0 0-6.278z"
      transform="translate(.25 .25)"
      // style={{
      //   fill: "#4c4c4c",
      //   stroke: "#fff",
      //   strokeWidth: ".5px",
      //   opacity: ".8",
      // }}
    />
  </svg>
);

export const scanIconSecondary = (): JSX.Element => (
  <svg width="12.68" height="12.68" viewBox="0 0 15.861 15.861">
    <defs>
      <style>{`.scan-icon-secondary-cls-2{fill:#4c4c4c}`}</style>
    </defs>
    <g
      id="Group_2511"
      data-name="Group 2511"
      transform="translate(-84.011 -129.238)"
      style={{ opacity: ".8" }}
    >
      <path
        id="Path_2733"
        data-name="Path 2733"
        className="scan-icon-secondary-cls-2"
        d="M91.963 269.219h7.258c.488 0 .65.163.651.653v.768a.5.5 0 0 1-.569.561H84.687c-.524 0-.675-.153-.675-.679v-.743a.5.5 0 0 1 .568-.561h3.716z"
        transform="translate(-.001 -133.043)"
      />
      <path
        id="Path_2734"
        data-name="Path 2734"
        className="scan-icon-secondary-cls-2"
        d="M85.994 131.221v2.429a.5.5 0 0 1-.535.545q-.458.008-.916 0a.5.5 0 0 1-.529-.549v-3.861a.492.492 0 0 1 .533-.543h3.886a.5.5 0 0 1 .535.543q.007.445 0 .891a.5.5 0 0 1-.56.546c-.792.001-1.584-.001-2.414-.001z"
      />
      <path
        id="Path_2735"
        data-name="Path 2735"
        className="scan-icon-secondary-cls-2"
        d="M306.951 131.222h-2.342c-.458 0-.63-.173-.631-.625v-.817a.494.494 0 0 1 .538-.54h3.886a.488.488 0 0 1 .53.521v3.911a.489.489 0 0 1-.508.52c-.313.008-.627.006-.941 0a.5.5 0 0 1-.531-.548v-2.129c-.002-.087-.001-.176-.001-.293z"
        transform="translate(-209.062 -.001)"
      />
      <path
        id="Path_2736"
        data-name="Path 2736"
        className="scan-icon-secondary-cls-2"
        d="M85.994 352.157h2.117c.776 0 .857.082.858.869v.569a.5.5 0 0 1-.536.543h-3.886a.492.492 0 0 1-.532-.544v-3.862a.494.494 0 0 1 .53-.548q.458-.008.916 0a.5.5 0 0 1 .535.545v2.129z"
        transform="translate(0 -209.041)"
      />
      <path
        id="Path_2737"
        data-name="Path 2737"
        className="scan-icon-secondary-cls-2"
        d="M306.925 352.177v-2.34c0-.461.169-.632.622-.633h.817a.5.5 0 0 1 .542.536v3.886a.493.493 0 0 1-.545.532h-3.862a.5.5 0 0 1-.547-.531q-.008-.458 0-.916a.5.5 0 0 1 .547-.533h2.129z"
        transform="translate(-209.037 -209.062)"
      />
    </g>
  </svg>
);

export const redirectIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "6.96"}
    height={height || "6.96"}
    viewBox="0 0 8.702 8.702"
  >
    <defs>
      <style>
        {` .redirect-icon-cls-1{fill:none;stroke:#428bca;stroke-linecap:round;stroke-linejoin:round;strokeWidth:2.5px}`}
      </style>
    </defs>
    <g
      id="Group_2532"
      data-name="Group 2532"
      transform="translate(-5.532 -5.277)"
    >
      <g
        id="Icon_feather-arrow-upRight"
        data-name="Icon feather-arrow-upRight"
        transform="translate(7.3 7.044)"
      >
        <path
          id="Path_2392"
          data-name="Path 2392"
          className="redirect-icon-cls-1"
          d="m10.5 15.667 5.167-5.167"
          transform="translate(-10.5 -10.5)"
        />
        <path
          id="Path_2393"
          data-name="Path 2393"
          className="redirect-icon-cls-1"
          d="M10.5 10.5h5.167v5.167"
          transform="translate(-10.5 -10.5)"
        />
      </g>
    </g>
  </svg>
);

export const downloadInstallerIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "117.803"}
    height={height || "117.299"}
    viewBox="0 0 117.803 117.299"
  >
    <defs>
      <style>{`.cls-3{fill:#fff}.cls-5{fill:#478fca}`}</style>
    </defs>
    <g
      id="Group_2679"
      data-name="Group 2679"
      transform="translate(1069.9 -179.638)"
    >
      <path
        id="Path_2911"
        data-name="Path 2911"
        d="M0 0h117.8v39.561H0z"
        transform="translate(-1069.9 257.376)"
        style={{ fill: "#b3b4b5" }}
      />
      <path
        id="Path_2909"
        data-name="Path 2909"
        d="M-952.1 291.755h-117.8l16.557-60.718h84.689z"
        transform="translate(0 -34.378)"
        style={{ fill: "#cdcdcd" }}
      />
      <g
        id="Group_2677"
        data-name="Group 2677"
        transform="translate(-1063.085 272.85)"
      >
        <rect
          id="Rectangle_1526"
          data-name="Rectangle 1526"
          className="cls-3"
          width="3.889"
          height="11.752"
          rx="1.945"
        />
        <rect
          id="Rectangle_1527"
          data-name="Rectangle 1527"
          className="cls-3"
          width="3.889"
          height="11.752"
          rx="1.945"
          transform="translate(7.863)"
        />
        <rect
          id="Rectangle_1528"
          data-name="Rectangle 1528"
          className="cls-3"
          width="3.889"
          height="11.752"
          rx="1.945"
          transform="translate(15.387)"
        />
        <rect
          id="Rectangle_1529"
          data-name="Rectangle 1529"
          className="cls-3"
          width="3.889"
          height="11.752"
          rx="1.945"
          transform="translate(23.25)"
        />
        <rect
          id="Rectangle_1530"
          data-name="Rectangle 1530"
          className="cls-3"
          width="3.889"
          height="11.752"
          rx="1.945"
          transform="translate(30.944)"
        />
        <rect
          id="Rectangle_1531"
          data-name="Rectangle 1531"
          className="cls-3"
          width="3.889"
          height="11.752"
          rx="1.945"
          transform="translate(38.807)"
        />
      </g>
      <path
        id="Rectangle_1532"
        data-name="Rectangle 1532"
        transform="translate(-970.852 274.414)"
        style={{ fill: "#ff4c00" }}
        d="M0 0h8.37v8.37H0z"
      />
      <rect
        id="Rectangle_1533"
        data-name="Rectangle 1533"
        className="cls-3"
        width="3.889"
        height="11.752"
        rx="1.945"
        transform="rotate(-90 -352.957 633.501)"
      />
      <g
        id="Group_2678"
        data-name="Group 2678"
        transform="translate(-1026.217 179.638)"
      >
        <path
          id="Rectangle_1534"
          data-name="Rectangle 1534"
          className="cls-5"
          transform="translate(10.146)"
          d="M0 0h10.146v50.389H0z"
        />
        <path
          id="Path_2910"
          data-name="Path 2910"
          className="cls-5"
          d="m-922.763 336.719 15.218-14h-30.437z"
          transform="translate(937.982 -275.338)"
        />
      </g>
    </g>
  </svg>
);

export const checkInCircleIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "56"} height={height || "56"} viewBox="0 0 56 56">
    <defs>
      <style>{`.circle-cls-1{fill:#87b87f}.check-cls-1{fill:#fff}`}</style>
    </defs>
    <g data-name="Group 8" transform="translate(-827.97 -378.97)">
      <circle
        className="circle-cls-1"
        data-name="Ellipse 15"
        cx="28"
        cy="28"
        r="28"
        transform="translate(827.97 378.97)"
      />
      <path
        className="check-cls-1"
        data-name="Path 2902"
        d="M-215.145 1731.227c3.58-3.576 7.071-7.058 10.555-10.547 1.372-1.373 2.037-1.381 3.406-.006.535.538 1.089 1.058 1.6 1.614a1.644 1.644 0 0 1 0 2.587q-7.123 7.164-14.28 14.293a1.653 1.653 0 0 1-2.594 0q-4.119-4.063-8.179-8.184a1.614 1.614 0 0 1-.008-2.516 40.62 40.62 0 0 1 2.006-2.018 1.7 1.7 0 0 1 2.728.053c1.33 1.308 2.635 2.642 3.954 3.961.247.242.502.47.812.763z"
        transform="translate(1067.997 -1321.866)"
      />
    </g>
  </svg>
);

export const checkedDatabaseIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "23.641"}
    height={height || "23.626"}
    viewBox="0 0 23.641 23.626"
  >
    <defs>
      <style>{`.cls{}`}</style>
    </defs>
    <g data-name="Group 2693">
      <path
        data-name="Icon awesome-database"
        d="M18.952 3.094v1.934c0 1.7-4.244 3.094-9.476 3.094S0 6.732 0 5.028V3.094C0 1.39 4.244 0 9.476 0s9.476 1.39 9.476 3.094zm0 4.351V11.8c0 1.7-4.244 3.094-9.476 3.094S0 13.5 0 11.8V7.445C2.036 8.847 5.762 9.5 9.476 9.5s7.44-.653 9.476-2.055zm0 6.768v4.351c0 1.7-4.244 3.094-9.476 3.094S0 20.269 0 18.565v-4.351c2.036 1.4 5.762 2.055 9.476 2.055s7.44-.653 9.476-2.055z"
        style={{ fill: "#428bca" }}
      />
      <g data-name="Path 2922" style={{ fill: "#d9edf7" }}>
        <path
          d="M7.555 14.61A7.063 7.063 0 0 1 .5 7.554 7.063 7.063 0 0 1 7.555.5a7.063 7.063 0 0 1 7.054 7.055 7.063 7.063 0 0 1-7.054 7.054z"
          style={{ stroke: "none" }}
          transform="translate(8.532 8.516)"
        />
        <path
          d="M7.555 1A6.562 6.562 0 0 0 1 7.555a6.562 6.562 0 0 0 6.555 6.554 6.562 6.562 0 0 0 6.554-6.554A6.562 6.562 0 0 0 7.555 1m0-1a7.555 7.555 0 1 1 0 15.11 7.555 7.555 0 0 1 0-15.11z"
          style={{ fill: "#428bca", stroke: "none" }}
          transform="translate(8.532 8.516)"
        />
      </g>
      <path
        data-name="Path 2917"
        d="M-222.259 1723.063c1.056-1.055 2.087-2.083 3.115-3.113.4-.405.6-.407 1.005 0 .158.159.321.313.474.477a.485.485 0 0 1 0 .764q-2.1 2.114-4.214 4.218a.488.488 0 0 1-.766 0q-1.215-1.2-2.414-2.415a.476.476 0 0 1 0-.742c.19-.205.389-.4.592-.6a.5.5 0 0 1 .805.016c.392.386.778.78 1.167 1.169.07.073.145.14.236.226z"
        transform="translate(237.403 -1706.043)"
        style={{ fill: "#428bca" }}
      />
    </g>
  </svg>
);

export const plusIconInFilledCircleNew = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "22"} height={height || "22"} viewBox="0 0 22 22">
    <defs>
      <style>{`.plus-icon-in-circle-cls-2{fill:#428bca}`}</style>
    </defs>
    <g data-name="Group 1133" transform="translate(-634 -116.617)">
      <circle
        data-name="Ellipse 1"
        cx="11"
        cy="11"
        r="11"
        transform="translate(634 116.617)"
        style={{ fill: "#478fca" }}
      />
      <path
        data-name="Union 1"
        d="M3.859 11.027v-3.86H0V3.859h3.859V0h3.308v3.859h3.859v3.308H7.167v3.859z"
        transform="translate(639.513 122.511)"
        style={{ fill: "#ffffff" }}
      />
    </g>
  </svg>
);

export const datasourceIconForEmptySlate = (): JSX.Element => (
  <svg width="96" height="83.4" viewBox="0 0 120 104.046">
    <defs>
      <style>{` .datasource-icon-for-empty-slate-cls-1{fill:#428bca}.datasource-icon-for-empty-slate-cls-2{fill:#cde2f7}`}</style>
    </defs>
    <g
      id="Group_2130"
      data-name="Group 2130"
      transform="translate(-1339 -384.954)"
    >
      <ellipse
        id="Ellipse_294"
        data-name="Ellipse 294"
        className="datasource-icon-for-empty-slate-cls-1"
        cx="5"
        cy="4.5"
        rx="5"
        ry="4.5"
        transform="translate(1449 427)"
      />
      <circle
        id="Ellipse_295"
        data-name="Ellipse 295"
        className="datasource-icon-for-empty-slate-cls-1"
        cx="5"
        cy="5"
        r="5"
        transform="translate(1357 479)"
      />
      <g
        id="Group_2123"
        data-name="Group 2123"
        transform="translate(1341.494 388.954)"
      >
        <path
          id="Icon_awesome-database"
          data-name="Icon awesome-database"
          className="datasource-icon-for-empty-slate-cls-2"
          d="M64.482 10.528v6.58c0 5.8-14.441 10.528-32.241 10.528S0 22.906 0 17.108v-6.58C0 4.729 14.441 0 32.241 0s32.241 4.729 32.241 10.528zm0 14.8v14.8c0 5.8-14.441 10.528-32.241 10.528S0 45.935 0 40.137v-14.8c6.927 4.77 19.6 6.991 32.241 6.991s25.314-2.228 32.241-6.996zm0 23.029v14.8c0 5.8-14.441 10.528-32.241 10.528S0 68.965 0 63.166v-14.8c6.927 4.77 19.6 6.991 32.241 6.991s25.314-2.225 32.241-6.995z"
          transform="translate(0 -4)"
        />
        <path
          id="Icon_awesome-database-2"
          data-name="Icon awesome-database"
          className="datasource-icon-for-empty-slate-cls-1"
          d="M71.453 11.666v7.291c0 6.425-16 11.666-35.727 11.666S0 25.382 0 18.957v-7.291C0 5.24 16 0 35.727 0s35.726 5.24 35.726 11.666zm0 16.405v16.405c0 6.425-16 11.666-35.727 11.666S0 50.9 0 44.476V28.071c7.676 5.286 21.724 7.747 35.727 7.747s28.05-2.461 35.726-7.747zm0 25.519v16.405c0 6.425-16 11.666-35.727 11.666S0 76.42 0 69.995V53.59c7.676 5.286 21.724 7.747 35.727 7.747s28.05-2.461 35.726-7.747z"
          transform="translate(18.184 -.027)"
        />
        <g
          id="Group_2129"
          data-name="Group 2129"
          transform="translate(57.19 51.371)"
        >
          <ellipse
            id="Ellipse_291"
            data-name="Ellipse 291"
            className="datasource-icon-for-empty-slate-cls-2"
            cx="22"
            cy="22.5"
            rx="22"
            ry="22.5"
            transform="translate(.316 -.325)"
          />
          <g
            id="Group_2121"
            data-name="Group 2121"
            transform="translate(11.64 12.698)"
          >
            <path
              id="Rectangle_1365"
              data-name="Rectangle 1365"
              className="datasource-icon-for-empty-slate-cls-1"
              transform="translate(-.325 5.977)"
              d="M0 0h21v7H0z"
            />
            <path
              id="Rectangle_1366"
              data-name="Rectangle 1366"
              className="datasource-icon-for-empty-slate-cls-1"
              transform="rotate(-90 13.326 6.651)"
              d="M0 0h20v8H0z"
            />
          </g>
        </g>
      </g>
      <circle
        id="Ellipse_293"
        data-name="Ellipse 293"
        className="datasource-icon-for-empty-slate-cls-1"
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(1339 385)"
      />
    </g>
  </svg>
);

export const productTourIcon = (): JSX.Element => (
  <svg width="146.07" height="93.2" viewBox="0 0 182.592 116.567">
    <defs>
      <style>{`.product-tour-icon-cls-2{fill:#428bca}.product-tour-icon-cls-3{fill:#cde2f7}`}</style>
    </defs>
    <g
      id="Group_2128"
      data-name="Group 2128"
      transform="translate(-459.82 -368.5)"
    >
      <g
        id="Group_2127"
        data-name="Group 2127"
        transform="translate(478.885 380.309)"
      >
        <g id="Group_2123" data-name="Group 2123">
          <g
            id="Rectangle_1367"
            data-name="Rectangle 1367"
            transform="translate(-.224 .224)"
            style={{ fill: "#fff", stroke: "#428bca", strokeWidth: "3px" }}
          >
            <rect width="143" height="98" rx="6" style={{ stroke: "none" }} />
            <rect
              x="1.5"
              y="1.5"
              width="140"
              height="95"
              rx="4.5"
              style={{ fill: "none" }}
            />
          </g>
        </g>
        <circle
          id="Ellipse_292"
          data-name="Ellipse 292"
          className="product-tour-icon-cls-2"
          cx="4.5"
          cy="4.5"
          r="4.5"
          transform="translate(122.776 10.224)"
        />
        <path
          id="Rectangle_1390"
          data-name="Rectangle 1390"
          className="product-tour-icon-cls-3"
          d="M7 0h39a7 7 0 0 1 7 7v8a1 1 0 0 1-1 1H0V7a7 7 0 0 1 7-7z"
          transform="translate(16.776 79.224)"
        />
        <path
          id="Rectangle_1391"
          data-name="Rectangle 1391"
          className="product-tour-icon-cls-3"
          d="M7 0h38a7 7 0 0 1 7 7v8a1 1 0 0 1-1 1H0V7a7 7 0 0 1 7-7z"
          transform="translate(79.776 79.224)"
        />
        <rect
          id="Rectangle_1369"
          data-name="Rectangle 1369"
          className="product-tour-icon-cls-3"
          width="9"
          height="93"
          rx="4"
          transform="translate(1.776 2.224)"
        />
        <rect
          id="Rectangle_1368"
          data-name="Rectangle 1368"
          className="product-tour-icon-cls-2"
          width="42"
          height="5"
          rx="2.5"
          transform="translate(16.776 12.224)"
        />
        <rect
          id="Rectangle_1370"
          data-name="Rectangle 1370"
          className="product-tour-icon-cls-2"
          width="15"
          height="5"
          rx="2.5"
          transform="translate(16.776 29.224)"
        />
        <rect
          id="Rectangle_1375"
          data-name="Rectangle 1375"
          className="product-tour-icon-cls-3"
          width="15"
          height="5"
          rx="2.5"
          transform="translate(16.776 40.224)"
        />
        <rect
          id="Rectangle_1380"
          data-name="Rectangle 1380"
          className="product-tour-icon-cls-3"
          width="15"
          height="4"
          rx="2"
          transform="translate(16.776 52.224)"
        />
        <rect
          id="Rectangle_1385"
          data-name="Rectangle 1385"
          className="product-tour-icon-cls-3"
          width="15"
          height="5"
          rx="2.5"
          transform="translate(16.776 63.224)"
        />
        <rect
          id="Rectangle_1371"
          data-name="Rectangle 1371"
          className="product-tour-icon-cls-2"
          width="15"
          height="5"
          rx="2.5"
          transform="translate(39.776 29.224)"
        />
        <rect
          id="Rectangle_1376"
          data-name="Rectangle 1376"
          className="product-tour-icon-cls-3"
          width="15"
          height="5"
          rx="2.5"
          transform="translate(39.776 40.224)"
        />
        <rect
          id="Rectangle_1381"
          data-name="Rectangle 1381"
          className="product-tour-icon-cls-3"
          width="15"
          height="4"
          rx="2"
          transform="translate(39.776 52.224)"
        />
        <rect
          id="Rectangle_1386"
          data-name="Rectangle 1386"
          className="product-tour-icon-cls-3"
          width="15"
          height="5"
          rx="2.5"
          transform="translate(39.776 63.224)"
        />
        <rect
          id="Rectangle_1372"
          data-name="Rectangle 1372"
          className="product-tour-icon-cls-2"
          width="15"
          height="5"
          rx="2.5"
          transform="translate(62.776 29.224)"
        />
        <rect
          id="Rectangle_1377"
          data-name="Rectangle 1377"
          className="product-tour-icon-cls-3"
          width="15"
          height="5"
          rx="2.5"
          transform="translate(62.776 40.224)"
        />
        <rect
          id="Rectangle_1382"
          data-name="Rectangle 1382"
          className="product-tour-icon-cls-3"
          width="15"
          height="4"
          rx="2"
          transform="translate(62.776 52.224)"
        />
        <rect
          id="Rectangle_1387"
          data-name="Rectangle 1387"
          className="product-tour-icon-cls-3"
          width="15"
          height="5"
          rx="2.5"
          transform="translate(62.776 63.224)"
        />
        <rect
          id="Rectangle_1373"
          data-name="Rectangle 1373"
          className="product-tour-icon-cls-2"
          width="15"
          height="5"
          rx="2.5"
          transform="translate(84.776 29.224)"
        />
        <rect
          id="Rectangle_1378"
          data-name="Rectangle 1378"
          className="product-tour-icon-cls-3"
          width="15"
          height="5"
          rx="2.5"
          transform="translate(84.776 40.224)"
        />
        <rect
          id="Rectangle_1383"
          data-name="Rectangle 1383"
          className="product-tour-icon-cls-3"
          width="15"
          height="4"
          rx="2"
          transform="translate(84.776 52.224)"
        />
        <rect
          id="Rectangle_1388"
          data-name="Rectangle 1388"
          className="product-tour-icon-cls-3"
          width="15"
          height="5"
          rx="2.5"
          transform="translate(84.776 63.224)"
        />
        <rect
          id="Rectangle_1374"
          data-name="Rectangle 1374"
          className="product-tour-icon-cls-2"
          width="24"
          height="5"
          rx="2.5"
          transform="translate(107.776 29.224)"
        />
        <rect
          id="Rectangle_1379"
          data-name="Rectangle 1379"
          className="product-tour-icon-cls-3"
          width="24"
          height="5"
          rx="2.5"
          transform="translate(107.776 40.224)"
        />
        <rect
          id="Rectangle_1384"
          data-name="Rectangle 1384"
          className="product-tour-icon-cls-3"
          width="24"
          height="4"
          rx="2"
          transform="translate(107.776 52.224)"
        />
        <rect
          id="Rectangle_1389"
          data-name="Rectangle 1389"
          className="product-tour-icon-cls-3"
          width="24"
          height="5"
          rx="2.5"
          transform="translate(107.776 63.224)"
        />
      </g>
      <path
        id="Path_2697"
        data-name="Path 2697"
        className="product-tour-icon-cls-2"
        d="M3717.115-281.167c-1.1-6.45-3.869-11.163-10.476-12.814 6.512-1.675 9.371-6.347 10.449-12.695 1.144 6.332 3.961 11.061 10.71 12.727a11.545 11.545 0 0 0-7.442 4.471 16.775 16.775 0 0 0-3.241 8.311z"
        transform="translate(-3095.676 766.233)"
      />
      <path
        id="Path_2699"
        data-name="Path 2699"
        className="product-tour-icon-cls-2"
        d="M3713.79-289.263c-.751-4.4-2.641-7.62-7.151-8.747 4.445-1.143 6.4-4.332 7.132-8.665.781 4.322 2.7 7.55 7.311 8.688a7.881 7.881 0 0 0-5.08 3.052 11.449 11.449 0 0 0-2.212 5.672z"
        transform="translate(-3078.67 695.487)"
      />
      <path
        id="Path_2700"
        data-name="Path 2700"
        className="product-tour-icon-cls-2"
        d="M3712.244-293.028c-.59-3.451-2.07-5.972-5.6-6.855 3.484-.9 5.013-3.4 5.59-6.792.612 3.387 2.119 5.917 5.73 6.809a6.177 6.177 0 0 0-3.981 2.392 8.969 8.969 0 0 0-1.739 4.446z"
        transform="translate(-3246.819 764.979)"
      />
      <path
        id="Path_2698"
        data-name="Path 2698"
        className="product-tour-icon-cls-2"
        d="M3717.115-281.167c-1.1-6.45-3.869-11.163-10.476-12.814 6.512-1.675 9.371-6.347 10.449-12.695 1.144 6.332 3.961 11.061 10.71 12.727a11.545 11.545 0 0 0-7.442 4.471 16.775 16.775 0 0 0-3.241 8.311z"
        transform="translate(-3235.499 675.175)"
      />
    </g>
  </svg>
);

export const noDataExistsIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "34.08"}
    height={height || "34.08"}
    viewBox="0 0 42.667 42.741"
  >
    <path
      data-name="Path 2701"
      d="M3992.469 601.1a21.371 21.371 0 1 0 21.366 21.34 21.422 21.422 0 0 0-21.366-21.34zm-12.635 30.187v-.071c-.249.155-.446.062-.713-.371a15.549 15.549 0 0 1-2.393-8.9 15.781 15.781 0 0 1 21.267-14.281 19.068 19.068 0 0 1 2.82 1.372c.414.238.625.43.416.746l.083.021-20.778 20.771zm20.183 5.02c-5.3 2.9-10.664 2.633-15.881-.439-.551-.325-.571-.568-.1-1q.306-.283.607-.572l.917-.919 19.065-19.1c.117-.121.234-.242.347-.367.352-.386.562-.354.837.09a15.317 15.317 0 0 1 2.218 5.75 15.476 15.476 0 0 1-8.011 16.562z"
      transform="translate(-3971.167 -601.105)"
    />
  </svg>
);

export const noAlertExistsIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "52.302"}
    height={height || "47.403"}
    viewBox="0 0 52.302 47.403"
  >
    <path
      id="Path_2706"
      data-name="Path 2706"
      d="M-496.727,21.357c-6.82,0-13.641.011-20.462-.006a5.472,5.472,0,0,1-5.478-4.179,5.6,5.6,0,0,1,.635-4.37q4.494-7.883,8.961-15.782,5.616-9.9,11.231-19.795c1.486-2.624,3.713-3.718,6.511-3.084a5.066,5.066,0,0,1,3.376,2.489q3.513,6.13,6.989,12.282,6.78,11.931,13.555,23.864a5.509,5.509,0,0,1-2.286,7.972,7.45,7.45,0,0,1-3.092.587c-6.647.05-13.294.026-19.941.026Zm-3.118-31.835c.05,3.088.441,6.163.613,9.245a33.728,33.728,0,0,0,.4,3.718c.165.979.232,2.39,1.121,3.019a2.217,2.217,0,0,0,3.184-.9,15.592,15.592,0,0,0,.779-4.209q.231-2.353.443-4.708.222-2.5.4-5a28.3,28.3,0,0,0-.146-4.517,2.822,2.822,0,0,0-1.439-2.387,3.6,3.6,0,0,0-5.253,2.49,9.384,9.384,0,0,0-.1,1.335C-499.854-11.754-499.856-11.117-499.845-10.478Zm3.511,26.165A3.342,3.342,0,0,0-492.82,12.2a3.5,3.5,0,0,0-3.551-3.515,3.485,3.485,0,0,0-3.524,3.543A3.383,3.383,0,0,0-496.334,15.687Z"
      transform="translate(522.861 26.034)"
      fill="#d2d2d2"
    />
  </svg>
);

export const deprecateIcon = (): JSX.Element => (
  <svg width="21" height="21" viewBox="0 0 21 21">
    <g id="Group_2683" data-name="Group 2683" transform="translate(-854 -1147)">
      <g
        id="Group_1348"
        data-name="Group 1348"
        transform="translate(-716.653 796.249)"
      >
        <g
          id="Ellipse_264"
          data-name="Ellipse 264"
          transform="translate(1570.653 350.751)"
          fill="#dd5a43"
          stroke="#dd5a43"
          strokeWidth="1"
        >
          <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
          <circle cx="10.5" cy="10.5" r="10" fill="none" />
        </g>
      </g>
      <g
        id="Group_844"
        data-name="Group 844"
        transform="translate(863.5 1149.403)"
      >
        <path
          id="Path_2643"
          data-name="Path 2643"
          d="M.806,2a.806.806,0,0,1,.806.806V9.557A.806.806,0,1,1,0,9.557V2.806A.806.806,0,0,1,.806,2Z"
          transform="translate(0.21)"
          style={{ fill: "#fff" }}
        />
        <ellipse
          id="Ellipse_265"
          data-name="Ellipse 265"
          cx="1.091"
          cy="1.091"
          rx="1.091"
          ry="1.091"
          transform="translate(0 11.388)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);

export const skipIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "20"} height={height || "20"} viewBox="0 0 20 20">
    <g id="Group_2654" data-name="Group 2654" transform="translate(-56 -673)">
      <g
        id="Ellipse_6"
        data-name="Ellipse 6"
        transform="translate(56 673)"
        fill="none"
        stroke="#989898"
        strokeWidth="1.6"
      >
        <circle cx="10" cy="10" r="10" stroke="none" />
        <circle cx="10" cy="10" r="9.2" fill="none" />
      </g>
      <g
        id="Group_2653"
        data-name="Group 2653"
        transform="translate(1785.044 466.002)"
      >
        <path
          id="Path_2804"
          data-name="Path 2804"
          d="M-1724.041,229.045c0-.961,0-1.921,0-2.882a.729.729,0,0,1,.374-.7.725.725,0,0,1,.819.067c1.376.972,2.755,1.942,4.125,2.922a.7.7,0,0,1,.005,1.194c-1.372.979-2.751,1.947-4.128,2.918a.728.728,0,0,1-.819.07.732.732,0,0,1-.376-.7C-1724.038,230.966-1724.041,230.005-1724.041,229.045Z"
          transform="translate(1 -11.692)"
          fill="#989898"
        />
        <path
          id="Path_2805"
          data-name="Path 2805"
          d="M-1589.266,217.379c0,1.188,0,2.376,0,3.564a.721.721,0,0,1-.478.719.666.666,0,0,1-.784-.21,1.027,1.027,0,0,1-.183-.548c-.012-1.959-.007-3.917-.006-5.876,0-.408-.007-.816,0-1.224a.739.739,0,0,1,.733-.806.742.742,0,0,1,.719.818Q-1589.264,215.6-1589.266,217.379Z"
          transform="translate(-126.007 0)"
          fill="#989898"
        />
      </g>
    </g>
  </svg>
);

export const fillChevronIconDown = (): JSX.Element => (
  <svg width="13" height="8" viewBox="0 0 13 8">
    <path
      id="Polygon_9"
      data-name="Polygon 9"
      d="M6.5,0,13,8H0Z"
      transform="translate(13 8) rotate(180)"
      fill="#fff"
    />
  </svg>
);

export const searchPageIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "126"} height={height || "126"} viewBox="0 0 126 126">
    <defs>
      <clipPath id="27xrkeazqa">
        <circle
          data-name="Ellipse 501"
          cx="63"
          cy="63"
          r="63"
          style={{ fill: "#f7f7f7" }}
        />
      </clipPath>
    </defs>
    <g data-name="Group 44" transform="translate(-8453 -404)">
      <circle
        data-name="Ellipse 499"
        cx="63"
        cy="63"
        r="63"
        transform="translate(8453 404)"
        style={{ fill: "#65c3c7", opacity: ".2" }}
      />
      <g
        data-name="Mask Group 10"
        transform="translate(8453 404)"
        style={{ clipPath: "url(#27xrkeazqa)" }}
      >
        <g data-name="Group 43" transform="rotate(4.01 -561.625 729.744)">
          <path
            d="M63.355 55.752H59.3l-1.52-1.52a31.724 31.724 0 0 0 8.109-21.287 32.945 32.945 0 1 0-32.944 32.944 31.724 31.724 0 0 0 21.287-8.109l1.52 1.52v4.055L81.094 88.7l7.6-7.6-25.339-25.348zm-30.41 0a22.808 22.808 0 1 1 22.807-22.807 22.713 22.713 0 0 1-22.807 22.807z"
            transform="translate(-11.41 -8.996)"
            style={{ fill: "#478fca", fillRule: "evenodd" }}
          />
          <circle
            data-name="Ellipse 500"
            cx="22.565"
            cy="22.565"
            r="22.565"
            transform="translate(-.968 1.68)"
            style={{ fill: "#fff", opacity: ".6" }}
          />
        </g>
      </g>
      <path
        data-name="Path 2909"
        d="M3717.115-281.167c-1.1-6.45-3.869-11.163-10.476-12.814 6.512-1.675 9.371-6.347 10.449-12.695 1.144 6.332 3.961 11.061 10.71 12.727a11.545 11.545 0 0 0-7.442 4.471 16.775 16.775 0 0 0-3.241 8.311z"
        transform="translate(4759.94 714.324)"
        style={{ fill: "#ff5200" }}
      />
      <path
        data-name="Path 2910"
        d="M3713.79-289.263c-.751-4.4-2.641-7.62-7.151-8.747 4.445-1.143 6.4-4.332 7.132-8.665.781 4.322 2.7 7.55 7.311 8.688a7.881 7.881 0 0 0-5.08 3.052 11.449 11.449 0 0 0-2.212 5.672z"
        transform="translate(4845.669 722.42)"
        style={{ fill: "#ff5200" }}
      />
      <path
        data-name="Path 2911"
        d="M3712.244-293.028c-.59-3.451-2.07-5.972-5.6-6.855 3.484-.9 5.013-3.4 5.59-6.792.612 3.387 2.119 5.917 5.73 6.809a6.177 6.177 0 0 0-3.981 2.392 8.969 8.969 0 0 0-1.739 4.446z"
        transform="translate(4770.52 788.913)"
        style={{ fill: "#ff5200" }}
      />
    </g>
  </svg>
);

export const saveIcon = (
  width?: string,
  height?: string,
  strokeWidth?: string
): JSX.Element => (
  <svg
    width={width || "14.385"}
    height={height || "18.414"}
    viewBox="0 0 14.385 18.414"
  >
    <defs>
      <style>
        {`
          .save-icon-outline-svg{
            fill: none; stroke: #4c4c4c; strokeWidth: ${strokeWidth || "2px"}
         }
        `}
      </style>
    </defs>
    <path
      d="M37 0h-9.521a1.455 1.455 0 0 0-1.457 1.393v14.089a1.08 1.08 0 0 0 .184.626.712.712 0 0 0 .588.306 1.062 1.062 0 0 0 .675-.284l4.261-3.618a.844.844 0 0 1 1.034 0l4.247 3.617a1.025 1.025 0 0 0 .659.285c.374 0 .738-.288.738-.932V1.393A1.409 1.409 0 0 0 37 0z"
      transform="translate(-25.022 1)"
      className="save-icon-outline-svg"
      data-name="Group 2216"
    />
  </svg>
);

export const saveIconFilled = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "14.385"}
    height={height || "18.414"}
    viewBox="0 0 14.385 18.414"
  >
    <defs>
      <style>
        {`
          .save-icon-filled-svg{
            fill: #428bca stroke: #428bca; strokeWidth: 2px
         }
        `}
      </style>
    </defs>

    <path
      d="M37 0h-9.521a1.455 1.455 0 0 0-1.457 1.393v14.089a1.08 1.08 0 0 0 .184.626.712.712 0 0 0 .588.306 1.062 1.062 0 0 0 .675-.284l4.261-3.618a.844.844 0 0 1 1.034 0l4.247 3.617a1.025 1.025 0 0 0 .659.285c.374 0 .738-.288.738-.932V1.393A1.409 1.409 0 0 0 37 0z"
      transform="translate(-25.022 1)"
      style={{ fill: "#428bca", stroke: "#428bca", strokeWidth: "2px" }}
      className="save-icon-filled-svg"
      data-name="Group 2216"
    />
  </svg>
);

export const shareIconWithoutBorder = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "23.01"}
    height={height || "20.759"}
    viewBox="0 0 23.01 20.759"
  >
    <path
      data-name="Path 2511"
      d="m20.787 33.633-6-6a.75.75 0 0 0-1.278.528v3H10.88q-8.36 0-10.259 4.725A10.676 10.676 0 0 0 0 39.789a14.079 14.079 0 0 0 1.489 5.288l.123.281q.088.199.158.352a1.332 1.332 0 0 0 .153.258.4.4 0 0 0 .328.2.342.342 0 0 0 .276-.117.437.437 0 0 0 .1-.293 2.387 2.387 0 0 0-.029-.311 2.425 2.425 0 0 1-.029-.275q-.059-.8-.059-1.442a9.979 9.979 0 0 1 .205-2.122 6.372 6.372 0 0 1 .569-1.624 4.079 4.079 0 0 1 .937-1.184 5.5 5.5 0 0 1 1.237-.815 6.706 6.706 0 0 1 1.559-.5 14.866 14.866 0 0 1 1.806-.252q.909-.07 2.058-.07h2.626v3a.746.746 0 0 0 1.278.528l6-6a.737.737 0 0 0 0-1.055z"
      transform="translate(1 -26.408)"
      style={{ fill: "none", stroke: "#4c4c4c", strokeWidth: "2px" }}
    />
  </svg>
);

export const minusIconFilled = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "18"} height={height || "18"} viewBox="0 0 18 18">
    <g
      id="Group_2668"
      data-name="Group 2668"
      transform="translate(-633.213 -117.713)"
    >
      <g
        id="Ellipse_264"
        data-name="Ellipse 264"
        transform="translate(633.213 117.713)"
        fill="none"
        stroke="#478fca"
        strokeWidth="1"
      >
        <circle cx="9" cy="9" r="9" stroke="none" />
        <circle cx="9" cy="9" r="8.5" fill="none" />
      </g>
      <g
        id="Rectangle_1519"
        data-name="Rectangle 1519"
        transform="translate(638.213 125.713)"
        fill="#fff"
        stroke="#478fca"
        strokeWidth="1"
      >
        <rect width="8" height="2" stroke="none" />
        <rect x="0.5" y="0.5" width="7" height="1" fill="none" />
      </g>
    </g>
  </svg>
);

export const blueTermIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "18.652"}
    height={height || "17.78"}
    viewBox="0 0 35.042 33.406"
  >
    <defs>
      <style>{`.blue-termicon-cls-1{fill: #428bca }`}</style>
    </defs>
    <g
      id="Group_2148"
      data-name="Group 2148"
      transform="translate(-4545 -53.819)"
    >
      <path
        id="Path_2358"
        data-name="Path 2358"
        d="M-919.19,686.191h-30.537a2.253,2.253,0,0,0-2.253,2.253v8.414h35v-2.137a2.266,2.266,0,0,0,.039-.386v-5.891A2.253,2.253,0,0,0-919.19,686.191Zm-25.472,7.047h-3.62v-1.713h3.62Zm14.055,0h-12.476v-1.713h12.476Z"
        transform="translate(5496.979 -632.371)"
        className="blue-termicon-cls-1"
      />
      <path
        id="Path_2359"
        data-name="Path 2359"
        d="M-951.979,717.6v16.943a2.253,2.253,0,0,0,2.253,2.253h30.537a2.253,2.253,0,0,0,2.253-2.253V717.6Zm14.9,15.634h-11.205v-3.591h11.205Zm0-5.343h-11.205V725.75h11.205Zm0-4.582h-11.205v-2.137h11.205Zm15.75,6.705a3.22,3.22,0,0,1-3.22,3.22h-4.765a3.22,3.22,0,0,1-3.22-3.22v-5.622a3.22,3.22,0,0,1,3.22-3.22h4.765a3.22,3.22,0,0,1,3.22,3.22Z"
        transform="translate(5496.979 -649.567)"
        className="blue-termicon-cls-1"
      />
    </g>
  </svg>
);

export const redoIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "14.854"}
    height={height || "14.809"}
    viewBox="0 0 14.854 14.809"
  >
    <g data-name="Group 2227">
      <g data-name="Group 2226">
        <path
          data-name="Path 2673"
          d="M-709.3-166.207a.634.634 0 0 1 .374.64v4.156a.635.635 0 0 1-.687.709c-1.4.011-2.792.007-4.188 0a.618.618 0 0 1-.644-.419.629.629 0 0 1 .217-.706c.421-.4.829-.815 1.263-1.245a4.57 4.57 0 0 0-2.662-1.3 4.956 4.956 0 0 0-5.6 4.083 4.975 4.975 0 0 0 4.482 5.749 4.861 4.861 0 0 0 4.2-1.768c.272-.317.4-.321.7-.028.366.365.721.741 1.1 1.095.241.227.214.409.007.642a7.514 7.514 0 0 1-10.8.425 7.988 7.988 0 0 1-1.98-3.485 6.528 6.528 0 0 1-.226-2.369 6.663 6.663 0 0 1 .255-1.346 7.222 7.222 0 0 1 6.1-5.42 7.124 7.124 0 0 1 5.955 1.767c.066.056.129.114.257.227.389-.411.776-.813 1.155-1.222a.592.592 0 0 1 .722-.185z"
          transform="translate(723.776 166.89)"
          fill="#cfd1d1"
        />
      </g>
    </g>
  </svg>
);

export const chainIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "60"} height={height || "60"} viewBox="0 0 60 60">
    <g id="Group_1932" data-name="Group 1932" transform="translate(-1411 -563)">
      <g
        id="Ellipse_264"
        data-name="Ellipse 264"
        transform="translate(1411 563)"
        fill="#fff"
        stroke="#428bca"
        strokeWidth="1"
      >
        <circle cx="30" cy="30" r="30" stroke="none" />
        <circle cx="30" cy="30" r="29.5" fill="none" />
      </g>
      <path
        id="link-solid"
        d="M14.672,8.328a6.825,6.825,0,0,1,.016,9.64l-.016.017L11.653,21A6.828,6.828,0,0,1,2,11.347L3.663,9.68a.718.718,0,0,1,1.226.476,8.278,8.278,0,0,0,.435,2.368.723.723,0,0,1-.17.746l-.588.588a3.234,3.234,0,1,0,4.545,4.6l3.019-3.018a3.234,3.234,0,0,0,0-4.574,3.365,3.365,0,0,0-.465-.385.72.72,0,0,1-.312-.566,1.789,1.789,0,0,1,.526-1.339l.946-.946a.722.722,0,0,1,.925-.078,6.85,6.85,0,0,1,.922.773ZM21,2a6.836,6.836,0,0,0-9.657,0L8.328,5.015l-.016.017a6.83,6.83,0,0,0,.938,10.412.722.722,0,0,0,.925-.078l.946-.946a1.789,1.789,0,0,0,.526-1.339.72.72,0,0,0-.312-.566,3.365,3.365,0,0,1-.465-.385,3.234,3.234,0,0,1,0-4.574l3.019-3.018a3.234,3.234,0,1,1,4.545,4.6l-.588.588a.723.723,0,0,0-.17.746,8.278,8.278,0,0,1,.435,2.368.718.718,0,0,0,1.226.476L21,11.653A6.835,6.835,0,0,0,21,2Z"
        transform="translate(1429.001 582)"
        fill="#428bca"
      />
    </g>
  </svg>
);

export const arrowLeftSecondary = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "20.432"}
    height={height || "33.668"}
    viewBox="0 0 20.432 33.668"
  >
    <path
      id="Icon_awesome-chevron-left"
      data-name="Icon awesome-chevron-left"
      d="M2.475,18.173,17.459,3.19a1.851,1.851,0,0,1,2.617,0l1.748,1.748a1.85,1.85,0,0,1,0,2.614L9.951,19.482,21.826,31.413a1.85,1.85,0,0,1,0,2.614l-1.748,1.748a1.851,1.851,0,0,1-2.617,0L2.475,20.79A1.851,1.851,0,0,1,2.475,18.173Z"
      transform="translate(-1.933 -2.648)"
      fill="#5697cf"
    />
  </svg>
);

export const arrowRightSecondary = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "20.432"}
    height={height || "33.668"}
    viewBox="0 0 20.432 33.668"
  >
    <path
      id="Icon_awesome-chevron-left"
      data-name="Icon awesome-chevron-left"
      d="M21.824,18.173,6.84,3.19a1.851,1.851,0,0,0-2.617,0L2.475,4.938a1.85,1.85,0,0,0,0,2.614l11.876,11.93L2.473,31.413a1.85,1.85,0,0,0,0,2.614l1.748,1.748a1.851,1.851,0,0,0,2.617,0L21.824,20.79A1.851,1.851,0,0,0,21.824,18.173Z"
      transform="translate(-1.933 -2.648)"
      fill="#5697cf"
    />
  </svg>
);

export const fileIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "42"}
    height={height || "34"}
    viewBox="0 0 51.982 42.993"
  >
    <path
      d="M2.535 42.992a1.652 1.652 0 0 1-1.513-2.313l8.188-18.49a7.917 7.917 0 0 1 6.529-4.532h33.289c2.507 0 3.637 2.032 2.527 4.532l-8.263 18.662a3.577 3.577 0 0 1-3.285 2.142zM0 31.938V3.978A3.978 3.978 0 0 1 3.978 0h10.477a5.134 5.134 0 0 1 4.051 2l3.978 5.187a5.083 5.083 0 0 0 4.05 2h11.831a3.978 3.978 0 0 1 3.978 3.978v.43a1.117 1.117 0 0 1-1.116 1.122h-27.4a7.927 7.927 0 0 0-6.537 4.526L1.533 32.261a.773.773 0 0 1-.722.477.793.793 0 0 1-.811-.8z"
      style={{ fill: "#d2d2d2" }}
    />
  </svg>
);

export const filledCrossIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "44"} height={height || "44"} viewBox="0 0 44 44">
    <g
      id="Group_1164"
      data-name="Group 1164"
      transform="translate(-1572.653 -355.751)"
    >
      <g
        id="Ellipse_264"
        data-name="Ellipse 264"
        transform="translate(1572.653 355.751)"
        fill="#d15b47"
        stroke="#d15b47"
        strokeWidth="1"
      >
        <circle cx="22" cy="22" r="22" stroke="none" />
        <circle cx="22" cy="22" r="21.5" fill="none" />
      </g>
      <g
        id="tick_1_"
        data-name="tick (1)"
        transform="translate(1581.653 364.752)"
      >
        <path
          id="Path_2385"
          data-name="Path 2385"
          d="M8,19.257A1.5,1.5,0,0,1,6.939,16.7L22.43,1.2a1.5,1.5,0,1,1,2.121,2.121L9.06,18.817A1.5,1.5,0,0,1,8,19.257Z"
          transform="translate(-2.499 3.235)"
          fill="#fff"
        />
        <path
          id="Path_2386"
          data-name="Path 2386"
          d="M23.49,19.257a1.5,1.5,0,0,1-1.061-.439L6.939,3.326A1.5,1.5,0,0,1,9.06,1.2L24.551,16.7a1.5,1.5,0,0,1-1.061,2.561Z"
          transform="translate(-2.499 3.235)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);

export const blobIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "10.02"}
    height={height || "13.431"}
    viewBox="0 0 10.02 13.431"
  >
    <g
      id="Group_2757"
      data-name="Group 2757"
      transform="translate(-1774.5 -377.219)"
    >
      <g id="Group_2756" data-name="Group 2756">
        <path
          id="Union_21"
          data-name="Union 21"
          d="M17664.988-5929.57a.989.989,0,0,1-.988-.985v-11.457a.99.99,0,0,1,.988-.989h5.807a.937.937,0,0,1,.7.315l2.3,2.622a.932.932,0,0,1,.23.608v8.9a.989.989,0,0,1-.988.985Zm.014-1h8.02v-8.467h-2.758V-5942H17665Z"
          transform="translate(-15889.5 6320.221)"
          fill="#2c2c2c"
        />
      </g>
      <g id="binary-svgrepo-com" transform="translate(1773.954 380.25)">
        <path
          id="Rectangle_1702"
          data-name="Rectangle 1702"
          d="M0-.25H1.465a.25.25,0,0,1,.25.25V2.2a.25.25,0,0,1-.25.25H0A.25.25,0,0,1-.25,2.2V0A.25.25,0,0,1,0-.25Zm1.215.5H.25v1.7h.965Z"
          transform="translate(3.25 1.75)"
          fill="#2c2c2c"
        />
        <path
          id="Path_2925"
          data-name="Path 2925"
          d="M10.483,3.954a.25.25,0,0,1-.25-.25V2H9.75a.25.25,0,1,1,0-.5h.733a.25.25,0,0,1,.25.25V3.7A.25.25,0,0,1,10.483,3.954Z"
          transform="translate(-3.325)"
          fill="#2c2c2c"
        />
        <path
          id="Rectangle_1703"
          data-name="Rectangle 1703"
          d="M0-.25H1.465a.25.25,0,0,1,.25.25V2.2a.25.25,0,0,1-.25.25H0A.25.25,0,0,1-.25,2.2V0A.25.25,0,0,1,0-.25Zm1.215.5H.25v1.7h.965Z"
          transform="translate(6.425 5.657)"
          fill="#2c2c2c"
        />
        <path
          id="Path_2926"
          data-name="Path 2926"
          d="M3.983,11.954a.25.25,0,0,1-.25-.25V10H3.25a.25.25,0,1,1,0-.5h.733a.25.25,0,0,1,.25.25V11.7A.25.25,0,0,1,3.983,11.954Z"
          transform="translate(0 -4.093)"
          fill="#2c2c2c"
        />
      </g>
    </g>
  </svg>
);

export const warningPageIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "126"} height={height || "126"} viewBox="0 0 126 126">
    <g data-name="Group 44">
      <path
        data-name="Path 2953"
        d="M63 0A63 63 0 1 1 0 63 63 63 0 0 1 63 0z"
        style={{ opacity: 0.1, fill: "#f87f6b" }}
      />
      <path
        data-name="Path 2909"
        d="M3717.115-281.167c-1.1-6.45-3.869-11.163-10.476-12.814 6.512-1.675 9.371-6.347 10.449-12.695 1.144 6.332 3.961 11.061 10.71 12.727a11.545 11.545 0 0 0-7.442 4.471 16.775 16.775 0 0 0-3.241 8.311z"
        transform="translate(-3695.06 404.324)"
        style={{ fill: "#ff5200" }}
      />
      <path
        data-name="Path 2910"
        d="M3713.79-289.263c-.751-4.4-2.641-7.62-7.151-8.747 4.445-1.143 6.4-4.332 7.132-8.665.781 4.322 2.7 7.55 7.311 8.688a7.881 7.881 0 0 0-5.08 3.052 11.449 11.449 0 0 0-2.212 5.672z"
        transform="translate(-3607.331 318.42)"
        style={{ fill: "#ff5200" }}
      />
      <path
        data-name="Path 2911"
        d="M3712.244-293.028c-.59-3.451-2.07-5.972-5.6-6.855 3.484-.9 5.013-3.4 5.59-6.792.612 3.387 2.119 5.917 5.73 6.809a6.177 6.177 0 0 0-3.981 2.392 8.969 8.969 0 0 0-1.739 4.446z"
        transform="translate(-3596.48 333.852)"
        style={{ fill: "#ff5200" }}
      />
      <path
        d="M66.271 51.3 38.246 4.374a5.2 5.2 0 0 0-8.827-.368l-27.8 47.223c-2.207 3.457.294 8.758 4.409 8.758h55.756c4.046 0 6.547-5.223 4.487-8.68zm-32.512.736a3.6 3.6 0 1 1 3.6-3.6 3.607 3.607 0 0 1-3.6 3.603zM37.584 38.8a3.679 3.679 0 0 1-7.356 0V19.963a3.679 3.679 0 0 1 7.356 0z"
        transform="translate(29.097 27.428)"
        style={{ fill: "#f87f6b" }}
      />
    </g>
  </svg>
);

export const fieldDictionaryIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "22.548"}
    height={height || "19.073"}
    viewBox="0 0 22.548 19.073"
  >
    <g
      id="Group_2680"
      data-name="Group 2680"
      transform="translate(-427.896 -849.925)"
    >
      <path
        id="Path_1314"
        data-name="Path 1314"
        d="M-851.832,213.849a2.666,2.666,0,0,0-.066-.61,2.148,2.148,0,0,0-2.158-1.644q-4.515,0-9.031,0t-9.031,0a2.155,2.155,0,0,0-2.258,2.27q0,3.425,0,14.53a2.167,2.167,0,0,0,2.261,2.271H-854.1a2.168,2.168,0,0,0,2.27-2.263Q-851.828,218.495-851.832,213.849Zm-15.6,14.569c0,.373-.144.506-.525.507-.7,0-1.39,0-2.085,0s-1.39,0-2.085,0c-.364,0-.5-.14-.5-.5,0-.821,0-2.164,0-2.986,0-.354.148-.5.508-.5q2.085,0,4.17,0c.369,0,.518.146.52.517C-867.433,226.269-867.433,227.6-867.437,228.418Zm-5.2-8.726c0-.378.136-.522.509-.523q2.085,0,4.17,0c.373,0,.518.146.519.518,0,.806,0,2.18,0,2.986,0,.4-.144.534-.551.535-.695,0-1.39,0-2.085,0-.671,0-1.343,0-2.014,0-.422,0-.55-.131-.55-.554C-872.637,221.856-872.637,220.49-872.636,219.692Zm5.2-2.755c0,.354-.156.5-.512.5q-2.085,0-4.17,0c-.372,0-.516-.145-.516-.517,0-.813,0-2.291,0-3.1,0-.373.138-.507.519-.508.7,0,1.39,0,2.085,0s1.39,0,2.085,0c.364,0,.507.138.509.5C-867.433,214.63-867.433,216.115-867.437,216.937Zm13.866,11.474c0,.376-.137.513-.514.514-.695,0-1.39,0-2.085,0s-1.39,0-2.085,0c-.375,0-.514-.139-.516-.517,0-.806,0-2.133,0-2.938,0-.385.148-.531.53-.531q2.073,0,4.147,0c.384,0,.523.143.523.534C-853.569,226.278-853.569,227.605-853.571,228.411Zm-5.2-8.693c0-.405.14-.549.537-.549q2.061,0,4.123,0c.406,0,.54.137.541.54,0,.8,0,2.164,0,2.962,0,.4-.135.536-.544.537-.687,0-1.374,0-2.061,0s-1.359,0-2.038,0c-.42,0-.557-.137-.558-.552C-858.773,221.866-858.773,220.507-858.771,219.718Zm5.2-2.788c0,.358-.146.508-.5.508q-2.1,0-4.194,0c-.351,0-.5-.153-.5-.51,0-.821,0-2.306,0-3.128,0-.347.148-.489.494-.49.7,0,1.406,0,2.109,0s1.39,0,2.085,0c.376,0,.511.138.512.516C-853.569,214.639-853.569,216.116-853.571,216.93Z"
        transform="translate(1302.273 638.332)"
        fill="#b1bac1"
      />
    </g>
  </svg>
);

export const aiSuggestIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "18"} height={height || "18"} viewBox="0 0 18 18">
    <g
      id="ai_artificial_intelligence_chip_technology_cpu_icon_179503"
      transform="translate(-77.371 -77.371)"
    >
      <path
        id="Path_2390"
        data-name="Path 2390"
        d="M202.995,217.025a.439.439,0,0,0,.058-.054.516.516,0,0,0,.129-.344.6.6,0,0,0-.107-.337.557.557,0,0,0-.32-.219l-.023,0-.593-1.812q-.2-.6-.362-1.1-.165-.516-.321-.873a2.675,2.675,0,0,0-.344-.6.69.69,0,0,0-.545-.3.7.7,0,0,0-.541.3,2.87,2.87,0,0,0-.353.608c-.11.243-.222.53-.339.86s-.231.682-.355,1.072l-1.347,4.179a.6.6,0,0,0-.014.131.484.484,0,0,0,.183.391.557.557,0,0,0,.344.115.682.682,0,0,0,.562-.323.28.28,0,0,0,.041-.086l.459-1.5h2.65l.4,1.554a.554.554,0,0,0,.52.324.564.564,0,0,0,.6-.53.3.3,0,0,0-.009-.1Zm-2.231-3.13.563,1.675c.046.145.086.285.133.42H199.6l.932-2.761q.1.3.229.665Z"
        transform="translate(-116.44 -128.848)"
        fill="#4c4c4c"
      />
      <path
        id="Path_2391"
        data-name="Path 2391"
        d="M269.41,217.17c.015-.382.028-.789.042-1.215l.067-2.3c0-.172.008-.323.01-.45h.132c.2.009.382.018.533.029a.547.547,0,0,0,.6-.534.575.575,0,0,0-.482-.576c-.086-.012-.212-.025-.391-.04s-.842-.008-1.927.021c-.588-.016-1.143.024-1.247.43a.526.526,0,0,0,.156.612.592.592,0,0,0,.434.1,2.81,2.81,0,0,1,.29-.018l.569-.009h.2v.162c0,.194-.008.421-.017.681l-.086,2.385q-.044,1.072-.058,1.576-.01.292-.021.51c-.5-.009-.82-.012-.965-.012a.654.654,0,0,0-.323.082.478.478,0,0,0-.235.454.567.567,0,0,0,.457.563.275.275,0,0,0,.086.016l2.969.05a.526.526,0,0,0,.556-.507.545.545,0,0,0-.122-.42.634.634,0,0,0-.471-.2l-.825-.012c.01-.108.018-.231.025-.368C269.383,217.893,269.4,217.552,269.41,217.17Z"
        transform="translate(-179.197 -129.483)"
        fill="#4c4c4c"
      />
      <path
        id="Path_2392"
        data-name="Path 2392"
        d="M95.371,87.041V79.547A2.179,2.179,0,0,0,93.2,77.374H88.252l-1.211,0H79.547a2.179,2.179,0,0,0-2.174,2.174v4.942l0,1.211v7.5a2.179,2.179,0,0,0,2.174,2.174h4.942l1.215,0h7.494A2.179,2.179,0,0,0,95.368,93.2V88.253Zm-1.212,6.153a.966.966,0,0,1-.965.965H79.547a.966.966,0,0,1-.965-.965V79.547a.966.966,0,0,1,.965-.965H93.195a.966.966,0,0,1,.965.965Z"
        fill="#4c4c4c"
      />
    </g>
  </svg>
);

export const tagsIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "24.586"}
    height={height || "27.771"}
    viewBox="0 0 24.586 27.771"
  >
    <g
      id="Group_2522"
      data-name="Group 2522"
      transform="translate(-103.782 -138.571)"
    >
      <path
        id="Path_2800"
        data-name="Path 2800"
        d="M-684.688,685.777c0-1.236-.021-2.474.008-3.709a1.861,1.861,0,0,1,1.329-1.69,2.861,2.861,0,0,1,.774-.109c2.247-.008,4.494.005,6.742-.011a2.266,2.266,0,0,1,1.712.708q4.386,4.4,8.787,8.789a2.159,2.159,0,0,1,.667,1.131,1.874,1.874,0,0,1-.466,1.728c-1.037,1.062-2.093,2.106-3.143,3.156q-1.973,1.974-3.949,3.944a1.966,1.966,0,0,1-2.872,0q-3.289-3.275-6.564-6.565c-.794-.795-1.585-1.593-2.384-2.383a2.065,2.065,0,0,1-.651-1.562c.013-1.142,0-2.285,0-3.427Zm3.486-.491a1.514,1.514,0,0,0,1.521-1.516,1.5,1.5,0,0,0-1.513-1.523,1.523,1.523,0,0,0-1.517,1.524A1.531,1.531,0,0,0-681.2,685.285Z"
        transform="translate(790.206 -533.995)"
        fill="#428bca"
      />
      <path
        id="Path_2799"
        data-name="Path 2799"
        d="M-684.687,686.743c0-1.453-.024-2.906.009-4.359a2.187,2.187,0,0,1,1.562-1.986,3.36,3.36,0,0,1,.91-.129c2.641-.01,5.281.006,7.922-.013a2.662,2.662,0,0,1,2.011.832q5.153,5.173,10.325,10.327a2.538,2.538,0,0,1,.783,1.329,2.2,2.2,0,0,1-.547,2.03c-1.219,1.248-2.46,2.474-3.693,3.708q-2.318,2.319-4.64,4.635a2.31,2.31,0,0,1-3.374,0q-3.865-3.848-7.713-7.714c-.933-.934-1.862-1.872-2.8-2.8a2.427,2.427,0,0,1-.765-1.836c.015-1.342,0-2.685,0-4.027Zm4.1-.578a1.778,1.778,0,0,0,1.787-1.782,1.762,1.762,0,0,0-1.778-1.789,1.789,1.789,0,0,0-1.783,1.79A1.8,1.8,0,0,0-680.59,686.165Z"
        transform="translate(788.98 -541.186)"
        fill="#428bca"
        stroke="#fff"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export function analyticsIcon(): JSX.Element {
  return (
    <svg width="18" height="21" viewBox="0 0 18 21" fill="none">
      <path
        d="M3 12.5a1.5 1.5 0 0 0-3 0v7a1.5 1.5 0 0 0 3 0v-7zM13 12.5a1.5 1.5 0 0 0-3 0v7a1.5 1.5 0 0 0 3 0v-7zM8 9.5a1.5 1.5 0 1 0-3 0v10a1.5 1.5 0 0 0 3 0v-10zM18 5.5a1.5 1.5 0 0 0-3 0v14a1.5 1.5 0 0 0 3 0v-14z"
        fill="#b1bac1"
      />
      <path
        d="M10.992 9 5.678 5.4 1.001 8.307l-.345-.6 5.036-3.131 5.126 3.469 5.123-7.46.547.407L10.992 9z"
        fill="#b1bac1"
      />
      <path
        d="M2 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zM12 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zM7 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0zM17 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
        fill="#b1bac1"
      />
    </svg>
  );
}

export const sourcesStatsIcon = (): JSX.Element => (
  <svg width="56" height="56" viewBox="0 0 70 71" fill="none">
    <rect opacity=".15" y=".5" width="70" height="70" rx="35" fill="#0E487B" />
    <path
      d="M52.998 21.215v3.56c0 3.147-7.838 5.716-17.498 5.716S18 27.932 18 24.786v-3.56c0-3.16 7.838-5.726 17.498-5.726 9.659 0 17.5 2.566 17.5 5.715zm0 8.035v8.034C52.998 40.43 45.16 43 35.5 43S18 40.425 18 37.284V29.25c3.759 2.589 10.641 3.8 17.498 3.8 6.856 0 13.738-1.211 17.5-3.8zm0 12.5v8.035c0 3.146-7.838 5.715-17.498 5.715S18 52.931 18 49.785v-8.037c3.759 2.589 10.641 3.795 17.498 3.795 6.856 0 13.738-1.206 17.5-3.795v.002z"
      fill="#0E487B"
    />
  </svg>
);

export const datasetsStatsIcon = (): JSX.Element => (
  <svg width="56" height="56" viewBox="0 0 70 71" fill="none">
    <rect opacity=".15" y=".5" width="70" height="70" rx="35" fill="#0E487B" />
    <path
      d="M35.5 50.158h14.012a3.368 3.368 0 0 0 2.935-1.535 3.31 3.31 0 0 0 .55-1.953V24.01a3.37 3.37 0 0 0-1.9-3.167 3.39 3.39 0 0 0-1.65-.34H21.367a3.353 3.353 0 0 0-3.227 2.43c-.084.296-.127.6-.13.908-.007 7.14-.007 14.28 0 21.419a17.7 17.7 0 0 0 .04 1.978 3.308 3.308 0 0 0 3.28 2.912h14.174l-.006.007zm10.795-10.776h-3.25c-.57 0-.816-.239-.816-.801v-3.825c0-.529.227-.768.756-.768h6.527c.56 0 .791.24.791.796v3.825c0 .529-.25.773-.783.773h-3.225zm-.02-8.083h-3.277c-.534 0-.767-.235-.767-.757v-3.858a.684.684 0 0 1 .777-.786h6.5c.551 0 .797.25.797.793v3.744c0 .643-.217.864-.86.864h-3.17zm-21.538 8.083h-3.195c-.61 0-.839-.226-.84-.83v-3.77c0-.573.21-.794.78-.794h6.498c.55 0 .788.245.788.797v3.798c0 .567-.234.799-.81.8l-3.221-.001zm0-8.083h-3.278c-.52 0-.746-.23-.748-.746v-3.858c0-.566.24-.797.816-.8H28a.683.683 0 0 1 .78.783v3.858a.674.674 0 0 1-.765.766c-1.095-.005-2.196-.009-3.285-.009l.007.006zm10.788 0H32.33c-.645 0-.86-.215-.86-.862v-3.689c0-.623.227-.852.846-.852h6.364c.636 0 .855.222.855.867v3.716c0 .608-.207.814-.814.814l-3.196.006zm-.023 2.697h3.275c.536 0 .756.225.758.758v3.825c0 .573-.237.81-.803.81H32.26c-.55 0-.787-.233-.79-.793v-3.798c0-.577.23-.803.808-.804 1.06-.01 2.14-.008 3.215-.008l.008.01zm10.791 13.476h-3.277c-.55 0-.78-.236-.782-.775v-3.825c0-.55.244-.799.791-.799h6.502c.538 0 .782.245.783.78v3.824c0 .56-.233.79-.792.79l-3.224.005zm-21.538 0h-3.301a.653.653 0 0 1-.734-.757v-3.878a.668.668 0 0 1 .734-.762h6.58a.66.66 0 0 1 .745.759v3.825c0 .597-.222.808-.825.808l-3.199.005zm10.758 0h-3.2c-.63 0-.838-.196-.84-.82v-3.747c0-.611.224-.824.844-.824h6.37c.63 0 .851.224.851.845v3.745c0 .583-.218.809-.8.809a317.895 317.895 0 0 0-3.233-.013l.008.005z"
      fill="#0E487B"
    />
  </svg>
);

export const fieldsStatsIcon = (): JSX.Element => (
  <svg width="56" height="56" viewBox="0 0 70 71" fill="none">
    <rect opacity=".15" y=".5" width="70" height="70" rx="35" fill="#0E487B" />
    <g clipPath="url(#3n36aey0la)">
      <path fill="#DBE4EB" d="M18.344 28h35v14.546h-35z" />
      <path
        d="M18.344 28v14.545h35V28h-35zm10.813 11.978h-8.256v-9.412h8.252l.004 9.412zm10.813 0h-8.252v-9.412h8.252v9.412zm10.813 0h-8.252v-9.412h8.255v9.412h-.003z"
        fill="#0E487B"
      />
    </g>
    <defs>
      <clipPath id="3n36aey0la">
        <path
          fill="#fff"
          transform="translate(18.344 28)"
          d="M0 0h35v14.546H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export const modelsStatsIcon = (): JSX.Element => (
  <svg width="56" height="56" viewBox="0 0 70 71" fill="none">
    <rect y=".5" width="70" height="70" rx="35" fill="#E0E9F1" />
    <path
      d="M51.354 17.92H21.021a2.333 2.333 0 0 0-2.334 2.333v4.667a2.333 2.333 0 0 0 2.334 2.333h30.333a2.333 2.333 0 0 0 2.334-2.333v-4.667a2.333 2.333 0 0 0-2.334-2.333zM32.104 30.753H21.021a2.333 2.333 0 0 0-2.334 2.334v4.666a2.333 2.333 0 0 0 2.334 2.334h11.083a2.333 2.333 0 0 0 2.334-2.334v-4.666a2.333 2.333 0 0 0-2.334-2.334zM32.104 43.587H21.021a2.333 2.333 0 0 0-2.334 2.333v4.666a2.333 2.333 0 0 0 2.334 2.334h11.083a2.333 2.333 0 0 0 2.334-2.334V45.92a2.333 2.333 0 0 0-2.334-2.334zM51.354 30.753H40.271a2.333 2.333 0 0 0-2.334 2.334v4.666a2.333 2.333 0 0 0 2.334 2.334h11.083a2.333 2.333 0 0 0 2.334-2.334v-4.666a2.333 2.333 0 0 0-2.334-2.334zM51.354 43.587H40.271a2.333 2.333 0 0 0-2.334 2.333v4.666a2.333 2.333 0 0 0 2.334 2.334h11.083a2.333 2.333 0 0 0 2.334-2.334V45.92a2.333 2.333 0 0 0-2.334-2.334z"
      fill="#2C6AA0"
    />
  </svg>
);

export const domainsStatsIcon = (): JSX.Element => (
  <svg width="56" height="56" viewBox="0 0 71 71" fill="none">
    <rect
      opacity=".15"
      x=".109"
      y=".5"
      width="70"
      height="70"
      rx="35"
      fill="#2C6AA0"
    />
    <path
      d="M36.327 39.384v-.779a1.769 1.769 0 0 0-.478-1.276 1.715 1.715 0 0 0-1.238-.535 1.694 1.694 0 0 0-1.237.535 1.746 1.746 0 0 0-.478 1.276v.779a1.768 1.768 0 0 0 .478 1.276 1.717 1.717 0 0 0 1.237.535 1.693 1.693 0 0 0 1.238-.535 1.747 1.747 0 0 0 .478-1.276z"
      fill="#2C6AA0"
    />
    <path
      d="M37.506 40.35a3.066 3.066 0 0 1-1.088 1.585 2.987 2.987 0 0 1-1.806.61c-.65 0-1.284-.214-1.806-.61a3.066 3.066 0 0 1-1.087-1.586h-11.83a4.776 4.776 0 0 1-2.084-.482v7.97c.002.751.296 1.47.818 2 .523.53 1.23.83 1.97.832h28.03a2.773 2.773 0 0 0 1.968-.832c.522-.53.817-1.249.819-2v-7.97a4.778 4.778 0 0 1-2.085.482h-11.82zM49.21 26.033h-6.69a5.41 5.41 0 0 0-1.794-3.243 5.259 5.259 0 0 0-3.435-1.29h-5.366a5.259 5.259 0 0 0-3.435 1.29 5.41 5.41 0 0 0-1.794 3.243h-6.684a2.83 2.83 0 0 0-2.026.808 2.92 2.92 0 0 0-.877 2.023v6.534a2.869 2.869 0 0 0 .817 2.002 2.75 2.75 0 0 0 1.971.83h11.691c.036-.788.368-1.531.928-2.077l.053-.044c.12-.114.248-.218.383-.311.049-.034.105-.057.156-.086.112-.07.228-.13.348-.184.098-.036.198-.068.299-.094.087-.026.168-.06.255-.08a2.963 2.963 0 0 1 1.201 0c.09.018.171.052.256.08.1.027.2.059.299.096.118.054.233.116.344.185.051.03.108.051.156.085.136.092.264.196.384.31.017.015.038.028.053.046.56.545.892 1.288.928 2.076h11.69a2.75 2.75 0 0 0 1.068-.216c.338-.142.645-.35.904-.613s.464-.575.604-.919c.14-.343.212-.712.212-1.083v-6.534a2.92 2.92 0 0 0-.874-2.024 2.83 2.83 0 0 0-2.026-.81zm-19.827 0a2.73 2.73 0 0 1 .977-1.362 2.664 2.664 0 0 1 1.578-.522h5.366c.566 0 1.119.183 1.578.522.459.338.8.815.977 1.362H29.383z"
      fill="#2C6AA0"
    />
  </svg>
);

export const categoriesStatsIcon = (): JSX.Element => (
  <svg width="56" height="56" viewBox="0 0 70 71" fill="none">
    <rect y=".5" width="70" height="70" rx="35" fill="#E0E9F1" />
    <path
      d="M19.632 33.056h11.667a1.944 1.944 0 0 0 1.944-1.945V19.444A1.944 1.944 0 0 0 31.3 17.5H19.632a1.945 1.945 0 0 0-1.945 1.944v11.667a1.944 1.944 0 0 0 1.945 1.945zm19.444 0h11.667a1.944 1.944 0 0 0 1.944-1.945V19.444a1.945 1.945 0 0 0-1.944-1.944H39.076a1.944 1.944 0 0 0-1.944 1.944v11.667a1.944 1.944 0 0 0 1.944 1.945zM19.632 52.5h11.667a1.944 1.944 0 0 0 1.944-1.944V38.889a1.944 1.944 0 0 0-1.944-1.945H19.632a1.944 1.944 0 0 0-1.945 1.945v11.667a1.945 1.945 0 0 0 1.945 1.944zm25.278 0c4.29 0 7.778-3.488 7.778-7.778 0-4.29-3.489-7.778-7.778-7.778-4.29 0-7.778 3.489-7.778 7.778 0 4.29 3.488 7.778 7.778 7.778z"
      fill="#2C6AA0"
    />
  </svg>
);

export const tagsetStatsIcon = (): JSX.Element => (
  <svg width="56" height="56" viewBox="0 0 70 71" fill="none">
    <rect
      y=".5"
      width="70"
      height="70"
      rx="35"
      fill="#62929E"
      fillOpacity=".15"
    />
    <path
      d="M18.381 34.86c0-1.834-.03-3.67.012-5.503a2.761 2.761 0 0 1 1.972-2.507c.373-.106.76-.16 1.148-.162 3.333-.011 6.666.008 10.001-.016a3.362 3.362 0 0 1 2.54 1.05c4.338 4.352 8.683 8.698 13.035 13.039.496.443.842 1.029.99 1.677a2.78 2.78 0 0 1-.692 2.564c-1.538 1.575-3.105 3.124-4.662 4.682a4682.857 4682.857 0 0 1-5.858 5.85 2.915 2.915 0 0 1-4.26 0 3104.522 3104.522 0 0 1-9.738-9.739c-1.178-1.179-2.352-2.363-3.537-3.535a3.062 3.062 0 0 1-.966-2.317c.02-1.694 0-3.39 0-5.084h.015zm5.171-.729a2.247 2.247 0 0 0 2.257-2.249 2.226 2.226 0 0 0-2.245-2.26 2.26 2.26 0 0 0-2.25 2.262 2.272 2.272 0 0 0 2.241 2.245l-.003.002z"
      fill="#3B85C6"
    />
    <path
      d="M16.563 25.625c0-2.156-.035-4.311.014-6.467a3.244 3.244 0 0 1 2.317-2.946c.439-.125.893-.19 1.35-.191 3.917-.015 7.834.009 11.752-.02a3.95 3.95 0 0 1 2.983 1.235 5883.755 5883.755 0 0 0 15.317 15.32c.582.52.988 1.21 1.161 1.971a3.264 3.264 0 0 1-.811 3.012c-1.809 1.851-3.65 3.67-5.479 5.5a6467.43 6467.43 0 0 1-6.883 6.876 3.426 3.426 0 0 1-5.005 0c-3.823-3.805-7.637-7.62-11.442-11.443-1.384-1.386-2.762-2.777-4.154-4.154a3.6 3.6 0 0 1-1.135-2.724c.023-1.99 0-3.983 0-5.974l.015.005zm6.082-.858a2.638 2.638 0 0 0 2.651-2.643 2.616 2.616 0 0 0-2.637-2.654 2.654 2.654 0 0 0-2.645 2.655 2.67 2.67 0 0 0 2.627 2.642h.004z"
      fill="#3B85C6"
      stroke="#E8EFF1"
    />
  </svg>
);

export const tagsStatsIcon = (): JSX.Element => (
  <svg width="56" height="56" viewBox="0 0 70 71" fill="none">
    <rect y=".5" width="70" height="70" rx="35" fill="#E8EFF1" />
    <path
      d="M17.016 26.625c0-2.156-.035-4.311.014-6.467a3.244 3.244 0 0 1 2.317-2.946c.439-.125.893-.19 1.35-.191 3.918-.015 7.834.009 11.752-.02a3.95 3.95 0 0 1 2.983 1.235 5899.446 5899.446 0 0 0 15.317 15.32c.582.52.988 1.21 1.161 1.971a3.263 3.263 0 0 1-.811 3.012c-1.808 1.851-3.65 3.67-5.479 5.5a6467.53 6467.53 0 0 1-6.883 6.876 3.427 3.427 0 0 1-5.005 0c-3.822-3.805-7.636-7.62-11.442-11.443-1.384-1.386-2.762-2.777-4.154-4.154a3.6 3.6 0 0 1-1.135-2.724c.023-1.99 0-3.983 0-5.974l.015.005zm6.083-.858a2.637 2.637 0 0 0 2.65-2.643 2.614 2.614 0 0 0-2.637-2.654 2.654 2.654 0 0 0-2.645 2.655 2.67 2.67 0 0 0 2.627 2.642h.005z"
      fill="#3B85C6"
      stroke="#E8EFF1"
    />
  </svg>
);

export const userGroupsStatsIcon = (): JSX.Element => (
  <svg width="56" height="56" viewBox="0 0 70 71" fill="none">
    <path
      opacity=".15"
      d="M0 35.5C0 16.17 15.67.5 35 .5s35 15.67 35 35-15.67 35-35 35-35-15.67-35-35z"
      fill="#3C9AF0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.276 46.763c-1.699 0-3.398.004-5.097 0-2.034-.006-3.14-1.124-3.14-3.16a10.503 10.503 0 0 1 .769-4.288 3.32 3.32 0 0 1 2.797-2.245c.332-.012.661.06.958.208.758.35 1.462.84 2.24 1.118a5.045 5.045 0 0 0 4.343-.567c.135-.077.259-.173.393-.251.447-.258.82-.651 1.435-.539a3.04 3.04 0 0 1 2.077 1.123c.402.551.727 1.155.966 1.794.446 1.333.618 2.742.507 4.144a2.698 2.698 0 0 1-2.688 2.64c-1.854.044-3.71.01-5.564.01l.004.013z"
      fill="#3C9AF0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.79 32.428a4.5 4.5 0 1 1-4.476-4.511 4.462 4.462 0 0 1 4.477 4.511zM43.753 46.763c-1.7 0-3.398.004-5.097 0-2.035-.006-3.14-1.124-3.141-3.16a10.505 10.505 0 0 1 .77-4.288 3.32 3.32 0 0 1 2.797-2.245c.331-.012.66.06.957.208.758.35 1.462.84 2.24 1.118a5.045 5.045 0 0 0 4.344-.567c.135-.077.258-.173.393-.251.447-.258.819-.651 1.434-.539a3.04 3.04 0 0 1 2.078 1.123c.401.551.726 1.155.965 1.794.446 1.333.619 2.742.508 4.144a2.7 2.7 0 0 1-2.688 2.64c-1.855.044-3.71.01-5.564.01l.004.013z"
      fill="#3C9AF0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.267 32.428a4.5 4.5 0 1 1-4.477-4.511 4.462 4.462 0 0 1 4.477 4.511z"
      fill="#3C9AF0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.253 48.813c-2.147 0-4.293.005-6.44 0-2.57-.008-3.967-1.42-3.969-3.994a13.27 13.27 0 0 1 .973-5.416 4.195 4.195 0 0 1 3.535-2.837c.418-.016.834.075 1.209.262.958.444 1.847 1.06 2.83 1.413a6.373 6.373 0 0 0 5.488-.717c.17-.097.327-.218.497-.317.565-.325 1.035-.822 1.812-.68a3.844 3.844 0 0 1 2.625 1.418 9.5 9.5 0 0 1 1.22 2.267c.564 1.684.782 3.465.641 5.236a3.41 3.41 0 0 1-3.396 3.335c-2.343.056-4.687.013-7.03.013l.005.017z"
      fill="#3C9AF0"
      stroke="#E2F0FD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.957 30.7a5.685 5.685 0 1 1-5.656-5.7 5.64 5.64 0 0 1 5.656 5.7z"
      fill="#3C9AF0"
      stroke="#E2F0FD"
    />
  </svg>
);

export const usersStatsIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "56"}
    height={height || "56"}
    viewBox="0 0 70 71"
    fill="none"
  >
    <rect y=".5" width="70" height="70" rx="35" fill="#E2F0FD" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.581 54.67c-3.598 0-7.197.008-10.796 0-4.31-.013-6.65-2.38-6.653-6.695-.097-3.108.458-6.2 1.63-9.08a7.033 7.033 0 0 1 5.926-4.756c.702-.026 1.4.125 2.027.44 1.606.743 3.097 1.778 4.745 2.368a10.687 10.687 0 0 0 9.2-1.201c.286-.163.548-.367.834-.531.947-.546 1.734-1.38 3.038-1.141a6.443 6.443 0 0 1 4.4 2.378 15.93 15.93 0 0 1 2.046 3.799 22.165 22.165 0 0 1 1.074 8.778 5.716 5.716 0 0 1-5.693 5.59c-3.928.095-7.858.024-11.786.024l.008.027z"
      fill="#3C9AF0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.143 24.306a9.53 9.53 0 0 1-16.297 6.69A9.53 9.53 0 0 1 35.66 14.75a9.455 9.455 0 0 1 9.483 9.556z"
      fill="#3C9AF0"
    />
  </svg>
);

export const reportStatsIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "56"}
    height={height || "56"}
    viewBox="0 0 70 70"
    fill="none"
  >
    <rect width="70" height="70" rx="35" fill="#E0E9F1" />
    <g clipPath="url(#8ygn428zda)" fill="#2C6AA0">
      <path d="M40.334 18v8.75H49L40.334 18z" />
      <path d="M40.334 28.937a2.16 2.16 0 0 1-1.531-.642 2.202 2.202 0 0 1-.636-1.545V18h-13a2.16 2.16 0 0 0-1.531.642c-.406.41-.635.966-.636 1.545v30.626c0 .58.23 1.136.635 1.545.406.41.957.641 1.532.642h21.666c.575 0 1.126-.23 1.532-.641A2.2 2.2 0 0 0 49 50.813V28.937h-8.666zm-8.668 19.688h-4.338v-6.562h4.328l.01 6.562zm6.5 0h-4.328V37.688h4.328v10.937zm6.5 0h-4.328V33.313h4.328v15.312z" />
    </g>
    <defs>
      <clipPath id="8ygn428zda">
        <path fill="#fff" transform="translate(23 18)" d="M0 0h26v35H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const termStatsIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "56"}
    height={height || "56"}
    viewBox="0 0 70 70"
    fill="none"
  >
    <rect width="70" height="70" rx="35" fill="#E8EFF1" />
    <g clipPath="url(#0z3u6uekwa)" fill="#428BCA">
      <path d="M50.159 18H19.278a2.28 2.28 0 0 0-2.28 2.28v8.51h35.397v-2.16c.024-.13.037-.26.04-.39v-5.962A2.28 2.28 0 0 0 50.159 18zM24.4 25.127h-3.661v-1.733H24.4v1.733zm14.213 0H25.996v-1.733h12.617v1.733zM17 32.377V49.51a2.28 2.28 0 0 0 2.28 2.28h30.879a2.28 2.28 0 0 0 2.28-2.28V32.377H17zm15.07 15.808H20.739v-3.63h11.33v3.63zm0-5.403H20.739V40.62h11.33v2.162zm0-4.634H20.739v-2.162h11.33v2.162zm15.927 6.781a3.257 3.257 0 0 1-3.257 3.256h-4.818a3.256 3.256 0 0 1-3.256-3.256v-5.684a3.256 3.256 0 0 1 3.256-3.257h4.818a3.255 3.255 0 0 1 3.257 3.257v5.684z" />
    </g>
    <defs>
      <clipPath id="0z3u6uekwa">
        <path
          fill="#fff"
          transform="translate(17 18)"
          d="M0 0h35.437v33.78H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export const adminsStatsIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "56"}
    height={height || "56"}
    viewBox="0 0 70 70"
    fill="none"
  >
    <path
      opacity=".15"
      d="M0 35C0 15.67 15.67 0 35 0s35 15.67 35 35-15.67 35-35 35S0 54.33 0 35z"
      fill="#3C9AF0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.346 49.8c-2.957 0-5.914.007-8.87 0-3.541-.01-5.464-1.956-5.467-5.5a18.279 18.279 0 0 1 1.34-7.461 5.779 5.779 0 0 1 4.868-3.908 3.44 3.44 0 0 1 1.666.361c1.32.611 2.545 1.462 3.899 1.946a8.78 8.78 0 0 0 7.56-.987c.234-.134.45-.301.684-.436.778-.449 1.425-1.133 2.496-.938a5.291 5.291 0 0 1 3.616 1.954c.699.96 1.264 2.01 1.68 3.122a18.213 18.213 0 0 1 .883 7.213 4.697 4.697 0 0 1-4.678 4.593c-3.227.078-6.456.019-9.684.019l.007.023z"
      fill="#3C9AF0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.203 24.852A7.832 7.832 0 1 1 33.41 17a7.768 7.768 0 0 1 7.791 7.852z"
      fill="#3C9AF0"
    />
    <path
      d="m53.296 45.244.026.016a1.8 1.8 0 0 1 .784.951c.141.397.14.831-.005 1.227l-.009.025-.01.025a8.92 8.92 0 0 1-1.569 2.468 1.778 1.778 0 0 1-2.257.385l-.374-.22a6.633 6.633 0 0 1-.884.518v.462c0 .418-.143.825-.41 1.15-.266.324-.64.547-1.056.624l-.01.002c-.94.164-1.9.164-2.84 0a1.787 1.787 0 0 1-1.068-.618 1.812 1.812 0 0 1-.418-1.156v-.467a6.676 6.676 0 0 1-.885-.52l-.373.218a1.777 1.777 0 0 1-2.258-.387 8.912 8.912 0 0 1-1.553-2.463l-.01-.025-.01-.026a1.82 1.82 0 0 1-.002-1.222c.14-.396.414-.733.778-.95l.026-.015.028-.014.473-.243a6.902 6.902 0 0 1 0-.984l-.475-.245-.025-.013-.024-.014a1.8 1.8 0 0 1-.78-.948c-.142-.395-.14-.828.001-1.223l.009-.024.01-.024c.38-.905.905-1.74 1.555-2.471a1.778 1.778 0 0 1 2.258-.387h.001l.373.22c.281-.195.577-.369.884-.518v-.464l10.099 7.35zm0 0-.028-.014-.481-.244a6.921 6.921 0 0 0 0-.979l.481-.244.037-.018.034-.022a1.8 1.8 0 0 0 .762-.957 1.816 1.816 0 0 0-.019-1.219l-.006-.017-.008-.018a8.873 8.873 0 0 0-1.551-2.471 1.778 1.778 0 0 0-2.259-.387l-.375.22a6.683 6.683 0 0 0-.883-.518l4.296 6.888zm-5.788-.716c.005.385-.133.755-.382 1.036-.274.25-.628.382-.991.376a1.439 1.439 0 0 1-1.002-.434 1.525 1.525 0 0 1-.434-1.044c-.006-.384.13-.753.378-1.034.274-.252.629-.387.993-.381.374.006.734.16 1.004.434.27.275.428.65.434 1.047z"
      fill="#3C9AF0"
      stroke="#E2F0FD"
      strokeWidth="2"
    />
  </svg>
);

export const editorsStatsIcon = (): JSX.Element => (
  <svg width="56" height="56" viewBox="0 0 70 71" fill="none">
    <rect y=".018" width="70" height="70" rx="35" fill="#E2F0FD" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.588 49.628c-2.957 0-5.913.007-8.87 0-3.541-.01-5.464-1.956-5.467-5.501a18.278 18.278 0 0 1 1.34-7.46 5.778 5.778 0 0 1 4.868-3.909 3.44 3.44 0 0 1 1.666.362c1.32.61 2.545 1.461 3.899 1.946a8.778 8.778 0 0 0 7.56-.987c.234-.134.45-.301.684-.437.778-.448 1.425-1.133 2.496-.937a5.291 5.291 0 0 1 3.616 1.954c.699.96 1.264 2.01 1.68 3.122a18.213 18.213 0 0 1 .883 7.212 4.697 4.697 0 0 1-4.678 4.594c-3.227.077-6.456.018-9.683.018l.006.023z"
      fill="#3C9AF0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.445 24.68a7.831 7.831 0 1 1-7.792-7.852 7.768 7.768 0 0 1 7.792 7.851z"
      fill="#3C9AF0"
    />
    <mask
      id="zim0ud83ia"
      maskUnits="userSpaceOnUse"
      x="32.343"
      y="34.122"
      width="22.273"
      height="22.273"
      fill="#000"
    >
      <path fill="#fff" d="M32.343 34.122h22.273v22.273H32.343z" />
      <path d="m35.002 49.413 1.11-3.865a.214.214 0 0 1 .115-.14l10.025-5.541.066-.035 2.818 5.095-.057.034-10.044 5.555a.193.193 0 0 1-.135.022l-3.832-1.101-.066-.024zm4.907-.828-1.596-2.88c-.348.193-.706.39-1.06.59a.145.145 0 0 0-.056.084l-.256.89a.703.703 0 0 0-.012.075l1.213.349-.346 1.202a.07.07 0 0 0 .019.016l.956.275c.025.005.051.002.073-.01.36-.198.712-.398 1.065-.591zm-.519-2.954a.262.262 0 0 0 .22-.038l6.557-3.627a.537.537 0 0 0 .08-.051.247.247 0 0 0 .067-.29.25.25 0 0 0-.283-.09.614.614 0 0 0-.086.042l-6.543 3.617a.483.483 0 0 0-.1.071.211.211 0 0 0-.01.31.212.212 0 0 0 .1.056h-.002z" />
    </mask>
    <path
      d="m35.002 49.413 1.11-3.865a.214.214 0 0 1 .115-.14l10.025-5.541.066-.035 2.818 5.095-.057.034-10.044 5.555a.193.193 0 0 1-.135.022l-3.832-1.101-.066-.024zm4.907-.828-1.596-2.88c-.348.193-.706.39-1.06.59a.145.145 0 0 0-.056.084l-.256.89a.703.703 0 0 0-.012.075l1.213.349-.346 1.202a.07.07 0 0 0 .019.016l.956.275c.025.005.051.002.073-.01.36-.198.712-.398 1.065-.591zm-.519-2.954a.262.262 0 0 0 .22-.038l6.557-3.627a.537.537 0 0 0 .08-.051.247.247 0 0 0 .067-.29.25.25 0 0 0-.283-.09.614.614 0 0 0-.086.042l-6.543 3.617a.483.483 0 0 0-.1.071.211.211 0 0 0-.01.31.212.212 0 0 0 .1.056h-.002z"
      fill="#3C9AF0"
    />
    <path
      d="m35.002 49.413-1.923-.553-.52 1.81 1.775.628.667-1.886zm1.11-3.865 1.923.552.007-.026.007-.025-1.936-.501zm.115-.14.865 1.804.052-.025.05-.028-.967-1.75zm10.025-5.541-.937-1.767-.015.008-.016.008.968 1.75zm.066-.035 1.75-.968-.95-1.72-1.736.92.936 1.768zm2.818 5.095L50.2 46.62l1.602-1.007-.916-1.655-1.75.968zm-10.101 5.589-.968-1.75-.02.01-.018.011 1.006 1.729zm-.135.022-.553 1.922.08.023.08.016.393-1.96zm1.01-1.953-.553 1.922 4.646 1.336-2.344-4.228-1.75.97zm-1.597-2.88 1.749-.97-.969-1.746-1.748.967.968 1.75zm-1.06.59-.982-1.742-.096.054-.09.064 1.168 1.624zm-.056.084 1.922.553.013-.046.011-.047-1.946-.46zm-.256.89-1.922-.552-.018.06-.013.062 1.953.43zm-.012.075-1.988-.226-.191 1.68 1.626.468.553-1.922zm1.213.349 1.922.553.553-1.923-1.923-.552-.552 1.922zm-.346 1.202-1.922-.552-.298 1.035.701.818 1.519-1.3zm.019.016-.99 1.738.208.118.23.066.552-1.922zm.956.275-.552 1.922.05.014.05.012.452-1.948zm.073-.01.92 1.776.025-.012.023-.013-.968-1.75zm1.065-.591.552-1.922-.792-.228-.722.396.962 1.754zm-.519-2.954.544-1.925-1.096 3.847.552-1.922zm.22-.038-.968-1.75-.093.051-.087.062 1.148 1.637zm6.557-3.627-.927-1.772-.02.01-.021.012.968 1.75zm.08-.051 1.223 1.582.032-.025.031-.026-1.286-1.531zm.067-.29 1.83-.808-.084-.189-.12-.168-1.626 1.166zm-.283-.09-.65-1.892-.044.015-.043.017.737 1.86zm-.086.042.968 1.75.024-.013.024-.014-1.016-1.723zm-6.543 3.617.94 1.766.014-.008.014-.008-.968-1.75zm-.1.071 1.32 1.501.017-.014.015-.014-1.353-1.473zm-.067.21-1.944.467v.003l1.944-.47zm.156.156-.475 1.943 1.028-3.865-.553 1.922zm-2.467 4.334 1.11-3.865-3.843-1.105-1.112 3.865 3.845 1.105zm1.125-3.916c-.065.25-.184.485-.35.687l-3.089-2.541c-.206.25-.353.54-.434.852l3.873 1.002zm-.35.687a1.787 1.787 0 0 1-.607.476l-1.73-3.607c-.29.14-.547.34-.752.59l3.089 2.541zm-.504.423 10.024-5.542-1.935-3.5-10.025 5.541 1.936 3.5zm9.993-5.525.067-.035-1.873-3.535-.067.036 1.873 3.534zm-2.62-.834 2.818 5.095 3.5-1.936-2.818-5.095-3.5 1.936zm4.568 4.127-1.063-1.694h.001l.001-.002h.002l.002-.002.003-.002.006-.004.023-.013 1.936 3.5a3.162 3.162 0 0 0 .146-.085l.004-.003h.001l.001-.001-1.063-1.694zm-1.025-1.717-5.022 2.778-5.022 2.778 1.936 3.5 5.022-2.778 5.022-2.777-1.936-3.5zM38.03 48.787c.381-.222.83-.297 1.263-.21l-.785 3.922c.525.105 1.07.015 1.533-.255l-2.011-3.457zm1.423-.17-3.831-1.102-1.106 3.844 3.832 1.101 1.105-3.844zm-3.831-1.102c.043.012.078.024.1.032l.025.009.006.002h.002l-.005-.001-.018-.007a2.658 2.658 0 0 0-.062-.023l-1.335 3.77c-.016-.005-.036-.012-.01-.003l.063.024c.032.01.076.026.128.04l1.106-3.843zm6.038.1-1.597-2.88-3.498 1.94 1.596 2.88 3.499-1.94zm-4.314-3.66c-.344.19-.71.393-1.074.598l1.965 3.484c.345-.195.692-.386 1.045-.581l-1.936-3.5zm-1.26.716c-.42.302-.716.745-.834 1.248l3.892.92a1.855 1.855 0 0 1-.722 1.08l-2.335-3.248zm-.81 1.155-.256.89 3.844 1.106.256-.89-3.844-1.106zm-.287 1.013c-.02.091-.036.184-.047.279l3.975.452a1.26 1.26 0 0 1-.022.13l-3.906-.86zm1.388 2.427 1.213.35 1.105-3.845-1.213-.349-1.105 3.844zm-.156-2.126-.346 1.203 3.844 1.105.346-1.203-3.844-1.105zm.057 3.056c.157.183.342.336.549.453l1.978-3.477c.192.11.365.252.511.422l-3.038 2.602zm.985.637.957.275 1.105-3.844-.957-.276-1.105 3.845zm1.056.3c.488.114 1.001.05 1.447-.18l-1.84-3.552c.4-.208.86-.265 1.3-.163l-.907 3.896zm1.494-.206c.395-.218.698-.391 1.059-.589l-1.924-3.507c-.345.19-.747.416-1.07.595l1.935 3.5zm-.456-.42 1.106-3.844-1.106 3.844zm-.51-2.952c.323.091.662.11.993.053l-.669-3.943a1.74 1.74 0 0 1 .764.04l-1.087 3.85zm.993.053c.33-.056.645-.185.92-.377l-2.297-3.276c.211-.148.453-.247.708-.29l.669 3.944zm.74-.265 6.556-3.627-1.936-3.5-6.557 3.627 1.936 3.5zm6.514-3.604c.133-.07.259-.15.377-.242l-2.446-3.164c.068-.053.14-.1.216-.14l1.853 3.546zm.44-.293c.373-.313.634-.738.744-1.213l-3.896-.903c.085-.37.289-.702.58-.947l2.572 3.063zm.744-1.213c.11-.474.063-.971-.134-1.416l-3.658 1.618a1.753 1.753 0 0 1-.104-1.105l3.896.903zm-.337-1.773a2.249 2.249 0 0 0-1.144-.832l-1.217 3.81a1.75 1.75 0 0 1-.89-.647l3.25-2.33zm-1.144-.832a2.249 2.249 0 0 0-1.415.015l1.299 3.784a1.75 1.75 0 0 1-1.101.011l1.217-3.81zm-1.502.047c-.126.05-.248.11-.365.179l2.032 3.446a1.396 1.396 0 0 1-.194.095l-1.473-3.72zm-.317.151-6.542 3.617 1.935 3.501 6.543-3.617-1.936-3.5zm-6.514 3.602c-.186.099-.359.221-.515.364l2.706 2.946c-.095.087-.2.162-.313.222l-1.878-3.532zm-.483.336c-.303.266-.526.61-.648.993l3.814 1.207c-.098.31-.279.587-.523.802l-2.643-3.002zm-.648.993a2.213 2.213 0 0 0-.041 1.185l3.889-.935c.076.315.064.646-.034.957l-3.814-1.207zm-.04 1.188c.095.394.297.755.584 1.042l2.83-2.825c.233.232.396.523.473.841l-3.888.942zm.584 1.042c.286.288.646.49 1.04.587l.95-3.886c.319.078.61.242.84.474l-2.83 2.825zm2.068-3.278h-.001l-1.105 3.844 1.106-3.844z"
      fill="#E2F0FD"
      mask="url(#zim0ud83ia)"
    />
    <path
      d="m49.075 44.964.493.89.88-.508.062-.036.443-.249c.488-.275.958-.54 1.44-.792l.003-.002a2.296 2.296 0 0 0 1.134-1.394 2.294 2.294 0 0 0-.22-1.783c-.102-.175-.195-.345-.294-.526l-.153-.276-.087-.157c-.343-.62-.69-1.248-1.042-1.873a2.245 2.245 0 0 0-3.004-.895l-.008.004-.008.005-1.99 1.093a1.49 1.49 0 0 0-.094.054l-.026.017a.096.096 0 0 1-.006.004l-.801.503.458.828 2.82 5.093zm3.534-2.883c.021.173.008.348-.04.516l-1.707-3.85c.35.621.695 1.246 1.04 1.868.029.053.057.106.087.158l.144.261c.102.187.205.373.311.557.088.15.144.317.165.49z"
      fill="#3C9AF0"
      stroke="#E2F0FD"
      strokeWidth="2"
    />
  </svg>
);

export const upArrowFilledIcon = (): JSX.Element => (
  <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
    <path
      d="M5.134 1.5a1 1 0 0 1 1.732 0l3.464 6A1 1 0 0 1 9.464 9H2.536a1 1 0 0 1-.866-1.5l3.464-6z"
      fill="#fff"
    />
  </svg>
);

export const downArrowFilledIcon = (): JSX.Element => (
  <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
    <path
      d="M6.866 10.5a1 1 0 0 1-1.732 0l-3.464-6A1 1 0 0 1 2.536 3h6.928a1 1 0 0 1 .866 1.5l-3.464 6z"
      fill="#fff"
    />
  </svg>
);

export const goldMedalIcon = (): JSX.Element => (
  <svg width="22.4" height="31.2" viewBox="0 0 28 39" fill="none">
    <path
      d="M11.278 22.824 15 24.973 7.443 38.062l-2.17-4.838 6.005-10.4z"
      fill="#CE4444"
    />
    <path
      d="m11.278 22.824-3.721-2.148L0 33.765l5.274-.54 6.004-10.4zM16.588 22.824l-3.722 2.149 7.557 13.089 2.17-4.838-6.005-10.4z"
      fill="#983535"
    />
    <path
      d="m16.588 22.824 3.721-2.148 7.557 13.089-5.274-.54-6.004-10.4z"
      fill="#CE4444"
    />
    <circle
      cx="13.819"
      cy="13.812"
      r="13.312"
      fill="url(#ujuuprskpa)"
      stroke="#765C00"
    />
    <circle cx="13.818" cy="13.812" r="10.001" fill="#A88300" />
    <mask
      id="p9w0pe68vb"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="4"
      y="4"
      width="21"
      height="21"
    >
      <circle cx="14.353" cy="14.88" r="10.024" fill="#C28B37" />
    </mask>
    <g mask="url(#p9w0pe68vb)">
      <circle cx="13.819" cy="13.812" r="10.024" fill="#C09525" />
    </g>
    <path
      d="m13.873 6.838 2.162 4.325 4.325.54-2.97 3.33.808 4.78-4.325-2.163-4.325 2.163.815-4.78-2.977-3.33 4.324-.54 2.163-4.325z"
      fill="url(#y7gckks5bc)"
    />
    <defs>
      <linearGradient
        id="ujuuprskpa"
        x1="13.819"
        y1="1"
        x2="13.819"
        y2="26.624"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC600" />
        <stop offset="1" stopColor="#FFDE69" />
      </linearGradient>
      <linearGradient
        id="y7gckks5bc"
        x1="13.873"
        y1="6.838"
        x2="13.873"
        y2="19.813"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFFCDD" />
        <stop offset="1" stopColor="#FFE896" />
      </linearGradient>
    </defs>
  </svg>
);

export const silverMedalIcon = (): JSX.Element => (
  <svg width="22.4" height="31.2" viewBox="0 0 28 38" fill="none">
    <path
      d="m11.26 22.788 3.715 2.145L7.43 38l-2.166-4.83 5.995-10.382z"
      fill="#CE4444"
    />
    <path
      d="m11.26 22.788-3.715-2.145L0 33.71l5.265-.54 5.995-10.382zM16.56 22.788l-3.716 2.145L20.39 38l2.165-4.83-5.994-10.382z"
      fill="#983535"
    />
    <path
      d="m16.56 22.788 3.715-2.145 7.544 13.067-5.265-.54-5.994-10.382z"
      fill="#CE4444"
    />
    <circle
      cx="13.903"
      cy="13.791"
      r="13.291"
      fill="#E3E3E3"
      stroke="#404040"
    />
    <circle cx="13.903" cy="13.791" r="9.984" fill="#595959" />
    <mask
      id="ufudy4mc4a"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="4"
      y="4"
      width="21"
      height="21"
    >
      <circle cx="14.435" cy="14.857" r="10.008" fill="#C28B37" />
    </mask>
    <g mask="url(#ufudy4mc4a)">
      <circle cx="13.903" cy="13.791" r="10.008" fill="url(#5j6w0jh8bb)" />
    </g>
    <path
      d="m13.958 6.829 2.158 4.317 4.318.54-2.965 3.324.806 4.771-4.317-2.159-4.318 2.16.813-4.772-2.972-3.324 4.318-.54 2.159-4.317z"
      fill="url(#kb0x1ps2fc)"
    />
    <defs>
      <linearGradient
        id="5j6w0jh8bb"
        x1="13.903"
        y1="3.783"
        x2="13.903"
        y2="23.798"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9CA1A3" />
        <stop offset="1" stopColor="#9CA1A3" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="kb0x1ps2fc"
        x1="13.958"
        y1="6.829"
        x2="13.958"
        y2="19.781"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1F5F5" />
        <stop offset="0" stopColor="#fff" />
        <stop offset="1" stopColor="#F1F5F5" />
      </linearGradient>
    </defs>
  </svg>
);

export const bronzeMedalIcon = (): JSX.Element => (
  <svg width="22.4" height="31.2" viewBox="0 0 28 38" fill="none">
    <path
      d="m11.26 22.788 3.715 2.145L7.43 38l-2.166-4.83 5.995-10.382z"
      fill="#CE4444"
    />
    <path
      d="m11.26 22.788-3.715-2.145L0 33.71l5.265-.54 5.995-10.382zM16.56 22.788l-3.716 2.145L20.39 38l2.165-4.83-5.994-10.382z"
      fill="#983535"
    />
    <path
      d="m16.56 22.788 3.715-2.145 7.544 13.067-5.265-.54-5.994-10.382z"
      fill="#CE4444"
    />
    <circle
      cx="13.904"
      cy="13.791"
      r="13.291"
      fill="#DC9E42"
      stroke="#774700"
    />
    <circle cx="13.903" cy="13.791" r="9.984" fill="#734C12" />
    <mask
      id="9h7kjh6q1a"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="4"
      y="4"
      width="21"
      height="21"
    >
      <circle cx="14.437" cy="14.857" r="10.008" fill="#C28B37" />
    </mask>
    <g mask="url(#9h7kjh6q1a)">
      <circle cx="13.904" cy="13.791" r="10.008" fill="#A36D1D" />
    </g>
    <path
      d="m13.958 6.829 2.158 4.317 4.318.54-2.965 3.324.806 4.771-4.317-2.159-4.318 2.16.813-4.772-2.972-3.324 4.318-.54 2.159-4.317z"
      fill="url(#vjd8xezeeb)"
    />
    <defs>
      <linearGradient
        id="vjd8xezeeb"
        x1="13.958"
        y1="6.829"
        x2="13.958"
        y2="19.781"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCFF80" />
        <stop offset=".401" stopColor="#FDE870" />
        <stop offset="1" stopColor="#FFC759" />
      </linearGradient>
    </defs>
  </svg>
);

export const steakIcon = (): JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 25 25" fill="none">
    <path
      d="M4.118 24.97c.225.12.462-.14.324-.354-.746-1.162-1.453-3.117-.327-5.635 1.879-4.2 3.022-6.374 3.022-6.374s.607 2.538 2.256 4.795c1.586 2.172 2.454 4.903 1.054 7.179-.131.213.1.466.324.351 1.732-.886 3.675-2.664 3.895-6.201.08-1.081-.04-2.595-.647-4.505-.78-2.42-1.738-3.55-2.292-4.035a.248.248 0 0 0-.41.204c.161 2.612-.821 3.274-1.38 1.78-.224-.596-.354-1.628-.354-2.884 0-2.092-.607-4.246-1.945-5.996a6.79 6.79 0 0 0-1.222-1.243.248.248 0 0 0-.4.215c.103 1.418.01 5.482-3.555 10.338-3.234 4.504-1.98 7.963-1.536 8.9.85 1.795 2.035 2.85 3.193 3.465z"
      fill="#FF5722"
    />
  </svg>
);

export const ascIcon = (): JSX.Element => (
  <svg width="8.667" height="12.059" viewBox="0 0 8.667 12.059">
    <g data-name="Group 2324">
      <path
        fill="#428bca"
        className="icn-cls-1"
        d="m25.388 60.768-3.6-3.6a.724.724 0 0 0-1.027 0l-3.608 3.6a.728.728 0 0 0 .515 1.242h7.209a.728.728 0 0 0 .511-1.242z"
        transform="translate(-16.934 -56.95)"
      />
      <path
        fill="#b5b9c1"
        data-name="sort-solid"
        d="M17.663 63.194h7.209a.728.728 0 0 1 .515 1.242l-3.6 3.6a.724.724 0 0 1-1.027 0l-3.608-3.6a.728.728 0 0 1 .511-1.242z"
        transform="translate(-16.934 -56.196)"
      />
    </g>
  </svg>
);

export const descIcon = (): JSX.Element => (
  <svg width="8.667" height="12.059" viewBox="0 0 8.667 12.059">
    <g data-name="Group 2324">
      <path
        fill="#b5b9c1"
        className="icn-cls-1"
        d="m25.388 60.768-3.6-3.6a.724.724 0 0 0-1.027 0l-3.608 3.6a.728.728 0 0 0 .515 1.242h7.209a.728.728 0 0 0 .511-1.242z"
        transform="translate(-16.934 -56.95)"
      />
      <path
        fill="#428bca"
        data-name="sort-solid"
        d="M17.663 63.194h7.209a.728.728 0 0 1 .515 1.242l-3.6 3.6a.724.724 0 0 1-1.027 0l-3.608-3.6a.728.728 0 0 1 .511-1.242z"
        transform="translate(-16.934 -56.196)"
      />
    </g>
  </svg>
);

export const approveIcon = (className = ""): JSX.Element => (
  <svg width="13" height="13" viewBox="0 0 14.1 14.1" className={className}>
    <defs>
      <style>
        {`.approvle-icon-cls1{stroke:#4c4c4c;fill:none}`}
        {`.approvle-icon-cls2{stroke:none}`}
        {`.approvle-icon-cls3{fill:none}`}
        {`.approvle-icon-cls4{stroke:#4c4c4c;fill:#fff}`}
      </style>
    </defs>
    <g data-name="Group 2703">
      <g data-name="Ellipse 264" className="approvle-icon-cls1">
        <circle cx="7.05" cy="7.05" r="7.05" className="approvle-icon-cls2" />
        <circle cx="7.05" cy="7.05" r="6.55" className="approvle-icon-cls3" />
      </g>
      <g data-name="tick (1)">
        <g data-name="Group 840">
          <path
            data-name="Path 2269"
            d="M5.055 68.084a.233.233 0 0 0-.363 0l-3.073 3.555-1.182-1.366a.233.233 0 0 0-.363 0 .33.33 0 0 0 0 .42l1.363 1.576a.233.233 0 0 0 .363 0L5.055 68.5a.33.33 0 0 0 0-.416z"
            transform="translate(4.377 -63.13)"
            className="approvle-icon-cls4"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const unApproveIcon = (): JSX.Element => (
  <svg width="13" height="13" viewBox="0 0 14.1 14.1">
    <defs>
      <style>
        {`.unapprove-icon-cls1{stroke:#4c4c4c;fill:none}`}
        {`.unapprove-icon-cls2{stroke:none}`}
        {`.unapprove-icon-cls3{fill:none}`}
        {`.unapprove-icon-cls4{stroke:#4c4c4c;fill:#4c4c4c;strokeWidth: .5px}`}
      </style>
    </defs>
    <g data-name="Group 2703">
      <g data-name="Ellipse 264" className="unapprove-icon-cls1">
        <circle cx="7.05" cy="7.05" r="7.05" className="unapprove-icon-cls2" />
        <circle cx="7.05" cy="7.05" r="6.55" className="unapprove-icon-cls3" />
      </g>
      <path
        data-name="Icon ionic-ios-close"
        d="m14.452 13.848 1.829-1.829a.429.429 0 0 0-.606-.606l-1.829 1.829-1.829-1.829a.429.429 0 1 0-.606.606l1.829 1.829-1.829 1.829a.429.429 0 0 0 .606.606l1.829-1.829 1.829 1.829a.429.429 0 0 0 .606-.606z"
        transform="translate(-6.795 -6.798)"
        className="unapprove-icon-cls4"
      />
    </g>
  </svg>
);

export const reviewIcon = (): JSX.Element => (
  <svg width="13" height="14" viewBox="0 0 14.312 15.814">
    <defs>
      <style>{`.review-icon-cls1{fill:#4c4c4c; stroke:#4c4c4c; strokeWidth:.3px}`}</style>
    </defs>
    <path
      d="M2.422 5.1a.345.345 0 0 1-.322-.358.338.338 0 0 1 .326-.355h5.547a.342.342 0 0 1 .326.355.337.337 0 0 1-.324.355zm7.563 3.2a3.121 3.121 0 0 1 2.613 4.83l1.351 1.47-.933.851-1.3-1.433A3.121 3.121 0 1 1 9.985 8.3zm1.66 1.461a2.346 2.346 0 1 0 .688 1.66 2.346 2.346 0 0 0-.688-1.66zm-9.22-2.768a.343.343 0 0 1-.325-.354.337.337 0 0 1 .324-.352H5.2a.345.345 0 0 1 .331.357.337.337 0 0 1-.323.356zm7.981-4.838h1.162a.835.835 0 0 1 .831.831v3.952c-.025.26-.663.264-.717 0V2.986a.116.116 0 0 0-.118-.118H10.4v4.07c-.062.236-.593.272-.713 0V.831a.116.116 0 0 0-.116-.118H.827a.114.114 0 0 0-.118.118v9.879a.114.114 0 0 0 .118.118h4.625a.368.368 0 0 1 0 .713H2.7v1.324a.116.116 0 0 0 .118.118h2.63c.26.029.345.621 0 .713H2.827A.832.832 0 0 1 2 12.865v-1.324H.831a.816.816 0 0 1-.586-.251.825.825 0 0 1-.245-.58V.831a.816.816 0 0 1 .251-.58A.824.824 0 0 1 .831 0h8.745a.819.819 0 0 1 .586.251.822.822 0 0 1 .244.586v1.318zM2.422 3.194a.345.345 0 0 1-.322-.355.338.338 0 0 1 .326-.355h5.547a.343.343 0 0 1 .326.355.338.338 0 0 1-.324.355z"
      transform="translate(.15 .15)"
      className="review-icon-cls1"
    />
  </svg>
);

export const userIconOutlined = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "22.963"}
    height={height || "25.994"}
    viewBox="0 0 22.963 25.994"
  >
    <g data-name="Group 2896">
      <path
        data-name="Path 126"
        d="M1745.634 347.8c-2.208 0-4.416.005-6.624 0-2.644-.008-4.08-1.461-4.082-4.108a13.65 13.65 0 0 1 1-5.571 4.315 4.315 0 0 1 3.636-2.918 2.569 2.569 0 0 1 1.244.27c.985.456 1.9 1.091 2.911 1.453a6.556 6.556 0 0 0 5.645-.737c.175-.1.336-.225.511-.326.581-.335 1.064-.846 1.864-.7a3.952 3.952 0 0 1 2.7 1.459 9.773 9.773 0 0 1 1.255 2.331 13.6 13.6 0 0 1 .659 5.386 3.507 3.507 0 0 1-3.493 3.43c-2.41.058-4.821.014-7.231.014z"
        transform="translate(-1734.178 -322.557)"
        style={{
          fill: "none",
          stroke: "#4c4c4c",
          strokeWidth: "1.5px",
          fillRule: "evenodd",
        }}
      />
      <path
        data-name="Path 127"
        d="M1786.7 252.695a5.848 5.848 0 1 1-5.818-5.863 5.8 5.8 0 0 1 5.818 5.863z"
        transform="translate(-1769.377 -246.082)"
        style={{
          fill: "none",
          stroke: "#4c4c4c",
          strokeWidth: "1.5px",
          fillRule: "evenodd",
        }}
      />
    </g>
  </svg>
);

export const moreIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "5"} height={height || "21"} viewBox="0 0 5 21">
    <g data-name="Group 1344" transform="translate(-1703 -142)">
      <circle
        data-name="Ellipse 265"
        cx="2.5"
        cy="2.5"
        r="2.5"
        transform="translate(1703 142)"
        style={{ fill: "#4c4c4c" }}
      />
      <circle
        data-name="Ellipse 266"
        cx="2.5"
        cy="2.5"
        r="2.5"
        transform="translate(1703 150)"
        style={{ fill: "#4c4c4c" }}
      />
      <circle
        data-name="Ellipse 267"
        cx="2.5"
        cy="2.5"
        r="2.5"
        transform="translate(1703 158)"
        style={{ fill: "#4c4c4c" }}
      />
    </g>
  </svg>
);

export const totalResultsIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "19.003"}
    height={height || "18.736"}
    viewBox="0 0 19.003 18.736"
  >
    <g data-name="circle-tick-svgrepo-com (1)">
      <path
        data-name="Path 2800"
        d="M18.75 11.275a9.185 9.185 0 0 1-6.842 7.325 8.508 8.508 0 0 1-7.95-14.067A9.155 9.155 0 0 1 13.99 2.426"
        transform="translate(-.807 -.838)"
        style={{
          fill: "none",
          stroke: "#fff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5px",
        }}
      />
      <path
        data-name="Path 2801"
        d="M5.75 9.009 9.037 12.3l7.889-8.55"
        transform="translate(1.017 -.02)"
        style={{
          fill: "none",
          stroke: "#fff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5px",
        }}
      />
    </g>
  </svg>
);

export const userActivityIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "18.04"}
    height={height || "18.04"}
    viewBox="0 0 18.04 18.04"
  >
    <g style={{ opacity: "0.8" }}>
      <path
        data-name="Path 2802"
        d="M156.712 127.392a2.128 2.128 0 0 0 2.126 2.126h3.136a2.128 2.128 0 0 0 2.126-2.126 3.7 3.7 0 0 0-2.081-3.323 2.126 2.126 0 1 0-3.227 0 3.7 3.7 0 0 0-2.08 3.323zm2.684-4.7a1.01 1.01 0 1 1 1.01 1.01 1.012 1.012 0 0 1-1.006-1.015zm1.01 2.126a2.582 2.582 0 0 1 2.579 2.579 1.012 1.012 0 0 1-1.01 1.01h-3.136a1.012 1.012 0 0 1-1.01-1.01 2.582 2.582 0 0 1 2.577-2.584z"
        transform="translate(-151.386 -116.524)"
        style={{ fill: "#272727" }}
      />
      <path
        data-name="Path 2803"
        d="M3.111 3.925a7.694 7.694 0 0 1 5.483-2.744A7.6 7.6 0 0 1 14.3 3.355l.326.314-1.148.058a.546.546 0 0 0-.5.584.541.541 0 0 0 .525.531h.026l2.416-.123a.546.546 0 0 0 .5-.584l-.116-2.563a.539.539 0 0 0-.55-.53.546.546 0 0 0-.5.584l.055 1.218-.326-.315A8.614 8.614 0 0 0 8.544.067a8.715 8.715 0 0 0-6.211 3.108A9.918 9.918 0 0 0 .3 11.993a.532.532 0 0 0 .5.417.5.5 0 0 0 .133-.018.562.562 0 0 0 .376-.681 8.756 8.756 0 0 1 1.8-7.786z"
        transform="translate(0 -.056)"
        style={{ fill: "#272727" }}
      />
      <path
        data-name="Path 2804"
        d="M59.049 180.243a.524.524 0 0 0-.642-.4.562.562 0 0 0-.376.681 8.756 8.756 0 0 1-1.8 7.786 7.694 7.694 0 0 1-5.483 2.743q-.195.01-.389.01a7.618 7.618 0 0 1-5.317-2.184l-.326-.315 1.148-.058a.546.546 0 0 0 .5-.584.539.539 0 0 0-.55-.53l-2.416.123a.546.546 0 0 0-.5.584l.116 2.563a.541.541 0 0 0 .525.531h.026a.546.546 0 0 0 .5-.584l-.055-1.218.326.315a8.628 8.628 0 0 0 6.023 2.473q.219 0 .44-.011a8.716 8.716 0 0 0 6.211-3.107 9.918 9.918 0 0 0 2.039-8.818z"
        transform="translate(-41.304 -174.14)"
        style={{ fill: "#272727" }}
      />
    </g>
  </svg>
);

export const alertIconOutlined = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "16"} height={height || "16"} viewBox="0 0 16 16">
    <g data-name="Group 2734">
      <g data-name="Group 2733" style={{ opacity: "0.8" }}>
        <path
          data-name="Path 2797"
          d="M235.043 102.264a.345.345 0 0 0 .344-.344v-5.512a.344.344 0 0 0-.689 0v5.511a.343.343 0 0 0 .345.345z"
          transform="translate(-227.348 -92.066)"
          style={{ fill: "#272727" }}
        />
        <path
          data-name="Path 2798"
          d="M224.514 330.73h-.014a.689.689 0 1 0 .014 1.378h.014a.689.689 0 1 0-.014-1.378z"
          transform="translate(-216.819 -319.154)"
          style={{ fill: "#272727" }}
        />
      </g>
      <g
        data-name="Ellipse 272"
        style={{ stroke: "#272727", fill: "none", opacity: "0.8" }}
      >
        <circle cx="8" cy="8" r="8" style={{ stroke: "none" }} />
        <circle cx="8" cy="8" r="7.5" style={{ fill: "none" }} />
      </g>
    </g>
  </svg>
);

export const duplicateIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "15.229"}
    height={height || "15.23"}
    viewBox="0 0 15.229 15.23"
  >
    <g
      id="Clone_-_duplicate"
      data-name="Clone - duplicate"
      fill="none"
      opacity="0.8"
    >
      <path
        d="M0,6.663a1.9,1.9,0,0,1,1.9-1.9h1.9V8.567a2.839,2.839,0,0,0,2.856,2.856H10.47v1.9a1.905,1.905,0,0,1-1.9,1.9H1.9a1.9,1.9,0,0,1-1.9-1.9ZM6.663,10.47a1.905,1.905,0,0,1-1.9-1.9V1.9A1.9,1.9,0,0,1,6.663,0h6.663a1.9,1.9,0,0,1,1.9,1.9V8.567a1.905,1.905,0,0,1-1.9,1.9Z"
        stroke="none"
      />
      <path
        d="M 6.662956237792969 0.9999961853027344 C 6.164656639099121 0.9999961853027344 5.759256362915039 1.405396461486816 5.759256362915039 1.90369701385498 L 5.759256362915039 8.566656112670898 C 5.759256362915039 9.064956665039062 6.164656639099121 9.470355987548828 6.662956237792969 9.470355987548828 L 13.3259162902832 9.470355987548828 C 13.82421684265137 9.470355987548828 14.22961616516113 9.064956665039062 14.22961616516113 8.566656112670898 L 14.22961616516113 1.90369701385498 C 14.22961616516113 1.405396461486816 13.82421684265137 0.9999961853027344 13.3259162902832 0.9999961853027344 L 6.662956237792969 0.9999961853027344 M 1.90369701385498 5.759256362915039 C 1.405396461486816 5.759256362915039 0.9999961853027344 6.164656639099121 0.9999961853027344 6.662956237792969 L 0.9999961853027344 13.3259162902832 C 0.9999961853027344 13.82421684265137 1.405396461486816 14.22961616516113 1.90369701385498 14.22961616516113 L 8.566656112670898 14.22961616516113 C 9.064956665039062 14.22961616516113 9.470355987548828 13.82421684265137 9.470355987548828 13.3259162902832 L 9.470355987548828 12.42220687866211 L 6.662956237792969 12.42220687866211 C 4.536996841430664 12.42220687866211 2.807406425476074 10.69261646270752 2.807406425476074 8.566656112670898 L 2.807406425476074 5.759256362915039 L 1.90369701385498 5.759256362915039 M 6.662956237792969 -3.814697265625e-06 L 13.3259162902832 -3.814697265625e-06 C 14.37592697143555 -3.814697265625e-06 15.22961711883545 0.8522062301635742 15.22961711883545 1.90369701385498 L 15.22961711883545 8.566656112670898 C 15.22961711883545 9.616666793823242 14.37592697143555 10.47035598754883 13.3259162902832 10.47035598754883 L 6.662956237792969 10.47035598754883 C 5.612946510314941 10.47035598754883 4.759256362915039 9.616666793823242 4.759256362915039 8.566656112670898 L 4.759256362915039 1.90369701385498 C 4.759256362915039 0.8522062301635742 5.612946510314941 -3.814697265625e-06 6.662956237792969 -3.814697265625e-06 Z M 1.90369701385498 4.759256362915039 L 3.807406425476074 4.759256362915039 L 3.807406425476074 8.566656112670898 C 3.807406425476074 10.14315605163574 5.059686660766602 11.42220687866211 6.662956237792969 11.42220687866211 L 10.47035598754883 11.42220687866211 L 10.47035598754883 13.3259162902832 C 10.47035598754883 14.37592697143555 9.616666793823242 15.22961711883545 8.566656112670898 15.22961711883545 L 1.90369701385498 15.22961711883545 C 0.8522062301635742 15.22961711883545 -3.814697265625e-06 14.37592697143555 -3.814697265625e-06 13.3259162902832 L -3.814697265625e-06 6.662956237792969 C -3.814697265625e-06 5.612946510314941 0.8522062301635742 4.759256362915039 1.90369701385498 4.759256362915039 Z"
        stroke="none"
        fill="#272727"
      />
    </g>
  </svg>
);

export const refreshIconOutlined1 = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg width={width || "15"} height={height || "15"} viewBox="0 0 15 15">
    <path
      d="M2.667 2.9a6.109 6.109 0 0 1 1.505-1.594L2.86 0h3.817v3.8L4.894 2.025a5.084 5.084 0 1 0 8.037 4.155 5.031 5.031 0 0 0-2.881-4.559l.442-.9a6.12 6.12 0 0 1 2.49 2.2 6.007 6.007 0 0 1 .959 3.261 6.124 6.124 0 0 1-12.247 0A6.006 6.006 0 0 1 2.667 2.9z"
      transform="rotate(74.99 6.761 6.606)"
      style={{ fill: "#272727", opacity: "0.8" }}
    />
  </svg>
);

export const notesIcon = (): JSX.Element => (
  <svg width="12" height="12" viewBox="0 0 14.836 14.836">
    <path
      d="M14.836 33.59v6.954h-5.32a.972.972 0 0 0-.972.972v5.321H1.59A1.59 1.59 0 0 1 0 45.247V33.59A1.59 1.59 0 0 1 1.59 32h11.657a1.59 1.59 0 0 1 1.589 1.59zm-5.3 7.948v5.3l5.3-5.3z"
      transform="translate(0 -32)"
      style={{ fill: "#d2d2d2" }}
    />
  </svg>
);

export const blueTagIcon = (): JSX.Element => (
  <svg width="19.5" height="19.5" viewBox="0 0 24.586 24.73">
    <defs>
      <style>{`.blue-tag-icon-cls-1234{fill:#428bca;stroke:#fff}`}</style>
    </defs>
    <g data-name="Group 2522">
      <path
        data-name="Path 2799"
        d="M-684.687 686.743c0-1.453-.024-2.906.009-4.359a2.187 2.187 0 0 1 1.562-1.986 3.36 3.36 0 0 1 .91-.129c2.641-.01 5.281.006 7.922-.013a2.662 2.662 0 0 1 2.011.832q5.153 5.173 10.325 10.327a2.538 2.538 0 0 1 .783 1.329 2.2 2.2 0 0 1-.547 2.03c-1.219 1.248-2.46 2.474-3.693 3.708q-2.318 2.319-4.64 4.635a2.31 2.31 0 0 1-3.374 0q-3.865-3.848-7.713-7.714c-.933-.934-1.862-1.872-2.8-2.8a2.427 2.427 0 0 1-.765-1.836c.015-1.342 0-2.685 0-4.027zm4.1-.578a1.778 1.778 0 0 0 1.787-1.782 1.762 1.762 0 0 0-1.778-1.789 1.789 1.789 0 0 0-1.783 1.79 1.8 1.8 0 0 0 1.771 1.781z"
        transform="translate(685.198 -679.757)"
        className="blue-tag-icon-cls-1234"
      />
    </g>
  </svg>
);

export const analyticsDictionaryIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "22.957"}
    height={height || "19.421"}
    viewBox="0 0 22.957 19.421"
  >
    <g
      id="Group_3076"
      data-name="Group 3076"
      transform="translate(-7915 1770.421)"
    >
      <path
        id="Subtraction_1"
        data-name="Subtraction 1"
        d="M20.86,19.421H2.093a2.2,2.2,0,0,1-1.458-.647,2.245,2.245,0,0,1-.5-.765A2.216,2.216,0,0,1,0,17.4V2.013a2.231,2.231,0,0,1,.136-.6A2.2,2.2,0,0,1,1.394.148,2.209,2.209,0,0,1,2.138,0h.105l.051,0H20.756a2.188,2.188,0,0,1,2.127,1.675,2.67,2.67,0,0,1,.068.621c.007,3.317.008,8.442,0,14.82a2.208,2.208,0,0,1-2.094,2.3ZM14.766,4.345a.542.542,0,0,0-.547.536V14.54a.542.542,0,0,0,.547.536h2.191a.542.542,0,0,0,.547-.536V4.882a.542.542,0,0,0-.547-.536ZM10.385,7.564a.543.543,0,0,0-.548.536V14.54a.543.543,0,0,0,.548.536h2.191a.543.543,0,0,0,.548-.536V8.1a.543.543,0,0,0-.548-.536ZM6,10.784a.543.543,0,0,0-.548.536v3.219A.543.543,0,0,0,6,15.077H8.193a.543.543,0,0,0,.548-.537V11.32a.543.543,0,0,0-.548-.536Z"
        transform="translate(7915 -1770.421)"
        fill="#85c0ec"
      />
    </g>
  </svg>
);

export const pagesSheetIcon = (): JSX.Element => (
  <svg width="35.632" height="45.35" viewBox="0 0 35.632 45.35">
    <g data-name="Group 3163" style={{ opacity: 0.3 }}>
      <g transform="translate(9.807 16.288)">
        <rect
          data-name="Rectangle 1825"
          width="4.627"
          height="6.763"
          rx="1"
          transform="translate(0 9.255)"
          style={{ fill: "#a3a3a3" }}
        />
        <rect
          data-name="Rectangle 1826"
          width="4.271"
          height="11.39"
          rx="1"
          transform="translate(11.746 4.627)"
          style={{ fill: "#a3a3a3" }}
        />
        <rect
          data-name="Rectangle 1827"
          width="4.627"
          height="16.018"
          rx="1"
          transform="translate(5.695)"
          style={{ fill: "#a3a3a3" }}
        />
      </g>
      <g data-name="Layer 60">
        <path
          data-name="Path 2957"
          d="m40.519 12.771-.1-.194a.259.259 0 0 0-.113-.211l-7.367-9.718A1.62 1.62 0 0 0 31.643 2H9.859A4.859 4.859 0 0 0 5 6.859v35.632a4.859 4.859 0 0 0 4.859 4.859h25.914a4.859 4.859 0 0 0 4.859-4.859V13.337a1.62 1.62 0 0 0-.113-.566zm-4.746-1.053h-3.239V7.474zm0 32.393H9.859a1.62 1.62 0 0 1-1.62-1.62V6.859a1.62 1.62 0 0 1 1.62-1.62h19.436v6.479a3.239 3.239 0 0 0 3.239 3.239h4.859v27.534a1.62 1.62 0 0 1-1.62 1.62z"
          transform="translate(-5 -2)"
          style={{ fill: "#a3a3a3" }}
        />
      </g>
    </g>
  </svg>
);

export const forwardLineageIcon = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.61114 7.3143H12.0556C12.5465 7.3143 12.9445 6.90497 12.9445 6.40001V0.914295C12.9445 0.409335 12.5465 0 12.0556 0H1.3889C0.897964 0 0.5 0.409335 0.5 0.914295V6.40001C0.5 6.90497 0.897964 7.3143 1.3889 7.3143H5.83334V12.8C5.83334 13.305 6.2313 13.7143 6.72224 13.7143H13.4652L12.7604 14.4392C12.4132 14.7963 12.4132 15.3751 12.7604 15.7322C13.1075 16.0893 13.6703 16.0893 14.0174 15.7322L16.2396 13.4465C16.5868 13.0895 16.5868 12.5106 16.2396 12.1535L14.0174 9.86782C13.6703 9.51076 13.1075 9.51076 12.7604 9.86782C12.4132 10.2248 12.4132 10.8037 12.7604 11.1608L13.4652 11.8857H7.61114V7.3143ZM11.1667 1.82859V5.48571H2.2778V1.82859H11.1667Z"
      fill="#959596"
    />
  </svg>
);

export const backwardLineageIcon = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.38886 7.3143H4.94442C4.45349 7.3143 4.05552 6.90497 4.05552 6.40001V0.914295C4.05552 0.409335 4.45349 0 4.94442 0H15.6111C16.102 0 16.5 0.409335 16.5 0.914295V6.40001C16.5 6.90497 16.102 7.3143 15.6111 7.3143H11.1667V12.8C11.1667 13.305 10.7687 13.7143 10.2778 13.7143H3.53484L4.23963 14.4392C4.58678 14.7963 4.58678 15.3751 4.23963 15.7322C3.89249 16.0893 3.32966 16.0893 2.98258 15.7322L0.760357 13.4465C0.413214 13.0895 0.413214 12.5106 0.760357 12.1535L2.98258 9.86782C3.32972 9.51076 3.89255 9.51076 4.23963 9.86782C4.58678 10.2248 4.58678 10.8037 4.23963 11.1608L3.53484 11.8857H9.38886V7.3143ZM5.83332 1.82859V5.48571H14.7222V1.82859H5.83332Z"
      fill="#959596"
    />
  </svg>
);

export const inSightsIconOutlined = (): JSX.Element => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M47.5 24c0 12.979-10.521 23.5-23.5 23.5S.5 36.979.5 24 11.021.5 24 .5 47.5 11.021 47.5 24z"
      fill="#fff"
      stroke="#428BCA"
    />
    <g clipPath="url(#4e87b87x9a)">
      <path d="M24.604 29.75v-5.352" stroke="#428BCA" strokeWidth="1.4" />
      <path
        d="M24.604 25.544c.814 0 1.475-.684 1.475-1.528 0-.845-.66-1.53-1.476-1.53-.814 0-1.475.685-1.475 1.53 0 .844.66 1.529 1.476 1.529z"
        fill="#428BCA"
      />
      <path
        d="M28.013 30.837v.665c0 .439-.169.86-.469 1.17-.299.31-.705.485-1.128.485h-.352c-.073.374-.27.71-.555.952a1.563 1.563 0 0 1-1.01.373c-.369 0-.726-.132-1.01-.373a1.667 1.667 0 0 1-.556-.952h-.351c-.424 0-.83-.175-1.129-.485-.3-.31-.468-.731-.468-1.17v-.665c0-.263.1-.516.28-.702a.943.943 0 0 1 .678-.291h5.112c.254 0 .498.105.677.291.18.186.28.439.281.702zm.909-13.396a6.274 6.274 0 0 0-4.563-1.835 6.294 6.294 0 0 0-4.479 2.045 6.76 6.76 0 0 0-1.771 4.728 6.739 6.739 0 0 0 2.16 4.818 2.2 2.2 0 0 1 .529.748c.123.285.186.594.184.906 0 .264.102.516.281.702.18.187.424.291.678.292h5.112a.943.943 0 0 0 .678-.292c.18-.186.28-.438.28-.702a2.276 2.276 0 0 1 .185-.908c.123-.285.303-.54.528-.748a6.613 6.613 0 0 0 1.513-2.06 6.854 6.854 0 0 0 .3-5.067 6.692 6.692 0 0 0-1.615-2.627z"
        fill="#fff"
        stroke="#428BCA"
        strokeWidth="1.4"
      />
      <path
        d="M18.854 17.017c-.615-.625-1.227-1.229-1.817-1.856a.709.709 0 0 1 .032-.95.663.663 0 0 1 .46-.235.641.641 0 0 1 .484.178c.6.598 1.177 1.22 1.775 1.842l-.934 1.021zM30.162 17.026l-.942-1.022c.027-.044.057-.085.09-.124l1.569-1.625a.707.707 0 0 1 .473-.27.677.677 0 0 1 .519.162.72.72 0 0 1 .261.556.747.747 0 0 1-.248.562c-.537.566-1.082 1.124-1.623 1.684a.94.94 0 0 1-.099.074v.003zM17.148 21.18v1.41c-.094.008-.159.02-.223.02h-2.179a.67.67 0 0 1-.52-.186.717.717 0 0 1-.225-.517.733.733 0 0 1 .195-.526.684.684 0 0 1 .503-.213c.8-.012 1.601-.004 2.402-.004.016.003.032.01.047.018v-.003zM31.86 22.608v-1.426c.039-.01.08-.017.12-.02.765 0 1.531-.006 2.297 0a.663.663 0 0 1 .507.193.711.711 0 0 1 .214.517.721.721 0 0 1-.194.533.671.671 0 0 1-.512.206c-.658.006-1.317 0-1.975 0l-.458-.003zM25.202 14.166h-1.38a.446.446 0 0 1-.018-.093v-2.32a.717.717 0 0 1 .105-.409.68.68 0 0 1 .314-.27.602.602 0 0 1 .744.13c.12.12.2.277.224.449.022.834.011 1.668.011 2.513zM18.47 27.136l.869 1.123c-.064.07-.121.136-.182.2-.352.363-.7.73-1.056 1.09a.706.706 0 0 1-.506.245.682.682 0 0 1-.519-.215.736.736 0 0 1-.2-.541.755.755 0 0 1 .242-.522c.412-.43.826-.856 1.24-1.284.031-.032.069-.059.112-.096zM30.611 27.192c.054.093.072.06.128.124.38.403.77.797 1.151 1.2a.738.738 0 0 1 .239.534.762.762 0 0 1-.214.545.709.709 0 0 1-.515.195.694.694 0 0 1-.5-.242 77.03 77.03 0 0 1-1.14-1.182.214.214 0 0 1-.023-.2c.258-.343.543-.547.874-.974z"
        fill="#428BCA"
      />
    </g>
    <defs>
      <clipPath id="4e87b87x9a">
        <path fill="#fff" transform="translate(14 11)" d="M0 0h21v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const inSightsIconFilled = (): JSX.Element => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M47.5 24c0 12.979-10.521 23.5-23.5 23.5S.5 36.979.5 24 11.021.5 24 .5 47.5 11.021 47.5 24z"
      fill="#428BCA"
      stroke="#428BCA"
    />
    <g clipPath="url(#h3zpgutsva)" fill="#fff">
      <path d="M24.604 25.544c.815 0 1.476-.684 1.476-1.528 0-.845-.661-1.53-1.476-1.53s-1.476.685-1.476 1.53c0 .844.661 1.529 1.476 1.529z" />
      <path
        d="M28.014 30.837v.665c-.001.439-.17.86-.469 1.17-.3.31-.705.485-1.129.485h-.351c-.074.374-.27.71-.555.952a1.563 1.563 0 0 1-1.01.373c-.37 0-.726-.132-1.011-.373a1.667 1.667 0 0 1-.555-.952h-.352c-.423 0-.829-.175-1.129-.485-.299-.31-.467-.731-.468-1.17v-.665c0-.263.101-.516.281-.702a.943.943 0 0 1 .678-.291h5.111c.255 0 .498.105.678.291.18.186.28.439.28.702zm.908-13.396a6.274 6.274 0 0 0-4.562-1.835 6.294 6.294 0 0 0-4.48 2.045 6.76 6.76 0 0 0-1.77 4.728 6.739 6.739 0 0 0 2.16 4.818c.225.208.405.463.528.748s.186.594.185.906c0 .264.101.516.28.702.18.187.424.291.679.292h5.111a.943.943 0 0 0 .678-.292c.18-.186.28-.438.281-.702a2.276 2.276 0 0 1 .185-.908c.123-.285.303-.54.528-.748a6.612 6.612 0 0 0 1.513-2.06 6.856 6.856 0 0 0 .3-5.067 6.692 6.692 0 0 0-1.616-2.627z"
        stroke="#fff"
        strokeWidth=".5"
      />
      <path d="M18.853 17.017c-.614-.625-1.227-1.229-1.817-1.856a.709.709 0 0 1 .032-.95.663.663 0 0 1 .46-.235.641.641 0 0 1 .485.178c.599.598 1.177 1.22 1.775 1.842l-.935 1.021zM30.163 17.026l-.943-1.022c.027-.044.058-.085.09-.124l1.569-1.625a.706.706 0 0 1 .474-.27.677.677 0 0 1 .518.162.72.72 0 0 1 .262.556.745.745 0 0 1-.248.562c-.538.566-1.082 1.124-1.624 1.684a.938.938 0 0 1-.098.074v.003zM17.148 21.18v1.41c-.094.008-.159.02-.223.02h-2.179a.67.67 0 0 1-.52-.186.717.717 0 0 1-.225-.517.733.733 0 0 1 .195-.526.684.684 0 0 1 .503-.213c.8-.012 1.601-.004 2.402-.004.016.003.032.01.047.018v-.003zM31.859 22.608v-1.426c.04-.01.08-.017.12-.02.766 0 1.532-.006 2.297 0a.663.663 0 0 1 .508.193.71.71 0 0 1 .214.517.721.721 0 0 1-.194.533.67.67 0 0 1-.513.206c-.658.006-1.316 0-1.974 0l-.458-.003zM25.202 14.166h-1.38a.446.446 0 0 1-.018-.093v-2.32a.717.717 0 0 1 .105-.409.68.68 0 0 1 .314-.27.602.602 0 0 1 .744.13c.12.12.2.277.224.449.022.834.011 1.668.011 2.513zM18.47 27.136l.868 1.123c-.064.07-.121.136-.182.2-.351.363-.7.73-1.055 1.09a.706.706 0 0 1-.506.245.682.682 0 0 1-.52-.215.736.736 0 0 1-.199-.541.755.755 0 0 1 .242-.522c.411-.43.826-.856 1.24-1.284.03-.032.069-.059.111-.096zM30.612 27.192c.053.093.071.06.127.124.381.403.771.797 1.152 1.2a.738.738 0 0 1 .238.534.762.762 0 0 1-.213.545.709.709 0 0 1-.516.195.694.694 0 0 1-.499-.242 77.03 77.03 0 0 1-1.14-1.182.215.215 0 0 1-.023-.2c.258-.343.542-.547.874-.974z" />
    </g>
    <defs>
      <clipPath id="h3zpgutsva">
        <path fill="#fff" transform="translate(14 11)" d="M0 0h21v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const drillIconOutlined = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "48"}
    height={height || "48"}
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      d="M47.5 24c0 12.979-10.521 23.5-23.5 23.5S.5 36.979.5 24 11.021.5 24 .5 47.5 11.021 47.5 24z"
      fill="#fff"
      stroke="#428BCA"
    />
    <path
      d="m15.897 29.785 2.373 2.52V14h1.461v18.3l2.373-2.516.896.955-3.102 3.293.015.015-.898.952-.013-.015-.015.016-.9-.954.015-.016L15 30.736l.897-.951zM25.897 29.785l2.373 2.52V14h1.461v18.3l2.373-2.516.896.955-3.102 3.293.015.015-.898.952-.013-.015-.015.016-.9-.954.015-.016L25 30.736l.897-.951z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeLinejoin="round"
    />
  </svg>
);

export const drillIconFilled = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "48"}
    height={height || "48"}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M47.5 24c0 12.979-10.521 23.5-23.5 23.5S.5 36.979.5 24 11.021.5 24 .5 47.5 11.021 47.5 24z"
      fill="#428BCA"
      stroke="#428BCA"
    />
    <path
      d="m15.897 29.785 2.373 2.52V14h1.461v18.3l2.373-2.516.896.955-3.102 3.293.015.015-.898.952-.013-.015-.015.016-.9-.954.015-.016L15 30.736l.897-.951zM25.897 29.785l2.373 2.52V14h1.461v18.3l2.373-2.516.896.955-3.102 3.293.015.015-.898.952-.013-.015-.015.016-.9-.954.015-.016L25 30.736l.897-.951z"
      fill="#fff"
      stroke="#fff"
      strokeLinejoin="round"
    />
  </svg>
);

export const requiredIcon = (width?: string, height?: string): JSX.Element => (
  <svg width={width || "16"} height={height || "15"} viewBox="0 0 16 15">
    <path
      data-name="Path 2936"
      d="m10.981-20.514-.6 5.371 5.628-1.541.585 4.5-4.964.32 3.27 4.245-4.109 2.105L8.53-9.832 6.585-5.544l-4.3-2.075 3.257-4.242-4.949-.382.711-4.44 5.5 1.541-.614-5.372z"
      transform="translate(-.593 20.514)"
      style={{ fill: "#d15b47" }}
    />
  </svg>
);

export const biDirectionalIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "16"}
    viewBox="0 0 20 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.333 11.886V7.314H4.89A.902.902 0 0 1 4 6.4V.914C4 .41 4.398 0 4.889 0H15.61c.491 0 .889.41.889.914V6.4a.902.902 0 0 1-.889.914H11.166v4.572h5.8l-.706-.725a.933.933 0 0 1 0-1.293.871.871 0 0 1 1.257 0l2.223 2.285a.933.933 0 0 1 0 1.293l-2.223 2.286a.871.871 0 0 1-1.257 0 .933.933 0 0 1 0-1.293l.705-.725H3.535l.705.725a.933.933 0 0 1 0 1.293.871.871 0 0 1-1.257 0L.76 13.447a.933.933 0 0 1 0-1.293l2.223-2.286a.871.871 0 0 1 1.257 0 .933.933 0 0 1 0 1.293l-.705.725h5.798zm-3.5-6.4V1.829h8.834v3.657H5.833z"
      fill="#959596"
    />
  </svg>
);

export const headForwardLineageIcon = (): JSX.Element => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M14.778 15.057h6.11c.676 0 1.223-.563 1.223-1.257V6.257c0-.694-.547-1.257-1.222-1.257H6.222C5.547 5 5 5.563 5 6.257V13.8c0 .694.547 1.257 1.222 1.257h6.111V22.6c0 .694.547 1.257 1.223 1.257h9.271l-.969.997a1.283 1.283 0 0 0 0 1.778c.477.49 1.251.49 1.729 0l3.055-3.143a1.283 1.283 0 0 0 0-1.778l-3.055-3.143a1.198 1.198 0 0 0-1.729 0 1.283 1.283 0 0 0 0 1.778l.97.997h-8.05v-6.286zm4.889-7.543v5.029H7.444V7.514h12.223z"
      fill="#428BCA"
    />
  </svg>
);

export const headBackwardLineageIcon = (): JSX.Element => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M17.2222 15.0572H11.1111C10.436 15.0572 9.88885 14.4943 9.88885 13.8V6.25716C9.88885 5.56284 10.436 5 11.1111 5H25.7778C26.4528 5 27 5.56284 27 6.25716V13.8C27 14.4943 26.4528 15.0572 25.7778 15.0572H19.6667V22.6C19.6667 23.2943 19.1195 23.8572 18.4444 23.8572H9.17291L10.142 24.8539C10.6193 25.3449 10.6193 26.1408 10.142 26.6318C9.66467 27.1227 8.89078 27.1227 8.41354 26.6318L5.35799 23.4889C4.88067 22.9981 4.88067 22.2021 5.35799 21.7111L8.41354 18.5683C8.89086 18.0773 9.66476 18.0773 10.142 18.5683C10.6193 19.0591 10.6193 19.8551 10.142 20.3461L9.17291 21.3429H17.2222V15.0572ZM12.3333 7.51431V12.5429H24.5555V7.51431H12.3333Z"
      fill="#428BCA"
    />
  </svg>
);

export const sortRightIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "7.407"}
    height={height || "10"}
    viewBox="0 0 7.407 12.951"
  >
    <path
      data-name="Path 3025"
      d="M.191 6.231 5.768.306a.971.971 0 0 1 1.414 0l5.578 5.925a.7.7 0 0 1-.508 1.176H.7a.7.7 0 0 1-.509-1.176z"
      transform="rotate(90 3.704 3.704)"
    />
  </svg>
);

export const chevronLeftFilled = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "26"}
    height={height || "26"}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Chevron Left">
      <path
        id="Polygon 3"
        d="M9.33301 16.8781L19.333 7.25564L19.333 26.5007L9.33301 16.8781Z"
        fill="#949494"
      />
    </g>
  </svg>
);

export const chevronRightFilled = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "26"}
    height={height || "26"}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Chevron Right">
      <path
        id="Polygon 3"
        d="M22.667 16.4344L12.667 26.0569L12.667 6.81185L22.667 16.4344Z"
        fill="#949494"
      />
    </g>
  </svg>
);

export const sortBottomIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "10"}
    height={height || "7.407"}
    viewBox="0 0 12.951 7.407"
  >
    <path
      data-name="Path 3025"
      d="M.191 1.176 5.768 7.1a.971.971 0 0 0 1.414 0l5.578-5.924A.7.7 0 0 0 12.252 0H.7a.7.7 0 0 0-.509 1.176z"
    />
  </svg>
);

export const trendUpIcon = (): JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="12" fill="#F6F6F6" />
    <path d="M12 8L17.6292 14.75H6.37083L12 8Z" fill="#069C56" />
  </svg>
);

export const trendUpIconRed = (): JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="12" fill="#F6F6F6" />
    <path d="M12 8L17.6292 14.75H6.37083L12 8Z" fill="#D94B55" />
  </svg>
);

export const trendUpIconGrey = (): JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="12" fill="#F6F6F6" />
    <path d="M12 8L17.6292 14.75H6.37083L12 8Z" fill="#949494" />
  </svg>
);

export const trendDownIconGrey = (): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    style={{ transform: "rotate(180deg)" }} // Rotate to make it downward
  >
    <rect width="24" height="24" rx="12" fill="#F6F6F6" />
    <path d="M12 8L17.6292 14.75H6.37083L12 8Z" fill="#949494" />
  </svg>
);

export const trendDownIconGreen = (): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    style={{ transform: "rotate(180deg)" }} // Rotate the entire SVG
  >
    <rect width="24" height="24" rx="12" fill="#F6F6F6" />
    <path d="M12 8L17.6292 14.75H6.37083L12 8Z" fill="#069C56" />
  </svg>
);

export const trendDownIcon = (): JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="12" fill="#F6F6F6" />
    <path d="M12 17L17.6292 10.25H6.37083L12 17Z" fill="#D3212C" />
  </svg>
);

export const assignIcon = (): JSX.Element => (
  <svg width="14" height="16" viewBox="0 0 14 16" fill="none">
    <path
      d="M13.115 0H.529C.212 0 0 .22 0 .55v14.28c0 .33.212.55.529.55h12.586c.317 0 .529-.22.529-.55V.55a.54.54 0 0 0-.53-.55zm-.53 14.28H1.059V1.1h11.528V14.28z"
      fill="#4F4F4F"
    />
    <path
      d="M7.35 8.239h3.702c.317 0 .529-.22.529-.55 0-.329-.212-.548-.53-.548h-3.7c-.318 0-.53.22-.53.549 0 .33.212.549.53.549zM3.225 9.118c.106.11.212.165.37.165.212 0 .265-.055.37-.165L6.082 6.92a.545.545 0 0 0 0-.77.498.498 0 0 0-.74 0L3.649 7.965l-.688-.823c-.211-.22-.529-.275-.74-.055-.212.22-.265.549-.053.769l1.057 1.263z"
      fill="#4F4F4F"
    />
  </svg>
);

export const greySuccessTickIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "15"}
    height={height || "15"}
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M7.05 13.6a6.55 6.55 0 1 0 0-13.1 6.55 6.55 0 0 0 0 13.1z"
      stroke="#4F4F4F"
    />
    <path
      d="M9.432 4.954a.233.233 0 0 0-.363 0L5.996 8.51 4.814 7.143a.233.233 0 0 0-.363 0 .33.33 0 0 0 0 .42L5.814 9.14a.233.233 0 0 0 .363 0L9.432 5.37a.33.33 0 0 0 0-.416z"
      fill="#4F4F4F"
      stroke="#4F4F4F"
      strokeWidth=".6"
    />
  </svg>
);

export const downloadIconOutlined = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.63 3.197a.767.767 0 0 0-.041.25c.015 1.263.012 2.528.01 3.785l-.002 1.433v1.316H8.462c-.483.002-.97.003-1.456 0 1.663 1.665 3.326 3.327 4.99 4.99a9162.49 9162.49 0 0 1 4.988-4.988c-.49.002-.983 0-1.473 0l-.834-.001h-.006c-.114-.001-.25-.01-.36-.016l-.116-.007-.797-.039V8.63c0-.466 0-.933-.002-1.402-.002-1.254-.004-2.516.01-3.774v-.03l.003-.029a.34.34 0 0 0-.041-.19 1.533 1.533 0 0 0-.278-.006l-.03.002h-.03c-.305 0-.598-.004-.884-.008a28.758 28.758 0 0 0-1.516.004zm3.002-.805.212-.815c.248.065.476.192.662.37l.016.017.016.016a2.033 2.033 0 0 1 .543 1.518c-.014 1.238-.012 2.475-.01 3.717l.002 1.081.45.001c.54.001 1.078.002 1.616 0a1.546 1.546 0 0 1 1.612.952 1.562 1.562 0 0 1-.474 1.817l-5.07 5.07a1.55 1.55 0 0 1-1.228.589 1.543 1.543 0 0 1-1.21-.605c-1.69-1.688-3.38-3.377-5.068-5.068a1.558 1.558 0 0 1-.46-1.818l.004-.01.005-.01a1.574 1.574 0 0 1 1.608-.918c.53.003 1.058.002 1.59 0h.474l.002-1.078c.002-1.254.005-2.5-.01-3.75a2.303 2.303 0 0 1 .281-1.148c.228-.4.65-.775 1.277-.803.582-.025 1.189-.017 1.764-.009.264.004.521.008.767.008.261-.016.524 0 .781.047l-.152.83z"
      fill="#4F4F4F"
    />
    <path
      d="M21.996 20.703v-2.98a.91.91 0 0 0-.045-.295 1 1 0 0 0-.98-.59h-.035c-.234.003-.468.006-.703.007-1.3.01-3.584-.005-4.884.013a1.033 1.033 0 0 0-.614.262c-.456.41-.874.86-1.31 1.294a1.824 1.824 0 0 1-2.84.013c-.435-.432-.878-.859-1.297-1.306a.815.815 0 0 0-.66-.28c-1.507.012-4 .022-5.51 0a1.034 1.034 0 0 0-1.073.595.904.904 0 0 0-.045.295v3.865c0 .095.013.188.041.278v.014c.241.713 1.139.59 1.717.59h11.21c1.701 0 4.395.049 6.1 0 .109.002.218-.012.324-.04h.014a.828.828 0 0 0 .503-.515c.043-.113.07-.23.082-.351 0-.038.007-.076.009-.114v-.036c0-.25-.001-.485-.004-.72z"
      stroke="#4F4F4F"
      strokeWidth="1.7"
      strokeMiterlimit="10"
    />
  </svg>
);

export const inProgressIcon = (): JSX.Element => (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none">
    <path
      d="M0.649589 7.01523C0.831417 7.17589 1.10914 7.15861 1.2698 6.97679L1.27689 6.96878V7.2767C1.27689 9.07256 1.97628 10.761 3.24622 12.0309C4.51604 13.3007 6.20445 14 8.0003 14C9.08509 14 10.163 13.7354 11.1177 13.235C12.0414 12.7509 12.8521 12.0466 13.4622 11.1981C13.6039 11.0012 13.559 10.7265 13.362 10.5849C13.165 10.4431 12.8903 10.4879 12.7487 10.685C12.2179 11.4231 11.5128 12.0357 10.7096 12.4567C9.88037 12.8914 8.94354 13.1212 8.0003 13.1212C4.77763 13.1212 2.15571 10.4993 2.15571 7.27659V6.96866L2.16292 6.97667C2.32358 7.15861 2.6013 7.17578 2.78312 7.01512C2.96507 6.85446 2.98223 6.57674 2.82157 6.39491L2.04574 5.51655C1.96232 5.42215 1.8424 5.36814 1.71641 5.36814C1.59043 5.36814 1.4705 5.42215 1.38709 5.51655L0.611255 6.39491C0.450481 6.57686 0.467646 6.85458 0.649589 7.01523Z"
      fill="#4F4F4F"
    />
    <path
      d="M2.63904 3.97006C2.83609 4.11172 3.11061 4.06698 3.25239 3.86993C3.78311 3.13198 4.48822 2.51932 5.2914 2.09822C6.12067 1.66351 7.05762 1.43373 8.00074 1.43373C11.2234 1.43373 13.8453 4.05565 13.8453 7.27832V7.58625L13.8381 7.57813C13.6775 7.3963 13.3997 7.37902 13.2179 7.53979C13.036 7.70045 13.0188 7.97817 13.1795 8.16L13.9553 9.03836C14.0388 9.13276 14.1586 9.18689 14.2846 9.18689C14.4106 9.18689 14.5307 9.13276 14.614 9.03836L15.3899 8.16C15.5506 7.97806 15.5334 7.70045 15.3515 7.53979C15.2679 7.46587 15.1641 7.4296 15.0607 7.4296C14.9392 7.4296 14.8181 7.47983 14.7312 7.57813L14.7242 7.58625V7.27832C14.7242 5.48236 14.0248 3.79407 12.7548 2.52413C11.485 1.25419 9.7966 0.554915 8.00074 0.554915C6.91607 0.554915 5.83803 0.819476 4.88335 1.31988C3.95979 1.80403 3.14906 2.50845 2.53892 3.35683C2.39725 3.55388 2.442 3.82839 2.63904 3.97006Z"
      fill="#4F4F4F"
    />
    <path
      d="M12.3356 6.15244C12.3658 6.03996 12.35 5.92004 12.2916 5.81911L11.4128 4.29686C11.3546 4.19593 11.2586 4.12235 11.1461 4.09214C11.0335 4.06205 10.9136 4.07773 10.8126 4.13609L10.1665 4.50912C9.90842 4.3075 9.62246 4.14204 9.31968 4.01914V3.27409C9.31968 3.0315 9.12298 2.83468 8.88028 2.83468H7.12264C6.88005 2.83468 6.68323 3.0315 6.68323 3.27409V4.01914C6.38045 4.14204 6.09449 4.3075 5.83646 4.50912L5.19027 4.13609C5.08946 4.07784 4.96943 4.06205 4.85694 4.09214C4.74434 4.12235 4.64834 4.19593 4.59009 4.29686L3.71128 5.81911C3.65303 5.92004 3.63724 6.03996 3.66733 6.15244C3.69754 6.26504 3.77124 6.36105 3.87205 6.41929L4.5196 6.79313C4.4974 6.95356 4.48619 7.11594 4.48619 7.27831C4.48619 7.44263 4.49763 7.60661 4.5204 7.76887L3.87205 8.14317C3.77112 8.20142 3.69754 8.29742 3.66733 8.41002C3.63724 8.52262 3.65303 8.64254 3.71128 8.74347L4.59009 10.2656C4.71139 10.4757 4.98018 10.5477 5.19027 10.4264L5.84069 10.0508C6.0977 10.251 6.38217 10.4153 6.68323 10.5375V11.2884C6.68323 11.531 6.87994 11.7278 7.12264 11.7278H8.88028C9.12298 11.7278 9.31968 11.531 9.31968 11.2884V10.5375C9.62063 10.4153 9.90522 10.251 10.1621 10.0508L10.8126 10.4264C11.0227 10.5478 11.2915 10.4757 11.4128 10.2656L12.2916 8.74347C12.3499 8.64254 12.3657 8.5225 12.3356 8.41002C12.3054 8.29742 12.2318 8.20142 12.1309 8.14317L11.4825 7.76887C11.5053 7.60661 11.5167 7.44263 11.5167 7.27831C11.5167 7.11594 11.5055 6.95368 11.4833 6.79313L12.1308 6.41929C12.2318 6.36105 12.3054 6.26504 12.3356 6.15244ZM8.00146 8.59654C7.27346 8.59654 6.68323 8.00631 6.68323 7.27831C6.68323 6.55031 7.27346 5.96009 8.00146 5.96009C8.72957 5.96009 9.31968 6.55031 9.31968 7.27831C9.31968 8.00631 8.72946 8.59654 8.00146 8.59654Z"
      fill="#4F4F4F"
    />
  </svg>
);

export const driftDirectionUpIcon = (
  <svg width="24.8" height="22.4" viewBox="0 0 31 28" fill="none">
    <title>Upward Direction</title>
    <rect x="0.5" y="0.5" width="29.6561" height="27" rx="3.5" fill="#F6F6F6" />
    <path
      d="M14.7198 5.25231L14.7189 5.25308L10.2502 9.74343C9.91548 10.0798 9.91672 10.6239 10.2532 10.9588C10.5896 11.2936 11.1337 11.2923 11.4685 10.9559L14.4687 7.94109L14.4687 22.1406C14.4687 22.6153 14.8534 23 15.3281 23C15.8027 23 16.1874 22.6153 16.1874 22.1406L16.1874 7.94113L19.1876 10.9559C19.5224 11.2923 20.0666 11.2936 20.403 10.9587C20.7394 10.6239 20.7406 10.0797 20.4059 9.74339L15.9372 5.25304L15.9364 5.25226C15.6004 4.91569 15.0546 4.91677 14.7198 5.25231Z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="0.6"
    />
    <rect
      x="0.5"
      y="0.5"
      width="29.6561"
      height="27"
      rx="3.5"
      stroke="#F6F6F6"
    />
  </svg>
);

export const driftDirectionDownIcon = (
  <svg width="24.8" height="22.4" viewBox="0 0 31 28" fill="none">
    <rect x="0.5" y="0.5" width="29.6561" height="27" rx="3.5" fill="#F6F6F6" />
    <title>Downward Direction</title>
    <path
      d="M14.7198 22.7477L14.7189 22.7469L10.2502 18.2566C9.91548 17.9202 9.91672 17.3761 10.2532 17.0412C10.5896 16.7064 11.1337 16.7077 11.4685 17.0441L14.4687 20.0589L14.4687 5.85937C14.4687 5.38474 14.8534 5 15.3281 5C15.8027 5 16.1874 5.38474 16.1874 5.85937L16.1874 20.0589L19.1876 17.0441C19.5224 16.7077 20.0666 16.7064 20.403 17.0413C20.7394 17.3761 20.7406 17.9203 20.4059 18.2566L15.9372 22.747L15.9364 22.7477C15.6004 23.0843 15.0546 23.0832 14.7198 22.7477Z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="0.6"
    />
    <rect
      x="0.5"
      y="0.5"
      width="29.6561"
      height="27"
      rx="3.5"
      stroke="#F6F6F6"
    />
  </svg>
);

export const driftDirectionBothIcon = (
  <svg width="33.6" height="22.4" viewBox="0 0 42 28" fill="none">
    <title>Both Directions</title>
    <rect x="0.5" y="0.5" width="40.3125" height="27" rx="3.5" fill="#F6F6F6" />
    <path
      d="M14.7198 5.25231L14.7189 5.25308L10.2502 9.74343C9.91548 10.0798 9.91672 10.6239 10.2532 10.9588C10.5896 11.2936 11.1337 11.2923 11.4685 10.9559L14.4687 7.94109L14.4687 22.1406C14.4687 22.6153 14.8534 23 15.3281 23C15.8027 23 16.1874 22.6153 16.1874 22.1406L16.1874 7.94113L19.1876 10.9559C19.5224 11.2923 20.0666 11.2936 20.403 10.9587C20.7394 10.6239 20.7406 10.0797 20.4059 9.74339L15.9372 5.25304L15.9364 5.25226C15.6004 4.91569 15.0546 4.91677 14.7198 5.25231Z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="0.6"
    />
    <path
      d="M26.5927 22.7477L26.5936 22.7469L31.0623 18.2566C31.397 17.9202 31.3958 17.3761 31.0593 17.0412C30.7229 16.7064 30.1788 16.7077 29.844 17.0441L26.8438 20.0589L26.8438 5.85936C26.8438 5.38474 26.4591 5 25.9844 5C25.5098 5 25.1251 5.38474 25.1251 5.85936L25.1251 20.0589L22.1249 17.0441C21.7901 16.7077 21.2459 16.7064 20.9095 17.0413C20.5731 17.3761 20.5719 17.9203 20.9066 18.2566L25.3753 22.747L25.3761 22.7477C25.7121 23.0843 26.2579 23.0832 26.5927 22.7477Z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="0.6"
    />
    <rect
      x="0.5"
      y="0.5"
      width="40.3125"
      height="27"
      rx="3.5"
      stroke="#F6F6F6"
    />
  </svg>
);

export const userWithTickIcon = (): JSX.Element => (
  <svg width="16" height="18" viewBox="0 0 16 18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 14.835H2.488a2.238 2.238 0 0 1-2.472-2.488 8.268 8.268 0 0 1 .607-3.374 2.613 2.613 0 0 1 2.2-1.767c.26-.01.52.046.753.163.6.276 1.149.661 1.763.88a3.971 3.971 0 0 0 3.419-.446c.106-.061.2-.136.31-.2.352-.2.644-.512 1.129-.423a2.394 2.394 0 0 1 1.637.883c.316.434.572.91.76 1.412.35 1.05.487 2.159.4 3.262a2.124 2.124 0 0 1-2.116 2.077c-1.46.035-2.92.008-4.38.008l.002.013z"
      fill="#D2D2D2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.05 3.551A3.542 3.542 0 1 1 6.528 0a3.512 3.512 0 0 1 3.524 3.551z"
      fill="#D2D2D2"
    />
    <mask
      id="o8xc21pbwa"
      maskUnits="userSpaceOnUse"
      x="7"
      y="10"
      width="9"
      height="8"
      fill="#000"
    >
      <path fill="#fff" d="M7 10h9v8H7z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.48 11.11a.413.413 0 0 1 .024.583l-4.086 4.425a.412.412 0 0 1-.595.012l-1.702-1.704a.413.413 0 0 1 .584-.583l1.398 1.4 3.794-4.11a.413.413 0 0 1 .583-.023z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.48 11.11a.413.413 0 0 1 .024.583l-4.086 4.425a.412.412 0 0 1-.595.012l-1.702-1.704a.413.413 0 0 1 .584-.583l1.398 1.4 3.794-4.11a.413.413 0 0 1 .583-.023z"
      fill="#D6D5D5"
    />
    <path
      d="m14.504 11.693-.735-.679.735.679zm-.024-.583-.678.734.678-.734zm-4.062 5.008-.734-.679.734.679zm-.295.132-.02-1 .02 1zm-.3-.12-.707.706.707-.706zm-1.702-1.704.707-.707-.707.707zm0-.583.707.707-.707-.707zm.584 0-.708.707.708-.707zm1.398 1.4-.707.706a1 1 0 0 0 1.442-.029l-.735-.678zm3.794-4.11-.735-.679.735.679zm1.341 1.238a1.413 1.413 0 0 0-.08-1.996l-1.356 1.47a.587.587 0 0 1-.033-.83l1.47 1.356zm-4.085 4.425 4.085-4.425-1.469-1.357-4.085 4.425 1.469 1.357zm-1.01.454c.384-.007.75-.171 1.01-.454l-1.47-1.357a.587.587 0 0 1 .42-.188l.04 2zm-1.027-.414c.272.272.643.422 1.027.414l-.04-2a.588.588 0 0 1 .427.173l-1.414 1.413zm-1.702-1.703 1.702 1.703 1.414-1.413-1.702-1.704-1.414 1.414zm0-1.998a1.413 1.413 0 0 0 0 1.998l1.414-1.414c.23.23.23.602 0 .83l-1.414-1.414zm1.998 0a1.413 1.413 0 0 0-1.998 0l1.414 1.415a.587.587 0 0 1-.83 0l1.414-1.414zm1.398 1.4-1.398-1.4-1.415 1.415 1.399 1.399 1.414-1.414zm2.352-4.08-3.794 4.109 1.47 1.356 3.794-4.109-1.47-1.357zm1.997-.08a1.413 1.413 0 0 0-1.997.08l1.47 1.356a.587.587 0 0 1-.83.033l1.357-1.47z"
      fill="#fff"
      mask="url(#o8xc21pbwa)"
    />
  </svg>
);

export const TickInFilledRectangleIcon = (): JSX.Element => (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none">
    <path
      d="M13.818 0H1.232C.915 0 .703.22.703.55v14.28c0 .33.212.55.529.55h12.586c.317 0 .529-.22.529-.55V.55a.54.54 0 0 0-.53-.55z"
      fill="#D6D5D5"
    />
    <path
      d="M6.187 9.75a.82.82 0 0 0 .616.25c.352 0 .44-.083.616-.25l3.52-3.333a.776.776 0 0 0 0-1.167.884.884 0 0 0-1.232 0L6.891 8 5.747 6.75c-.352-.333-.88-.417-1.232-.083-.352.333-.44.833-.088 1.166l1.76 1.917z"
      fill="#fff"
    />
  </svg>
);

export const leftArrowIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "34"}
    height={height || "20"}
    viewBox="0 0 34 20"
    fill="none"
  >
    <path
      d="m1.448 10.968.001.002 7.983 7.604c.598.57 1.566.568 2.161-.005a1.419 1.419 0 0 0-.005-2.068l-5.36-5.105h25.244c.844 0 1.528-.655 1.528-1.463 0-.807-.684-1.462-1.528-1.462H6.228l5.36-5.106c.598-.57.6-1.495.005-2.068a1.577 1.577 0 0 0-2.16-.005L1.448 8.897l-.001.001a1.42 1.42 0 0 0 0 2.07z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth=".2"
    />
  </svg>
);

export const rightArrowIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "34"}
    height={height || "20"}
    viewBox="0 0 34 20"
    fill="none"
  >
    <path
      d="m32.552 10.968-.002.002-7.982 7.604a1.577 1.577 0 0 1-2.161-.005 1.419 1.419 0 0 1 .005-2.068l5.36-5.105H2.528C1.684 11.396 1 10.74 1 9.933c0-.807.684-1.462 1.528-1.462h25.244l-5.36-5.106a1.418 1.418 0 0 1-.005-2.068 1.577 1.577 0 0 1 2.16-.005l7.984 7.605.001.001a1.42 1.42 0 0 1 0 2.07z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth=".2"
    />
  </svg>
);

export const flatIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect width="24" height="24" rx="12" fill="#F6F6F6" />
    <path fill="#959596" d="M6 11h12v2H6z" />
  </svg>
);

export const checkMarkSvg = (): JSX.Element => (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none">
    <path
      d="M6.08527 7.66198C7.90989 5.83027 9.69686 4.0393 11.4827 2.24042C11.9336 1.78758 12.369 1.31778 12.8243 0.866076C12.9179 0.75149 13.0349 0.659301 13.1672 0.596045C13.2995 0.532789 13.4438 0.5 13.5898 0.5C13.7358 0.5 13.8801 0.532789 14.0124 0.596045C14.1447 0.659301 14.2618 0.75149 14.3553 0.866076C14.7881 1.29853 15.2157 1.73701 15.6382 2.18155C15.7517 2.27633 15.8431 2.39578 15.9057 2.53125C15.9683 2.66672 16.0005 2.81481 16 2.96462C15.9995 3.11443 15.9662 3.26217 15.9027 3.39717C15.8391 3.53218 15.7469 3.651 15.6327 3.74494C12.7309 6.72836 9.82573 9.70955 6.91727 12.6885C6.82386 12.8079 6.70534 12.9043 6.57053 12.9705C6.43571 13.0368 6.28804 13.0711 6.13845 13.0711C5.98885 13.0711 5.84116 13.0368 5.70634 12.9705C5.57152 12.9043 5.45304 12.8079 5.35963 12.6885C3.70377 10.9979 2.05123 9.30387 0.402015 7.6065C0.278308 7.51248 0.177631 7.39039 0.107879 7.24989C0.0381278 7.10939 0.0012102 6.95429 2.92469e-05 6.79675C-0.00115171 6.63921 0.0334468 6.48353 0.101084 6.34195C0.168721 6.20038 0.26756 6.0768 0.389844 5.98085C0.802701 5.54688 1.22072 5.11857 1.64391 4.69592C1.73792 4.57645 1.85726 4.48036 1.99292 4.4149C2.12858 4.34945 2.27701 4.31635 2.42703 4.3181C2.57704 4.31984 2.72473 4.3564 2.8589 4.42499C2.99307 4.49358 3.11023 4.5924 3.20155 4.71402C4.07896 5.60837 4.94862 6.51065 5.82271 7.4084C5.91798 7.50462 6.0188 7.59745 6.08527 7.66198Z"
      fill="#478848"
    />
  </svg>
);

export const dvSumnLogo = (
  <svg width="85" height="45" viewBox="0 0 107 57" fill="none">
    <path
      d="m46.861 27.112 10.15-7.578 12.16 19.137S91.191 8.281 95.066 2.94a6.206 6.206 0 0 1 3.97-2.513c.157-.031.34.014.47-.122h1.287c.036.08.111.059.175.067a6.317 6.317 0 0 1 5.36 4.73c.026.274.092.542.194.797v1.415c-.08.242-.134.49-.16.744a6.628 6.628 0 0 1-1.08 2.335c-3.225 4.453-29.302 40.45-31.393 43.358a6.328 6.328 0 0 1-10.735-.46c-2.099-3.515-16.291-26.177-16.291-26.177l-.002-.002z"
      fill="#54CCD1"
    />
    <path
      d="M21.13 36.725s3.403 0 4.784.015a7.256 7.256 0 0 0 6.012-2.85 8.162 8.162 0 0 0 1.527-2.741 8.338 8.338 0 0 0 .273-3.796 7.872 7.872 0 0 0-7.785-6.833c-1.483 0-4.808-.008-4.808-.008v16.212h-.003zm25.86-9.422c-1.743-2.564-3.383-5.036-5.246-7.516-.643-.862-1.3-1.723-2.028-2.517-3.425-3.71-8.539-4.345-11.3-4.306-5.134.02-15.794 0-15.794 0l.027 30.923s11.129.012 16.082-.046a9.704 9.704 0 0 0 7.681-3.556c.769-.91 1.45-1.888 2.037-2.924a6.236 6.236 0 0 1 5.523-3.182 6.344 6.344 0 0 1 6.215 5.613 6.316 6.316 0 0 1-.792 3.922 26.674 26.674 0 0 1-5.223 6.729 23.014 23.014 0 0 1-10.61 5.66 18.518 18.518 0 0 1-4.105.451c-7.662-.009-15.323-.012-22.984-.01a6.33 6.33 0 0 1-4.089-1.363 6.2 6.2 0 0 1-2.308-3.845A4.911 4.911 0 0 1 0 50.723V6.168c0-.075.015-.247.023-.32A6.28 6.28 0 0 1 5.747.304h24.604c3.249.173 6.446.893 9.455 2.129a24.928 24.928 0 0 1 10.43 7.67c1.808 2.252 3.475 4.602 5.11 6.982.576.841 1.199 1.653 1.714 2.537.088.157.148.301.162.328a6.13 6.13 0 0 1 .579 4.202 6.21 6.21 0 0 1-2.37 3.766 6.575 6.575 0 0 1-4.977 1.24 7.648 7.648 0 0 1-3.462-1.855h-.001z"
      fill="#FF6915"
    />
  </svg>
);

export const helpIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 5a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm.632 10.209a.932.932 0 1 1-1.863-.056.932.932 0 0 1 1.863.056zm1.521-3.979a4.51 4.51 0 0 1-.793.71l-.41.281c-.183.135-.319.324-.388.54-.04.193-.063.388-.066.584a.127.127 0 0 1-.14.122H11.13c-.128 0-.144-.075-.14-.113a2.56 2.56 0 0 1 .309-1.29 4.1 4.1 0 0 1 1.109-.95c.115-.084.215-.187.296-.304.147-.175.235-.393.25-.622a1.106 1.106 0 0 0-.228-.713.902.902 0 0 0-.806-.355.882.882 0 0 0-.794.462 1.525 1.525 0 0 0-.137.853H9.473a2.358 2.358 0 0 1 .865-2.139 2.597 2.597 0 0 1 1.493-.389 3.014 3.014 0 0 1 1.935.556 1.936 1.936 0 0 1 .77 1.644c-.003.407-.137.8-.383 1.124z"
      fill="#4F4F4F"
      opacity=".6"
    />
  </svg>
);

export const darkFilledFilterIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "19"}
    height={height || "19"}
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.695.4H16.99v.82l.001-.82a1.611 1.611 0 0 1 1.14 2.748l-5.859 5.858v8.3a1.61 1.61 0 0 1-2.533 1.318L7.101 16.78a1.612 1.612 0 0 1-.687-1.32V9.006L.556 3.148A1.61 1.61 0 0 1 1.695.4z"
      fill="#4F4F4F"
    />
  </svg>
);

export const importIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "19"}
    height={height || "22"}
    viewBox="0 0 19 22"
    fill="none"
  >
    <path
      d="M18 20C18 20.5523 17.5523 21 17 21H1V17.0976H1.94439V20.0244H16.0554C16.6077 20.0244 17.0554 19.5767 17.0554 19.0244V7.05482L12.1384 1.97555H1.94439V9.29265H1V1H12.5281L18 6.65253V20Z"
      fill="#4F4F4F"
      stroke="#4F4F4F"
      strokeWidth="0.65"
      strokeLinejoin="round"
    />
    <path
      d="M17.5277 7.34147H11.8611V1.48779H12.8055V6.36574H17.5277V7.34147Z"
      fill="#4F4F4F"
      stroke="#4F4F4F"
      strokeWidth="0.65"
      strokeLinejoin="round"
    />
    <path
      d="M9.08106 17.2441L8.41406 16.555L11.6666 13.1954L8.41406 9.8355L9.08106 9.14648L13.0006 13.1954L9.08106 17.2441Z"
      fill="#4F4F4F"
      stroke="#4F4F4F"
      strokeWidth="0.65"
      strokeLinejoin="round"
    />
    <path
      d="M1 12.7073H12.3333V13.6828H1V12.7073Z"
      fill="#4F4F4F"
      stroke="#4F4F4F"
      strokeWidth="0.65"
      strokeLinejoin="round"
    />
  </svg>
);

export const cursorSvg = (): JSX.Element => (
  <svg
    width="14"
    height="14"
    style={{ marginBottom: "4px" }}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#nj1abik70a)" fill="#fff">
      <path d="m15.843 13.533-3.184-3.185 2.271-1.312a.535.535 0 0 0-.069-.96l-10.13-4.04a.535.535 0 0 0-.695.694l4.04 10.131a.535.535 0 0 0 .96.07l1.313-2.272 3.184 3.184a.535.535 0 0 0 .756 0l1.554-1.554a.535.535 0 0 0 0-.756zM2.349 1.592a.535.535 0 0 0-.757.757l1.19 1.189a.533.533 0 0 0 .756 0 .535.535 0 0 0 0-.757L2.349 1.59zM2.752 5.291a.535.535 0 0 0-.536-.535H.536a.535.535 0 0 0 0 1.07h1.68c.296 0 .536-.24.536-.535zM2.535 6.943 1.346 8.132a.535.535 0 0 0 .757.756L3.292 7.7a.535.535 0 0 0-.757-.756zM5.29 2.752c.296 0 .536-.24.536-.535V.535a.535.535 0 0 0-1.07 0v1.682c0 .295.24.535.535.535zM7.32 3.448a.533.533 0 0 0 .379-.156l1.188-1.19a.535.535 0 0 0-.756-.756L6.94 2.535a.535.535 0 0 0 .38.913z" />
    </g>
    <defs>
      <clipPath id="nj1abik70a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const commentIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "16"}
    height={height || "16"}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.684 14.667H1.621l.751-.759c.405-.408.661-.941.728-1.515A5.766 5.766 0 0 1 .855 9.715a5.292 5.292 0 0 1-.15-3.361 6.578 6.578 0 0 1 2.497-3.52A8.11 8.11 0 0 1 8.025 1.34a8.038 8.038 0 0 1 5.574 1.918 5.768 5.768 0 0 1 1.77 3.066 5.806 5.806 0 0 1-.347 3.531 5.92 5.92 0 0 1-1.427 2.002 8.019 8.019 0 0 1-5.57 1.925c-.85 0-1.697-.109-2.52-.323a3.908 3.908 0 0 1-2.82 1.207zM8.024 2.23c-3.64 0-5.873 2.19-6.472 4.362a4.511 4.511 0 0 0 .201 2.994 4.456 4.456 0 0 0 2.03 2.193l.22.133-.007.259a3.523 3.523 0 0 1-.35 1.45 3.117 3.117 0 0 0 1.379-.954l.186-.222.275.08a9.03 9.03 0 0 0 2.538.362c4.53 0 6.594-2.769 6.594-5.34 0-.687-.145-1.366-.423-1.993a4.884 4.884 0 0 0-1.19-1.644 7.185 7.185 0 0 0-4.98-1.686v.006z"
      fill="#fff"
      stroke="#fff"
      strokeWidth=".7"
    />
    <path
      d="M5.05 8.804c.58 0 1.05-.475 1.05-1.06 0-.585-.47-1.06-1.05-1.06-.579 0-1.049.475-1.049 1.06 0 .585.47 1.06 1.05 1.06zM7.85 8.804c.58 0 1.05-.475 1.05-1.06 0-.585-.47-1.06-1.05-1.06-.58 0-1.05.475-1.05 1.06 0 .585.47 1.06 1.05 1.06zM10.651 8.804c.58 0 1.05-.475 1.05-1.06 0-.585-.47-1.06-1.05-1.06-.58 0-1.05.475-1.05 1.06 0 .585.47 1.06 1.05 1.06z"
      fill="#fff"
    />
  </svg>
);

export const importSubmittedSvg = (
  <svg width="127" height="127" viewBox="0 0 127 127" fill="none">
    <circle cx="63.5" cy="63.5" r="63.5" fill="#CDE2F7" />
    <mask
      id="26lz8ztzha"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="127"
      height="127"
    >
      <circle cx="63.5" cy="63.5" r="63.5" fill="#D9D9D9" />
    </mask>
    <g mask="url(#26lz8ztzha)">
      <circle cx="63.5" cy="63.5" r="63.5" fill="#CDE2F7" />
      <mask
        id="pohj64koab"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="127"
        height="127"
      >
        <circle cx="63.5" cy="63.5" r="63.5" fill="#D9D9D9" />
      </mask>
    </g>
    <path
      d="M91.332 91.567a1 1 0 0 1-1 1H39V80.554h2.907v9.01h45.517a1 1 0 0 0 1-1V49.639L73.288 34.003h-31.38v49.379H39V31h35.487l16.845 17.4v43.167z"
      fill="#fff"
      stroke="#fff"
      strokeWidth="2.65"
      strokeLinejoin="round"
    />
    <path
      d="M89.874 50.521H72.43v-18.02h2.907v15.017h14.537v3.003z"
      fill="#fff"
      stroke="#fff"
      strokeWidth="2.65"
      strokeLinejoin="round"
    />
    <path
      d="M39.509 34H39l.5-.5.009.5H71.5l1 16.5h18l-1.5 38L40.5 91l-.991-57z"
      fill="#fff"
    />
    <path
      d="M80.5 99.75c8.975 0 16.25-7.275 16.25-16.25S89.475 67.25 80.5 67.25 64.25 74.525 64.25 83.5s7.275 16.25 16.25 16.25z"
      fill="#428BCA"
    />
    <path
      d="M85.992 78.668a.539.539 0 0 0-.836 0l-7.085 8.194-2.722-3.15a.539.539 0 0 0-.836 0 .762.762 0 0 0 0 .967l3.142 3.633a.539.539 0 0 0 .835 0l7.502-8.678a.762.762 0 0 0 0-.966z"
      fill="#fff"
      stroke="#fff"
    />
  </svg>
);

export const checkedListIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "20"}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M11.317 4.526H16.9c.479 0 .798-.286.798-.714s-.32-.713-.798-.713h-5.584c-.479 0-.798.285-.798.713s.32.714.798.714zM3.549 5.668a.613.613 0 0 0 .48.214c.276 0 .344-.072.482-.214l2.748-2.855a.708.708 0 0 0 0-.999.647.647 0 0 0-.962 0L4.099 4.17l-.894-1.07c-.274-.286-.687-.357-.961-.072-.275.286-.344.714-.07 1l1.375 1.64zM11.317 10.926H16.9c.479 0 .798-.286.798-.714s-.32-.713-.798-.713h-5.584c-.479 0-.798.285-.798.713s.32.714.798.714zM3.549 12.067a.613.613 0 0 0 .48.214c.276 0 .344-.07.482-.214l2.748-2.854a.708.708 0 0 0 0-.999.647.647 0 0 0-.962 0L4.099 10.57l-.894-1.07c-.274-.286-.687-.357-.961-.072-.275.286-.344.714-.07 1l1.375 1.64zM11.317 17.426H16.9c.479 0 .798-.286.798-.714s-.32-.713-.798-.713h-5.584c-.479 0-.798.285-.798.713s.32.714.798.714zM3.549 18.567a.613.613 0 0 0 .48.215c.276 0 .344-.072.482-.215l2.748-2.854a.708.708 0 0 0 0-.999.647.647 0 0 0-.962 0L4.099 17.07l-.894-1.07c-.274-.286-.687-.357-.961-.072-.275.286-.344.714-.07 1l1.375 1.64z"
      fill="#fff"
    />
  </svg>
);

export const importSubmittedFailedSvg = (
  <svg width="127" height="127" viewBox="0 0 127 127" fill="none">
    <circle cx="63.5" cy="63.5" r="63.5" fill="#CDE2F7" />
    <mask
      id="2r490n4twa"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="127"
      height="127"
    >
      <circle cx="63.5" cy="63.5" r="63.5" fill="#D9D9D9" />
    </mask>
    <g mask="url(#2r490n4twa)">
      <circle cx="63.5" cy="63.5" r="63.5" fill="#FBECEA" />
      <mask
        id="9studhnqqb"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="127"
        height="127"
      >
        <circle cx="63.5" cy="63.5" r="63.5" fill="#FBECEA" />
      </mask>
    </g>
    <path
      d="M91.332 91.567a1 1 0 0 1-1 1H39V80.554h2.907v9.01h45.517a1 1 0 0 0 1-1V49.639L73.288 34.003h-31.38v49.379H39V31h35.487l16.845 17.4v43.167z"
      fill="#fff"
      stroke="#fff"
      strokeWidth="2.65"
      strokeLinejoin="round"
    />
    <path
      d="M89.874 50.522H72.43v-18.02h2.907v15.016h14.537v3.004z"
      fill="#fff"
      stroke="#fff"
      strokeWidth="2.65"
      strokeLinejoin="round"
    />
    <path
      d="M39.509 34H39l.5-.5.009.5H71.5l1 16.5h18l-1.5 38L40.5 91l-.991-57z"
      fill="#fff"
    />
    <path
      d="M84.999 71.666A13.333 13.333 0 1 1 71.665 85 13.348 13.348 0 0 1 85 71.666zM79.857 88.43a1.213 1.213 0 1 0 1.714 1.714l3.428-3.43 3.428 3.43a1.212 1.212 0 0 0 1.713-1.714l-3.427-3.43 3.428-3.428a1.212 1.212 0 1 0-1.714-1.714l-3.428 3.429-3.428-3.43a1.21 1.21 0 0 0-2.084.853 1.212 1.212 0 0 0 .37.862L83.285 85l-3.428 3.429z"
      fill="#D15B47"
    />
  </svg>
);

export const starIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "18"}
    height={height || "16"}
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.854 15.833 5.208 9.98.667 6.042l6-.521L9 0l2.333 5.52 6 .522-4.541 3.937 1.354 5.854L9 12.73l-5.146 3.104z"
      fill="#F1C911"
    />
  </svg>
);

export const starIconOutlined = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "18"}
    height={height || "16"}
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.73 13.23 9 11.27l3.27 1.98-.874-3.708 2.875-2.5-3.792-.334L9 3.208l-1.48 3.48-3.79.333 2.874 2.5-.875 3.708zm-1.876 2.603L5.208 9.98.667 6.042l6-.521L9 0l2.333 5.52 6 .522-4.541 3.937 1.354 5.854L9 12.73l-5.146 3.104z"
      fill="#F1C911"
    />
  </svg>
);

export const twoStarsIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "20"}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7 12.5 21 8.8l2.125.175-4.725 4.05 1.425 6.15-1.85-1.125L16.7 12.5zm-2.325-7.225-1.425-3.35.8-1.925 2.3 5.425-1.675-.15zM4.325 19l1.625-7.025L.5 7.25l7.2-.625L10.5 0l2.8 6.625 7.2.625-5.45 4.725L16.675 19 10.5 15.275 4.325 19z"
      fill="#428BCA"
    />
  </svg>
);

export const guideBookIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "20"}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5.833 15h8.334a2.5 2.5 0 0 0 2.5-2.5V4.167a2.5 2.5 0 0 0-2.5-2.5H5.833a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5h10a.833.833 0 0 0 0-1.666h-10a.833.833 0 1 1 0-1.667zM5 4.167a.833.833 0 0 1 .833-.834h8.334a.833.833 0 0 1 .833.834V12.5a.833.833 0 0 1-.833.833H5.833c-.283 0-.565.049-.833.143v-9.31z"
      fill="#fff"
    />
    <path
      d="M10 11.667a.833.833 0 0 0 .833-.834v-2.5a.833.833 0 1 0-1.667 0v2.5a.833.833 0 0 0 .834.834zM10 6.667A.833.833 0 1 0 10 5a.833.833 0 0 0 0 1.667z"
      fill="#fff"
    />
  </svg>
);

export const playIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "20"}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 16.944a6.944 6.944 0 1 0 0-13.889 6.944 6.944 0 0 0 0 13.89z"
      stroke="#fff"
      strokeWidth="1.4"
    />
    <path
      d="M8.611 8.445v3.666a.278.278 0 0 0 .412.243l-.412-3.91zm0 0a.278.278 0 0 1 .413-.244l3.3 1.834-3.713-1.59zm2.915 1.833-2.315 1.285V8.992l2.315 1.286zM9.211 8.443v.002-.002z"
      fill="#fff"
      stroke="#fff"
      strokeWidth="1.2"
    />
    <mask id="2mxz8yovqa" fill="#fff">
      <path d="m12.189 10.278-3.3-1.833v3.666l3.3-1.833zm.556 0a.55.55 0 0 1-.285.486l-3.301 1.833a.554.554 0 0 1-.826-.486V8.445a.556.556 0 0 1 .826-.486l3.3 1.833a.55.55 0 0 1 .287.486h-.002z" />
    </mask>
    <path
      d="m12.189 10.278-3.3-1.833v3.666l3.3-1.833zm.556 0a.55.55 0 0 1-.285.486l-3.301 1.833a.554.554 0 0 1-.826-.486V8.445a.556.556 0 0 1 .826-.486l3.3 1.833a.55.55 0 0 1 .287.486h-.002z"
      fill="#fff"
    />
    <path
      d="m12.189 10.278.583 1.05 1.888-1.05-1.888-1.049-.583 1.05zm-3.3-1.833.583-1.05-1.783-.99v2.04h1.2zm0 3.666h-1.2v2.04l1.783-.99-.583-1.05zm3.856-1.833v-1.2h-1.208l.007 1.208 1.2-.008zm-.285.486-.579-1.052-.004.003.582 1.049zm-3.301 1.833-.583-1.049.583 1.049zm-.826-.486h1.2-1.2zm0-3.666h1.2v-.001h-1.2zm.826-.486-.583 1.048.583-1.048zm3.3 1.833-.583 1.049.008.005.575-1.054zm.287.486v1.2h1.192l.008-1.193-1.2-.007zm.026-1.049-3.3-1.833-1.166 2.098 3.3 1.833 1.166-2.098zm-5.083-.784v3.666h2.4V8.445h-2.4zm1.783 4.716 3.3-1.834-1.166-2.098-3.3 1.834 1.166 2.098zm2.072-2.875a.65.65 0 0 1 .09-.333l2.07 1.215c.16-.272.242-.582.24-.898l-2.4.016zm.09-.333a.65.65 0 0 1 .247-.24l1.157 2.102a1.75 1.75 0 0 0 .666-.647l-2.07-1.215zm.243-.238-3.3 1.833 1.165 2.098 3.3-1.833-1.165-2.098zm-3.301 1.833a.644.644 0 0 1 .32-.08l-.028 2.399c.305.004.607-.073.874-.221l-1.166-2.098zm.32-.08a.645.645 0 0 1 .32.088l-1.217 2.069c.263.155.563.238.869.242l.029-2.4zm.32.088a.645.645 0 0 1 .232.236l-2.083 1.191c.152.265.37.487.634.642l1.217-2.069zm.232.236a.645.645 0 0 1 .085.32h-2.4c0 .305.08.606.232.871l2.083-1.192zm.085.32V8.444h-2.4v3.666h2.4zm0-3.668c0 .112-.029.222-.084.32l-2.085-1.19a1.756 1.756 0 0 0-.23.872l2.4-.002zm-.084.32A.644.644 0 0 1 9.216 9L7.998 6.93a1.756 1.756 0 0 0-.634.643l2.085 1.19zM9.216 9a.644.644 0 0 1-.32.089l-.029-2.4a1.755 1.755 0 0 0-.869.242L9.216 9zm-.32.089a.644.644 0 0 1-.32-.082L9.742 6.91a1.755 1.755 0 0 0-.875-.221l.03 2.4zm-.32-.081 3.3 1.833 1.166-2.098-3.3-1.833-1.166 2.098zm3.308 1.838a.651.651 0 0 1-.248-.24l2.067-1.22a1.75 1.75 0 0 0-.67-.647l-1.149 2.107zm-.248-.24a.65.65 0 0 1-.09-.335l2.4.014a1.75 1.75 0 0 0-.243-.9l-2.067 1.22zm1.11-1.528h-.002v2.4h.002v-2.4z"
      fill="#fff"
      mask="url(#2mxz8yovqa)"
    />
  </svg>
);

export const giftIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "18"}
    height={height || "18"}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M15.594 4.75h-1.908c.295-.392.47-.879.47-1.406A2.346 2.346 0 0 0 11.812 1c-.778 0-1.352.279-1.806.878-.38.5-.658 1.2-1.006 2.084-.348-.884-.626-1.583-1.006-2.084C7.54 1.278 6.966 1 6.188 1a2.346 2.346 0 0 0-2.344 2.344c0 .527.175 1.014.47 1.406H2.406C1.631 4.75 1 5.38 1 6.156v.938c0 .61.392 1.132.938 1.325v7.175c0 .775.63 1.406 1.406 1.406h11.312c.776 0 1.406-.63 1.406-1.406V8.419c.546-.193.938-.714.938-1.325v-.938c0-.775-.63-1.406-1.406-1.406zM9.86 4.336c.719-1.822.992-2.399 1.953-2.399.775 0 1.406.631 1.406 1.407 0 .775-.631 1.406-1.406 1.406H9.695l.164-.414zM6.188 1.937c.96 0 1.233.577 1.952 2.399l.164.414H6.187c-.775 0-1.406-.63-1.406-1.406 0-.776.631-1.406 1.407-1.406zm.937 14.126H3.344a.47.47 0 0 1-.469-.47V8.5h4.25v7.563zm0-8.5H2.406a.47.47 0 0 1-.469-.47v-.937a.47.47 0 0 1 .47-.468h4.718v1.875zm2.813 8.5H8.062V5.688h1.876v10.375zm5.187-.47a.47.47 0 0 1-.469.47h-3.781V8.5h4.25v7.094zm.938-8.5a.47.47 0 0 1-.47.47h-4.718V5.688h4.719a.47.47 0 0 1 .469.468v.938z"
      fill="#fff"
      stroke="#fff"
      strokeWidth=".5"
    />
  </svg>
);

export const codeIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "19"}
    height={height || "14"}
    viewBox="0 0 19 14"
    fill="none"
  >
    <path
      d="M18.4255 6.56298L14.3989 2.53746C14.3421 2.47136 14.2715 2.41703 14.1915 2.37789C14.1114 2.33874 14.0236 2.31562 13.9337 2.30996C13.8437 2.30431 13.7535 2.31624 13.6686 2.34502C13.5838 2.3738 13.5061 2.41881 13.4406 2.47722C13.375 2.53564 13.323 2.60619 13.2877 2.68447C13.2523 2.76276 13.2346 2.84708 13.2354 2.93215C13.2362 3.01723 13.2556 3.10123 13.2925 3.17888C13.3293 3.25654 13.3827 3.32618 13.4494 3.38345L17.0509 6.98777L13.4494 10.5921C13.3455 10.7131 13.2938 10.8667 13.3048 11.0222C13.3158 11.1776 13.3886 11.3234 13.5086 11.4304C13.6286 11.5373 13.7871 11.5975 13.9521 11.599C14.1172 11.6004 14.2768 11.5429 14.3989 11.4381L18.4255 7.41257C18.5406 7.29781 18.6048 7.14579 18.6048 6.98777C18.6048 6.82975 18.5406 6.67773 18.4255 6.56298Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5641 2.04104C13.6895 1.9985 13.8223 1.98101 13.9545 1.98931C14.0867 1.99762 14.2163 2.03161 14.3352 2.08979C14.4501 2.14597 14.5532 2.22382 14.6379 2.31963L18.6563 6.33694C18.6563 6.33692 18.6563 6.33695 18.6563 6.33694C18.8309 6.511 18.9316 6.74549 18.9316 6.99301C18.9316 7.24049 18.831 7.4749 18.6564 7.64895C18.6564 7.649 18.6565 7.6489 18.6564 7.64895L14.6213 11.683L14.612 11.6911C14.4282 11.8488 14.1915 11.9328 13.9497 11.9307C13.7078 11.9286 13.4726 11.8405 13.2917 11.6794C13.1104 11.5178 12.9966 11.2937 12.9794 11.0504C12.9623 10.8069 13.0436 10.5691 13.2021 10.3846L13.2101 10.3752L16.5897 6.99301L13.2267 3.6274C13.1309 3.54274 13.0527 3.43984 12.9978 3.32406C12.9409 3.20406 12.9105 3.07344 12.9092 2.94057C12.9079 2.8077 12.9357 2.67651 12.9904 2.55544C13.0449 2.43445 13.1248 2.32683 13.2237 2.23866C13.3226 2.15053 13.4387 2.08358 13.5641 2.04104ZM13.9135 2.64109C13.8658 2.63809 13.8181 2.64447 13.7739 2.65949C13.7296 2.67451 13.6903 2.69758 13.6581 2.72627C13.626 2.75492 13.6017 2.78841 13.5856 2.824C13.5696 2.85949 13.5618 2.89694 13.5622 2.93421C13.5626 2.9715 13.5711 3.00888 13.5878 3.04419C13.6046 3.07959 13.6296 3.11277 13.6625 3.14096L13.6719 3.14907L17.5128 6.99301L13.691 10.8178C13.6461 10.8738 13.6263 10.94 13.6308 11.0044C13.6356 11.072 13.6674 11.1395 13.7261 11.1918C13.7854 11.2446 13.867 11.2769 13.9553 11.2777C14.0399 11.2784 14.119 11.2501 14.1787 11.2021L18.195 7.18688C18.2506 7.13144 18.2786 7.06151 18.2786 6.99301C18.2786 6.92451 18.251 6.85494 18.1953 6.7995L14.1596 2.76486L14.1516 2.75545C14.1244 2.7238 14.0895 2.69657 14.0484 2.67647C14.0072 2.65635 13.9613 2.64409 13.9135 2.64109Z"
      fill="#428BCA"
    />
    <path
      d="M6.33672 10.5903L2.73523 6.98594L6.33672 3.38162C6.40297 3.32422 6.45597 3.25456 6.49244 3.17698C6.5289 3.0994 6.54803 3.01557 6.54865 2.93071C6.54926 2.84584 6.53135 2.76177 6.49601 2.68373C6.46068 2.60569 6.40869 2.53535 6.34328 2.4771C6.27787 2.41886 6.20044 2.37395 6.11583 2.34518C6.03122 2.31641 5.94123 2.3044 5.85148 2.30989C5.76173 2.31538 5.67414 2.33826 5.59418 2.3771C5.51421 2.41593 5.44358 2.4699 5.38669 2.53563L1.36012 6.56475C1.24609 6.67931 1.18262 6.83057 1.18262 6.98774C1.18262 7.14491 1.24609 7.29617 1.36012 7.41073L5.38723 11.4363C5.50933 11.5411 5.6689 11.5986 5.83399 11.5971C5.99908 11.5957 6.1575 11.5355 6.27754 11.4285C6.39757 11.3216 6.47037 11.1758 6.48134 11.0203C6.49231 10.8649 6.44066 10.7113 6.33672 10.5903Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83286 1.98921C5.96472 1.98114 6.09719 1.99875 6.22224 2.04127C6.34732 2.0838 6.46303 2.1506 6.56172 2.23848C6.66045 2.3264 6.74016 2.43368 6.79477 2.55428C6.8494 2.67495 6.87742 2.80574 6.87646 2.93832C6.8755 3.07089 6.84558 3.20126 6.78924 3.32113C6.73477 3.43702 6.65702 3.54014 6.56155 3.62511L3.19813 6.99118L6.56899 10.3647L6.33803 10.5955L6.58572 10.3828C6.7442 10.5673 6.82554 10.8051 6.80835 11.0486C6.79117 11.2919 6.67741 11.516 6.49605 11.6776C6.31522 11.8387 6.08001 11.9268 5.83813 11.9289C5.59627 11.931 5.35956 11.847 5.17584 11.6892L5.16646 11.6812L1.13061 7.64692C0.957615 7.47311 0.857422 7.2392 0.857422 6.99298C0.857422 6.74676 0.957027 6.51344 1.13002 6.33964L5.14965 2.31745C5.2346 2.22195 5.33788 2.14445 5.45285 2.08861C5.57167 2.03091 5.701 1.99728 5.83286 1.98921ZM6.09678 10.816L2.27496 6.99118L6.11537 3.14775L6.12424 3.14006C6.15682 3.11183 6.18164 3.07867 6.19826 3.04332C6.21484 3.00803 6.22319 2.97073 6.22346 2.93358C6.22373 2.89643 6.21592 2.85907 6.19989 2.82366C6.18382 2.78817 6.15955 2.75479 6.12746 2.72621C6.09533 2.6976 6.05619 2.67458 6.01204 2.65957C5.96787 2.64456 5.92037 2.63814 5.87273 2.64105C5.82509 2.64397 5.77924 2.65609 5.73813 2.67606C5.69704 2.69602 5.66213 2.72308 5.63487 2.75457L5.62721 2.76342L1.59284 6.80034C1.59276 6.80043 1.59292 6.80026 1.59284 6.80034C1.53794 6.85563 1.51044 6.92497 1.51044 6.99298C1.51044 7.06099 1.53769 7.13007 1.59256 7.18534C1.59247 7.18525 1.59265 7.18543 1.59256 7.18534L5.6091 11.2003C5.66876 11.2483 5.74791 11.2766 5.83247 11.2759C5.92078 11.2751 6.00241 11.2428 6.06165 11.19C6.12037 11.1377 6.15219 11.0701 6.15696 11.0026C6.1615 10.9382 6.14165 10.872 6.09678 10.816Z"
      fill="#428BCA"
    />
    <path
      d="M10.9492 0.466846C10.7782 0.442563 10.604 0.483072 10.4645 0.579536C10.3251 0.675999 10.2318 0.820586 10.2049 0.981749L8.28952 12.8117C8.26379 12.973 8.30672 13.1374 8.40895 13.2689C8.51118 13.4005 8.66441 13.4886 8.8352 13.514C8.86807 13.5187 8.90127 13.5211 8.93452 13.5212C9.09033 13.5206 9.24082 13.4676 9.35894 13.3717C9.47706 13.2758 9.55508 13.1433 9.57897 12.9981L11.4943 1.16814C11.5197 1.00705 11.4767 0.842996 11.3746 0.711665C11.2726 0.580334 11.1196 0.492349 10.9492 0.466846Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2791 0.316231C10.4875 0.172065 10.7448 0.113196 10.9954 0.148795L10.9495 0.472082L10.9978 0.149145C11.2479 0.186562 11.4772 0.316307 11.6328 0.516497C11.789 0.717451 11.857 0.972091 11.8172 1.2243L11.817 1.22557L9.90163 13.0555C9.8643 13.2824 9.74294 13.4861 9.56506 13.6305C9.38759 13.7745 9.16447 13.8521 8.9361 13.853L8.93408 13.853C8.88559 13.8528 8.83715 13.8493 8.78916 13.8424L8.78757 13.8422C8.537 13.805 8.3073 13.6751 8.15147 13.4745C7.99504 13.2732 7.92715 13.018 7.96744 12.7655L9.88315 0.933241C9.92518 0.68138 10.0702 0.460796 10.2791 0.316231ZM10.9024 0.795202C10.8115 0.782599 10.7208 0.804767 10.6506 0.853315C10.5809 0.901538 10.5393 0.969876 10.5274 1.04013C10.5273 1.04033 10.5274 1.03993 10.5274 1.04013L8.6123 12.8683C8.61229 12.8684 8.61232 12.8682 8.6123 12.8683C8.60122 12.9383 8.61916 13.0121 8.66712 13.0738C8.7156 13.1362 8.79205 13.1824 8.88272 13.1961C8.89989 13.1985 8.91727 13.1998 8.9347 13.1999C9.01756 13.1993 9.095 13.1709 9.15352 13.1234C9.21177 13.0761 9.24655 13.0141 9.25708 12.9506C9.25706 12.9508 9.2571 12.9505 9.25708 12.9506L11.1721 1.12246C11.1721 1.12263 11.1722 1.12229 11.1721 1.12246C11.183 1.05263 11.1651 0.978869 11.1172 0.917308C11.0689 0.855111 10.9927 0.809018 10.9024 0.795202Z"
      fill="#428BCA"
    />
  </svg>
);

export const expandToFullScreenIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "20"}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M18.997 1.677c0-.011-.003-.022-.005-.033-.001-.013-.003-.027-.006-.04l-.009-.037-.008-.034-.013-.036-.012-.033-.015-.033c-.006-.011-.01-.023-.017-.034l-.017-.03-.02-.033-.024-.032-.02-.027a.768.768 0 0 0-.05-.054V1.22a.76.76 0 0 0-.055-.05l-.026-.02c-.011-.007-.021-.016-.033-.023l-.032-.02-.03-.018-.035-.016-.032-.015c-.011-.005-.023-.008-.034-.012-.012-.005-.023-.01-.035-.013l-.034-.009-.037-.009-.04-.006-.033-.005a.768.768 0 0 0-.074-.003H13a.75.75 0 0 0 0 1.5h3.44l-5.47 5.47a.75.75 0 0 0 1.06 1.06l5.47-5.47v3.44A.75.75 0 0 0 19 7V1.75a.763.763 0 0 0-.004-.074zM7.97 10.97 2.5 16.44V13A.75.75 0 0 0 1 13v5.25c0 .025.001.05.004.075 0 .01.003.021.004.033l.007.04.009.036.008.034.013.036.012.034.015.032c.006.011.01.023.017.034l.017.03.02.033.024.032.02.027a.738.738 0 0 0 .105.105l.026.02c.011.008.021.016.033.023.01.008.021.014.032.02l.03.018.035.017.032.015.034.012c.011.004.023.009.035.012l.034.01.037.008.04.006.033.005c.025.002.05.004.074.004H7a.75.75 0 0 0 0-1.5H3.56l5.47-5.47a.75.75 0 1 0-1.06-1.06z"
      fill="#fff"
      stroke="#fff"
      strokeWidth=".5"
    />
  </svg>
);

export const playVideoIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "110"}
    height={height || "110"}
    viewBox="0 0 110 110"
    fill="none"
  >
    <path
      opacity="0.75"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 55C0 24.6243 24.6243 0 55 0C85.3757 0 110 24.6243 110 55C110 85.3757 85.3757 110 55 110C24.6243 110 0 85.3757 0 55Z"
      fill="black"
    />
    <path
      d="M39.5313 41.3626V70.0187C39.5317 70.3962 39.6444 70.767 39.8583 71.0947C40.0722 71.4223 40.3798 71.6954 40.7509 71.8869C41.1219 72.0785 41.5435 72.182 41.974 72.1871C42.4046 72.1922 42.8292 72.0988 43.206 71.916L39.5313 41.3626ZM39.5313 41.3626C39.5304 40.9841 39.6424 40.612 39.8562 40.2832M39.5313 41.3626L39.8562 40.2832M40.0313 70.0181V41.3626L40.0312 41.3614C40.0306 41.0837 40.1125 40.8062 40.2754 40.5557C40.4387 40.3045 40.6793 40.0874 40.9795 39.9322C41.2799 39.777 41.6257 39.6913 41.9819 39.6874C42.3381 39.6835 42.6865 39.7614 42.9919 39.9103L42.992 39.9104L72.4099 54.2384L72.4106 54.2388C72.7238 54.3907 72.9763 54.6092 73.1482 54.8649C73.3196 55.1198 73.4062 55.404 73.4062 55.6885C73.4062 55.9729 73.3196 56.2571 73.1482 56.512C72.9763 56.7677 72.7238 56.9862 72.4106 57.1381L72.4099 57.1385L42.9879 71.4661L40.0313 70.0181ZM40.0313 70.0181C40.0316 70.295 40.114 70.5717 40.277 70.8213C40.4405 71.0717 40.6807 71.288 40.9803 71.4427C41.2799 71.5974 41.6247 71.6829 41.98 71.6871C42.3349 71.6913 42.6823 71.6142 42.9871 71.4665L40.0313 70.0181ZM39.8562 40.2832C40.0699 39.9543 40.3781 39.6802 40.75 39.488M39.8562 40.2832L40.75 39.488M40.75 39.488C41.1219 39.2958 41.5447 39.1922 41.9764 39.1874M40.75 39.488L41.9764 39.1874M41.9764 39.1874C42.408 39.1827 42.8337 39.2769 43.211 39.4609L41.9764 39.1874Z"
      fill="white"
      stroke="white"
    />
    <path
      d="M69.7902 54.763L70.701 54.3144L69.7902 53.8659L44.0804 41.2047L43.3595 40.8496V41.6532V66.9756V67.7792L44.0804 67.4242L69.7902 54.763ZM72.896 52.6395C73.184 53.0725 73.3529 53.5529 73.3955 54.0441L73.3975 54.3181C73.4018 54.8995 73.2291 55.4756 72.8912 55.986C72.5528 56.4971 72.0597 56.925 71.4581 57.2183L71.4563 57.2191L45.7422 69.8803L45.742 69.8804C45.1554 70.1696 44.4901 70.3195 43.8126 70.3123C43.1351 70.305 42.4744 70.1409 41.8964 69.8395C41.3185 69.5383 40.8469 69.1123 40.5225 68.6096C40.1986 68.1075 40.0312 67.5444 40.0313 66.9756V41.6532V41.6526C40.0306 41.0836 40.1974 40.5201 40.5211 40.0176C40.8452 39.5144 41.3168 39.088 41.8947 38.7863C42.4728 38.4846 43.1338 38.3202 43.8116 38.3128C44.4894 38.3054 45.1551 38.4553 45.742 38.7446L45.7421 38.7446L71.4519 51.4058L71.4519 51.4059L71.4552 51.4074C72.0596 51.6996 72.5554 52.1276 72.896 52.6395Z"
      fill="white"
      stroke="white"
    />
  </svg>
);

export const likeIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "16"}
    height={height || "17"}
    viewBox="0 0 16 17"
    fill="none"
  >
    <g clipPath="url(#ofs79zju1a)" fill="#4F4F4F">
      <path d="M.48 7.036a.473.473 0 0 0-.474.473v6.952c0 .261.212.473.473.473h2.852V7.036H.479zM15.994 9.65c0-.601-.323-1.128-.805-1.417a1.652 1.652 0 0 0-1.357-2.587h-3.483c.107-.483.253-1.21.354-1.97.265-1.977.084-3.073-.569-3.45C9.727-.01 9.29-.058 8.9.09c-.301.115-.708.397-.94 1.089l-.915 2.397C6.58 4.723 5.16 5.927 4.277 6.59v8.553a15.3 15.3 0 0 0 5.078.862h3.795a1.652 1.652 0 0 0 1.402-2.518 1.652 1.652 0 0 0 .637-2.422 1.65 1.65 0 0 0 .805-1.416z" />
    </g>
    <defs>
      <clipPath id="ofs79zju1a">
        <path fill="#fff" transform="translate(0 .006)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const disLikeIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "16"}
    height={height || "17"}
    viewBox="0 0 16 17"
    fill="none"
  >
    <g clipPath="url(#pqo7u4ubya)" fill="#4F4F4F">
      <path d="M.48 8.977a.473.473 0 0 1-.474-.474V1.552c0-.262.212-.474.473-.474h2.852v7.899H.479zM15.994 6.363c0 .6-.323 1.128-.805 1.416a1.652 1.652 0 0 1-1.357 2.587h-3.483c.107.484.253 1.21.354 1.97.265 1.977.084 3.074-.569 3.451-.407.235-.845.283-1.235.135-.301-.115-.708-.397-.94-1.089l-.915-2.397c-.464-1.146-1.885-2.35-2.767-3.015V.87A15.3 15.3 0 0 1 9.355.006h3.795a1.652 1.652 0 0 1 1.402 2.52 1.652 1.652 0 0 1 .637 2.42c.482.29.805.816.805 1.417z" />
    </g>
    <defs>
      <clipPath id="pqo7u4ubya">
        <path
          fill="#fff"
          transform="matrix(1 0 0 -1 0 16.006)"
          d="M0 0h16v16H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export const typeSVG = (
  <svg width="22" height="16" viewBox="0 0 22 16" fill="none">
    <path
      d="M1.625 15.1667C1.19167 15.1667 0.8125 14.9997 0.4875 14.6656C0.1625 14.3316 0 13.9569 0 13.5417V1.625C0 1.19167 0.1625 0.8125 0.4875 0.4875C0.8125 0.1625 1.19167 0 1.625 0H20.0417C20.475 0 20.8542 0.1625 21.1792 0.4875C21.5042 0.8125 21.6667 1.19167 21.6667 1.625V13.5417C21.6667 13.9569 21.5042 14.3316 21.1792 14.6656C20.8542 14.9997 20.475 15.1667 20.0417 15.1667H1.625ZM1.625 13.5417H20.0417V1.625H1.625V13.5417ZM5.95833 11.7813H15.7083V10.1563H5.95833V11.7813ZM3.33125 8.39583H4.95625V6.77083H3.33125V8.39583ZM6.68958 8.39583H8.31458V6.77083H6.68958V8.39583ZM10.0208 8.39583H11.6458V6.77083H10.0208V8.39583ZM13.3792 8.39583H15.0042V6.77083H13.3792V8.39583ZM16.7104 8.39583H18.3354V6.77083H16.7104V8.39583ZM3.33125 5.01042H4.95625V3.38542H3.33125V5.01042ZM6.68958 5.01042H8.31458V3.38542H6.68958V5.01042ZM10.0208 5.01042H11.6458V3.38542H10.0208V5.01042ZM13.3792 5.01042H15.0042V3.38542H13.3792V5.01042ZM16.7104 5.01042H18.3354V3.38542H16.7104V5.01042ZM1.625 13.5417V1.625V13.5417Z"
      fill="white"
    />
  </svg>
);

export const flagCircleSVG = (): JSX.Element => (
  <svg width="152" height="152" viewBox="0 0 152 152" fill="none">
    <mask
      id="mask0_195_13607"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="152"
      height="152"
    >
      <circle cx="76" cy="76" r="76" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_195_13607)">
      <rect x="35" y="41" width="7" height="102" rx="2" fill="#2E6589" />
      <path
        d="M43.0012 47C40.2012 44.6 40.0469 46.5 40.0029 48C39.5033 65 38.8023 98.8 40.0012 102C41.4999 106 47.4994 105 54.4994 105C65.5448 105 84.8016 91.1522 97.9994 81C110.999 71 125.999 69 129.999 70C133.999 71 135.499 69.5 127.003 63.5C115.967 55.7075 103.003 57.5 79.5026 60C56.0026 62.5 46.5012 50 43.0012 47Z"
        fill="#FF6915"
      />
    </g>
    <circle cx="76" cy="76" r="75" stroke="#FAE0D6" strokeWidth="2" />
  </svg>
);

export const redHandCircleIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "100"}
    height={height || "102"}
    viewBox="0 0 100 102"
    fill="none"
  >
    <circle
      cx="50.156"
      cy="51.656"
      r="48.843"
      stroke="#FAE0D6"
      strokeWidth="2"
    />
    <path
      d="m66.378 58.703-.043-.063a4.248 4.248 0 0 0-2.483-1.745c1.124-1.454 1.296-3.44.256-4.978a4.316 4.316 0 0 0-2.794-1.79c.847-1.398.883-3.142-.054-4.527l-.045-.067a4.019 4.019 0 0 0-2.094-1.604l8.932-5.682c2.159-1.373 2.812-4.12 1.471-6.103-1.34-1.98-4.19-2.485-6.348-1.114L45.443 42.288l.56-1.748a5.71 5.71 0 0 0-.467-4.661 5.934 5.934 0 0 0-3.766-2.777l-1.295-.386a.94.94 0 0 0-1.082.42L28.65 51.739c-1.963 3.401-1.886 7.446.213 10.55l6.272 9.273.009-.005c3.18 4.701 9.965 5.837 15.133 2.556 2.313-1.469 4.03-2.573 5.426-3.46 3.739-2.371 5.115-3.252 9.224-5.879 2.15-1.374 2.788-4.095 1.45-6.072z"
      fill="#FAE0D6"
    />
    <path
      d="m66.374 58.703-.043-.063a4.248 4.248 0 0 0-2.483-1.745c1.124-1.454 1.296-3.44.256-4.978a4.316 4.316 0 0 0-2.794-1.79c.847-1.398.883-3.142-.054-4.527l-.045-.067a4.02 4.02 0 0 0-2.094-1.604l8.932-5.682c2.159-1.373 2.812-4.12 1.471-6.103-1.34-1.98-4.19-2.485-6.348-1.114L45.439 42.288 46 40.54a5.71 5.71 0 0 0-.467-4.661 5.934 5.934 0 0 0-3.765-2.777l-1.296-.386a.94.94 0 0 0-1.082.42L28.646 51.739c-1.963 3.401-1.886 7.446.213 10.55l6.272 9.273.009-.005c3.18 4.701 9.965 5.837 15.133 2.556 2.313-1.469 4.03-2.573 5.427-3.46 3.738-2.371 5.114-3.252 9.223-5.879 2.15-1.374 2.788-4.095 1.45-6.072zM54.68 69.133l-5.441 3.453c-4.314 2.74-9.964 1.82-12.586-2.056l-6.242-9.229c-1.718-2.54-1.769-5.871-.145-8.683l5.186-8.984 5.186-8.984.603.178.047.012a4.107 4.107 0 0 1 2.624 1.916c.565.993.678 2.168.314 3.245l-1.332 4.14a.884.884 0 0 0 .327.987.951.951 0 0 0 1.067.035l19.895-12.638c1.302-.827 3.008-.546 3.787.606.779 1.151.364 2.781-.939 3.61l-11.99 7.628-.127.078c-.018.012-.035.026-.053.037l-5.126 3.261a.883.883 0 0 0-.267 1.246.945.945 0 0 0 1.284.259l5.281-3.36c1.256-.8 2.868-.493 3.627.63l.045.066c.78 1.153.392 2.77-.91 3.6l-4.691 2.984a.883.883 0 0 0-.267 1.245.945.945 0 0 0 1.284.26l3.68-2.342c1.304-.83 2.981-.59 3.765.569.78 1.152.338 2.74-.966 3.569l-3.472 2.208a.883.883 0 0 0-.267 1.246.945.945 0 0 0 1.285.259l1.88-1.196c1.303-.83 2.974-.515 3.754.638l.043.062c.777 1.15.374 2.747-.924 3.577-4.105 2.625-5.483 3.499-9.22 5.869z"
      fill="#fff"
    />
    <path
      d="M57.55 31.036c.294-.066.563-.241.736-.51l3.628-5.63a1.126 1.126 0 0 0-.377-1.58 1.203 1.203 0 0 0-1.628.365l-3.627 5.63a1.126 1.126 0 0 0 .376 1.58c.276.168.597.21.892.145zM46.26 32.026c.21.242.501.378.803.404.3.025.612-.062.861-.266.5-.408.564-1.13.143-1.615L42.61 26.04a1.207 1.207 0 0 0-1.666-.139c-.5.408-.563 1.131-.143 1.616l5.458 4.509zM52.444 31.13c.642-.117 1.065-.716.944-1.338l-1.23-6.369c-.12-.622-.738-1.032-1.38-.915-.64.116-1.063.715-.943 1.337l1.23 6.37c.12.621.738 1.031 1.38.915z"
      fill="#FF5200"
    />
  </svg>
);

export const collapsedActionsIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "15"}
    height={height || "15"}
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M15 14.063a.937.937 0 0 0-.938-.938H.938a.937.937 0 1 0 0 1.875h13.124c.518 0 .938-.42.938-.938zM15 .938A.937.937 0 0 0 14.062 0H.938a.937.937 0 1 0 0 1.875h13.124c.518 0 .938-.42.938-.938zM14.996 5.344a.937.937 0 0 0-.937-.938H8.996a.938.938 0 0 0 0 1.875h5.063c.517 0 .937-.42.937-.937zM14.996 9.656a.937.937 0 0 0-.937-.937H8.996a.938.938 0 0 0 0 1.875h5.063c.517 0 .937-.42.937-.938z"
      fill="#4F4F4F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.055 4.663a.5.5 0 0 1 .769-.421L5.123 6.99a.5.5 0 0 1 .005.84l-4.3 2.819a.5.5 0 0 1-.773-.418V4.662z"
      fill="#4F4F4F"
    />
  </svg>
);

export const expandedActionsIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "15"}
    height={height || "15"}
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M15 14.063a.937.937 0 0 0-.938-.938H.938a.937.937 0 1 0 0 1.875h13.124c.518 0 .938-.42.938-.938zM15 .938A.937.937 0 0 0 14.062 0H.938a.937.937 0 1 0 0 1.875h13.124c.518 0 .938-.42.938-.938zM14.998 5.344a.937.937 0 0 0-.938-.938H8.998a.938.938 0 0 0 0 1.875h5.063c.517 0 .937-.42.937-.937zM14.998 9.656a.937.937 0 0 0-.938-.937H8.998a.937.937 0 1 0 0 1.875h5.063c.517 0 .937-.42.937-.938z"
      fill="#4F4F4F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.775 4.663a.5.5 0 0 0-.769-.421L.707 6.99a.5.5 0 0 0-.005.84l4.3 2.819a.5.5 0 0 0 .773-.418V4.662z"
      fill="#4F4F4F"
    />
  </svg>
);

export const collapseIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "18"}
    height={height || "18"}
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clipPath="url(#4gveubneea)" fill="#4F4F4F">
      <path d="M1.28.22 6 4.94V3a.75.75 0 1 1 1.5 0v3.75c0 .025-.001.05-.004.074 0 .011-.003.022-.004.033l-.007.04-.009.037-.008.034-.013.035-.012.034-.015.032c-.006.012-.01.023-.017.035l-.017.03-.02.032-.024.033-.02.026a.752.752 0 0 1-.105.105l-.026.02-.033.024-.032.02-.03.017-.035.017-.032.015-.034.012-.035.013-.034.008-.037.01-.04.006-.033.004a.767.767 0 0 1-.074.004H3A.75.75 0 1 1 3 6h1.94L.22 1.28A.75.75 0 0 1 1.28.22zM16.72 17.78 12 13.06V15a.75.75 0 0 1-1.5 0v-3.75c0-.025.001-.05.004-.074 0-.011.003-.022.005-.033l.006-.04.009-.037.008-.034.013-.035.012-.034.015-.032c.006-.012.01-.023.017-.034l.018-.03c.006-.012.012-.023.02-.033l.023-.033.02-.026a.772.772 0 0 1 .105-.105l.026-.02.033-.024.032-.02.03-.017.035-.017.032-.015.034-.012.035-.013.034-.008.037-.01.04-.005.033-.005a.732.732 0 0 1 .074-.004H15a.75.75 0 0 1 0 1.5h-1.94l4.72 4.72a.75.75 0 1 1-1.06 1.06zM7.35 10.802l.024.032.02.032.017.03.017.035.015.032.012.034.013.035.008.034.01.037.006.04.004.033c.003.025.004.05.004.074V15A.75.75 0 0 1 6 15v-1.94l-4.72 4.72a.75.75 0 0 1-1.06-1.06L4.94 12H3a.75.75 0 0 1 0-1.5h3.75c.025 0 .05.001.074.004.011 0 .022.003.033.005l.04.006.037.009.034.008.035.013.034.012.032.015c.012.006.023.01.034.017l.03.017.033.02.032.024.027.02a.741.741 0 0 1 .054.049h.001l.001.002a.765.765 0 0 1 .049.054l.02.027zM13.06 6H15a.75.75 0 0 1 0 1.5h-3.75a.753.753 0 0 1-.074-.004c-.011 0-.022-.003-.033-.004l-.04-.007-.037-.009-.034-.008-.035-.013-.034-.012-.032-.015c-.012-.006-.023-.01-.034-.017l-.03-.018c-.012-.006-.023-.012-.033-.02-.012-.007-.022-.015-.033-.023l-.026-.02a.752.752 0 0 1-.105-.105l-.02-.026-.024-.033-.02-.032-.017-.03-.017-.035-.015-.032c-.005-.011-.008-.022-.012-.034l-.013-.035-.008-.034-.01-.037-.006-.04-.004-.033a.76.76 0 0 1-.004-.074V3A.75.75 0 0 1 12 3v1.94L16.72.22a.75.75 0 0 1 1.06 1.06L13.06 6z" />
    </g>
    <defs>
      <clipPath id="4gveubneea">
        <path fill="#fff" transform="matrix(-1 0 0 1 18 0)" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const noCodeIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "20"}
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      d="m15.362 9.653-2.648-2.846a.432.432 0 0 0-.306-.161.425.425 0 0 0-.324.118.437.437 0 0 0-.097.496c.024.055.06.104.103.145l2.368 2.548L12.09 12.5a.441.441 0 0 0 .039.593.427.427 0 0 0 .585.005l2.648-2.846a.44.44 0 0 0 0-.6zM7.425 12.498 5.056 9.95l2.369-2.548a.437.437 0 0 0 .104-.494.437.437 0 0 0-.25-.24.425.425 0 0 0-.48.136L4.153 9.652a.44.44 0 0 0 0 .598L6.8 13.096a.427.427 0 0 0 .586-.005.44.44 0 0 0 .039-.593zM10.46 5.338a.426.426 0 0 0-.318.08.438.438 0 0 0-.17.284l-1.26 8.364a.442.442 0 0 0 .078.323.43.43 0 0 0 .346.179.427.427 0 0 0 .28-.106.438.438 0 0 0 .144-.264l1.26-8.364a.442.442 0 0 0-.08-.323.43.43 0 0 0-.28-.173z"
      fill="#4F4F4F"
      stroke="#4F4F4F"
      strokeWidth=".4"
    />
    <path
      d="M9.994 18.317a8.326 8.326 0 1 0 0-16.651 8.326 8.326 0 0 0 0 16.651z"
      stroke="#4F4F4F"
      strokeWidth="1.7"
    />
    <path fill="#4F4F4F" d="m3.336 4.587.966-.966 11.753 11.753-.966.966z" />
  </svg>
);

export const lockSolidIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "15"}
    height={height || "17"}
    viewBox="0 0 15 17"
    fill="none"
  >
    <path
      d="M2.56 6.453V4.916a4.606 4.606 0 0 1 9.211 0v1.537h.512a2.05 2.05 0 0 1 2.05 2.047v6.142a2.05 2.05 0 0 1-2.048 2.048H2.048A2.049 2.049 0 0 1 0 14.642V8.5a2.048 2.048 0 0 1 2.048-2.047h.512zm2.047 0h5.119V4.916a2.56 2.56 0 0 0-5.119 0v1.537z"
      fill="#BDBEC4"
    />
  </svg>
);

export const chevronRightWithBg = (): JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
    <rect width="20" height="20" rx="2" fill="#F6F6F6" />
    <path d="m7 16 6-6-6-6" stroke="#949494" strokeWidth="1.5" />
  </svg>
);

export const chevronDownWithBg = (): JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
    <rect width="20" height="20" rx="2" fill="#F0F4F8" />
    <path d="m4 7 6 6 6-6" stroke="#428BCA" strokeWidth="1.5" />
  </svg>
);

export const chevronRightCollapse = (): JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
    <path d="m7 16 6-6-6-6" stroke="#949494" strokeWidth="1.5" />
  </svg>
);

export const chevronDownCollapse = (): JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
    <path d="m4 7 6 6 6-6" stroke="#428BCA" strokeWidth="1.5" />
  </svg>
);

export const runAnalysisIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "21"}
    height={height || "18.5"}
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M11.001 20.259a9.26 9.26 0 1 0 0-18.519 9.26 9.26 0 0 0 0 18.519z"
      stroke="#428BCA"
      strokeWidth="2"
    />
    <path
      d="M14.62 11.117c.024.041.039.087.044.135v.045a.337.337 0 0 1-.174.297l-.002.002-5.025 2.79a.346.346 0 0 1-.172.044l-.006.5.006-.5a.346.346 0 0 1-.342-.346V8.503a.346.346 0 0 1 .514-.303l5.024 2.79.003.002c.054.03.098.073.13.125z"
      fill="#428BCA"
      stroke="#428BCA"
    />
  </svg>
);

export const codeViewIcon = (): JSX.Element => (
  <svg width="21.6" height="17.6" viewBox="0 0 27 22" fill="none">
    <path
      d="m26.109 10.569-5.867-6.306a.956.956 0 0 0-.678-.356.942.942 0 0 0-.718.262.967.967 0 0 0-.3.712.979.979 0 0 0 .313.707l5.247 5.646-5.247 5.646a.977.977 0 0 0 .086 1.313.947.947 0 0 0 1.297.012l5.867-6.306a.975.975 0 0 0 0-1.33zM8.51 16.873l-5.248-5.645L8.51 5.582a.968.968 0 0 0 .308-.706.98.98 0 0 0-.299-.71.952.952 0 0 0-.716-.263.944.944 0 0 0-.678.354l-5.866 6.31a.975.975 0 0 0 0 1.326l5.867 6.305a.946.946 0 0 0 1.297-.012.974.974 0 0 0 .087-1.313zM15.224 1.01a.944.944 0 0 0-.707.177.97.97 0 0 0-.378.63l-2.79 18.53a.979.979 0 0 0 .174.716.952.952 0 0 0 .765.395.946.946 0 0 0 .619-.234.972.972 0 0 0 .32-.585l2.79-18.53a.978.978 0 0 0-.173-.715.952.952 0 0 0-.62-.384z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth=".4"
    />
  </svg>
);

export const profillingIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "14.4"}
    height={height || "14.4"}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M4.504 18H0v-6.714a1 1 0 0 1 1-1h2.495a1 1 0 0 1 1 .998L4.505 18zm6.748 0H6.759V6.143a1 1 0 0 1 1-1h2.493a1 1 0 0 1 1 1V18zM18 18h-4.493V1a1 1 0 0 1 1-1H17a1 1 0 0 1 1 1v17z"
      fill="#428BCA"
    />
  </svg>
);

export const maximizeIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "16"}
    height={height || "16"}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="m18.996 1.64-.005-.03-.005-.038-.009-.035-.008-.033-.012-.034-.012-.031-.014-.031-.016-.032c-.005-.01-.01-.02-.017-.029l-.018-.031-.023-.03-.019-.026a.685.685 0 0 0-.046-.052h-.001a.724.724 0 0 0-.052-.047l-.025-.019-.03-.022-.032-.02-.028-.016-.032-.016-.031-.014-.032-.012-.034-.011c-.01-.004-.021-.006-.032-.009l-.035-.008-.038-.006-.031-.004a.725.725 0 0 0-.07-.004h-4.974a.71.71 0 1 0 0 1.421h3.258l-5.181 5.182a.71.71 0 1 0 1.005 1.005l5.181-5.182v3.258a.71.71 0 1 0 1.421 0V1.711a.715.715 0 0 0-.003-.07zM7.603 11.392 2.42 16.574v-3.258a.71.71 0 1 0-1.421 0v4.973c0 .024.001.047.004.07 0 .011.003.021.004.032.002.012.003.025.006.037l.008.035.009.033.011.033.012.032.014.031.016.032.017.029.019.03c.007.012.015.021.022.031.006.009.012.018.02.026a.729.729 0 0 0 .1.1c.006.006.015.012.024.018l.03.022.031.02.029.016.032.016.03.014.033.011c.01.005.022.009.033.012l.033.009.035.008c.012.003.025.004.037.006l.031.004a.714.714 0 0 0 .07.004h4.974a.71.71 0 1 0 0-1.421H3.426l5.182-5.182a.71.71 0 1 0-1.005-1.005z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth=".7"
    />
  </svg>
);

export const noCodeViewIcon = (): JSX.Element => (
  <svg width="21.6" height="18.4" viewBox="0 0 23 23" fill="none">
    <path
      d="m17.755 11.094-3.089-3.32a.503.503 0 0 0-.56-.159.501.501 0 0 0-.292.28.515.515 0 0 0 .124.577l2.763 2.973-2.763 2.972a.514.514 0 0 0 .045.692.499.499 0 0 0 .683.006l3.09-3.32a.514.514 0 0 0 0-.7zM8.493 14.414 5.73 11.441l2.763-2.973a.51.51 0 0 0 .123-.575.51.51 0 0 0-.292-.28.496.496 0 0 0-.56.158l-3.089 3.323a.514.514 0 0 0 0 .698l3.09 3.32a.498.498 0 0 0 .683-.007.513.513 0 0 0 .045-.69zM12.03 6.061a.497.497 0 0 0-.371.093.511.511 0 0 0-.2.332L9.99 16.243a.515.515 0 0 0 .092.377.501.501 0 0 0 .403.208c.12 0 .235-.044.325-.123a.51.51 0 0 0 .17-.308l1.469-9.757a.515.515 0 0 0-.092-.377.501.501 0 0 0-.326-.202z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth=".4"
    />
    <path
      d="M11.486 21.203c5.365 0 9.713-4.349 9.713-9.713 0-5.365-4.348-9.713-9.713-9.713-5.364 0-9.713 4.348-9.713 9.713 0 5.364 4.35 9.713 9.713 9.713z"
      stroke="#428BCA"
      strokeWidth="1.7"
    />
    <path
      fill="#428BCA"
      d="M3.723 5.185 4.85 4.058 18.56 17.77l-1.126 1.126z"
    />
  </svg>
);

export const minimizedIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "16"}
    height={height || "16"}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M11.188 8.175c0 .01.003.021.004.031.002.013.003.026.006.038.002.012.006.024.009.035l.008.032c.003.012.008.023.012.034l.011.032.015.03.015.033.017.029.019.03.022.031.02.026c.014.018.03.035.046.051v.001a.7.7 0 0 0 .052.047l.026.019.03.022.031.019.029.017c.01.006.021.01.032.015l.03.015.033.011c.011.004.022.009.034.012l.032.008c.011.003.023.007.035.009l.037.006.032.004a.728.728 0 0 0 .07.004h4.973a.71.71 0 1 0 0-1.421H13.61l5.182-5.182a.71.71 0 1 0-1.005-1.005L12.605 6.39V3.132a.71.71 0 1 0-1.42 0v4.973c0 .024 0 .047.003.07zM2.21 18.792 7.39 13.61v3.258a.71.71 0 1 0 1.421 0v-4.973a.714.714 0 0 0-.003-.07l-.005-.031-.005-.038-.009-.035-.008-.033-.012-.033c-.004-.01-.007-.022-.012-.032l-.014-.03-.015-.033-.017-.029c-.007-.01-.012-.02-.02-.03-.006-.011-.014-.021-.022-.031l-.019-.026a.7.7 0 0 0-.099-.099l-.025-.019-.03-.022-.032-.019-.028-.017c-.01-.006-.022-.01-.032-.015l-.031-.015-.032-.011c-.011-.004-.022-.009-.034-.012l-.032-.008c-.012-.003-.023-.007-.035-.009l-.038-.006-.03-.004a.714.714 0 0 0-.071-.004H3.128a.71.71 0 1 0 0 1.421h3.259l-5.182 5.182a.71.71 0 0 0 1.005 1.005z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth=".7"
    />
  </svg>
);

export const greyCodeIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "21"}
    height={height || "17"}
    viewBox="0 0 21 17"
    fill="none"
  >
    <path
      d="m19.784 8.17-4.498-4.835a.733.733 0 0 0-.52-.273.722.722 0 0 0-.55.2.742.742 0 0 0-.23.547.751.751 0 0 0 .24.542l4.022 4.328-4.023 4.329a.75.75 0 0 0 .067 1.007.726.726 0 0 0 .994.009l4.498-4.834a.748.748 0 0 0 0-1.02zM6.29 13.003 2.269 8.675 6.29 4.346a.742.742 0 0 0 .236-.541.751.751 0 0 0-.23-.545.73.73 0 0 0-.548-.2.724.724 0 0 0-.52.27L.731 8.17a.748.748 0 0 0 0 1.016l4.499 4.834a.726.726 0 0 0 .994-.01.747.747 0 0 0 .067-1.006zM11.438.841a.724.724 0 0 0-.541.136.744.744 0 0 0-.29.483l-2.14 14.206a.75.75 0 0 0 .134.55.73.73 0 0 0 .587.302.726.726 0 0 0 .474-.18.745.745 0 0 0 .245-.448l2.14-14.207a.75.75 0 0 0-.134-.548.73.73 0 0 0-.475-.294z"
      fill="#4F4F4F"
      stroke="#4F4F4F"
      strokeWidth=".4"
    />
  </svg>
);

export const flameIconFilled = (): JSX.Element => (
  <svg width="17.6" height="17.6" viewBox="0 0 22 22" fill="none">
    <path
      d="M2.74.9h-.002a1.84 1.84 0 0 0-1.301 3.14l6.299 6.298v6.93a1.84 1.84 0 0 0 .785 1.507l2.85 1.994a1.84 1.84 0 0 0 2.893-1.507v-8.924l6.299-6.299A1.841 1.841 0 0 0 19.262.9H2.738z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth=".2"
      strokeLinejoin="round"
    />
  </svg>
);

export const flameIcon = (): JSX.Element => (
  <svg width="17.6" height="17.6" viewBox="0 0 22 22" fill="none">
    <path
      d="M2.74.9h-.002a1.84 1.84 0 0 0-1.301 3.14l6.299 6.298v6.93a1.84 1.84 0 0 0 .785 1.507l2.85 1.994a1.84 1.84 0 0 0 2.893-1.507v-8.924l6.299-6.299A1.841 1.841 0 0 0 19.262.9H2.738zm6.966 8.664a.1.1 0 0 0-.03-.07L3.055 2.87h15.892l-6.623 6.623a.1.1 0 0 0-.029.07v9.447L9.706 17.2V9.564z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth=".2"
      strokeLinejoin="round"
    />
  </svg>
);

export const greyPlayIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "22"}
    height={height || "22"}
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M10.998 18.639a7.639 7.639 0 1 0 0-15.278 7.639 7.639 0 0 0 0 15.278z"
      stroke="#4F4F4F"
      strokeWidth="2"
    />
    <path
      d="M13.911 11.141a.19.19 0 0 1 .025.072v.032a.19.19 0 0 1-.099.169h-.002L9.69 13.718a.197.197 0 0 1-.098.025l-.006.5.006-.5a.197.197 0 0 1-.17-.1l-.434.249.434-.248a.198.198 0 0 1-.026-.099V8.94a.198.198 0 0 1 .294-.174l4.145 2.303.003.001c.03.017.056.041.073.071z"
      fill="#4F4F4F"
      stroke="#4F4F4F"
    />
  </svg>
);

export const greyCommentIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "18"}
    viewBox="0 0 20 18"
    fill="none"
  >
    <path
      d="M3.621 17H2.345l.902-.91c.485-.49.793-1.13.873-1.818a6.92 6.92 0 0 1-2.694-3.215 6.35 6.35 0 0 1-.18-4.032A7.894 7.894 0 0 1 4.242 2.8a9.732 9.732 0 0 1 5.787-1.79 9.645 9.645 0 0 1 6.69 2.3 6.922 6.922 0 0 1 2.123 3.68 6.967 6.967 0 0 1-.417 4.237 7.103 7.103 0 0 1-1.711 2.403 9.623 9.623 0 0 1-6.685 2.31 12.06 12.06 0 0 1-3.025-.388A4.688 4.688 0 0 1 3.621 17zM10.03 2.076c-4.368 0-7.049 2.629-7.767 5.235a5.413 5.413 0 0 0 .24 3.593 5.348 5.348 0 0 0 2.437 2.63l.264.16-.008.31a4.228 4.228 0 0 1-.421 1.74A3.74 3.74 0 0 0 6.43 14.6l.223-.266.33.095c.99.29 2.016.436 3.046.435 5.436 0 7.912-3.322 7.912-6.409a5.91 5.91 0 0 0-.507-2.39 5.86 5.86 0 0 0-1.428-1.973 8.622 8.622 0 0 0-5.976-2.023v.007z"
      fill="#4F4F4F"
      stroke="#4F4F4F"
      strokeWidth=".5"
    />
    <path
      d="M6.463 9.966c.696 0 1.26-.57 1.26-1.272 0-.702-.564-1.271-1.26-1.271-.696 0-1.26.57-1.26 1.271 0 .703.564 1.272 1.26 1.272zM9.822 9.966c.696 0 1.26-.57 1.26-1.272 0-.702-.564-1.271-1.26-1.271-.695 0-1.26.57-1.26 1.271 0 .703.565 1.272 1.26 1.272zM13.182 9.966c.695 0 1.26-.57 1.26-1.272 0-.702-.565-1.271-1.26-1.271-.696 0-1.26.57-1.26 1.271 0 .703.564 1.272 1.26 1.272z"
      fill="#4F4F4F"
    />
  </svg>
);

export const greyDeleteIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "16"}
    height={height || "17"}
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.997 4.564H1.06c-.307 0-.392-.101-.393-.386v-.55c0-.246.113-.354.37-.355h2.989a.243.243 0 0 0 .167-.037.232.232 0 0 0 .098-.136c.204-.498.418-.993.64-1.485A1.47 1.47 0 0 1 5.5.925C5.756.757 6.06.67 6.37.677 7.46.663 8.547.663 9.636.677c.307-.006.608.08.864.245.256.165.453.403.565.681.226.49.434.988.64 1.486.015.058.05.11.102.144.05.034.113.049.174.041.98-.008 1.956 0 2.938 0 .324 0 .416.095.416.414v.426c0 .373-.082.45-.473.45h-.857v9.52a2.378 2.378 0 0 1-.447 1.487c-.147.214-.348.389-.583.507a1.595 1.595 0 0 1-.763.168c-2.766-.01-5.532 0-8.297 0a1.79 1.79 0 0 1-1.236-.387 1.695 1.695 0 0 1-.624-1.107 3.39 3.39 0 0 1-.058-.652V4.564zM7.338 9.75v3.527c0 .26.104.362.375.365h.492c.376 0 .459-.08.459-.446v-7a.295.295 0 0 0-.09-.244.313.313 0 0 0-.25-.087h-.565c-.326 0-.416.094-.416.404a835.52 835.52 0 0 0-.007 3.482l.002-.001zm-1.34.021V6.245c0-.271-.104-.377-.383-.38a5.654 5.654 0 0 0-.623.007.42.42 0 0 0-.27.14.493.493 0 0 0-.057.287v7.035a.29.29 0 0 0 .094.222.307.307 0 0 0 .233.081c.194.005.387 0 .583 0 .323 0 .416-.1.416-.416.005-1.146.008-2.295.007-3.449zm5.336-.02V6.243c0-.273-.104-.375-.384-.377h-.51c-.34 0-.434.09-.434.418v7c0 .248.11.355.364.36h.511c.365 0 .453-.085.453-.436V9.75zm-1.013-6.488c-.023-.068-.039-.122-.062-.176-.12-.29-.251-.575-.363-.868a.343.343 0 0 0-.142-.196.36.36 0 0 0-.24-.057c-.88.007-1.766 0-2.642 0-.757 0-.595-.093-.897.583-.104.23-.197.464-.302.708l4.648.006z"
      fill="#4F4F4F"
    />
  </svg>
);

export const analysisSearchIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "59"}
    height={height || "61"}
    viewBox="0 0 59 61"
    fill="none"
  >
    <path
      d="M25.483 20.971h-4.077a1.041 1.041 0 0 0-1.02 1.061v12.732a1.041 1.041 0 0 0 1.02 1.061h4.077a1.04 1.04 0 0 0 1.019-1.061V22.032a1.04 1.04 0 0 0-1.02-1.061zM17.329 27.337h-4.077a1.041 1.041 0 0 0-1.02 1.061v6.37a1.041 1.041 0 0 0 1.02 1.061h4.077a1.04 1.04 0 0 0 1.019-1.061v-6.37a1.04 1.04 0 0 0-1.02-1.061zM33.636 14.605H29.56a1.04 1.04 0 0 0-1.018 1.061v19.1a1.042 1.042 0 0 0 1.02 1.061h4.076a1.041 1.041 0 0 0 1.02-1.061v-19.1a1.041 1.041 0 0 0-1.02-1.061z"
      fill="#428BCA"
    />
    <path
      d="M57.853 56.212 43.397 41.161a25.724 25.724 0 0 0 5.479-15.946C48.873 11.311 38.01-.003 24.656-.003 11.3-.003.436 11.311.436 25.215S11.3 50.43 24.656 50.43a23.524 23.524 0 0 0 15.316-5.7l14.456 15.048a2.356 2.356 0 0 0 3.425 0 2.592 2.592 0 0 0 0-3.566zM24.656 45.387c-10.683 0-19.376-9.05-19.376-20.172S13.972 5.043 24.655 5.043c10.684 0 19.38 9.054 19.38 20.172v.448c-.178 10.855-8.8 19.724-19.38 19.724z"
      fill="#428BCA"
    />
  </svg>
);

export const analyzeDataIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "15"}
    height={height || "17"}
    viewBox="0 0 15 17"
    fill="none"
  >
    <path
      d="M8.449 4.661v.45c0 .395-.956.722-2.142.722s-2.143-.324-2.143-.721v-.45c0-.398.956-.722 2.142-.722s2.143.324 2.143.721zm0 1.014v1.013c0 .394-.956.72-2.142.72s-2.143-.323-2.143-.72V5.674c.66.355 1.4.52 2.142.479a4.035 4.035 0 0 0 2.143-.479v.001zm0 1.576v1.013c0 .394-.956.72-2.142.72s-2.143-.323-2.143-.72V7.25c.66.355 1.4.52 2.142.479A4.035 4.035 0 0 0 8.45 7.25v.001z"
      fill="#fff"
    />
    <path
      d="m14.757 14.575-3.694-3.958a6.569 6.569 0 0 0 1.464-4.008 6.584 6.584 0 0 0-1.293-4.07A6.253 6.253 0 0 0 7.753.2a6.097 6.097 0 0 0-4.137.42 6.356 6.356 0 0 0-2.97 2.996 6.63 6.63 0 0 0-.497 4.251 6.483 6.483 0 0 0 2.196 3.636 6.15 6.15 0 0 0 3.922 1.42 6.075 6.075 0 0 0 3.59-1.17l3.721 3.988a.818.818 0 0 0 .577.275.796.796 0 0 0 .594-.235.844.844 0 0 0 .25-.602.867.867 0 0 0-.243-.605l.001.001zM6.267 1.696c.916 0 1.811.28 2.573.804a4.744 4.744 0 0 1 1.707 2.141c.35.872.442 1.832.264 2.757a4.818 4.818 0 0 1-1.268 2.444 4.592 4.592 0 0 1-2.372 1.306c-.899.184-1.83.09-2.677-.272a4.664 4.664 0 0 1-2.078-1.758 4.875 4.875 0 0 1-.78-2.651c0-1.265.488-2.479 1.356-3.373a4.564 4.564 0 0 1 3.275-1.398z"
      fill="#fff"
    />
  </svg>
);

export const globalIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "14"}
    height={height || "14"}
    viewBox="0 0 14 14"
    fill="none"
  >
    <g clipPath="url(#clip0_828_177171)">
      <path
        d="M2.57638 7.44531H0C0.0810596 8.85972 0.580407 10.195 1.4387 11.3075C1.92142 11.0349 2.46335 10.8011 3.04879 10.6105C2.77022 9.63717 2.60826 8.56248 2.57638 7.44531Z"
        fill="#C9C9C9"
      />
      <path
        d="M2.57638 6.624C2.60826 5.5068 2.77022 4.43211 3.04881 3.45877C2.46335 3.26815 1.92144 3.03438 1.43872 2.76172C0.580407 3.87426 0.0810595 5.20956 0 6.624H2.57638Z"
        fill="#C9C9C9"
      />
      <path
        d="M4.51814 1.98238C4.36237 2.27002 4.22171 2.57851 4.09668 2.90436C4.87582 3.09057 5.71888 3.20177 6.5894 3.22838V0.0703125C5.82302 0.245586 5.09942 0.90894 4.51814 1.98238V1.98238Z"
        fill="#C9C9C9"
      />
      <path
        d="M7.41016 0.0703125V3.22835C8.28062 3.20174 9.12367 3.09052 9.90282 2.90433C9.77776 2.57851 9.63711 2.27 9.48136 1.98235C8.90008 0.908967 8.17648 0.245613 7.41016 0.0703125V0.0703125Z"
        fill="#C9C9C9"
      />
      <path
        d="M10.1627 3.68359C9.30094 3.89535 8.36922 4.02082 7.41016 4.04869V6.62482H10.6027C10.5713 5.58242 10.4207 4.5837 10.1627 3.68359V3.68359Z"
        fill="#C9C9C9"
      />
      <path
        d="M3.30491 11.3906C2.83075 11.5451 2.38924 11.7299 1.99023 11.9426C2.00749 11.9603 2.02442 11.9781 2.04187 11.9955C2.77168 12.7253 3.63418 13.274 4.57476 13.62C4.29447 13.2982 4.03373 12.9174 3.79736 12.4809C3.61361 12.1416 3.44931 11.7765 3.30491 11.3906V11.3906Z"
        fill="#C9C9C9"
      />
      <path
        d="M10.6956 2.68245C11.1698 2.52802 11.6113 2.34315 12.0103 2.13046C11.993 2.11285 11.9761 2.09502 11.9587 2.07757C11.2289 1.34776 10.3664 0.799105 9.42578 0.453125C9.70607 0.774929 9.96681 1.1557 10.2032 1.59217C10.3869 1.93148 10.5512 2.2966 10.6956 2.68245Z"
        fill="#C9C9C9"
      />
      <path
        d="M11.4236 7.44531C11.3917 8.56248 11.2297 9.63717 10.9512 10.6105C11.5366 10.8011 12.0785 11.0349 12.5613 11.3075C13.4196 10.195 13.9189 8.85975 14 7.44534H11.4236V7.44531Z"
        fill="#C9C9C9"
      />
      <path
        d="M10.6957 11.3906C10.5513 11.7765 10.387 12.1416 10.2032 12.4809C9.96684 12.9174 9.70607 13.2981 9.42578 13.62C10.3664 13.274 11.2289 12.7253 11.9587 11.9955C11.9761 11.9781 11.9931 11.9602 12.0103 11.9426C11.6113 11.73 11.1698 11.5451 10.6957 11.3906V11.3906Z"
        fill="#C9C9C9"
      />
      <path
        d="M3.30485 2.68245C3.44925 2.2966 3.61356 1.9315 3.79734 1.59217C4.03368 1.1557 4.29444 0.774929 4.57473 0.453125C3.63415 0.799105 2.77165 1.34776 2.04184 2.07757C2.02439 2.09502 2.00746 2.11285 1.99023 2.13046C2.38921 2.34315 2.83069 2.52802 3.30485 2.68245V2.68245Z"
        fill="#C9C9C9"
      />
      <path
        d="M10.9512 3.45874C11.2298 4.43208 11.3917 5.50678 11.4236 6.62397H14C13.9189 5.20953 13.4196 3.87424 12.5613 2.76172C12.0785 3.03435 11.5366 3.26812 10.9512 3.45874V3.45874Z"
        fill="#C9C9C9"
      />
      <path
        d="M6.59007 6.62482V4.04869C5.631 4.02082 4.69925 3.89532 3.83744 3.68359C3.57949 4.58367 3.42883 5.58239 3.39746 6.62485H6.59007V6.62482Z"
        fill="#C9C9C9"
      />
      <path
        d="M7.41016 7.44534V10.0214C8.3692 10.0493 9.30094 10.1748 10.1627 10.3865C10.4207 9.48643 10.5713 8.48774 10.6027 7.44531H7.41016V7.44534Z"
        fill="#C9C9C9"
      />
      <path
        d="M9.48136 12.0898C9.63713 11.8021 9.77778 11.4936 9.90282 11.1678C9.12367 10.9816 8.28064 10.8704 7.41016 10.8438V14.0018C8.1765 13.8265 8.9001 13.1631 9.48136 12.0898V12.0898Z"
        fill="#C9C9C9"
      />
      <path
        d="M6.5894 14.0018V10.8438C5.71891 10.8704 4.87585 10.9816 4.09668 11.1678C4.22174 11.4936 4.36239 11.8021 4.51817 12.0898C5.09945 13.1632 5.82305 13.8265 6.5894 14.0018V14.0018Z"
        fill="#C9C9C9"
      />
      <path
        d="M6.59007 7.44531H3.39746C3.42886 8.48774 3.57949 9.48643 3.83744 10.3865C4.69923 10.1748 5.63097 10.0493 6.59007 10.0214V7.44531Z"
        fill="#C9C9C9"
      />
    </g>
    <defs>
      <clipPath id="clip0_828_177171">
        <rect
          width="14"
          height="13.9303"
          fill="white"
          transform="translate(0 0.0703125)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const lockIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "13"}
    height={height || "15"}
    viewBox="0 0 13 15"
    fill="none"
  >
    <g clipPath="url(#clip0_828_177204)">
      <path
        d="M2.24718 6.01454V4.66579C2.26746 3.60685 2.70237 2.59814 3.45842 1.85643C4.21448 1.11472 5.23133 0.699219 6.29046 0.699219C7.34959 0.699219 8.36645 1.11472 9.1225 1.85643C9.87856 2.59814 10.3135 3.60685 10.3337 4.66579V6.01454H10.7833C11.2601 6.01454 11.7174 6.20378 12.0547 6.54069C12.392 6.8776 12.5818 7.33463 12.5824 7.81139V13.2042C12.582 13.6808 12.3925 14.1378 12.0555 14.4748C11.7184 14.8119 11.2614 15.0014 10.7848 15.0018H1.79759C1.3209 15.0016 0.863791 14.8121 0.52672 14.475C0.189648 14.138 0.000196614 13.6809 0 13.2042L0 7.81139C0.000393163 7.33483 0.189932 6.87791 0.526982 6.541C0.864032 6.20408 1.32103 6.01473 1.79759 6.01454H2.24718ZM4.04477 6.01454H8.53838V4.66579C8.52768 4.07697 8.28626 3.51588 7.86607 3.10325C7.44587 2.69063 6.88049 2.45944 6.29158 2.45944C5.70266 2.45944 5.13728 2.69063 4.71708 3.10325C4.29689 3.51588 4.05547 4.07697 4.04477 4.66579V6.01454Z"
        fill="#C9C9C9"
      />
    </g>
    <defs>
      <clipPath id="clip0_828_177204">
        <rect
          width="12.5824"
          height="14.38"
          fill="white"
          transform="translate(0 0.621094)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const doubleChevronRightIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "16"}
    height={height || "17"}
    viewBox="0 0 16 17"
    fill="none"
  >
    <g clipPath="url(#1of0zsseea)">
      <path
        d="m6.895.634 7.412 7.412-7.412 7.413"
        stroke="#4F4F4F"
        strokeWidth="1.3"
      />
    </g>
    <g clipPath="url(#95g14bf5cb)">
      <path
        d="m.633.634 7.412 7.412L.633 15.46"
        stroke="#4F4F4F"
        strokeWidth="1.3"
      />
    </g>
    <defs>
      <clipPath id="1of0zsseea">
        <path
          fill="#fff"
          transform="matrix(0 1 1 0 6.262 0)"
          d="M0 0h16.09v9.312H0z"
        />
      </clipPath>
      <clipPath id="95g14bf5cb">
        <path
          fill="#fff"
          transform="matrix(0 1 1 0 0 0)"
          d="M0 0h16.09v9.312H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export const doubleChevronLeftIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "16"}
    height={height || "17"}
    viewBox="0 0 16 17"
    fill="none"
  >
    <g clipPath="url(#ofz1egxsta)">
      <path
        d="M8.68.663 1.267 8.085l7.413 7.42"
        stroke="#4F4F4F"
        strokeWidth="1.3"
      />
    </g>
    <g clipPath="url(#2s2uahrjwb)">
      <path
        d="M14.941.663 7.53 8.085l7.412 7.42"
        stroke="#4F4F4F"
        strokeWidth="1.3"
      />
    </g>
    <defs>
      <clipPath id="ofz1egxsta">
        <path
          fill="#fff"
          transform="rotate(90 4.642 4.67)"
          d="M0 0h16.109v9.312H0z"
        />
      </clipPath>
      <clipPath id="2s2uahrjwb">
        <path
          fill="#fff"
          transform="rotate(90 7.773 7.801)"
          d="M0 0h16.109v9.312H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export const pinFilledIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "18"}
    height={height || "18"}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="m1.775 17.78 4.923-4.953c.132.12.246.227.361.329.843.835 1.678 1.678 2.528 2.506.428.42.86.29 1.014-.292.083-.317.154-.637.221-.957l.001-.005c.376-1.778.376-1.78 1.684-3.067.133-.13.267-.259.392-.396l.006-.007c.345-.378.686-.751 1.293-.577a.822.822 0 0 0 .38-.05 7.38 7.38 0 0 0 2.879-1.564.501.501 0 0 0 .174-.608.5.5 0 0 0-.135-.182c-.211-.23-.441-.445-.664-.667-1.966-1.956-3.933-3.91-5.902-5.864-.423-.42-.715-.417-1.05.063a16.763 16.763 0 0 0-1.078 1.694 2.985 2.985 0 0 0-.419 1.847.63.63 0 0 1-.202.427c-.535.555-1.1 1.083-1.63 1.643-.26.284-.606.474-.985.54-.716.14-1.43.298-2.131.5a.93.93 0 0 0-.587.456c-.058.171.118.478.278.645.803.834 1.634 1.64 2.455 2.457.108.108.206.222.354.389L1 16.938l.775.842z"
      fill="#949494"
      stroke="#949494"
      strokeWidth=".3"
    />
  </svg>
);

export const searchWithDatabaseIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "17"}
    height={height || "19"}
    viewBox="0 0 17 19"
    fill="none"
  >
    <path
      d="M9.506 5.58v.506c0 .444-1.076.811-2.41.811s-2.41-.364-2.41-.81V5.58c0-.447 1.075-.811 2.41-.811 1.333 0 2.41.364 2.41.81zm0 1.14v1.14c0 .443-1.076.81-2.41.81s-2.41-.364-2.41-.81V6.718a4.54 4.54 0 0 0 2.41.539 4.54 4.54 0 0 0 2.41-.539v.001zm0 1.773v1.14c0 .443-1.076.81-2.41.81s-2.41-.364-2.41-.81v-1.14a4.54 4.54 0 0 0 2.41.538 4.54 4.54 0 0 0 2.41-.539v.001z"
      fill="#949494"
    />
    <path
      d="m16.601 16.733-4.155-4.453a7.39 7.39 0 0 0 1.647-4.508 7.406 7.406 0 0 0-1.455-4.579A7.034 7.034 0 0 0 8.72.561a6.859 6.859 0 0 0-4.653.473 7.15 7.15 0 0 0-3.342 3.37 7.458 7.458 0 0 0-.559 4.782 7.293 7.293 0 0 0 2.47 4.09 6.919 6.919 0 0 0 4.413 1.597 6.833 6.833 0 0 0 4.038-1.314l4.187 4.486a.924.924 0 0 0 .65.308.895.895 0 0 0 .667-.264.948.948 0 0 0 .282-.677.973.973 0 0 0-.274-.68h.001zM7.05 2.244c1.03 0 2.038.315 2.895.904a5.337 5.337 0 0 1 1.92 2.41c.394.98.498 2.06.296 3.101a5.42 5.42 0 0 1-1.426 2.749 5.166 5.166 0 0 1-2.668 1.47c-1.01.206-2.059.1-3.01-.307a5.248 5.248 0 0 1-2.34-1.977A5.484 5.484 0 0 1 1.84 7.61c0-1.423.55-2.788 1.526-3.795A5.135 5.135 0 0 1 7.05 2.244z"
      fill="#949494"
    />
  </svg>
);

export const thinCrossIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "12"}
    height={height || "13"}
    viewBox="0 0 12 13"
    fill="none"
  >
    <path
      d="m7.42 6.002 4.286-4.288a1.004 1.004 0 0 0-1.42-1.42L6 4.581 1.714.294a1.004 1.004 0 1 0-1.42 1.42L4.58 6.002.294 10.289a1.005 1.005 0 0 0 1.42 1.42l4.283-4.285 4.286 4.288a1.002 1.002 0 0 0 1.637-.326 1.006 1.006 0 0 0-.217-1.095L7.42 6.001z"
      fill="#949494"
    />
  </svg>
);

export const thickTickIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "16"}
    height={height || "11"}
    viewBox="0 0 16 11"
    fill="none"
  >
    <path
      d="M14.666 1.333 6.072 9.667 2.166 5.879"
      stroke="#428BCA"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const backIcon2 = (): JSX.Element => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m.252 6.608.001.001 4.49 4.469A.86.86 0 0 0 5.956 9.86l-3.015-3h10.2a.86.86 0 1 0 0-1.72H2.94l3.015-3A.86.86 0 1 0 4.743.922L.253 5.391a.86.86 0 0 0 0 1.217z"
      fill="#428BCA"
    />
  </svg>
);

export const expnadIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "18"}
    height={height || "18"}
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clipPath="url(#clip0_970_201145)">
      <path
        d="M6.21967 7.28033L1.50001 2.56068V4.5C1.50001 4.91421 1.16424 5.24999 0.750027 5.24999C0.335816 5.24999 3.39746e-06 4.91421 3.39746e-06 4.5V0.750059C3.39746e-06 0.725344 0.00130374 0.700629 0.00372952 0.675984C0.00481937 0.664875 0.00689393 0.654117 0.00847596 0.643184C0.0103744 0.62993 0.0119212 0.616641 0.0145227 0.603457C0.0170188 0.590871 0.020464 0.578672 0.0235929 0.566332C0.0264405 0.554977 0.0289375 0.543551 0.0323476 0.532301C0.0360039 0.520172 0.0405735 0.508465 0.0448274 0.496617C0.0488704 0.485402 0.052562 0.474082 0.0571323 0.463008C0.0617026 0.451934 0.067117 0.441352 0.0721795 0.430559C0.0775584 0.419168 0.0826202 0.407672 0.0885968 0.396492C0.0941514 0.386156 0.100445 0.376313 0.106457 0.366258C0.112996 0.355324 0.119183 0.34425 0.126319 0.333562C0.133737 0.322453 0.142035 0.312012 0.150015 0.301324C0.156695 0.29243 0.162882 0.283289 0.169984 0.274605C0.185558 0.255656 0.201941 0.23741 0.219273 0.220078C0.219414 0.219938 0.219519 0.219797 0.219659 0.219656C0.2198 0.219516 0.219941 0.219445 0.220046 0.219305C0.237414 0.201973 0.255625 0.185555 0.274609 0.16998C0.283293 0.162844 0.292433 0.156656 0.301362 0.149977C0.312015 0.141996 0.322457 0.133734 0.333566 0.126316C0.344254 0.11918 0.355328 0.112992 0.366297 0.106453C0.376351 0.100441 0.38616 0.0941484 0.396496 0.0885937C0.407676 0.0826172 0.419137 0.0775547 0.430562 0.0721758C0.441355 0.0670781 0.451973 0.0616992 0.463012 0.0570937C0.474086 0.0525234 0.485406 0.0487969 0.496656 0.0447891C0.508504 0.0405352 0.520176 0.036 0.53227 0.0323438C0.54352 0.0289336 0.55498 0.0264375 0.566336 0.0235898C0.578676 0.0204609 0.590875 0.0170156 0.603425 0.0145195C0.616609 0.011918 0.629898 0.0103359 0.643152 0.0084375C0.654086 0.00689062 0.664843 0.00478125 0.675952 0.00369141C0.700597 0.00130078 0.725277 0 0.749992 0H4.5C4.91421 0 5.24999 0.335777 5.24999 0.749988C5.24999 1.1642 4.91421 1.49998 4.5 1.49998H2.56068L7.28033 6.21967C7.57322 6.51255 7.57322 6.98745 7.28033 7.28033C6.98745 7.57322 6.51256 7.57322 6.21967 7.28033Z"
        fill="#4F4F4F"
      />
      <path
        d="M11.7803 10.7197L16.5 15.4393V13.5C16.5 13.0858 16.8358 12.75 17.25 12.75C17.6642 12.75 18 13.0858 18 13.5V17.25C18 17.2747 17.9987 17.2994 17.9963 17.324C17.9952 17.3351 17.9931 17.3458 17.9915 17.3568C17.9896 17.3701 17.9881 17.3834 17.9854 17.3965C17.9829 17.4091 17.9795 17.4213 17.9764 17.4336C17.9735 17.445 17.971 17.4564 17.9676 17.4677C17.964 17.4798 17.9594 17.4915 17.9552 17.5033C17.9511 17.5146 17.9474 17.5259 17.9429 17.537C17.9383 17.548 17.9329 17.5586 17.9278 17.5694C17.9224 17.5808 17.9173 17.5923 17.9114 17.6035C17.9058 17.6138 17.8995 17.6236 17.8935 17.6337C17.887 17.6446 17.8808 17.6557 17.8736 17.6664C17.8662 17.6775 17.858 17.6879 17.85 17.6986C17.8433 17.7075 17.8371 17.7167 17.83 17.7254C17.8144 17.7443 17.798 17.7626 17.7807 17.7799C17.7805 17.7801 17.7804 17.7802 17.7803 17.7803C17.7802 17.7804 17.78 17.7806 17.7799 17.7807C17.7626 17.798 17.7443 17.8144 17.7254 17.83C17.7167 17.8371 17.7075 17.8433 17.6986 17.8499C17.688 17.8579 17.6775 17.8662 17.6664 17.8736C17.6557 17.8808 17.6447 17.887 17.6337 17.8935C17.6237 17.8995 17.6138 17.9058 17.6035 17.9114C17.5923 17.9173 17.5808 17.9224 17.5694 17.9278C17.5586 17.9329 17.548 17.9383 17.537 17.9428C17.5259 17.9474 17.5146 17.9511 17.5033 17.9551C17.4915 17.9594 17.4798 17.9639 17.4677 17.9676C17.4564 17.971 17.445 17.9735 17.4336 17.9764C17.4213 17.9795 17.4091 17.9829 17.3965 17.9854C17.3833 17.988 17.37 17.9896 17.3568 17.9915C17.3458 17.993 17.3351 17.9951 17.324 17.9962C17.2994 17.9987 17.2747 18 17.25 18H17.25H13.5C13.0858 18 12.75 17.6642 12.75 17.25C12.75 16.8358 13.0858 16.5 13.5 16.5H15.4393L10.7197 11.7803C10.4268 11.4874 10.4268 11.0126 10.7197 10.7197C11.0126 10.4268 11.4874 10.4268 11.7803 10.7197Z"
        fill="#4F4F4F"
      />
      <path
        d="M0.14991 17.6985C0.141965 17.6879 0.133702 17.6775 0.126319 17.6664C0.119147 17.6557 0.112961 17.6446 0.106422 17.6337C0.100445 17.6236 0.0941517 17.6138 0.0886322 17.6035C0.0826556 17.5924 0.0775584 17.5808 0.0721795 17.5694C0.0670818 17.5586 0.0617378 17.5481 0.0571323 17.537C0.052562 17.5259 0.0488352 17.5146 0.0448274 17.5034C0.0405735 17.4915 0.0360382 17.4799 0.032382 17.4678C0.0289718 17.4565 0.026476 17.4451 0.0236283 17.4337C0.0204994 17.4214 0.0170542 17.4092 0.0145581 17.3966C0.0119566 17.3834 0.0104096 17.3701 0.00847596 17.3569C0.00692908 17.3459 0.00481937 17.3352 0.00372952 17.3241C0.00130374 17.2994 3.39746e-06 17.2747 3.39746e-06 17.25V13.5C3.39746e-06 13.0858 0.335781 12.75 0.749992 12.75C1.1642 12.75 1.49998 13.0858 1.49998 13.5V15.4393L6.21967 10.7197C6.51256 10.4268 6.98745 10.4268 7.28033 10.7197C7.57322 11.0126 7.57322 11.4874 7.28033 11.7803L2.56068 16.5H4.5C4.91421 16.5 5.24999 16.8358 5.24999 17.25C5.24999 17.6642 4.91421 18 4.5 18H0.749992C0.725277 18 0.700597 17.9987 0.675988 17.9963C0.664913 17.9952 0.654156 17.9931 0.643187 17.9915C0.629934 17.9896 0.616609 17.9881 0.603461 17.9854C0.590875 17.9829 0.57871 17.9795 0.56637 17.9764C0.554979 17.9735 0.543554 17.971 0.532304 17.9676C0.52021 17.964 0.508503 17.9594 0.496691 17.9552C0.485441 17.9511 0.47412 17.9474 0.463046 17.9429C0.452007 17.9383 0.441425 17.9329 0.430667 17.9278C0.419242 17.9224 0.40771 17.9174 0.39653 17.9114C0.38623 17.9058 0.376421 17.8996 0.366402 17.8936C0.355433 17.887 0.344323 17.8808 0.333636 17.8737C0.322562 17.8663 0.312156 17.858 0.301538 17.8501C0.292574 17.8434 0.283398 17.8372 0.274679 17.83C0.25587 17.8146 0.237765 17.7983 0.220539 17.7811C0.220258 17.7808 0.219976 17.7806 0.21973 17.7803C0.219484 17.7801 0.219238 17.7798 0.218992 17.7795C0.201836 17.7623 0.185523 17.7442 0.170054 17.7254C0.162847 17.7167 0.156625 17.7075 0.14991 17.6985Z"
        fill="#4F4F4F"
      />
      <path
        d="M15.4393 1.50001H13.5C13.0858 1.50001 12.75 1.16423 12.75 0.750023C12.75 0.335777 13.0858 0 13.5 0H17.25H17.25C17.2747 0 17.2994 0.00130078 17.324 0.00372656C17.3351 0.00481641 17.3459 0.00689062 17.3568 0.00847266C17.3701 0.0103711 17.3834 0.011918 17.3965 0.0145195C17.4091 0.0170156 17.4213 0.0204609 17.4337 0.0235898C17.445 0.0264375 17.4564 0.0289336 17.4677 0.0323438C17.4798 0.036 17.4915 0.0405703 17.5034 0.0448242C17.5146 0.0488672 17.5259 0.0525586 17.537 0.0571289C17.5481 0.0617344 17.5587 0.0671133 17.5695 0.0722461C17.5809 0.0775898 17.5924 0.0826523 17.6035 0.0886289C17.6139 0.0941836 17.6237 0.100512 17.6338 0.106523C17.6447 0.113027 17.6558 0.11918 17.6664 0.126316C17.6776 0.13377 17.6881 0.142066 17.6988 0.150082C17.7076 0.156727 17.7167 0.162879 17.7254 0.16998C17.7636 0.20134 17.7987 0.236426 17.83 0.274641C17.8371 0.283254 17.8433 0.292359 17.8499 0.301254C17.8579 0.311977 17.8662 0.322453 17.8737 0.333598C17.8808 0.34425 17.887 0.355289 17.8935 0.366223C17.8995 0.376277 17.9059 0.386156 17.9114 0.396527C17.9174 0.407672 17.9224 0.419133 17.9278 0.430523C17.9329 0.441316 17.9383 0.451969 17.9429 0.463043C17.9475 0.474117 17.9512 0.485402 17.9552 0.496652C17.9595 0.5085 17.964 0.520207 17.9677 0.532336C17.9711 0.543586 17.9736 0.555012 17.9764 0.566367C17.9796 0.578707 17.983 0.590906 17.9855 0.603492C17.9881 0.616676 17.9897 0.629965 17.9916 0.643219C17.9931 0.654152 17.9952 0.664945 17.9963 0.67602C17.9987 0.700594 18 0.725273 18 0.749988V4.5C18 4.91421 17.6642 5.24999 17.25 5.24999C16.8358 5.24999 16.5 4.91421 16.5 4.5V2.56068L11.7804 7.28033C11.4875 7.57322 11.0126 7.57322 10.7197 7.28033C10.4268 6.98745 10.4268 6.51255 10.7197 6.21967L15.4393 1.50001Z"
        fill="#4F4F4F"
      />
    </g>
    <defs>
      <clipPath id="clip0_970_201145">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="matrix(-1 0 0 1 18 0)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const gridSortAscIcon = (
  <svg width="8.667" height="12.059" viewBox="0 0 8.667 12.059">
    <g data-name="Group 2324">
      <path
        fill="#428bca"
        className="icn-cls-1 grid-sort-asc-icon-fill"
        d="m25.388 60.768-3.6-3.6a.724.724 0 0 0-1.027 0l-3.608 3.6a.728.728 0 0 0 .515 1.242h7.209a.728.728 0 0 0 .511-1.242z"
        transform="translate(-16.934 -56.95)"
      />
      <path
        fill="#b5b9c1"
        data-name="sort-solid"
        d="M17.663 63.194h7.209a.728.728 0 0 1 .515 1.242l-3.6 3.6a.724.724 0 0 1-1.027 0l-3.608-3.6a.728.728 0 0 1 .511-1.242z"
        transform="translate(-16.934 -56.196)"
      />
    </g>
  </svg>
);

export const gridSortDescIcon = (
  <svg width="8.667" height="12.059" viewBox="0 0 8.667 12.059">
    <g data-name="Group 2324">
      <path
        fill="#b5b9c1"
        className="icn-cls-1"
        d="m25.388 60.768-3.6-3.6a.724.724 0 0 0-1.027 0l-3.608 3.6a.728.728 0 0 0 .515 1.242h7.209a.728.728 0 0 0 .511-1.242z"
        transform="translate(-16.934 -56.95)"
      />
      <path
        fill="#428bca"
        className="grid-sort-desc-icon-fill"
        data-name="sort-solid"
        d="M17.663 63.194h7.209a.728.728 0 0 1 .515 1.242l-3.6 3.6a.724.724 0 0 1-1.027 0l-3.608-3.6a.728.728 0 0 1 .511-1.242z"
        transform="translate(-16.934 -56.196)"
      />
    </g>
  </svg>
);

export const sendMessageIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "27"}
    height={height || "22"}
    viewBox="0 0 27 22"
    fill="none"
  >
    <path
      d="M1.047.757 25.037 11 1.046 21.243l-.011-7.36 17.976-2.387v-.991L1.036 8.118l.01-7.361z"
      fill="#428BCA"
      stroke="#428BCA"
    />
  </svg>
);

export const codeViewWithCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 12.0039C23 18.079 18.0751 23.0039 12 23.0039C5.92487 23.0039 1 18.079 1 12.0039C1 5.92877 5.92487 1.00391 12 1.00391C18.0751 1.00391 23 5.92877 23 12.0039ZM21.5276 12.0039C21.5276 17.2658 17.2619 21.5315 12 21.5315C6.73807 21.5315 2.47244 17.2658 2.47244 12.0039C2.47244 6.74198 6.73807 2.47635 12 2.47635C17.2619 2.47635 21.5276 6.74198 21.5276 12.0039Z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="0.25"
    />
    <path
      d="M18.4761 11.6277L15.2717 8.42431C15.2265 8.37171 15.1703 8.32848 15.1066 8.29733C15.0429 8.26618 14.973 8.24778 14.9014 8.24328C14.8299 8.23877 14.758 8.24827 14.6905 8.27118C14.623 8.29408 14.5612 8.3299 14.509 8.37638C14.4569 8.42286 14.4154 8.47901 14.3873 8.5413C14.3592 8.6036 14.3451 8.67069 14.3457 8.7384C14.3464 8.8061 14.3618 8.87294 14.3912 8.93474C14.4205 8.99653 14.463 9.05195 14.5161 9.09752L17.3822 11.9657L14.5161 14.8339C14.4333 14.9302 14.3922 15.0525 14.401 15.1762C14.4097 15.2999 14.4676 15.4159 14.5632 15.501C14.6587 15.5861 14.7848 15.634 14.9161 15.6352C15.0475 15.6363 15.1745 15.5906 15.2717 15.5071L18.4761 12.3038C18.5677 12.2124 18.6188 12.0915 18.6188 11.9657C18.6188 11.84 18.5677 11.719 18.4761 11.6277Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6071 8.01932C14.7069 7.98547 14.8126 7.97155 14.9178 7.97816C15.023 7.98477 15.1261 8.01182 15.2208 8.05812C15.3123 8.10283 15.3943 8.16477 15.4617 8.24101L18.6596 11.4379C18.6596 11.4378 18.6596 11.4379 18.6596 11.4379C18.7986 11.5764 18.8787 11.763 18.8787 11.9599C18.8787 12.1569 18.7986 12.3434 18.6597 12.4819C18.6597 12.482 18.6598 12.4819 18.6597 12.4819L15.4485 15.6921L15.441 15.6985C15.2948 15.824 15.1065 15.8909 14.914 15.8892C14.7215 15.8875 14.5343 15.8174 14.3904 15.6892C14.2461 15.5606 14.1555 15.3823 14.1419 15.1887C14.1282 14.9949 14.1929 14.8057 14.319 14.6588L14.3254 14.6514L17.0149 11.9599L14.3386 9.2817C14.2624 9.21432 14.2002 9.13244 14.1565 9.04031C14.1112 8.94482 14.087 8.84087 14.086 8.73514C14.0849 8.62941 14.1071 8.52501 14.1505 8.42866C14.194 8.33239 14.2575 8.24675 14.3363 8.17658C14.415 8.10645 14.5073 8.05318 14.6071 8.01932ZM14.8852 8.49682C14.8472 8.49443 14.8093 8.49951 14.7741 8.51147C14.7388 8.52342 14.7076 8.54177 14.682 8.56461C14.6564 8.58741 14.637 8.61406 14.6243 8.64237C14.6115 8.67062 14.6053 8.70042 14.6056 8.73008C14.6059 8.75975 14.6127 8.7895 14.626 8.81759C14.6394 8.84577 14.6593 8.87217 14.6854 8.8946L14.6929 8.90106L17.7496 11.9599L14.7081 15.0036C14.6724 15.0481 14.6566 15.1008 14.6602 15.1521C14.664 15.2059 14.6894 15.2596 14.7361 15.3012C14.7832 15.3432 14.8482 15.3689 14.9185 15.3696C14.9858 15.3701 15.0488 15.3476 15.0962 15.3094L18.2925 12.1142C18.3368 12.0701 18.359 12.0145 18.359 11.9599C18.359 11.9054 18.337 11.8501 18.2928 11.806L15.0811 8.59532L15.0746 8.58783C15.053 8.56264 15.0253 8.54097 14.9925 8.52497C14.9598 8.50897 14.9232 8.49921 14.8852 8.49682Z"
      fill="#428BCA"
    />
    <path
      d="M8.86151 14.8325L5.99537 11.9643L8.86151 9.09606C8.91423 9.05039 8.95641 8.99496 8.98543 8.93322C9.01445 8.87149 9.02968 8.80478 9.03017 8.73724C9.03066 8.66971 9.0164 8.60281 8.98828 8.54071C8.96016 8.4786 8.91878 8.42263 8.86673 8.37628C8.81467 8.32993 8.75306 8.2942 8.68572 8.2713C8.61838 8.24841 8.54677 8.23885 8.47535 8.24322C8.40392 8.24759 8.33422 8.26579 8.27058 8.2967C8.20694 8.32761 8.15073 8.37055 8.10545 8.42285L4.90102 11.6291C4.81028 11.7203 4.75977 11.8406 4.75977 11.9657C4.75977 12.0908 4.81028 12.2111 4.90102 12.3023L8.10589 15.5057C8.20306 15.5891 8.33004 15.6348 8.46142 15.6337C8.59281 15.6326 8.71888 15.5846 8.81441 15.4995C8.90994 15.4144 8.96787 15.2984 8.9766 15.1747C8.98533 15.051 8.94423 14.9288 8.86151 14.8325Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.45956 7.97808C8.56449 7.97166 8.66991 7.98567 8.76944 8.01951C8.86898 8.05335 8.96106 8.10651 9.0396 8.17644C9.11817 8.2464 9.18161 8.33177 9.22506 8.42774C9.26854 8.52377 9.29084 8.62785 9.29008 8.73335C9.28931 8.83884 9.2655 8.94259 9.22067 9.03798C9.17732 9.1302 9.11544 9.21226 9.03946 9.27988L6.36278 11.9585L9.04538 14.643L8.86158 14.8267L9.0587 14.6574C9.18482 14.8042 9.24955 14.9935 9.23587 15.1872C9.2222 15.3809 9.13166 15.5592 8.98734 15.6878C8.84343 15.816 8.65624 15.8861 8.46375 15.8878C8.27128 15.8894 8.0829 15.8226 7.93668 15.697L7.92922 15.6906L4.71741 12.4803C4.57974 12.342 4.5 12.1558 4.5 11.9599C4.5 11.764 4.57927 11.5783 4.71694 11.44L7.91585 8.23928C7.98345 8.16329 8.06564 8.10161 8.15714 8.05718C8.2517 8.01126 8.35462 7.9845 8.45956 7.97808ZM8.66959 15.0022L5.6281 11.9585L8.68438 8.9L8.69144 8.89389C8.71737 8.87143 8.73712 8.84504 8.75035 8.8169C8.76355 8.78882 8.77019 8.75914 8.77041 8.72958C8.77062 8.70001 8.76441 8.67029 8.75165 8.6421C8.73886 8.61387 8.71954 8.5873 8.69401 8.56456C8.66843 8.54179 8.63729 8.52348 8.60215 8.51153C8.567 8.49958 8.5292 8.49447 8.49129 8.49679C8.45338 8.49911 8.41689 8.50876 8.38417 8.52465C8.35147 8.54053 8.32369 8.56207 8.30199 8.58713L8.2959 8.59417L5.08526 11.8066C5.0852 11.8067 5.08533 11.8066 5.08526 11.8066C5.04157 11.8506 5.01968 11.9058 5.01968 11.9599C5.01968 12.014 5.04137 12.069 5.08504 12.113C5.08497 12.1129 5.08511 12.1131 5.08504 12.113L8.28148 15.308C8.32896 15.3461 8.39196 15.3687 8.45925 15.3681C8.52952 15.3675 8.59449 15.3417 8.64163 15.2997C8.68836 15.2581 8.71368 15.2044 8.71748 15.1506C8.7211 15.0994 8.7053 15.0467 8.66959 15.0022Z"
      fill="#428BCA"
    />
    <path
      d="M12.5248 6.7672C12.3887 6.74787 12.25 6.78011 12.1391 6.85687C12.0281 6.93363 11.9538 7.04869 11.9324 7.17694L10.4082 16.5908C10.3877 16.7192 10.4218 16.85 10.5032 16.9547C10.5845 17.0594 10.7065 17.1295 10.8424 17.1497C10.8686 17.1534 10.895 17.1554 10.9215 17.1554C11.0455 17.155 11.1652 17.1128 11.2592 17.0365C11.3532 16.9602 11.4153 16.8547 11.4343 16.7391L12.9586 7.32527C12.9788 7.19707 12.9446 7.06653 12.8634 6.96202C12.7821 6.85751 12.6604 6.78749 12.5248 6.7672Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9913 6.6452C12.1572 6.53048 12.3619 6.48363 12.5614 6.51196L12.5248 6.76922L12.5633 6.51224C12.7623 6.54202 12.9447 6.64526 13.0686 6.80457C13.1929 6.96448 13.247 7.16711 13.2153 7.36781L13.2152 7.36883L11.6909 16.7827C11.6612 16.9633 11.5646 17.1253 11.4231 17.2402C11.2818 17.3549 11.1043 17.4166 10.9225 17.4173L10.9209 17.4173C10.8823 17.4172 10.8438 17.4144 10.8056 17.4089L10.8043 17.4087C10.6049 17.3791 10.4221 17.2758 10.2981 17.1161C10.1736 16.9559 10.1196 16.7529 10.1516 16.5519L11.6762 7.1362C11.7096 6.93578 11.825 6.76024 11.9913 6.6452ZM12.4873 7.02635C12.415 7.01632 12.3428 7.03396 12.287 7.0726C12.2315 7.11097 12.1983 7.16535 12.1889 7.22126C12.1889 7.22142 12.1889 7.2211 12.1889 7.22126L10.6648 16.6338C10.6648 16.6338 10.6648 16.6337 10.6648 16.6338C10.656 16.6895 10.6703 16.7482 10.7085 16.7973C10.747 16.8469 10.8079 16.8837 10.88 16.8946C10.8937 16.8965 10.9075 16.8975 10.9214 16.8976C10.9873 16.8972 11.049 16.8746 11.0955 16.8368C11.1419 16.7991 11.1696 16.7498 11.178 16.6993C11.1779 16.6993 11.178 16.6992 11.178 16.6993L12.702 7.28677C12.702 7.28691 12.702 7.28664 12.702 7.28677C12.7107 7.23121 12.6964 7.17251 12.6583 7.12352C12.6198 7.07403 12.5592 7.03735 12.4873 7.02635Z"
      fill="#428BCA"
    />
  </svg>
);

export const downArrowFilledBlue = (): JSX.Element => (
  <svg width="10" height="7" viewBox="0 0 10 7" fill="none">
    <path
      d="M5.72 6.652a.918.918 0 0 1-1.44 0L.281 1.925C-.329 1.202.121 0 1.001 0H9c.88 0 1.33 1.202.72 1.925L5.72 6.652z"
      fill="#428BCA"
    />
  </svg>
);

export const rightArrowFilledBlue = (): JSX.Element => (
  <svg width="10" height="14" viewBox="0 0 10 7" fill="none">
    <path
      d="M6.652 5.72a.918.918 0 0 1 0-1.44L1.925.281C1.202-.329 0 .121 0 1.001V9c0 .88 1.202 1.33 1.925.72L6.652 5.72z"
      fill="#428BCA"
    />
  </svg>
);

export const filledCodeViewWithCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "26"}
    height={height || "26"}
    viewBox="0 0 26 26"
    fill="none"
  >
    <path
      d="M13 24.85c6.545 0 11.85-5.305 11.85-11.85S19.545 1.15 13 1.15 1.15 6.455 1.15 13 6.455 24.85 13 24.85z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="1.7"
    />
    <path
      d="m20.835 12.61-3.7-3.698a.63.63 0 0 0-.88-.055.567.567 0 0 0-.189.417.54.54 0 0 0 .053.227.57.57 0 0 0 .144.188L19.573 13l-3.31 3.312a.547.547 0 0 0 .054.77c.11.098.256.154.408.155a.623.623 0 0 0 .41-.148l3.7-3.698A.551.551 0 0 0 21 13a.551.551 0 0 0-.165-.39zM9.736 16.31 6.426 13l3.31-3.312a.54.54 0 0 0 .006-.831.609.609 0 0 0-.452-.153.63.63 0 0 0-.427.207l-3.7 3.702A.55.55 0 0 0 5 13a.55.55 0 0 0 .163.389l3.7 3.698c.112.097.26.15.41.148a.621.621 0 0 0 .408-.155.547.547 0 0 0 .054-.77zM13.97 7.006a.63.63 0 0 0-.445.104.563.563 0 0 0-.239.37l-1.76 10.868c-.023.148.016.3.11.42a.608.608 0 0 0 .483.232c.143 0 .281-.05.39-.137a.56.56 0 0 0 .202-.344l1.76-10.868a.543.543 0 0 0-.11-.42.608.608 0 0 0-.391-.225z"
      fill="#fff"
      stroke="#fff"
      strokeWidth=".6"
    />
  </svg>
);

export const brushIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "18"}
    height={height || "20"}
    viewBox="0 0 18 20"
    fill="none"
  >
    <path
      d="M16.996.476c-.304-.138-.67-.026-.821.25l-5.587 10.26-1.094-.502c-.906-.416-2.01-.078-2.464.752l-.274.501 6.567 3.018.274-.502c.452-.829.09-1.84-.82-2.26l-1.094-.503L17.27 1.23c.15-.278.028-.615-.274-.754zM1.202 14.944a.592.592 0 0 0-.527.462.55.55 0 0 0 .329.597l2.924 1.344a3.276 3.276 0 0 0 1.68.284.548.548 0 0 0 .32.636l2.737 1.257c.23.104.496.067.68-.082.096-.079 2.18-1.8 3.399-3.696l-6.594-3.03c-1.477 1.801-4.91 2.224-4.948 2.228z"
      fill="#428BCA"
    />
  </svg>
);

export const contextIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.594 19.13c-.438 0-.814-.156-1.126-.468A1.535 1.535 0 0 1 0 17.536V1.594C0 1.156.156.78.468.468A1.535 1.535 0 0 1 1.594 0H14.96l4.171 4.171V9h-1.594V4.889l-3.295-3.295H1.595v15.942h11.85v1.594H1.593zM4.002 6.802h8.513v-2.8H4.002v2.8z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.63 10.5h10.74v.575-.575a1.132 1.132 0 0 1 .8 1.93l-4.113 4.113v5.827a1.131 1.131 0 0 1-1.779.926L15.426 22a1.13 1.13 0 0 1-.483-.926v-4.531L10.83 12.43a1.132 1.132 0 0 1 .8-1.93zm10.692 1.15H11.678l4.416 4.417v4.997l1.812 1.267v-6.264l4.416-4.416z"
      fill="#428BCA"
    />
  </svg>
);

export const filledContextIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.13 9V4.171L14.959 0H1.594C1.17 0 .797.16.478.478.16.798 0 1.17 0 1.594v15.942c0 .425.16.797.478 1.116.32.319.691.478 1.116.478h11.85v-1.966L9.767 13.49A2.631 2.631 0 0 1 11.628 9h7.502zm0 1.5h-7.5a1.134 1.134 0 0 0-1.044.698 1.13 1.13 0 0 0 .244 1.232l4.113 4.113v2.587h2.593c.425 0 .797-.16 1.116-.478.194-.194.329-.408.405-.642v-1.467l.073-.073V10.5zm-6.616-3.698H4.002v-2.8h8.512v2.8z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.63 10.5h10.74a1.134 1.134 0 0 1 1.044.698 1.13 1.13 0 0 1-.244 1.232l-4.113 4.113v5.827a1.131 1.131 0 0 1-1.779.926L15.426 22a1.13 1.13 0 0 1-.483-.926v-4.531L10.83 12.43a1.132 1.132 0 0 1 .8-1.93z"
      fill="#428BCA"
    />
  </svg>
);
export const exampleIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "25"}
    height={height || "20"}
    viewBox="0 0 25 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.518 18.708h9.975c-2.28-1.292-4.651-1.292-6.66-1.292.55 0-1.117-.29-1.117-.646V3.204H1.518v15.504zm11.989 0h9.975V3.204h-2.198V16.77c0 .357-.29.646-.646.646-2.008 0-4.85 0-7.131 1.292zM12.5 20H.872a.646.646 0 0 1-.646-.646V2.558c0-.356.29-.646.646-.646h2.844v-.646c0-.356.29-.646.646-.646 2.535 0 5.391 0 8.138 2.35C15.247.62 18.103.62 20.637.62c.357 0 .646.29.646.646v.646h2.845c.357 0 .646.29.646.646v16.796c0 .357-.29.646-.646.646H12.5z"
      fill="#949494"
    />
  </svg>
);
export const utilityIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "25"}
    height={height || "24"}
    viewBox="0 0 25 24"
    fill="none"
  >
    <g clipPath="url(#9uoenbobha)" fill="#949494">
      <path d="M11.893 5.945c1.457 0 2.689.96 3.106 2.274h6.097v-.64a.703.703 0 0 0-.657-.701l-1.682-.112h-.01a.354.354 0 0 1-.304-.22 7.062 7.062 0 0 0-.212-.474.354.354 0 0 1 .05-.39l1.016-1.161a.703.703 0 0 0-.031-.96l-1.73-1.73a.703.703 0 0 0-.96-.032l-1.161 1.017a.353.353 0 0 1-.39.05 6.964 6.964 0 0 0-.866-.358.354.354 0 0 1-.24-.312l-.1-1.54A.703.703 0 0 0 13.115 0h-2.445a.703.703 0 0 0-.702.657l-.101 1.54a.353.353 0 0 1-.24.31c-.297.1-.586.22-.866.359a.353.353 0 0 1-.39-.05l-1.16-1.017a.703.703 0 0 0-.96.031L4.52 3.56a.703.703 0 0 0-.032.96l1.017 1.161a.354.354 0 0 1 .05.391 7.11 7.11 0 0 0-.213.473.354.354 0 0 1-.304.22l-.01.001-1.681.112a.703.703 0 0 0-.657.701v.64h6.097a3.264 3.264 0 0 1 3.105-2.274zM22.076 13.969l-1.166-1.696a2.337 2.337 0 0 1-.388-1.666c.053-.36.062-.537.086-.982H3.058c-.025.917.232 2.531 1.177 4.11.55.931 1.574 2.663 1.574 5.308v4.254c0 .388.315.703.703.703h7.866a.703.703 0 0 0 .694-.588l.234-1.413c.034-.204.105-.394.598-.472.677-.107 1.644.098 2.258.15a2.195 2.195 0 0 0 2.37-2.447l-.313-2.631 1.37-.703c.71-.364.94-1.27.487-1.927z" />
    </g>
    <defs>
      <clipPath id="9uoenbobha">
        <path fill="#fff" transform="translate(.5)" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const chatIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    width={width || "18.5"}
    height={height || "16.5"}
    viewBox="0 0 18.5 16.5"
    fill="#85c0ec"
  >
    <g id="Chat">
      <path
        className="cls-1"
        d="M19.09,7a7.14,7.14,0,0,0-2.21-3.82A9.85,9.85,0,0,0,10,.77,9.88,9.88,0,0,0,4.1,2.61,8.21,8.21,0,0,0,1,7a6.71,6.71,0,0,0,.19,4.2,7.15,7.15,0,0,0,2.66,3.24,2.89,2.89,0,0,1-.78,1.52L1.75,17.26H3.62a4.82,4.82,0,0,0,1.94-.4,4.73,4.73,0,0,0,1.52-1A12.26,12.26,0,0,0,10,16.2a9.9,9.9,0,0,0,6.86-2.37,7.34,7.34,0,0,0,1.78-2.49A7.19,7.19,0,0,0,19.09,7ZM10,14.63a10.68,10.68,0,0,1-3-.43l-.48-.14-.33.39a3.51,3.51,0,0,1-1,.83A4.44,4.44,0,0,0,5.45,14v-.45l-.4-.24a5.13,5.13,0,0,1-2.33-2.51A5.25,5.25,0,0,1,2.5,7.39c.7-2.51,3.29-5,7.53-5h.25a8.33,8.33,0,0,1,5.56,2,5.74,5.74,0,0,1,1.37,1.89,5.6,5.6,0,0,1,.48,2.29C17.69,11.43,15.29,14.63,10,14.63Z"
        transform="translate(-0.75 -0.76)"
      />
      <path
        className="cls-1"
        d="M6.46,10A1.28,1.28,0,1,0,5.2,8.71,1.26,1.26,0,0,0,6.46,10Z"
        transform="translate(-0.75 -0.76)"
      />
      <path
        className="cls-1"
        d="M9.82,10A1.28,1.28,0,1,0,8.56,8.71,1.26,1.26,0,0,0,9.82,10Z"
        transform="translate(-0.75 -0.76)"
      />
      <path
        className="cls-1"
        d="M13.18,10a1.28,1.28,0,1,0-1.26-1.27A1.26,1.26,0,0,0,13.18,10Z"
        transform="translate(-0.75 -0.76)"
      />
    </g>
  </svg>
);

export const transparentDvSumLogo = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "25"}
    height={height || "13"}
    viewBox="0 0 25 13"
    fill="none"
  >
    <path
      d="M10.6348 5.83258L12.9371 4.18364L15.6951 8.34764C15.6951 8.34764 20.6891 1.7352 21.5677 0.572257C21.7815 0.283793 22.1048 0.0874566 22.4681 0.0255785C22.5034 0.019035 22.545 0.0255789 22.5747 0H22.8655C22.8736 0.0172509 22.8903 0.0130832 22.9052 0.0148678C23.1924 0.0484851 23.4623 0.164732 23.6794 0.348314C23.8964 0.531895 24.0504 0.774214 24.1212 1.04338C24.127 1.10302 24.1418 1.16153 24.1652 1.21708V1.52402C24.1467 1.57646 24.1344 1.63074 24.1286 1.68583C24.0827 1.86919 23.9995 2.04203 23.8837 2.19443C23.1526 3.16345 17.2384 10.9983 16.7653 11.6277C16.6277 11.8208 16.4411 11.9771 16.223 12.0819C16.005 12.1866 15.7627 12.2363 15.519 12.2262C15.2754 12.2161 15.0385 12.1467 14.8306 12.0244C14.6227 11.9021 14.4508 11.7309 14.331 11.5272C13.8554 10.7628 10.6366 5.83199 10.6366 5.83199L10.6348 5.83258Z"
      fill="white"
    />
    <path
      d="M4.79867 7.92389C4.79867 7.92389 5.57003 7.92389 5.88378 7.92746C6.14623 7.93609 6.40701 7.88432 6.64433 7.77649C6.88165 7.66865 7.08862 7.50788 7.24792 7.30761C7.4023 7.13258 7.51999 6.93059 7.59454 6.71275C7.68117 6.44578 7.70238 6.16322 7.65655 5.88709C7.59941 5.47625 7.38901 5.0992 7.06432 4.82576C6.73963 4.55233 6.32265 4.40105 5.8906 4.39994H4.80053V7.92746L4.79867 7.92389ZM10.6639 5.87401C10.2683 5.31603 9.89622 4.77828 9.47395 4.23874C9.33048 4.04867 9.17691 3.86581 9.01386 3.69087C8.67538 3.37597 8.2736 3.1305 7.833 2.96942C7.39241 2.80834 6.92223 2.73504 6.45114 2.75397C5.28666 2.75873 2.86903 2.75397 2.86903 2.75397L2.87399 9.4842C2.87399 9.4842 5.39765 9.48419 6.51997 9.47408C6.85231 9.47971 7.18167 9.41306 7.48333 9.27913C7.78498 9.1452 8.05111 8.94747 8.26173 8.70077C8.43598 8.50304 8.59064 8.29015 8.72368 8.06487C8.84829 7.85196 9.03048 7.67526 9.25103 7.55339C9.47159 7.43153 9.72233 7.36902 9.97683 7.37245C10.2277 7.37686 10.4731 7.44382 10.6888 7.56677C10.9046 7.68972 11.0833 7.86441 11.2073 8.07367C11.3314 8.28294 11.3965 8.51958 11.3964 8.76032C11.3962 9.00105 11.3307 9.23761 11.2064 9.44672C10.8958 9.9925 10.4957 10.4868 10.0215 10.9107C9.34752 11.5186 8.51722 11.9438 7.61562 12.1426C7.31032 12.2081 6.99835 12.2406 6.68552 12.2396C4.94935 12.2396 3.21172 12.2396 1.47265 12.2396C1.13583 12.2483 0.806568 12.143 0.542556 11.9421C0.264738 11.7361 0.0773819 11.4377 0.0173617 11.1058C0.00872476 11.0618 0.00292657 11.0173 0 10.9725V1.27635C0 1.26029 0.00371732 1.22281 0.00557751 1.20675C0.0436837 0.89227 0.194299 0.600206 0.431744 0.380333C0.669188 0.160459 0.978768 0.0263891 1.30771 0.000976562H6.88829C7.62531 0.0385741 8.35042 0.195234 9.03309 0.464366C9.96095 0.8111 10.777 1.38669 11.3986 2.13295C11.8085 2.62311 12.1873 3.13409 12.5575 3.65221C12.6884 3.83484 12.8297 4.00912 12.9463 4.20364C12.9668 4.23814 12.9798 4.26908 12.9829 4.27503C13.139 4.55499 13.1856 4.87928 13.1143 5.18933C13.0473 5.5166 12.856 5.80832 12.5774 6.00785C12.4178 6.12314 12.2356 6.20642 12.0417 6.25272C11.8478 6.29902 11.6462 6.30738 11.4489 6.27732C11.1551 6.21064 10.8845 6.07163 10.6639 5.87401V5.87401Z"
      fill="white"
    />
  </svg>
);

export const logoutIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "19"}
    height={height || "19"}
    viewBox="0 0 19 19"
    fill="none"
  >
    <g clipPath="url(#xpz03dzq3a)">
      <path
        d="M13.884 2.22a.161.161 0 0 0-.233.144v1.29c0 .11.059.213.151.273.453.285.872.621 1.25 1a7.132 7.132 0 0 1 2.093 5.063 7.14 7.14 0 0 1-2.093 5.063 7.094 7.094 0 0 1-2.274 1.534 7.085 7.085 0 0 1-2.783.563 7.085 7.085 0 0 1-2.782-.563 7.093 7.093 0 0 1-2.274-1.534A7.132 7.132 0 0 1 2.846 9.99a7.139 7.139 0 0 1 2.093-5.062c.381-.382.8-.716 1.25-1a.321.321 0 0 0 .15-.274V2.362a.162.162 0 0 0-.233-.144 8.692 8.692 0 0 0-4.79 7.664c-.056 4.797 3.868 8.783 8.663 8.793 4.801.01 8.695-3.884 8.695-8.687 0-3.399-1.949-6.342-4.79-7.768zm-4.532 8.74h1.286c.088 0 .16-.072.16-.16V1.478a.161.161 0 0 0-.16-.16H9.352a.161.161 0 0 0-.16.16V10.8c0 .088.072.16.16.16z"
        fill="#C9C9C9"
        stroke="#C9C9C9"
        strokeWidth=".5"
      />
    </g>
    <defs>
      <clipPath id="xpz03dzq3a">
        <path fill="#fff" transform="translate(.995 .996)" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const linkToIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "9"}
    height={height || "9"}
    viewBox="0 0 9 9"
    fill="none"
  >
    <path
      d="M8.996.737 8.99.702 8.984.658l-.01-.04-.01-.037C8.962.567 8.957.555 8.952.54L8.938.506 8.92.47C8.915.457 8.91.445 8.903.433 8.897.42 8.89.41 8.883.4l-.02-.036-.027-.035-.021-.03A.825.825 0 0 0 8.76.24H8.76A.823.823 0 0 0 8.7.184L8.671.164C8.66.154 8.648.146 8.636.138L8.6.116l-.033-.02L8.53.08 8.495.062 8.458.05 8.42.035l-.037-.01-.04-.01L8.298.01 8.263.004A.836.836 0 0 0 8.182 0H2.455a.818.818 0 1 0 0 1.636h3.752L.24 7.603A.818.818 0 0 0 1.397 8.76l5.967-5.967v3.752a.818.818 0 1 0 1.636 0V.818a.823.823 0 0 0-.004-.08z"
      fill="#C9C9C9"
    />
  </svg>
);

export const chatNavIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "18"}
    viewBox="0 0 20 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.345 17h1.276c.631 0 1.256-.13 1.837-.378a4.724 4.724 0 0 0 1.547-1.07 12.06 12.06 0 0 0 3.025.388 9.623 9.623 0 0 0 6.685-2.31 7.103 7.103 0 0 0 1.711-2.403 6.967 6.967 0 0 0 .418-4.237 6.922 6.922 0 0 0-2.125-3.68 9.645 9.645 0 0 0-6.69-2.3A9.732 9.732 0 0 0 4.244 2.8a7.894 7.894 0 0 0-2.998 4.225 6.35 6.35 0 0 0 .18 4.032 6.92 6.92 0 0 0 2.695 3.215 3.091 3.091 0 0 1-.873 1.818l-.902.91zm5.376-8.307c0 .702-.564 1.271-1.26 1.271-.696 0-1.26-.569-1.26-1.271s.564-1.272 1.26-1.272c.696 0 1.26.57 1.26 1.272zm2.1 1.271c.696 0 1.26-.569 1.26-1.271S10.517 7.42 9.82 7.42c-.696 0-1.26.57-1.26 1.272 0 .702.564 1.271 1.26 1.271zm4.62-1.271c0 .702-.564 1.271-1.26 1.271-.695 0-1.26-.569-1.26-1.271s.565-1.272 1.26-1.272c.697 0 1.26.57 1.26 1.272z"
      fill="#C9C9C9"
    />
    <path
      d="M3.621 17v.25V17zm-1.276 0-.177-.176-.422.426h.6V17zm3.113-.378-.098-.23.098.23zm1.547-1.07.063-.242-.141-.037-.102.106.18.173zm3.025.388.01-.25h-.01v.25zm6.685-2.31.162.19.007-.006-.17-.184zm1.711-2.403.23.1-.23-.1zM16.72 3.31l.168-.185-.006-.005-.162.19zm-6.69-2.3-.003.25h.015l-.011-.25zM4.244 2.8l-.144-.204h-.001l.145.204zM1.245 7.025l-.24-.07.24.07zm.18 4.032-.233.09.002.006.232-.096zm2.695 3.215.248.029.019-.156-.133-.084-.134.211zm-.873 1.818-.178-.176.178.176zm1.693-2.555.13-.214-.007-.004-.007-.004-.116.222zm.264.16.25.007.004-.145-.124-.076-.13.214zm-.008.31-.25-.007.25.007zm-.421 1.74-.225-.11-.262.542.569-.196-.082-.236zM6.43 14.6l-.192-.16.192.16zm.223-.266.07-.24-.157-.045-.105.124.192.161zm.33.095.07-.24-.07.24zm3.046.435v-.25.25zm7.912-6.409h.25-.25zm-1.935-4.363.167-.186-.006-.006-.161.192zM3.62 16.75H2.345v.5h1.276v-.5zm1.74-.358a4.438 4.438 0 0 1-1.74.358v.5a4.939 4.939 0 0 0 1.936-.398l-.197-.46zm1.464-1.013a4.473 4.473 0 0 1-1.465 1.013l.197.46a4.974 4.974 0 0 0 1.629-1.127l-.36-.346zm3.205.311c-1 0-1.994-.128-2.962-.38l-.125.484a12.31 12.31 0 0 0 3.087.396v-.5zm6.522-2.25a9.373 9.373 0 0 1-6.511 2.25l-.022.5c2.5.11 4.95-.736 6.858-2.37l-.325-.38zm1.645-2.312a6.854 6.854 0 0 1-1.651 2.318l.338.368a7.354 7.354 0 0 0 1.771-2.487l-.458-.2zm.402-4.086c.296 1.371.155 2.8-.402 4.086l.459.199c.598-1.381.75-2.917.432-4.39l-.489.105zm-2.047-3.546a6.672 6.672 0 0 1 2.047 3.546l.489-.105a7.172 7.172 0 0 0-2.201-3.812l-.335.37zM10.04 1.259a9.395 9.395 0 0 1 6.516 2.242l.324-.38A9.895 9.895 0 0 0 10.02.76l.022.5zM4.387 3.004a9.482 9.482 0 0 1 5.639-1.744l.008-.5a9.982 9.982 0 0 0-5.935 1.836l.288.408zm-2.902 4.09a7.644 7.644 0 0 1 2.903-4.09l-.29-.408a8.144 8.144 0 0 0-3.093 4.359l.48.14zm.174 3.873a6.1 6.1 0 0 1-.174-3.874l-.48-.137a6.6 6.6 0 0 0 .187 4.192l.467-.18zm2.595 3.094a6.67 6.67 0 0 1-2.597-3.099l-.463.19a7.17 7.17 0 0 0 2.792 3.331l.268-.422zm-.83 2.205c.525-.53.858-1.222.944-1.965l-.496-.058a2.841 2.841 0 0 1-.803 1.671l.355.352zm-.901.91.901-.91-.355-.352-.901.91.355.352zm3.938-6.962c.836 0 1.51-.683 1.51-1.521h-.5c0 .566-.454 1.021-1.01 1.021v.5zm-1.51-1.521c0 .838.674 1.521 1.51 1.521v-.5c-.555 0-1.01-.455-1.01-1.021h-.5zm1.51-1.522c-.836 0-1.51.684-1.51 1.522h.5c0-.566.455-1.022 1.01-1.022v-.5zm1.51 1.522c0-.838-.674-1.522-1.51-1.522v.5c.556 0 1.01.456 1.01 1.022h.5zm2.86 0c0 .566-.454 1.021-1.01 1.021v.5c.836 0 1.51-.683 1.51-1.521h-.5zM9.82 7.67c.556 0 1.01.456 1.01 1.022h.5c0-.838-.674-1.522-1.51-1.522v.5zM8.81 8.693c0-.566.454-1.022 1.01-1.022v-.5c-.836 0-1.51.684-1.51 1.522h.5zm1.01 1.021c-.556 0-1.01-.455-1.01-1.021h-.5c0 .838.674 1.521 1.51 1.521v-.5zm3.36.5c.837 0 1.51-.683 1.51-1.521h-.5c0 .566-.454 1.021-1.01 1.021v.5zm-1.51-1.521c0 .838.675 1.521 1.51 1.521v-.5c-.555 0-1.01-.455-1.01-1.021h-.5zm1.51-1.522c-.835 0-1.51.684-1.51 1.522h.5c0-.566.455-1.022 1.01-1.022v-.5zm1.51 1.522c0-.838-.673-1.522-1.51-1.522v.5c.556 0 1.01.456 1.01 1.022h.5zM2.023 7.243a5.664 5.664 0 0 0 .252 3.76l.46-.198a5.163 5.163 0 0 1-.23-3.427l-.482-.134zm.252 3.76a5.598 5.598 0 0 0 2.55 2.753l.232-.443a5.097 5.097 0 0 1-2.323-2.508l-.459.198zm2.537 2.745.263.16.26-.427-.264-.16-.26.427zm.143-.06-.008.31.5.014.008-.31-.5-.014zm-.008.31a3.978 3.978 0 0 1-.396 1.638l.45.218c.278-.575.43-1.204.446-1.843l-.5-.012zm-.09 1.983a3.991 3.991 0 0 0 1.766-1.221l-.384-.32a3.49 3.49 0 0 1-1.545 1.068l.164.473zm1.766-1.22.223-.266-.384-.322-.223.267.384.32zm-.038-.187.33.096.139-.48-.33-.096-.14.48zm.33.095c1.012.296 2.06.446 3.115.445v-.5c-1.007 0-2.008-.142-2.975-.425l-.14.48zm3.115.445c2.77 0 4.813-.847 6.166-2.114a6.223 6.223 0 0 0 1.996-4.545h-.5a5.723 5.723 0 0 1-1.838 4.18c-1.245 1.166-3.158 1.98-5.824 1.98v.5zm8.162-6.659a6.16 6.16 0 0 0-.528-2.491l-.457.203c.319.72.485 1.5.485 2.289h.5zm-.528-2.491a6.112 6.112 0 0 0-1.49-2.058l-.335.371a5.612 5.612 0 0 1 1.368 1.89l.457-.203zM16.167 3.9a8.872 8.872 0 0 0-6.15-2.08l.025.5a8.373 8.373 0 0 1 5.803 1.963l.322-.383z"
      fill="#C9C9C9"
    />
  </svg>
);

export const pieChartIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "22"}
    height={height || "22"}
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.504 11.69c0 4.855 3.95 8.805 8.806 8.805 2.333 0 4.52-.898 6.178-2.532l-6.299-6.15a.172.172 0 0 1-.051-.123V2.886c-4.777.092-8.634 4.006-8.634 8.804zm10.052-1.553V1.505c4.719.09 8.54 3.913 8.632 8.632h-8.632zm.557 1.418h8.38a8.747 8.747 0 0 1-2.383 5.855l-5.997-5.855z"
      fill="#428BCA"
    />
  </svg>
);

export const columnChartIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "26"}
    height={height || "22"}
    viewBox="0 0 26 22"
    fill="none"
  >
    <path
      d="M23.111 0H2.89C1.3 0 0 1.1 0 2.444v17.111C0 20.9 1.3 22 2.889 22H23.11C24.7 22 26 20.9 26 19.555V2.445C26 1.1 24.7 0 23.111 0zm0 19.555H2.89V2.445H23.11v17.11zm-17.333-11h2.889v8.556h-2.89V8.556zm5.778-3.666h2.888V17.11h-2.888V4.89zm5.777 7.333h2.89v4.89h-2.89v-4.89z"
      fill="#428BCA"
    />
  </svg>
);

export const chartGridIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "30"}
    height={height || "30"}
    viewBox="0 0 30 30"
    fill="none"
  >
    <mask
      id="mask0_1741_276271"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="3"
      y="4"
      width="24"
      height="22"
    >
      <path
        d="M24.3333 4H5.66667C4.2 4 3 5.1 3 6.44445V23.5555C3 24.9 4.2 26 5.66667 26H24.3333C25.8 26 27 24.9 27 23.5555V6.44445C27 5.1 25.8 4 24.3333 4ZM25.1538 23.5555H4.84615V6H25.1538V23.5555ZM8.33333 10.5556H11V21.1112H8.33333V10.5556ZM13.6667 7.88888H16.3333V21.1112H13.6667V7.88888ZM19 11.2222H21.6667V21.1112H19V11.2222Z"
        fill="#428BCA"
      />
    </mask>
    <g mask="url(#mask0_1741_276271)">
      <rect x="3" y="4" width="26" height="11" fill="#428BCA" />
    </g>
    <mask
      id="mask1_1741_276271"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="3"
      y="4"
      width="24"
      height="22"
    >
      <path
        d="M15 25.9986H5.39102C4.99293 26.013 4.5982 25.9158 4.24502 25.7162C3.89185 25.5167 3.5922 25.2217 3.37528 24.8599C3.11373 24.4314 2.98313 23.9248 3.00187 23.4115V6.60321C2.98377 6.11686 3.09741 5.63539 3.32871 5.21808C3.56001 4.80076 3.89885 4.4658 4.30364 4.25446C4.65608 4.06863 5.0461 3.98216 5.43759 4.00306H24.6907C25.1899 4.00317 25.6756 4.17906 26.0745 4.50417C26.4735 4.82927 26.764 5.28597 26.9024 5.80552C26.9601 6.02458 26.9904 6.25103 26.9924 6.47881C26.9972 11.7736 26.9972 17.0682 26.9924 22.3624C27.0085 22.8518 26.999 23.3417 26.9643 23.8299C26.8976 24.4252 26.632 24.9734 26.2178 25.3712C25.8035 25.7689 25.2692 25.9887 24.7156 25.989C21.4754 25.9937 18.2364 25.9937 14.9983 25.989L15 25.9986ZM7.59793 18.0076H9.82651C10.2176 18.0076 10.3886 17.8337 10.3886 17.4135V14.5768C10.3886 14.1844 10.2336 14.0078 9.87063 14.0069C8.37903 14.0029 6.88717 14.0029 5.39504 14.0069C5.01117 14.0069 4.85302 14.1862 4.85302 14.5976V17.4344C4.85302 17.8276 5.02323 18.0076 5.39024 18.0076H7.59793ZM7.61156 12.0053H9.86023C10.2256 12.0053 10.3855 11.8314 10.3863 11.4434V8.58662C10.3976 8.50822 10.3918 8.428 10.3693 8.35247C10.3469 8.27694 10.3084 8.20819 10.257 8.15167C10.2052 8.09514 10.1418 8.05262 10.0721 8.02753C10.0023 8.00244 9.92813 7.99549 9.85543 8.00725H5.39828C5.01922 8.00725 4.85294 8.19254 4.85214 8.59617V11.372C4.85214 11.8496 5.00079 12.0114 5.44249 12.0123H7.61078L7.61156 12.0053ZM22.3803 18.0076H24.5719C24.9895 18.0076 25.1477 17.8398 25.1477 17.3918V14.5959C25.1477 14.1705 25.0032 14.0078 24.6129 14.0069C23.1272 14.004 21.6414 14.004 20.1557 14.0069C19.7783 14.0069 19.6153 14.1888 19.6145 14.5985V17.4144C19.6145 17.8354 19.7751 18.0076 20.1702 18.0076H22.3803ZM22.3851 12.0053H24.6338C24.9911 12.0053 25.1453 11.8313 25.1469 11.4529V8.59617C25.1469 8.17601 24.9863 8.00463 24.5847 8.00289H20.1461C20.0735 7.99109 19.9993 7.99793 19.9296 8.02286C19.8598 8.04779 19.7965 8.0901 19.7446 8.14641C19.6929 8.20277 19.6541 8.27151 19.6313 8.34705C19.6086 8.42259 19.6026 8.50282 19.6137 8.58136V11.4381C19.6028 11.5155 19.6089 11.5946 19.6315 11.669C19.6541 11.7433 19.6926 11.8109 19.7438 11.8661C19.795 11.9215 19.8574 11.9631 19.9262 11.9874C19.995 12.0118 20.0681 12.0182 20.1396 12.0062C20.8889 12.0062 21.6359 12.0062 22.3827 12.0062L22.3851 12.0053ZM14.987 12.0053H17.1779C17.6212 12.0053 17.7681 11.8461 17.7681 11.3668V8.63185C17.7681 8.17081 17.6124 7.99939 17.1892 7.99939H12.8252C12.3884 7.99939 12.2389 8.16385 12.2381 8.64316V11.399C12.2381 11.8496 12.3795 12.0019 12.7955 12.0027C13.5263 12.0056 14.2558 12.0056 14.9839 12.0027L14.987 12.0053ZM15.004 14.0061H12.7553C12.3883 14.0061 12.2373 14.1731 12.2365 14.5698V17.4057C12.2365 17.8311 12.3971 18.0068 12.7866 18.0068H17.2244C17.6051 18.0068 17.7642 17.8328 17.765 17.4179C17.7682 16.4789 17.7682 15.5403 17.765 14.602C17.765 14.174 17.6043 14.0061 17.2108 14.0052C16.4776 14.0052 15.7388 14.0052 15 14.0052L15.004 14.0061ZM7.60352 24.0004H9.8522C10.2256 24.0004 10.387 23.8264 10.3878 23.4263V20.5895C10.3878 20.1824 10.2208 19.9971 9.84573 19.9971H5.38789C5.01927 19.9971 4.85216 20.1781 4.85135 20.5748V23.4115C4.85135 23.8273 5.01199 23.9969 5.39426 23.9969L7.60352 24.0004ZM22.373 24.0004H24.6386C24.7086 24.0117 24.7801 24.0048 24.8472 23.9805C24.9143 23.9561 24.9751 23.915 25.0248 23.8604C25.0744 23.8056 25.1114 23.7389 25.1327 23.6658C25.1541 23.5926 25.1593 23.515 25.1477 23.4393V20.5626C25.1584 20.4869 25.1527 20.4095 25.1311 20.3366C25.1095 20.2637 25.0726 20.1972 25.0232 20.1424C24.9739 20.0876 24.9134 20.046 24.8467 20.0208C24.7799 19.9956 24.7087 19.9875 24.6386 19.9971H20.126C20.0559 19.9867 19.9845 19.9941 19.9176 20.0189C19.8507 20.0436 19.7901 20.0851 19.7406 20.1398C19.691 20.1945 19.6538 20.2609 19.6322 20.3339C19.6106 20.4068 19.6051 20.4843 19.6161 20.5599V23.3958C19.6161 23.8378 19.7687 23.9952 20.1831 23.9952L22.373 24.0004ZM14.996 24.0004H17.1892C17.622 24.0004 17.7634 23.8543 17.7658 23.3915C17.7695 22.4636 17.7695 21.5374 17.7658 20.613C17.7658 20.1589 17.6132 20.0041 17.1876 20.0041H12.8195C12.3883 20.0041 12.2358 20.1702 12.2358 20.6304V23.4089C12.2358 23.8439 12.3859 24.0083 12.7843 24.0091C13.5143 24.0031 14.2531 24.0022 14.992 24.0022L14.996 24.0004Z"
        fill="#428BCA"
      />
    </mask>
    <g mask="url(#mask1_1741_276271)">
      <rect x="3" y="16" width="26" height="10" fill="#428BCA" />
    </g>
  </svg>
);
export const workflowIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_650_122093)">
      <path d="M24 16.9688H16.9688V24H24V16.9688Z" fill="#C9C9C9" />
      <path
        d="M22.5938 2.8125H7.03125V0H0V7.03125H7.03125V4.21875H22.5938V11.2969H18.5879V9.86452L16.4531 11.9999L18.5879 14.1357V12.7031H22.5938C23.3692 12.7031 24 12.0723 24 11.2969V4.21875C24 3.44334 23.3692 2.8125 22.5938 2.8125Z"
        fill="#C9C9C9"
      />
      <path
        d="M16.0312 20.4842L13.8965 18.3489V19.7812H1.45312V12.7031H8.48438V15.5156H15.5156V8.48438H8.48438V11.2969H1.45312C0.677719 11.2969 0.046875 11.9277 0.046875 12.7031V19.7812C0.046875 20.5567 0.677719 21.1875 1.45312 21.1875H13.8965V22.62L16.0312 20.4842Z"
        fill="#C9C9C9"
      />
    </g>
    <defs>
      <clipPath id="clip0_650_122093">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const assignToMe = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "25"}
    height={height || "25"}
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M16.466 12.688a3.763 3.763 0 0 0-2.756 1.187 5.768 5.768 0 0 0-3.62-1.26h-.01a5.725 5.725 0 0 0-4.133 1.736c-1.104 1.128-1.708 2.67-1.705 4.344a.34.34 0 0 0 .345.345l9.057-.018.062.07a3.796 3.796 0 1 0 2.76-6.404zM4.943 18.346c.072-1.356.597-2.595 1.497-3.516a5.032 5.032 0 0 1 3.64-1.525h.01a5.092 5.092 0 0 1 3.195 1.111 3.804 3.804 0 0 0-.13 3.916l-8.212.014zm11.523 1.242a3.105 3.105 0 1 1 0-6.21 3.105 3.105 0 0 1 0 6.21zM10.084 11.794a3.647 3.647 0 1 0 0-7.294 3.647 3.647 0 0 0 0 7.294zm0-6.604a2.957 2.957 0 1 1 0 5.914 2.957 2.957 0 0 1 0-5.914z"
      fill="#4F4F4F"
      stroke="#4F4F4F"
      strokeWidth=".3"
    />
    <path
      d="m17.627 15.43-1.667 1.357-.61-.714a.345.345 0 1 0-.525.448l.828.97a.347.347 0 0 0 .48.044l1.928-1.57a.345.345 0 0 0-.434-.534z"
      fill="#4F4F4F"
      stroke="#4F4F4F"
      strokeWidth=".3"
    />
  </svg>
);

export const waitingStatus = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "22"}
    height={height || "22"}
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      opacity=".9"
      d="M6.575 15.425h1.5l5.75-5.75-1.5-1.5-5.75 5.75v1.5zm7.75-6.25 1-1a.71.71 0 0 0 .213-.488.623.623 0 0 0-.188-.487l-.525-.525a.71.71 0 0 0-.487-.212.622.622 0 0 0-.488.187l-1.025 1.025 1.5 1.5zM11 21a9.676 9.676 0 0 1-3.875-.788 10.144 10.144 0 0 1-3.188-2.15 10.142 10.142 0 0 1-2.15-3.187A9.676 9.676 0 0 1 1 11c0-1.383.262-2.683.788-3.9a9.994 9.994 0 0 1 2.15-3.175 10.25 10.25 0 0 1 3.187-2.137A9.676 9.676 0 0 1 11 1c1.383 0 2.683.262 3.9.788a10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 21 11a9.676 9.676 0 0 1-.788 3.875 10.25 10.25 0 0 1-2.137 3.188 9.994 9.994 0 0 1-3.175 2.15A9.738 9.738 0 0 1 11 21z"
      fill="#4F4F4F"
      stroke="#fff"
      strokeWidth=".6"
    />
  </svg>
);

export const modifyingStatus = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "29"}
    height={height || "26"}
    viewBox="0 0 29 26"
    fill="none"
  >
    <path
      d="M1.27006 12.5183C1.60083 12.8106 2.10604 12.7792 2.39831 12.4484L2.41121 12.4338V12.994C2.41121 16.2609 3.68351 19.3323 5.9937 21.6425C8.30369 23.9525 11.3751 25.2246 14.6421 25.2246C16.6154 25.2246 18.5763 24.7433 20.313 23.833C21.9933 22.9523 23.4682 21.6711 24.5781 20.1275C24.8358 19.7693 24.7542 19.2697 24.3958 19.012C24.0373 18.7541 23.5377 18.8357 23.28 19.1941C22.3145 20.5368 21.0318 21.6513 19.5707 22.4171C18.0622 23.2079 16.3579 23.6259 14.6421 23.6259C8.77955 23.6259 4.0099 18.8563 4.0099 12.9938V12.4336L4.02302 12.4482C4.31528 12.7792 4.82049 12.8104 5.15126 12.5181C5.48224 12.2259 5.51347 11.7206 5.22121 11.3899L3.80986 9.79201C3.65811 9.62027 3.43995 9.52202 3.21077 9.52202C2.98158 9.52202 2.76342 9.62027 2.61167 9.79201L1.20033 11.3899C0.907856 11.7208 0.939081 12.2261 1.27006 12.5183Z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="0.3"
    />
    <path
      d="M4.88143 6.98835C5.23988 7.24606 5.73927 7.16467 5.99718 6.80621C6.96264 5.46377 8.24534 4.34926 9.70644 3.58322C11.215 2.79241 12.9194 2.37441 14.6351 2.37441C20.4976 2.37441 25.2673 7.14406 25.2673 13.0066V13.5667L25.2542 13.5519C24.9619 13.2212 24.4567 13.1897 24.1259 13.4822C23.7949 13.7745 23.7637 14.2797 24.056 14.6105L25.4673 16.2083C25.6193 16.3801 25.8372 16.4785 26.0664 16.4785C26.2956 16.4785 26.514 16.3801 26.6655 16.2083L28.0771 14.6105C28.3693 14.2795 28.3381 13.7745 28.0071 13.4822C27.8552 13.3477 27.6664 13.2818 27.4782 13.2818C27.2571 13.2818 27.0369 13.3731 26.8789 13.5519L26.866 13.5667V13.0066C26.866 9.73944 25.5937 6.6682 23.2835 4.358C20.9735 2.04781 17.902 0.775721 14.6351 0.775721C12.6619 0.775721 10.7008 1.25699 8.96413 2.16729C7.28405 3.04803 5.80921 4.32948 4.69928 5.87281C4.44158 6.23126 4.52297 6.73065 4.88143 6.98835Z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="0.3"
    />
    <path
      d="M8.40039 19.2754H10.4923L18.5111 11.2565L16.4193 9.16464L8.40039 17.1835V19.2754ZM19.2084 10.5592L20.603 9.16464C20.789 8.9787 20.8877 8.75208 20.8994 8.48478C20.911 8.21749 20.8238 7.99087 20.6379 7.80492L19.9057 7.07277C19.7198 6.88682 19.4932 6.78804 19.2259 6.77642C18.9586 6.76479 18.7319 6.85196 18.546 7.0379L17.1166 8.46735L19.2084 10.5592Z"
      fill="#428BCA"
    />
  </svg>
);
export const commentIcon2 = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "18"}
    height={height || "16"}
    viewBox="0 0 18 16"
    fill="none"
  >
    <g clipPath="url(#clip0_622_112251)">
      <path
        d="M17.8446 6.05165C17.5383 4.62157 16.7856 3.32486 15.6943 2.3474C13.845 0.743876 11.4494 -0.0924462 9.0003 0.0104337C6.94457 -0.0219364 4.93259 0.603417 3.25975 1.79468C1.80363 2.83624 0.741276 4.3356 0.243539 6.05165C-0.134195 7.39391 -0.0693915 8.82159 0.428404 10.1244C0.956767 11.4058 1.85822 12.5002 3.01651 13.2662C2.91836 13.8225 2.65383 14.3363 2.25759 14.7401L0.973269 16.0007H2.79273C3.44208 16.0031 4.08484 15.871 4.6803 15.6129C5.23159 15.3881 5.73385 15.0587 6.15921 14.6432C7.08954 14.8662 8.04343 14.9769 9.0003 14.9729C11.4369 15.0765 13.8222 14.2552 15.6749 12.6747C16.416 12.0001 17.0061 11.1773 17.4068 10.2601C17.9866 8.93637 18.1396 7.46581 17.8446 6.05165ZM9.0003 13.4504C8.01238 13.4504 7.02951 13.31 6.08138 13.0335L5.61435 12.8977L5.29327 13.2759C5.02204 13.6022 4.69206 13.8752 4.3203 14.0807C4.46555 13.6817 4.5508 13.2634 4.57327 12.8395V12.4032L4.18408 12.1704C3.17096 11.6419 2.37067 10.7827 1.91705 9.73649C1.47771 8.6889 1.40237 7.525 1.703 6.42983C2.38408 3.99589 4.90408 1.58134 9.02948 1.58134H9.27273C11.2532 1.54728 13.1776 2.23718 14.6825 3.52074C15.248 4.0342 15.7018 4.65801 16.0154 5.35346C16.3263 6.05264 16.4854 6.80935 16.4825 7.57407C16.4825 10.3474 14.1473 13.4504 9.0003 13.4504Z"
        fill="#428BCA"
      />
      <path
        d="M5.55637 8.96079C5.80307 8.96462 6.04534 8.89535 6.25247 8.76174C6.4596 8.62814 6.62224 8.43623 6.71977 8.21036C6.8173 7.98449 6.84531 7.73485 6.80026 7.49309C6.75521 7.25133 6.63912 7.02835 6.46673 6.85244C6.29433 6.67654 6.07339 6.55563 5.83194 6.50505C5.59049 6.45448 5.33941 6.47652 5.11055 6.56838C4.88169 6.66023 4.68536 6.81777 4.54647 7.021C4.40758 7.22423 4.33238 7.46399 4.33043 7.70988C4.32653 7.87276 4.35537 8.03478 4.41523 8.18639C4.4751 8.338 4.56478 8.47615 4.67901 8.5927C4.79324 8.70926 4.92971 8.80187 5.08038 8.86508C5.23105 8.9283 5.39289 8.96084 5.55637 8.96079Z"
        fill="#428BCA"
      />
      <path
        d="M8.82493 8.96079C9.07162 8.96462 9.3139 8.89535 9.52103 8.76174C9.72815 8.62814 9.8908 8.43623 9.98832 8.21036C10.0859 7.98449 10.1139 7.73485 10.0688 7.49309C10.0238 7.25133 9.90768 7.02835 9.73528 6.85244C9.56288 6.67654 9.34195 6.55563 9.1005 6.50505C8.85905 6.45448 8.60797 6.47652 8.37911 6.56838C8.15024 6.66023 7.95391 6.81777 7.81502 7.021C7.67613 7.22423 7.60094 7.46399 7.59898 7.70988C7.59509 7.87276 7.62392 8.03478 7.68379 8.18639C7.74365 8.338 7.83334 8.47615 7.94757 8.5927C8.0618 8.70926 8.19826 8.80187 8.34894 8.86508C8.49961 8.9283 8.66145 8.96084 8.82493 8.96079Z"
        fill="#428BCA"
      />
      <path
        d="M12.0941 8.96079C12.3417 8.96464 12.5847 8.89488 12.7923 8.76042C12.9999 8.62597 13.1625 8.43291 13.2595 8.20591C13.3564 7.9789 13.3833 7.72824 13.3367 7.48594C13.2901 7.24364 13.172 7.02068 12.9977 6.84553C12.8233 6.67039 12.6006 6.551 12.3578 6.50262C12.1151 6.45423 11.8634 6.47905 11.6348 6.57389C11.4063 6.66873 11.2113 6.8293 11.0748 7.03509C10.9382 7.24088 10.8663 7.48256 10.8682 7.72927C10.8669 7.89054 10.8977 8.05046 10.9587 8.19982C11.0197 8.34918 11.1098 8.48502 11.2238 8.59951C11.3378 8.71399 11.4734 8.80486 11.6227 8.86687C11.7721 8.92887 11.9323 8.96079 12.0941 8.96079Z"
        fill="#428BCA"
      />
    </g>
    <defs>
      <clipPath id="clip0_622_112251">
        <rect width="18" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const guideMeIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "19"}
    height={height || "20"}
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.135 15.625H17.24c.52 0 .94-.419.94-.938V.938a.938.938 0 0 0-.94-.937H3.135C1.405 0 0 1.4 0 3.125v13.75A3.131 3.131 0 0 0 3.135 20H17.24a.938.938 0 1 0 0-1.875H3.135c-.69 0-1.254-.563-1.254-1.25 0-.688.564-1.25 1.254-1.25zm6.62-3.088a.952.952 0 0 1-.664.275.952.952 0 0 1-.665-.274.935.935 0 0 1 0-1.325c.351-.35.978-.35 1.33 0a.935.935 0 0 1 0 1.325zM7.28 3.47a2.856 2.856 0 0 1 2.313-.613 2.841 2.841 0 0 1 2.276 2.269 2.819 2.819 0 0 1-1.417 2.963c-.257.143-.42.462-.42.825v.15c0 .518-.42.937-.94.937a.938.938 0 0 1-.94-.938v-.15c0-1.05.532-1.993 1.391-2.462a.938.938 0 0 0 .47-1 .935.935 0 0 0-.74-.744.918.918 0 0 0-.783.2.947.947 0 0 0-.339.719c0 .519-.42.938-.94.938a.938.938 0 0 1-.94-.938c0-.831.37-1.619 1.009-2.156z"
      fill="#428BCA"
    />
  </svg>
);
export const protectedDatabaseIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "18"}
    viewBox="0 0 20 18"
    fill="none"
  >
    <path
      d="M14.424 2.413V3.85c0 1.268-3.23 2.303-7.211 2.303C3.232 6.152 0 5.12 0 3.852V2.419C0 1.144 3.23.11 7.212.11c3.98 0 7.212 1.034 7.212 2.303zm0 3.239V8.89c0 1.268-3.23 2.303-7.211 2.303C3.232 11.193 0 10.156 0 8.89V5.652c1.55 1.043 4.386 1.531 7.212 1.531 2.825 0 5.662-.488 7.212-1.531zm0 5.038v3.238c0 1.268-3.23 2.303-7.211 2.303C3.232 16.231 0 15.196 0 13.928v-3.24c1.55 1.044 4.386 1.53 7.212 1.53 2.825 0 5.66-.486 7.212-1.53v.002z"
      fill="#C9C9C9"
    />
    <path
      d="m14.311 6.076 3.877 1.081c.42.11.712.476.712.892v5.28c0 .802-.462 1.526-1.207 1.893l-2.55 1.431-.018.009a2.326 2.326 0 0 1-1.009.228c-.346 0-.693-.076-1.009-.228l-.035-.018-2.533-1.422c-.745-.367-1.207-1.09-1.207-1.893V8.05c0-.416.292-.781.712-.892l3.893-1.085a.736.736 0 0 1 .359 0l.015.004z"
      fill="#C9C9C9"
      stroke="#fff"
    />
    <path
      d="m16.372 10.786-2.55 2.253-.016.013-.023.018a.593.593 0 0 1-.05.034l-.028.016-.024.012-.03.014-.024.01-.033.011-.023.007-.036.009-.02.004a.663.663 0 0 1-.043.006l-.016.002a.636.636 0 0 1-.12 0c-.006 0-.011-.002-.017-.003-.015-.001-.03-.003-.044-.006l-.022-.005-.038-.01-.023-.007-.035-.012-.025-.011-.032-.015-.024-.014a.652.652 0 0 1-.03-.018l-.024-.017a.629.629 0 0 1-.05-.04l-.016-.014-1.115-1.064a.577.577 0 0 1 0-.843.646.646 0 0 1 .884 0l.69.658 2.109-1.863a.646.646 0 0 1 .883.032.577.577 0 0 1-.035.843z"
      fill="#fff"
    />
  </svg>
);

export const thumbsDownFilledSvg = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "22"}
    height={height || "22"}
    viewBox="0 0 27 27"
    fill="none"
  >
    <g clipPath="url(#lwummgejta)" fill="#428BCA">
      <path d="M.808 15.137a.799.799 0 0 1-.798-.799V2.607c0-.441.357-.799.798-.799h4.813v13.329H.808zM26.99 10.727a2.786 2.786 0 0 1-1.357 2.39c.311.45.494.994.494 1.581a2.788 2.788 0 0 1-2.785 2.784h-5.877c.18.817.426 2.042.598 3.324.446 3.337.141 5.188-.96 5.824-.687.397-1.428.478-2.085.227-.508-.193-1.195-.67-1.586-1.837l-1.544-4.045c-.784-1.934-3.182-3.965-4.67-5.087V1.455A25.82 25.82 0 0 1 15.788 0h6.404a2.787 2.787 0 0 1 2.784 2.784c0 .538-.153 1.04-.418 1.466a2.788 2.788 0 0 1 1.57 2.506c0 .586-.183 1.131-.494 1.58a2.786 2.786 0 0 1 1.357 2.39z" />
    </g>
    <defs>
      <clipPath id="lwummgejta">
        <path fill="#fff" transform="matrix(1 0 0 -1 0 27)" d="M0 0h27v27H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const thumbsUpFilledSvg = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "22"}
    height={height || "22"}
    viewBox="0 0 27 27"
    fill="none"
  >
    <g clipPath="url(#wg9362xpua)" fill="#428BCA">
      <path d="M.808 11.863a.799.799 0 0 0-.798.799v11.731c0 .441.357.799.798.799h4.813V11.863H.808zM26.99 16.273a2.786 2.786 0 0 0-1.357-2.39c.311-.45.494-.994.494-1.581a2.788 2.788 0 0 0-2.785-2.784h-5.877c.18-.817.426-2.042.598-3.324.446-3.337.141-5.188-.96-5.824-.687-.397-1.428-.477-2.085-.227-.508.193-1.195.67-1.586 1.837l-1.544 4.045c-.784 1.934-3.182 3.965-4.67 5.087v14.433A25.82 25.82 0 0 0 15.788 27h6.404a2.787 2.787 0 0 0 2.784-2.784c0-.538-.153-1.04-.418-1.466a2.788 2.788 0 0 0 1.57-2.506c0-.586-.183-1.131-.494-1.58a2.786 2.786 0 0 0 1.357-2.39z" />
    </g>
    <defs>
      <clipPath id="wg9362xpua">
        <path fill="#fff" d="M0 0h27v27H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const thumbsDownSvg = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "22"}
    height={height || "22"}
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M26.7804 15.7938C26.7775 15.7967 26.7735 15.7984 26.7692 15.7984H23.0406V4.89844H26.7692C26.7735 4.89844 26.7775 4.90016 26.7804 4.90304C26.7833 4.9059 26.7848 4.90965 26.7848 4.91344V15.7834C26.7848 15.7872 26.7833 15.791 26.7804 15.7938Z"
      fill="white"
      stroke="#428BCA"
      strokeWidth="1.45"
      strokeMiterlimit="10"
    />
    <path
      d="M3.23429 12.433L3.23428 12.4307C3.23296 12.1117 3.31495 11.7978 3.47219 11.52C3.62943 11.2422 3.85651 11.0101 4.13106 10.8467L4.79884 10.4493L4.35612 9.81069C4.20406 9.59133 4.10146 9.34167 4.05535 9.07891C4.00924 8.81616 4.02072 8.54654 4.089 8.28864C4.15729 8.03075 4.28075 7.79067 4.45093 7.585C4.6211 7.37932 4.83393 7.21294 5.07478 7.09735L5.79597 6.75124L5.3808 6.06746C5.20076 5.77093 5.10565 5.43076 5.10578 5.08401V5.08372C5.10578 4.59318 5.30031 4.1225 5.64695 3.77478C5.99331 3.42736 6.46333 3.23099 6.95431 3.22873H12.8876L12.8886 3.22873C15.342 3.22533 17.7792 3.61205 20.109 4.3734V16.8551C19.449 17.3657 18.6499 18.0317 17.9093 18.7762C17.0681 19.6219 16.2491 20.6211 15.8293 21.6498L15.8261 21.6575L15.8232 21.6652L14.392 25.4152L14.3773 25.4537L14.3671 25.4937C14.2982 25.7622 14.1684 26.0113 13.9876 26.2216C13.8122 26.4257 13.5934 26.5879 13.3473 26.6966C13.1364 26.7662 12.9128 26.7899 12.6918 26.766C12.4626 26.7412 12.2418 26.6659 12.0454 26.5455L12.0388 26.5415L12.0321 26.5376C11.7919 26.3974 11.5344 26.0704 11.405 25.2836C11.2759 24.4986 11.2978 23.3794 11.5043 21.8615L11.5043 21.8615L11.5051 21.8552C11.6514 20.7058 11.8764 19.5901 12.0434 18.8541L12.2443 17.9687H11.3364H5.89343C5.40105 17.9665 4.92957 17.77 4.58155 17.4223C4.23339 17.0744 4.03699 16.6033 4.03492 16.1116C4.03426 15.7392 4.14894 15.3756 4.36332 15.0708L4.81246 14.4322L4.14237 14.0315C3.86563 13.866 3.63658 13.6318 3.47746 13.3517C3.31835 13.0715 3.23458 12.7551 3.23429 12.433Z"
      fill="white"
      stroke="#428BCA"
      strokeWidth="1.45"
      strokeMiterlimit="10"
    />
  </svg>
);

export const thumbsUpSvg = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "22"}
    height={height || "22"}
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M3.23913 14.2101C3.24201 14.2072 3.24604 14.2055 3.25036 14.2055H6.97893V25.1055H3.25036C3.24604 25.1055 3.24201 25.1037 3.23913 25.1009C3.23627 25.098 3.23477 25.0943 3.23477 25.0905V14.2205C3.23477 14.2167 3.23627 14.2129 3.23913 14.2101Z"
      fill="white"
      stroke="#428BCA"
      strokeWidth="1.45"
      strokeMiterlimit="10"
    />
    <path
      d="M26.7852 17.5709L26.7853 17.5732C26.7866 17.8922 26.7046 18.2061 26.5473 18.4839C26.3901 18.7617 26.163 18.9938 25.8885 19.1572L25.2207 19.5546L25.6634 20.1932C25.8155 20.4126 25.9181 20.6622 25.9642 20.925C26.0103 21.1877 25.9988 21.4574 25.9305 21.7153C25.8622 21.9732 25.7388 22.2132 25.5686 22.4189C25.3984 22.6246 25.1856 22.791 24.9448 22.9066L24.2236 23.2527L24.6387 23.9364C24.8188 24.233 24.9139 24.5731 24.9137 24.9199V24.9202C24.9138 25.4107 24.7192 25.8814 24.3726 26.2291C24.0262 26.5765 23.5562 26.7729 23.0652 26.7752H17.1319L17.1309 26.7752C14.6775 26.7786 12.2403 26.3919 9.91055 25.6305V13.1488C10.5705 12.6382 11.3697 11.9722 12.1102 11.2277C12.9515 10.382 13.7704 9.38283 14.1903 8.35414L14.1934 8.34645L14.1964 8.33868L15.6275 4.58868L15.6422 4.55017L15.6525 4.51024C15.7213 4.24174 15.8511 3.99264 16.0319 3.78229C16.2073 3.57824 16.4261 3.41597 16.6722 3.30727C16.8832 3.23771 17.1067 3.21403 17.3278 3.23794C17.5569 3.26273 17.7777 3.33803 17.9742 3.45838L17.9808 3.46242L17.9874 3.46632C18.2277 3.60655 18.4852 3.93355 18.6145 4.72033C18.7436 5.50529 18.7217 6.62447 18.5152 8.14245L18.5152 8.14245L18.5144 8.14868C18.3682 9.29806 18.1431 10.4138 17.9761 11.1498L17.7753 12.0352H18.6832H24.1261C24.6185 12.0374 25.09 12.2339 25.438 12.5816C25.7861 12.9295 25.9825 13.4006 25.9846 13.8923C25.9853 14.2647 25.8706 14.6283 25.6562 14.9331L25.2071 15.5717L25.8772 15.9724C26.1539 16.1379 26.383 16.3721 26.5421 16.6523C26.7012 16.9324 26.7849 17.2488 26.7852 17.5709Z"
      fill="white"
      stroke="#428BCA"
      strokeWidth="1.45"
      strokeMiterlimit="10"
    />
  </svg>
);

export const thumbsDownWithBgSvg = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "32"}
    height={height || "32"}
    viewBox="0 0 32 32"
    fill="none"
  >
    <rect
      x="0.65"
      y="0.65"
      width="30.7"
      height="30.7"
      rx="6.35"
      fill="#FBECEA"
    />
    <rect
      x="0.65"
      y="0.65"
      width="30.7"
      height="30.7"
      rx="6.35"
      stroke="white"
      strokeWidth="0.7"
    />
    <path
      d="M21.644 16.7251C21.7383 16.7251 21.8287 16.6877 21.8954 16.621C21.9621 16.5544 21.9995 16.4641 21.9995 16.3698V11.1515C21.9995 11.0573 21.9621 10.9669 21.8954 10.9003C21.8287 10.8336 21.7383 10.7962 21.644 10.7962H19.5059V16.7251H21.644Z"
      fill="#D3212C"
    />
    <path
      d="M9.99776 14.7617C9.99796 14.9765 10.0538 15.1875 10.1599 15.3743C10.266 15.5611 10.4187 15.7172 10.6031 15.8275C10.4588 16.0327 10.3816 16.2776 10.3821 16.5284C10.3834 16.8565 10.5144 17.1708 10.7466 17.4028C10.9788 17.6348 11.2933 17.7657 11.6217 17.767H14.2354C14.1537 18.127 14.0432 18.6743 13.9711 19.2408C13.7693 20.7242 13.9087 21.55 14.3939 21.8332C14.5322 21.9179 14.6875 21.9708 14.8486 21.9883C15.0098 22.0057 15.1729 21.9872 15.326 21.934C15.4978 21.8609 15.6505 21.7493 15.7721 21.6078C15.8938 21.4662 15.9812 21.2986 16.0275 21.1179L16.7145 19.3176C17.0653 18.4583 18.1319 17.5558 18.7949 17.0565V10.6427C17.5693 10.212 16.2793 9.99284 14.9801 9.99464H12.131C11.8031 9.99591 11.489 10.127 11.2576 10.3591C11.0262 10.5912 10.8962 10.9056 10.8962 11.2332C10.8961 11.4635 10.9593 11.6893 11.0788 11.8861C10.9178 11.9634 10.7755 12.0746 10.6617 12.2121C10.5479 12.3497 10.4654 12.5102 10.4197 12.6827C10.374 12.8552 10.3663 13.0356 10.3972 13.2114C10.428 13.3871 10.4966 13.5541 10.5983 13.7008C10.4145 13.8102 10.2625 13.9656 10.1571 14.1516C10.0518 14.3377 9.99688 14.548 9.99776 14.7617Z"
      fill="#D3212C"
    />
  </svg>
);

export const thumbsUpWithBgSvg = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "32"}
    height={height || "32"}
    viewBox="0 0 32 32"
    fill="none"
  >
    <rect x="0.6" y="0.6" width="30.8" height="30.8" rx="6.4" fill="#E2F7DF" />
    <rect
      x="0.6"
      y="0.6"
      width="30.8"
      height="30.8"
      rx="6.4"
      stroke="white"
      strokeWidth="0.8"
    />
    <path
      d="M10.356 15.2642C10.2617 15.2642 10.1713 15.3016 10.1046 15.3682C10.0379 15.4348 10.0005 15.5252 10.0005 15.6194V20.8378C10.0005 20.932 10.0379 21.0224 10.1046 21.089C10.1713 21.1556 10.2617 21.193 10.356 21.193H12.4941V15.2642H10.356Z"
      fill="#069C56"
    />
    <path
      d="M22.0022 17.2275C22.002 17.0128 21.9462 16.8017 21.8401 16.6149C21.734 16.4282 21.5813 16.272 21.3969 16.1618C21.5412 15.9565 21.6184 15.7117 21.6179 15.4608C21.6166 15.1327 21.4856 14.8184 21.2534 14.5864C21.0212 14.3544 20.7067 14.2235 20.3783 14.2223H17.7646C17.8463 13.8622 17.9568 13.3149 18.0289 12.7484C18.2307 11.265 18.0913 10.4393 17.6061 10.1561C17.4678 10.0714 17.3125 10.0184 17.1514 10.001C16.9902 9.98355 16.8271 10.0021 16.674 10.0552C16.5022 10.1283 16.3495 10.2399 16.2279 10.3815C16.1062 10.523 16.0188 10.6906 15.9725 10.8714L15.2855 12.6716C14.9347 13.531 13.8681 14.4335 13.2051 14.9328V21.3465C14.4307 21.7773 15.7207 21.9964 17.0199 21.9946H19.869C20.1969 21.9933 20.511 21.8623 20.7424 21.6302C20.9738 21.398 21.1038 21.0837 21.1038 20.756C21.1039 20.5258 21.0407 20.3 20.9212 20.1031C21.0822 20.0259 21.2245 19.9146 21.3383 19.7771C21.4521 19.6396 21.5346 19.479 21.5803 19.3065C21.626 19.134 21.6337 18.9537 21.6028 18.7779C21.572 18.6021 21.5034 18.4352 21.4017 18.2885C21.5855 18.1791 21.7375 18.0237 21.8429 17.8376C21.9482 17.6516 22.0031 17.4413 22.0022 17.2275Z"
      fill="#069C56"
    />
  </svg>
);

export const shareConceptSvg = (
  <svg width="13" height="15" viewBox="0 0 13 18" fill="none">
    <path
      d="M10.62 1.339C9.093.15 7.119-.277 5.186.179 2.946.688 1.14 2.443.593 4.638c-.546 2.21.084 4.448 1.695 6.009.574.566.91 1.455.91 2.366v.152c0 .387.308.69.7.69h5.601c.393 0 .7-.303.7-.69v-.152c0-.897.35-1.814.967-2.408a6.177 6.177 0 0 0-.546-9.267zM3.898 15.237v.69C3.898 17.07 4.841 18 6 18h1.4c1.159 0 2.1-.93 2.1-2.072v-.69H3.9z"
      fill="#4F4F4F"
    />
  </svg>
);

export const generateQuesSvg = (
  <svg width="19" height="19" viewBox="0 0 24 24" fill="none">
    <path
      d="M20.284 13.387c-.041-.083-.145-.124-.227-.145-.476 0-4.568-.165-4.568-4.919a.274.274 0 0 0-.269-.268.274.274 0 0 0-.269.268c0 4.754-4.092 4.92-4.546 4.92a.235.235 0 0 0-.166.061c-.041.021-.062.062-.083.083a.307.307 0 0 0 0 .269.287.287 0 0 0 .248.144h.021c.475 0 4.547.166 4.547 4.92 0 .144.124.268.269.268a.274.274 0 0 0 .268-.269c0-4.733 4.072-4.919 4.547-4.919.104 0 .186-.062.248-.144a.254.254 0 0 0-.02-.269zM11.81 8.014c.145 0 .269-.124.269-.29a.274.274 0 0 0-.269-.268c-.248 0-2.48-.083-2.48-2.687A.274.274 0 0 0 9.06 4.5a.274.274 0 0 0-.268.269c0 2.604-2.233 2.687-2.48 2.687h-.021c-.145.02-.248.124-.248.268 0 .145.124.269.268.269.27 0 2.48.083 2.48 2.687 0 .144.125.268.27.268.123.021.247-.103.247-.248 0-2.604 2.232-2.686 2.48-2.686h.021zM9.433 16.778c-.248 0-2.48-.083-2.48-2.687a.274.274 0 0 0-.269-.269.274.274 0 0 0-.268.269c0 2.604-2.233 2.687-2.48 2.687h-.021c-.145.02-.248.124-.248.269 0 .144.124.268.268.268.27 0 2.48.083 2.48 2.687 0 .145.125.269.27.269.123.041.247-.083.247-.248 0-2.604 2.232-2.687 2.48-2.687h.021c.145 0 .269-.124.269-.29a.274.274 0 0 0-.269-.268z"
      fill="#4F4F4F"
    />
  </svg>
);

export const shareConceptSvgYellowVariant = (
  <svg width="13" height="15" viewBox="0 0 13 18" fill="none">
    <path
      d="M10.62 1.339C9.093.15 7.119-.277 5.186.179 2.946.688 1.14 2.443.593 4.638c-.546 2.21.084 4.448 1.695 6.009.574.566.91 1.455.91 2.366v.152c0 .387.308.69.7.69h5.601c.393 0 .7-.303.7-.69v-.152c0-.897.35-1.814.967-2.408a6.177 6.177 0 0 0-.546-9.267zM3.898 15.237v.69C3.898 17.07 4.841 18 6 18h1.4c1.159 0 2.1-.93 2.1-2.072v-.69H3.9z"
      fill="#F1C911"
    />
  </svg>
);

export const emptyChatIcon = (
  <svg width="32" height="31" viewBox="0 0 41 40" fill="none">
    <path
      d="M28.833 7.5h-7.5V5a.834.834 0 0 0-1.666 0v2.5h-7.5A4.17 4.17 0 0 0 8 11.665v15a4.17 4.17 0 0 0 4.167 4.167h4.554l3.086 4.629a.834.834 0 0 0 1.386 0l3.086-4.63h4.554A4.17 4.17 0 0 0 33 26.667v-15a4.17 4.17 0 0 0-4.167-4.167zm2.5 19.166a2.502 2.502 0 0 1-2.5 2.5h-5a.836.836 0 0 0-.693.371l-2.64 3.96-2.64-3.96a.835.835 0 0 0-.693-.371h-5a2.502 2.502 0 0 1-2.5-2.5v-2.5h21.666v2.5zm0-4.167H9.667V11.666a2.503 2.503 0 0 1 2.5-2.5h16.666a2.503 2.503 0 0 1 2.5 2.5v10.833zm-14.166-5.833a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0zm10 0a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0zm-22.5-3.333v6.666A.833.833 0 0 1 3 20v-6.666a.833.833 0 0 1 1.667 0zm33.333 0v6.666a.833.833 0 0 1-1.667 0v-6.666a.833.833 0 0 1 1.667 0z"
      fill="#949494"
    />
  </svg>
);

export const emptyChatIcon1 = (
  <svg width="34" height="29.6" viewBox="0 0 43 37" fill="none">
    <path
      d="M41.774 13.862a15.853 15.853 0 0 0-4.927-8.488A22.006 22.006 0 0 0 21.507.02 22.079 22.079 0 0 0 8.355 4.108a18.244 18.244 0 0 0-6.911 9.754 14.862 14.862 0 0 0 .423 9.333 15.899 15.899 0 0 0 5.93 7.199 6.414 6.414 0 0 1-1.738 3.377L3.115 36.66h4.169c1.488.005 2.96-.297 4.325-.889a10.55 10.55 0 0 0 3.389-2.222c2.132.511 4.317.765 6.51.756a22.118 22.118 0 0 0 15.294-5.267 16.31 16.31 0 0 0 3.969-5.532 15.927 15.927 0 0 0 1.003-9.644zM21.508 30.816c-2.264 0-4.516-.322-6.688-.955l-1.07-.311-.736.866a7.82 7.82 0 0 1-2.23 1.844 9.839 9.839 0 0 0 .58-2.844v-1l-.892-.533a11.414 11.414 0 0 1-5.195-5.577 11.629 11.629 0 0 1-.49-7.577c1.56-5.577 7.335-11.11 16.788-11.11h.557a18.61 18.61 0 0 1 12.396 4.444 12.755 12.755 0 0 1 3.055 4.2 12.405 12.405 0 0 1 1.07 5.088c0 6.355-5.351 13.465-17.145 13.465z"
      fill="#C9C9C9"
    />
    <path
      d="M15.302 15.498a.415.415 0 0 0-.415.415v6.097c0 .23.186.415.415.415h2.5v-6.927h-2.5zM28.896 17.79c0-.527-.283-.99-.705-1.243a1.449 1.449 0 0 0-1.19-2.269h-3.055c.094-.424.222-1.06.31-1.727.233-1.734.074-2.696-.498-3.027-.357-.206-.742-.248-1.084-.118-.264.1-.62.348-.824.955l-.802 2.102c-.407 1.005-1.654 2.06-2.427 2.644v7.5c1.433.503 2.928.757 4.453.757h3.328a1.449 1.449 0 0 0 1.23-2.209 1.449 1.449 0 0 0 .56-2.123c.421-.253.704-.716.704-1.243z"
      fill="#C9C9C9"
    />
  </svg>
);

export const chatBotIcon = (width?: string, height?: string): JSX.Element => (
  <img
    src="/assets/normal-bot.png"
    alt="app-logo"
    width={width || 25}
    height={height || 25}
  />
);

export const analysisToolIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <img
    src="/assets/analysis-tool.png"
    alt="app-logo"
    width={width}
    height={height}
  />
);

export const queryChartSortIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "20"}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M1.19 7.553a.623.623 0 0 0 .884-.013l1.33-1.37v9.988a.625.625 0 1 0 1.25 0V6.17l1.33 1.371a.625.625 0 1 0 .897-.87L4.477 4.192a.62.62 0 0 0-.896 0H3.58L1.176 6.67a.625.625 0 0 0 .014.883z"
      fill="#C9C9C9"
    />
    <path
      d="M1.19 13.23a.623.623 0 0 1 .884.013l1.33 1.37V4.626a.625.625 0 1 1 1.25 0v9.989l1.33-1.37a.625.625 0 1 1 .897.87L4.477 16.59a.62.62 0 0 1-.896 0H3.58l-2.404-2.478a.625.625 0 0 1 .014-.883zM18.875 5h-8.732a.625.625 0 1 0 0 1.25h8.732a.625.625 0 1 0 0-1.25zM17.55 8.875a.625.625 0 0 0-.625-.625h-6.782a.625.625 0 1 0 0 1.25h6.782c.345 0 .625-.28.625-.625zM15.6 12.125a.625.625 0 0 0-.625-.625h-4.832a.625.625 0 1 0 0 1.25h4.832c.345 0 .625-.28.625-.625zM10.143 14.75a.625.625 0 1 0 0 1.25h2.882a.625.625 0 1 0 0-1.25h-2.882z"
      fill="#C9C9C9"
    />
  </svg>
);

export const verboseIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "18"}
    height={height || "22"}
    viewBox="0 0 18 22"
    fill="none"
  >
    <path
      d="M17.2451 5.52713C17.0662 5.14295 16.8231 4.79205 16.5264 4.48947L13.1105 1.0736C12.4193 0.391623 11.4892 0.00641497 10.5182 0H3.66667C2.69456 0.00116443 1.76261 0.387847 1.07523 1.07523C0.387847 1.76261 0.00116443 2.69456 0 3.66667V18.3333C0.00116443 19.3054 0.387847 20.2374 1.07523 20.9248C1.76261 21.6122 2.69456 21.9988 3.66667 22H13.9333C14.9054 21.9988 15.8374 21.6122 16.5248 20.9248C17.2122 20.2374 17.5988 19.3054 17.6 18.3333V7.0818C17.5964 6.5439 17.4753 6.01329 17.2451 5.52713ZM15.0964 5.13333H13.2C13.0055 5.13333 12.819 5.05607 12.6815 4.91854C12.5439 4.78102 12.4667 4.59449 12.4667 4.4V2.5036L15.0964 5.13333ZM16.1333 18.3333C16.1333 18.9168 15.9015 19.4764 15.489 19.889C15.0764 20.3015 14.5168 20.5333 13.9333 20.5333H3.66667C3.08319 20.5333 2.52361 20.3015 2.11103 19.889C1.69845 19.4764 1.46667 18.9168 1.46667 18.3333V3.66667C1.46667 3.08319 1.69845 2.52361 2.11103 2.11103C2.52361 1.69845 3.08319 1.46667 3.66667 1.46667H10.5182C10.6805 1.46811 10.8421 1.48779 11 1.52533V4.4C11 4.98348 11.2318 5.54306 11.6444 5.95564C12.0569 6.36822 12.6165 6.6 13.2 6.6H16.0747C16.1122 6.75789 16.1319 6.91951 16.1333 7.0818V18.3333Z"
      fill="#428BCA"
    />
    <path
      d="M8.41161 14.5219C9.34763 14.5219 10.1064 13.7632 10.1064 12.8271V11.1323C10.1064 10.1963 9.34763 9.4375 8.41161 9.4375C7.47559 9.4375 6.7168 10.1963 6.7168 11.1323V12.8271C6.7168 13.7632 7.47559 14.5219 8.41161 14.5219ZM7.5642 11.1323C7.5642 10.6643 7.9436 10.2849 8.41161 10.2849C8.87962 10.2849 9.25902 10.6643 9.25902 11.1323V12.8271C9.25902 13.2951 8.87962 13.6745 8.41161 13.6745C7.9436 13.6745 7.5642 13.2951 7.5642 12.8271V11.1323Z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="0.264423"
    />
    <path
      d="M6.29405 14.0982C6.29405 13.8642 6.10435 13.6745 5.87035 13.6745H4.17553V9.8612C4.17553 9.6272 3.98583 9.4375 3.75183 9.4375C3.51782 9.4375 3.32812 9.6272 3.32812 9.8612V13.6745C3.32812 14.1425 3.70752 14.5219 4.17553 14.5219H5.87035C6.10435 14.5219 6.29405 14.3322 6.29405 14.0982Z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="0.264423"
    />
    <path
      d="M12.646 14.5217C13.582 14.5217 14.3408 13.7629 14.3408 12.8269V12.4032C14.3408 12.1692 14.1511 11.9795 13.9171 11.9795H13.0697C12.8357 11.9795 12.646 12.1692 12.646 12.4032C12.646 12.6372 12.8357 12.8269 13.0697 12.8269H13.4934C13.4934 13.2949 13.114 13.6743 12.646 13.6743C12.178 13.6743 11.7986 13.2949 11.7986 12.8269V11.132C11.7977 10.7187 12.0952 10.365 12.5027 10.295C12.9101 10.2251 13.3085 10.4594 13.4455 10.8494C13.5301 11.0602 13.7658 11.1668 13.98 11.0911C14.1941 11.0154 14.3105 10.7844 14.2438 10.5673C13.9685 9.7892 13.1729 9.32253 12.3595 9.46206C11.546 9.60159 10.9514 10.3067 10.9512 11.132V12.8269C10.9512 13.7629 11.71 14.5217 12.646 14.5217Z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="0.264423"
    />
  </svg>
);

export const filledVerboseIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "18"}
    height={height || "22"}
    viewBox="0 0 18 22"
    fill="none"
  >
    <path
      d="M13.1065 1.07558C12.9115 0.88361 12.6956 0.714128 12.4629 0.570312V4.40198C12.4629 4.59647 12.5401 4.783 12.6776 4.92052C12.8151 5.05805 13.0015 5.13531 13.196 5.13531H17.0262C16.8825 4.90247 16.7131 4.6865 16.5212 4.49145L13.1065 1.07558Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6421 5.95176C12.0541 6.36396 12.6125 6.59631 13.1952 6.59805H17.5497C17.5545 6.65182 17.5611 6.70478 17.5676 6.75774C17.5806 6.86367 17.5936 6.9696 17.5936 7.08205V18.3314C17.5936 19.3038 17.2075 20.2365 16.5201 20.9241C15.8327 21.6117 14.9004 21.998 13.9283 21.998H3.66534C2.69323 21.998 1.76094 21.6117 1.07355 20.9241C0.386169 20.2365 0 19.3038 0 18.3314V3.66471C0 2.69225 0.386169 1.75962 1.07355 1.07199C1.76094 0.384355 2.69323 -0.00195312 3.66534 -0.00195312H10.5122C10.6246 -0.00195312 10.7305 0.0110835 10.8364 0.0241203L10.8364 0.0241208C10.8893 0.0306394 10.9423 0.0371579 10.996 0.0420468V4.39805C10.9978 4.98099 11.23 5.53956 11.6421 5.95176ZM10.0925 12.8231C10.0925 13.7592 9.33403 14.518 8.39834 14.518C7.46266 14.518 6.70414 13.7592 6.70414 12.8231V11.1283C6.70414 10.1923 7.46266 9.43351 8.39834 9.43351C9.33403 9.43351 10.0925 10.1923 10.0925 11.1283V12.8231ZM8.39834 10.2809C7.9305 10.2809 7.55124 10.6603 7.55124 11.1283V12.8231C7.55124 13.2911 7.9305 13.6705 8.39834 13.6705C8.86619 13.6705 9.24545 13.2911 9.24545 12.8231V11.1283C9.24545 10.6603 8.86619 10.2809 8.39834 10.2809ZM6.28735 14.0942C6.28735 13.8602 6.09772 13.6705 5.8638 13.6705H4.1696V9.85721C4.1696 9.62321 3.97997 9.43351 3.74605 9.43351C3.51213 9.43351 3.3225 9.62321 3.3225 9.85721V13.6705C3.3225 14.1386 3.70176 14.518 4.1696 14.518H5.8638C6.09772 14.518 6.28735 14.3283 6.28735 14.0942ZM14.3356 12.8229C14.3356 13.7589 13.5771 14.5177 12.6414 14.5177C11.7057 14.5177 10.9472 13.7589 10.9472 12.8229V11.1281C10.9474 10.3028 11.5419 9.59759 12.355 9.45806C13.1681 9.31853 13.9635 9.78521 14.2386 10.5633C14.3053 10.7804 14.189 11.0114 13.9749 11.0871C13.7608 11.1628 13.5252 11.0562 13.4406 10.8454C13.3037 10.4554 12.9054 10.2211 12.4981 10.291C12.0908 10.361 11.7934 10.7147 11.7943 11.1281V12.8229C11.7943 13.2909 12.1736 13.6703 12.6414 13.6703C13.1092 13.6703 13.4885 13.2909 13.4885 12.8229H13.065C12.831 12.8229 12.6414 12.6332 12.6414 12.3992C12.6414 12.1652 12.831 11.9755 13.065 11.9755H13.9121C14.146 11.9755 14.3356 12.1652 14.3356 12.3992V12.8229Z"
      fill="#428BCA"
    />
  </svg>
);

export const queryChartAscSortIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "20"}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M1.19 7.553a.623.623 0 0 0 .884-.013l1.33-1.37v9.988a.625.625 0 1 0 1.25 0V6.17l1.33 1.371a.625.625 0 1 0 .897-.87L4.477 4.192a.62.62 0 0 0-.896 0H3.58L1.176 6.67a.625.625 0 0 0 .014.883zM18.875 5h-8.732a.625.625 0 1 0 0 1.25h8.732a.625.625 0 1 0 0-1.25zM17.55 8.875a.625.625 0 0 0-.625-.625h-6.782a.625.625 0 1 0 0 1.25h6.782c.345 0 .625-.28.625-.625zM15.6 12.125a.625.625 0 0 0-.625-.625h-4.832a.625.625 0 1 0 0 1.25h4.832c.345 0 .625-.28.625-.625zM10.143 14.75a.625.625 0 1 0 0 1.25h2.882a.625.625 0 1 0 0-1.25h-2.882z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth=".35"
    />
  </svg>
);

export const queryChartDescSortIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "20"}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M1.19 13.23a.623.623 0 0 1 .884.013l1.33 1.37V4.626a.625.625 0 1 1 1.25 0v9.989l1.33-1.37a.625.625 0 1 1 .897.87L4.477 16.59a.62.62 0 0 1-.896 0H3.58l-2.404-2.478a.625.625 0 0 1 .014-.883zM18.875 5h-8.732a.625.625 0 1 0 0 1.25h8.732a.625.625 0 1 0 0-1.25zM17.55 8.875a.625.625 0 0 0-.625-.625h-6.782a.625.625 0 1 0 0 1.25h6.782c.345 0 .625-.28.625-.625zM15.6 12.125a.625.625 0 0 0-.625-.625h-4.832a.625.625 0 1 0 0 1.25h4.832c.345 0 .625-.28.625-.625zM10.143 14.75a.625.625 0 1 0 0 1.25h2.882a.625.625 0 1 0 0-1.25h-2.882z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth=".35"
    />
  </svg>
);

export const gridWithSideBarIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "25"}
    height={height || "24"}
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.898 5.469c0-.701.7-1.27 1.563-1.27h16.075c.863 0 1.562.569 1.562 1.27v13.06c0 .702-.7 1.27-1.562 1.27H4.462c-.863 0-1.563-.568-1.563-1.27V5.47zm1.563-.181c-.123 0-.223.08-.223.181v13.06c0 .1.1.182.224.182h16.074c.123 0 .223-.081.223-.181V5.468c0-.1-.1-.181-.223-.181H4.46z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth=".35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.983 4.2c.312 0 .564.243.564.543v14.512c0 .3-.252.544-.564.544a.555.555 0 0 1-.565-.544V4.743c0-.3.253-.544.565-.544z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth=".35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.055 9.284a.662.662 0 0 1-.666.658L3.613 9.96a.662.662 0 0 1-.668-.657c0-.363.298-.658.666-.658l17.777-.017c.368 0 .667.294.667.657z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth=".35"
    />
  </svg>
);

export const notAnalyzedIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10.5497 9.14546V9.59562C10.5497 9.98964 11.5059 10.3167 12.6916 10.3167C13.8773 10.3167 14.8345 9.99259 14.8345 9.59562V9.14546C14.8345 8.74849 13.8783 8.42441 12.6926 8.42441C11.5069 8.42441 10.5497 8.74849 10.5497 9.14546ZM10.5497 10.1591V11.1717C10.5497 11.5657 11.5059 11.8927 12.6916 11.8927C13.8773 11.8927 14.8345 11.5687 14.8345 11.1717V10.1581C14.1753 10.5132 13.4353 10.6786 12.6926 10.6368C11.9495 10.6788 11.2092 10.5134 10.5497 10.1581V10.1591ZM10.5497 11.7351V12.7477C10.5497 13.1418 11.5059 13.4688 12.6916 13.4688C13.8773 13.4688 14.8345 13.1447 14.8345 12.7477V11.7341C14.1753 12.0893 13.4353 12.2546 12.6926 12.2129C11.9495 12.2548 11.2092 12.0894 10.5497 11.7341V11.7351Z"
      fill="#949494"
    />
    <path
      d="M4.24259 19.0589L7.93641 15.101C7.01985 13.9758 6.50336 12.5621 6.4723 11.0936C6.44123 9.62507 6.89744 8.18957 7.76554 7.0243C8.63364 5.85902 9.86168 5.03372 11.2467 4.68475C12.6318 4.33579 14.091 4.48406 15.3832 5.10505C16.6754 5.72604 17.7232 6.7826 18.3536 8.10013C18.984 9.41766 19.1592 10.9173 18.8502 12.3513C18.5412 13.7853 17.7666 15.0677 16.6543 15.9868C15.542 16.9059 14.1586 17.4065 12.7327 17.406C11.4476 17.4093 10.1932 17.0011 9.14314 16.2377L5.42159 20.2252C5.34801 20.3083 5.25902 20.3754 5.15986 20.4225C5.06071 20.4695 4.9534 20.4957 4.84427 20.4994C4.73515 20.5031 4.62641 20.4842 4.52448 20.4439C4.42255 20.4035 4.3295 20.3426 4.2508 20.2646C4.17211 20.1866 4.10938 20.0932 4.0663 19.9899C4.02323 19.8865 4.00069 19.7753 4.00001 19.6628C3.99934 19.5504 4.02054 19.4389 4.06236 19.335C4.10419 19.2311 4.16579 19.1369 4.24354 19.0579L4.24259 19.0589ZM12.7327 6.18048C11.8166 6.18029 10.9209 6.45999 10.1591 6.98422C9.3972 7.50845 8.80338 8.25365 8.45268 9.12557C8.10199 9.9975 8.01018 10.957 8.18887 11.8827C8.36756 12.8083 8.80873 13.6586 9.45656 14.326C10.1044 14.9934 10.9298 15.4478 11.8284 15.6319C12.727 15.816 13.6584 15.7214 14.5048 15.3601C15.3512 14.9989 16.0745 14.3871 16.5834 13.6023C17.0923 12.8175 17.3638 11.8948 17.3636 10.951C17.3634 9.68588 16.8754 8.47263 16.007 7.57803C15.1386 6.68344 13.9609 6.18074 12.7327 6.18048V6.18048Z"
      fill="#949494"
    />
    <mask
      id="path-3-outside-1_1323_37"
      maskUnits="userSpaceOnUse"
      x="3.5"
      y="2.79289"
      width="17.6777"
      height="17.6777"
      fill="black"
    >
      <rect fill="white" x="3.5" y="2.79289" width="17.6777" height="17.6777" />
      <path d="M3.5 4.20711L4.20711 3.5L20.4706 19.7635L19.7635 20.4706L3.5 4.20711Z" />
    </mask>
    <path
      d="M3.5 4.20711L4.20711 3.5L20.4706 19.7635L19.7635 20.4706L3.5 4.20711Z"
      fill="#949494"
    />
    <path
      d="M3.5 4.20711L19.7635 20.4706L21.1777 19.0563L4.91421 2.79289L3.5 4.20711Z"
      fill="#F5F5F5"
      mask="url(#path-3-outside-1_1323_37)"
    />
  </svg>
);

export const salesForceLogoSvg = (width?: string): JSX.Element => (
  <svg width={width || "40"} viewBox="0 0 100 73" fill="none">
    <path
      d="M41.9354 7.97209C45.1415 4.501 49.6052 2.3483 54.5418 2.3483C61.1041 2.3483 66.8296 6.15047 69.8785 11.7949C72.5281 10.5648 75.4609 9.88053 78.5466 9.88053C90.3827 9.88053 99.9784 19.9377 99.9784 32.3433C99.9784 44.7504 90.3827 54.8076 78.5466 54.8076C77.1022 54.8076 75.6903 54.6575 74.3252 54.3706C71.6402 59.3469 66.5237 62.7091 60.651 62.7091C58.1926 62.7091 55.8673 62.1191 53.7969 61.07C51.0751 67.7223 44.7337 72.3867 37.3429 72.3867C29.6462 72.3867 23.0867 67.3265 20.5688 60.2298C19.4684 60.4726 18.3285 60.5991 17.1587 60.5991C7.99495 60.5991 0.565918 52.8006 0.565918 43.1789C0.565918 36.7311 3.90374 31.1014 8.86304 28.0894C7.842 25.6483 7.27414 22.9542 7.27414 20.1217C7.27414 9.05653 15.9196 0.0867157 26.5831 0.0867157C32.8438 0.0867157 38.4078 3.17966 41.9354 7.97209Z"
      fill="#00A1E0"
    />
    <path
      d="M14.9629 37.5508C14.9006 37.72 14.9856 37.7553 15.0054 37.7847C15.1923 37.926 15.3821 38.0275 15.5733 38.1408C16.5872 38.7 17.5445 38.8633 18.5457 38.8633C20.5849 38.8633 21.851 37.7362 21.851 35.9219V35.8866C21.851 34.2092 20.4221 33.6 19.081 33.16L18.9068 33.1012C17.8957 32.7598 17.0234 32.4655 17.0234 31.7739V31.7372C17.0234 31.1456 17.5332 30.7101 18.3234 30.7101C19.2014 30.7101 20.2437 31.0132 20.9149 31.3987C20.9149 31.3987 21.1117 31.5312 21.184 31.3325C21.2236 31.2266 21.5635 30.276 21.5989 30.173C21.6371 30.0612 21.5692 29.9788 21.4998 29.9347C20.7336 29.4506 19.6744 29.1195 18.5783 29.1195L18.3744 29.121C16.5079 29.121 15.2051 30.2922 15.2051 31.9711V32.0064C15.2051 33.7766 16.6424 34.3504 17.9892 34.7506L18.2058 34.8198C19.1872 35.1332 20.0326 35.4025 20.0326 36.1205V36.1559C20.0326 36.8121 19.4832 37.3006 18.5967 37.3006C18.2526 37.3006 17.1551 37.2933 15.9698 36.5149C15.8267 36.4281 15.7432 36.3648 15.6327 36.2956C15.5747 36.2574 15.4288 36.1912 15.3651 36.3913L14.9629 37.5508Z"
      fill="white"
    />
    <path
      d="M44.8213 37.5508C44.759 37.72 44.844 37.7553 44.8638 37.7847C45.0507 37.926 45.2405 38.0275 45.4316 38.1408C46.4456 38.7 47.4029 38.8633 48.4041 38.8633C50.4433 38.8633 51.7094 37.7362 51.7094 35.9219V35.8866C51.7094 34.2092 50.2805 33.6 48.9394 33.16L48.7652 33.1012C47.7541 32.7598 46.8818 32.4655 46.8818 31.7739V31.7372C46.8818 31.1456 47.3916 30.7101 48.1818 30.7101C49.0598 30.7101 50.1021 31.0132 50.7733 31.3987C50.7733 31.3987 50.9701 31.5312 51.0424 31.3325C51.082 31.2266 51.4219 30.276 51.4573 30.173C51.4955 30.0612 51.4276 29.9788 51.3582 29.9347C50.592 29.4506 49.5328 29.1195 48.4367 29.1195L48.2328 29.121C46.3663 29.121 45.0635 30.2922 45.0635 31.9711V32.0064C45.0635 33.7766 46.5008 34.3504 47.8476 34.7506L48.0642 34.8198C49.0456 35.1332 49.8925 35.4025 49.8925 36.1205V36.1559C49.8925 36.8121 49.3416 37.3006 48.4551 37.3006C48.111 37.3006 47.0135 37.2933 45.8282 36.5149C45.6851 36.4281 45.6002 36.3677 45.4925 36.2956C45.4557 36.2706 45.283 36.2015 45.2235 36.3913L44.8213 37.5508Z"
      fill="white"
    />
    <path
      d="M65.2011 34.0311C65.2011 35.0567 65.017 35.8645 64.6545 36.4354C64.2962 37.0005 63.7538 37.2756 62.9976 37.2756C62.24 37.2756 61.7004 37.0019 61.3478 36.4354C60.9909 35.866 60.8097 35.0567 60.8097 34.0311C60.8097 33.007 60.9909 32.2007 61.3478 31.6356C61.7004 31.0765 62.24 30.8043 62.9976 30.8043C63.7538 30.8043 64.2962 31.0765 64.6559 31.6356C65.017 32.2007 65.2011 33.007 65.2011 34.0311ZM66.9033 32.13C66.7362 31.5429 66.4756 31.025 66.1287 30.5939C65.7817 30.1613 65.3427 29.814 64.8216 29.5609C64.3019 29.3093 63.6873 29.1813 62.9976 29.1813C62.3065 29.1813 61.6919 29.3093 61.1722 29.5609C60.6511 29.814 60.2121 30.1613 59.8637 30.5939C59.5182 31.0265 59.2576 31.5444 59.0891 32.13C58.9234 32.7142 58.8398 33.3528 58.8398 34.0311C58.8398 34.7094 58.9234 35.3495 59.0891 35.9322C59.2576 36.5178 59.5168 37.0358 59.8651 37.4684C60.2121 37.901 60.6525 38.2468 61.1722 38.4925C61.6933 38.7382 62.3065 38.8633 62.9976 38.8633C63.6873 38.8633 64.3004 38.7382 64.8216 38.4925C65.3413 38.2468 65.7817 37.901 66.1287 37.4684C66.4756 37.0372 66.7362 36.5193 66.9033 35.9322C67.0704 35.348 67.154 34.708 67.154 34.0311C67.154 33.3543 67.0704 32.7142 66.9033 32.13Z"
      fill="white"
    />
    <path
      d="M80.8746 37.0024C80.818 36.8303 80.6579 36.895 80.6579 36.895C80.4101 36.9936 80.1467 37.0848 79.8663 37.1304C79.5817 37.1761 79.2687 37.1996 78.9331 37.1996C78.1089 37.1996 77.4547 36.9451 76.9859 36.4418C76.5158 35.9386 76.2524 35.1249 76.2552 34.0243C76.258 33.0222 76.4903 32.2689 76.908 31.695C77.323 31.1241 77.9545 30.8313 78.7971 30.8313C79.4995 30.8313 80.0348 30.9151 80.5956 31.0991C80.5956 31.0991 80.7302 31.1594 80.7939 30.9769C80.9426 30.5473 81.053 30.2398 81.2117 29.7674C81.257 29.6335 81.1465 29.5761 81.1069 29.56C80.8859 29.4702 80.3648 29.3245 79.9711 29.2627C79.6029 29.2039 79.1724 29.173 78.6938 29.173C77.9786 29.173 77.3414 29.2995 76.7962 29.5526C76.2524 29.8042 75.7907 30.1515 75.4253 30.5841C75.06 31.0167 74.7824 31.5346 74.5969 32.1202C74.4128 32.7044 74.3193 33.3459 74.3193 34.0243C74.3193 35.4913 74.7003 36.6773 75.4522 37.5454C76.2056 38.4165 77.3371 38.8594 78.8127 38.8594C79.6851 38.8594 80.5801 38.6754 81.223 38.4121C81.223 38.4121 81.3462 38.3503 81.2924 38.2016L80.8746 37.0024Z"
      fill="white"
    />
    <path
      d="M83.856 33.0467C83.9367 32.4773 84.0883 32.0035 84.3219 31.6341C84.6745 31.0735 85.2127 30.766 85.9689 30.766C86.7251 30.766 87.225 31.075 87.5833 31.6341C87.8212 32.0035 87.9246 32.4979 87.9656 33.0467H83.856ZM89.5871 31.7945C89.4427 31.228 89.0844 30.6556 88.8493 30.3937C88.4783 29.9788 88.1157 29.6889 87.7561 29.5271C87.2859 29.3181 86.7223 29.1798 86.1048 29.1798C85.3854 29.1798 84.7326 29.3049 84.203 29.5638C83.6719 29.8228 83.2258 30.176 82.8761 30.6159C82.5263 31.0544 82.2629 31.5768 82.0958 32.1697C81.9273 32.7598 81.8423 33.4028 81.8423 34.0811C81.8423 34.7712 81.9301 35.4142 82.1043 35.9925C82.2799 36.5752 82.5603 37.0887 82.9398 37.514C83.3179 37.9422 83.805 38.2776 84.3885 38.5116C84.9677 38.7441 85.6715 38.8647 86.4801 38.8633C88.1441 38.8574 89.0207 38.4719 89.3818 38.2644C89.4455 38.2276 89.5064 38.1629 89.4299 37.9775L89.0532 36.8813C88.9966 36.7179 88.8366 36.7783 88.8366 36.7783C88.4245 36.9372 87.8382 37.2226 86.4716 37.2197C85.578 37.2182 84.9153 36.9445 84.5004 36.5163C84.0741 36.0779 83.8659 35.4334 83.8291 34.524L89.5914 34.5299C89.5914 34.5299 89.7429 34.527 89.7585 34.3739C89.7641 34.3092 89.9567 33.1438 89.5871 31.7945Z"
      fill="white"
    />
    <path
      d="M37.7071 33.0467C37.7892 32.4773 37.9393 32.0035 38.173 31.6341C38.5256 31.0735 39.0638 30.766 39.82 30.766C40.5762 30.766 41.0761 31.075 41.4358 31.6341C41.6723 32.0035 41.7756 32.4979 41.8167 33.0467H37.7071ZM43.4368 31.7945C43.2923 31.228 42.9355 30.6556 42.7004 30.3937C42.3294 29.9788 41.9668 29.6889 41.6071 29.5271C41.137 29.3181 40.5734 29.1798 39.9559 29.1798C39.2379 29.1798 38.5837 29.3049 38.0541 29.5638C37.523 29.8228 37.0769 30.176 36.7271 30.6159C36.3774 31.0544 36.114 31.5768 35.9468 32.1697C35.7797 32.7598 35.6934 33.4028 35.6934 34.0811C35.6934 34.7712 35.7812 35.4142 35.9553 35.9925C36.1309 36.5752 36.4113 37.0887 36.7909 37.514C37.169 37.9422 37.6561 38.2776 38.2396 38.5116C38.8188 38.7441 39.5226 38.8647 40.3312 38.8633C41.9951 38.8574 42.8717 38.4719 43.2328 38.2644C43.2966 38.2276 43.3575 38.1629 43.281 37.9775L42.9057 36.8813C42.8477 36.7179 42.6876 36.7783 42.6876 36.7783C42.2755 36.9372 41.6907 37.2226 40.3213 37.2197C39.4291 37.2182 38.7664 36.9445 38.3514 36.5163C37.9252 36.0779 37.717 35.4334 37.6802 34.524L43.4424 34.5299C43.4424 34.5299 43.594 34.527 43.6095 34.3739C43.6152 34.3092 43.8078 33.1438 43.4368 31.7945Z"
      fill="white"
    />
    <path
      d="M25.2534 36.9681C25.0282 36.7812 24.997 36.7341 24.9206 36.6135C24.8073 36.4295 24.7492 36.1676 24.7492 35.8351C24.7492 35.3083 24.9163 34.9302 25.2633 34.6756C25.259 34.6771 25.7589 34.2268 26.9343 34.243C27.7599 34.2548 28.4977 34.3813 28.4977 34.3813V37.1035H28.4991C28.4991 37.1035 27.767 37.2668 26.9428 37.3183C25.7703 37.3919 25.2491 36.9666 25.2534 36.9681ZM27.5461 32.7613C27.3124 32.7436 27.0094 32.7333 26.6468 32.7333C26.1526 32.7333 25.6754 32.7981 25.2279 32.9231C24.7775 33.0482 24.3725 33.2439 24.0242 33.5029C23.6744 33.7633 23.3926 34.0959 23.1886 34.4902C22.9847 34.8845 22.8813 35.3495 22.8813 35.8704C22.8813 36.4001 22.9691 36.8607 23.1447 37.2374C23.3203 37.6155 23.5738 37.9304 23.8967 38.1732C24.2168 38.416 24.6119 38.594 25.0707 38.7014C25.5224 38.8088 26.0351 38.8633 26.5959 38.8633C27.1864 38.8633 27.7755 38.8133 28.3462 38.7117C28.9112 38.6117 29.6051 38.466 29.7977 38.4204C29.9889 38.3733 30.2013 38.313 30.2013 38.313C30.3444 38.2762 30.333 38.1173 30.333 38.1173L30.3302 32.6421C30.3302 31.4414 30.0215 30.5512 29.414 29.9994C28.8093 29.4491 27.9185 29.171 26.7672 29.171C26.3353 29.171 25.64 29.2328 25.2236 29.3196C25.2236 29.3196 23.9647 29.5727 23.4464 29.9935C23.4464 29.9935 23.3331 30.0671 23.3954 30.2319L23.8032 31.3708C23.8542 31.5179 23.9916 31.4679 23.9916 31.4679C23.9916 31.4679 24.0355 31.4502 24.0865 31.4193C25.1953 30.7925 26.5973 30.8116 26.5973 30.8116C27.2204 30.8116 27.699 30.9411 28.0219 31.1986C28.3363 31.4488 28.4963 31.8269 28.4963 32.6244V32.8775C28.0007 32.8039 27.5461 32.7613 27.5461 32.7613Z"
      fill="white"
    />
    <path
      d="M74.0211 29.6683C74.065 29.5329 73.9729 29.4682 73.9347 29.4534C73.837 29.4137 73.347 29.3063 72.9689 29.2813C72.2453 29.2357 71.8431 29.3622 71.4834 29.53C71.1265 29.6977 70.73 29.9684 70.5091 30.276V29.5476C70.5091 29.4461 70.4397 29.3652 70.3434 29.3652H68.8664C68.7701 29.3652 68.7007 29.4461 68.7007 29.5476V38.4777C68.7007 38.5778 68.78 38.6602 68.8763 38.6602H70.3901C70.4864 38.6602 70.5643 38.5778 70.5643 38.4777V34.0163C70.5643 33.4175 70.628 32.8201 70.7555 32.4449C70.8801 32.0741 71.05 31.7768 71.2596 31.5635C71.4706 31.3516 71.71 31.203 71.9719 31.1191C72.2396 31.0338 72.5356 31.0058 72.7452 31.0058C73.0468 31.0058 73.3782 31.0867 73.3782 31.0867C73.4886 31.1 73.5509 31.0293 73.5877 30.9249C73.6869 30.6512 73.9673 29.8316 74.0211 29.6683Z"
      fill="white"
    />
    <path
      d="M59.815 25.5314C59.6309 25.4726 59.4639 25.4329 59.2458 25.3902C59.0248 25.349 58.7614 25.3284 58.4626 25.3284C57.4204 25.3284 56.599 25.6344 56.0226 26.2377C55.4491 26.8381 55.0597 27.7518 54.8643 28.954L54.7934 29.3586H53.4849C53.4849 29.3586 53.3263 29.3527 53.2923 29.5322L53.0785 30.7785C53.0629 30.8963 53.1125 30.9713 53.2654 30.9713H54.5385L53.247 38.4638C53.1465 39.0671 53.0304 39.563 52.9015 39.9396C52.7755 40.3104 52.6523 40.5885 52.4993 40.7916C52.352 40.9858 52.2133 41.13 51.9725 41.2139C51.7743 41.2831 51.5448 41.3154 51.2942 41.3154C51.1554 41.3154 50.9699 41.2919 50.8325 41.2625C50.6966 41.2345 50.6243 41.2036 50.521 41.158C50.521 41.158 50.3723 41.0991 50.3128 41.2536C50.2661 41.3816 49.9262 42.3513 49.8851 42.4705C49.8455 42.5897 49.9021 42.6824 49.9743 42.7103C50.1443 42.7721 50.2703 42.8133 50.5011 42.8707C50.8212 42.9487 51.0917 42.9531 51.3452 42.9531C51.8748 42.9531 52.3591 42.8751 52.7599 42.7251C53.1621 42.5735 53.5133 42.3101 53.8248 41.954C54.1604 41.5685 54.3714 41.1653 54.5725 40.6136C54.7722 40.0691 54.9436 39.3923 55.0795 38.6036L56.3781 30.9713H58.2757C58.2757 30.9713 58.4357 30.9772 58.4683 30.7962L58.6836 29.5514C58.6977 29.4322 58.6496 29.3586 58.4952 29.3586H56.6528C56.6627 29.3159 56.7463 28.642 56.9573 28.0078C57.0479 27.7386 57.2179 27.5193 57.3609 27.3692C57.5025 27.2221 57.6654 27.1176 57.8438 27.0573C58.0265 26.9955 58.2346 26.9661 58.4626 26.9661C58.6354 26.9661 58.8068 26.9867 58.9356 27.0146C59.1141 27.0544 59.1835 27.075 59.2302 27.0897C59.4185 27.1485 59.444 27.0911 59.4808 26.997L59.9213 25.7404C59.9666 25.605 59.8547 25.5476 59.815 25.5314Z"
      fill="white"
    />
    <path
      d="M34.0694 38.4596C34.0694 38.5597 34 38.6406 33.9037 38.6406H32.3757C32.2794 38.6406 32.2114 38.5597 32.2114 38.4596V25.6818C32.2114 25.5817 32.2794 25.5008 32.3757 25.5008H33.9037C34 25.5008 34.0694 25.5817 34.0694 25.6818V38.4596Z"
      fill="white"
    />
  </svg>
);

export const dataModelIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "33"}
    height={height || "32"}
    viewBox="0 0 33 32"
    fill="none"
  >
    <path
      d="M4.5 20.49a.96.96 0 0 1 .96-.96h2.83v-4.236h7.578V12.47h-2.824a.96.96 0 0 1-.96-.96V4.96a.96.96 0 0 1 .96-.96h6.917a.96.96 0 0 1 .96.96v6.55a.96.96 0 0 1-.96.96h-2.83v2.824h7.58v4.235h2.829a.96.96 0 0 1 .96.96v6.55a.96.96 0 0 1-.96.96h-6.923a.96.96 0 0 1-.96-.96v-6.55a.96.96 0 0 1 .96-.96h2.83v-2.824H9.554v2.823h2.829a.96.96 0 0 1 .96.96v6.551a.96.96 0 0 1-.96.96H5.46a.96.96 0 0 1-.96-.96v-6.55z"
      fill="#C9C9C9"
    />
  </svg>
);

export const bulbIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "16"}
    height={height || "20"}
    viewBox="0 0 16 20"
    fill="none"
  >
    <path d="M8.10449 14.4843V9.38086" stroke="#4F4F4F" strokeWidth="1.5" />
    <path
      d="M8.10417 10.4736C8.92433 10.4736 9.5892 9.82061 9.5892 9.01512C9.5892 8.20962 8.92433 7.55664 8.10417 7.55664C7.28401 7.55664 6.61914 8.20962 6.61914 9.01512C6.61914 9.82061 7.28401 10.4736 8.10417 10.4736Z"
      fill="#4F4F4F"
    />
    <path
      d="M11.5349 15.5266V16.1578C11.5346 16.5765 11.3651 16.9779 11.0636 17.274C10.7622 17.57 10.3534 17.7365 9.9271 17.7368H9.57329C9.49916 18.0934 9.30189 18.4139 9.01484 18.6441C8.72779 18.8743 8.36858 19 7.998 19C7.62742 19 7.26822 18.8743 6.98117 18.6441C6.69412 18.4139 6.49684 18.0934 6.42272 17.7368H6.0689C5.64259 17.7365 5.23383 17.57 4.93239 17.274C4.63094 16.9779 4.46144 16.5765 4.46112 16.1578V15.5266C4.46112 15.2759 4.56255 15.0354 4.7431 14.8581C4.92365 14.6807 5.16853 14.5811 5.42387 14.5811H10.5673C10.8227 14.5811 11.0675 14.6807 11.2481 14.8581C11.4286 15.0354 11.5301 15.2759 11.5301 15.5266H11.5349ZM12.4483 2.75021C11.8375 2.17702 11.1178 1.72758 10.3303 1.42756C9.54266 1.12754 8.70262 0.982804 7.85808 1.00163C7.01354 1.02045 6.18104 1.20246 5.40812 1.53726C4.6352 1.87206 3.93699 2.3531 3.35336 2.95291C2.76973 3.55272 2.31212 4.25956 2.00663 5.03306C1.70114 5.80657 1.55378 6.63159 1.57294 7.46103C1.59211 8.29047 1.77743 9.10808 2.11833 9.86718C2.45923 10.6263 2.94902 11.312 3.55975 11.8852C3.62153 11.9427 3.68411 11.9994 3.74749 12.0554C3.97362 12.2534 4.1543 12.4964 4.27754 12.7682C4.40078 13.04 4.46376 13.3345 4.46232 13.632C4.46232 13.8828 4.56376 14.1233 4.7443 14.3006C4.92485 14.478 5.16974 14.5776 5.42507 14.5776H10.5685C10.8239 14.5776 11.0687 14.478 11.2493 14.3006C11.4298 14.1233 11.5313 13.8828 11.5313 13.632C11.5306 13.3334 11.5946 13.0381 11.7191 12.7656C11.8436 12.4932 12.0257 12.2499 12.2533 12.0518C12.8871 11.5016 13.4043 10.8342 13.7754 10.0877C14.1466 9.34119 14.3643 8.53018 14.4163 7.70101C14.4682 6.87183 14.3534 6.04072 14.0783 5.25514C13.8032 4.46956 13.3732 3.74489 12.8129 3.12251C12.6966 2.99329 12.5762 2.86919 12.4519 2.75021H12.4483Z"
      stroke="#4F4F4F"
      strokeWidth="1.5"
    />
  </svg>
);
export const primaryKey = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "13px"}
    height={height || "13px"}
    viewBox="0 0 512 512"
    style={{ marginRight: "5px" }}
  >
    <path
      fill="#D9A252"
      d="M282.3 343.7L248.1 376.1C244.5 381.5 238.4 384 232 384H192V424C192 437.3 181.3 448 168 448H128V488C128 501.3 117.3 512 104 512H24C10.75 512 0 501.3 0 488V408C0 401.6 2.529 395.5 7.029 391L168.3 229.7C162.9 212.8 160 194.7 160 176C160 78.8 238.8 0 336 0C433.2 0 512 78.8 512 176C512 273.2 433.2 352 336 352C317.3 352 299.2 349.1 282.3 343.7zM376 176C398.1 176 416 158.1 416 136C416 113.9 398.1 96 376 96C353.9 96 336 113.9 336 136C336 158.1 353.9 176 376 176z"
    />
  </svg>
);

export const foreignKey = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "13px"}
    height={height || "13px"}
    viewBox="0 0 512 512"
    style={{ marginRight: "5px" }}
  >
    <path
      fill="#478FCD"
      d="M282.3 343.7L248.1 376.1C244.5 381.5 238.4 384 232 384H192V424C192 437.3 181.3 448 168 448H128V488C128 501.3 117.3 512 104 512H24C10.75 512 0 501.3 0 488V408C0 401.6 2.529 395.5 7.029 391L168.3 229.7C162.9 212.8 160 194.7 160 176C160 78.8 238.8 0 336 0C433.2 0 512 78.8 512 176C512 273.2 433.2 352 336 352C317.3 352 299.2 349.1 282.3 343.7zM376 176C398.1 176 416 158.1 416 136C416 113.9 398.1 96 376 96C353.9 96 336 113.9 336 136C336 158.1 353.9 176 376 176z"
    />
  </svg>
);

export const tableRelationshipIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "29.61"}
    height={height || "23.012"}
    viewBox="0 0 29.61 23.012"
  >
    <g
      id="Group_2133"
      data-name="Group 2133"
      transform="translate(2453.982 -1659.909)"
    >
      <path
        id="Path_1271"
        data-name="Path 1271"
        d="M-2346.723,1659.917h-5.538a.988.988,0,0,0-.988.988v1.326c-.146.365-.494.478-1.03.529a7.44,7.44,0,0,0-4.87,2.367.853.853,0,0,0-.249.672c.221.591.54,1.145.881,1.832a6,6,0,0,1,5.127-2.907c.082.116.133.157.139.2a.078.078,0,0,0,0,.011v1.5a.988.988,0,0,0,.988.988h5.538a.987.987,0,0,0,.987-.988V1660.9A.988.988,0,0,0-2346.723,1659.917Z"
        transform="translate(-79.133 -0.007)"
        fill="#a7a7a7"
      />
      <path
        id="Path_1272"
        data-name="Path 1272"
        d="M-2425.835,1675.408h-.685q-2.08-.03-4.161,0h-.692a.988.988,0,0,0-.988.988v1.545a5.661,5.661,0,0,1-5.9-4.783,23.376,23.376,0,0,1-.171-2.438,7.763,7.763,0,0,0-7.168-7.98,1.047,1.047,0,0,1-.851-.4V1660.9a.987.987,0,0,0-.987-.988h-2.228q-.721,0-1.443,0h-1.867a.988.988,0,0,0-.987.988v5.537a.988.988,0,0,0,.987.988h5.538a.988.988,0,0,0,.987-.988v-1.529c.117-.152.322-.189.653-.157a5.56,5.56,0,0,1,5.1,4.538c.214,1.114.205,2.27.338,3.4.493,4.221,2.877,6.7,7.071,7.3.5.072.8.188.922.524v1.423a.988.988,0,0,0,.988.988h5.537a.988.988,0,0,0,.988-.988V1676.4A.988.988,0,0,0-2425.835,1675.408Z"
        transform="translate(0.476)"
        fill="#428bca"
      />
      <path
        id="Path_1273"
        data-name="Path 1273"
        d="M-2440.406,1755.155a15.589,15.589,0,0,0-.785-1.673c-2.044,2.086-2.713,2.5-4.366,2.748-.549.081-.795.113-.909-.05v-1.486a.988.988,0,0,0-.988-.988h-.963q-1.874-.035-3.75,0h-.825a.988.988,0,0,0-.988.988v1.531q-.007,1.21,0,2.42v1.586a.988.988,0,0,0,.988.988h5.537a.988.988,0,0,0,.988-.988v-1.588c.125-.2.355-.292.733-.327a7.757,7.757,0,0,0,5.115-2.412A.909.909,0,0,0-2440.406,1755.155Z"
        transform="translate(0 -78.298)"
        fill="#a7a7a7"
      />
    </g>
  </svg>
);

export const collapseSvg = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "32"}
    height={height || "32"}
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M2.666 11.334v9.333h26.667v-9.334H2.666zm8.237 7.687H4.617v-6.04h6.286v6.04zm8.236 0h-6.283v-6.04h6.283v6.04zm8.237 0h-6.282v-6.04h6.287v6.04h-.005z"
      fill="#949494"
    />
  </svg>
);

export const generalknowledgeToolIcon = (): JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M16.235 15.714c.15-1.065.224-2.139.222-3.214a22.802 22.802 0 0 0-.222-3.214h4.21a9.536 9.536 0 0 1 0 6.428h-4.21zM11.5 22c-.927 0-1.874-.952-2.6-2.612a13.544 13.544 0 0 1-.805-2.56h6.81a13.56 13.56 0 0 1-.804 2.56c-.726 1.66-1.673 2.612-2.6 2.612zm-3.608-6.286a22.145 22.145 0 0 1 0-6.428h7.217a21.6 21.6 0 0 1 .234 3.214 21.6 21.6 0 0 1-.234 3.214H7.893zm-5.335 0a9.537 9.537 0 0 1 0-6.428h4.21a23.275 23.275 0 0 0 0 6.428h-4.21zM11.501 3c.928 0 1.875.952 2.601 2.612.332.758.602 1.623.804 2.56h-6.81c.202-.937.473-1.801.804-2.56C9.627 3.952 10.574 3 11.501 3zm8.461 5.172h-3.92c-.222-1.102-.531-2.119-.92-3.006-.314-.719-.67-1.328-1.06-1.818a9.446 9.446 0 0 1 5.9 4.824zM8.941 3.347c-.39.491-.745 1.1-1.06 1.819-.388.887-.697 1.904-.92 3.006h-3.92a9.448 9.448 0 0 1 5.9-4.825zm-5.9 13.48H6.96c.223 1.103.532 2.12.92 3.007.315.718.67 1.327 1.06 1.818a9.446 9.446 0 0 1-5.9-4.824zm11.02 4.825c.39-.491.746-1.1 1.06-1.818.389-.888.698-1.905.92-3.006h3.921a9.448 9.448 0 0 1-5.9 4.825v-.001z"
      fill="#C9C9C9"
    />
  </svg>
);

export const dataUnderstandingToolIcon = (): JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M21.92 6.66c-.064.3-.1.6-.195.886-.216.67-.464 1.332-.693 1.999-1.032 3.006-2.063 6.013-3.093 9.02a1.128 1.128 0 0 1-.506.728c-.269.176-.605.252-.936.213H4.989c-.26 0-.521.01-.78-.008a2.268 2.268 0 0 1-1.377-.426.785.785 0 0 1-.29-.36.69.69 0 0 1-.018-.442c.113-.325.46-.263.746-.263 3.803 0 7.606 0 11.41-.006.4.054.808-.008 1.164-.178.356-.169.64-.436.81-.76.13-.274.273-.544.373-.825.416-1.176.824-2.354 1.223-3.534.864-2.533 1.73-5.064 2.58-7.601.093-.247.117-.51.069-.767a1.501 1.501 0 0 0-.347-.706 1.777 1.777 0 0 0-.68-.479 2.004 2.004 0 0 0-.856-.14h-3.729c-1.257 0-2.514.022-3.77-.007-1.237-.029-2.473.1-3.71.011a.945.945 0 0 0-.283.044c-.567.14-.793.56-1.004.985-.094.194-.187.389-.292.578l-4.794 11.74a2.928 2.928 0 0 0-.263.644c-.037.308-.157.624-.171.936.045.794.42 1.544 1.052 2.108.632.565 1.478.903 2.375.95h12.13c.44 0 .873-.092 1.267-.265a2.794 2.794 0 0 0 1-.737 3.3 3.3 0 0 0 .638-1.303c1.022-2.968 2.039-5.938 3.05-8.909a9.962 9.962 0 0 0 .474-1.69c.05-.313-.031-.631-.227-.895a1.476 1.476 0 0 0-.839-.542zm-13.282.386c.073-.2.139-.4.22-.601a.585.585 0 0 1 .26-.337.724.724 0 0 1 .447-.102h7.758c.413 0 .527.135.4.485-.386 1.054-.288 1.023-1.527 1.013-1.093-.008-2.185 0-3.278 0H9.022c-.405 0-.506-.122-.384-.459v.001zm-1.086 2.967c.079-.209.148-.42.236-.626a.56.56 0 0 1 .237-.283.682.682 0 0 1 .383-.098h7.893c.334 0 .453.15.34.43-.415 1.102-.288 1.083-1.616 1.07-1.071-.01-2.143 0-3.215 0H7.951c-.449-.002-.54-.117-.399-.494z"
      fill="#C9C9C9"
    />
  </svg>
);

export const sqlQueryToolIcon = (): JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 24 20" fill="none">
    <path
      d="M20.733.5H3.268C1.896.5.773 1.45.773 2.611V17.39c0 1.161 1.123 2.111 2.495 2.111h17.465c1.372 0 2.494-.95 2.494-2.111V2.61C23.227 1.45 22.105.5 20.733.5zM5.763 7.889h2.495v7.389H5.763v-7.39zm4.99-3.167h2.495v10.556h-2.495V4.722zm4.99 6.334h2.495v4.222h-2.495v-4.222z"
      fill="#C9C9C9"
    />
  </svg>
);

export const notAllowedIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "32"}
    height={height || "32"}
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M20 3.5c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM9.846 25.804a11.867 11.867 0 0 1-1.792-5.93c-.208-6.76 5.294-12.387 12.058-12.325a11.901 11.901 0 0 1 6.194 1.796.214.214 0 0 1 .04.334L10.18 25.844a.215.215 0 0 1-.334-.04zM20 31.452a11.895 11.895 0 0 1-6.305-1.797.215.215 0 0 1-.04-.334l16.166-16.166a.215.215 0 0 1 .334.04 11.9 11.9 0 0 1 1.797 6.305c0 6.6-5.35 11.952-11.952 11.952z"
      fill="#949494"
    />
    <path
      d="M29.152 6.374a15.964 15.964 0 0 1 5.752 12.287c0 8.837-7.164 16-16 16a15.927 15.927 0 0 1-9.152-2.874A15.931 15.931 0 0 0 20.001 35.5c8.836 0 16-7.163 16-16 0-5.433-2.708-10.234-6.849-13.126z"
      fill="#949494"
    />
  </svg>
);

export const retryIcon = (): JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M20.0033 5.59794V9.59794C20.0033 9.81011 19.919 10.0136 19.7689 10.1636C19.6189 10.3137 19.4154 10.3979 19.2033 10.3979H15.2033C14.9911 10.3979 14.7876 10.3137 14.6376 10.1636C14.4875 10.0136 14.4033 9.81011 14.4033 9.59794C14.4033 9.38576 14.4875 9.18228 14.6376 9.03225C14.7876 8.88222 14.9911 8.79794 15.2033 8.79794H17.5313C16.816 7.56763 15.7104 6.61137 14.3899 6.08082C13.0693 5.55027 11.6094 5.47581 10.2418 5.86926C8.87413 6.2627 7.67699 7.10152 6.84025 8.25267C6.00351 9.40382 5.57506 10.8014 5.62288 12.2237C5.6707 13.646 6.19204 15.0117 7.10421 16.104C8.01638 17.1964 9.26716 17.9529 10.6582 18.2536C12.0491 18.5543 13.5007 18.382 14.7826 17.7639C16.0646 17.1459 17.1034 16.1175 17.7345 14.8419C17.7807 14.7471 17.8453 14.6623 17.9245 14.5925C18.0037 14.5227 18.0959 14.4693 18.1958 14.4353C18.2958 14.4013 18.4014 14.3874 18.5068 14.3944C18.6121 14.4014 18.715 14.4292 18.8095 14.4762C18.904 14.5232 18.9883 14.5884 19.0575 14.6681C19.1267 14.7478 19.1795 14.8404 19.2127 14.9406C19.246 15.0408 19.2591 15.1465 19.2513 15.2518C19.2435 15.3571 19.2149 15.4598 19.1673 15.5539C18.3934 17.1145 17.1314 18.3799 15.5728 19.1579C14.0143 19.9358 12.2444 20.1838 10.532 19.8642C8.8197 19.5445 7.25848 18.6747 6.08553 17.3869C4.91258 16.0991 4.19201 14.4636 4.03329 12.729C3.87456 10.9943 4.28636 9.25521 5.20611 7.77591C6.12586 6.29661 7.50331 5.15793 9.12921 4.53284C10.7551 3.90775 12.5406 3.83042 14.2145 4.3126C15.8883 4.79477 17.359 5.8101 18.4033 7.20434V5.59794C18.4033 5.38577 18.4875 5.18228 18.6376 5.03226C18.7876 4.88223 18.9911 4.79794 19.2033 4.79794C19.4154 4.79794 19.6189 4.88223 19.7689 5.03226C19.919 5.18228 20.0033 5.38577 20.0033 5.59794Z"
      fill="#428BCA"
    />
  </svg>
);

export const rightPrecision = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#now3h8qyla)" fill="#428BCA">
      <path d="M18.57 15.767A.332.332 0 0 0 18 16v1h-3.666a.666.666 0 0 0-.667.667V19a.666.666 0 0 0 .667.667H18v1a.333.333 0 0 0 .57.235l3-2.333a.333.333 0 0 0 0-.471l-3-2.331zM3 14.333a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM4.667 6.333v4a4 4 0 0 0 8 0v-4a4 4 0 1 0-8 0zm6 0v4a2 2 0 1 1-4 0v-4a2 2 0 0 1 4 0zM13.333 6.333v4a4 4 0 1 0 8 0v-4a4 4 0 1 0-8 0zm2 0a2 2 0 1 1 4 0v4a2 2 0 1 1-4 0v-4z" />
    </g>
    <defs>
      <clipPath id="now3h8qyla">
        <path fill="#fff" transform="translate(2 2)" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const leftPrecision = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#7nz9iur1oa)" fill="#428BCA">
      <path d="M5.098 15.767a.333.333 0 0 1 .569.233v1h3.666a.666.666 0 0 1 .667.667V19a.667.667 0 0 1-.667.667H5.667v1a.333.333 0 0 1-.57.235l-3-2.333a.333.333 0 0 1 0-.471l3-2.331zM3 14.333a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM4.667 6.333v4a4 4 0 0 0 8 0v-4a4 4 0 1 0-8 0zm6 0v4a2 2 0 1 1-4 0v-4a2 2 0 0 1 4 0zM13.333 6.333v4a4 4 0 1 0 8 0v-4a4 4 0 1 0-8 0zm2 0a2 2 0 1 1 4 0v4a2 2 0 1 1-4 0v-4z" />
    </g>
    <defs>
      <clipPath id="7nz9iur1oa">
        <path fill="#fff" transform="translate(2 2)" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const prefrencesIconSvg = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || 20}
    height={height || 20}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.73 12.5H6.527c-.163 0-.271-.2-.271-.5s.108-.5.27-.5H21.73c.162 0 .27.2.27.5s-.135.5-.27.5zM4.764 12.5H2.271C2.108 12.5 2 12.3 2 12s.108-.5.271-.5h2.493c.163 0 .271.2.271.5s-.135.5-.27.5z"
      fill="#428BCA"
    />
    <path
      d="M6.527 10.121v3.703c0 .47-.407.86-.894.86-.488 0-.895-.39-.895-.86V10.12c0-.47.407-.86.895-.86.243 0 .46.104.623.26a.834.834 0 0 1 .27.6z"
      fill="#428BCA"
    />
    <path
      d="M5.632 14.92c-.623 0-1.165-.496-1.165-1.122V10.12c0-.6.515-1.121 1.165-1.121.298 0 .596.104.813.313.217.209.352.495.352.782v3.703c0 .626-.515 1.121-1.165 1.121zm0-5.372c-.325 0-.623.26-.623.6v3.702c0 .313.27.6.623.6.352 0 .623-.261.623-.6v-3.729a.51.51 0 0 0-.19-.417.63.63 0 0 0-.433-.156zM21.73 19.5h-9.215c-.163 0-.27-.2-.27-.5s.107-.5.27-.5h9.214c.163 0 .271.2.271.5s-.135.5-.27.5zM10.753 19.5H2.271C2.108 19.5 2 19.3 2 19s.108-.5.271-.5h8.482c.163 0 .271.2.271.5s-.135.5-.27.5z"
      fill="#428BCA"
    />
    <path
      d="M12.515 17.202v3.702c0 .47-.406.86-.894.86s-.894-.39-.894-.86v-3.702c0-.47.406-.86.894-.86.244 0 .46.104.623.26a.834.834 0 0 1 .271.6z"
      fill="#428BCA"
    />
    <path
      d="M11.62 22c-.623 0-1.165-.496-1.165-1.121v-3.677c0-.6.515-1.121 1.165-1.121.299 0 .597.104.813.313.217.208.326.495.326.782v3.703c.027.625-.488 1.12-1.139 1.12zm0-5.372c-.325 0-.623.261-.623.6v3.703c0 .313.271.6.623.6.353 0 .624-.261.624-.6V17.2a.51.51 0 0 0-.19-.416.63.63 0 0 0-.434-.157zM21.728 5.5H18.72c-.162 0-.27-.2-.27-.5s.108-.5.27-.5h3.008c.163 0 .271.2.271.5s-.135.5-.27.5zM16.96 5.5H2.27C2.108 5.5 2 5.3 2 5s.108-.5.271-.5h14.688c.163 0 .271.2.271.5s-.135.5-.27.5z"
      fill="#428BCA"
    />
    <path
      d="M18.72 3.121v3.703c0 .47-.406.86-.894.86s-.894-.39-.894-.86V3.12c0-.47.406-.86.894-.86.244 0 .46.104.623.26a.834.834 0 0 1 .271.6z"
      fill="#428BCA"
    />
    <path
      d="M17.825 7.92c-.623 0-1.165-.496-1.165-1.122V3.12c0-.6.515-1.121 1.165-1.121.299 0 .597.104.813.313.217.209.353.495.353.782v3.703c0 .626-.515 1.121-1.166 1.121zm0-5.372c-.325 0-.623.26-.623.6V6.85c0 .313.271.6.623.6.353 0 .624-.261.624-.6V3.121a.51.51 0 0 0-.19-.417.63.63 0 0 0-.434-.156z"
      fill="#428BCA"
    />
  </svg>
);

export const deleteIconSolid = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || 20}
    height={height || 20}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill="#D15B47"
      fillRule="evenodd"
      d="M5.45 7.751H4.428c-.335 0-.428-.11-.429-.42v-.6c0-.269.124-.387.403-.388h3.261a.266.266 0 0 0 .182-.04.253.253 0 0 0 .108-.148c.223-.544.455-1.084.698-1.62.121-.307.337-.57.618-.754.281-.183.614-.277.952-.27 1.186-.015 2.373-.015 3.56 0a1.67 1.67 0 0 1 .944.267c.279.18.494.44.616.744a43.7 43.7 0 0 1 .699 1.62c.015.064.055.12.11.157a.28.28 0 0 0 .19.045c1.069-.009 2.135 0 3.205 0 .354 0 .454.104.454.452v.465c0 .406-.088.491-.516.491h-.935v10.385a2.594 2.594 0 0 1-.487 1.622c-.16.234-.38.425-.636.554a1.74 1.74 0 0 1-.833.183c-3.017-.011-6.034 0-9.051 0-.489.032-.97-.12-1.348-.423a1.85 1.85 0 0 1-.681-1.207 3.699 3.699 0 0 1-.064-.711V7.75zm5.826 5.658v3.847c0 .284.114.396.41.4h.536c.41 0 .5-.089.5-.488V9.531a.322.322 0 0 0-.098-.265.342.342 0 0 0-.272-.096h-.616c-.356 0-.454.103-.454.441a909.89 909.89 0 0 0-.008 3.8l.002-.002zm-1.461.023V9.585c0-.295-.114-.411-.418-.413a6.167 6.167 0 0 0-.68.006.458.458 0 0 0-.294.153.538.538 0 0 0-.062.314v7.674a.315.315 0 0 0 .102.242.332.332 0 0 0 .254.089c.212.005.423 0 .636 0 .353 0 .454-.11.454-.454.006-1.25.008-2.504.008-3.763zm5.82-.022V9.583c0-.298-.112-.41-.419-.411h-.557c-.37 0-.473.099-.473.456v7.637c0 .27.122.387.399.392h.556c.399 0 .495-.092.495-.476V13.41zM14.53 6.332c-.025-.074-.042-.133-.067-.192-.131-.316-.274-.627-.395-.947a.375.375 0 0 0-.156-.213.393.393 0 0 0-.26-.063c-.962.008-1.929 0-2.884 0-.825 0-.65-.101-.978.637-.114.251-.216.506-.33.772l5.07.006z"
      clipRule="evenodd"
    />
  </svg>
);

export const jobScheduleIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 31}
    height={height || 26}
    viewBox="0 0 31 26"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5253 25.9891C22.8953 25.9891 21.2643 25.9671 19.6343 26.0001C19.0343 26.0121 18.7822 25.8691 18.7912 25.2001C18.8252 22.5131 18.8162 19.8261 18.7912 17.1391C18.7912 16.6071 18.9273 16.3921 19.4993 16.3961C22.8806 16.4167 26.2623 16.4167 29.6443 16.3961C30.1273 16.3961 30.3622 16.52 30.3592 17.051C30.3446 19.799 30.3446 22.5464 30.3592 25.2931C30.3592 25.8741 30.1082 25.9931 29.5902 25.9931C27.9072 25.9741 26.2123 25.9881 24.5253 25.9891ZM24.6183 17.412C23.3183 17.412 22.0182 17.4341 20.7182 17.4021C20.1182 17.3871 19.8553 17.5501 19.8683 18.2081C19.9043 20.1411 19.8963 22.0761 19.8683 24.0081C19.8603 24.5741 20.0122 24.8191 20.6252 24.8081C23.2539 24.7834 25.8829 24.7834 28.5122 24.8081C29.1042 24.8081 29.3022 24.5881 29.2942 24.0081C29.2695 22.0747 29.2695 20.1414 29.2942 18.2081C29.3022 17.6241 29.1022 17.394 28.5112 17.408C27.2172 17.431 25.9183 17.413 24.6183 17.412Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83942 7.92997C7.47142 7.92997 9.10444 7.95098 10.7394 7.91898C11.3464 7.90698 11.5884 8.06197 11.5794 8.71897C11.5447 11.3483 11.5447 13.978 11.5794 16.608C11.5874 17.26 11.3584 17.422 10.7454 17.418C7.45042 17.395 4.15539 17.39 0.861389 17.418C0.161389 17.425 -0.00757276 17.174 0.000427238 16.518C0.0304272 13.949 0.0404272 11.379 0.000427238 8.80997C-0.0125728 8.05597 0.270355 7.89198 0.951355 7.90998C2.57335 7.95498 4.21042 7.92897 5.83942 7.92997ZM5.78839 16.409C7.11739 16.409 8.44635 16.387 9.77435 16.419C10.3374 16.433 10.5003 16.226 10.4933 15.684C10.4687 13.6913 10.4687 11.698 10.4933 9.70396C10.5003 9.14896 10.3054 8.97596 9.75836 8.97996C7.10103 9.00129 4.44334 9.00129 1.78534 8.97996C1.22534 8.97996 1.05436 9.17996 1.06036 9.72096C1.08236 11.7136 1.08236 13.707 1.06036 15.701C1.05336 16.267 1.26743 16.428 1.80243 16.417C3.12943 16.391 4.45841 16.409 5.78741 16.409H5.78839Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.6176 21.543C25.3086 21.543 25.9996 21.543 26.6906 21.543C27.0606 21.543 27.3306 21.603 27.3296 22.078C27.3296 22.499 27.1775 22.678 26.7535 22.678C25.2809 22.6686 23.8085 22.6686 22.3365 22.678C21.9135 22.678 21.8546 22.441 21.8506 22.098C21.8506 21.733 21.9615 21.537 22.3635 21.544C23.1175 21.554 23.8656 21.543 24.6176 21.543Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.6044 20.5388C23.8804 20.5388 23.1554 20.5248 22.4304 20.5388C21.9904 20.5498 21.8594 20.3499 21.8594 19.9389C21.8594 19.4989 22.1134 19.4639 22.4464 19.4649C23.8654 19.4699 25.2844 19.4739 26.7034 19.4649C27.0904 19.4649 27.3304 19.5329 27.3234 20.0039C27.3164 20.4749 27.0664 20.5469 26.6864 20.5409C25.9934 20.5319 25.2994 20.5398 24.6044 20.5388Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.75135 11.0901C6.44235 11.0901 7.1353 11.0971 7.8263 11.0901C8.2033 11.0851 8.45835 11.1531 8.45435 11.6271C8.45035 12.1011 8.16533 12.1511 7.80433 12.1501C6.39033 12.1501 4.97734 12.1421 3.56434 12.1501C3.14534 12.1501 2.97436 11.9831 2.98536 11.5571C2.99636 11.1311 3.26134 11.0901 3.58534 11.0921C4.31034 11.0921 5.02935 11.0901 5.75135 11.0901Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.67437 14.2451C4.95337 14.2451 4.23133 14.2361 3.50933 14.2451C3.11933 14.2521 2.98533 14.0761 2.98833 13.7001C2.99133 13.3241 3.1083 13.1411 3.5053 13.1431C4.97863 13.1511 6.4517 13.1511 7.92437 13.1431C8.31437 13.1431 8.44629 13.3211 8.44829 13.6941C8.45029 14.0671 8.31927 14.2511 7.92827 14.2451C7.17727 14.2371 6.42537 14.2451 5.67437 14.2451Z"
      fill="#428BCA"
    />
    <path
      d="M15.2032 20.599L18.2032 22.622L15.2032 24.643V20.599ZM4.71924 23.294V21.947H15.2032V23.294H4.71924ZM4.71924 21.947V16.556H6.21924V21.948L4.71924 21.947ZM24.9422 13.856V5.76697H22.2422L20.9382 4.41797H26.4382V5.76697V13.857L24.9422 13.856ZM4.71924 8.46597V4.41797H14.5332L13.8552 5.76697H6.21924V8.46697L4.71924 8.46597Z"
      fill="#428BCA"
    />
    <path
      d="M25.6133 16.5596L23.5903 13.5596H27.6353L25.6133 16.5596Z"
      fill="#428BCA"
    />
    <path
      d="M17.8057 0.999995L13.0391 5.7666L17.8057 10.5332L22.5723 5.7666L17.8057 0.999995Z"
      fill="white"
      stroke="white"
      strokeWidth="1.2"
    />
    <path
      d="M21.8655 5.7666L17.8058 9.8263L13.7461 5.7666L17.8058 1.7069L21.8655 5.7666Z"
      fill="white"
    />
    <path
      d="M14.4533 5.7666L17.8059 9.11919L21.1585 5.7666L17.8059 2.41401L14.4533 5.7666ZM13.0391 5.7666L17.8059 0.999797L22.5727 5.7666L17.8059 10.5334L13.0391 5.7666Z"
      fill="#428BCA"
    />
  </svg>
);

export const removeScheduleIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "17"}
    height={height || "17"}
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M14.21 13.9994L16.353 11.8568C16.3996 11.8102 16.4366 11.7549 16.4618 11.694C16.487 11.6331 16.5 11.5678 16.5 11.5019C16.5 11.436 16.487 11.3707 16.4618 11.3098C16.4366 11.2489 16.3996 11.1936 16.353 11.147C16.3063 11.1004 16.251 11.0634 16.1901 11.0382C16.1292 11.013 16.0639 11 15.998 11C15.9321 11 15.8668 11.013 15.8059 11.0382C15.745 11.0634 15.6896 11.1004 15.643 11.147L13.5 13.2896L11.357 11.147C11.2629 11.0529 11.1352 11 11.002 11C10.8689 11 10.7412 11.0529 10.647 11.147C10.5529 11.2411 10.5 11.3688 10.5 11.5019C10.5 11.635 10.5529 11.7627 10.647 11.8568L12.79 13.9994L10.647 16.142C10.5529 16.2361 10.5 16.3638 10.5 16.4969C10.5 16.6301 10.5529 16.7577 10.647 16.8518C10.7412 16.946 10.8689 16.9989 11.002 16.9989C11.1352 16.9989 11.2629 16.946 11.357 16.8518L13.4983 14.7104L15.6413 16.853C15.6879 16.8996 15.7432 16.9366 15.8042 16.9618C15.8651 16.987 15.9303 17 15.9963 17C16.0622 17 16.1275 16.987 16.1884 16.9618C16.2493 16.9366 16.3046 16.8996 16.3513 16.853C16.3979 16.8064 16.4348 16.751 16.4601 16.6902C16.4853 16.6293 16.4983 16.564 16.4983 16.4981C16.4983 16.4322 16.4853 16.3669 16.4601 16.306C16.4348 16.2451 16.3979 16.1898 16.3513 16.1432L14.21 13.9994Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.31711 1.38018V2.28492H1.21504C1.05222 2.27463 0.889064 2.29904 0.736574 2.35651C0.584074 2.41398 0.445784 2.50318 0.331014 2.61808C0.216254 2.73298 0.127704 2.87092 0.0712942 3.0226C0.0148942 3.17429 -0.00804609 3.33618 0.00404391 3.49739V14.7644C-0.00994609 14.9293 0.0124639 15.0952 0.0697039 15.2506C0.126944 15.4061 0.217654 15.5473 0.335524 15.6646C0.453404 15.7818 0.595624 15.8722 0.752304 15.9295C0.908994 15.9867 1.07638 16.0096 1.24286 15.9963H9.27609L10.3386 14.8275H1.17911V5.70647H13.8106V10.9307L14.9917 9.5809C14.9897 7.55304 14.9892 5.5252 14.9961 3.49739C14.9994 3.338 14.9702 3.17959 14.9104 3.03161C14.8505 2.88363 14.7612 2.74913 14.6478 2.63609C14.5343 2.52304 14.3991 2.43377 14.25 2.37364C14.101 2.31351 13.9413 2.28373 13.7804 2.28608C13.537 2.30808 13.2914 2.30266 13.0369 2.29705C12.9195 2.29446 12.8002 2.29183 12.6784 2.29183V1.3882C12.6773 1.07403 12.5679 0.76968 12.3683 0.52557C12.1687 0.28145 11.8909 0.11226 11.581 0.0460199C11.2653 0.00445989 10.9465 -0.00899033 10.6284 0.00582967C10.2598 0.0109197 9.9078 0.1588 9.6479 0.41782C9.388 0.67685 9.2408 1.02643 9.2378 1.39167V2.27574H5.7612V1.495C5.7741 1.29695 5.7445 1.09843 5.6743 0.91254C5.6041 0.72666 5.495 0.55763 5.35407 0.4166C5.21314 0.27556 5.04363 0.1657 4.85673 0.0942997C4.66983 0.0229096 4.46978 -0.00844027 4.26977 0.00235973H3.71467C3.34688 0.00764973 2.99554 0.15432 2.73479 0.41137C2.47404 0.66843 2.32428 1.0158 2.31711 1.38018ZM4.60814 1.57766V2.69369C4.60814 2.89606 4.60844 3.09785 4.60873 3.29877C4.60902 3.49796 4.60931 3.6963 4.60931 3.89351C4.60815 4.19777 4.52472 4.28619 4.22805 4.28619C3.46553 4.29767 3.46553 4.29766 3.46553 3.54217V1.54896C3.46669 1.20566 3.53043 1.1425 3.87808 1.1425H4.17937C4.55832 1.14365 4.60814 1.2045 4.60814 1.57766ZM11.5276 1.47776V2.72354H11.5288V2.72379C11.5288 3.12212 11.5288 3.52045 11.5242 3.92108C11.5207 4.18746 11.4268 4.27816 11.1614 4.28735C10.3815 4.31605 10.3815 4.31602 10.3815 3.54101V1.52254C10.3827 1.20909 10.4476 1.14366 10.7651 1.14366H11.1927C11.4233 1.13907 11.5276 1.24813 11.5276 1.47776Z"
      fill="#428BCA"
    />
  </svg>
);
export const starIconInFilledCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="#8B9AA3"
    />
    <path
      d="M17.3004 11.419C17.6936 11.0458 17.4734 10.4038 16.9229 10.3292L14.2806 9.9709C14.0604 9.94105 13.8717 9.80668 13.7773 9.62753L12.5977 7.3583C12.346 6.88057 11.6383 6.88057 11.4023 7.3583L10.2227 9.62753C10.1283 9.82161 9.9396 9.94105 9.71941 9.9709L7.07706 10.3292C6.52657 10.4038 6.30638 11.0458 6.69958 11.419L8.6027 13.1956C8.75998 13.3449 8.83862 13.5539 8.79144 13.7629L8.33532 16.2561C8.25668 16.7786 8.83862 17.1668 9.3262 16.9279L11.6854 15.7485C11.8742 15.644 12.1101 15.644 12.3146 15.7485L14.6738 16.9279C15.1614 17.1668 15.7433 16.7786 15.649 16.2561L15.1928 13.7629C15.1614 13.5539 15.2243 13.3449 15.3816 13.1956L17.3004 11.419Z"
      fill="white"
    />
  </svg>
);

export const unhideIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "20"}
    fill="none"
    viewBox="0 0 20 14"
  >
    <g fill="#428BCA" fillRule="evenodd" clipRule="evenodd">
      <path d="M3.561 2.448C5.183 1.142 7.351 0 9.973 0c2.62 0 4.785 1.143 6.406 2.448C18 3.754 19.116 5.254 19.656 6.06a1.685 1.685 0 0 1 0 1.88c-.538.807-1.654 2.307-3.273 3.612C14.763 12.858 12.595 14 9.973 14c-2.622 0-4.79-1.143-6.412-2.449C1.941 10.247.825 8.747.287 7.941a1.684 1.684 0 0 1 0-1.882c.538-.806 1.654-2.306 3.274-3.61Zm.848 1.055C2.935 4.69 1.907 6.07 1.411 6.813l-.002.003a.33.33 0 0 0 0 .368l.002.003c.496.743 1.524 2.122 2.998 3.31 1.474 1.186 3.35 2.149 5.564 2.149 2.213 0 4.09-.963 5.562-2.15 1.473-1.186 2.5-2.565 2.997-3.309l.002-.003a.33.33 0 0 0 0-.368l-.001-.002c-.5-.745-1.528-2.124-3.002-3.31-1.473-1.187-3.348-2.15-5.558-2.15-2.213 0-4.09.963-5.564 2.15Z" />
      <path d="M11.724 5.242a2.482 2.482 0 0 0-4.19 2.245 2.487 2.487 0 0 0 1.951 1.952A2.481 2.481 0 0 0 12.452 7c0-.659-.262-1.29-.728-1.757Zm-1.756-2.08a3.834 3.834 0 0 1 3.837 3.837 3.843 3.843 0 0 1-2.366 3.549 3.832 3.832 0 0 1-4.182-.83 3.841 3.841 0 0 1 2.71-6.557Z" />
    </g>
  </svg>
);

export const hideIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "19"}
    height={height || "16"}
    viewBox="0 0 19 16"
    fill="none"
  >
    <path
      d="M15.6744 15.8918L12.3494 12.6064C11.8875 12.7515 11.4224 12.8604 10.954 12.9329C10.4856 13.0055 10.0007 13.0418 9.49935 13.0418C7.50699 13.0418 5.73234 12.4909 4.17539 11.3892C2.61845 10.2875 1.49032 8.85916 0.791016 7.1043C1.0681 6.40499 1.41775 5.75516 1.83997 5.15482C2.2622 4.55447 2.74379 4.0168 3.28477 3.5418L1.10768 1.32513L2.21602 0.216797L16.7827 14.7835L15.6744 15.8918ZM9.49935 10.6668C9.64449 10.6668 9.77973 10.6602 9.90508 10.647C10.0304 10.6338 10.1657 10.6074 10.3108 10.5678L6.03581 6.29284C5.99622 6.43798 5.96984 6.57322 5.95664 6.69857C5.94345 6.82391 5.93685 6.95916 5.93685 7.1043C5.93685 8.09388 6.2832 8.93503 6.97591 9.62773C7.66862 10.3204 8.50977 10.6668 9.49935 10.6668ZM15.2785 11.023L12.765 8.5293C12.8573 8.30499 12.9299 8.07739 12.9827 7.84648C13.0355 7.61558 13.0619 7.36819 13.0619 7.1043C13.0619 6.11471 12.7155 5.27357 12.0228 4.58086C11.3301 3.88815 10.4889 3.5418 9.49935 3.5418C9.23546 3.5418 8.98807 3.56819 8.75716 3.62096C8.52626 3.67374 8.29866 3.75291 8.07435 3.85846L6.0556 1.83971C6.59657 1.61541 7.15074 1.44718 7.7181 1.33503C8.28546 1.22287 8.87921 1.1668 9.49935 1.1668C11.4917 1.1668 13.2664 1.71766 14.8233 2.8194C16.3803 3.92114 17.5084 5.34944 18.2077 7.1043C17.9042 7.88277 17.5051 8.60516 17.0103 9.27148C16.5155 9.9378 15.9382 10.5217 15.2785 11.023ZM11.6171 7.38138L9.24206 5.00638C9.6115 4.94041 9.95126 4.9701 10.2613 5.09544C10.5714 5.22079 10.8386 5.40221 11.0629 5.63971C11.2872 5.87721 11.4488 6.151 11.5478 6.46107C11.6467 6.77114 11.6698 7.07791 11.6171 7.38138Z"
      fill="#428BCA"
    />
  </svg>
);

export const exclamationMarkInsideFilledTriangle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "21"}
    height={height || "18"}
    viewBox="0 0 21 18"
    fill="none"
  >
    <path
      d="M10.1159 17.893H2.6784C2.33618 17.9041 1.99381 17.8815 1.65611 17.8257C1.33775 17.7794 1.03612 17.6556 0.778313 17.4655C0.520502 17.2754 0.314559 17.0249 0.17925 16.7366C0.0441536 16.4484 -0.0161397 16.1315 0.00369131 15.8145C0.0235223 15.4975 0.122965 15.1905 0.292961 14.9208C0.686018 14.1492 1.14495 13.41 1.58344 12.6619C3.75775 8.93977 5.93473 5.21873 8.11434 1.49881C8.21806 1.32283 8.3319 1.15284 8.4552 0.989635C8.62758 0.721045 8.86528 0.499258 9.14662 0.344505C9.42796 0.189753 9.74397 0.106974 10.066 0.103609C10.3881 0.100465 10.7059 0.17688 10.9904 0.325954C11.2749 0.475027 11.517 0.692008 11.6949 0.957118C12.1292 1.58025 12.5278 2.22691 12.8888 2.89408C15.1692 6.78971 17.4457 10.6876 19.7184 14.5877C19.8578 14.8196 19.9701 15.0664 20.0526 15.3234C20.1567 15.6018 20.1922 15.9005 20.1566 16.1951C20.1211 16.4897 20.0153 16.7718 19.8479 17.0182C19.6805 17.2646 19.4563 17.4683 19.1937 17.6126C18.931 17.7569 18.6376 17.8376 18.3372 17.8482C17.4284 17.9177 16.5036 17.8908 15.5868 17.8942C13.7624 17.9009 11.9335 17.893 10.1159 17.893Z"
      fill="#D15B47"
    />
    <path
      d="M11.323 14.0961C11.3305 14.2582 11.3043 14.4202 11.2457 14.5718C11.187 14.7235 11.0975 14.8616 10.9825 14.9776C10.867 15.0933 10.7285 15.1843 10.5759 15.2449C10.4232 15.3055 10.2597 15.3344 10.0952 15.3298C9.92686 15.336 9.75889 15.3072 9.60239 15.2456C9.44589 15.184 9.30427 15.0908 9.18637 14.972C9.0699 14.8538 8.97933 14.713 8.92068 14.5586C8.86202 14.4042 8.83651 14.2395 8.84552 14.0748C8.84465 13.9161 8.87643 13.7588 8.9387 13.6126C9.00098 13.4663 9.09258 13.3339 9.20801 13.2235C9.32304 13.1121 9.45973 13.0248 9.60988 12.9669C9.76002 12.9091 9.92028 12.8819 10.0814 12.887C10.2451 12.8795 10.4087 12.9056 10.5617 12.9635C10.7148 13.0214 10.8543 13.1099 10.9711 13.2235C11.0874 13.3372 11.1787 13.4734 11.2393 13.6235C11.2999 13.7737 11.3283 13.9345 11.323 14.0961Z"
      fill="white"
    />
    <path
      d="M11.1153 8.85283L11.1946 7.6326L11.2562 6.69715C11.3005 6.0242 11.3698 5.09219 10.5348 4.8589C10.3363 4.78739 10.1226 4.76677 9.91382 4.79894C9.70502 4.8311 9.50785 4.91501 9.34083 5.04285C9.17324 5.16972 9.04078 5.33648 8.95615 5.52751C8.87152 5.71855 8.83745 5.92764 8.85686 6.13527C8.89321 7.0516 8.94997 7.96678 9.01245 8.88199C9.0435 9.3396 9.07565 9.7972 9.10897 10.2548C9.1138 10.6911 9.17542 11.1249 9.29202 11.5458C9.30351 11.584 9.31739 11.6215 9.33389 11.658C9.38855 11.7901 9.4787 11.9051 9.5946 11.9904C9.71049 12.0758 9.84786 12.1284 9.99175 12.1425C10.1357 12.1566 10.2809 12.1317 10.4117 12.0705C10.5424 12.0092 10.6535 11.9139 10.7334 11.7948C10.8254 11.6453 10.8857 11.4789 10.9106 11.3057C10.9935 10.5319 11.063 9.75458 11.105 8.97845C11.1138 8.93717 11.1173 8.89496 11.1153 8.85283Z"
      fill="white"
    />
  </svg>
);

export const exceptionsIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "22"}
    height={height || "22"}
    viewBox="0 0 22 22"
    fill="none"
  >
    <g clipPath="url(#clip0_1668_72828)">
      <path
        d="M5.19975 12.5993H9.05827C9.25076 12.1968 9.47387 11.8205 9.72761 11.4706C9.98134 11.1206 10.2657 10.7969 10.5807 10.4994H5.19975V12.5993ZM5.19975 16.799H8.42831C8.37581 16.449 8.34957 16.099 8.34957 15.7491C8.34957 15.3991 8.37581 15.0491 8.42831 14.6991H5.19975V16.799ZM3.09988 20.9988C2.52241 20.9988 2.02806 20.7931 1.61684 20.3819C1.20561 19.9707 1 19.4763 1 18.8989V2.09988C1 1.52241 1.20561 1.02806 1.61684 0.616839C2.02806 0.205613 2.52241 0 3.09988 0H11.4994L17.799 6.29963V8.71448C17.4665 8.60949 17.1253 8.53074 16.7753 8.47825C16.4253 8.42575 16.0666 8.3995 15.6991 8.3995V7.34957H10.4494V2.09988H3.09988V18.8989H9.05827C9.25076 19.3014 9.47387 19.6776 9.72761 20.0276C9.98134 20.3775 10.2657 20.7013 10.5807 20.9988H3.09988Z"
        fill="#D15B47"
      />
      <path
        d="M15.725 9.5C16.9661 9.5 18.1793 9.86802 19.2112 10.5575C20.2431 11.247 21.0474 12.2271 21.5223 13.3737C21.9973 14.5203 22.1215 15.782 21.8794 16.9992C21.6373 18.2164 21.0397 19.3345 20.1621 20.2121C19.2845 21.0897 18.1664 21.6873 16.9492 21.9294C15.732 22.1715 14.4703 22.0473 13.3237 21.5723C12.1771 21.0974 11.197 20.2931 10.5075 19.2612C9.81802 18.2293 9.45 17.0161 9.45 15.775C9.45196 14.1114 10.1137 12.5164 11.2901 11.3401C12.4664 10.1637 14.0614 9.50196 15.725 9.5ZM13.3051 17.3888C13.2506 17.4414 13.2072 17.5044 13.1773 17.574C13.1474 17.6436 13.1317 17.7184 13.131 17.7942C13.1303 17.8699 13.1448 17.945 13.1735 18.0151C13.2021 18.0853 13.2445 18.1489 13.2981 18.2025C13.3516 18.2561 13.4153 18.2984 13.4854 18.3271C13.5555 18.3558 13.6306 18.3702 13.7064 18.3696C13.7821 18.3689 13.857 18.3532 13.9266 18.3233C13.9962 18.2934 14.0591 18.2499 14.1118 18.1954L15.725 16.5816L17.3382 18.1954C17.4458 18.2994 17.5899 18.3568 17.7395 18.3555C17.8891 18.3542 18.0322 18.2943 18.1379 18.1885C18.2437 18.0827 18.3037 17.9396 18.305 17.7901C18.3063 17.6405 18.2488 17.4964 18.1449 17.3888L16.5316 15.775L18.1449 14.1612C18.1994 14.1086 18.2428 14.0456 18.2727 13.976C18.3026 13.9064 18.3183 13.8316 18.319 13.7558C18.3197 13.6801 18.3052 13.605 18.2765 13.5349C18.2479 13.4647 18.2055 13.4011 18.1519 13.3475C18.0984 13.2939 18.0347 13.2516 17.9646 13.2229C17.8945 13.1942 17.8194 13.1798 17.7436 13.1804C17.6679 13.1811 17.593 13.1968 17.5234 13.2267C17.4538 13.2566 17.3909 13.3001 17.3382 13.3546L15.725 14.9684L14.1118 13.3546C14.0591 13.3001 13.9962 13.2566 13.9266 13.2267C13.857 13.1968 13.7821 13.1811 13.7064 13.1804C13.6306 13.1798 13.5555 13.1942 13.4854 13.2229C13.4153 13.2516 13.3516 13.2939 13.2981 13.3475C13.2445 13.4011 13.2021 13.4647 13.1735 13.5349C13.1448 13.605 13.1303 13.6801 13.131 13.7558C13.1317 13.8316 13.1474 13.9064 13.1773 13.976C13.2072 14.0456 13.2506 14.1086 13.3051 14.1612L14.9184 15.775L13.3051 17.3888Z"
        fill="#D15B47"
      />
    </g>
    <defs>
      <clipPath id="clip0_1668_72828">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const shieldIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "22"}
    fill="none"
    viewBox="0 0 16 18"
  >
    <path
      fill="#428BCA"
      d="M15.017 3.277 8.621.622a1.61 1.61 0 0 0-1.23 0L.996 3.277A1.598 1.598 0 0 0 0 4.748C0 11.34 3.817 15.9 7.383 17.378a1.612 1.612 0 0 0 1.23 0C11.47 16.193 16 12.098 16 4.748a1.59 1.59 0 0 0-.983-1.47ZM8.003 15.32V2.665L13.866 5.1c-.115 5.028-2.74 8.671-5.863 10.219Z"
    />
  </svg>
);

export const columnSequenceIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.8016 11.9996V18.9996H14.4016V11.9996H15.2016H15.6016L13.6016 9.27734L11.6016 11.9996H12.8016Z"
      fill="#428BCA"
    />
    <path
      d="M18.8 16.2778L18.8 9.27778L17.2 9.27778L17.2 16.2778L16.4 16.2778L16 16.2778L18 19L20 16.2778L18.8 16.2778Z"
      fill="#428BCA"
    />
    <rect x="4" y="5" width="15" height="2" fill="#428BCA" />
    <rect x="4" y="9" width="7" height="2" fill="#428BCA" />
    <rect x="4" y="13" width="7" height="2" fill="#428BCA" />
    <rect x="4" y="17" width="7" height="2" fill="#428BCA" />
  </svg>
);

export const filledPlayIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "25"}
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M11.9994 20.8335C16.6018 20.8335 20.3327 17.1024 20.3327 12.4998C20.3327 7.89716 16.6018 4.16602 11.9994 4.16602C7.39699 4.16602 3.66602 7.89716 3.66602 12.4998C3.66602 17.1024 7.39699 20.8335 11.9994 20.8335Z"
      fill="white"
    />
    <path d="M15.7485 12.7641C15.7494 12.8999 15.7135 13.0334 15.6448 13.1505C15.5761 13.2676 15.477 13.3639 15.358 13.4294L10.836 15.9413C10.7202 16.0057 10.5895 16.0387 10.4569 16.0371C10.3244 16.0355 10.1945 15.9993 10.0802 15.9321C9.96598 15.8649 9.87124 15.769 9.80542 15.6539C9.7396 15.5388 9.70498 15.4086 9.70498 15.276V10.2522C9.70484 10.1196 9.73937 9.98918 9.80514 9.87399C9.8709 9.7588 9.96563 9.6628 10.0799 9.5955C10.1942 9.52819 10.3241 9.49193 10.4567 9.49029C10.5894 9.48866 10.7201 9.52171 10.836 9.58617L15.3572 12.0981C15.4768 12.1632 15.5764 12.2596 15.6455 12.3769C15.7147 12.4941 15.7508 12.628 15.75 12.7641H15.7485Z" />
  </svg>
);

export const tickinBoxIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "22"}
    height={height || "22"}
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M10.0388 16.4997L15.218 11.3205L13.8888 9.99134L10.0159 13.8643L8.09089 11.9393L6.78464 13.2455L10.0388 16.4997ZM5.5013 20.1663C4.99714 20.1663 4.56554 19.9868 4.20651 19.6278C3.84748 19.2688 3.66797 18.8372 3.66797 18.333V3.66634C3.66797 3.16217 3.84748 2.73058 4.20651 2.37155C4.56554 2.01252 4.99714 1.83301 5.5013 1.83301H12.8346L18.3346 7.33301V18.333C18.3346 18.8372 18.1551 19.2688 17.7961 19.6278C17.4371 19.9868 17.0055 20.1663 16.5013 20.1663H5.5013ZM11.918 8.24967V3.66634H5.5013V18.333H16.5013V8.24967H11.918Z"
      fill="#428BCA"
    />
  </svg>
);
export const scheduledIcon = (): JSX.Element => (
  <svg width="44" height="43" viewBox="0 0 44 43" fill="none">
    <mask
      id="mask0_833_136244"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="44"
      height="43"
    >
      <path
        d="M0.834961 8.01086e-05H43.165V42.3301H0.834961V8.01086e-05Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_833_136244)">
      <path
        d="M33.4919 3.7207H5.3821C3.55571 3.7207 2.07507 5.20134 2.07507 7.02773V11.9883H36.7989V7.02773C36.7989 5.20134 35.3183 3.7207 33.4919 3.7207Z"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.0199 6.20117V1.24062"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.8541 6.20117V1.24062"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.9094 6.20117V1.24062"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9646 6.20117V1.24062"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0826 17.5684H24.1495"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7245 17.5684H16.7914"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.4408 17.5684H31.5077"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.36633 23.1484H9.43323"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7245 23.1484H16.7914"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0826 23.1484H24.1495"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.36633 28.7305H9.43323"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7245 28.7305H16.7914"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.9248 31.9955C41.9248 37.0181 37.8531 41.0898 32.8304 41.0898C27.8078 41.0898 23.7361 37.0181 23.7361 31.9955C23.7361 26.9729 27.8078 22.9012 32.8304 22.9012C37.8531 22.9012 41.9248 26.9729 41.9248 31.9955Z"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.8304 27.8623V31.9961H36.9642"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.7989 23.8108V11.9881H2.07507V31.8303C2.07507 33.2 3.18557 34.3105 4.55535 34.3105H24.0338"
        stroke="#C9C9C9"
        strokeWidth="1.60156"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const circleTickSvg = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g opacity="0.8">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9601 5.90342C13.6314 5.36197 12.171 5.23013 10.7667 5.52488C9.36595 5.81888 8.08504 6.52386 7.08776 7.54942C6.15362 8.58039 5.56758 9.87889 5.41265 11.2611C5.25732 12.647 5.54328 14.0466 6.22989 15.2607C6.9165 16.4748 7.96882 17.4417 9.23719 18.0237C10.5007 18.6035 11.9145 18.7719 13.2788 18.5053C14.6299 18.1684 15.8547 17.4479 16.8054 16.4308C17.7597 15.4098 18.3966 14.1338 18.6389 12.7579C18.7045 12.385 19.0601 12.1358 19.4331 12.2015C19.806 12.2672 20.0552 12.6228 19.9895 12.9957C19.7012 14.6335 18.943 16.1522 17.8073 17.3673C16.6716 18.5824 15.2071 19.4417 13.592 19.8406C13.5817 19.8432 13.5712 19.8455 13.5607 19.8476C11.9088 20.1745 10.1957 19.9725 8.66523 19.2702C7.13477 18.5679 5.86482 17.4011 5.03614 15.9358C4.20745 14.4704 3.86228 12.7812 4.04977 11.1084C4.23726 9.43558 4.94785 7.86454 6.08037 6.61876C6.0853 6.61334 6.09032 6.60799 6.09543 6.60272C7.28428 5.37641 8.81301 4.53363 10.485 4.1827C12.1569 3.83177 13.8957 3.98873 15.4776 4.6334C15.8283 4.77631 15.9968 5.17647 15.8539 5.52718C15.711 5.87789 15.3108 6.04634 14.9601 5.90342Z"
        fill="#222A2D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7789 6.60622C20.0572 6.86313 20.0745 7.29695 19.8176 7.5752L13.0302 14.9265C12.9036 15.0637 12.7266 15.1433 12.54 15.147C12.3534 15.1507 12.1733 15.0781 12.0414 14.9461L9.2134 12.1165C8.94569 11.8486 8.94581 11.4145 9.21367 11.1467C9.48153 10.879 9.9157 10.8792 10.1834 11.147L12.5068 13.4718L18.81 6.64487C19.0669 6.36662 19.5007 6.34932 19.7789 6.60622Z"
        fill="#222A2D"
      />
    </g>
  </svg>
);

export const toReviewSvg = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g opacity="0.8">
      <g clipPath="url(#clip0_3227_30698)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.38511 6.70155C1.33428 6.70082 1.28381 6.71017 1.23661 6.72905C1.18941 6.74793 1.14642 6.77597 1.11011 6.81155C1.07411 6.84755 1.04579 6.89048 1.02688 6.93776C1.00797 6.98503 0.998865 7.03565 1.00011 7.08655V12.724C0.999385 12.7749 1.00873 12.8254 1.02761 12.8726C1.04649 12.9198 1.07453 12.9627 1.11011 12.999C1.14642 13.0346 1.18941 13.0627 1.23661 13.0816C1.28381 13.1004 1.33428 13.1098 1.38511 13.109H3.69511V6.69238L1.38511 6.70155ZM2.72345 12.1374H1.97178V7.67322H2.72345V12.1374Z"
          fill="#222A2D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8332 8.15912C13.7848 8.07064 13.723 7.99023 13.6498 7.92078C13.6498 7.92078 13.6498 7.85662 13.5765 7.84745L13.5123 7.78328C13.4644 7.7413 13.4121 7.70443 13.3565 7.67328C13.3925 7.61824 13.4232 7.55993 13.4482 7.49912C13.4518 7.46254 13.4518 7.42569 13.4482 7.38912C13.513 7.23848 13.5473 7.07645 13.549 6.91245C13.537 6.56832 13.3964 6.2412 13.1548 5.99578C12.9115 5.75114 12.5831 5.60993 12.2382 5.60162H9.39651C9.45151 5.34495 9.52484 5.00578 9.58901 4.62995C9.58901 4.42828 9.65318 4.21745 9.68068 4.00662C9.90068 2.37495 9.75401 1.47662 9.24984 1.17412C9.09528 1.07551 8.91916 1.01576 8.73651 0.99995C8.56041 0.981239 8.38235 0.999982 8.21401 1.05495C8.02979 1.13595 7.86668 1.25827 7.73734 1.41245C7.60196 1.55985 7.50719 1.7399 7.46234 1.93495L6.71984 3.89662C6.16305 4.87256 5.39202 5.70941 4.46484 6.34412V13.2741C5.79007 13.7408 7.18483 13.9795 8.58984 13.9799H10.1665C10.1324 13.8848 10.1079 13.7866 10.0932 13.6866C10.0521 13.4716 10.0521 13.2508 10.0932 13.0358H8.58984C7.5234 13.0362 6.4621 12.8881 5.43651 12.5958V6.81162C5.7766 6.54319 6.10102 6.2555 6.40818 5.94995C6.91491 5.46963 7.32556 4.89721 7.61818 4.26328L8.38818 2.25578V2.19162C8.40506 2.14214 8.42983 2.09571 8.46151 2.05412L8.55318 1.98078H8.61734C8.61734 1.98078 8.67234 1.98078 8.69068 1.98078C8.72855 2.05869 8.75333 2.14231 8.76401 2.22828C8.77566 2.38696 8.77566 2.54627 8.76401 2.70495C8.75867 3.08241 8.72805 3.45909 8.67234 3.83245C8.60862 4.33827 8.51681 4.84016 8.39734 5.33578L8.13151 6.52745H12.174C12.2234 6.52692 12.2725 6.53639 12.3182 6.55529C12.3638 6.57419 12.4052 6.60214 12.4398 6.63745C12.5048 6.70714 12.5408 6.79887 12.5407 6.89412C12.5408 6.96506 12.5218 7.03474 12.4857 7.09578L11.8807 7.94828L12.7973 8.48912C12.8554 8.51778 12.9011 8.56668 12.9257 8.62662C12.9615 8.67762 12.9807 8.73845 12.9807 8.80078C12.9943 8.85804 12.9943 8.9177 12.9807 8.97495C12.95 9.02832 12.9057 9.0726 12.8523 9.10328L11.9357 9.63495V9.68995C12.0923 9.63819 12.2566 9.61339 12.4215 9.61662H13.6498C13.7153 9.57692 13.7767 9.53087 13.8332 9.47912C13.9502 9.27905 14.0104 9.05086 14.0073 8.81912C14.0049 8.58808 13.9451 8.36127 13.8332 8.15912Z"
          fill="#222A2D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.89 11.1933C22.8554 11.158 22.814 11.13 22.7683 11.1111C22.7226 11.0922 22.6736 11.0827 22.6242 11.0833H20.3325L20.25 17.3991H22.5417C22.5911 17.3996 22.6401 17.3902 22.6858 17.3713C22.7315 17.3524 22.7729 17.3244 22.8075 17.2891C22.8567 17.2658 22.8997 17.2312 22.9332 17.1882C22.9666 17.1453 22.9895 17.095 23 17.0416V11.4591C23.0005 11.4097 22.9911 11.3606 22.9722 11.315C22.9533 11.2693 22.9253 11.2279 22.89 11.1933ZM21.9733 16.4549H21.2583V12.0458H22.0833L21.9733 16.4549Z"
          fill="#222A2D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5021 10.1666H12.4588C12.401 10.1577 12.3423 10.1577 12.2846 10.1666C11.9967 10.1988 11.7283 10.3281 11.5238 10.5333C11.2767 10.7749 11.135 11.1044 11.1296 11.45C11.1248 11.5263 11.1248 11.6028 11.1296 11.6791C11.1253 11.734 11.1253 11.7892 11.1296 11.8441L11.1846 11.9908L11.2671 12.1558C11.186 12.1895 11.1091 12.2326 11.0379 12.2841C10.9642 12.3411 10.8966 12.4057 10.8363 12.4766C10.7091 12.6213 10.618 12.7941 10.5704 12.9808C10.5292 13.168 10.5292 13.3619 10.5704 13.5491C10.5789 13.6216 10.5974 13.6926 10.6254 13.76C10.6382 13.802 10.6567 13.8421 10.6804 13.8791C10.6965 13.9215 10.718 13.9616 10.7446 13.9983C10.6922 14.0266 10.6431 14.0604 10.5979 14.0991C10.5313 14.1443 10.4725 14.2 10.4238 14.2641C10.3639 14.3282 10.3116 14.3989 10.2679 14.475C10.1561 14.6738 10.0962 14.8977 10.0938 15.1258C10.093 15.3561 10.1497 15.5829 10.2588 15.7858C10.3126 15.8811 10.3806 15.9676 10.4604 16.0425C10.4825 16.0692 10.5071 16.0937 10.5338 16.1158L10.6988 16.235C10.6618 16.2879 10.6282 16.343 10.5979 16.4C10.5632 16.4608 10.5355 16.5253 10.5154 16.5925C10.4959 16.6493 10.4806 16.7075 10.4696 16.7666C10.4647 16.8368 10.4647 16.9073 10.4696 16.9775C10.4764 17.3209 10.6141 17.6488 10.8546 17.8941C11.0968 18.1404 11.4259 18.2819 11.7713 18.2883H14.5671C14.5029 18.545 14.4296 18.875 14.3654 19.2508V19.4158C14.3654 19.5625 14.3196 19.7091 14.3013 19.865C14.0721 21.4508 14.2096 22.3308 14.7321 22.615C14.8793 22.7063 15.0455 22.7627 15.2179 22.78C15.388 22.798 15.5599 22.7793 15.7221 22.725C15.9068 22.6486 16.0726 22.5328 16.2079 22.3858C16.3494 22.307 16.4765 22.2047 16.5838 22.0833L17.3263 20.1583C17.8808 19.1961 18.6492 18.3744 19.5721 17.7566L19.6271 10.9C18.3038 10.4228 16.9088 10.1748 15.5021 10.1666ZM18.5638 17.2708C18.2613 17.5183 17.9221 17.8025 17.6013 18.1233C17.0979 18.5939 16.6902 19.1573 16.4004 19.7825L15.6671 21.7716V21.8266C15.6537 21.8775 15.6285 21.9246 15.5938 21.9641C15.5695 21.9956 15.5381 22.0207 15.5021 22.0375H15.4471C15.4235 22.0467 15.3973 22.0467 15.3738 22.0375C15.3359 21.9595 15.3111 21.8759 15.3004 21.79C15.2544 21.2638 15.276 20.734 15.3646 20.2133C15.429 19.7136 15.5208 19.2179 15.6396 18.7283L15.9146 17.555H11.9179C11.8697 17.5565 11.8217 17.5474 11.7774 17.5284C11.733 17.5094 11.6934 17.4809 11.6613 17.445C11.5998 17.3888 11.5612 17.3119 11.5527 17.2291C11.5443 17.1463 11.5666 17.0632 11.6154 16.9958L12.2204 16.1525L11.3038 15.6116C11.2457 15.583 11.2 15.5341 11.1754 15.4741C11.1463 15.4206 11.1305 15.3609 11.1296 15.3C11.1319 15.2392 11.1475 15.1798 11.1754 15.1258C11.2086 15.0744 11.2524 15.0306 11.3038 14.9975L12.2204 14.4841L11.9179 14.035L11.6429 13.6316C11.6124 13.5873 11.5906 13.5375 11.5788 13.485C11.5742 13.4362 11.5742 13.3871 11.5788 13.3383C11.5919 13.2873 11.617 13.2401 11.6521 13.2008C11.6829 13.1601 11.724 13.1284 11.7713 13.1091L12.7338 12.6508L12.1929 11.7341C12.1568 11.6731 12.1378 11.6034 12.1379 11.5325C12.1381 11.4845 12.1479 11.437 12.1668 11.3929C12.1857 11.3488 12.2133 11.309 12.2479 11.2758C12.3143 11.2114 12.403 11.1753 12.4954 11.175H15.5479C16.5999 11.1846 17.6455 11.3388 18.6554 11.6333L18.5638 17.2708Z"
          fill="#222A2D"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3227_30698">
        <rect width="22" height="22" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

export const toReviewFilledSvg = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M1.68027 6.80078C1.60027 6.80078 1.52027 6.80078 1.44027 6.88078C1.36027 7.04078 1.28027 7.12078 1.28027 7.20078V12.6408C1.28027 12.7208 1.28027 12.8008 1.36027 12.8808C1.44027 12.9608 1.52027 12.9608 1.60027 12.9608H3.84027V6.80078H1.68027Z"
      fill="#949494"
    />
    <path
      d="M13.9206 8.88125C13.9206 9.12125 13.8406 9.28125 13.7606 9.52125H12.3206C11.8406 9.52125 11.3606 9.68125 10.9606 10.0813C10.5606 10.4812 10.4006 10.8813 10.4006 11.4412C10.4006 11.6012 10.4006 11.7612 10.4806 11.9212C10.4006 12.0012 10.3206 12.0813 10.3206 12.0813C10.1606 12.3212 10.0006 12.5612 9.92062 12.8012C9.84062 13.0413 9.84062 13.3612 9.92062 13.6012C9.92062 13.6812 9.92062 13.7612 10.0006 13.8412C10.0006 13.8412 10.0006 13.8412 9.92062 13.9212H8.64062C7.28063 13.9212 5.92063 13.6812 4.64062 13.2013V6.48125C5.36062 5.92125 6.48062 5.04125 6.80062 4.08125L7.52062 2.16125C7.60062 2.00125 7.68062 1.76125 7.76062 1.68125C7.92062 1.52125 8.08063 1.44125 8.24063 1.36125C8.40062 1.28125 8.56062 1.28125 8.72062 1.28125C8.88062 1.28125 9.04063 1.36125 9.20062 1.44125C9.68062 1.76125 9.84062 2.64125 9.60063 4.16125C9.52063 4.72125 9.44062 5.36125 9.36062 5.68125H12.0806C12.4006 5.68125 12.7206 5.84125 12.9606 6.08125C13.2006 6.32125 13.3606 6.64125 13.3606 7.04125C13.3606 7.28125 13.2806 7.52125 13.1206 7.76125C13.2806 7.84125 13.5206 8.00125 13.6006 8.24125C13.8406 8.48125 13.9206 8.64125 13.9206 8.88125Z"
      fill="#949494"
    />
    <path
      d="M22.7202 11.2789V16.7989C22.7202 16.8789 22.7202 16.9589 22.6402 17.0389C22.5602 17.1189 22.4802 17.1189 22.4002 17.1189H20.1602V10.8789H22.4002C22.4802 10.8789 22.5602 10.8789 22.6402 10.9589C22.6402 11.1189 22.7202 11.1989 22.7202 11.2789Z"
      fill="#949494"
    />
    <path
      d="M22.7202 11.2789V16.7989C22.7202 16.8789 22.7202 16.9589 22.6402 17.0389C22.5602 17.1189 22.4802 17.1189 22.4002 17.1189H20.1602V10.8789H22.4002C22.4802 10.8789 22.5602 10.8789 22.6402 10.9589C22.6402 11.1189 22.7202 11.1989 22.7202 11.2789Z"
      fill="#949494"
    />
    <path
      d="M19.3602 10.7997V17.5197C18.6402 18.0797 17.5202 18.9597 17.2002 19.9197L16.4802 21.8397C16.4002 21.9997 16.3202 22.2397 16.2402 22.3197C16.0802 22.4797 15.9202 22.5597 15.7602 22.6397C15.6002 22.7197 15.4402 22.7197 15.2802 22.7197C15.1202 22.7197 14.9602 22.6397 14.8002 22.5597C14.3202 22.2397 14.1602 21.3597 14.3202 19.8397C14.4002 19.1997 14.4802 18.6397 14.5602 18.3197H11.8402C11.5202 18.3197 11.2002 18.1597 10.9602 17.9197C10.7202 17.6797 10.5602 17.3597 10.5602 16.9597C10.5602 16.7197 10.6402 16.4797 10.8002 16.2397C10.6402 16.0797 10.4802 15.9997 10.3202 15.7597C10.2402 15.5997 10.1602 15.3597 10.1602 15.1197C10.1602 14.8797 10.2402 14.6397 10.3202 14.4797C10.4002 14.3197 10.5602 14.0797 10.8002 13.9997C10.8002 13.9997 10.8002 13.9197 10.7202 13.9197C10.6402 13.7597 10.5602 13.6797 10.5602 13.5197C10.5602 13.3597 10.5602 13.1197 10.5602 12.9597C10.5602 12.7997 10.7202 12.6397 10.8002 12.4797C10.9602 12.3197 11.0402 12.2397 11.2002 12.1597C11.0402 11.9197 11.0402 11.6797 11.0402 11.4397C11.0402 11.1197 11.2002 10.7997 11.4402 10.5597C11.6802 10.3197 12.0002 10.1597 12.3202 10.1597H15.2802C16.6402 10.0797 18.0002 10.3197 19.3602 10.7997Z"
      fill="#949494"
    />
  </svg>
);

export const giftIconWithBgSvg = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "100"}
    height={height || "100"}
    viewBox="0 0 100 100"
    fill="none"
  >
    <circle cx="50" cy="50" r="50" fill="#EFF3F8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51 25C51 24.4477 50.5523 24 50 24C49.4477 24 49 24.4477 49 25V26.1739C49 26.7262 49.4477 27.1739 50 27.1739C50.5523 27.1739 51 26.7262 51 26.1739V25ZM30.7511 31.3368C30.3605 30.9463 29.7274 30.9463 29.3368 31.3368C28.9463 31.7274 28.9463 32.3605 29.3368 32.7511L30.5108 33.925C30.9013 34.3155 31.5344 34.3155 31.925 33.925C32.3155 33.5344 32.3155 32.9013 31.925 32.5108L30.7511 31.3368ZM22 49.6523C22 49.1001 22.4477 48.6523 23 48.6523H24.1739C24.7262 48.6523 25.1739 49.1001 25.1739 49.6523C25.1739 50.2046 24.7262 50.6523 24.1739 50.6523H23C22.4477 50.6523 22 50.2046 22 49.6523ZM70.6632 32.7511C71.0538 32.3605 71.0538 31.7274 70.6632 31.3368C70.2727 30.9463 69.6396 30.9463 69.249 31.3368L68.0751 32.5108C67.6846 32.9013 67.6846 33.5344 68.0751 33.925C68.4656 34.3155 69.0988 34.3155 69.4893 33.925L70.6632 32.7511ZM74.8262 49.6523C74.8262 49.1001 75.2739 48.6523 75.8262 48.6523H77.0001C77.5524 48.6523 78.0001 49.1001 78.0001 49.6523C78.0001 50.2046 77.5524 50.6523 77.0001 50.6523H75.8262C75.2739 50.6523 74.8262 50.2046 74.8262 49.6523ZM60.7638 42.7855H65.0193C66.7492 42.7855 68.1565 44.1882 68.1565 45.9123V47.9969C68.1565 49.3557 67.2822 50.5142 66.065 50.9445V66.8969C66.065 68.621 64.6577 70.0237 62.9278 70.0237H37.6906C35.9608 70.0237 34.5534 68.621 34.5534 66.8969V50.9445C33.3362 50.5142 32.4619 49.3557 32.4619 47.9969V45.9123C32.4619 44.1882 33.8693 42.7855 35.5991 42.7855H39.8547C39.1967 41.9139 38.8061 40.8309 38.8061 39.6587C38.8061 36.7851 41.1517 34.4473 44.0348 34.4473C45.7715 34.4473 47.0521 35.0674 48.065 36.3989C48.9124 37.5129 49.532 39.0682 50.3092 41.0334C51.0864 39.0682 51.706 37.5129 52.5534 36.3989C53.5663 35.0674 54.847 34.4473 56.5837 34.4473C59.4668 34.4473 61.8124 36.7851 61.8124 39.6587C61.8124 40.8309 61.4217 41.9139 60.7638 42.7855ZM56.5837 36.5318C54.4398 36.5318 53.8308 37.8133 52.2288 41.8641C52.1133 42.1561 51.9911 42.4648 51.863 42.7855H56.5837C58.3135 42.7855 59.7209 41.3828 59.7209 39.6587C59.7209 37.9345 58.3135 36.5318 56.5837 36.5318ZM48.3897 41.8641C46.7876 37.8133 46.1786 36.5318 44.0348 36.5318C42.3049 36.5318 40.8976 37.9345 40.8976 39.6587C40.8976 41.3828 42.3049 42.7855 44.0348 42.7855H48.7555C48.6273 42.4648 48.5051 42.1561 48.3897 41.8641ZM37.6906 67.9392H46.1263V51.1237H36.6449V66.8969C36.6449 67.4716 37.114 67.9392 37.6906 67.9392ZM35.5991 49.0392H46.1263V44.8701H35.5991C35.0225 44.8701 34.5534 45.3376 34.5534 45.9123V47.9969C34.5534 48.5716 35.0225 49.0392 35.5991 49.0392ZM48.2177 44.8701V67.9392H52.4007V44.8701H48.2177ZM62.9278 67.9392C63.5044 67.9392 63.9735 67.4716 63.9735 66.8969V51.1237H54.4922V67.9392H62.9278ZM65.0193 49.0392C65.5959 49.0392 66.065 48.5716 66.065 47.9969V45.9123C66.065 45.3376 65.5959 44.8701 65.0193 44.8701H54.4922V49.0392H65.0193Z"
      fill="#428BCA"
    />
  </svg>
);

export const blueFileIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "32"}
    height={height || "32"}
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M12.4474 22.0516H20.3421V20.4727H12.4474V22.0516ZM12.4474 17.8411H20.3421V16.2622H12.4474V17.8411ZM10.4028 25.999C9.87113 25.999 9.42105 25.8148 9.05263 25.4464C8.68421 25.078 8.5 24.6279 8.5 24.0962V7.90187C8.5 7.37015 8.68421 6.92008 9.05263 6.55166C9.42105 6.18323 9.87113 5.99902 10.4028 5.99902H18.7632L24.2895 11.5253V24.0962C24.2895 24.6279 24.1053 25.078 23.7368 25.4464C23.3684 25.8148 22.9183 25.999 22.3866 25.999H10.4028ZM17.9737 12.3148V7.57795H10.4028C10.3219 7.57795 10.2476 7.61169 10.1801 7.67916C10.1127 7.74665 10.0789 7.82089 10.0789 7.90187V24.0962C10.0789 24.1772 10.1127 24.2514 10.1801 24.3189C10.2476 24.3864 10.3219 24.4201 10.4028 24.4201H22.3866C22.4676 24.4201 22.5418 24.3864 22.6093 24.3189C22.6768 24.2514 22.7105 24.1772 22.7105 24.0962V12.3148H17.9737Z"
      fill="#428BCA"
    />
  </svg>
);

export const bulletIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "11"}
    height={height || "11"}
    viewBox="0 0 11 11"
    fill="none"
  >
    <circle cx="5.5" cy="5.5" r="5" fill="#428BCA" />
  </svg>
);

export const analysisWorkFlowConfigSVG = (
  <svg width="712" height="485" viewBox="0 0 834 485" fill="none">
    <rect x="0.5" y="0.5" width="833" height="484" fill="#F6F6F6" />
    <rect x="0.5" y="0.5" width="833" height="484" stroke="#C9C9C9" />
    <rect x="12" y="12" width="425" height="12" rx="6" fill="#E8E8E8" />
    <rect x="12" y="36" width="425" height="12" rx="6" fill="#E8E8E8" />
    <rect x="12" y="60" width="425" height="12" rx="6" fill="#E8E8E8" />
    <rect x="12" y="84" width="425" height="12" rx="6" fill="#E8E8E8" />
    <rect x="12" y="108" width="425" height="12" rx="6" fill="#E8E8E8" />
    <rect x="12" y="132" width="425" height="12" rx="6" fill="#E8E8E8" />
  </svg>
);

export const queryDeleteIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "18"}
    height={height || "20"}
    viewBox="0 0 18 20"
    fill="none"
  >
    <path
      d="M10.6497 16.1168H11.5497C11.6691 16.1168 11.7835 16.0685 11.8679 15.9824C11.9523 15.8964 11.9997 15.7797 11.9997 15.658V7.39917C11.9997 7.27748 11.9523 7.16078 11.8679 7.07473C11.7835 6.98869 11.6691 6.94035 11.5497 6.94035H10.6497C10.5304 6.94035 10.4159 6.98869 10.3315 7.07473C10.2471 7.16078 10.1997 7.27748 10.1997 7.39917V15.658C10.1997 15.7797 10.2471 15.8964 10.3315 15.9824C10.4159 16.0685 10.5304 16.1168 10.6497 16.1168ZM16.7998 3.26976H13.7094L12.4343 1.10182C12.2743 0.829973 12.048 0.605025 11.7773 0.448897C11.5067 0.29277 11.201 0.210787 10.8901 0.210938H7.10929C6.79847 0.210919 6.49294 0.292964 6.22245 0.449086C5.95196 0.605207 5.72572 0.830084 5.56578 1.10182L4.29002 3.26976H1.19961C1.04048 3.26976 0.88787 3.33421 0.775347 3.44894C0.662824 3.56367 0.599609 3.71927 0.599609 3.88152L0.599609 4.49329C0.599609 4.65554 0.662824 4.81114 0.775347 4.92587C0.88787 5.0406 1.04048 5.10505 1.19961 5.10505H1.79962V17.9521C1.79962 18.4389 1.98926 18.9057 2.32683 19.2499C2.6644 19.594 3.12224 19.7874 3.59964 19.7874H14.3997C14.8771 19.7874 15.335 19.594 15.6725 19.2499C16.0101 18.9057 16.1998 18.4389 16.1998 17.9521V5.10505H16.7998C16.9589 5.10505 17.1115 5.0406 17.224 4.92587C17.3366 4.81114 17.3998 4.65554 17.3998 4.49329V3.88152C17.3998 3.71927 17.3366 3.56367 17.224 3.44894C17.1115 3.33421 16.9589 3.26976 16.7998 3.26976ZM7.04367 2.1575C7.06372 2.12346 7.0921 2.09532 7.12601 2.07582C7.15993 2.05631 7.19823 2.04612 7.23717 2.04623H10.7622C10.8011 2.04619 10.8393 2.05641 10.8731 2.07591C10.907 2.09541 10.9353 2.12352 10.9553 2.1575L11.6101 3.26976H6.38929L7.04367 2.1575ZM14.3997 17.9521H3.59964V5.10505H14.3997V17.9521ZM6.44966 16.1168H7.34967C7.46902 16.1168 7.58348 16.0685 7.66787 15.9824C7.75226 15.8964 7.79968 15.7797 7.79968 15.658V7.39917C7.79968 7.27748 7.75226 7.16078 7.66787 7.07473C7.58348 6.98869 7.46902 6.94035 7.34967 6.94035H6.44966C6.33032 6.94035 6.21586 6.98869 6.13146 7.07473C6.04707 7.16078 5.99966 7.27748 5.99966 7.39917V15.658C5.99966 15.7797 6.04707 15.8964 6.13146 15.9824C6.21586 16.0685 6.33032 16.1168 6.44966 16.1168Z"
      fill="#428BCA"
    />
  </svg>
);

export const acknowledgeSvg = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "14"}
    height={height || "16"}
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      d="M13.1147 0H0.52882C0.211528 0 0 0.219707 0 0.549267V14.8302C0 15.1598 0.211528 15.3795 0.52882 15.3795H13.1147C13.432 15.3795 13.6436 15.1598 13.6436 14.8302V0.549267C13.6436 0.219707 13.3791 0 13.1147 0ZM12.5859 14.2809H1.05764V1.09853H12.5859V14.2809Z"
      fill="#428BCA"
    />
    <path
      d="M7.34913 8.23916H11.0509C11.3682 8.23916 11.5797 8.01945 11.5797 7.68989C11.5797 7.36033 11.3682 7.14062 11.0509 7.14062H7.34913C7.03184 7.14062 6.82031 7.36033 6.82031 7.68989C6.82031 8.01945 7.03184 8.23916 7.34913 8.23916Z"
      fill="#428BCA"
    />
    <path
      d="M3.2255 9.11812C3.33127 9.22798 3.43703 9.2829 3.59568 9.2829C3.8072 9.2829 3.86009 9.22798 3.96585 9.11812L6.08113 6.92106C6.29266 6.70135 6.29266 6.37179 6.08113 6.15208C5.8696 5.93238 5.55231 5.93238 5.34078 6.15208L3.64856 7.96466L2.96109 7.14076C2.74956 6.92106 2.43227 6.86613 2.22074 7.08584C2.00922 7.30554 1.95633 7.6351 2.16786 7.85481L3.2255 9.11812Z"
      fill="#428BCA"
    />
  </svg>
);

export const doubleTickIcon = (
  width?: string,
  height?: string,
  fill?: string
): JSX.Element => (
  <svg
    width={width || "25"}
    height={height || "25"}
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M7.13718 18.0273L2.2002 13.0903L3.19551 12.1094L7.15161 16.0655L7.47369 15.7432L8.4548 16.7241L7.13718 18.0273ZM12.3965 18.0273L7.45949 13.0903L8.44037 12.095L12.3965 16.0511L20.9603 7.4873L21.9412 8.48262L12.3965 18.0273ZM12.0742 13.0903L11.0789 12.1094L15.6866 7.50173L16.6819 8.48262L12.0742 13.0903Z"
      fill={fill || "#4F4F4F"}
    />
  </svg>
);

export const lineChartIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "33"}
    height={height || "32"}
    viewBox="0 0 33 32"
    fill="none"
  >
    <path
      d="M7.58875 6.54437C7.58875 5.69014 6.89861 5 6.04437 5C5.19014 5 4.5 5.69014 4.5 6.54437V22.7603C4.5 24.8935 6.22777 26.6212 8.36094 26.6212H27.6656C28.5199 26.6212 29.21 25.9311 29.21 25.0769C29.21 24.2226 28.5199 23.5325 27.6656 23.5325H8.36094C7.93623 23.5325 7.58875 23.185 7.58875 22.7603V6.54437ZM27.212 10.7238C27.8152 10.1206 27.8152 9.14085 27.212 8.53758C26.6087 7.93431 25.629 7.93431 25.0257 8.53758L19.9437 13.6244L17.1735 10.8541C16.5703 10.2509 15.5905 10.2509 14.9873 10.8541L9.58196 16.2595C8.97869 16.8627 8.97869 17.8424 9.58196 18.4457C10.1852 19.049 11.1649 19.049 11.7682 18.4457L16.0828 14.1359L18.853 16.9062C19.4563 17.5094 20.436 17.5094 21.0393 16.9062L27.2168 10.7287L27.212 10.7238Z"
      fill="#C9C9C9"
    />
  </svg>
);

export const rulesDictionaryIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.00575 21H20.9904L20.9875 20.9951C21.5452 20.9662 22.069 20.7135 22.4449 20.292C22.8208 19.8705 23.0182 19.3144 22.9942 18.745C23.0019 12.5052 23.001 7.49132 22.9942 4.24623C22.9959 4.04181 22.974 3.8379 22.9291 3.63869C22.8187 3.17165 22.5577 2.75609 22.188 2.45886C21.8183 2.16162 21.3614 2 20.8908 2H3.19837H3.1495H3.04887C2.80481 2.00593 2.56359 2.05492 2.33589 2.14479C2.06143 2.25369 1.81235 2.42008 1.60471 2.63323C1.39707 2.84638 1.23548 3.10158 1.13033 3.38237C1.06054 3.57095 1.01668 3.76849 1 3.96936V19.0228C1.01539 19.2266 1.05895 19.4272 1.12937 19.6186C1.23714 19.899 1.40023 20.1537 1.60853 20.367C1.98031 20.749 2.47884 20.9749 3.00575 21ZM15.0872 11L12.6313 8.49645L13.6095 7.49928L15.0803 8.99856L18.0218 6L19 6.99716L15.0872 11ZM11.2438 8.17113H5V9.58555H11.2438V8.17113ZM12.6313 14.4964L15.0872 17L19 12.9972L18.0218 12L15.0803 14.9986L13.6095 13.4993L12.6313 14.4964ZM5 14.1711H11.2438V15.5855H5V14.1711Z"
      fill="#C9C9C9"
    />
  </svg>
);

export const referenceDictionaryIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || "27"}
    height={height || "27"}
    viewBox="0 0 27 27"
    fill="none"
  >
    <path
      d="M20.25 1.125H6.75C5.85489 1.125 4.99645 1.48058 4.36351 2.11351C3.73058 2.74645 3.375 3.60489 3.375 4.5V22.5C3.375 23.3951 3.73058 24.2536 4.36351 24.8865C4.99645 25.5194 5.85489 25.875 6.75 25.875H20.25C20.8467 25.875 21.419 25.6379 21.841 25.216C22.2629 24.794 22.5 24.2217 22.5 23.625V21.375C22.7984 21.375 23.0845 21.2565 23.2955 21.0455C23.5065 20.8345 23.625 20.5484 23.625 20.25V4.5C23.625 3.60489 23.2694 2.74645 22.6365 2.11351C22.0036 1.48058 21.1451 1.125 20.25 1.125ZM20.25 23.625H6.75C6.45163 23.625 6.16548 23.5065 5.9545 23.2955C5.74353 23.0845 5.625 22.7984 5.625 22.5C5.62708 22.3504 5.659 22.2026 5.71888 22.0655C5.77877 21.9283 5.86541 21.8045 5.97375 21.7013C6.07348 21.5961 6.19398 21.5128 6.32761 21.4566C6.46123 21.4004 6.60507 21.3726 6.75 21.375H20.25V23.625Z"
      fill="#428BCA"
    />
  </svg>
);

export const trendStraingLineIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect width="24" height="24" rx="12" fill="#F6F6F6" />
    <rect
      x="6.35352"
      y="11.2939"
      width="11.2941"
      height="1.41176"
      fill="#949494"
    />
  </svg>
);

export const deactivateIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "25"}
    height={height || "26"}
    viewBox="0 0 25 26"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1282 22.2423L23.3968 25.5109L24.5507 24.357L1.70468 1.51098L0.550781 2.66488L3.14001 5.25411V20.5669C3.12099 20.7911 3.15145 21.0168 3.2293 21.2282C3.30714 21.4396 3.43049 21.6317 3.59079 21.7911C3.75108 21.9505 3.94449 22.0734 4.15756 22.1513C4.37063 22.2292 4.59826 22.2603 4.82465 22.2423H20.1282ZM18.5387 20.6528L6.13512 8.24922H4.73796V20.6528H18.5387ZM6.28551 3.59631H5.72678L7.85135 5.72087C7.84723 5.60568 7.84723 5.46873 7.84723 5.30601V2.59548C7.8488 2.12863 7.93548 2.04275 8.40825 2.04275H8.81798C9.3333 2.04431 9.40105 2.12706 9.40105 2.63451V4.15218C9.40105 4.42726 9.40145 4.70155 9.40185 4.97465V4.97502C9.40225 5.2459 9.40264 5.51562 9.40264 5.78379C9.40107 6.19756 9.28761 6.3178 8.88418 6.3178H8.88417C8.71271 6.32038 8.56961 6.32254 8.45017 6.31969L10.3797 8.24922H21.9153V19.7848L23.4153 21.2848C23.4231 21.2658 23.4306 21.2467 23.4377 21.2275C23.5155 21.0163 23.5462 20.7909 23.5274 20.5669C23.5274 18.8645 23.5255 17.1621 23.5236 15.4596C23.5197 12.0548 23.5159 8.64995 23.5274 5.24512C23.5319 5.02837 23.4923 4.81295 23.4109 4.61171C23.3295 4.41048 23.2081 4.22758 23.0538 4.07385C22.8995 3.92012 22.7156 3.79873 22.5129 3.71696C22.3103 3.63518 22.0931 3.59469 21.8743 3.59788C21.5433 3.6278 21.2092 3.62043 20.8632 3.61279C20.7035 3.60927 20.5413 3.60569 20.3756 3.60569V2.37687C20.3742 1.94964 20.2254 1.53576 19.954 1.20379C19.6826 0.871815 19.3048 0.641729 18.8833 0.551657C18.454 0.495142 18.0204 0.476847 17.5879 0.497003C17.0866 0.503925 16.608 0.705021 16.2545 1.05726C15.9011 1.40951 15.7009 1.88489 15.6968 2.38158V3.58382H10.9691V2.5221C10.9866 2.25277 10.9464 1.98281 10.8509 1.73003C10.7555 1.47724 10.6071 1.24739 10.4154 1.0556C10.2238 0.8638 9.99326 0.714409 9.7391 0.617318C9.48493 0.520227 9.2129 0.477602 8.9409 0.492286H8.18604C7.68588 0.49948 7.2081 0.698926 6.85351 1.0485C6.49893 1.39807 6.29527 1.87044 6.28551 2.36595V3.59631ZM18.8108 4.19278V2.49866C18.8108 2.18638 18.6689 2.03807 18.3553 2.04432H17.7738C17.342 2.04432 17.2538 2.1333 17.2522 2.55955V5.30444V5.30449C17.2522 6.35837 17.2522 6.35841 18.3128 6.31937C18.6737 6.30688 18.8013 6.18353 18.806 5.82129C18.8123 5.27662 18.8123 4.73507 18.8123 4.19352V4.19278H18.8108Z"
      fill="#428BCA"
    />
  </svg>
);

export const weeklyCalendarIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "25"}
    height={height || "25"}
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M8.76663 13.674C8.56169 13.674 8.38703 13.6018 8.24265 13.4576C8.0984 13.3132 8.02627 13.1385 8.02627 12.9336C8.02627 12.7287 8.0984 12.554 8.24265 12.4096C8.38703 12.2652 8.56169 12.193 8.76663 12.193C8.97156 12.193 9.14622 12.2652 9.29061 12.4096C9.43485 12.554 9.50698 12.7287 9.50698 12.9336C9.50698 13.1385 9.43485 13.3132 9.29061 13.4576C9.14622 13.6018 8.97156 13.674 8.76663 13.674ZM12.1147 13.674C11.9098 13.674 11.7351 13.6018 11.5908 13.4576C11.4465 13.3132 11.3744 13.1385 11.3744 12.9336C11.3744 12.7287 11.4465 12.554 11.5908 12.4096C11.7351 12.2652 11.9098 12.193 12.1147 12.193C12.3197 12.193 12.4943 12.2652 12.6387 12.4096C12.783 12.554 12.8551 12.7287 12.8551 12.9336C12.8551 13.1385 12.783 13.3132 12.6387 13.4576C12.4943 13.6018 12.3197 13.674 12.1147 13.674ZM15.4629 13.674C15.2579 13.674 15.0833 13.6018 14.9389 13.4576C14.7946 13.3132 14.7225 13.1385 14.7225 12.9336C14.7225 12.7287 14.7946 12.554 14.9389 12.4096C15.0833 12.2652 15.2579 12.193 15.4629 12.193C15.6678 12.193 15.8424 12.2652 15.9868 12.4096C16.1311 12.554 16.2032 12.7287 16.2032 12.9336C16.2032 13.1385 16.1311 13.3132 15.9868 13.4576C15.8424 13.6018 15.6678 13.674 15.4629 13.674ZM6.51314 20C6.0903 20 5.7324 19.8535 5.43944 19.5606C5.14648 19.2676 5 18.9097 5 18.4869V7.28366C5 6.86082 5.14648 6.50292 5.43944 6.20996C5.7324 5.917 6.0903 5.77052 6.51314 5.77052H7.672V4H8.95977V5.77052H15.3019V4H16.5575V5.77052H17.7163C18.1392 5.77052 18.4971 5.917 18.79 6.20996C19.083 6.50292 19.2295 6.86082 19.2295 7.28366V18.4869C19.2295 18.9097 19.083 19.2676 18.79 19.5606C18.4971 19.8535 18.1392 20 17.7163 20H6.51314ZM6.51314 18.7445H17.7163C17.7808 18.7445 17.8398 18.7176 17.8934 18.6639C17.9471 18.6103 17.9739 18.5513 17.9739 18.4869V10.6318H6.25554V18.4869C6.25554 18.5513 6.2824 18.6103 6.33611 18.6639C6.38968 18.7176 6.44869 18.7445 6.51314 18.7445Z"
      fill="#4F4F4F"
    />
  </svg>
);

export const monthlyCalendarIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "25"}
    height={height || "25"}
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M7.51314 20C7.0903 20 6.7324 19.8535 6.43944 19.5606C6.14648 19.2676 6 18.9097 6 18.4869V7.28366C6 6.86082 6.14648 6.50292 6.43944 6.20996C6.7324 5.917 7.0903 5.77052 7.51314 5.77052H8.672V4H9.95977V5.77052H16.3019V4H17.5575V5.77052H18.7163C19.1392 5.77052 19.4971 5.917 19.79 6.20996C20.083 6.50292 20.2295 6.86082 20.2295 7.28366V18.4869C20.2295 18.9097 20.083 19.2676 19.79 19.5606C19.4971 19.8535 19.1392 20 18.7163 20H7.51314ZM7.51314 18.7445H18.7163C18.7808 18.7445 18.8398 18.7176 18.8934 18.6639C18.9471 18.6103 18.9739 18.5513 18.9739 18.4869V10.6318H7.25554V18.4869C7.25554 18.5513 7.2824 18.6103 7.33611 18.6639C7.38968 18.7176 7.44869 18.7445 7.51314 18.7445ZM13.1147 13.7867C12.9098 13.7867 12.7351 13.7145 12.5908 13.5702C12.4465 13.4259 12.3744 13.2513 12.3744 13.0462C12.3744 12.8412 12.4465 12.6666 12.5908 12.5222C12.7351 12.378 12.9098 12.3058 13.1147 12.3058C13.3197 12.3058 13.4943 12.378 13.6387 12.5222C13.783 12.6666 13.8551 12.8412 13.8551 13.0462C13.8551 13.2513 13.783 13.4259 13.6387 13.5702C13.4943 13.7145 13.3197 13.7867 13.1147 13.7867ZM9.76663 13.7867C9.56169 13.7867 9.38703 13.7145 9.24265 13.5702C9.0984 13.4259 9.02627 13.2513 9.02627 13.0462C9.02627 12.8412 9.0984 12.6666 9.24265 12.5222C9.38703 12.378 9.56169 12.3058 9.76663 12.3058C9.97156 12.3058 10.1462 12.378 10.2906 12.5222C10.4349 12.6666 10.507 12.8412 10.507 13.0462C10.507 13.2513 10.4349 13.4259 10.2906 13.5702C10.1462 13.7145 9.97156 13.7867 9.76663 13.7867ZM16.4629 13.7867C16.2579 13.7867 16.0833 13.7145 15.9389 13.5702C15.7946 13.4259 15.7225 13.2513 15.7225 13.0462C15.7225 12.8412 15.7946 12.6666 15.9389 12.5222C16.0833 12.378 16.2579 12.3058 16.4629 12.3058C16.6678 12.3058 16.8424 12.378 16.9868 12.5222C17.1311 12.6666 17.2032 12.8412 17.2032 13.0462C17.2032 13.2513 17.1311 13.4259 16.9868 13.5702C16.8424 13.7145 16.6678 13.7867 16.4629 13.7867ZM13.1147 17.0704C12.9098 17.0704 12.7351 16.9982 12.5908 16.8538C12.4465 16.7096 12.3744 16.535 12.3744 16.3301C12.3744 16.125 12.4465 15.9503 12.5908 15.8061C12.7351 15.6617 12.9098 15.5895 13.1147 15.5895C13.3197 15.5895 13.4943 15.6617 13.6387 15.8061C13.783 15.9503 13.8551 16.125 13.8551 16.3301C13.8551 16.535 13.783 16.7096 13.6387 16.8538C13.4943 16.9982 13.3197 17.0704 13.1147 17.0704ZM9.76663 17.0704C9.56169 17.0704 9.38703 16.9982 9.24265 16.8538C9.0984 16.7096 9.02627 16.535 9.02627 16.3301C9.02627 16.125 9.0984 15.9503 9.24265 15.8061C9.38703 15.6617 9.56169 15.5895 9.76663 15.5895C9.97156 15.5895 10.1462 15.6617 10.2906 15.8061C10.4349 15.9503 10.507 16.125 10.507 16.3301C10.507 16.535 10.4349 16.7096 10.2906 16.8538C10.1462 16.9982 9.97156 17.0704 9.76663 17.0704ZM16.4629 17.0704C16.2579 17.0704 16.0833 16.9982 15.9389 16.8538C15.7946 16.7096 15.7225 16.535 15.7225 16.3301C15.7225 16.125 15.7946 15.9503 15.9389 15.8061C16.0833 15.6617 16.2579 15.5895 16.4629 15.5895C16.6678 15.5895 16.8424 15.6617 16.9868 15.8061C17.1311 15.9503 17.2032 16.125 17.2032 16.3301C17.2032 16.535 17.1311 16.7096 16.9868 16.8538C16.8424 16.9982 16.6678 17.0704 16.4629 17.0704Z"
      fill="#4F4F4F"
    />
  </svg>
);
export const blueEarthIcon = (): JSX.Element => (
  <svg width="13" height="13" viewBox="0 0 16 17" fill="none">
    <path
      d="M11.9871 10.7902C12.1133 9.89344 12.176 8.9889 12.1746 8.08331C12.176 7.17773 12.1133 6.27318 11.9871 5.37644H15.5324C16.159 7.12664 16.159 9.03999 15.5324 10.7902H11.9871ZM8.00116 16.0833C7.21991 16.0833 6.42241 15.2814 5.81085 13.8836C5.53148 13.2452 5.30398 12.5174 5.13366 11.7274H10.8687C10.6984 12.5171 10.4709 13.2449 10.1915 13.8836C9.57991 15.2814 8.78241 16.0833 8.00116 16.0833ZM4.96241 10.7902C4.69908 8.99521 4.69908 7.17141 4.96241 5.37644H11.0399C11.1731 6.27255 11.2391 7.17736 11.2374 8.08331C11.2391 8.98926 11.1731 9.89408 11.0399 10.7902H4.96241ZM0.469914 10.7902C-0.156638 9.03999 -0.156638 7.12664 0.469914 5.37644H4.01523C3.76481 7.17233 3.76481 8.99429 4.01523 10.7902H0.469914ZM8.00116 0.083313C8.78241 0.083313 9.57991 0.884875 10.1915 2.283C10.4709 2.92144 10.6984 3.64925 10.8687 4.43925H5.13366C5.30398 3.64956 5.53148 2.92175 5.81085 2.283C6.42241 0.884875 7.21991 0.083313 8.00116 0.083313ZM15.1262 4.43894H11.8255C11.638 3.51081 11.3774 2.65425 11.0505 1.90769C10.7859 1.30206 10.4859 0.78925 10.1574 0.376125C11.2224 0.671054 12.2143 1.18464 13.0697 1.88415C13.9252 2.58366 14.6256 3.45375 15.1262 4.43894ZM5.84491 0.375813C5.51741 0.78925 5.21773 1.30175 4.95273 1.90706C4.62585 2.65425 4.36554 3.51081 4.17773 4.43831H0.876164C1.37685 3.45324 2.07725 2.58326 2.93273 1.88382C3.7882 1.18437 4.78 0.670794 5.84491 0.375813ZM0.876164 11.7277H4.17679C4.36429 12.6558 4.62491 13.5124 4.95179 14.2589C5.21679 14.8643 5.51648 15.3767 5.84398 15.7902C4.77919 15.4952 3.78754 14.9816 2.93222 14.2821C2.0769 13.5827 1.37667 12.7127 0.876164 11.7277ZM10.1574 15.7902C10.4849 15.3767 10.7849 14.8643 11.0496 14.2589C11.3765 13.5118 11.6368 12.6552 11.8246 11.7277H15.1262C14.6256 12.7129 13.9252 13.583 13.0698 14.2826C12.2143 14.9822 11.2224 15.4958 10.1574 15.7908V15.7902Z"
      fill="#428BCA"
    />
  </svg>
);

export const magnifierIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "19.2"}
    height={height || "19.2"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.4712 18.9665L16.2851 14.7621C17.3237 13.5666 17.9088 12.0646 17.9438 10.5044C17.9789 8.9442 17.4617 7.41915 16.4778 6.18124C15.4939 4.94334 14.1021 4.06668 12.5324 3.6961C10.9628 3.32553 9.30922 3.48323 7.84494 4.14314C6.38066 4.80306 5.19332 5.92569 4.47911 7.32554C3.7649 8.72539 3.56657 10.3187 3.91689 11.8421C4.26721 13.3656 5.14522 14.728 6.40583 15.7043C7.66644 16.6806 9.2342 17.2123 10.8501 17.2116C12.3065 17.2152 13.728 16.7817 14.9181 15.9709L19.1362 20.2072C19.2195 20.2957 19.3204 20.3671 19.4328 20.4173C19.5452 20.4676 19.6668 20.4955 19.7906 20.4995C19.9144 20.5035 20.0377 20.4835 20.1533 20.4407C20.269 20.3979 20.3745 20.3331 20.4638 20.2502C20.5531 20.1673 20.6242 20.068 20.673 19.958C20.7218 19.8481 20.7473 19.7299 20.748 19.6103C20.7487 19.4907 20.7246 19.3722 20.677 19.2618C20.6295 19.1513 20.5595 19.0512 20.4712 18.9674V18.9665ZM10.8501 5.28432C11.8881 5.28432 12.9029 5.5816 13.766 6.13859C14.6291 6.69557 15.3019 7.48723 15.6991 8.41346C16.0964 9.33969 16.2003 10.3589 15.9978 11.3422C15.7953 12.3254 15.2954 13.2286 14.5614 13.9376C13.8273 14.6465 12.8921 15.1292 11.874 15.3248C10.8559 15.5204 9.80057 15.42 8.84152 15.0364C7.88247 14.6527 7.06275 14.003 6.48603 13.1694C5.90931 12.3358 5.60149 11.3558 5.60149 10.3533C5.60149 9.0089 6.15446 7.71959 7.13876 6.76898C8.12306 5.81836 9.45805 5.28432 10.8501 5.28432Z"
      fill="#4F4F4F"
      stroke="#4F4F4F"
      strokeWidth="0.5"
    />
  </svg>
);

export const blueBotIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "18"}
    viewBox="0 0 20 18"
    fill="none"
  >
    <path
      d="M7.37574 13.4946C7.15324 13.4946 6.93573 13.4286 6.75073 13.305C6.56572 13.1814 6.42153 13.0057 6.33638 12.8001C6.25123 12.5946 6.22895 12.3684 6.27236 12.1502C6.31577 11.9319 6.42291 11.7315 6.58025 11.5741C6.73758 11.4168 6.93804 11.3097 7.15627 11.2662C7.3745 11.2228 7.6007 11.2451 7.80626 11.3303C8.01183 11.4154 8.18753 11.5596 8.31115 11.7446C8.43476 11.9296 8.50074 12.1471 8.50074 12.3696C8.50074 12.668 8.38222 12.9541 8.17124 13.1651C7.96026 13.3761 7.67411 13.4946 7.37574 13.4946ZM12.6257 13.4946C12.4032 13.4946 12.1857 13.4286 12.0007 13.305C11.8157 13.1814 11.6715 13.0057 11.5864 12.8001C11.5012 12.5946 11.479 12.3684 11.5224 12.1502C11.5658 11.9319 11.6729 11.7315 11.8302 11.5741C11.9876 11.4168 12.188 11.3097 12.4063 11.2662C12.6245 11.2228 12.8507 11.2451 13.0563 11.3303C13.2618 11.4154 13.4375 11.5596 13.5611 11.7446C13.6848 11.9296 13.7507 12.1471 13.7507 12.3696C13.7507 12.668 13.6322 12.9541 13.4212 13.1651C13.2103 13.3761 12.9241 13.4946 12.6257 13.4946ZM18.5929 11.5643C17.4496 7.90666 14.032 5.24463 10.0007 5.24463C5.96949 5.24463 2.55184 7.90666 1.40856 11.5643C1.29371 11.4528 1.29043 16.3278 1.49668 16.0728C2.14074 17.2137 3.35012 17.9946 4.75074 17.9946H15.2507C16.6514 17.9946 17.8607 17.2137 18.5048 16.0728C18.7111 16.3278 18.7078 11.4528 18.5929 11.5643ZM13.3757 14.9946H6.62574C5.92955 14.9946 5.26187 14.7181 4.76959 14.2258C4.27731 13.7335 4.00074 13.0658 4.00074 12.3696C4.00074 11.6734 4.27731 11.0058 4.76959 10.5135C5.26187 10.0212 5.92955 9.74463 6.62574 9.74463H13.3757C14.0719 9.74463 14.7396 10.0212 15.2319 10.5135C15.7242 11.0058 16.0007 11.6734 16.0007 12.3696C16.0007 13.0658 15.7242 13.7335 15.2319 14.2258C14.7396 14.7181 14.0719 14.9946 13.3757 14.9946Z"
      fill="#428BCA"
    />
    <path
      d="M11.3447 1.44303C11.3441 1.74016 11.2598 2.0299 11.1031 2.27294C10.9464 2.51597 10.7249 2.70053 10.4688 2.80155V8.68364H9.58399V2.80457C9.35504 2.71693 9.1526 2.56228 8.99882 2.35754C8.84504 2.1528 8.74584 1.90586 8.71208 1.64375C8.67833 1.38163 8.71131 1.11443 8.80742 0.871394C8.90353 0.628354 9.05907 0.418836 9.25701 0.265764C9.45496 0.112693 9.68769 0.0219662 9.92973 0.00351189C10.1718 -0.0149425 10.4138 0.0395864 10.6293 0.161132C10.8449 0.282678 11.0256 0.466557 11.1518 0.692649C11.278 0.918742 11.3447 1.17834 11.3447 1.44303Z"
      fill="#428BCA"
    />
    <path
      d="M2.47891 12.1484C2.47891 11.5975 2.03242 11.1509 1.48164 11.1509C0.930866 11.1509 0.484375 11.5975 0.484375 12.1484V15.4503C0.484375 16.0012 0.930866 16.4478 1.48164 16.4478C2.03242 16.4478 2.47891 16.0012 2.47891 15.4503V12.1484Z"
      fill="#428BCA"
    />
    <path
      d="M19.4945 12.1484C19.4945 11.5975 19.048 11.1509 18.4973 11.1509C17.9465 11.1509 17.5 11.5975 17.5 12.1484V15.4503C17.5 16.0012 17.9465 16.4478 18.4973 16.4478C19.048 16.4478 19.4945 16.0012 19.4945 15.4503V12.1484Z"
      fill="#428BCA"
    />
  </svg>
);

export const multiChatIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "25"}
    height={height || "25"}
    viewBox="0 0 25 25"
    fill="none"
  >
    <g clipPath="url(#clip0_5239_131942)">
      <g opacity="0.8">
        <path
          d="M7.90662 15.5577L7.9066 15.5578L7.90861 15.5624C8.03824 15.8626 8.18815 16.1527 8.35711 16.4305C8.12926 16.3932 7.90286 16.3461 7.67851 16.2891L7.40048 16.2186L7.19922 16.423C6.91684 16.7098 6.58588 16.9391 6.22363 17.0998L6.22363 17.0998L6.21941 17.1017C5.82522 17.281 5.39945 17.3723 4.96976 17.3701H4.9672H4.69267L4.85388 17.2071L4.8557 17.2052C5.24404 16.8085 5.50252 16.3 5.59844 15.7497L5.65369 15.4327L5.38807 15.2511C4.56968 14.6915 3.92955 13.8912 3.55195 12.9508C3.20031 12.0002 3.15443 10.9573 3.42149 9.97715C3.78886 8.70906 4.5541 7.6061 5.5933 6.84015C6.72024 6.01535 8.05608 5.55233 9.43398 5.50691L9.45095 5.50635L9.45467 5.50718H9.50995H9.78726H9.79835L9.80943 5.50669C10.9425 5.45641 12.0646 5.6905 13.0822 6.18124C11.764 6.50912 10.5346 7.15754 9.50069 8.07956L9.50065 8.07951L9.49453 8.08514C8.49254 9.0091 7.80275 10.235 7.5216 11.5852L7.51111 11.6357V11.6779C7.51031 11.682 7.50854 11.6904 7.50488 11.7045C7.50168 11.7168 7.49899 11.7265 7.49544 11.7393C7.49311 11.7477 7.49041 11.7574 7.48694 11.7701C7.47965 11.7968 7.47025 11.8324 7.46214 11.8714L7.45995 11.882L7.45821 11.8926C7.40459 12.2211 7.38029 12.5539 7.3856 12.8868C7.37533 13.8045 7.55271 14.7146 7.90662 15.5577Z"
          stroke="#222A2D"
        />
      </g>
      <g opacity="0.8" clipPath="url(#clip1_5239_131942)">
        <path
          d="M9.37827 11.9993C9.63133 10.8177 10.2533 9.74629 11.1549 8.93866C12.683 7.61375 14.6623 6.92273 16.6859 7.00774C18.3844 6.98099 20.0468 7.49769 21.429 8.48197C22.6321 9.34256 23.5099 10.5814 23.9212 11.9993C24.2333 13.1083 24.1797 14.288 23.7684 15.3644C23.3319 16.4232 22.587 17.3274 21.63 17.9603C21.7111 18.42 21.9297 18.8445 22.2571 19.1782L23.3182 20.2197H21.8149C21.2784 20.2217 20.7473 20.1125 20.2553 19.8992C19.7998 19.7135 19.3848 19.4414 19.0333 19.098C18.2647 19.2823 17.4765 19.3738 16.6859 19.3704C14.6727 19.4561 12.7018 18.7775 11.171 17.4716C10.5586 16.9142 10.0711 16.2344 9.74004 15.4766C9.26095 14.3828 9.13454 13.1677 9.37827 11.9993ZM16.6859 18.1125C17.5022 18.1125 18.3143 17.9965 19.0977 17.768L19.4835 17.6558L19.7488 17.9683C19.9729 18.2379 20.2456 18.4635 20.5527 18.6333C20.4327 18.3036 20.3623 17.958 20.3437 17.6078V17.2472L20.6653 17.0549C21.5024 16.6182 22.1636 15.9083 22.5384 15.0439C22.9014 14.1783 22.9637 13.2166 22.7153 12.3118C22.1525 10.3007 20.0704 8.3057 16.6618 8.3057H16.4608C14.8245 8.27755 13.2344 8.84759 11.991 9.90813C11.5237 10.3324 11.1488 10.8478 10.8896 11.4224C10.6328 12.0001 10.5013 12.6253 10.5038 13.2572C10.5038 15.5487 12.4332 18.1125 16.6859 18.1125Z"
          fill="#222A2D"
        />
        <path
          d="M19.5317 14.4021C19.3279 14.4052 19.1277 14.348 18.9565 14.2376C18.7854 14.1272 18.651 13.9686 18.5704 13.782C18.4899 13.5954 18.4667 13.3891 18.5039 13.1894C18.5412 12.9896 18.6371 12.8054 18.7795 12.66C18.922 12.5147 19.1045 12.4148 19.304 12.373C19.5035 12.3312 19.711 12.3494 19.9001 12.4253C20.0892 12.5012 20.2514 12.6314 20.3661 12.7993C20.4809 12.9672 20.543 13.1653 20.5446 13.3685C20.5479 13.5031 20.524 13.6369 20.4746 13.7622C20.4251 13.8875 20.351 14.0016 20.2566 14.0979C20.1622 14.1942 20.0495 14.2707 19.925 14.323C19.8005 14.3752 19.6668 14.4021 19.5317 14.4021Z"
          fill="#222A2D"
        />
        <path
          d="M16.8305 14.4021C16.6267 14.4052 16.4265 14.348 16.2554 14.2376C16.0842 14.1272 15.9498 13.9686 15.8693 13.782C15.7887 13.5954 15.7655 13.3891 15.8028 13.1894C15.84 12.9896 15.9359 12.8054 16.0783 12.66C16.2208 12.5147 16.4033 12.4148 16.6028 12.373C16.8023 12.3312 17.0098 12.3494 17.1989 12.4253C17.388 12.5012 17.5502 12.6314 17.665 12.7993C17.7797 12.9672 17.8418 13.1653 17.8435 13.3685C17.8467 13.5031 17.8229 13.6369 17.7734 13.7622C17.7239 13.8875 17.6498 14.0016 17.5554 14.0979C17.4611 14.1942 17.3483 14.2707 17.2238 14.323C17.0993 14.3752 16.9656 14.4021 16.8305 14.4021Z"
          fill="#222A2D"
        />
        <path
          d="M14.1291 14.4021C13.9246 14.4052 13.7238 14.3476 13.5523 14.2365C13.3808 14.1254 13.2464 13.9659 13.1663 13.7783C13.0862 13.5908 13.0639 13.3837 13.1025 13.1835C13.141 12.9833 13.2385 12.799 13.3826 12.6543C13.5266 12.5096 13.7107 12.411 13.9113 12.371C14.1118 12.331 14.3198 12.3515 14.5086 12.4299C14.6975 12.5082 14.8586 12.6409 14.9714 12.8109C15.0842 12.981 15.1436 13.1807 15.1421 13.3845C15.1431 13.5178 15.1177 13.6499 15.0673 13.7733C15.0168 13.8967 14.9424 14.0089 14.8482 14.1035C14.7541 14.1981 14.642 14.2732 14.5186 14.3244C14.3952 14.3757 14.2628 14.4021 14.1291 14.4021Z"
          fill="#222A2D"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5239_131942">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.75 0.5)"
        />
      </clipPath>
      <clipPath id="clip1_5239_131942">
        <rect
          width="14.8725"
          height="13.22"
          fill="white"
          transform="matrix(-1 0 0 1 24.1226 7)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const multiChatFilledIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "21"}
    height={height || "16"}
    viewBox="0 0 21 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.61961 10.8642C5.88215 11.4723 6.23403 12.035 6.66286 12.5325C6.03721 12.5148 5.41521 12.428 4.80746 12.2738C4.48151 12.6048 4.09862 12.8704 3.67838 13.0568C3.21874 13.2659 2.72151 13.3726 2.21916 13.3701H0.746728L1.75036 12.3555C2.06687 12.0322 2.279 11.616 2.35782 11.1638C1.45444 10.5462 0.750809 9.66402 0.337353 8.63075C-0.0531594 7.57917 -0.104106 6.42567 0.192091 5.34183C0.589108 3.96832 1.41851 2.77035 2.5493 1.93715C3.7566 1.05333 5.18966 0.555965 6.66946 0.507178C6.69992 0.50036 6.73144 0.50036 6.7619 0.507178H7.03922C8.72386 0.432432 10.384 0.943191 11.7536 1.95757C10.0299 2.08714 8.39272 2.78686 7.08544 3.95272C6.16138 4.80481 5.5233 5.9373 5.26306 7.18717C5.26306 7.2825 5.22344 7.37783 5.20363 7.47316C5.15443 7.77457 5.13233 8.08002 5.1376 8.38562C5.12714 9.23762 5.2914 10.0823 5.61961 10.8642Z"
      fill="#949494"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7046 10.8267C20.0951 9.77511 20.146 8.62161 19.8498 7.53777C19.4647 6.1418 18.6342 4.92063 17.4926 4.0718C16.2853 3.18799 14.8523 2.69062 13.3725 2.64183C13.342 2.63501 13.3105 2.63501 13.28 2.64183H12.6726C10.8679 2.64454 9.12429 3.31642 7.76007 4.53484C6.9081 5.32399 6.31896 6.36997 6.07635 7.52415C6.07635 7.60586 6.04334 7.68758 6.03013 7.76929C5.98521 8.04605 5.96312 8.32623 5.96411 8.60684C5.95693 9.40297 6.11215 10.1918 6.4197 10.922C6.72505 11.6296 7.16256 12.2682 7.70725 12.8014L7.77328 12.8695C9.22844 14.1433 11.0957 14.8047 13.0027 14.7217C13.7501 14.7287 14.4953 14.6395 15.2213 14.4561C15.557 14.7907 15.9514 15.0564 16.3834 15.2392C16.843 15.4482 17.3402 15.555 17.8426 15.5524H19.282L18.2784 14.5378C17.9667 14.2127 17.7593 13.7967 17.6841 13.3462C18.5855 12.7321 19.2889 11.855 19.7046 10.8267ZM11.4643 9.26735C11.4191 9.38992 11.3493 9.5013 11.2596 9.5942C11.169 9.68293 11.064 9.7544 10.9492 9.80529C10.8325 9.85695 10.7065 9.88248 10.5795 9.88019C10.3856 9.88643 10.1945 9.83182 10.0314 9.72358C9.86997 9.6141 9.74359 9.4577 9.66829 9.27416C9.59002 9.09245 9.56923 8.88994 9.60886 8.69536C9.60504 8.67055 9.60504 8.64527 9.60886 8.62046C9.64891 8.45241 9.7335 8.29916 9.85317 8.17785C9.98932 8.03474 10.1642 7.93742 10.355 7.89867C10.5437 7.85779 10.74 7.87924 10.9162 7.95995C11.0946 8.03668 11.248 8.16423 11.3586 8.32766C11.4164 8.41714 11.4588 8.51618 11.4841 8.62046C11.5052 8.70964 11.5163 8.80103 11.5171 8.89283C11.5261 9.02015 11.508 9.14795 11.4643 9.26735ZM14.0328 9.26735C13.9828 9.38897 13.9111 9.49984 13.8215 9.5942C13.7567 9.66852 13.6781 9.72872 13.5904 9.77124C13.5653 9.78756 13.5388 9.80125 13.5111 9.8121C13.3932 9.86743 13.2642 9.8931 13.1348 9.887C12.9429 9.89405 12.7537 9.83931 12.5933 9.73039C12.4317 9.62224 12.3034 9.46866 12.2236 9.28778C12.1516 9.1044 12.131 8.90384 12.1642 8.70898V8.62727C12.2031 8.46227 12.2854 8.31151 12.4019 8.19147C12.5384 8.04752 12.7129 7.94808 12.9037 7.90547C13.0507 7.86472 13.2056 7.86472 13.3527 7.90547H13.4649C13.6444 7.98015 13.7984 8.10813 13.9073 8.27318C13.9886 8.39821 14.0427 8.53992 14.0658 8.68855C14.069 8.73389 14.069 8.77941 14.0658 8.82474C14.0842 8.9708 14.0729 9.1192 14.0328 9.26054V9.26735ZM16.588 9.26735C16.5405 9.38866 16.471 9.49957 16.3834 9.5942C16.2937 9.68889 16.1857 9.76312 16.0664 9.8121C15.9506 9.86686 15.8239 9.89253 15.6967 9.887C15.5028 9.89324 15.3117 9.83863 15.1486 9.73039C14.9889 9.62183 14.8629 9.46818 14.7855 9.28778C14.7083 9.10587 14.6853 8.9044 14.7194 8.70898C14.757 8.51359 14.8487 8.33365 14.9835 8.19101C15.1183 8.04836 15.2903 7.94917 15.4788 7.90547C15.6691 7.86542 15.8667 7.88437 16.0466 7.95995C16.2241 8.03506 16.3759 8.16309 16.4824 8.32766C16.5941 8.48849 16.6542 8.68138 16.6541 8.87921C16.6603 9.00921 16.64 9.1391 16.5946 9.26054L16.588 9.26735Z"
      fill="#949494"
    />
  </svg>
);

export const allGatewayUpIcon = (): JSX.Element => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M25.2391 27.25H25.1385H7.43183H7.42842V27.25C5.72774 27.2268 4.08802 26.6308 2.79475 25.5639C1.50128 24.4969 0.635871 23.0257 0.351724 21.4055C0.0675547 19.7851 0.383229 18.1207 1.24251 16.7025C2.07103 15.335 3.35369 14.2806 4.8786 13.706C4.87816 13.6937 4.87768 13.681 4.87719 13.668L4.87715 13.6668C4.87522 13.6153 4.87307 13.5584 4.87303 13.5009M25.2391 27.25L26.4578 14.8832C26.6051 14.436 26.68 13.9691 26.6794 13.4989L26.9294 13.5001C26.9294 13.4998 26.9294 13.4995 26.9294 13.4991C26.9352 12.2449 26.4239 11.0415 25.5109 10.1519C24.598 9.26245 23.3578 8.75887 22.0625 8.74855L22.0607 8.74855C21.1845 8.74766 20.3259 8.97795 19.5775 9.41286C18.7073 8.03816 17.4077 6.96249 15.8635 6.34091C14.2387 5.68687 12.4342 5.5722 10.7345 6.01468C9.03469 6.45718 7.5347 7.43219 6.47255 8.78782C5.41063 10.1431 4.84723 11.8014 4.87303 13.5009M25.2391 27.25L25.2426 27.2467C26.7995 27.2033 28.291 26.6222 29.4427 25.6057C30.6191 24.5674 31.3588 23.147 31.5178 21.6146C31.6768 20.0822 31.2434 18.5481 30.3026 17.3054C29.4185 16.1378 28.1451 15.3045 26.7022 14.9401L25.2391 27.25ZM4.87303 13.5009C4.87303 13.5002 4.87303 13.4996 4.87303 13.4989H5.12303M4.87303 13.5009C4.87304 13.5015 4.87305 13.5021 4.87305 13.5028L5.12303 13.4989M5.12303 13.4989C5.12303 13.5524 5.12505 13.6061 5.12705 13.6596C5.12904 13.7124 5.13101 13.7648 5.13101 13.8163V13.8803L5.12303 13.4989Z"
      fill="white"
      stroke="#7DCC6F"
      strokeWidth="0.5"
    />
    <path
      d="M25.1385 27H7.43183C5.78703 26.9776 4.20246 26.4012 2.95384 25.3711C1.70522 24.341 0.871579 22.9225 0.597966 21.3623C0.324353 19.8021 0.62809 18.1991 1.45633 16.832C2.28456 15.465 3.58487 14.4205 5.13101 13.8803V13.8163C5.13101 13.7127 5.12303 13.6052 5.12303 13.4989C5.09769 11.8569 5.64177 10.2535 6.66934 8.94201C7.69691 7.63052 9.14942 6.68565 10.7975 6.25662C12.4455 5.82759 14.1952 5.93885 15.7702 6.57283C17.3452 7.20681 18.6557 8.32738 19.4949 9.75757C20.2512 9.26214 21.1454 8.99762 22.0605 8.99855C23.2927 9.00836 24.4707 9.48748 25.3365 10.331C26.2022 11.1745 26.6851 12.3136 26.6794 13.4989C26.6802 14.053 26.576 14.6025 26.372 15.1206C27.8718 15.4319 29.2 16.2633 30.1032 17.4563C31.0065 18.6493 31.4215 20.1203 31.2691 21.5888C31.1168 23.0573 30.4077 24.4205 29.2773 25.4183C28.1468 26.4161 26.674 26.9787 25.1398 26.9987L25.1385 27ZM12.8678 21.6241C13.3011 21.9885 13.8023 22.2704 14.345 22.4548V23.6196C14.3445 23.6837 14.3668 23.7461 14.4082 23.7963C14.4495 23.8466 14.5075 23.8818 14.5725 23.8961C15.446 24.0858 16.3525 24.0858 17.226 23.8961C17.291 23.8818 17.3489 23.8466 17.3903 23.7963C17.4317 23.7461 17.454 23.6837 17.4535 23.6196V22.4548C17.9952 22.2671 18.4964 21.985 18.932 21.6229L19.9673 22.2052C20.0117 22.2302 20.0622 22.2434 20.1136 22.2436C20.154 22.2435 20.1938 22.235 20.2305 22.2189C20.2672 22.2028 20.3 22.1794 20.3266 22.1502C20.9359 21.5072 21.3903 20.7428 21.6573 19.9115C21.6763 19.8495 21.6736 19.7832 21.6496 19.7228C21.6255 19.6625 21.5815 19.6114 21.5242 19.5775L20.4889 18.9951C20.5951 18.4451 20.5951 17.8811 20.4889 17.3311L21.5242 16.7487C21.5817 16.7158 21.6261 16.6652 21.6502 16.6051C21.6744 16.545 21.6768 16.4788 21.6573 16.4172C21.3892 15.5864 20.935 14.8222 20.3266 14.1786C20.2993 14.1496 20.266 14.1264 20.2289 14.1106C20.1918 14.0947 20.1516 14.0865 20.111 14.0864C20.0604 14.0866 20.0107 14.0998 19.9673 14.1248L18.932 14.7059C18.4979 14.342 17.9963 14.0602 17.4535 13.8752V12.7181C17.454 12.654 17.4317 12.5917 17.3903 12.5414C17.3489 12.4911 17.291 12.4559 17.226 12.4417C16.3524 12.2527 15.4461 12.2527 14.5725 12.4417C14.5075 12.4559 14.4495 12.4911 14.4082 12.5414C14.3668 12.5917 14.3445 12.654 14.345 12.7181V13.8829C13.8033 14.0707 13.3021 14.3527 12.8665 14.7149L11.8339 14.1325C11.7894 14.1075 11.7389 14.0943 11.6875 14.0941C11.6471 14.0943 11.6073 14.1027 11.5706 14.1188C11.5339 14.1349 11.5012 14.1583 11.4746 14.1875C10.8652 14.8305 10.4108 15.5949 10.1439 16.4262C10.124 16.4878 10.1264 16.554 10.1506 16.6142C10.1747 16.6743 10.2192 16.7249 10.2769 16.7577L11.3122 17.3401C11.2072 17.8901 11.2072 18.454 11.3122 19.0041L10.2769 19.5864C10.2192 19.6193 10.1747 19.6698 10.1506 19.73C10.1264 19.7901 10.124 19.8563 10.1439 19.9179C10.4119 20.7488 10.8661 21.513 11.4746 22.1566C11.5018 22.1856 11.5351 22.2087 11.5722 22.2246C11.6094 22.2405 11.6495 22.2487 11.6902 22.2488C11.7408 22.2486 11.7904 22.2353 11.8339 22.2104L12.8692 21.628L12.8678 21.6241ZM15.8966 20.06C15.506 20.0648 15.1228 19.9579 14.7956 19.7527C14.4684 19.5475 14.212 19.2533 14.0591 18.9076C13.9061 18.5619 13.8635 18.1803 13.9366 17.8112C14.0097 17.4422 14.1953 17.1024 14.4697 16.835C14.7441 16.5676 15.095 16.3848 15.4777 16.3097C15.8604 16.2346 16.2577 16.2707 16.619 16.4133C16.9804 16.556 17.2895 16.7987 17.507 17.1107C17.7246 17.4228 17.8407 17.79 17.8408 18.1657C17.8443 18.6652 17.6415 19.1455 17.2769 19.5013C16.9124 19.857 16.4159 20.0589 15.8966 20.0626V20.06Z"
      fill="#59A84B"
    />
  </svg>
);

export const userWithTickInCircleIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "18"}
    height={height || "17"}
    viewBox="0 0 18 17"
    fill="none"
  >
    <path
      d="M13.2242 8.68572C12.1805 8.68205 11.182 9.11188 10.4675 9.87271C9.43975 9.05275 8.16288 8.60836 6.84814 8.61332H6.83779C5.25764 8.61667 3.79132 9.23088 2.70455 10.3487C1.60042 11.477 0.996669 13.0192 1.00001 14.6926C1.00066 14.7841 1.03659 14.8718 1.10013 14.9375C1.16498 15.0024 1.25323 15.0386 1.34504 15.0376L10.4019 15.0203C10.4226 15.0445 10.4432 15.0652 10.464 15.0894C11.6531 16.3478 13.5432 16.6421 15.0587 15.805C16.5742 14.9678 17.3314 13.2113 16.8993 11.5347C16.4672 9.85815 14.9556 8.68626 13.2242 8.68572ZM1.70043 14.3441C1.77293 12.9881 2.29738 11.7496 3.19782 10.8284C4.15361 9.84509 5.44742 9.30338 6.83779 9.30338H6.84814C8.0086 9.29885 9.13582 9.6907 10.0431 10.4143C9.27867 11.5949 9.22828 13.1012 9.91198 14.3304L1.70043 14.3441ZM13.2242 15.5862C11.5092 15.5862 10.119 14.1959 10.119 12.4809C10.119 10.7661 11.5092 9.37577 13.2242 9.37577C14.9392 9.37577 16.3293 10.7661 16.3293 12.4809C16.3293 14.1959 14.9392 15.5862 13.2242 15.5862Z"
      fill="#222A2D"
      stroke="#222A2D"
      strokeWidth="0.3"
    />
    <path
      d="M6.8412 7.79384C8.85528 7.79384 10.4881 6.16105 10.4881 4.14698C10.4881 2.13279 8.85528 0.5 6.8412 0.5C4.82713 0.5 3.19434 2.13279 3.19434 4.14698C3.19628 6.16019 4.82789 7.7919 6.8412 7.79384ZM6.8412 1.19006C8.47432 1.19006 9.79801 2.51397 9.79801 4.14698C9.79801 5.77988 8.47432 7.10378 6.8412 7.10378C5.20819 7.10378 3.88439 5.77988 3.88439 4.14698C3.88634 2.51472 5.20895 1.19211 6.8412 1.19006Z"
      fill="#222A2D"
      stroke="#222A2D"
      strokeWidth="0.3"
    />
    <path
      d="M14.3873 11.4307L12.7208 12.7867L12.1101 12.0725C11.9863 11.9276 11.7685 11.9106 11.6238 12.0345C11.4789 12.1583 11.4619 12.3762 11.5858 12.5211L12.4138 13.4905C12.4795 13.5668 12.5752 13.611 12.6761 13.6112C12.7551 13.612 12.8319 13.5851 12.8933 13.5353L14.8221 11.9654C14.9678 11.845 14.989 11.6295 14.8698 11.4827C14.7504 11.3359 14.5351 11.3128 14.3873 11.4307Z"
      fill="#222A2D"
      stroke="#222A2D"
      strokeWidth="0.3"
    />
  </svg>
);

export const allGatewaysDownIcon = (): JSX.Element => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M25.2391 27.25H25.1385H7.43183H7.42842V27.25C5.72774 27.2268 4.08802 26.6308 2.79475 25.5639C1.50128 24.4969 0.635871 23.0257 0.351724 21.4055C0.0675547 19.7851 0.383229 18.1207 1.24251 16.7025C2.07103 15.335 3.35369 14.2806 4.8786 13.706C4.87816 13.6937 4.87768 13.681 4.87719 13.668L4.87715 13.6668C4.87522 13.6153 4.87307 13.5584 4.87303 13.5009M25.2391 27.25L26.4578 14.8832C26.6051 14.436 26.68 13.9691 26.6794 13.4989L26.9294 13.5001C26.9294 13.4998 26.9294 13.4995 26.9294 13.4991C26.9352 12.2449 26.4239 11.0415 25.5109 10.1519C24.598 9.26245 23.3578 8.75887 22.0625 8.74855L22.0607 8.74855C21.1845 8.74766 20.3259 8.97795 19.5775 9.41286C18.7073 8.03816 17.4077 6.96249 15.8635 6.34091C14.2387 5.68687 12.4342 5.5722 10.7345 6.01468C9.03469 6.45718 7.5347 7.43219 6.47255 8.78782C5.41063 10.1431 4.84723 11.8014 4.87303 13.5009M25.2391 27.25L25.2426 27.2467C26.7995 27.2033 28.291 26.6222 29.4427 25.6057C30.6191 24.5674 31.3588 23.147 31.5178 21.6146C31.6768 20.0822 31.2434 18.5481 30.3026 17.3054C29.4185 16.1378 28.1451 15.3045 26.7022 14.9401L25.2391 27.25ZM4.87303 13.5009C4.87303 13.5002 4.87303 13.4996 4.87303 13.4989H5.12303M4.87303 13.5009C4.87304 13.5015 4.87305 13.5021 4.87305 13.5028L5.12303 13.4989M5.12303 13.4989C5.12303 13.5524 5.12505 13.6061 5.12705 13.6596C5.12904 13.7124 5.13101 13.7648 5.13101 13.8163V13.8803L5.12303 13.4989Z"
      fill="white"
      stroke="#E0B2B6"
      strokeWidth="0.5"
    />
    <path
      d="M25.1385 27H7.43183C5.78703 26.9776 4.20246 26.4012 2.95384 25.3711C1.70522 24.341 0.871579 22.9225 0.597966 21.3623C0.324353 19.8021 0.62809 18.1991 1.45633 16.832C2.28456 15.465 3.58487 14.4205 5.13101 13.8803V13.8163C5.13101 13.7127 5.12303 13.6052 5.12303 13.4989C5.09769 11.8569 5.64177 10.2535 6.66934 8.94201C7.69691 7.63052 9.14942 6.68565 10.7975 6.25662C12.4455 5.82759 14.1952 5.93885 15.7702 6.57283C17.3452 7.20681 18.6557 8.32738 19.4949 9.75757C20.2512 9.26214 21.1454 8.99762 22.0605 8.99855C23.2927 9.00836 24.4707 9.48748 25.3365 10.331C26.2022 11.1745 26.6851 12.3136 26.6794 13.4989C26.6802 14.053 26.576 14.6025 26.372 15.1206C27.8718 15.4319 29.2 16.2633 30.1032 17.4563C31.0065 18.6493 31.4215 20.1203 31.2691 21.5888C31.1168 23.0573 30.4077 24.4205 29.2773 25.4183C28.1468 26.4161 26.674 26.9787 25.1398 26.9987L25.1385 27ZM12.8678 21.6241C13.3011 21.9885 13.8023 22.2704 14.345 22.4548V23.6196C14.3445 23.6837 14.3668 23.7461 14.4082 23.7963C14.4495 23.8466 14.5075 23.8818 14.5725 23.8961C15.446 24.0858 16.3525 24.0858 17.226 23.8961C17.291 23.8818 17.3489 23.8466 17.3903 23.7963C17.4317 23.7461 17.454 23.6837 17.4535 23.6196V22.4548C17.9952 22.2671 18.4964 21.985 18.932 21.6229L19.9673 22.2052C20.0117 22.2302 20.0622 22.2434 20.1136 22.2436C20.154 22.2435 20.1938 22.235 20.2305 22.2189C20.2672 22.2028 20.3 22.1794 20.3266 22.1502C20.9359 21.5072 21.3903 20.7428 21.6573 19.9115C21.6763 19.8495 21.6736 19.7832 21.6496 19.7228C21.6255 19.6625 21.5815 19.6114 21.5242 19.5775L20.4889 18.9951C20.5951 18.4451 20.5951 17.8811 20.4889 17.3311L21.5242 16.7487C21.5817 16.7158 21.6261 16.6652 21.6502 16.6051C21.6744 16.545 21.6768 16.4788 21.6573 16.4172C21.3892 15.5864 20.935 14.8222 20.3266 14.1786C20.2993 14.1496 20.266 14.1264 20.2289 14.1106C20.1918 14.0947 20.1516 14.0865 20.111 14.0864C20.0604 14.0866 20.0107 14.0998 19.9673 14.1248L18.932 14.7059C18.4979 14.342 17.9963 14.0602 17.4535 13.8752V12.7181C17.454 12.654 17.4317 12.5917 17.3903 12.5414C17.3489 12.4911 17.291 12.4559 17.226 12.4417C16.3524 12.2527 15.4461 12.2527 14.5725 12.4417C14.5075 12.4559 14.4495 12.4911 14.4082 12.5414C14.3668 12.5917 14.3445 12.654 14.345 12.7181V13.8829C13.8033 14.0707 13.3021 14.3527 12.8665 14.7149L11.8339 14.1325C11.7894 14.1075 11.7389 14.0943 11.6875 14.0941C11.6471 14.0943 11.6073 14.1027 11.5706 14.1188C11.5339 14.1349 11.5012 14.1583 11.4746 14.1875C10.8652 14.8305 10.4108 15.5949 10.1439 16.4262C10.124 16.4878 10.1264 16.554 10.1506 16.6142C10.1747 16.6743 10.2192 16.7249 10.2769 16.7577L11.3122 17.3401C11.2072 17.8901 11.2072 18.454 11.3122 19.0041L10.2769 19.5864C10.2192 19.6193 10.1747 19.6698 10.1506 19.73C10.1264 19.7901 10.124 19.8563 10.1439 19.9179C10.4119 20.7488 10.8661 21.513 11.4746 22.1566C11.5018 22.1856 11.5351 22.2087 11.5722 22.2246C11.6094 22.2405 11.6495 22.2487 11.6902 22.2488C11.7408 22.2486 11.7904 22.2353 11.8339 22.2104L12.8692 21.628L12.8678 21.6241ZM15.8966 20.06C15.506 20.0648 15.1228 19.9579 14.7956 19.7527C14.4684 19.5475 14.212 19.2533 14.0591 18.9076C13.9061 18.5619 13.8635 18.1803 13.9366 17.8112C14.0097 17.4422 14.1953 17.1024 14.4697 16.835C14.7441 16.5676 15.095 16.3848 15.4777 16.3097C15.8604 16.2346 16.2577 16.2707 16.619 16.4133C16.9804 16.556 17.2895 16.7987 17.507 17.1107C17.7246 17.4228 17.8407 17.79 17.8408 18.1657C17.8443 18.6652 17.6415 19.1455 17.2769 19.5013C16.9124 19.857 16.4159 20.0589 15.8966 20.0626V20.06Z"
      fill="#D94B55"
    />
  </svg>
);

export const intermidiateGatewaysStateIcon = (): JSX.Element => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M25.2391 27.25H25.1385H7.43183H7.42842V27.25C5.72774 27.2268 4.08802 26.6308 2.79475 25.5639C1.50128 24.4969 0.635871 23.0257 0.351724 21.4055C0.0675547 19.7851 0.383229 18.1207 1.24251 16.7025C2.07103 15.335 3.35369 14.2806 4.8786 13.706C4.87816 13.6937 4.87768 13.681 4.87719 13.668L4.87715 13.6668C4.87522 13.6153 4.87307 13.5584 4.87303 13.5009M25.2391 27.25L26.4578 14.8832C26.6051 14.436 26.68 13.9691 26.6794 13.4989L26.9294 13.5001C26.9294 13.4998 26.9294 13.4995 26.9294 13.4991C26.9352 12.2449 26.4239 11.0415 25.5109 10.1519C24.598 9.26245 23.3578 8.75887 22.0625 8.74855L22.0607 8.74855C21.1845 8.74766 20.3259 8.97795 19.5775 9.41286C18.7073 8.03816 17.4077 6.96249 15.8635 6.34091C14.2387 5.68687 12.4342 5.5722 10.7345 6.01468C9.03469 6.45718 7.5347 7.43219 6.47255 8.78782C5.41063 10.1431 4.84723 11.8014 4.87303 13.5009M25.2391 27.25L25.2426 27.2467C26.7995 27.2033 28.291 26.6222 29.4427 25.6057C30.6191 24.5674 31.3588 23.147 31.5178 21.6146C31.6768 20.0822 31.2434 18.5481 30.3026 17.3054C29.4185 16.1378 28.1451 15.3045 26.7022 14.9401L25.2391 27.25ZM4.87303 13.5009C4.87303 13.5002 4.87303 13.4996 4.87303 13.4989H5.12303M4.87303 13.5009C4.87304 13.5015 4.87305 13.5021 4.87305 13.5028L5.12303 13.4989M5.12303 13.4989C5.12303 13.5524 5.12505 13.6061 5.12705 13.6596C5.12904 13.7124 5.13101 13.7648 5.13101 13.8163V13.8803L5.12303 13.4989Z"
      fill="white"
      stroke="#F5B18A"
      strokeWidth="0.5"
    />
    <path
      d="M25.1385 27H7.43183C5.78703 26.9776 4.20246 26.4012 2.95384 25.3711C1.70522 24.341 0.871579 22.9225 0.597966 21.3623C0.324353 19.8021 0.62809 18.1991 1.45633 16.832C2.28456 15.465 3.58487 14.4205 5.13101 13.8803V13.8163C5.13101 13.7127 5.12303 13.6052 5.12303 13.4989C5.09769 11.8569 5.64177 10.2535 6.66934 8.94201C7.69691 7.63052 9.14942 6.68565 10.7975 6.25662C12.4455 5.82759 14.1952 5.93885 15.7702 6.57283C17.3452 7.20681 18.6557 8.32738 19.4949 9.75757C20.2512 9.26214 21.1454 8.99762 22.0605 8.99855C23.2927 9.00836 24.4707 9.48748 25.3365 10.331C26.2022 11.1745 26.6851 12.3136 26.6794 13.4989C26.6802 14.053 26.576 14.6025 26.372 15.1206C27.8718 15.4319 29.2 16.2633 30.1032 17.4563C31.0065 18.6493 31.4215 20.1203 31.2691 21.5888C31.1168 23.0573 30.4077 24.4205 29.2773 25.4183C28.1468 26.4161 26.674 26.9787 25.1398 26.9987L25.1385 27ZM12.8678 21.6241C13.3011 21.9885 13.8023 22.2704 14.345 22.4548V23.6196C14.3445 23.6837 14.3668 23.7461 14.4082 23.7963C14.4495 23.8466 14.5075 23.8818 14.5725 23.8961C15.446 24.0858 16.3525 24.0858 17.226 23.8961C17.291 23.8818 17.3489 23.8466 17.3903 23.7963C17.4317 23.7461 17.454 23.6837 17.4535 23.6196V22.4548C17.9952 22.2671 18.4964 21.985 18.932 21.6229L19.9673 22.2052C20.0117 22.2302 20.0622 22.2434 20.1136 22.2436C20.154 22.2435 20.1938 22.235 20.2305 22.2189C20.2672 22.2028 20.3 22.1794 20.3266 22.1502C20.9359 21.5072 21.3903 20.7428 21.6573 19.9115C21.6763 19.8495 21.6736 19.7832 21.6496 19.7228C21.6255 19.6625 21.5815 19.6114 21.5242 19.5775L20.4889 18.9951C20.5951 18.4451 20.5951 17.8811 20.4889 17.3311L21.5242 16.7487C21.5817 16.7158 21.6261 16.6652 21.6502 16.6051C21.6744 16.545 21.6768 16.4788 21.6573 16.4172C21.3892 15.5864 20.935 14.8222 20.3266 14.1786C20.2993 14.1496 20.266 14.1264 20.2289 14.1106C20.1918 14.0947 20.1516 14.0865 20.111 14.0864C20.0604 14.0866 20.0107 14.0998 19.9673 14.1248L18.932 14.7059C18.4979 14.342 17.9963 14.0602 17.4535 13.8752V12.7181C17.454 12.654 17.4317 12.5917 17.3903 12.5414C17.3489 12.4911 17.291 12.4559 17.226 12.4417C16.3524 12.2527 15.4461 12.2527 14.5725 12.4417C14.5075 12.4559 14.4495 12.4911 14.4082 12.5414C14.3668 12.5917 14.3445 12.654 14.345 12.7181V13.8829C13.8033 14.0707 13.3021 14.3527 12.8665 14.7149L11.8339 14.1325C11.7894 14.1075 11.7389 14.0943 11.6875 14.0941C11.6471 14.0943 11.6073 14.1027 11.5706 14.1188C11.5339 14.1349 11.5012 14.1583 11.4746 14.1875C10.8652 14.8305 10.4108 15.5949 10.1439 16.4262C10.124 16.4878 10.1264 16.554 10.1506 16.6142C10.1747 16.6743 10.2192 16.7249 10.2769 16.7577L11.3122 17.3401C11.2072 17.8901 11.2072 18.454 11.3122 19.0041L10.2769 19.5864C10.2192 19.6193 10.1747 19.6698 10.1506 19.73C10.1264 19.7901 10.124 19.8563 10.1439 19.9179C10.4119 20.7488 10.8661 21.513 11.4746 22.1566C11.5018 22.1856 11.5351 22.2087 11.5722 22.2246C11.6094 22.2405 11.6495 22.2487 11.6902 22.2488C11.7408 22.2486 11.7904 22.2353 11.8339 22.2104L12.8692 21.628L12.8678 21.6241ZM15.8966 20.06C15.506 20.0648 15.1228 19.9579 14.7956 19.7527C14.4684 19.5475 14.212 19.2533 14.0591 18.9076C13.9061 18.5619 13.8635 18.1803 13.9366 17.8112C14.0097 17.4422 14.1953 17.1024 14.4697 16.835C14.7441 16.5676 15.095 16.3848 15.4777 16.3097C15.8604 16.2346 16.2577 16.2707 16.619 16.4133C16.9804 16.556 17.2895 16.7987 17.507 17.1107C17.7246 17.4228 17.8407 17.79 17.8408 18.1657C17.8443 18.6652 17.6415 19.1455 17.2769 19.5013C16.9124 19.857 16.4159 20.0589 15.8966 20.0626V20.06Z"
      fill="#FF6915"
    />
  </svg>
);

export const downGatewayIcon = (): JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g id="Tab Icons">
      <path
        id="SAWS"
        d="M15.4988 15.832H4.9591C3.98005 15.8187 3.03686 15.4756 2.29363 14.8624C1.5504 14.2493 1.05419 13.4049 0.891321 12.4763C0.728456 11.5476 0.909252 10.5934 1.40225 9.77966C1.89525 8.96595 2.66924 8.34424 3.58956 8.02271V7.98462C3.58956 7.9229 3.58481 7.85891 3.58481 7.79567C3.56973 6.81826 3.89358 5.86388 4.50523 5.08323C5.11688 4.30258 5.98147 3.74016 6.96245 3.48478C7.94344 3.22941 8.98491 3.29563 9.92241 3.673C10.8599 4.05037 11.64 4.71738 12.1395 5.56868C12.5897 5.27378 13.1219 5.11633 13.6666 5.11688C14.4001 5.12272 15.1013 5.40791 15.6166 5.91C16.1319 6.41209 16.4194 7.09015 16.416 7.79567C16.4164 8.12545 16.3544 8.45256 16.233 8.76098C17.1258 8.94625 17.9164 9.44115 18.454 10.1513C18.9916 10.8614 19.2386 11.737 19.148 12.6111C19.0573 13.4852 18.6352 14.2966 17.9623 14.8905C17.2894 15.4845 16.4127 15.8193 15.4995 15.8313L15.4988 15.832ZM8.19482 12.6321C8.45269 12.849 8.75106 13.0168 9.07405 13.1266V13.8199C9.07378 13.8581 9.08705 13.8952 9.11168 13.9251C9.13631 13.955 9.17082 13.976 9.2095 13.9845C9.72944 14.0974 10.269 14.0974 10.7889 13.9845C10.8276 13.976 10.8621 13.955 10.8868 13.9251C10.9114 13.8952 10.9247 13.8581 10.9244 13.8199V13.1266C11.2468 13.0148 11.5451 12.8469 11.8044 12.6314L12.4207 12.978C12.4471 12.9929 12.4772 13.0007 12.5078 13.0009C12.5318 13.0008 12.5555 12.9957 12.5774 12.9862C12.5992 12.9766 12.6187 12.9626 12.6345 12.9453C12.9972 12.5625 13.2677 12.1075 13.4266 11.6127C13.438 11.5758 13.4363 11.5363 13.422 11.5004C13.4077 11.4644 13.3815 11.434 13.3474 11.4139L12.7312 11.0672C12.7944 10.7399 12.7944 10.4041 12.7312 10.0768L13.3474 9.7301C13.3817 9.71046 13.4081 9.68036 13.4224 9.64458C13.4368 9.60881 13.4383 9.56944 13.4266 9.53277C13.2671 9.03822 12.9967 8.58335 12.6345 8.20023C12.6183 8.18299 12.5985 8.1692 12.5764 8.15976C12.5543 8.15031 12.5304 8.14541 12.5062 8.14537C12.4761 8.14547 12.4465 8.15337 12.4207 8.16823L11.8044 8.51413C11.546 8.29754 11.2475 8.12978 10.9244 8.01966V7.33092C10.9247 7.29276 10.9114 7.25564 10.8868 7.22572C10.8621 7.1958 10.8276 7.17485 10.7889 7.16635C10.269 7.05385 9.72948 7.05385 9.2095 7.16635C9.17082 7.17485 9.13631 7.1958 9.11168 7.22572C9.08705 7.25564 9.07378 7.29276 9.07405 7.33092V8.02424C8.75162 8.13601 8.45331 8.30388 8.19403 8.51946L7.57936 8.1728C7.55291 8.15795 7.52286 8.15007 7.49223 8.14995C7.46821 8.15005 7.4445 8.15507 7.42265 8.16465C7.4008 8.17424 7.38132 8.18819 7.36549 8.20556C7.00278 8.5883 6.73232 9.04329 6.5734 9.5381C6.56161 9.57477 6.56301 9.61419 6.57738 9.64999C6.59176 9.6858 6.61826 9.7159 6.65261 9.73543L7.26886 10.0821C7.20637 10.4095 7.20637 10.7451 7.26886 11.0725L6.65261 11.4192C6.61826 11.4387 6.59176 11.4688 6.57738 11.5046C6.56301 11.5404 6.56161 11.5799 6.5734 11.6165C6.73294 12.1111 7.00333 12.5659 7.36549 12.9491C7.38173 12.9663 7.40153 12.9801 7.42362 12.9895C7.44572 12.999 7.46963 13.0039 7.49381 13.0039C7.52394 13.0038 7.55349 12.9959 7.57936 12.9811L8.19561 12.6344L8.19482 12.6321ZM9.99764 11.7011C9.76516 11.704 9.53704 11.6403 9.34229 11.5181C9.14753 11.396 8.99494 11.2209 8.9039 11.0151C8.81286 10.8094 8.78748 10.5822 8.831 10.3625C8.87452 10.1429 8.98497 9.94058 9.1483 9.78144C9.31164 9.62229 9.52048 9.51345 9.74829 9.46876C9.9761 9.42406 10.2126 9.44553 10.4277 9.53043C10.6428 9.61533 10.8267 9.75984 10.9562 9.94557C11.0857 10.1313 11.1549 10.3499 11.1549 10.5735C11.157 10.8708 11.0363 11.1568 10.8193 11.3685C10.6023 11.5802 10.3067 11.7004 9.99764 11.7026V11.7011Z"
        fill="#D3212C"
      />
    </g>
  </svg>
);

export const runningGatewayIcon = (): JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g id="Tab Icons">
      <path
        id="SAWS"
        d="M15.4988 15.832H4.9591C3.98005 15.8187 3.03686 15.4756 2.29363 14.8624C1.5504 14.2493 1.05419 13.4049 0.891321 12.4763C0.728456 11.5476 0.909252 10.5934 1.40225 9.77966C1.89525 8.96595 2.66924 8.34424 3.58956 8.02271V7.98462C3.58956 7.9229 3.58481 7.85891 3.58481 7.79567C3.56973 6.81826 3.89358 5.86388 4.50523 5.08323C5.11688 4.30258 5.98147 3.74016 6.96245 3.48478C7.94344 3.22941 8.98491 3.29563 9.92241 3.673C10.8599 4.05037 11.64 4.71738 12.1395 5.56868C12.5897 5.27378 13.1219 5.11633 13.6666 5.11688C14.4001 5.12272 15.1013 5.40791 15.6166 5.91C16.1319 6.41209 16.4194 7.09015 16.416 7.79567C16.4164 8.12545 16.3544 8.45256 16.233 8.76098C17.1258 8.94625 17.9164 9.44115 18.454 10.1513C18.9916 10.8614 19.2386 11.737 19.148 12.6111C19.0573 13.4852 18.6352 14.2966 17.9623 14.8905C17.2894 15.4845 16.4127 15.8193 15.4995 15.8313L15.4988 15.832ZM8.19482 12.6321C8.45269 12.849 8.75106 13.0168 9.07405 13.1266V13.8199C9.07378 13.8581 9.08705 13.8952 9.11168 13.9251C9.13631 13.955 9.17082 13.976 9.2095 13.9845C9.72944 14.0974 10.269 14.0974 10.7889 13.9845C10.8276 13.976 10.8621 13.955 10.8868 13.9251C10.9114 13.8952 10.9247 13.8581 10.9244 13.8199V13.1266C11.2468 13.0148 11.5451 12.8469 11.8044 12.6314L12.4207 12.978C12.4471 12.9929 12.4772 13.0007 12.5078 13.0009C12.5318 13.0008 12.5555 12.9957 12.5774 12.9862C12.5992 12.9766 12.6187 12.9626 12.6345 12.9453C12.9972 12.5625 13.2677 12.1075 13.4266 11.6127C13.438 11.5758 13.4363 11.5363 13.422 11.5004C13.4077 11.4644 13.3815 11.434 13.3474 11.4139L12.7312 11.0672C12.7944 10.7399 12.7944 10.4041 12.7312 10.0768L13.3474 9.7301C13.3817 9.71046 13.4081 9.68036 13.4224 9.64458C13.4368 9.60881 13.4383 9.56944 13.4266 9.53277C13.2671 9.03822 12.9967 8.58335 12.6345 8.20023C12.6183 8.18299 12.5985 8.1692 12.5764 8.15976C12.5543 8.15031 12.5304 8.14541 12.5062 8.14537C12.4761 8.14547 12.4465 8.15337 12.4207 8.16823L11.8044 8.51413C11.546 8.29754 11.2475 8.12978 10.9244 8.01966V7.33092C10.9247 7.29276 10.9114 7.25564 10.8868 7.22572C10.8621 7.1958 10.8276 7.17485 10.7889 7.16635C10.269 7.05385 9.72948 7.05385 9.2095 7.16635C9.17082 7.17485 9.13631 7.1958 9.11168 7.22572C9.08705 7.25564 9.07378 7.29276 9.07405 7.33092V8.02424C8.75162 8.13601 8.45331 8.30388 8.19403 8.51946L7.57936 8.1728C7.55291 8.15795 7.52286 8.15007 7.49223 8.14995C7.46821 8.15005 7.4445 8.15507 7.42265 8.16465C7.4008 8.17424 7.38132 8.18819 7.36549 8.20556C7.00278 8.5883 6.73232 9.04329 6.5734 9.5381C6.56161 9.57477 6.56301 9.61419 6.57738 9.64999C6.59176 9.6858 6.61826 9.7159 6.65261 9.73543L7.26886 10.0821C7.20637 10.4095 7.20637 10.7451 7.26886 11.0725L6.65261 11.4192C6.61826 11.4387 6.59176 11.4688 6.57738 11.5046C6.56301 11.5404 6.56161 11.5799 6.5734 11.6165C6.73294 12.1111 7.00333 12.5659 7.36549 12.9491C7.38173 12.9663 7.40153 12.9801 7.42362 12.9895C7.44572 12.999 7.46963 13.0039 7.49381 13.0039C7.52394 13.0038 7.55349 12.9959 7.57936 12.9811L8.19561 12.6344L8.19482 12.6321ZM9.99764 11.7011C9.76516 11.704 9.53704 11.6403 9.34229 11.5181C9.14753 11.396 8.99494 11.2209 8.9039 11.0151C8.81286 10.8094 8.78748 10.5822 8.831 10.3625C8.87452 10.1429 8.98497 9.94058 9.1483 9.78144C9.31164 9.62229 9.52048 9.51345 9.74829 9.46876C9.9761 9.42406 10.2126 9.44553 10.4277 9.53043C10.6428 9.61533 10.8267 9.75984 10.9562 9.94557C11.0857 10.1313 11.1549 10.3499 11.1549 10.5735C11.157 10.8708 11.0363 11.1568 10.8193 11.3685C10.6023 11.5802 10.3067 11.7004 9.99764 11.7026V11.7011Z"
        fill="#59a84b"
      />
    </g>
  </svg>
);

export const refrenceDictIcon = (): JSX.Element => (
  <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
    <path
      d="M30 1.6665H10C8.67392 1.6665 7.40215 2.19329 6.46447 3.13097C5.52678 4.06865 5 5.34042 5 6.6665V33.3332C5 34.6592 5.52678 35.931 6.46447 36.8687C7.40215 37.8064 8.67392 38.3332 10 38.3332H30C30.8841 38.3332 31.7319 37.982 32.357 37.3569C32.9821 36.7317 33.3333 35.8839 33.3333 34.9998V31.6665C33.7754 31.6665 34.1993 31.4909 34.5118 31.1783C34.8244 30.8658 35 30.4419 35 29.9998V6.6665C35 5.34042 34.4732 4.06865 33.5355 3.13097C32.5979 2.19329 31.3261 1.6665 30 1.6665ZM30 34.9998H10C9.55797 34.9998 9.13405 34.8242 8.82149 34.5117C8.50893 34.1991 8.33333 33.7752 8.33333 33.3332C8.33642 33.1115 8.3837 32.8926 8.47242 32.6894C8.56113 32.4862 8.6895 32.3028 8.85 32.1498C8.99775 31.994 9.17627 31.8706 9.37423 31.7874C9.5722 31.7042 9.78529 31.663 10 31.6665H30V34.9998Z"
      fill="#428BCA"
    />
  </svg>
);

export const widgetIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "40"}
    height={height || "40"}
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M23.8581 5.85716C23.8581 5.82034 23.8283 5.79049 23.7914 5.79049H8.09905C7.21576 5.79049 6.46567 6.09723 5.85287 6.71003C5.24008 7.32283 4.93333 8.07292 4.93333 8.9562V31.9014C4.93333 32.7847 5.24008 33.5348 5.85287 34.1476C6.46567 34.7604 7.21576 35.0671 8.09905 35.0671H31.0443C31.9275 35.0671 32.6776 34.7604 33.2904 34.1476C33.9032 33.5348 34.21 32.7847 34.21 31.9014V16.209C34.21 16.1722 34.1801 16.1424 34.1433 16.1424H31.5718C31.535 16.1424 31.5052 16.1722 31.5052 16.209V31.9014C31.5052 32.0397 31.4614 32.1485 31.3764 32.2336C31.2914 32.3186 31.1826 32.3623 31.0443 32.3623H8.09905C7.96076 32.3623 7.85193 32.3186 7.7669 32.2336C7.68187 32.1485 7.63814 32.0397 7.63814 31.9014V8.9562C7.63814 8.81791 7.68187 8.70908 7.7669 8.62406C7.85193 8.53903 7.96076 8.49529 8.09905 8.49529H23.7914C23.8283 8.49529 23.8581 8.46544 23.8581 8.42862V5.85716ZM11.56 28.5718C11.56 28.6086 11.5899 28.6385 11.6267 28.6385H14.1977C14.2345 28.6385 14.2644 28.6086 14.2644 28.5718V17.4288C14.2644 17.3919 14.2345 17.3621 14.1977 17.3621H11.6267C11.5899 17.3621 11.56 17.3919 11.56 17.4288V28.5718ZM18.2193 28.5718C18.2193 28.6086 18.2491 28.6385 18.2859 28.6385H20.8574C20.8942 28.6385 20.9241 28.6086 20.9241 28.5718V12.2858C20.9241 12.249 20.8942 12.2192 20.8574 12.2192H18.2859C18.2491 12.2192 18.2193 12.249 18.2193 12.2858V28.5718ZM24.8785 28.5718C24.8785 28.6086 24.9083 28.6385 24.9452 28.6385H27.5166C27.5535 28.6385 27.5833 28.6086 27.5833 28.5718V22.5717C27.5833 22.5349 27.5535 22.505 27.5166 22.505H24.9452C24.9083 22.505 24.8785 22.5349 24.8785 22.5717V28.5718ZM28.9337 14.4287C28.9337 14.4655 28.9636 14.4954 29.0004 14.4954H31.5718C31.6087 14.4954 31.6385 14.4655 31.6385 14.4287V11.0668H35.0005C35.0373 11.0668 35.0671 11.0369 35.0671 11.0001V8.42862C35.0671 8.39181 35.0373 8.36196 35.0005 8.36196H31.6385V5C31.6385 4.96318 31.6087 4.93333 31.5718 4.93333H29.0004C28.9636 4.93333 28.9337 4.96318 28.9337 5V8.36196H25.5717C25.5349 8.36196 25.5051 8.39181 25.5051 8.42862V11.0001C25.5051 11.0369 25.5349 11.0668 25.5717 11.0668H28.9337V14.4287Z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="0.133335"
      strokeLinejoin="round"
    />
  </svg>
);

export const filledWidgetIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "40"}
    height={height || "40"}
    viewBox="0 0 48 47"
    fill="none"
  >
    <path
      d="M10.974 36.6667H14.9733V19.3333H10.974V36.6667ZM21.3327 36.6667H25.3327V11.3333H21.3327V36.6667ZM31.6914 36.6667H35.6914V27.3333H31.6914V36.6667ZM37.9994 14.6667V9.33333H32.666V5.33333H37.9994V0H41.9994V5.33333H47.3327V9.33333H41.9994V14.6667H37.9994ZM5.48668 46.6667C4.13957 46.6667 2.99935 46.2 2.06602 45.2667C1.13268 44.3333 0.666016 43.1931 0.666016 41.846V6.154C0.666016 4.80689 1.13268 3.66667 2.06602 2.73333C2.99935 1.8 4.13957 1.33333 5.48668 1.33333H29.8967V12.6153C29.8967 13.9411 30.3687 15.076 31.3127 16.02C32.2567 16.964 33.3916 17.436 34.7174 17.436H45.9994V41.846C45.9994 43.1931 45.5327 44.3333 44.5994 45.2667C43.666 46.2 42.5258 46.6667 41.1787 46.6667H5.48668Z"
      fill="#428BCA"
    />
  </svg>
);

export const createYourOwnWidgetIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "432"}
    height={height || "190"}
    viewBox="0 0 432 190"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="432" height="190" rx="4" fill="#EFF3F8" />
    <path
      d="M202.974 107.667H206.973V90.3333H202.974V107.667ZM213.333 107.667H217.333V82.3333H213.333V107.667ZM223.691 107.667H227.691V98.3333H223.691V107.667ZM229.999 85.6667V80.3333H224.666V76.3333H229.999V71H233.999V76.3333H239.333V80.3333H233.999V85.6667H229.999ZM197.487 117.667C196.14 117.667 194.999 117.2 194.066 116.267C193.133 115.333 192.666 114.193 192.666 112.846V77.154C192.666 75.8069 193.133 74.6667 194.066 73.7333C194.999 72.8 196.14 72.3333 197.487 72.3333H221.897V83.6153C221.897 84.9411 222.369 86.076 223.313 87.02C224.257 87.964 225.392 88.436 226.717 88.436H237.999V112.846C237.999 114.193 237.533 115.333 236.599 116.267C235.666 117.2 234.526 117.667 233.179 117.667H197.487Z"
      fill="#428BCA"
    />
  </svg>
);

export const pickFromGalleryWidgetIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "432"}
    height={height || "190"}
    viewBox="0 0 432 190"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="432" height="190" rx="4" fill="#EFF3F8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M183.602 114.897C184.782 116.077 186.201 116.667 187.858 116.667H219.14C220.797 116.667 222.215 116.077 223.395 114.897C224.575 113.717 225.165 112.299 225.165 110.641V79.3598C225.165 77.7026 224.575 76.284 223.395 75.104C222.215 73.924 220.797 73.334 219.14 73.334H187.858C186.201 73.334 184.782 73.924 183.602 75.104C182.422 76.284 181.832 77.7026 181.832 79.3598V110.641C181.832 112.299 182.422 113.717 183.602 114.897ZM232.695 90.8048C233.269 91.3798 233.991 91.6673 234.86 91.6673H247.136C248.006 91.6673 248.728 91.3798 249.303 90.8048C249.878 90.2304 250.165 89.5084 250.165 88.639V76.3631C250.165 75.4931 249.878 74.7709 249.303 74.1965C248.728 73.6215 248.006 73.334 247.136 73.334H234.86C233.991 73.334 233.269 73.6215 232.695 74.1965C232.12 74.7709 231.832 75.4931 231.832 76.3631V88.639C231.832 89.5084 232.12 90.2304 232.695 90.8048ZM232.695 115.805C233.269 116.38 233.991 116.667 234.86 116.667H247.136C248.006 116.667 248.728 116.38 249.303 115.805C249.878 115.23 250.165 114.508 250.165 113.638V101.362C250.165 100.493 249.878 99.7709 249.303 99.1965C248.728 98.6215 248.006 98.334 247.136 98.334H234.86C233.991 98.334 233.269 98.6215 232.695 99.1965C232.12 99.7709 231.832 100.493 231.832 101.362V113.638C231.832 114.508 232.12 115.23 232.695 115.805ZM190.133 104.185C190.667 104.729 191.309 105.001 192.059 105.001C192.809 105.001 193.451 104.729 193.985 104.185C194.52 103.641 194.787 102.987 194.787 102.223V101.858C194.787 101.754 194.764 101.644 194.718 101.528L200.923 95.209C201.332 95.2553 201.559 95.2784 201.605 95.2784H201.963C202.065 95.2784 202.173 95.2553 202.287 95.209L205.764 98.7507C205.718 98.8664 205.696 98.9763 205.696 99.0805V99.4451C205.696 100.209 205.963 100.863 206.497 101.407C207.031 101.951 207.673 102.223 208.423 102.223C209.173 102.223 209.815 101.951 210.349 101.407C210.883 100.863 211.15 100.209 211.15 99.4451V99.0805C211.15 98.9763 211.127 98.8664 211.082 98.7507L215.923 93.8201C216.037 93.8664 216.145 93.8895 216.247 93.8895H216.605C217.355 93.8895 217.997 93.6176 218.531 93.0736C219.065 92.5296 219.332 91.8757 219.332 91.1118C219.332 90.3479 219.065 89.6939 218.531 89.15C217.997 88.606 217.355 88.334 216.605 88.334C215.855 88.334 215.213 88.606 214.679 89.15C214.145 89.6939 213.877 90.3479 213.877 91.1118V91.4763C213.877 91.5805 213.9 91.6905 213.946 91.8062L209.105 96.7368C208.991 96.6905 208.883 96.6673 208.781 96.6673H208.065C207.963 96.6673 207.855 96.6905 207.741 96.7368L204.264 93.1951C204.309 92.7784 204.332 92.5469 204.332 92.5007C204.332 91.7368 204.065 91.0828 203.531 90.5388C202.997 89.9949 202.355 89.7229 201.605 89.7229C200.855 89.7229 200.213 89.9949 199.679 90.5388C199.145 91.0828 198.877 91.7368 198.877 92.5007V92.8652C198.877 92.9694 198.9 93.0794 198.946 93.1951L192.741 99.5145C192.627 99.4682 192.52 99.4451 192.417 99.4451H192.059C191.309 99.4451 190.667 99.7171 190.133 100.261C189.599 100.805 189.332 101.459 189.332 102.223C189.332 102.987 189.599 103.641 190.133 104.185Z"
      fill="#428BCA"
    />
  </svg>
);

export const dashboardIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6.66667 11.9971C6.66667 11.2172 6.06971 10.585 5.33333 10.585C4.59695 10.585 4 11.2172 4 11.9971V18.5872C4 19.3671 4.59695 19.9994 5.33333 19.9994C6.06971 19.9994 6.66667 19.3671 6.66667 18.5872V11.9971Z"
      fill="#C9C9C9"
    />
    <path
      d="M15.5553 11.9971C15.5553 11.2172 14.9584 10.585 14.222 10.585C13.4856 10.585 12.8887 11.2172 12.8887 11.9971V18.5872C12.8887 19.3671 13.4856 19.9994 14.222 19.9994C14.9584 19.9994 15.5553 19.3671 15.5553 18.5872V11.9971Z"
      fill="#C9C9C9"
    />
    <path
      d="M11.112 9.1729C11.112 8.39299 10.515 7.76074 9.77865 7.76074C9.04227 7.76074 8.44531 8.39299 8.44531 9.1729V18.5873C8.44531 19.3672 9.04227 19.9995 9.77865 19.9995C10.515 19.9995 11.112 19.3672 11.112 18.5873V9.1729Z"
      fill="#C9C9C9"
    />
    <path
      d="M20.0007 5.40728C20.0007 4.62736 19.4037 3.99512 18.6673 3.99512C17.9309 3.99512 17.334 4.62736 17.334 5.40728V18.5875C17.334 19.3674 17.9309 19.9996 18.6673 19.9996C19.4037 19.9996 20.0007 19.3674 20.0007 18.5875V5.40728Z"
      fill="#C9C9C9"
    />
  </svg>
);

export const barrChartIcon = (width?: string, height?: string): JSX.Element => {
  return (
    <svg
      width={width || "14"}
      height={height || "14"}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M0.333355 3.66663H6.16669L6.16669 0.333294H0.333355V3.66663ZM0.333355 8.66663H13.6667V5.33329H0.333355V8.66663ZM0.333355 13.6666H9.50002V10.3333H0.333355V13.6666Z"
        fill="#949494"
      />
    </svg>
  );
};

export const stackedBarChartIcon = (
  width?: string,
  height?: string
): JSX.Element => {
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
    >
      <g opacity="0.8">
        <path
          d="M3.33335 16.6666H12.5V13.3333H3.33335V16.6666ZM13.3334 16.6666H16.6667V13.3333H13.3334V16.6666ZM3.33335 11.6666H10V8.33329H3.33335V11.6666ZM10.8334 11.6666H14.1667V8.33329H10.8334V11.6666ZM3.33335 6.66663H7.50002V3.33329H3.33335V6.66663ZM8.33335 6.66663H11.6667V3.33329H8.33335V6.66663Z"
          fill="#949494"
        />
      </g>
    </svg>
  );
};

export const donutChartIcon = (
  width?: string,
  height?: string
): JSX.Element => {
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
    >
      <g opacity="0.8">
        <path
          d="M9.1875 18.2917C7.04861 18.0834 5.26389 17.1875 3.83333 15.6042C2.40278 14.0209 1.6875 12.1528 1.6875 10C1.6875 7.84726 2.40278 5.97921 3.83333 4.39587C5.26389 2.81254 7.04861 1.91671 9.1875 1.70837V4.20837C7.74306 4.40282 6.54861 5.04865 5.60417 6.14587C4.65972 7.2431 4.1875 8.52782 4.1875 10C4.1875 11.4723 4.65972 12.757 5.60417 13.8542C6.54861 14.9514 7.74306 15.5973 9.1875 15.7917V18.2917ZM10.8542 18.2917V15.7917C12.1597 15.625 13.2639 15.0834 14.1667 14.1667C15.0694 13.25 15.6181 12.1389 15.8125 10.8334H18.3125C18.1181 12.8195 17.3229 14.5105 15.9271 15.9063C14.5312 17.3021 12.8403 18.0973 10.8542 18.2917ZM15.8125 9.16671C15.6181 7.86115 15.0694 6.75004 14.1667 5.83337C13.2639 4.91671 12.1597 4.37504 10.8542 4.20837V1.70837C12.8403 1.90282 14.5312 2.69796 15.9271 4.09379C17.3229 5.48962 18.1181 7.1806 18.3125 9.16671H15.8125Z"
          fill="#949494"
        />
      </g>
    </svg>
  );
};

export const stackedColumnChartIcon = (
  width?: string,
  height?: string
): JSX.Element => {
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
    >
      <g opacity="0.8">
        <path
          d="M3.33331 16.6667V7.50004H6.66665V16.6667H3.33331ZM3.33331 6.66671V3.33337H6.66665V6.66671H3.33331ZM8.33331 16.6667V10H11.6666V16.6667H8.33331ZM8.33331 9.16671V5.83337H11.6666V9.16671H8.33331ZM13.3333 16.6667V12.5H16.6666V16.6667H13.3333ZM13.3333 11.6667V8.33337H16.6666V11.6667H13.3333Z"
          fill="#949494"
        />
      </g>
    </svg>
  );
};

export const kpiChartIcon = (width?: string, height?: string): JSX.Element => {
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
    >
      <g opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.6689 6.17757L3.57449 5.0951C4.00504 4.84367 4.9894 5.11059 4.9909 5.66274V14.269C4.9909 14.7021 4.4281 14.9183 3.86379 14.9183C3.29948 14.9183 2.73667 14.7021 2.73667 14.269V7.38117L2.31813 7.62484C2.21188 7.69341 2.08642 7.73114 1.95744 7.73331C1.53891 7.73331 1.25038 7.31709 1.25038 6.89452C1.24583 6.75093 1.2822 6.6088 1.35577 6.48277C1.42934 6.35675 1.53742 6.2514 1.6689 6.17757ZM15.1981 5.02747C13.2053 5.02747 11.6612 5.89372 11.6612 8.22064V11.8068C11.6612 14.1309 13.2061 15 15.1981 15C17.1901 15 18.75 14.1337 18.75 11.8068V8.22064C18.75 5.89372 17.1908 5.02747 15.1981 5.02747ZM16.4973 11.8068C16.4973 12.7407 16.0066 13.1597 15.1981 13.1597C14.3895 13.1597 13.9132 12.7371 13.9132 11.8068V8.22064C13.9132 7.28677 14.3895 6.86773 15.1981 6.86773C16.0066 6.86773 16.4973 7.29029 16.4973 8.22064V11.8068ZM8.59618 13.0288C9.42616 13.0288 10.099 12.3982 10.099 11.6202C10.099 10.8423 9.42616 10.2117 8.59618 10.2117C7.76619 10.2117 7.09335 10.8423 7.09335 11.6202C7.09335 12.3982 7.76619 13.0288 8.59618 13.0288Z"
          fill="#949494"
        />
        <path
          d="M3.57449 5.0951L3.69798 5.31249L3.70055 5.31098L3.57449 5.0951ZM1.6689 6.17757L1.79131 6.39555L1.79238 6.39494L1.6689 6.17757ZM4.9909 5.66274H5.2409L5.2409 5.66206L4.9909 5.66274ZM2.73667 7.38117H2.98667V6.94634L2.61089 7.16512L2.73667 7.38117ZM2.31813 7.62484L2.19221 7.40857L2.18257 7.41479L2.31813 7.62484ZM1.95744 7.73331V7.98334L1.96164 7.98327L1.95744 7.73331ZM1.25038 6.89452H1.50051L1.50025 6.8866L1.25038 6.89452ZM1.35577 6.48277L1.13987 6.35674H1.13987L1.35577 6.48277ZM3.451 4.87772L1.54542 5.96019L1.79238 6.39494L3.69797 5.31247L3.451 4.87772ZM5.2409 5.66206C5.2397 5.21949 4.8537 4.95547 4.52568 4.84144C4.34925 4.78011 4.15712 4.74805 3.97444 4.75009C3.79448 4.7521 3.60539 4.78754 3.44842 4.87921L3.70055 5.31098C3.75886 5.27694 3.85428 5.25146 3.98002 5.25006C4.10305 5.24869 4.23783 5.27073 4.3615 5.31372C4.63367 5.40833 4.74061 5.55385 4.7409 5.66342L5.2409 5.66206ZM5.2409 14.269V5.66274H4.7409V14.269H5.2409ZM3.86379 15.1683C4.17277 15.1683 4.49656 15.1099 4.75293 14.9786C5.01002 14.8469 5.2409 14.6152 5.2409 14.269H4.7409C4.7409 14.3558 4.69039 14.4488 4.52499 14.5335C4.35888 14.6186 4.11911 14.6683 3.86379 14.6683V15.1683ZM2.48667 14.269C2.48667 14.6152 2.71756 14.8469 2.97465 14.9786C3.23102 15.1099 3.5548 15.1683 3.86379 15.1683V14.6683C3.60846 14.6683 3.36869 14.6186 3.20258 14.5335C3.03719 14.4488 2.98667 14.3558 2.98667 14.269H2.48667ZM2.48667 7.38117V14.269H2.98667V7.38117H2.48667ZM2.44391 7.8409L2.86245 7.59722L2.61089 7.16512L2.19234 7.40879L2.44391 7.8409ZM1.96164 7.98327C2.13629 7.98034 2.30741 7.9293 2.45369 7.8349L2.18257 7.41479C2.11634 7.45753 2.03656 7.48194 1.95324 7.48334L1.96164 7.98327ZM1.00038 6.89452C1.00038 7.1599 1.09018 7.42489 1.2511 7.62775C1.41386 7.83291 1.65832 7.98331 1.95744 7.98331V7.48331C1.83803 7.48331 1.72896 7.42559 1.64282 7.317C1.55484 7.20611 1.50038 7.05171 1.50038 6.89452H1.00038ZM1.13987 6.35674C1.043 6.52266 0.994439 6.71113 1.00051 6.90245L1.50025 6.8866C1.49722 6.79074 1.5214 6.69493 1.57168 6.60881L1.13987 6.35674ZM1.54649 5.95958C1.37757 6.05444 1.23663 6.19098 1.13987 6.35674L1.57168 6.60881C1.62205 6.52252 1.69728 6.44835 1.79131 6.39555L1.54649 5.95958ZM11.9112 8.22064C11.9112 7.1171 12.2742 6.39756 12.8384 5.94678C13.4125 5.48812 14.2324 5.27747 15.1981 5.27747V4.77747C14.171 4.77747 13.2225 4.99994 12.5263 5.55614C11.8203 6.12021 11.4112 6.99726 11.4112 8.22064H11.9112ZM11.9112 11.8068V8.22064H11.4112V11.8068H11.9112ZM15.1981 14.75C14.233 14.75 13.413 14.5387 12.8387 14.0796C12.2743 13.6284 11.9112 12.9088 11.9112 11.8068H11.4112C11.4112 13.0289 11.8205 13.9058 12.5265 14.4702C13.2227 15.0267 14.1712 15.25 15.1981 15.25V14.75ZM18.5 11.8068C18.5 12.9095 18.1337 13.6291 17.5656 14.0802C16.9874 14.5393 16.1633 14.75 15.1981 14.75V15.25C16.2248 15.25 17.1767 15.0275 17.8765 14.4718C18.5863 13.9081 19 13.031 19 11.8068H18.5ZM18.5 8.22064V11.8068H19V8.22064H18.5ZM15.1981 5.27747C16.1637 5.27747 16.9878 5.48813 17.5658 5.94722C18.1338 6.39836 18.5 7.11793 18.5 8.22064H19C19 6.99643 18.5866 6.11942 17.8768 5.55569C17.1771 4.99993 16.2252 4.77747 15.1981 4.77747V5.27747ZM15.1981 13.4097C15.643 13.4097 16.0409 13.2941 16.3267 13.0111C16.6131 12.7276 16.7473 12.3155 16.7473 11.8068H16.2473C16.2473 12.2319 16.1361 12.4963 15.975 12.6558C15.8133 12.8158 15.5616 12.9097 15.1981 12.9097V13.4097ZM13.6632 11.8068C13.6632 12.3121 13.7928 12.7238 14.0749 13.0082C14.3573 13.2928 14.7525 13.4097 15.1981 13.4097V12.9097C14.8351 12.9097 14.5879 12.8153 14.4299 12.6561C14.2717 12.4966 14.1632 12.2319 14.1632 11.8068H13.6632ZM13.6632 8.22064V11.8068H14.1632V8.22064H13.6632ZM15.1981 6.61773C14.7531 6.61773 14.3577 6.73343 14.0751 7.01774C13.7927 7.30185 13.6632 7.71385 13.6632 8.22064H14.1632C14.1632 7.79356 14.2718 7.52911 14.4297 7.37022C14.5875 7.21155 14.8346 7.11773 15.1981 7.11773V6.61773ZM16.7473 8.22064C16.7473 7.71343 16.613 7.30157 16.3269 7.01781C16.0413 6.73451 15.6435 6.61773 15.1981 6.61773V7.11773C15.5611 7.11773 15.8129 7.21223 15.9748 7.37279C16.1362 7.5329 16.2473 7.7975 16.2473 8.22064H16.7473ZM16.7473 11.8068V8.22064H16.2473V11.8068H16.7473ZM9.849 11.6202C9.849 12.2451 9.30359 12.7788 8.59618 12.7788V13.2788C9.54873 13.2788 10.349 12.5512 10.349 11.6202H9.849ZM8.59618 10.4617C9.30359 10.4617 9.849 10.9954 9.849 11.6202H10.349C10.349 10.6892 9.54873 9.96169 8.59618 9.96169V10.4617ZM7.34335 11.6202C7.34335 10.9954 7.88876 10.4617 8.59618 10.4617V9.96169C7.64362 9.96169 6.84335 10.6892 6.84335 11.6202H7.34335ZM8.59618 12.7788C7.88876 12.7788 7.34335 12.2451 7.34335 11.6202H6.84335C6.84335 12.5512 7.64362 13.2788 8.59618 13.2788V12.7788Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const boldPlusIcon = (width?: string, height?: string): JSX.Element => {
  return (
    <svg
      width={width || "36"}
      height={height || "36"}
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M18.0013 35.3327C27.5742 35.3327 35.3346 27.5723 35.3346 17.9993C35.3346 8.42641 27.5742 0.666016 18.0013 0.666016C8.42837 0.666016 0.667969 8.42641 0.667969 17.9993C0.667969 27.5723 8.42837 35.3327 18.0013 35.3327Z"
        fill="#428BCA"
      />
      <path
        d="M15.4007 26.6663V20.5997H9.33398V15.3997H15.4007V9.33301H20.6007V15.3997H26.6673V20.5997H20.6007V26.6663H15.4007Z"
        fill="white"
      />
    </svg>
  );
};

export const fillSizeIcon = (width?: string, height?: string): JSX.Element => {
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
    >
      <g id="Group">
        <path
          id="Vector"
          d="M19.7735 10.38C19.7791 10.3731 19.784 10.3658 19.7893 10.3588C19.7957 10.3502 19.8024 10.3419 19.8083 10.333C19.814 10.3244 19.819 10.3156 19.8242 10.3069C19.829 10.2989 19.834 10.291 19.8384 10.2828C19.8432 10.2738 19.8472 10.2647 19.8515 10.2556C19.8556 10.247 19.8599 10.2385 19.8635 10.2297C19.8672 10.2208 19.8701 10.2118 19.8734 10.2029C19.8767 10.1934 19.8804 10.1841 19.8833 10.1744C19.886 10.1654 19.888 10.1563 19.8903 10.1472C19.8928 10.1374 19.8955 10.1276 19.8975 10.1176C19.8996 10.1071 19.9008 10.0966 19.9024 10.086C19.9036 10.0772 19.9053 10.0686 19.9062 10.0597C19.9081 10.0402 19.9091 10.0207 19.9091 10.0011C19.9091 10.0009 19.9091 10.0008 19.9091 10.0007C19.9091 10.0005 19.9091 10.0004 19.9091 10.0002C19.9091 9.98065 19.9081 9.96112 19.9062 9.94162C19.9053 9.93269 19.9036 9.92404 19.9024 9.91523C19.9008 9.90472 19.8996 9.89417 19.8975 9.88371C19.8955 9.87365 19.8928 9.86391 19.8903 9.85404C19.888 9.84497 19.886 9.83588 19.8833 9.82692C19.8804 9.81724 19.8768 9.80791 19.8734 9.79843C19.8701 9.78947 19.8672 9.78044 19.8636 9.77161C19.8599 9.76278 19.8556 9.75429 19.8515 9.74569C19.8472 9.7366 19.8432 9.72746 19.8384 9.71857C19.834 9.7103 19.829 9.70242 19.8242 9.69441C19.819 9.68568 19.814 9.67685 19.8083 9.66836C19.8024 9.65945 19.7958 9.65106 19.7894 9.64251C19.7841 9.63547 19.7792 9.62821 19.7735 9.62133C19.761 9.60607 19.7478 9.59141 19.7338 9.57747L16.7715 6.61513C16.5378 6.38141 16.1589 6.38141 15.9251 6.61513C15.6914 6.84885 15.6914 7.22778 15.9251 7.4615L17.8658 9.40215L11.6933 9.40217C11.3627 9.40217 11.0948 9.67012 11.0948 10.0006C11.0948 10.3312 11.3627 10.5991 11.6933 10.5991L17.8658 10.5991L15.9251 12.5398C15.6914 12.7735 15.6914 13.1524 15.9251 13.3861C16.1588 13.6199 16.5378 13.6199 16.7715 13.3862L19.7338 10.4239C19.7478 10.4099 19.761 10.3952 19.7735 10.38Z"
          fill="#4F4F4F"
          stroke="#4F4F4F"
          strokeWidth="0.5"
        />
        <path
          id="Vector_2"
          d="M8.30672 9.40121L2.13421 9.40121L4.07486 7.46056C4.30858 7.22684 4.30858 6.84792 4.07486 6.6142C3.84112 6.38046 3.46219 6.38046 3.22848 6.61418L0.266162 9.57649C0.252216 9.59044 0.239025 9.60509 0.226507 9.62035C0.220874 9.62721 0.215974 9.63445 0.210677 9.64154C0.20427 9.65009 0.197624 9.65848 0.191693 9.66738C0.186 9.67589 0.18108 9.6847 0.175883 9.69343C0.171063 9.70146 0.166024 9.70932 0.161601 9.71759C0.15684 9.72648 0.152793 9.73564 0.148528 9.74471C0.144462 9.75334 0.140157 9.76181 0.136487 9.77063C0.132817 9.77946 0.129901 9.78849 0.126687 9.79745C0.123295 9.80692 0.119665 9.81626 0.11673 9.82594C0.114032 9.83491 0.112048 9.84399 0.109767 9.85306C0.107287 9.86292 0.10451 9.87268 0.102506 9.88273C0.100423 9.89319 0.0992134 9.90372 0.0976861 9.91425C0.0964167 9.92306 0.0947499 9.93171 0.093877 9.94064C0.0919531 9.96014 0.0909213 9.9797 0.0909215 9.99926C0.0909213 9.99941 0.0908821 9.99953 0.0909017 9.99967C0.0909018 9.99983 0.0909218 9.99997 0.090922 10.0001C0.0909417 10.0197 0.0919732 10.0392 0.0938776 10.0587C0.0947504 10.0676 0.0964166 10.0763 0.0976863 10.0851C0.0992138 10.0956 0.100424 10.1062 0.102507 10.1166C0.10449 10.1266 0.107247 10.1364 0.109747 10.1463C0.112028 10.1553 0.114012 10.1644 0.11673 10.1734C0.119666 10.1831 0.123295 10.1924 0.126688 10.2019C0.129901 10.2109 0.132857 10.2199 0.136507 10.2287C0.140177 10.2375 0.144462 10.246 0.148529 10.2546C0.152813 10.2637 0.15686 10.2728 0.161621 10.2818C0.166044 10.29 0.171083 10.2979 0.175883 10.3059C0.181081 10.3146 0.18602 10.3235 0.191714 10.332C0.197684 10.3409 0.20431 10.3493 0.210718 10.3578C0.216014 10.3649 0.220913 10.3721 0.226547 10.379C0.239064 10.3942 0.252256 10.4089 0.266182 10.4228L0.266202 10.4229L3.22852 13.3852C3.46224 13.6189 3.84116 13.6189 4.07488 13.3852C4.3086 13.1515 4.3086 12.7725 4.07488 12.5388L2.13423 10.5982L8.30678 10.5982C8.63731 10.5982 8.90526 10.3302 8.90526 9.99967C8.90526 9.66915 8.63727 9.40123 8.30672 9.40121Z"
          fill="#4F4F4F"
          stroke="#4F4F4F"
          strokeWidth="0.5"
        />
      </g>
    </svg>
  );
};

export const halfSizeIcon = (width?: string, height?: string): JSX.Element => {
  return (
    <svg
      width={width || "18"}
      height={height || "18"}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M10.0253 9.31612C10.0206 9.31038 10.0165 9.30435 10.0122 9.29846C10.0068 9.29134 10.0013 9.28436 9.99631 9.27694C9.99157 9.26985 9.98745 9.26249 9.98312 9.25522C9.97912 9.24854 9.97492 9.24199 9.97124 9.2351C9.96725 9.22768 9.9639 9.22002 9.96033 9.21245C9.95696 9.20528 9.95337 9.19822 9.95031 9.19086C9.94725 9.1835 9.94482 9.17598 9.94213 9.16853C9.9393 9.16064 9.93627 9.15286 9.93383 9.14479C9.93158 9.13732 9.92991 9.12973 9.92801 9.12218C9.92594 9.11396 9.92365 9.10584 9.92198 9.09746C9.92024 9.08875 9.91923 9.07994 9.91796 9.07116C9.91692 9.06384 9.91553 9.05663 9.91479 9.04921C9.9132 9.03298 9.91232 9.01669 9.91232 9.00039C9.91232 9.00026 9.91231 9.00015 9.91231 9.00001C9.91231 8.99988 9.91234 8.99978 9.91232 8.99967C9.91234 8.98335 9.91318 8.96707 9.91479 8.95082C9.91551 8.94338 9.9169 8.93617 9.91796 8.92883C9.91922 8.92007 9.92024 8.91128 9.92198 8.90256C9.92365 8.89418 9.92594 8.88607 9.92803 8.87783C9.92993 8.87028 9.93158 8.86271 9.93383 8.85524C9.93628 8.84717 9.93928 8.8394 9.94213 8.8315C9.94481 8.82403 9.94727 8.8165 9.95029 8.80915C9.95335 8.80179 9.95692 8.79472 9.96033 8.78754C9.9639 8.77997 9.96725 8.77235 9.97122 8.76494C9.97491 8.75805 9.97912 8.75149 9.98312 8.74481C9.98745 8.73754 9.99157 8.73018 9.9963 8.72311C10.0013 8.71568 10.0068 8.70869 10.0121 8.70157C10.0165 8.6957 10.0206 8.68965 10.0253 8.68391C10.0358 8.6712 10.0468 8.65898 10.0584 8.64736L12.527 6.17875C12.7218 5.98398 13.0375 5.98398 13.2323 6.17875C13.4271 6.37351 13.4271 6.68929 13.2323 6.88405L11.6151 8.50126L16.7589 8.50128C17.0343 8.50128 17.2576 8.72457 17.2576 9.00001C17.2576 9.27545 17.0343 9.49875 16.7589 9.49875L11.6151 9.49875L13.2323 11.116C13.4271 11.3107 13.4271 11.6265 13.2323 11.8213C13.0376 12.016 12.7218 12.016 12.527 11.8213L10.0584 9.3527C10.0468 9.34106 10.0358 9.32883 10.0253 9.31612Z"
        fill="#4F4F4F"
        stroke="#4F4F4F"
        strokeWidth="0.416667"
      />
      <path
        d="M1.24114 8.5013L6.3849 8.50129L4.76769 6.88409C4.57293 6.68932 4.57293 6.37355 4.76769 6.17878C4.96248 5.984 5.27825 5.984 5.47302 6.17876L7.94161 8.64736C7.95323 8.65898 7.96422 8.6712 7.97466 8.68391C7.97935 8.68963 7.98343 8.69566 7.98785 8.70156C7.99319 8.70869 7.99872 8.71568 8.00367 8.7231C8.00841 8.7302 8.01251 8.73754 8.01684 8.74481C8.02086 8.7515 8.02506 8.75805 8.02874 8.76494C8.03271 8.77235 8.03608 8.77999 8.03964 8.78754C8.04303 8.79473 8.04661 8.80179 8.04967 8.80915C8.05273 8.8165 8.05516 8.82402 8.05784 8.8315C8.06067 8.83938 8.06369 8.84717 8.06614 8.85523C8.06838 8.86271 8.07004 8.87028 8.07194 8.87783C8.07401 8.88605 8.07632 8.89418 8.07799 8.90256C8.07973 8.91127 8.08073 8.92005 8.08201 8.92883C8.08306 8.93617 8.08445 8.94338 8.08518 8.95082C8.08678 8.96707 8.08764 8.98337 8.08764 8.99966C8.08764 8.9998 8.08768 8.9999 8.08766 9.00001C8.08766 9.00014 8.08764 9.00026 8.08764 9.00039C8.08763 9.01667 8.08677 9.03297 8.08518 9.04921C8.08445 9.05665 8.08306 9.06385 8.08201 9.07116C8.08073 9.07994 8.07973 9.08875 8.07799 9.09746C8.07634 9.10583 8.07404 9.11394 8.07196 9.12217C8.07005 9.12973 8.0684 9.1373 8.06614 9.14479C8.06369 9.15286 8.06067 9.16064 8.05784 9.16853C8.05516 9.176 8.0527 9.18352 8.04966 9.19086C8.0466 9.19822 8.04303 9.20526 8.03964 9.21245C8.03607 9.22002 8.03269 9.22766 8.02873 9.2351C8.02504 9.24199 8.02084 9.24854 8.01684 9.25521C8.01251 9.26249 8.00839 9.26984 8.00365 9.27694C7.99867 9.28436 7.99315 9.29133 7.98781 9.29846C7.9834 9.30433 7.97932 9.31039 7.97462 9.31611C7.96419 9.32883 7.9532 9.34104 7.94159 9.35265L7.94158 9.35266L5.47298 11.8213C5.27821 12.016 4.96244 12.016 4.76768 11.8213C4.57291 11.6265 4.57291 11.3107 4.76768 11.116L6.38489 9.49875L1.24109 9.49875C0.965656 9.49875 0.742358 9.27545 0.742358 9.00001C0.742358 8.72458 0.96569 8.50131 1.24114 8.5013Z"
        fill="#4F4F4F"
        stroke="#4F4F4F"
        strokeWidth="0.416667"
      />
    </svg>
  );
};

export const addToHomeIcon = (width?: string, height?: string): JSX.Element => {
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          d="M3.33268 16.6666V8.85413L1.83268 9.99996L0.853516 8.68746L9.99935 1.66663L19.166 8.66663L18.166 9.99996L9.99935 3.74996L4.99935 7.58329V15H7.49935V16.6666H3.33268ZM12.4368 18.3333L8.91602 14.7916L10.0827 13.6041L12.4368 15.9583L17.166 11.25L18.3327 12.4375L12.4368 18.3333Z"
          fill="#4F4F4F"
        />
      </g>
    </svg>
  );
};

export const dragIcon = (width?: string, height?: string): JSX.Element => {
  return (
    <svg
      width={width || "10"}
      height={height || "14"}
      viewBox="0 0 10 14"
      fill="none"
    >
      <path
        d="M2.50065 13.6661C2.04232 13.6661 1.64996 13.5029 1.32357 13.1765C0.997179 12.8501 0.833984 12.4578 0.833984 11.9994C0.833984 11.5411 0.997179 11.1487 1.32357 10.8223C1.64996 10.496 2.04232 10.3328 2.50065 10.3328C2.95898 10.3328 3.35135 10.496 3.67773 10.8223C4.00412 11.1487 4.16732 11.5411 4.16732 11.9994C4.16732 12.4578 4.00412 12.8501 3.67773 13.1765C3.35135 13.5029 2.95898 13.6661 2.50065 13.6661ZM7.50065 13.6661C7.04232 13.6661 6.64996 13.5029 6.32357 13.1765C5.99718 12.8501 5.83398 12.4578 5.83398 11.9994C5.83398 11.5411 5.99718 11.1487 6.32357 10.8223C6.64996 10.496 7.04232 10.3328 7.50065 10.3328C7.95898 10.3328 8.35135 10.496 8.67773 10.8223C9.00412 11.1487 9.16732 11.5411 9.16732 11.9994C9.16732 12.4578 9.00412 12.8501 8.67773 13.1765C8.35135 13.5029 7.95898 13.6661 7.50065 13.6661ZM2.50065 8.6661C2.04232 8.6661 1.64996 8.5029 1.32357 8.17651C0.997179 7.85012 0.833984 7.45776 0.833984 6.99943C0.833984 6.5411 0.997179 6.14874 1.32357 5.82235C1.64996 5.49596 2.04232 5.33276 2.50065 5.33276C2.95898 5.33276 3.35135 5.49596 3.67773 5.82235C4.00412 6.14874 4.16732 6.5411 4.16732 6.99943C4.16732 7.45776 4.00412 7.85012 3.67773 8.17651C3.35135 8.5029 2.95898 8.6661 2.50065 8.6661ZM7.50065 8.6661C7.04232 8.6661 6.64996 8.5029 6.32357 8.17651C5.99718 7.85012 5.83398 7.45776 5.83398 6.99943C5.83398 6.5411 5.99718 6.14874 6.32357 5.82235C6.64996 5.49596 7.04232 5.33276 7.50065 5.33276C7.95898 5.33276 8.35135 5.49596 8.67773 5.82235C9.00412 6.14874 9.16732 6.5411 9.16732 6.99943C9.16732 7.45776 9.00412 7.85012 8.67773 8.17651C8.35135 8.5029 7.95898 8.6661 7.50065 8.6661ZM2.50065 3.6661C2.04232 3.6661 1.64996 3.5029 1.32357 3.17651C0.997179 2.85012 0.833984 2.45776 0.833984 1.99943C0.833984 1.5411 0.997179 1.14874 1.32357 0.822347C1.64996 0.495958 2.04232 0.332764 2.50065 0.332764C2.95898 0.332764 3.35135 0.495958 3.67773 0.822347C4.00412 1.14874 4.16732 1.5411 4.16732 1.99943C4.16732 2.45776 4.00412 2.85012 3.67773 3.17651C3.35135 3.5029 2.95898 3.6661 2.50065 3.6661ZM7.50065 3.6661C7.04232 3.6661 6.64996 3.5029 6.32357 3.17651C5.99718 2.85012 5.83398 2.45776 5.83398 1.99943C5.83398 1.5411 5.99718 1.14874 6.32357 0.822347C6.64996 0.495958 7.04232 0.332764 7.50065 0.332764C7.95898 0.332764 8.35135 0.495958 8.67773 0.822347C9.00412 1.14874 9.16732 1.5411 9.16732 1.99943C9.16732 2.45776 9.00412 2.85012 8.67773 3.17651C8.35135 3.5029 7.95898 3.6661 7.50065 3.6661Z"
        fill="#4F4F4F"
      />
    </svg>
  );
};

export const removeFromHomeIcon = (
  width?: string,
  height?: string
): JSX.Element => {
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="in_home_mode_24dp_FILL0_wght400_GRAD0_opsz24" opacity="0.8">
        <path
          id="Vector"
          d="M3.33268 16.667V8.85449L1.83268 10.0003L0.853516 8.68783L9.99935 1.66699L19.166 8.66699L18.166 10.0003L9.99935 3.75033L4.99935 7.58366V15.0003H7.49935V16.667H3.33268Z"
          fill="#4F4F4F"
        />
        <path
          id="Vector_2"
          d="M10.596 18.4044L10.6667 18.4751L10.7374 18.4044L13.3333 15.8084L15.9293 18.4044L16 18.4751L16.0707 18.4044L16.7374 17.7377L16.8081 17.667L16.7374 17.5963L14.1414 15.0003L16.7374 12.4044L16.8081 12.3337L16.7374 12.2629L16.0707 11.5963L16 11.5256L15.9293 11.5963L13.3333 14.1922L10.7374 11.5963L10.6667 11.5256L10.596 11.5963L9.92929 12.2629L9.85858 12.3337L9.92929 12.4044L12.5252 15.0003L9.92929 17.5963L9.85858 17.667L9.92929 17.7377L10.596 18.4044Z"
          fill="#4F4F4F"
          stroke="#4F4F4F"
          strokeWidth="0.2"
        />
      </g>
    </svg>
  );
};

export const thinRedirectIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "13"}
    height={height || "14"}
    viewBox="0 0 13 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.136719 11.8774L1.62037 13.361L10.6432 4.33818V9.25452H12.7575V0.740234H4.24323V2.85452H9.15958L0.136719 11.8774ZM10.9 3.71775V3.71744L1.62022 12.9972L1.62037 12.9974L10.9 3.71775ZM12.5004 8.99738H12.5V0.997437H4.50037V0.997377H12.5004V8.99738Z"
      fill="#428BCA"
    />
  </svg>
);

export const grayGearWithStarIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "34"}
    height={height || "33"}
    viewBox="0 0 34 33"
    fill="none"
  >
    <path
      d="M23.6641 21.3662L25.6664 22.3816C25.9578 22.5528 26.1804 22.8234 26.2946 23.1455C26.4088 23.4676 26.4074 23.8205 26.2905 24.1416C25.6696 25.6025 24.8129 26.9475 23.756 28.1209C23.5406 28.3809 23.2422 28.5557 22.913 28.6146C22.5837 28.6735 22.2447 28.6129 21.9549 28.4433L20.2251 27.4279C19.2637 28.2671 18.1571 28.9169 16.962 29.3442V31.3766C16.9622 31.7164 16.8451 32.0455 16.6312 32.3065C16.4172 32.5675 16.12 32.7438 15.7914 32.8046C14.2985 33.0646 12.7729 33.0646 11.28 32.8046C10.9482 32.7475 10.6469 32.5728 10.4295 32.3115C10.2121 32.0502 10.0925 31.719 10.092 31.3766V29.341C8.89812 28.9097 7.79251 28.2584 6.83041 27.4198L5.10063 28.4304C4.8109 28.6 4.47181 28.6606 4.1426 28.6017C3.8134 28.5428 3.515 28.3681 3.29956 28.108C2.25292 26.9362 1.40547 25.5952 0.792007 24.14C0.676738 23.8187 0.676086 23.4664 0.790167 23.1447C0.904247 22.823 1.1258 22.5523 1.41612 22.38L3.3946 21.3646C3.16277 20.0974 3.16277 18.7975 3.3946 17.5303L1.41612 16.5085C1.12607 16.3375 0.904518 16.068 0.790379 15.7473C0.676239 15.4266 0.676816 15.0753 0.792007 14.7549C1.40394 13.2952 2.25208 11.9501 3.30114 10.7756C3.51659 10.5156 3.81498 10.3408 4.14419 10.2819C4.4734 10.223 4.81249 10.2837 5.10221 10.4533L6.83199 11.4687C7.79346 10.6295 8.90001 9.97962 10.0951 9.55233V7.51673C10.0943 7.17841 10.2105 6.85058 10.4234 6.59067C10.6362 6.33077 10.9322 6.15537 11.2594 6.0952C12.7547 5.83806 14.2818 5.83806 15.7771 6.0952C16.1089 6.15226 16.4102 6.32692 16.6277 6.58826C16.8451 6.8496 16.9646 7.18077 16.9652 7.52318V9.54749C18.1592 9.97716 19.2654 10.6268 20.2283 11.4638L21.9581 10.4484C22.2478 10.2788 22.5869 10.2182 22.9161 10.2771C23.2453 10.336 23.5437 10.5107 23.7592 10.7708C24.8062 11.9455 25.6522 13.2906 26.262 14.7501C26.3809 15.0678 26.3864 15.4178 26.2776 15.7392C26.1687 16.0606 25.9524 16.3329 25.6664 16.5085L23.6641 17.5239C23.896 18.7932 23.896 20.0968 23.6641 21.3662ZM16.6737 22.6427C17.4662 21.7867 17.8998 20.6503 17.8827 19.4745C17.8655 18.2986 17.3988 17.1759 16.5817 16.3442C15.7645 15.5126 14.6611 15.0375 13.5055 15.0197C12.3498 15.002 11.2328 15.4429 10.3914 16.249C9.60436 17.106 9.17537 18.2406 9.19493 19.4133C9.21448 20.586 9.68104 21.7051 10.4962 22.5345C11.3113 23.3638 12.4112 23.8385 13.5637 23.8584C14.7163 23.8783 15.8314 23.4434 16.6737 22.6427Z"
      fill="#8E8E8E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.1669 1C23.809 1 24.3657 1.44576 24.508 2.07386L25.269 5.43129C25.621 6.98423 26.8297 8.19683 28.3776 8.54993L31.7243 9.3134C32.3504 9.45621 32.7947 10.0147 32.7947 10.6589C32.7947 11.3031 32.3504 11.8616 31.7243 12.0044L28.3776 12.7678C26.8297 13.1209 25.621 14.3335 25.269 15.8865L24.508 19.2439C24.3657 19.872 23.809 20.3178 23.1669 20.3178C22.5247 20.3178 21.9681 19.872 21.8257 19.2439L21.0647 15.8865C20.7127 14.3335 19.504 13.1209 17.9561 12.7678L14.6095 12.0044C13.9834 11.8616 13.5391 11.3031 13.5391 10.6589C13.5391 10.0147 13.9834 9.45621 14.6095 9.3134L17.9561 8.54993C19.504 8.19683 20.7127 6.98423 21.0647 5.43129L21.8257 2.07386C21.9681 1.44576 22.5247 1 23.1669 1Z"
      fill="#8E8E8E"
      stroke="white"
      strokeWidth="2"
    />
  </svg>
);

export const solidGoToIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "10"}
    height={height || "10"}
    viewBox="0 0 10 10"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.80643 1.19195C9.28501 1.67053 9.28501 2.44647 8.80643 2.92505L2.92407 8.8074C2.44549 9.28599 1.66955 9.28599 1.19097 8.8074C0.712385 8.32882 0.712385 7.55288 1.19097 7.0743L7.07332 1.19195C7.55191 0.713362 8.32784 0.713362 8.80643 1.19195Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.832031 2.0585C0.832031 1.38168 1.3807 0.833008 2.05752 0.833008H7.93987C8.61669 0.833008 9.16537 1.38168 9.16537 2.0585V7.94085C9.16537 8.61767 8.61669 9.16634 7.93987 9.16634C7.26305 9.16634 6.71438 8.61767 6.71438 7.94085V3.28399H2.05752C1.3807 3.28399 0.832031 2.73532 0.832031 2.0585Z"
      fill="#428BCA"
    />
  </svg>
);

export const solidGoToIconInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "26"}
    height={height || "26"}
    viewBox="0 0 26 26"
    fill="none"
  >
    <rect
      x="1.13281"
      y="1.13281"
      width="23.7344"
      height="23.7344"
      rx="11.8672"
      fill="white"
    />
    <rect
      x="1.13281"
      y="1.13281"
      width="23.7344"
      height="23.7344"
      rx="11.8672"
      stroke="#428BCA"
      strokeWidth="0.765625"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.937 9.27036C17.2841 9.63085 17.2841 10.2153 16.937 10.5758L10.5174 17.2423C10.1703 17.6027 9.60748 17.6027 9.26035 17.2423C8.91322 16.8818 8.91322 16.2973 9.26035 15.9368L15.6799 9.27036C16.027 8.90988 16.5899 8.90988 16.937 9.27036Z"
      fill="#428BCA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 9.92308C9 9.41328 9.39797 9 9.88889 9H16.3084C16.7994 9 17.1973 9.41328 17.1973 9.92308V16.5895C17.1973 17.0993 16.7994 17.5126 16.3084 17.5126C15.8175 17.5126 15.4196 17.0993 15.4196 16.5895V10.8462H9.88889C9.39797 10.8462 9 10.4329 9 9.92308Z"
      fill="#428BCA"
    />
  </svg>
);

export const doubleArrowLeftInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "28"}
    height={height || "28"}
    viewBox="0 0 28 28"
    fill="none"
  >
    <rect
      x="2.13281"
      y="2.13281"
      width="23.7344"
      height="23.7344"
      rx="11.8672"
      fill="white"
    />
    <rect
      x="2.13281"
      y="2.13281"
      width="23.7344"
      height="23.7344"
      rx="11.8672"
      stroke="#428BCA"
      strokeWidth="0.765625"
    />
    <path
      d="M14.3058 9.7785L9.12784 14.9565L8.0925 13.9212L13.2705 8.74316L14.3058 9.7785Z"
      fill="#428BCA"
    />
    <path
      d="M14.3062 18.1289L9.12815 12.9509L8.09281 13.9862L13.2708 19.1642L14.3062 18.1289Z"
      fill="#428BCA"
    />
    <path
      d="M18.593 9.7785L13.415 14.9565L12.3796 13.9212L17.5576 8.74316L18.593 9.7785Z"
      fill="#428BCA"
    />
    <path
      d="M18.5933 18.1289L13.4153 12.9509L12.3799 13.9862L17.5579 19.1642L18.5933 18.1289Z"
      fill="#428BCA"
    />
  </svg>
);

export const doubleArrowRightInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "28"}
    height={height || "28"}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.13281"
      y="2.13281"
      width="23.7344"
      height="23.7344"
      rx="11.8672"
      fill="white"
    />
    <rect
      x="2.13281"
      y="2.13281"
      width="23.7344"
      height="23.7344"
      rx="11.8672"
      stroke="#428BCA"
      strokeWidth="0.765625"
    />
    <path
      d="M13.9114 9.7785L19.0894 14.9565L20.1248 13.9212L14.9468 8.74316L13.9114 9.7785Z"
      fill="#428BCA"
    />
    <path
      d="M13.9111 18.1289L19.0891 12.9509L20.1245 13.9862L14.9465 19.1642L13.9111 18.1289Z"
      fill="#428BCA"
    />
    <path
      d="M9.62384 9.7785L14.8018 14.9565L15.8372 13.9212L10.6592 8.74316L9.62384 9.7785Z"
      fill="#428BCA"
    />
    <path
      d="M9.62402 18.1289L14.802 12.9509L15.8374 13.9862L10.6594 19.1642L9.62402 18.1289Z"
      fill="#428BCA"
    />
  </svg>
);

export const singleArrowLeftInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "32"}
    height={height || "32"}
    viewBox="0 0 32 32"
    fill="none"
  >
    <rect
      x="2.4375"
      y="2.4375"
      width="27.125"
      height="27.125"
      rx="13.5625"
      fill="white"
    />
    <rect
      x="2.4375"
      y="2.4375"
      width="27.125"
      height="27.125"
      rx="13.5625"
      stroke="#428BCA"
      strokeWidth="0.875"
    />
    <g clipPath="url(#clip0_9378_44297)">
      <path
        d="M18.6224 10.5248L11.8171 17.3301L10.4564 15.9694L17.2617 9.16406L18.6224 10.5248Z"
        fill="#428BCA"
      />
      <path
        d="M18.625 21.5L11.8197 14.6947L10.4589 16.0554L17.2643 22.8607L18.625 21.5Z"
        fill="#428BCA"
      />
    </g>
    <defs>
      <clipPath id="clip0_9378_44297">
        <rect
          width="8.16667"
          height="14"
          fill="white"
          transform="matrix(-1 0 0 1 18.625 9)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const singleArrowRightInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "32"}
    height={height || "32"}
    viewBox="0 0 32 32"
    fill="none"
  >
    <rect
      x="2.4375"
      y="2.4375"
      width="27.125"
      height="27.125"
      rx="13.5625"
      fill="white"
    />
    <rect
      x="2.4375"
      y="2.4375"
      width="27.125"
      height="27.125"
      rx="13.5625"
      stroke="#428BCA"
      strokeWidth="0.875"
    />
    <g clipPath="url(#clip0_9378_44306)">
      <path
        d="M12.5026 10.5248L19.3079 17.3301L20.6686 15.9694L13.8633 9.16406L12.5026 10.5248Z"
        fill="#428BCA"
      />
      <path
        d="M12.5 21.5L19.3053 14.6947L20.6661 16.0554L13.8607 22.8607L12.5 21.5Z"
        fill="#428BCA"
      />
    </g>
    <defs>
      <clipPath id="clip0_9378_44306">
        <rect
          width="8.16667"
          height="14"
          fill="white"
          transform="translate(12.5 9)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const minusInCircle = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "32"}
    height={height || "32"}
    viewBox="0 0 32 32"
    fill="none"
  >
    <rect
      x="2.4375"
      y="2.4375"
      width="27.125"
      height="27.125"
      rx="13.5625"
      fill="white"
    />
    <rect
      x="2.4375"
      y="2.4375"
      width="27.125"
      height="27.125"
      rx="13.5625"
      stroke="#428BCA"
      strokeWidth="0.875"
    />
    <path d="M9.43945 16.875V14.6875H22.5645V16.875H9.43945Z" fill="#428BCA" />
  </svg>
);

export const baseNodeInCircle = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "26"}
    height={height || "26"}
    viewBox="0 0 26 26"
    fill="none"
  >
    <rect
      x="1.13281"
      y="1.13281"
      width="23.7344"
      height="23.7344"
      rx="11.8672"
      fill="white"
    />
    <rect
      x="1.13281"
      y="1.13281"
      width="23.7344"
      height="23.7344"
      rx="11.8672"
      stroke="#428BCA"
      strokeWidth="0.765625"
    />
    <path
      d="M6.02042 16.262C6.03302 15.6414 6.33999 15.0632 6.84819 14.7024C7.35639 14.3416 8.00633 14.2405 8.60107 14.4298C9.19596 14.6192 9.66593 15.0766 9.86855 15.6638C10.3915 15.6363 10.8838 15.4104 11.2438 15.0328C11.6039 14.6551 11.8042 14.1544 11.8035 13.6341L11.8035 12.8863C11.8029 12.1153 12.0857 11.3708 12.5989 10.7925L9.86855 10.7925C9.6817 11.3976 9.21308 11.8761 8.60948 12.0784C8.00587 12.2805 7.34127 12.1814 6.82404 11.8121C6.30666 11.4428 6 10.8486 6 10.2156C6 9.5827 6.30667 8.98852 6.82404 8.61921C7.34127 8.24992 8.00587 8.15082 8.60948 8.35289C9.21308 8.55513 9.68171 9.03367 9.86855 9.63872L16.5823 9.63872C16.7692 9.03367 17.2378 8.55514 17.8414 8.35289C18.445 8.15081 19.1096 8.24991 19.6269 8.61921C20.1442 8.98851 20.4509 9.5827 20.4509 10.2156C20.4509 10.8486 20.1442 11.4427 19.6269 11.8121C19.1096 12.1814 18.445 12.2804 17.8414 12.0784C17.2378 11.8761 16.7692 11.3976 16.5823 10.7925L15.9955 10.7925C15.9205 10.8229 15.84 10.8376 15.759 10.8352L15.0281 10.8352C14.4865 10.8352 13.967 11.049 13.584 11.4296C13.201 11.8103 12.9858 12.3267 12.9858 12.865L12.9858 13.6128C12.9864 14.441 12.6644 15.2372 12.0872 15.8347C11.5102 16.4321 10.7228 16.7843 9.89004 16.8174C9.70484 17.4214 9.23891 17.9001 8.63772 18.1043C8.03669 18.3086 7.37339 18.2134 6.85486 17.8484C6.33644 17.4834 6.02611 16.8933 6.02042 16.262ZM7.20287 10.2157C7.20287 10.4254 7.2867 10.6264 7.43576 10.7747C7.58497 10.9228 7.78727 11.0061 7.99825 11.0061C8.20923 11.0061 8.41155 10.9228 8.56074 10.7747C8.70995 10.6264 8.79363 10.4253 8.79363 10.2157C8.79363 10.006 8.70995 9.80493 8.56074 9.65667C8.41153 9.50839 8.20923 9.42523 7.99825 9.42523C7.78727 9.42523 7.58494 9.50839 7.43576 9.65667C7.2867 9.80496 7.20287 10.006 7.20287 10.2157ZM19.2483 10.2157C19.2483 10.006 19.1644 9.80493 19.0154 9.65667C18.8662 9.50839 18.6639 9.42523 18.4529 9.42523C18.2419 9.42523 18.0396 9.50839 17.8904 9.65667C17.7412 9.80496 17.6575 10.006 17.6575 10.2157C17.6575 10.4253 17.7412 10.6264 17.8904 10.7747C18.0396 10.9228 18.2419 11.0061 18.4529 11.0061C18.6639 11.0061 18.8662 10.9228 19.0154 10.7747C19.1644 10.6264 19.2483 10.4253 19.2483 10.2157ZM8.81525 16.262C8.81525 16.0523 8.73142 15.8512 8.58221 15.703C8.433 15.5547 8.2307 15.4715 8.01987 15.4715C7.80888 15.4715 7.60657 15.5547 7.45738 15.703C7.3082 15.8512 7.22435 16.0523 7.22435 16.262C7.22435 16.4716 7.30817 16.6727 7.45738 16.821C7.60659 16.9691 7.80889 17.0524 8.01987 17.0524C8.23072 17.0524 8.43303 16.9691 8.58221 16.821C8.73142 16.6727 8.81525 16.4716 8.81525 16.262Z"
      fill="#428BCA"
      stroke="#428BCA"
      strokeWidth="0.21"
    />
  </svg>
);

export const resetIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "20"}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M17.5 9.99837C17.5026 11.6778 16.9414 13.3095 15.9064 14.6321C14.8714 15.9547 13.4225 16.8916 11.7916 17.2928C10.1608 17.694 8.44255 17.5362 6.91207 16.8448C5.38159 16.1533 4.12747 14.9682 3.35062 13.4792C2.57377 11.9902 2.31915 10.2836 2.62754 8.63276C2.93593 6.98188 3.78949 5.48228 5.05148 4.37418C6.31347 3.26608 7.91086 2.61362 9.58775 2.5213C11.2646 2.42899 12.924 2.90216 14.3 3.86504L14.2083 3.59837C14.1376 3.38288 14.1554 3.14813 14.2577 2.94574C14.3601 2.74336 14.5387 2.58993 14.7542 2.51921C14.9697 2.44848 15.2044 2.46626 15.4068 2.56862C15.6092 2.67098 15.7626 2.84955 15.8333 3.06504L16.6667 5.56504C16.708 5.69036 16.719 5.8237 16.6987 5.95409C16.6784 6.08448 16.6274 6.20819 16.55 6.31504C16.4693 6.42864 16.3615 6.5202 16.2363 6.58134C16.1111 6.64249 15.9725 6.67126 15.8333 6.66504H13.3333C13.1123 6.66504 12.9004 6.57724 12.7441 6.42096C12.5878 6.26468 12.5 6.05272 12.5 5.83171C12.503 5.65532 12.5619 5.48444 12.6682 5.34367C12.7746 5.2029 12.9228 5.09951 13.0917 5.04837C11.9955 4.36323 10.7027 4.06164 9.41647 4.19095C8.13024 4.32027 6.9234 4.87317 5.98551 5.76281C5.04762 6.65246 4.43181 7.82844 4.2348 9.10606C4.0378 10.3837 4.27077 11.6905 4.89711 12.8214C5.52345 13.9522 6.50768 14.843 7.69522 15.3537C8.88275 15.8645 10.2063 15.9663 11.458 15.6432C12.7097 15.3201 13.8186 14.5904 14.6105 13.5687C15.4025 12.5469 15.8326 11.2911 15.8333 9.99837C15.8333 9.77736 15.9211 9.5654 16.0774 9.40912C16.2337 9.25284 16.4457 9.16504 16.6667 9.16504C16.8877 9.16504 17.0996 9.25284 17.2559 9.40912C17.4122 9.5654 17.5 9.77736 17.5 9.99837Z"
      fill="#428BCA"
    />
  </svg>
);

export const crossIcon1 = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_9567_19304)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1872 18.5616C17.8778 18.8709 17.3691 18.8709 17.0597 18.5616L12 13.5018L6.94026 18.5616C6.6309 18.8709 6.12218 18.8709 5.81282 18.5616C5.50346 18.2522 5.50346 17.7435 5.81282 17.4341L10.8726 12.3744L5.81282 7.31463C5.50346 7.00527 5.50346 6.49654 5.81282 6.18718C6.12218 5.87782 6.6309 5.87782 6.94026 6.18718L12 11.2469L17.0597 6.18718C17.3691 5.87782 17.8778 5.87782 18.1872 6.18718C18.4965 6.49654 18.4965 7.00527 18.1872 7.31463L13.1274 12.3744L18.1872 17.4341C18.4965 17.7435 18.4965 18.2522 18.1872 18.5616Z"
        fill="#F8F8FB"
      />
    </g>
    <defs>
      <clipPath id="clip0_9567_19304">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const schemaIcon = (width?: string, height?: string): JSX.Element => {
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4 18V14.1238H5.74867V11.9381H4V8.0619H5.74867V5.8762H4V2H8.63394V5.8762H6.88527V8.0619H8.63394V9.4317H11.5774V8.0619H16.2113V11.9381H11.5774V10.5683H8.63394V11.9381H6.88527V14.1238H8.63394V18H4Z"
        fill="#BCBDC3"
      />
    </svg>
  );
};

export const blackCloneIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "25"}
    height={height || "24"}
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M19.061 6.05928L17.4395 4.4381C17.1583 4.15717 16.7771 3.99933 16.3795 3.99927H11.0004C10.6026 3.99927 10.2211 4.15725 9.93988 4.43846C9.65861 4.71967 9.5006 5.10107 9.5006 5.49877V6.99826H7.00029C6.80293 6.99826 6.60751 7.03721 6.42524 7.11286C6.24296 7.18852 6.07741 7.2994 5.93808 7.43915C5.79875 7.5789 5.68837 7.74477 5.61328 7.92725C5.53819 8.10973 5.49987 8.30523 5.5005 8.50255V18.496C5.49987 18.6933 5.53819 18.8888 5.61328 19.0713C5.68837 19.2538 5.79875 19.4197 5.93808 19.5594C6.07741 19.6992 6.24296 19.81 6.42524 19.8857C6.60751 19.9614 6.80293 20.0003 7.00029 20.0003H13.9962C14.3939 20.0003 14.7754 19.8423 15.0567 19.5611C15.3379 19.2799 15.496 18.8985 15.496 18.5008V16.9965H17.9963C18.1936 16.9971 18.3892 16.9588 18.5717 16.8837C18.7542 16.8087 18.9201 16.6983 19.0599 16.559C19.1997 16.4197 19.3106 16.2542 19.3862 16.072C19.4619 15.8897 19.5008 15.6943 19.5008 15.497V7.11995C19.5008 6.92293 19.462 6.72785 19.3865 6.54585C19.311 6.36386 19.2004 6.19852 19.061 6.05928ZM13.8131 18.496H7.18813C7.13729 18.496 7.08854 18.4758 7.0526 18.4399C7.01665 18.4039 6.99646 18.3552 6.99646 18.3044V8.68556C6.99646 8.63473 7.01665 8.58599 7.0526 8.55005C7.08854 8.51412 7.13729 8.49393 7.18813 8.49393H9.5006V15.497C9.5006 15.8947 9.65861 16.2761 9.93988 16.5573C10.2211 16.8385 10.6026 16.9965 11.0004 16.9965H14.0009V18.3092C13.9997 18.3585 13.9795 18.4055 13.9445 18.4403C13.9095 18.4751 13.8625 18.495 13.8131 18.496ZM17.8132 15.497H11.1882C11.1374 15.497 11.0886 15.4768 11.0527 15.4409C11.0168 15.4049 10.9966 15.3562 10.9966 15.3054V5.68656C10.9966 5.63574 11.0168 5.587 11.0527 5.55106C11.0886 5.51512 11.1374 5.49493 11.1882 5.49493H14.5002V8.24481C14.5002 8.44378 14.5793 8.63461 14.72 8.7753C14.8607 8.916 15.0516 8.99504 15.2506 8.99504H18.001V15.3054C18.001 15.3562 17.9809 15.4049 17.9449 15.4409C17.909 15.4768 17.8602 15.497 17.8094 15.497H17.8132ZM18.0049 7.49841H16V5.49877H16.301C16.3504 5.49922 16.3978 5.51879 16.4332 5.55338L17.9455 7.06533C17.9801 7.10071 17.9996 7.14808 18.0001 7.19756L18.0049 7.49841Z"
      fill="#4F4F4F"
    />
  </svg>
);

export const tableIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "16"}
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99218 15.999H1.98471C1.65296 16.0095 1.32402 15.9387 1.02971 15.7936C0.735392 15.6485 0.485691 15.434 0.304917 15.1708C0.0869654 14.8592 -0.0218707 14.4907 -0.00625508 14.1175V1.89324C-0.0213349 1.53953 0.0733632 1.18938 0.266112 0.885874C0.458861 0.582372 0.741229 0.338764 1.07856 0.185063C1.37225 0.0499145 1.69727 -0.0129746 2.02351 0.00222405H18.0678C18.4838 0.00230244 18.8885 0.130229 19.221 0.366666C19.5534 0.603103 19.7955 0.935254 19.9109 1.3131C19.9589 1.47242 19.9842 1.63711 19.9859 1.80277C19.9899 5.65354 19.9899 9.50413 19.9859 13.3545C19.9992 13.7104 19.9914 14.0667 19.9624 14.4218C19.9068 14.8547 19.6855 15.2534 19.3403 15.5427C18.9951 15.832 18.5498 15.9918 18.0885 15.992C15.3884 15.9954 12.6891 15.9954 9.99079 15.992L9.99218 15.999ZM3.8238 10.1874H5.68095C6.00686 10.1874 6.14938 10.0609 6.14938 9.75528V7.69219C6.14938 7.40686 6.0202 7.27841 5.71771 7.27778C4.47471 7.27483 3.2315 7.27483 1.98806 7.27778C1.66816 7.27778 1.53637 7.40812 1.53637 7.70737V9.77045C1.53637 10.0564 1.67821 10.1874 1.98405 10.1874H3.8238ZM3.83515 5.82206H5.70905C6.01355 5.82206 6.14675 5.69553 6.14742 5.41337V3.33572C6.15684 3.2787 6.152 3.22036 6.13329 3.16543C6.11457 3.1105 6.08251 3.0605 6.03966 3.01939C5.99652 2.97829 5.94372 2.94736 5.88559 2.92911C5.82746 2.91087 5.76563 2.90581 5.70505 2.91436H1.99075C1.67487 2.91436 1.5363 3.04912 1.53564 3.34267V5.36147C1.53564 5.7088 1.65952 5.82649 2.0276 5.82712H3.8345L3.83515 5.82206ZM16.1424 10.1874H17.9688C18.3168 10.1874 18.4486 10.0653 18.4486 9.73948V7.70609C18.4486 7.39672 18.3282 7.27841 18.0029 7.27778C16.7648 7.27567 15.5267 7.27567 14.2886 7.27778C13.9741 7.27778 13.8383 7.41004 13.8376 7.70802V9.75593C13.8376 10.0621 13.9714 10.1874 14.3007 10.1874H16.1424ZM16.1464 5.82206H18.0203C18.3181 5.82206 18.4466 5.69552 18.4479 5.42032V3.34267C18.4479 3.0371 18.3141 2.91246 17.9795 2.9112H14.2806C14.2201 2.90261 14.1583 2.90758 14.1002 2.92571C14.042 2.94385 13.9892 2.97462 13.946 3.01557C13.9029 3.05656 13.8706 3.10656 13.8516 3.16149C13.8327 3.21643 13.8277 3.27478 13.8369 3.3319V5.40954C13.8279 5.46583 13.833 5.52336 13.8518 5.57744C13.8706 5.63152 13.9027 5.68062 13.9453 5.72081C13.988 5.76112 14.04 5.79135 14.0974 5.80905C14.1547 5.82675 14.2156 5.83142 14.2752 5.82268C14.8996 5.82268 15.5221 5.82268 16.1445 5.82268L16.1464 5.82206ZM9.98139 5.82206H11.8071C12.1765 5.82206 12.299 5.70628 12.299 5.35768V3.36862C12.299 3.03331 12.1692 2.90865 11.8165 2.90865H8.17988C7.81582 2.90865 7.69129 3.02825 7.69062 3.37685V5.38108C7.69062 5.7088 7.80846 5.81954 8.15513 5.82017C8.76413 5.82228 9.37201 5.82228 9.97878 5.82017L9.98139 5.82206ZM9.99553 7.27716H8.12163C7.81579 7.27716 7.68998 7.39864 7.68931 7.68713V9.7496C7.68931 10.059 7.82311 10.1868 8.14769 10.1868H11.8459C12.1631 10.1868 12.2957 10.0602 12.2964 9.75844C12.299 9.07559 12.299 8.39296 12.2964 7.71053C12.2964 7.39926 12.1625 7.27718 11.8345 7.27655C11.2235 7.27655 10.6079 7.27655 9.99218 7.27655L9.99553 7.27716ZM3.82846 14.5458H5.70235C6.01355 14.5458 6.14806 14.4192 6.14873 14.1282V12.0651C6.14873 11.769 6.00949 11.6343 5.69696 11.6343H1.98209C1.67491 11.6343 1.53565 11.7659 1.53498 12.0544V14.1175C1.53498 14.4199 1.66885 14.5432 1.9874 14.5432L3.82846 14.5458ZM16.1364 14.5458H18.0243C18.0827 14.5539 18.1422 14.549 18.1982 14.5313C18.2541 14.5136 18.3048 14.4836 18.3462 14.4439C18.3875 14.4041 18.4183 14.3556 18.4361 14.3024C18.4539 14.2492 18.4582 14.1927 18.4486 14.1377V12.0455C18.4575 11.9904 18.4527 11.9342 18.4347 11.8812C18.4168 11.8282 18.386 11.7798 18.3449 11.7399C18.3037 11.7001 18.2534 11.6698 18.1978 11.6515C18.1421 11.6331 18.0828 11.6273 18.0243 11.6343H14.2639C14.2055 11.6267 14.146 11.6321 14.0902 11.6501C14.0344 11.6681 13.9839 11.6982 13.9426 11.738C13.9013 11.7778 13.8704 11.8261 13.8524 11.8792C13.8344 11.9322 13.8297 11.9885 13.8389 12.0436V14.1061C13.8389 14.4275 13.9661 14.5419 14.3114 14.5419L16.1364 14.5458ZM9.98883 14.5458H11.8165C12.1772 14.5458 12.295 14.4395 12.297 14.1029C12.3001 13.4281 12.3001 12.7545 12.297 12.0822C12.297 11.7519 12.1699 11.6393 11.8152 11.6393H8.17514C7.81576 11.6393 7.68866 11.7602 7.68866 12.0948V14.1156C7.68866 14.4319 7.81379 14.5515 8.14573 14.5521C8.75407 14.5477 9.36978 14.547 9.98548 14.547L9.98883 14.5458Z"
      fill="#949494"
    />
  </svg>
);

export const nodeTableIcon = (width?: string, height?: string): JSX.Element => (
  <svg
    width={width || "16"}
    height={height || "17"}
    viewBox="0 0 16 17"
    fill="none"
  >
    <rect y="0.5" width="16" height="16" rx="8" fill="#428BCA" />
    <path
      d="M8.65234 12.5H7.13867V6.62109H5.2002V5.36133H10.5908V6.62109H8.65234V12.5Z"
      fill="white"
    />
  </svg>
);

export const dataBricksIcon = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "20"}
    height={height || "21"}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1129 9.02943L10.1984 12.9247L2.85233 8.77558L2.50881 8.9594V11.9706L10.2072 16.3299L17.1217 12.4345V14.0364L10.2072 17.9317L2.85233 13.7826L2.50881 13.9664V14.4741L10.2072 18.8334L17.9321 14.4741V11.4629L17.5886 11.2791L10.1984 15.4282L3.31036 11.5329V9.9573L10.1984 13.8264L17.9233 9.46711V6.49967L17.5269 6.28959L10.1984 10.4125L3.68031 6.72726L10.1984 3.0683L15.5803 6.0795L16.0647 5.82565V5.458L10.1984 2.16669L2.5 6.50842V6.97236L10.1984 11.3316L17.1129 7.43629V9.02943Z"
      fill="#FF3621"
    />
  </svg>
);

export const transformationNodeSvg = (
  width?: string,
  height?: string
): JSX.Element => {
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M14.3022 7.9113H15.5164L15.2983 8.12215C15.1614 8.25907 15.0845 8.44476 15.0845 8.63838C15.0845 8.832 15.1614 9.0177 15.2983 9.15461C15.4352 9.29152 15.6209 9.36844 15.8145 9.36844C16.0082 9.36844 16.1939 9.29152 16.3308 9.15461L17.7849 7.70045C17.8531 7.63285 17.9072 7.55244 17.9441 7.46384C17.981 7.37524 18 7.2802 18 7.18422C18 7.08824 17.981 6.9932 17.9441 6.9046C17.9072 6.816 17.8531 6.73558 17.7849 6.66799L16.3308 5.21383C16.263 5.14604 16.1825 5.09226 16.0939 5.05557C16.0053 5.01888 15.9104 5 15.8145 5C15.6209 5 15.4352 5.07692 15.2983 5.21383C15.1614 5.35074 15.0845 5.53643 15.0845 5.73006C15.0845 5.92368 15.1614 6.10937 15.2983 6.24628L15.5164 6.45714H14.3022C13.7549 6.45573 13.2143 6.57792 12.7208 6.81461C12.2273 7.05129 11.7936 7.39635 11.4521 7.82405L10.2742 9.27821L8.54373 7.09697C8.2022 6.66927 7.7685 6.32421 7.27499 6.08753C6.78148 5.85084 6.2409 5.72865 5.69357 5.73006H2.72708C2.53425 5.73006 2.34931 5.80666 2.21296 5.94301C2.0766 6.07937 2 6.2643 2 6.45714C2 6.64997 2.0766 6.83491 2.21296 6.97126C2.34931 7.10762 2.53425 7.18422 2.72708 7.18422H5.69357C6.02061 7.18486 6.34333 7.25903 6.63783 7.40125C6.93233 7.54347 7.19109 7.75009 7.39494 8.00582L9.35806 10.4561L7.39494 12.9063C7.19109 13.1621 6.93233 13.3687 6.63783 13.5109C6.34333 13.6531 6.02061 13.7273 5.69357 13.7279H2.72708C2.53425 13.7279 2.34931 13.8046 2.21296 13.9409C2.0766 14.0773 2 14.2622 2 14.455C2 14.6479 2.0766 14.8328 2.21296 14.9692C2.34931 15.1055 2.53425 15.1821 2.72708 15.1821H5.69357C6.2409 15.1835 6.78148 15.0613 7.27499 14.8246C7.7685 14.588 8.2022 14.2429 8.54373 13.8152L12.6154 8.72563C12.8184 8.47313 13.0752 8.26904 13.3669 8.12818C13.6587 7.98732 13.9782 7.91323 14.3022 7.9113Z"
        fill="#949494"
      />
      <path
        d="M17.7847 13.2118L16.3305 11.7577C16.1936 11.6207 16.0079 11.5438 15.8143 11.5438C15.6207 11.5438 15.435 11.6207 15.2981 11.7577C15.1612 11.8946 15.0843 12.0803 15.0843 12.2739C15.0843 12.4675 15.1612 12.6532 15.2981 12.7901L15.5162 13.001H14.302C13.9749 13.0003 13.6522 12.9261 13.3577 12.7839C13.0632 12.6417 12.8045 12.4351 12.6006 12.1794L11.8735 11.2705L10.9429 12.4338L11.4664 13.0882C11.8064 13.514 12.2377 13.8579 12.7286 14.0945C13.2194 14.3311 13.7571 14.4543 14.302 14.4551H15.5162L15.2981 14.666C15.2303 14.7338 15.1765 14.8142 15.1398 14.9028C15.1031 14.9914 15.0843 15.0863 15.0843 15.1822C15.0843 15.2781 15.1031 15.373 15.1398 15.4616C15.1765 15.5502 15.2303 15.6306 15.2981 15.6984C15.3659 15.7662 15.4464 15.82 15.5349 15.8567C15.6235 15.8934 15.7184 15.9123 15.8143 15.9123C15.9102 15.9123 16.0051 15.8934 16.0937 15.8567C16.1823 15.82 16.2627 15.7662 16.3305 15.6984L17.7847 14.2443C17.8529 14.1767 17.9069 14.0963 17.9439 14.0077C17.9808 13.9191 17.9998 13.824 17.9998 13.728C17.9998 13.6321 17.9808 13.537 17.9439 13.4484C17.9069 13.3598 17.8529 13.2794 17.7847 13.2118Z"
        fill="#949494"
      />
    </svg>
  );
};

export const assetRelationshipsBlankStateSvg = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "26"}
    height={height || "25"}
    viewBox="0 0 26 25"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.56 0.847656H11.44C10.8656 0.847656 10.4 1.31484 10.4 1.89113V6.06505C10.4 6.64135 10.8656 7.10853 11.44 7.10853H12.6479V10.2399H10.4C9.82562 10.2399 9.36 10.7071 9.36 11.2834V12.4488H6.24V11.2822C6.24 10.7059 5.77438 10.2387 5.2 10.2387H1.04C0.465624 10.2387 0 10.7059 0 11.2822V14.4126C0 14.9889 0.465624 15.4561 1.04 15.4561H5.2C5.77438 15.4561 6.24 14.9889 6.24 14.4126V13.2488H9.36V14.4138C9.36 14.9901 9.82562 15.4573 10.4 15.4573H12.6479V18.5869H11.44C10.8656 18.5869 10.4 19.0541 10.4 19.6304V23.8043C10.4 24.3806 10.8656 24.8478 11.44 24.8478H14.56C15.1344 24.8478 15.6 24.3806 15.6 23.8043V19.6304C15.6 19.0541 15.1344 18.5869 14.56 18.5869H13.4479V15.4573H15.6C16.1744 15.4573 16.64 14.9901 16.64 14.4138V13.2488H19.76V14.4126C19.76 14.9889 20.2256 15.4561 20.8 15.4561H24.96C25.5344 15.4561 26 14.9889 26 14.4126V11.2822C26 10.7059 25.5344 10.2387 24.96 10.2387H20.8C20.2256 10.2387 19.76 10.7059 19.76 11.2822V12.4488H16.64V11.2834C16.64 10.7071 16.1744 10.2399 15.6 10.2399H13.4479V7.10853H14.56C15.1344 7.10853 15.6 6.64135 15.6 6.06505V1.89113C15.6 1.31484 15.1344 0.847656 14.56 0.847656Z"
      fill="#8E8E8E"
    />
  </svg>
);

export const assetDictICon = (width: string, height: string): JSX.Element => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.5193 6.64104C19.4153 6.62023 19.3112 6.59942 19.2072 6.59942V6.49538C19.2072 5.22601 18.1875 4.20636 16.9182 4.20636H11.1956L7.9494 2.56243C7.86616 2.52081 7.76211 2.5 7.65807 2.5H4.76558C3.49622 2.5 2.47656 3.51965 2.47656 4.78902V14.9855C2.47656 16.2549 3.49622 17.2746 4.76558 17.2746H10.8627V19.2514H4.09968C3.74593 19.2514 3.47541 19.522 3.47541 19.8757C3.47541 20.2295 3.74593 20.5 4.09968 20.5H18.8743C19.228 20.5 19.4985 20.2295 19.4985 19.8757C19.4985 19.522 19.228 19.2514 18.8743 19.2514H12.1112V17.2746H14.213V17.2538H17.6881C18.7702 17.2538 19.6858 16.5046 19.9147 15.4642L21.2673 9.36705C21.5378 8.1185 20.7471 6.91156 19.5193 6.64104ZM17.9795 6.57861H8.07425C7.01298 6.57861 6.07656 7.32775 5.84766 8.36821L4.20373 15.8387C3.9124 15.6514 3.74593 15.3185 3.74593 14.9855V4.78902C3.74593 4.20636 4.20373 3.74856 4.78639 3.74856H7.53321L10.7795 5.39249C10.8627 5.4341 10.9667 5.45491 11.0708 5.45491H16.939C17.5217 5.45491 17.9795 5.91272 17.9795 6.49538V6.57861Z"
      fill="#62A8D1"
    />
  </svg>
);

export const ascSortingIcon = (
  width?: string,
  height?: string
): JSX.Element => {
  return (
    <svg
      width={width || "9"}
      height={height || "14"}
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.42986 5.83333H8.22918C8.36483 5.83321 8.49742 5.78392 8.61019 5.69168C8.72297 5.59945 8.81088 5.4684 8.86284 5.31509C8.9148 5.16177 8.92848 4.99306 8.90214 4.83024C8.8758 4.66743 8.81063 4.51781 8.71485 4.40028L5.3199 0.246472C5.25645 0.168362 5.181 0.106377 5.09789 0.0640774C5.01478 0.0217775 4.92566 0 4.83565 0C4.74564 0 4.65652 0.0217775 4.57341 0.0640774C4.4903 0.106377 4.41485 0.168362 4.3514 0.246472L0.948907 4.40028C0.853408 4.51746 0.788328 4.66655 0.761835 4.82883C0.735342 4.99112 0.748616 5.15936 0.799992 5.31244C0.851369 5.46552 0.938557 5.59663 1.05062 5.6893C1.16267 5.78197 1.29461 5.83208 1.42986 5.83333Z"
        fill="#C9C9C9"
      />
      <path
        d="M8.71483 9.59981L5.31988 13.7536C5.25643 13.8317 5.18098 13.8937 5.09787 13.936C5.01477 13.9783 4.92564 14.0001 4.83563 14.0001C4.74562 14.0001 4.6565 13.9783 4.57339 13.936C4.49028 13.8937 4.41483 13.8317 4.35138 13.7536L0.948888 9.59981C0.853112 9.48227 0.787941 9.33265 0.761601 9.16984C0.735262 9.00702 0.748935 8.83831 0.800894 8.685C0.852853 8.53168 0.940768 8.40063 1.05354 8.3084C1.16632 8.21616 1.2989 8.16687 1.43455 8.16675H8.23388C8.36913 8.168 8.50106 8.21811 8.61312 8.31078C8.72518 8.40345 8.81237 8.53456 8.86374 8.68764C8.91512 8.84073 8.9284 9.00896 8.9019 9.17125C8.87541 9.33353 8.81033 9.48262 8.71483 9.59981Z"
        fill="#428BCA"
      />
    </svg>
  );
};

export const descSortingIcon = (
  width?: string,
  height?: string
): JSX.Element => {
  return (
    <svg
      width={width || "9"}
      height={height || "14"}
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.42986 8.16667H8.22918C8.36483 8.16679 8.49742 8.21608 8.61019 8.30832C8.72297 8.40055 8.81088 8.5316 8.86284 8.68491C8.9148 8.83823 8.92848 9.00694 8.90214 9.16976C8.8758 9.33257 8.81063 9.48219 8.71485 9.59972L5.3199 13.7535C5.25645 13.8316 5.181 13.8936 5.09789 13.9359C5.01478 13.9782 4.92566 14 4.83565 14C4.74564 14 4.65652 13.9782 4.57341 13.9359C4.4903 13.8936 4.41485 13.8316 4.3514 13.7535L0.948907 9.59972C0.853408 9.48254 0.788328 9.33345 0.761835 9.17117C0.735342 9.00888 0.748616 8.84064 0.799992 8.68756C0.851369 8.53448 0.938557 8.40337 1.05062 8.3107C1.16267 8.21803 1.29461 8.16792 1.42986 8.16667V8.16667Z"
        fill="#C9C9C9"
      />
      <path
        d="M8.71483 4.40019L5.31988 0.246395C5.25643 0.168285 5.18098 0.106296 5.09787 0.0639963C5.01476 0.0216965 4.92564 -8.10623e-05 4.83563 -8.10623e-05C4.74562 -8.10623e-05 4.6565 0.0216965 4.57339 0.0639963C4.49028 0.106296 4.41483 0.168285 4.35138 0.246395L0.948888 4.40019C0.853112 4.51773 0.787941 4.66735 0.761601 4.83016C0.735262 4.99298 0.748935 5.16169 0.800894 5.315C0.852853 5.46832 0.940768 5.59937 1.05354 5.6916C1.16632 5.78384 1.2989 5.83313 1.43455 5.83325H8.23388C8.36913 5.832 8.50106 5.78189 8.61312 5.68922C8.72518 5.59655 8.81237 5.46544 8.86374 5.31236C8.91512 5.15927 8.9284 4.99104 8.9019 4.82875C8.87541 4.66647 8.81033 4.51738 8.71483 4.40019Z"
        fill="#428BCA"
      />
    </svg>
  );
};

export const warningYellowInCircleIcon = (
  width?: string,
  height?: string
): JSX.Element => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="50" r="50" fill="#FEF9E0" />
      <path
        d="M50.3838 64.6122H37.1515C36.5426 64.6317 35.9335 64.5921 35.3327 64.4941C34.7663 64.4128 34.2296 64.1954 33.771 63.8615C33.3123 63.5277 32.9459 63.0878 32.7051 62.5816C32.4648 62.0755 32.3575 61.519 32.3928 60.9624C32.4281 60.4058 32.605 59.8665 32.9074 59.3931C33.6067 58.038 34.4232 56.74 35.2034 55.4263C39.0718 48.8901 42.9449 42.3558 46.8227 35.8236C47.0072 35.5145 47.2098 35.216 47.4291 34.9294C47.7358 34.4578 48.1587 34.0683 48.6593 33.7966C49.1598 33.5248 49.722 33.3795 50.295 33.3735C50.868 33.368 51.4334 33.5022 51.9396 33.764C52.4458 34.0258 52.8764 34.4068 53.1929 34.8723C53.9656 35.9666 54.6748 37.1021 55.3171 38.2737C59.3742 45.1145 63.4244 51.9594 67.4679 58.8081C67.7159 59.2153 67.9157 59.6487 68.0625 60.1C68.2476 60.5888 68.3108 61.1133 68.2475 61.6307C68.1843 62.148 67.9961 62.6434 67.6983 63.0761C67.4005 63.5088 67.0016 63.8665 66.5343 64.1199C66.0671 64.3732 65.545 64.515 65.0106 64.5335C63.3937 64.6556 61.7483 64.6084 60.1172 64.6143C56.8714 64.6261 53.6176 64.6122 50.3838 64.6122Z"
        fill="#F1C911"
      />
      <path
        d="M52.5323 57.9454C52.5456 58.2301 52.4989 58.5145 52.3946 58.7808C52.2903 59.0471 52.131 59.2897 51.9264 59.4934C51.7209 59.6966 51.4746 59.8563 51.203 59.9627C50.9314 60.0691 50.6405 60.1199 50.3479 60.1119C50.0483 60.1227 49.7495 60.0723 49.4711 59.9641C49.1926 59.8559 48.9407 59.6922 48.7309 59.4836C48.5237 59.276 48.3626 59.0288 48.2582 58.7576C48.1538 58.4864 48.1084 58.1972 48.1245 57.908C48.1229 57.6293 48.1795 57.3532 48.2903 57.0963C48.4011 56.8394 48.564 56.6071 48.7694 56.4132C48.9741 56.2175 49.2173 56.0642 49.4844 55.9626C49.7515 55.861 50.0366 55.8133 50.3232 55.8222C50.6145 55.8091 50.9055 55.8549 51.1778 55.9566C51.4502 56.0583 51.6984 56.2137 51.9061 56.4132C52.1132 56.6128 52.2755 56.8519 52.3833 57.1155C52.4911 57.3792 52.5417 57.6617 52.5323 57.9454Z"
        fill="white"
      />
      <path
        d="M52.1588 48.7377L52.2999 46.595L52.4095 44.9523C52.4883 43.7706 52.6115 42.1339 51.126 41.7243C50.7728 41.5987 50.3927 41.5625 50.0212 41.619C49.6498 41.6755 49.299 41.8228 49.0018 42.0473C48.7036 42.2701 48.468 42.5629 48.3174 42.8984C48.1669 43.2338 48.1062 43.601 48.1408 43.9656C48.2055 45.5747 48.3064 47.1818 48.4176 48.7889C48.4728 49.5925 48.53 50.3961 48.5893 51.1996C48.5979 51.9657 48.7075 52.7276 48.915 53.4666C48.9354 53.5338 48.9601 53.5996 48.9895 53.6636C49.0867 53.8957 49.2471 54.0975 49.4533 54.2475C49.6595 54.3974 49.9039 54.4897 50.1599 54.5145C50.4161 54.5393 50.6744 54.4956 50.907 54.388C51.1395 54.2804 51.3372 54.1131 51.4793 53.9039C51.6431 53.6415 51.7504 53.3492 51.7946 53.0451C51.9422 51.6861 52.0658 50.3212 52.1405 48.9583C52.1561 48.8858 52.1623 48.8117 52.1588 48.7377Z"
        fill="white"
      />
    </svg>
  );
};
export const alarmIconWithBgSvg = (
  width?: string,
  height?: string
): JSX.Element => (
  <svg
    width={width || "100"}
    height={height || "100"}
    viewBox="0 0 100 100"
    fill="none"
  >
    <circle cx="50" cy="50" r="50" fill="#EFF3F8" />
    <path
      d="M30 45.0626C30 41.8682 30.6783 38.9195 32.035 36.2166C33.3921 33.5141 35.2235 31.2322 37.5292 29.371L39.5328 31.9001C37.6023 33.4612 36.0724 35.3751 34.9433 37.6417C33.8144 39.9084 33.25 42.3821 33.25 45.0626H30ZM67.4162 45.0626C67.4162 42.3821 66.8518 39.905 65.7229 37.6315C64.5937 35.3579 63.0639 33.4404 61.1334 31.879L63.137 29.371C65.4427 31.2322 67.2741 33.5141 68.6311 36.2166C69.9878 38.9195 70.6662 41.8682 70.6662 45.0626H67.4162ZM34.0831 64.4998V61.2503H37.9999V45.0832C37.9999 42.1694 38.8992 39.593 40.6979 37.3541C42.4963 35.1152 44.8052 33.6832 47.6248 33.0582V31.7083C47.6248 30.9583 47.8887 30.3195 48.4167 29.7919C48.9443 29.264 49.5831 29 50.3331 29C51.0831 29 51.7219 29.264 52.2495 29.7919C52.7774 30.3195 53.0414 30.9583 53.0414 31.7083V33.0582C55.861 33.6832 58.1699 35.1152 59.9683 37.3541C61.7669 39.593 62.6663 42.1694 62.6663 45.0832V61.2503H66.5831V64.4998H34.0831ZM50.3331 70.5832C49.2526 70.5832 48.3298 70.2006 47.5646 69.4354C46.7991 68.6702 46.4163 67.7472 46.4163 66.6664H54.2499C54.2499 67.7472 53.8671 68.6702 53.1015 69.4354C52.3363 70.2006 51.4135 70.5832 50.3331 70.5832ZM41.2499 61.2503H59.4163V45.0832C59.4163 42.5749 58.5296 40.434 56.7562 38.6606C54.9824 36.8868 52.8414 36 50.3331 36C47.8248 36 45.6838 36.8868 43.91 38.6606C42.1366 40.434 41.2499 42.5749 41.2499 45.0832V61.2503Z"
      fill="#428BCA"
    />
  </svg>
);
